const statusDe = {
  draft: 'Entwurf',
  sent: 'Versendet',
  accepted: 'Angenommen',
  rejected: 'Abgelehnt',
  invoiced: 'Berechnet',
  paid: 'Bezahlt',
  cancelled: 'Storniert',
  pending: 'Ausstehend',
  lead: 'Lead',
  offer: 'Angebot',
  ordered: 'Beauftragt',
  in_progress: 'In Arbeit',
  completed: 'Abgeschlossen',
  cancelledProject: 'Abgebrochen'
};

const statusEn = {
  draft: 'Draft',
  sent: 'Sent',
  accepted: 'Accepted',
  rejected: 'Rejected',
  invoiced: 'Invoiced',
  paid: 'Paid',
  cancelled: 'Cancelled',
  pending: 'Pending',
  lead: 'Lead',
  offer: 'Offer',
  ordered: 'Ordered',
  in_progress: 'In progress',
  completed: 'Completed',
  cancelledProject: 'Cancelled'
};

const statusFr = {
  draft: 'Brouillon',
  sent: 'Envoyé',
  accepted: 'Accepté',
  rejected: 'Rejeté',
  invoiced: 'Facturé',
  paid: 'Payé',
  cancelled: 'Annulé',
  pending: 'En attente',
  lead: 'Prospect',
  offer: 'Offre',
  ordered: 'Commandé',
  in_progress: 'En cours',
  completed: 'Terminé',
  cancelledProject: 'Projet annulé'
};

const statusIt = {
  draft: 'Bozza',
  sent: 'Inviato',
  accepted: 'Accettato',
  rejected: 'Rifiutato',
  invoiced: 'Fatturato',
  paid: 'Pagato',
  cancelled: 'Annullato',
  pending: 'In sospeso',
  lead: 'Lead',
  offer: 'Offerta',
  ordered: 'Ordinato',
  in_progress: 'In corso',
  completed: 'Completato',
  cancelledProject: 'Annullato'
};

const statusPl = {
  draft: 'Szkic',
  sent: 'Wysłane',
  accepted: 'Zaakceptowane',
  rejected: 'Odrzucone',
  invoiced: 'Zafakturowane',
  paid: 'Opłacone',
  cancelled: 'Anulowane',
  pending: 'Oczekujące',
  lead: 'Lead',
  offer: 'Oferta',
  ordered: 'Zamówione',
  in_progress: 'W trakcie',
  completed: 'Zakończone',
  cancelledProject: 'Anulowany'
};

const statusCs = {
  draft: 'Návrh',
  sent: 'Odesláno',
  accepted: 'Schváleno',
  rejected: 'Zamítnuto',
  invoiced: 'Vyfakturováno',
  paid: 'Zaplaceno',
  cancelled: 'Stornováno',
  pending: 'Čeká',
  lead: 'Lead',
  offer: 'Nabídka',
  ordered: 'Objednáno',
  in_progress: 'V průběhu',
  completed: 'Dokončeno',
  cancelledProject: 'Zrušeno'
};
// ── Changelog ─────────────────────────────────────────────
const changelogDe = {
  title: 'Changelog',
  entries: 'Einträge',
  refresh: 'Aktualisieren',
  searchPlaceholder: 'Suchen nach Nutzer, Aktion, Entität ...',
  noneFound: 'Keine Einträge gefunden',
  noEntries: 'Noch keine Aktionen protokolliert.',
  timestamp: 'Zeit',
  user: 'Nutzer',
  action: 'Aktion',
  entityType: 'Entität',
  entityId: 'Entitäts-ID',
  details: 'Details',
};
const changelogEn = {
  title: 'Changelog',
  entries: 'Entries',
  refresh: 'Refresh',
  searchPlaceholder: 'Search by user, action, entity ...',
  noneFound: 'No entries found',
  noEntries: 'No actions logged yet.',
  timestamp: 'Time',
  user: 'User',
  action: 'Action',
  entityType: 'Entity',
  entityId: 'Entity ID',
  details: 'Details',
};

// ── Fahrzeuge (Vehicles) ─────────────────────────────────────────────
const vehiclesDe = {
  title: 'Fahrzeuge',
  add: 'Fahrzeug anlegen',
  edit: 'Fahrzeug bearbeiten',
  name: 'Name',
  nameRequired: 'Name ist erforderlich',
  license_plate: 'Kennzeichen',
  license_plate_placeholder: 'z.B. M-AB 1234',
  brand: 'Marke',
  model: 'Modell',
  year: 'Baujahr',
  editVehicle: 'Fahrzeug bearbeiten',
  newVehicle: 'Neues Fahrzeug',
  noneFound: 'Keine Fahrzeuge gefunden',
  purchase_type: 'Kaufart',
  allPurchaseTypes: 'Alle Kaufarten',
  purchase_type_buy: 'Kauf',
  purchase_type_lease: 'Leasing',
  purchase_type_rent: 'Miete',
  purchase_price: 'Kaufpreis',
  leasing_rate: 'Monatliche Rate',
  leasing_start: 'Leasingbeginn',
  leasing_end: 'Leasingende',
  leasing_km_limit: 'km-Limit/Jahr',
  current_km: 'Aktueller Kilometerstand',
  daily_rate: 'Tagessatz (Abrechnung)',
  daily_rate_placeholder: 'z.B. 150.00',
  status: 'Status',
  allStatuses: 'Alle Status',
  status_active: 'Aktiv',
  status_inactive: 'Inaktiv',
  status_maintenance: 'In Wartung',
  tabOverview: 'Übersicht', tabAssignments: 'Zuweisungen', tabCosts: 'Kosten',
  tabMaintenance: 'Wartung', tabDocuments: 'Dokumente', tabUsage: 'Nutzung',
  addAssignment: 'Zuweisung hinzufügen', noAssignments: 'Keine Zuweisungen',
  noAssigned: 'Keine Fahrzeuge zugewiesen',
  assignFrom: 'Von', assignTo: 'Bis',
  assignConflict: 'Dieses Fahrzeug ist im gewählten Zeitraum bereits dem Projekt „{project}" zugewiesen. Bitte Zeitraum anpassen oder zuerst die andere Zuweisung entfernen.',
  assignStatusBlocked: 'Dieses Fahrzeug kann nicht zugewiesen werden, da es sich aktuell im Status „{status}" befindet.',
  addCost: 'Kosten hinzufügen', noCosts: 'Keine Kosten',
  costType: 'Typ', costAmount: 'Betrag', costDate: 'Datum', costNote: 'Beschreibung',
  cost_fuel: 'Kraftstoff', cost_repair: 'Reparatur', cost_leasing: 'Leasing',
  cost_insurance: 'Versicherung', cost_maintenance: 'Wartung',
  addMaintenance: 'Wartung hinzufügen', noMaintenance: 'Keine Wartungen',
  maintType: 'Typ', maintDue: 'Fällig am', maintDone: 'Erledigt am',
  maintNext: 'Nächste Fälligkeit', maintNotes: 'Notizen',
  addDocument: 'Dokument hinzufügen', noDocuments: 'Keine Dokumente',
  docType: 'Typ', docPath: 'Dateipfad',
  doc_invoice: 'Rechnung', doc_contract: 'Vertrag', doc_image: 'Bild',
  doc_manual: 'Handbuch', doc_inspection: 'Inspektion',
  addUsage: 'Nutzung hinzufügen', noUsage: 'Keine Nutzungen',
  usageFlat: 'Pauschal', usageKm: 'KM-Erfassung', usage_km: 'KM-Erfassung',
  kmBase: 'KM-Strecke', kmFactor: 'Faktor', kmTotal: 'Gesamt',
  kmBasePlaceholder: 'z.B. 48,5', kmCalculating: 'Wird berechnet…',
  km_rate: 'KM-Satz (€/km)', km_rate_placeholder: 'z.B. 0,35',
  kmRoundTrip: 'Hin- und Rückweg (×2)',
  kmDays: 'Tage', kmDaysShort: ' Tage',
  kmNoCompanyAddr: 'Keine Firmenadresse in den Einstellungen hinterlegt',
  kmNoProjectAddr: 'Keine Baustellen-Adresse am Projekt hinterlegt',
  kmCalcFailed: 'Berechnung fehlgeschlagen – bitte manuell eingeben',
  usageType: 'Typ', usageQty: 'Menge', usageDate: 'Datum',
  usage_hourly: 'Stundenweise', usage_daily: 'Tageweise',
  infoText: 'Die Fahrzeugverwaltung bietet eine vollständige Übersicht über die Fahrzeugflotte.',
  infoItem1: 'Fahrzeugstatus, Kilometerstand und Zuweisungen im Blick behalten',
  infoItem2: 'Kosten, Wartungen und Dokumente je Fahrzeug verwalten',
  infoItem3: 'Fahrzeuge Projekten zuweisen und Nutzung protokollieren',
  startTour: 'Führung starten',
  tourListTitle: 'Fahrzeugliste',
  tourListText: 'Alle Fahrzeuge auf einen Blick mit Status, Kennzeichen und Typ. Klick auf eine Zeile öffnet die Detailansicht.',
  tourDetailTitle: 'Fahrzeugdetails',
  tourDetailText: 'Alle Informationen zum ausgewählten Fahrzeug – Stammdaten, Zuweisungen, Kosten, Wartungen und mehr.',
  tourTabsTitle: 'Tabs',
  tourTabsText: 'Zwischen Übersicht, Projektzuweisungen, Kosten, Wartungen, Dokumenten und Nutzungsprotokoll wechseln.',
  tourNewTitle: 'Neues Fahrzeug',
  tourNewText: 'Legt ein neues Fahrzeug an – mit Typ, Marke, Modell, Kennzeichen und Kaufinformationen.',
  tourModalTitle: 'Fahrzeugformular',
  tourModalText: 'Alle Stammdaten des Fahrzeugs erfassen. Buchungen auf Projekte – Zuweisungen, Kosten und Nutzung – können danach direkt im Detailbereich gepflegt werden.',
  tourTabOverviewTitle: 'Übersicht', tourTabOverviewText: 'Alle Stammdaten, Status, Kaufinformationen und Leasingdetails des Fahrzeugs.',
  tourTabAssignmentsTitle: 'Projektzuweisungen', tourTabAssignmentsText: 'Welchem Projekt ist das Fahrzeug aktuell zugewiesen? Zeitraum und Zuweisungshistorie.',
  tourTabCostsTitle: 'Kosten', tourTabCostsText: 'Reparaturen, Kraftstoff und andere Kosten direkt am Fahrzeug erfassen.',
  tourTabMaintenanceTitle: 'Wartungen', tourTabMaintenanceText: 'Fällige und abgeschlossene Wartungsintervalle mit Terminen und Notizen.',
  tourTabDocumentsTitle: 'Dokumente', tourTabDocumentsText: 'Fahrzeugpapiere, Versicherungen und andere Dokumente hochladen und verwalten.',
  tourTabUsageTitle: 'Nutzungsprotokoll', tourTabUsageText: 'Km-Stand, Betriebsstunden und projektbezogene Nutzungsbuchungen – diese können direkt in Rechnungen übernommen werden.',
  lockedByOther: 'Wird gerade bearbeitet von {name}',
};
const vehiclesEn = {
  title: 'Vehicles',
  add: 'Add vehicle',
  edit: 'Edit vehicle',
  name: 'Name',
  nameRequired: 'Name is required',
  license_plate: 'License plate',
  license_plate_placeholder: 'e.g. BV61 ABC',
  brand: 'Brand',
  model: 'Model',
  year: 'Year',
  editVehicle: 'Edit vehicle',
  newVehicle: 'New vehicle',
  noneFound: 'No vehicles found',
  purchase_type: 'Purchase type',
  allPurchaseTypes: 'All purchase types',
  purchase_type_buy: 'Buy',
  purchase_type_lease: 'Lease',
  purchase_type_rent: 'Rent',
  purchase_price: 'Purchase price',
  leasing_rate: 'Monthly rate',
  leasing_start: 'Lease start',
  leasing_end: 'Lease end',
  leasing_km_limit: 'km limit/year',
  current_km: 'Current km',
  daily_rate: 'Daily rate (billing)',
  daily_rate_placeholder: 'e.g. 150.00',
  status: 'Status',
  allStatuses: 'All statuses',
  status_active: 'Active',
  status_inactive: 'Inactive',
  status_maintenance: 'In maintenance',
  tabOverview: 'Overview', tabAssignments: 'Assignments', tabCosts: 'Costs',
  tabMaintenance: 'Maintenance', tabDocuments: 'Documents', tabUsage: 'Usage',
  addAssignment: 'Add assignment', noAssignments: 'No assignments',
  noAssigned: 'No vehicles assigned',
  assignFrom: 'From', assignTo: 'To',
  assignConflict: 'This vehicle is already assigned to project "{project}" during the selected period. Please adjust the dates or remove the other assignment first.',
  assignStatusBlocked: 'This vehicle cannot be assigned because its current status is "{status}".',
  addCost: 'Add cost', noCosts: 'No costs',
  costType: 'Type', costAmount: 'Amount', costDate: 'Date', costNote: 'Description',
  cost_fuel: 'Fuel', cost_repair: 'Repair', cost_leasing: 'Leasing',
  cost_insurance: 'Insurance', cost_maintenance: 'Maintenance',
  addMaintenance: 'Add maintenance', noMaintenance: 'No maintenance entries',
  maintType: 'Type', maintDue: 'Due date', maintDone: 'Completed',
  maintNext: 'Next due', maintNotes: 'Notes',
  addDocument: 'Add document', noDocuments: 'No documents',
  docType: 'Type', docPath: 'File path',
  doc_invoice: 'Invoice', doc_contract: 'Contract', doc_image: 'Image',
  doc_manual: 'Manual', doc_inspection: 'Inspection',
  addUsage: 'Add usage', noUsage: 'No usage entries',
  usageType: 'Type', usageQty: 'Quantity', usageDate: 'Date',
  usage_hourly: 'Hourly', usage_daily: 'Daily', usage_km: 'KM tracking',
  usageFlat: 'Flat rate', usageKm: 'KM tracking',
  kmBase: 'Distance (km)', kmFactor: 'Factor', kmTotal: 'Total',
  kmBasePlaceholder: 'e.g. 48.5', kmCalculating: 'Calculating…',
  km_rate: 'KM rate (€/km)', km_rate_placeholder: 'e.g. 0.35',
  kmRoundTrip: 'Round trip (×2)',
  kmDays: 'Days', kmDaysShort: ' days',
  kmNoCompanyAddr: 'No company address stored in settings',
  kmNoProjectAddr: 'No site address stored on the project',
  kmCalcFailed: 'Calculation failed – please enter manually',
  infoText: 'Vehicle management provides a complete overview of the vehicle fleet.',
  infoItem1: 'Track vehicle status, mileage and assignments',
  infoItem2: 'Manage costs, maintenance and documents per vehicle',
  infoItem3: 'Assign vehicles to projects and log usage',
  startTour: 'Start tour',
  tourListTitle: 'Vehicle list',
  tourListText: 'All vehicles at a glance with status, licence plate and type. Click a row to open the detail view.',
  tourDetailTitle: 'Vehicle details',
  tourDetailText: 'All information about the selected vehicle – master data, assignments, costs, maintenance and more.',
  tourTabsTitle: 'Tabs',
  tourTabsText: 'Switch between overview, project assignments, costs, maintenance, documents and usage log.',
  tourNewTitle: 'New vehicle',
  tourNewText: 'Creates a new vehicle – with type, make, model, licence plate and purchase information.',
  tourModalTitle: 'Vehicle form',
  tourModalText: 'Enter all master data for the vehicle. Project bookings – assignments, costs and usage – can be maintained afterwards in the detail area.',
  tourTabOverviewTitle: 'Overview', tourTabOverviewText: 'All master data, status, purchase information and leasing details of the vehicle.',
  tourTabAssignmentsTitle: 'Project assignments', tourTabAssignmentsText: 'Which project is the vehicle currently assigned to? Period and assignment history.',
  tourTabCostsTitle: 'Costs', tourTabCostsText: 'Record repairs, fuel and other costs directly on the vehicle.',
  tourTabMaintenanceTitle: 'Maintenance', tourTabMaintenanceText: 'Due and completed maintenance intervals with dates and notes.',
  tourTabDocumentsTitle: 'Documents', tourTabDocumentsText: 'Upload and manage vehicle documents, insurance and other files.',
  tourTabUsageTitle: 'Usage log', tourTabUsageText: 'Mileage, operating hours and project-related usage bookings – these can be included directly in invoices.',
  lockedByOther: 'Currently being edited by {name}',
};
const vehiclesFr = {
  title: 'Véhicules',
  add: 'Ajouter véhicule',
  edit: 'Modifier véhicule',
  name: 'Nom',
  nameRequired: 'Le nom est requis',
  license_plate: 'Plaque',
  license_plate_placeholder: 'ex. AB-123-CD',
  brand: 'Marque',
  model: 'Modèle',
  year: 'Année',
  editVehicle: 'Modifier véhicule',
  newVehicle: 'Nouveau véhicule',
  noneFound: 'Aucun véhicule trouvé',
  purchase_type: 'Type d\'achat',
  allPurchaseTypes: 'Tous les types d\'achat',
  purchase_type_buy: 'Achat',
  purchase_type_lease: 'Location',
  purchase_type_rent: 'Location',
  purchase_price: 'Prix d\'achat',
  leasing_rate: 'Loyer mensuel',
  leasing_start: 'Début du leasing',
  leasing_end: 'Fin du leasing',
  leasing_km_limit: 'Limite km/an',
  current_km: 'Kilométrage actuel',
  status: 'Statut',
  allStatuses: 'Tous les statuts',
  status_active: 'Actif',
  status_inactive: 'Inactif',
  status_maintenance: 'En maintenance',
  tabOverview: 'Aperçu', tabAssignments: 'Affectations', tabCosts: 'Coûts',
  tabMaintenance: 'Maintenance', tabDocuments: 'Documents', tabUsage: 'Utilisation',
  addAssignment: 'Ajouter affectation', noAssignments: 'Aucune affectation',
  noAssigned: 'Aucun véhicule affecté',
  assignFrom: 'De', assignTo: 'À',
  assignConflict: 'Ce véhicule est déjà affecté au projet « {project} » pendant la période sélectionnée. Veuillez ajuster les dates ou supprimer d\'abord l\'autre affectation.',
  assignStatusBlocked: 'Ce véhicule ne peut pas être affecté car son statut actuel est « {status} ».',
  addCost: 'Ajouter coût', noCosts: 'Aucun coût',
  costType: 'Type', costAmount: 'Montant', costDate: 'Date', costNote: 'Description',
  cost_fuel: 'Carburant', cost_repair: 'Réparation', cost_leasing: 'Leasing',
  cost_insurance: 'Assurance', cost_maintenance: 'Maintenance',
  addMaintenance: 'Ajouter maintenance', noMaintenance: 'Aucune maintenance',
  maintType: 'Type', maintDue: 'Échéance', maintDone: 'Effectué le',
  maintNext: 'Prochaine échéance', maintNotes: 'Notes',
  addDocument: 'Ajouter document', noDocuments: 'Aucun document',
  docType: 'Type', docPath: 'Chemin fichier',
  doc_invoice: 'Facture', doc_contract: 'Contrat', doc_image: 'Image',
  doc_manual: 'Manuel', doc_inspection: 'Inspection',
  addUsage: 'Ajouter utilisation', noUsage: 'Aucune utilisation',
  usageType: 'Type', usageQty: 'Quantité', usageDate: 'Date',
  usage_hourly: 'Horaire', usage_daily: 'Journalier', usage_km: 'Suivi km',
  usageFlat: 'Forfait', usageKm: 'Suivi km',
  kmBase: 'Distance (km)', kmFactor: 'Facteur', kmTotal: 'Total',
  kmBasePlaceholder: 'ex. 48,5', kmCalculating: 'Calcul en cours…',
  km_rate: 'Tarif km (€/km)', km_rate_placeholder: 'ex. 0,35',
  kmRoundTrip: 'Aller-retour (×2)',
  kmDays: 'Jours', kmDaysShort: ' j',
  kmNoCompanyAddr: 'Aucune adresse d\'entreprise dans les paramètres',
  kmNoProjectAddr: 'Aucune adresse de chantier sur le projet',
  kmCalcFailed: 'Calcul échoué – veuillez saisir manuellement',
  infoText: 'La gestion des véhicules offre une vue complète de la flotte.',
  infoItem1: 'Suivre le statut, le kilométrage et les affectations des véhicules',
  infoItem2: 'Gérer les coûts, la maintenance et les documents par véhicule',
  infoItem3: 'Affecter les véhicules aux projets et consigner l\'utilisation',
  startTour: 'Lancer la visite guidée',
  tourListTitle: 'Liste des véhicules',
  tourListText: 'Tous les véhicules en un coup d\'œil avec statut, plaque et type. Cliquez sur une ligne pour ouvrir le détail.',
  tourDetailTitle: 'Détails du véhicule',
  tourDetailText: 'Toutes les informations sur le véhicule sélectionné – données de base, affectations, coûts, entretiens et plus.',
  tourTabsTitle: 'Onglets',
  tourTabsText: 'Basculez entre vue d\'ensemble, affectations projet, coûts, entretiens, documents et journal d\'utilisation.',
  tourNewTitle: 'Nouveau véhicule',
  tourNewText: 'Crée un nouveau véhicule – avec type, marque, modèle, plaque et informations d\'achat.',
  tourModalTitle: 'Formulaire véhicule',
  tourModalText: 'Saisissez toutes les données de base. Les réservations projet – affectations, coûts et utilisation – peuvent être gérées ensuite dans la zone de détail.',
  tourTabOverviewTitle: 'Vue d\'ensemble', tourTabOverviewText: 'Toutes les données de base, statut, informations d\'achat et détails de leasing.',
  tourTabAssignmentsTitle: 'Affectations projet', tourTabAssignmentsText: 'À quel projet le véhicule est-il actuellement affecté ? Période et historique.',
  tourTabCostsTitle: 'Coûts', tourTabCostsText: 'Enregistrez réparations, carburant et autres coûts directement sur le véhicule.',
  tourTabMaintenanceTitle: 'Entretiens', tourTabMaintenanceText: 'Intervalles d\'entretien à venir et terminés avec dates et notes.',
  tourTabDocumentsTitle: 'Documents', tourTabDocumentsText: 'Téléversez et gérez les documents du véhicule, assurances et autres fichiers.',
  tourTabUsageTitle: 'Journal d\'utilisation', tourTabUsageText: 'Kilométrage, heures de marche et réservations d\'utilisation par projet – peuvent être incluses directement dans les factures.',
  lockedByOther: 'Actuellement modifie par {name}',
};
const vehiclesIt = {
  title: 'Veicoli',
  add: 'Aggiungi veicolo',
  edit: 'Modifica veicolo',
  name: 'Nome',
  nameRequired: 'Il nome è obbligatorio',
  license_plate: 'Targa',
  license_plate_placeholder: 'es. AB 123 CD',
  brand: 'Marca',
  model: 'Modello',
  year: 'Anno',
  editVehicle: 'Modifica veicolo',
  newVehicle: 'Nuovo veicolo',
  noneFound: 'Nessun veicolo trovato',
  purchase_type: 'Tipo di acquisto',
  allPurchaseTypes: 'Tutti i tipi di acquisto',
  purchase_type_buy: 'Acquisto',
  purchase_type_lease: 'Leasing',
  purchase_type_rent: 'Noleggio',
  purchase_price: 'Prezzo di acquisto',
  leasing_rate: 'Canone mensile',
  leasing_start: 'Inizio leasing',
  leasing_end: 'Fine leasing',
  leasing_km_limit: 'Limite km/anno',
  current_km: 'Chilometraggio attuale',
  status: 'Stato',
  allStatuses: 'Tutti gli stati',
  status_active: 'Attivo',
  status_inactive: 'Inattivo',
  status_maintenance: 'In manutenzione',
  tabOverview: 'Panoramica', tabAssignments: 'Assegnazioni', tabCosts: 'Costi',
  tabMaintenance: 'Manutenzione', tabDocuments: 'Documenti', tabUsage: 'Utilizzo',
  addAssignment: 'Aggiungi assegnazione', noAssignments: 'Nessuna assegnazione',
  noAssigned: 'Nessun veicolo assegnato',
  assignFrom: 'Dal', assignTo: 'Al',
  assignConflict: 'Questo veicolo è già assegnato al progetto "{project}" nel periodo selezionato. Modifica le date o rimuovi prima l\'altra assegnazione.',
  assignStatusBlocked: 'Questo veicolo non può essere assegnato perché il suo stato attuale è "{status}".',
  addCost: 'Aggiungi costo', noCosts: 'Nessun costo',
  costType: 'Tipo', costAmount: 'Importo', costDate: 'Data', costNote: 'Descrizione',
  cost_fuel: 'Carburante', cost_repair: 'Riparazione', cost_leasing: 'Leasing',
  cost_insurance: 'Assicurazione', cost_maintenance: 'Manutenzione',
  addMaintenance: 'Aggiungi manutenzione', noMaintenance: 'Nessuna manutenzione',
  maintType: 'Tipo', maintDue: 'Scadenza', maintDone: 'Completato il',
  maintNext: 'Prossima scadenza', maintNotes: 'Note',
  addDocument: 'Aggiungi documento', noDocuments: 'Nessun documento',
  docType: 'Tipo', docPath: 'Percorso file',
  doc_invoice: 'Fattura', doc_contract: 'Contratto', doc_image: 'Immagine',
  doc_manual: 'Manuale', doc_inspection: 'Ispezione',
  addUsage: 'Aggiungi utilizzo', noUsage: 'Nessun utilizzo',
  usageType: 'Tipo', usageQty: 'Quantità', usageDate: 'Data',
  usage_hourly: 'Orario', usage_daily: 'Giornaliero', usage_km: 'Tracciamento km',
  usageFlat: 'Forfettario', usageKm: 'Tracciamento km',
  kmBase: 'Distanza (km)', kmFactor: 'Fattore', kmTotal: 'Totale',
  kmBasePlaceholder: 'es. 48,5', kmCalculating: 'Calcolo in corso…',
  km_rate: 'Tariffa km (€/km)', km_rate_placeholder: 'es. 0,35',
  kmRoundTrip: 'Andata e ritorno (×2)',
  kmDays: 'Giorni', kmDaysShort: ' gg',
  kmNoCompanyAddr: 'Nessun indirizzo aziendale nelle impostazioni',
  kmNoProjectAddr: 'Nessun indirizzo cantiere nel progetto',
  kmCalcFailed: 'Calcolo fallito – inserire manualmente',
  infoText: 'La gestione dei veicoli offre una panoramica completa della flotta.',
  infoItem1: 'Monitorare stato, chilometraggio e assegnazioni dei veicoli',
  infoItem2: 'Gestire costi, manutenzione e documenti per veicolo',
  infoItem3: 'Assegnare veicoli ai progetti e registrare l\'utilizzo',
  startTour: 'Avvia la guida',
  tourListTitle: 'Lista veicoli',
  tourListText: 'Tutti i veicoli in sintesi con stato, targa e tipo. Clic su una riga per aprire il dettaglio.',
  tourDetailTitle: 'Dettagli veicolo',
  tourDetailText: 'Tutte le informazioni sul veicolo selezionato – dati principali, assegnazioni, costi, manutenzioni e altro.',
  tourTabsTitle: 'Tab',
  tourTabsText: 'Passa tra panoramica, assegnazioni progetto, costi, manutenzioni, documenti e registro utilizzo.',
  tourNewTitle: 'Nuovo veicolo',
  tourNewText: 'Crea un nuovo veicolo – con tipo, marca, modello, targa e informazioni di acquisto.',
  tourModalTitle: 'Modulo veicolo',
  tourModalText: 'Inserisci tutti i dati principali. Le prenotazioni progetto – assegnazioni, costi e utilizzo – possono essere gestite in seguito nell\'area dettaglio.',
  tourTabOverviewTitle: 'Panoramica', tourTabOverviewText: 'Tutti i dati principali, stato, informazioni di acquisto e dettagli leasing.',
  tourTabAssignmentsTitle: 'Assegnazioni progetto', tourTabAssignmentsText: 'A quale progetto è attualmente assegnato il veicolo? Periodo e storico.',
  tourTabCostsTitle: 'Costi', tourTabCostsText: 'Registra riparazioni, carburante e altri costi direttamente sul veicolo.',
  tourTabMaintenanceTitle: 'Manutenzioni', tourTabMaintenanceText: 'Intervalli di manutenzione in scadenza e completati con date e note.',
  tourTabDocumentsTitle: 'Documenti', tourTabDocumentsText: 'Carica e gestisci documenti del veicolo, assicurazioni e altri file.',
  tourTabUsageTitle: 'Registro utilizzo', tourTabUsageText: 'Chilometraggio, ore di esercizio e prenotazioni utilizzo per progetto – possono essere incluse direttamente nelle fatture.',
  lockedByOther: 'Attualmente in modifica da {name}',
};
const vehiclesPl = {
  title: 'Pojazdy',
  add: 'Dodaj pojazd',
  edit: 'Edytuj pojazd',
  name: 'Nazwa',
  nameRequired: 'Nazwa jest wymagana',
  license_plate: 'Tablica',
  license_plate_placeholder: 'np. AB 12345',
  brand: 'Marka',
  model: 'Model',
  year: 'Rok',
  editVehicle: 'Edytuj pojazd',
  newVehicle: 'Nowy pojazd',
  noneFound: 'Nie znaleziono pojazdów',
  purchase_type: 'Rodzaj zakupu',
  allPurchaseTypes: 'Wszystkie rodzaje zakupu',
  purchase_type_buy: 'Kupno',
  purchase_type_lease: 'Leasing',
  purchase_type_rent: 'Wynajem',
  purchase_price: 'Cena zakupu',
  leasing_rate: 'Rata miesieczna',
  leasing_start: 'Poczatek leasingu',
  leasing_end: 'Koniec leasingu',
  leasing_km_limit: 'Limit km/rok',
  current_km: 'Aktualny przebieg',
  status: 'Status',
  allStatuses: 'Wszystkie statusy',
  status_active: 'Aktywny',
  status_inactive: 'Nieaktywny',
  status_maintenance: 'W naprawie',
  tabOverview: 'Przeglad', tabAssignments: 'Przypisania', tabCosts: 'Koszty',
  tabMaintenance: 'Serwis', tabDocuments: 'Dokumenty', tabUsage: 'Uzycie',
  addAssignment: 'Dodaj przypisanie', noAssignments: 'Brak przypisani',
  noAssigned: 'Brak przypisanych pojazdów',
  assignFrom: 'Od', assignTo: 'Do',
  assignConflict: 'Ten pojazd jest już przypisany do projektu „{project}" w wybranym okresie. Zmień daty lub najpierw usuń inne przypisanie.',
  assignStatusBlocked: 'Ten pojazd nie może być przypisany, ponieważ jego aktualny status to „{status}".',
  addCost: 'Dodaj koszt', noCosts: 'Brak kosztow',
  costType: 'Typ', costAmount: 'Kwota', costDate: 'Data', costNote: 'Opis',
  cost_fuel: 'Paliwo', cost_repair: 'Naprawa', cost_leasing: 'Leasing',
  cost_insurance: 'Ubezpieczenie', cost_maintenance: 'Serwis',
  addMaintenance: 'Dodaj serwis', noMaintenance: 'Brak wpisow serwisowych',
  maintType: 'Typ', maintDue: 'Termin', maintDone: 'Wykonano',
  maintNext: 'Nastepny termin', maintNotes: 'Uwagi',
  addDocument: 'Dodaj dokument', noDocuments: 'Brak dokumentow',
  docType: 'Typ', docPath: 'Sciezka pliku',
  doc_invoice: 'Faktura', doc_contract: 'Umowa', doc_image: 'Zdjecie',
  doc_manual: 'Instrukcja', doc_inspection: 'Przeglad',
  addUsage: 'Dodaj uzycie', noUsage: 'Brak wpisow uzycia',
  usageType: 'Typ', usageQty: 'Ilosc', usageDate: 'Data',
  usage_hourly: 'Godzinowe', usage_daily: 'Dzienne', usage_km: 'Śledzenie km',
  usageFlat: 'Ryczałt', usageKm: 'Śledzenie km',
  kmBase: 'Odległość (km)', kmFactor: 'Współczynnik', kmTotal: 'Łącznie',
  kmBasePlaceholder: 'np. 48,5', kmCalculating: 'Obliczanie…',
  km_rate: 'Stawka km (€/km)', km_rate_placeholder: 'np. 0,35',
  kmRoundTrip: 'W obie strony (×2)',
  kmDays: 'Dni', kmDaysShort: ' dni',
  kmNoCompanyAddr: 'Brak adresu firmy w ustawieniach',
  kmNoProjectAddr: 'Brak adresu budowy w projekcie',
  kmCalcFailed: 'Obliczenie nieudane – wprowadź ręcznie',
  infoText: 'Zarzadzanie pojazdami zapewnia pelen przeglad floty pojazdow.',
  infoItem1: 'Sledzic status pojazdu, przebieg i przypisania',
  infoItem2: 'Zarzadzac kosztami, konserwacja i dokumentami dla kazdego pojazdu',
  infoItem3: 'Przypisywac pojazdy do projektow i rejestrowac uzycie',
  startTour: 'Uruchom przewodnik',
  tourListTitle: 'Lista pojazdów',
  tourListText: 'Wszystkie pojazdy na pierwszy rzut oka ze statusem, tablicą i typem. Klik wiersza otwiera szczegóły.',
  tourDetailTitle: 'Szczegóły pojazdu',
  tourDetailText: 'Wszystkie informacje o wybranym pojeździe – dane podstawowe, przypisania, koszty, konserwacje i więcej.',
  tourTabsTitle: 'Zakładki',
  tourTabsText: 'Przełącz między przeglądem, przypisaniami projektu, kosztami, konserwacjami, dokumentami i dziennikiem użycia.',
  tourNewTitle: 'Nowy pojazd',
  tourNewText: 'Tworzy nowy pojazd – z typem, marką, modelem, tablicą i informacjami zakupu.',
  tourModalTitle: 'Formularz pojazdu',
  tourModalText: 'Wprowadź wszystkie dane podstawowe. Rezerwacje projektu – przypisania, koszty i użycie – można zarządzać w obszarze szczegółów.',
  tourTabOverviewTitle: 'Przegląd', tourTabOverviewText: 'Wszystkie dane podstawowe, status, informacje zakupu i szczegóły leasingu.',
  tourTabAssignmentsTitle: 'Przypisania projektu', tourTabAssignmentsText: 'Do jakiego projektu jest aktualnie przypisany pojazd? Okres i historia.',
  tourTabCostsTitle: 'Koszty', tourTabCostsText: 'Rejestruj naprawy, paliwo i inne koszty bezpośrednio przy pojeździe.',
  tourTabMaintenanceTitle: 'Konserwacje', tourTabMaintenanceText: 'Zaplanowane i zakończone interwały konserwacji z datami i notatkami.',
  tourTabDocumentsTitle: 'Dokumenty', tourTabDocumentsText: 'Przesyłaj i zarządzaj dokumentami pojazdu, ubezpieczeniami i innymi plikami.',
  tourTabUsageTitle: 'Dziennik użycia', tourTabUsageText: 'Przebieg, godziny pracy i rezerwacje użycia per projekt – można je bezpośrednio uwzględnić w fakturach.',
  lockedByOther: 'Aktualnie edytowane przez {name}',
};
const vehiclesCs = {
  title: 'Vozidla',
  add: 'Pridat vozidlo',
  edit: 'Upravit vozidlo',
  name: 'Nazev',
  nameRequired: 'Nazev je povinny',
  license_plate: 'SPZ',
  license_plate_placeholder: 'napr. 1A2 3456',
  brand: 'Znacka',
  model: 'Model',
  year: 'Rok',
  editVehicle: 'Upravit vozidlo',
  newVehicle: 'Nove vozidlo',
  noneFound: 'Zadna vozidla nenalezena',
  purchase_type: 'Typ nakupu',
  allPurchaseTypes: 'Vsechny typy nakupu',
  purchase_type_buy: 'Koupe',
  purchase_type_lease: 'Leasing',
  purchase_type_rent: 'Pronajem',
  purchase_price: 'Cena nakupu',
  leasing_rate: 'Mesicni splatka',
  leasing_start: 'Zacatek leasingu',
  leasing_end: 'Konec leasingu',
  leasing_km_limit: 'Limit km/rok',
  current_km: 'Aktualni stav km',
  status: 'Stav',
  allStatuses: 'Vsechny stavy',
  status_active: 'Aktivni',
  status_inactive: 'Neaktivni',
  status_maintenance: 'V servisu',
  tabOverview: 'Prehled', tabAssignments: 'Prirazeni', tabCosts: 'Naklady',
  tabMaintenance: 'Servis', tabDocuments: 'Dokumenty', tabUsage: 'Pouziti',
  addAssignment: 'Pridat prirazeni', noAssignments: 'Zadna prirazeni',
  noAssigned: 'Zadna prirazena vozidla',
  assignFrom: 'Od', assignTo: 'Do',
  assignConflict: 'Toto vozidlo je jiz prirazeno k projektu „{project}" ve zvoleném období. Upravte data nebo nejdrive odeberte jine prirazeni.',
  assignStatusBlocked: 'Toto vozidlo nelze priradit, protoze jeho aktualni stav je „{status}".',
  addCost: 'Pridat naklad', noCosts: 'Zadne naklady',
  costType: 'Typ', costAmount: 'Castka', costDate: 'Datum', costNote: 'Popis',
  cost_fuel: 'Palivo', cost_repair: 'Oprava', cost_leasing: 'Leasing',
  cost_insurance: 'Pojisteni', cost_maintenance: 'Servis',
  addMaintenance: 'Pridat servis', noMaintenance: 'Zadne zaznamy servisu',
  maintType: 'Typ', maintDue: 'Termin', maintDone: 'Provedeno',
  maintNext: 'Pristi termin', maintNotes: 'Poznamky',
  addDocument: 'Pridat dokument', noDocuments: 'Zadne dokumenty',
  docType: 'Typ', docPath: 'Cesta k souboru',
  doc_invoice: 'Faktura', doc_contract: 'Smlouva', doc_image: 'Obrazek',
  doc_manual: 'Manual', doc_inspection: 'Prohlídka',
  addUsage: 'Pridat pouziti', noUsage: 'Zadne zaznamy pouziti',
  usageType: 'Typ', usageQty: 'Mnozstvi', usageDate: 'Datum',
  usage_hourly: 'Hodinove', usage_daily: 'Denni', usage_km: 'Sledování km',
  usageFlat: 'Paušál', usageKm: 'Sledování km',
  kmBase: 'Vzdálenost (km)', kmFactor: 'Faktor', kmTotal: 'Celkem',
  kmBasePlaceholder: 'např. 48,5', kmCalculating: 'Vypočítávám…',
  km_rate: 'Sazba km (€/km)', km_rate_placeholder: 'např. 0,35',
  kmRoundTrip: 'Tam a zpět (×2)',
  kmDays: 'Dny', kmDaysShort: ' dny',
  kmNoCompanyAddr: 'Žádná adresa firmy v nastavení',
  kmNoProjectAddr: 'Žádná adresa staveniště v projektu',
  kmCalcFailed: 'Výpočet selhal – zadejte ručně',
  infoText: 'Sprava vozidel poskytuje uplny prehled o vozovem parku.',
  infoItem1: 'Sledovat stav vozidla, najezd a prirazeni',
  infoItem2: 'Spravovat naklady, udrzbu a dokumenty pro kazde vozidlo',
  infoItem3: 'Prirazovat vozidla k projektum a zaznamenavat pouziti',
  startTour: 'Spustit průvodce',
  tourListTitle: 'Seznam vozidel',
  tourListText: 'Všechna vozidla na první pohled se stavem, SPZ a typem. Kliknutím na řádek otevřete detail.',
  tourDetailTitle: 'Detail vozidla',
  tourDetailText: 'Všechny informace o vybraném vozidle – základní údaje, přiřazení, náklady, údržba a další.',
  tourTabsTitle: 'Záložky',
  tourTabsText: 'Přepínejte mezi přehledem, přiřazeními projektu, náklady, údržbou, dokumenty a protokolem využití.',
  tourNewTitle: 'Nové vozidlo',
  tourNewText: 'Vytvoří nové vozidlo – s typem, značkou, modelem, SPZ a informacemi o nákupu.',
  tourModalTitle: 'Formulář vozidla',
  tourModalText: 'Zadejte všechny základní údaje. Projektové rezervace – přiřazení, náklady a využití – lze spravovat v oblasti detailu.',
  tourTabOverviewTitle: 'Přehled', tourTabOverviewText: 'Všechny základní údaje, stav, informace o nákupu a detaily leasingu.',
  tourTabAssignmentsTitle: 'Přiřazení projektu', tourTabAssignmentsText: 'Ke kterému projektu je vozidlo aktuálně přiřazeno? Období a historie.',
  tourTabCostsTitle: 'Náklady', tourTabCostsText: 'Zaznamenejte opravy, palivo a další náklady přímo u vozidla.',
  tourTabMaintenanceTitle: 'Údržba', tourTabMaintenanceText: 'Nadcházející a dokončené intervaly údržby s daty a poznámkami.',
  tourTabDocumentsTitle: 'Dokumenty', tourTabDocumentsText: 'Nahrajte a spravujte doklady vozidla, pojištění a další soubory.',
  tourTabUsageTitle: 'Protokol využití', tourTabUsageText: 'Stav km, provozní hodiny a projektové rezervace využití – lze je přímo zahrnout do faktur.',
  lockedByOther: 'Prave upravuje {name}',
};

// ── Maschinen (Machines) ─────────────────────────────────────────────
const machinesDe = {
  title: 'Maschinen',
  add: 'Maschine anlegen',
  edit: 'Maschine bearbeiten',
  name: 'Name',
  nameRequired: 'Name ist erforderlich',
  newMachine: 'Neue Maschine',
  editMachine: 'Maschine bearbeiten',
  noneFound: 'Keine Maschinen gefunden',
  type: 'Typ',
  serial_number: 'Seriennummer',
  manufacturer: 'Hersteller',
  model: 'Modell',
  year: 'Baujahr',
  purchase_price: 'Kaufpreis',
  leasing_rate: 'Monatliche Rate',
  leasing_start: 'Leasingbeginn',
  leasing_end: 'Leasingende',
  purchase_type: 'Kaufart',
  purchase_type_buy: 'Kauf',
  purchase_type_lease: 'Leasing',
  location: 'Standort',
  daily_rate: 'Tagessatz (Abrechnung)',
  daily_rate_placeholder: 'z.B. 150.00',
  status: 'Status',
  allStatuses: 'Alle Status',
  status_active: 'Aktiv',
  status_inactive: 'Inaktiv',
  status_maintenance: 'In Wartung',
  status_defective: 'Defekt',
  tabOverview: 'Übersicht', tabAssignments: 'Zuweisungen', tabCosts: 'Kosten',
  tabMaintenance: 'Wartung', tabDocuments: 'Dokumente', tabUsage: 'Nutzung',
  addAssignment: 'Zuweisung hinzufügen', noAssignments: 'Keine Zuweisungen',
  assignFrom: 'Von', assignTo: 'Bis',
  assignConflict: 'Diese Maschine ist im gewählten Zeitraum bereits dem Projekt „{project}" zugewiesen. Bitte Zeitraum anpassen oder zuerst die andere Zuweisung entfernen.',
  assignStatusBlocked: 'Diese Maschine kann nicht zugewiesen werden, da sie sich aktuell im Status „{status}" befindet.',
  addCost: 'Kosten hinzufügen', noCosts: 'Keine Kosten',
  costType: 'Typ', costAmount: 'Betrag', costDate: 'Datum', costNote: 'Beschreibung',
  cost_fuel: 'Kraftstoff', cost_repair: 'Reparatur', cost_maintenance: 'Wartung',
  addMaintenance: 'Wartung hinzufügen', noMaintenance: 'Keine Wartungen',
  maintType: 'Typ', maintDue: 'Fällig am', maintDone: 'Erledigt am',
  maintNext: 'Nächste Fälligkeit', maintNotes: 'Notizen',
  addDocument: 'Dokument hinzufügen', noDocuments: 'Keine Dokumente',
  docType: 'Typ', docPath: 'Dateipfad',
  doc_invoice: 'Rechnung', doc_manual: 'Handbuch', doc_inspection: 'Inspektion',
  addUsage: 'Nutzung hinzufügen', noUsage: 'Keine Nutzungen',
  usageType: 'Typ', usageQty: 'Menge', usageDate: 'Datum',
  usage_hourly: 'Stundenweise', usage_daily: 'Tageweise',
  infoText: 'Die Maschinenverwaltung bietet eine vollständige Übersicht über den Maschinenpark.',
  infoItem1: 'Maschinenstatus, Standort und Zuweisungen im Blick behalten',
  infoItem2: 'Kosten, Wartungen und Dokumente je Maschine verwalten',
  infoItem3: 'Maschinen Projekten zuweisen und Nutzung protokollieren',
  startTour: 'Führung starten',
  tourListTitle: 'Maschinenliste', tourListText: 'Alle Maschinen mit Status, Typ und Standort. Klick öffnet die Detailansicht.',
  tourDetailTitle: 'Maschinendetails', tourDetailText: 'Alle Informationen zur ausgewählten Maschine – Stammdaten, Zuweisungen, Kosten, Wartungen und mehr.',
  tourTabOverviewTitle: 'Übersicht', tourTabOverviewText: 'Stammdaten, Status, Kaufinformationen und technische Details der Maschine.',
  tourTabAssignmentsTitle: 'Projektzuweisungen', tourTabAssignmentsText: 'Welchem Projekt ist die Maschine zugewiesen? Zeitraum und Zuweisungshistorie.',
  tourTabCostsTitle: 'Kosten', tourTabCostsText: 'Reparaturen, Betriebskosten und weitere Ausgaben direkt an der Maschine erfassen.',
  tourTabMaintenanceTitle: 'Wartungen', tourTabMaintenanceText: 'Fällige und abgeschlossene Wartungsintervalle mit Terminen und Notizen.',
  tourTabDocumentsTitle: 'Dokumente', tourTabDocumentsText: 'Maschinenhandbücher, Prüfprotokolle und andere Dokumente hochladen und verwalten.',
  tourTabUsageTitle: 'Nutzungsprotokoll', tourTabUsageText: 'Betriebsstunden und projektbezogene Nutzungsbuchungen – können direkt in Rechnungen übernommen werden.',
  tourNewTitle: 'Neue Maschine', tourNewText: 'Legt eine neue Maschine an – mit Typ, Hersteller, Modell und Kaufinformationen.',
  tourModalTitle: 'Maschinenformular', tourModalText: 'Alle Stammdaten erfassen. Buchungen auf Projekte können danach im Detailbereich gepflegt werden.',
  lockedByOther: 'Wird gerade bearbeitet von {name}',
};
const machinesEn = {
  title: 'Machines', add: 'Add machine', edit: 'Edit machine', name: 'Name',
  nameRequired: 'Name is required', newMachine: 'New machine', editMachine: 'Edit machine',
  noneFound: 'No machines found', type: 'Type', serial_number: 'Serial number',
  manufacturer: 'Manufacturer', model: 'Model', year: 'Year', purchase_price: 'Purchase price',
  leasing_rate: 'Monthly rate', leasing_start: 'Lease start', leasing_end: 'Lease end',
  purchase_type: 'Purchase type', purchase_type_buy: 'Buy', purchase_type_lease: 'Lease',
  daily_rate: 'Daily rate (billing)', daily_rate_placeholder: 'e.g. 150.00',
  location: 'Location', status: 'Status', allStatuses: 'All statuses',
  status_active: 'Active', status_inactive: 'Inactive', status_maintenance: 'In maintenance', status_defective: 'Defective',
  tabOverview: 'Overview', tabAssignments: 'Assignments', tabCosts: 'Costs',
  tabMaintenance: 'Maintenance', tabDocuments: 'Documents', tabUsage: 'Usage',
  addAssignment: 'Add assignment', noAssignments: 'No assignments', assignFrom: 'From', assignTo: 'To',
  assignConflict: 'This machine is already assigned to project "{project}" during the selected period. Please adjust the dates or remove the other assignment first.',
  assignStatusBlocked: 'This machine cannot be assigned because its current status is "{status}".',
  addCost: 'Add cost', noCosts: 'No costs', costType: 'Type', costAmount: 'Amount', costDate: 'Date', costNote: 'Description',
  cost_fuel: 'Fuel', cost_repair: 'Repair', cost_maintenance: 'Maintenance',
  addMaintenance: 'Add maintenance', noMaintenance: 'No maintenance entries',
  maintType: 'Type', maintDue: 'Due date', maintDone: 'Completed', maintNext: 'Next due', maintNotes: 'Notes',
  addDocument: 'Add document', noDocuments: 'No documents', docType: 'Type', docPath: 'File path',
  doc_invoice: 'Invoice', doc_manual: 'Manual', doc_inspection: 'Inspection',
  addUsage: 'Add usage', noUsage: 'No usage entries', usageType: 'Type', usageQty: 'Quantity', usageDate: 'Date',
  usage_hourly: 'Hourly', usage_daily: 'Daily',
  infoText: 'Machine management provides a complete overview of the machine fleet.',
  infoItem1: 'Track machine status, location and assignments',
  infoItem2: 'Manage costs, maintenance and documents per machine',
  infoItem3: 'Assign machines to projects and log usage',
  startTour: 'Start tour',
  tourListTitle: 'Machine list', tourListText: 'All machines with status, type and location. Click to open the detail view.',
  tourDetailTitle: 'Machine details', tourDetailText: 'All information about the selected machine – master data, assignments, costs, maintenance and more.',
  tourTabOverviewTitle: 'Overview', tourTabOverviewText: 'Master data, status, purchase information and technical details of the machine.',
  tourTabAssignmentsTitle: 'Project assignments', tourTabAssignmentsText: 'Which project is the machine assigned to? Period and assignment history.',
  tourTabCostsTitle: 'Costs', tourTabCostsText: 'Record repairs, operating costs and other expenses directly on the machine.',
  tourTabMaintenanceTitle: 'Maintenance', tourTabMaintenanceText: 'Due and completed maintenance intervals with dates and notes.',
  tourTabDocumentsTitle: 'Documents', tourTabDocumentsText: 'Upload and manage machine manuals, inspection records and other documents.',
  tourTabUsageTitle: 'Usage log', tourTabUsageText: 'Operating hours and project-related usage bookings – can be included directly in invoices.',
  tourNewTitle: 'New machine', tourNewText: 'Creates a new machine – with type, manufacturer, model and purchase information.',
  tourModalTitle: 'Machine form', tourModalText: 'Enter all master data. Project bookings can be maintained afterwards in the detail area.',
  lockedByOther: 'Currently being edited by {name}',
};
const machinesFr = {
  title: 'Machines', add: 'Ajouter machine', edit: 'Modifier machine', name: 'Nom',
  nameRequired: 'Le nom est requis', newMachine: 'Nouvelle machine', editMachine: 'Modifier machine',
  noneFound: 'Aucune machine trouvée', type: 'Type', serial_number: 'Numéro de série',
  manufacturer: 'Fabricant', model: 'Modèle', year: 'Année', purchase_price: 'Prix d\'achat',
  leasing_rate: 'Loyer mensuel', leasing_start: 'Début du leasing', leasing_end: 'Fin du leasing',
  purchase_type: 'Type d\'achat', purchase_type_buy: 'Achat', purchase_type_lease: 'Location',
  location: 'Emplacement', status: 'Statut', allStatuses: 'Tous les statuts',
  status_active: 'Actif', status_inactive: 'Inactif', status_maintenance: 'En maintenance', status_defective: 'Défectueux',
  tabOverview: 'Aperçu', tabAssignments: 'Affectations', tabCosts: 'Coûts',
  tabMaintenance: 'Maintenance', tabDocuments: 'Documents', tabUsage: 'Utilisation',
  addAssignment: 'Ajouter affectation', noAssignments: 'Aucune affectation', assignFrom: 'De', assignTo: 'À',
  assignConflict: 'Cette machine est déjà affectée au projet « {project} » pendant la période sélectionnée. Veuillez ajuster les dates ou supprimer d\'abord l\'autre affectation.',
  assignStatusBlocked: 'Cette machine ne peut pas être affectée car son statut actuel est « {status} ».',
  addCost: 'Ajouter coût', noCosts: 'Aucun coût', costType: 'Type', costAmount: 'Montant', costDate: 'Date', costNote: 'Description',
  cost_fuel: 'Carburant', cost_repair: 'Réparation', cost_maintenance: 'Maintenance',
  addMaintenance: 'Ajouter maintenance', noMaintenance: 'Aucune maintenance',
  maintType: 'Type', maintDue: 'Échéance', maintDone: 'Effectué le', maintNext: 'Prochaine échéance', maintNotes: 'Notes',
  addDocument: 'Ajouter document', noDocuments: 'Aucun document', docType: 'Type', docPath: 'Chemin fichier',
  doc_invoice: 'Facture', doc_manual: 'Manuel', doc_inspection: 'Inspection',
  addUsage: 'Ajouter utilisation', noUsage: 'Aucune utilisation', usageType: 'Type', usageQty: 'Quantité', usageDate: 'Date',
  usage_hourly: 'Horaire', usage_daily: 'Journalier',
  infoText: 'La gestion des machines offre une vue complète du parc de machines.',
  infoItem1: 'Suivre le statut, l\'emplacement et les affectations des machines',
  infoItem2: 'Gérer les coûts, la maintenance et les documents par machine',
  infoItem3: 'Affecter les machines aux projets et consigner l\'utilisation',
  startTour: 'Lancer la visite guidée',
  tourListTitle: 'Liste des machines', tourListText: 'Toutes les machines avec statut, type et emplacement. Cliquez pour ouvrir le détail.',
  tourDetailTitle: 'Détails machine', tourDetailText: 'Toutes les informations sur la machine – données de base, affectations, coûts, entretiens et plus.',
  tourTabOverviewTitle: 'Vue d\'ensemble', tourTabOverviewText: 'Données de base, statut, informations d\'achat et détails techniques.',
  tourTabAssignmentsTitle: 'Affectations projet', tourTabAssignmentsText: 'À quel projet la machine est-elle affectée ? Période et historique.',
  tourTabCostsTitle: 'Coûts', tourTabCostsText: 'Réparations, coûts d\'exploitation et autres dépenses directement sur la machine.',
  tourTabMaintenanceTitle: 'Entretiens', tourTabMaintenanceText: 'Intervalles d\'entretien à venir et terminés avec dates et notes.',
  tourTabDocumentsTitle: 'Documents', tourTabDocumentsText: 'Manuels, procès-verbaux d\'inspection et autres documents à téléverser.',
  tourTabUsageTitle: 'Journal d\'utilisation', tourTabUsageText: 'Heures de marche et réservations d\'utilisation par projet – peuvent être incluses dans les factures.',
  tourNewTitle: 'Nouvelle machine', tourNewText: 'Crée une nouvelle machine – avec type, fabricant, modèle et informations d\'achat.',
  tourModalTitle: 'Formulaire machine', tourModalText: 'Saisissez toutes les données de base. Les réservations projet se gèrent ensuite dans la zone détail.',
  lockedByOther: 'Actuellement modifie par {name}',
};
const machinesIt = {
  title: 'Macchine', add: 'Aggiungi macchina', edit: 'Modifica macchina', name: 'Nome',
  nameRequired: 'Il nome è obbligatorio', newMachine: 'Nuova macchina', editMachine: 'Modifica macchina',
  noneFound: 'Nessuna macchina trovata', type: 'Tipo', serial_number: 'Numero di serie',
  manufacturer: 'Produttore', model: 'Modello', year: 'Anno', purchase_price: 'Prezzo di acquisto',
  leasing_rate: 'Canone mensile', leasing_start: 'Inizio leasing', leasing_end: 'Fine leasing',
  purchase_type: 'Tipo di acquisto', purchase_type_buy: 'Acquisto', purchase_type_lease: 'Leasing',
  location: 'Posizione', status: 'Stato', allStatuses: 'Tutti gli stati',
  status_active: 'Attivo', status_inactive: 'Inattivo', status_maintenance: 'In manutenzione', status_defective: 'Difettoso',
  tabOverview: 'Panoramica', tabAssignments: 'Assegnazioni', tabCosts: 'Costi',
  tabMaintenance: 'Manutenzione', tabDocuments: 'Documenti', tabUsage: 'Utilizzo',
  addAssignment: 'Aggiungi assegnazione', noAssignments: 'Nessuna assegnazione', assignFrom: 'Dal', assignTo: 'Al',
  assignConflict: 'Questa macchina è già assegnata al progetto "{project}" nel periodo selezionato. Modifica le date o rimuovi prima l\'altra assegnazione.',
  assignStatusBlocked: 'Questa macchina non può essere assegnata perché il suo stato attuale è "{status}".',
  addCost: 'Aggiungi costo', noCosts: 'Nessun costo', costType: 'Tipo', costAmount: 'Importo', costDate: 'Data', costNote: 'Descrizione',
  cost_fuel: 'Carburante', cost_repair: 'Riparazione', cost_maintenance: 'Manutenzione',
  addMaintenance: 'Aggiungi manutenzione', noMaintenance: 'Nessuna manutenzione',
  maintType: 'Tipo', maintDue: 'Scadenza', maintDone: 'Completato il', maintNext: 'Prossima scadenza', maintNotes: 'Note',
  addDocument: 'Aggiungi documento', noDocuments: 'Nessun documento', docType: 'Tipo', docPath: 'Percorso file',
  doc_invoice: 'Fattura', doc_manual: 'Manuale', doc_inspection: 'Ispezione',
  addUsage: 'Aggiungi utilizzo', noUsage: 'Nessun utilizzo', usageType: 'Tipo', usageQty: 'Quantità', usageDate: 'Data',
  usage_hourly: 'Orario', usage_daily: 'Giornaliero',
  infoText: 'La gestione dei macchinari offre una panoramica completa del parco macchine.',
  infoItem1: 'Monitorare stato, posizione e assegnazioni dei macchinari',
  infoItem2: 'Gestire costi, manutenzione e documenti per macchina',
  infoItem3: 'Assegnare macchinari ai progetti e registrare l\'utilizzo',
  startTour: 'Avvia la guida',
  tourListTitle: 'Lista macchinari', tourListText: 'Tutti i macchinari con stato, tipo e posizione. Clic per aprire il dettaglio.',
  tourDetailTitle: 'Dettagli macchinario', tourDetailText: 'Tutte le informazioni sul macchinario – dati principali, assegnazioni, costi, manutenzioni e altro.',
  tourTabOverviewTitle: 'Panoramica', tourTabOverviewText: 'Dati principali, stato, informazioni di acquisto e dettagli tecnici.',
  tourTabAssignmentsTitle: 'Assegnazioni progetto', tourTabAssignmentsText: 'A quale progetto è assegnato il macchinario? Periodo e storico.',
  tourTabCostsTitle: 'Costi', tourTabCostsText: 'Riparazioni, costi operativi e altre spese direttamente sul macchinario.',
  tourTabMaintenanceTitle: 'Manutenzioni', tourTabMaintenanceText: 'Intervalli di manutenzione in scadenza e completati con date e note.',
  tourTabDocumentsTitle: 'Documenti', tourTabDocumentsText: 'Manuali, verbali di ispezione e altri documenti da caricare.',
  tourTabUsageTitle: 'Registro utilizzo', tourTabUsageText: 'Ore di esercizio e prenotazioni utilizzo per progetto – includibili direttamente nelle fatture.',
  tourNewTitle: 'Nuovo macchinario', tourNewText: 'Crea un nuovo macchinario – con tipo, produttore, modello e informazioni di acquisto.',
  tourModalTitle: 'Modulo macchinario', tourModalText: 'Inserisci tutti i dati principali. Le prenotazioni progetto si gestiscono poi nell\'area dettaglio.',
  lockedByOther: 'Attualmente in modifica da {name}',
};
const machinesPl = {
  title: 'Maszyny', add: 'Dodaj maszyne', edit: 'Edytuj maszyne', name: 'Nazwa',
  nameRequired: 'Nazwa jest wymagana', newMachine: 'Nowa maszyna', editMachine: 'Edytuj maszyne',
  noneFound: 'Nie znaleziono maszyn', type: 'Typ', serial_number: 'Numer seryjny',
  manufacturer: 'Producent', model: 'Model', year: 'Rok', purchase_price: 'Cena zakupu',
  leasing_rate: 'Rata miesieczna', leasing_start: 'Poczatek leasingu', leasing_end: 'Koniec leasingu',
  purchase_type: 'Rodzaj zakupu', purchase_type_buy: 'Kupno', purchase_type_lease: 'Leasing',
  location: 'Lokalizacja', status: 'Status', allStatuses: 'Wszystkie statusy',
  status_active: 'Aktywny', status_inactive: 'Nieaktywny', status_maintenance: 'W naprawie', status_defective: 'Uszkodzony',
  tabOverview: 'Przeglad', tabAssignments: 'Przypisania', tabCosts: 'Koszty',
  tabMaintenance: 'Serwis', tabDocuments: 'Dokumenty', tabUsage: 'Uzycie',
  addAssignment: 'Dodaj przypisanie', noAssignments: 'Brak przypisani', assignFrom: 'Od', assignTo: 'Do',
  assignConflict: 'Ta maszyna jest już przypisana do projektu „{project}" w wybranym okresie. Zmień daty lub najpierw usuń inne przypisanie.',
  assignStatusBlocked: 'Ta maszyna nie może być przypisana, ponieważ jej aktualny status to „{status}".',
  addCost: 'Dodaj koszt', noCosts: 'Brak kosztow', costType: 'Typ', costAmount: 'Kwota', costDate: 'Data', costNote: 'Opis',
  cost_fuel: 'Paliwo', cost_repair: 'Naprawa', cost_maintenance: 'Serwis',
  addMaintenance: 'Dodaj serwis', noMaintenance: 'Brak wpisow serwisowych',
  maintType: 'Typ', maintDue: 'Termin', maintDone: 'Wykonano', maintNext: 'Nastepny termin', maintNotes: 'Uwagi',
  addDocument: 'Dodaj dokument', noDocuments: 'Brak dokumentow', docType: 'Typ', docPath: 'Sciezka pliku',
  doc_invoice: 'Faktura', doc_manual: 'Instrukcja', doc_inspection: 'Przeglad',
  addUsage: 'Dodaj uzycie', noUsage: 'Brak wpisow uzycia', usageType: 'Typ', usageQty: 'Ilosc', usageDate: 'Data',
  usage_hourly: 'Godzinowe', usage_daily: 'Dzienne',
  infoText: 'Zarzadzanie maszynami zapewnia pelen przeglad parku maszynowego.',
  infoItem1: 'Sledzic status maszyny, lokalizacje i przypisania',
  infoItem2: 'Zarzadzac kosztami, konserwacja i dokumentami dla kazdej maszyny',
  infoItem3: 'Przypisywac maszyny do projektow i rejestrowac uzycie',
  startTour: 'Uruchom przewodnik',
  tourListTitle: 'Lista maszyn', tourListText: 'Wszystkie maszyny ze statusem, typem i lokalizacją. Klik otwiera szczegóły.',
  tourDetailTitle: 'Szczegóły maszyny', tourDetailText: 'Wszystkie informacje o wybranej maszynie – dane podstawowe, przypisania, koszty, konserwacje i więcej.',
  tourTabOverviewTitle: 'Przegląd', tourTabOverviewText: 'Dane podstawowe, status, informacje zakupu i szczegóły techniczne.',
  tourTabAssignmentsTitle: 'Przypisania projektu', tourTabAssignmentsText: 'Do jakiego projektu jest przypisana maszyna? Okres i historia.',
  tourTabCostsTitle: 'Koszty', tourTabCostsText: 'Naprawy, koszty eksploatacji i inne wydatki bezpośrednio przy maszynie.',
  tourTabMaintenanceTitle: 'Konserwacje', tourTabMaintenanceText: 'Zaplanowane i zakończone interwały konserwacji z datami i notatkami.',
  tourTabDocumentsTitle: 'Dokumenty', tourTabDocumentsText: 'Instrukcje, protokoły kontrolne i inne dokumenty do przesłania.',
  tourTabUsageTitle: 'Dziennik użycia', tourTabUsageText: 'Godziny pracy i rezerwacje użycia per projekt – można je uwzględnić w fakturach.',
  tourNewTitle: 'Nowa maszyna', tourNewText: 'Tworzy nową maszynę – z typem, producentem, modelem i informacjami zakupu.',
  tourModalTitle: 'Formularz maszyny', tourModalText: 'Wprowadź wszystkie dane podstawowe. Rezerwacje projektu zarządza się w obszarze szczegółów.',
  lockedByOther: 'Aktualnie edytowane przez {name}',
};
const machinesCs = {
  title: 'Stroje', add: 'Pridat stroj', edit: 'Upravit stroj', name: 'Nazev',
  nameRequired: 'Nazev je povinny', newMachine: 'Novy stroj', editMachine: 'Upravit stroj',
  noneFound: 'Zadne stroje nenalezeny', type: 'Typ', serial_number: 'Seriove cislo',
  manufacturer: 'Vyrobce', model: 'Model', year: 'Rok', purchase_price: 'Cena nakupu',
  leasing_rate: 'Mesicni splatka', leasing_start: 'Zacatek leasingu', leasing_end: 'Konec leasingu',
  purchase_type: 'Typ nakupu', purchase_type_buy: 'Koupe', purchase_type_lease: 'Leasing',
  location: 'Umisteni', status: 'Stav', allStatuses: 'Vsechny stavy',
  status_active: 'Aktivni', status_inactive: 'Neaktivni', status_maintenance: 'V servisu', status_defective: 'Vadny',
  tabOverview: 'Prehled', tabAssignments: 'Prirazeni', tabCosts: 'Naklady',
  tabMaintenance: 'Servis', tabDocuments: 'Dokumenty', tabUsage: 'Pouziti',
  addAssignment: 'Pridat prirazeni', noAssignments: 'Zadna prirazeni', assignFrom: 'Od', assignTo: 'Do',
  assignConflict: 'Tento stroj je jiz prirazen k projektu „{project}" ve zvoleném období. Upravte data nebo nejdrive odeberte jine prirazeni.',
  assignStatusBlocked: 'Tento stroj nelze priradit, protoze jeho aktualni stav je „{status}".',
  addCost: 'Pridat naklad', noCosts: 'Zadne naklady', costType: 'Typ', costAmount: 'Castka', costDate: 'Datum', costNote: 'Popis',
  cost_fuel: 'Palivo', cost_repair: 'Oprava', cost_maintenance: 'Servis',
  addMaintenance: 'Pridat servis', noMaintenance: 'Zadne zaznamy servisu',
  maintType: 'Typ', maintDue: 'Termin', maintDone: 'Provedeno', maintNext: 'Pristi termin', maintNotes: 'Poznamky',
  addDocument: 'Pridat dokument', noDocuments: 'Zadne dokumenty', docType: 'Typ', docPath: 'Cesta k souboru',
  doc_invoice: 'Faktura', doc_manual: 'Manual', doc_inspection: 'Prohlídka',
  addUsage: 'Pridat pouziti', noUsage: 'Zadne zaznamy pouziti', usageType: 'Typ', usageQty: 'Mnozstvi', usageDate: 'Datum',
  usage_hourly: 'Hodinove', usage_daily: 'Denni',
  infoText: 'Sprava stroju poskytuje uplny prehled o strojnim parku.',
  infoItem1: 'Sledovat stav stroje, umisteni a prirazeni',
  infoItem2: 'Spravovat naklady, udrzbu a dokumenty pro kazdy stroj',
  infoItem3: 'Prirazovat stroje k projektum a zaznamenavat pouziti',
  startTour: 'Spustit průvodce',
  tourListTitle: 'Seznam strojů', tourListText: 'Všechny stroje se stavem, typem a umístěním. Kliknutím otevřete detail.',
  tourDetailTitle: 'Detail stroje', tourDetailText: 'Všechny informace o vybraném stroji – základní údaje, přiřazení, náklady, údržba a další.',
  tourTabOverviewTitle: 'Přehled', tourTabOverviewText: 'Základní údaje, stav, informace o nákupu a technické detaily.',
  tourTabAssignmentsTitle: 'Přiřazení projektu', tourTabAssignmentsText: 'Ke kterému projektu je stroj přiřazen? Období a historie.',
  tourTabCostsTitle: 'Náklady', tourTabCostsText: 'Opravy, provozní náklady a další výdaje přímo u stroje.',
  tourTabMaintenanceTitle: 'Údržba', tourTabMaintenanceText: 'Nadcházející a dokončené intervaly údržby s daty a poznámkami.',
  tourTabDocumentsTitle: 'Dokumenty', tourTabDocumentsText: 'Příručky, inspekční protokoly a další dokumenty k nahrání.',
  tourTabUsageTitle: 'Protokol využití', tourTabUsageText: 'Provozní hodiny a projektové rezervace využití – lze zahrnout přímo do faktur.',
  tourNewTitle: 'Nový stroj', tourNewText: 'Vytvoří nový stroj – s typem, výrobcem, modelem a informacemi o nákupu.',
  tourModalTitle: 'Formulář stroje', tourModalText: 'Zadejte všechny základní údaje. Projektové rezervace se spravují v oblasti detailu.',
  lockedByOther: 'Prave upravuje {name}',
};

const dashboardDe = {
  title: 'Dashboard',
  infoText: 'Das Dashboard gibt dir einen schnellen Überblick über alle wichtigen Bereiche.',
  infoItem1: 'Projektstatus und aktuelle Auslastung auf einen Blick sehen',
  infoItem2: 'Offene Anfragen und Genehmigungen verwalten',
  infoItem3: 'Arbeitszeiten und aktive Mitarbeiter überwachen',
  infoItem4: 'Anstehende Termine und Projekte der nächsten Tage anzeigen',
  infoItem5: 'Umsätze, offene Angebote und überfällige Rechnungen prüfen',
  infoItem6: 'Lagerbestand und Mindestbestände überwachen',
  infoItem7: 'Schnellzugriffe für Zeiterfassung, Urlaub und Medien nutzen',
  welcome: 'Willkommen',
  recordTime: 'Zeit erfassen',
  sitePlanning: 'Baustellenplanung',
  vacation: 'Urlaub',
  storage: 'Ablage',
  projects: 'Projekte',
  pendingRequests: 'Ausstehende Anfragen',
  timeEntries: 'Zeiteinträge',
  materialBookings: 'Materialbuchungen',
  vacationRequests: 'Urlaubsanträge',
  sickThisMonth: 'Krankmeldungen diesen Monat',
  timeTracking: 'Zeiterfassung',
  record: 'Erfassen',
  activeEmployees: 'Aktive Mitarbeiter',
  totalHours: 'Stunden gesamt',
  absent: 'Abwesend',
  utilizationWeek: 'Auslastung diese Woche',
  noEntries: 'Keine Einträge',
  finance: 'Finanzen',
  all: 'Alle',
  revenueThisMonth: 'Umsatz diesen Monat',
  openOffers: 'Offene Angebote',
  overdueInvoices: 'Überfällige Rechnungen',
  nextSevenDays: 'Nächste 7 Tage',
  noAppointments: 'Keine Termine geplant',
  lowStockExceeded: 'Meldebestand unterschritten',
  warehouse: 'Lager',
  min: 'Min',
  stockHealthy: 'Alle Bestände im grünen Bereich',
  startTour: 'Führung starten',
  tourStatsTitle: 'Projektstatus',
  tourStatsText: 'Hier siehst du auf einen Blick wie viele Projekte gerade in Bearbeitung, Angebot oder beauftragt sind. Klick auf eine Kachel um die gefilterte Projektliste zu öffnen.',
  tourTimeTitle: 'Zeiterfassung heute',
  tourTimeText: 'Aktive Mitarbeiter, gebuchte Stunden und Abwesenheiten für den heutigen Tag – direkt auf dem Dashboard.',
  tourUtilizationTitle: 'Auslastung diese Woche',
  tourUtilizationText: 'Die Wochenstunden deiner Mitarbeiter auf einen Blick. So erkennst du schnell wer ausgelastet ist und wer noch Kapazität hat.',
  tourFinanceTitle: 'Finanzen',
  tourFinanceText: 'Umsatz diesen Monat, offene Angebote und überfällige Rechnungen im Schnellüberblick.',
  tourScheduleTitle: 'Nächste 7 Tage',
  tourScheduleText: 'Anstehende Termine und Projektereignisse der nächsten Woche – damit du immer weißt was als nächstes ansteht.',
  tourPendingTitle: 'Ausstehende Anfragen',
  tourPendingText: 'Hier siehst du Zeiteinträge, Materialbuchungen und Urlaubsanträge die noch auf deine Genehmigung warten.',
  tourWarehouseTitle: 'Lager',
  tourWarehouseText: 'Überblick über den Lagerbestand. Hier erscheinen Warnungen bei Unterschreitung des Mindestbestands und Bestellbedarf aus offenen Angeboten. Alles grün bedeutet: alles in Ordnung.',
  tourWarehouseDemandTitle: 'Bestellbedarf',
  tourWarehouseDemandText: 'Artikel, die in offenen Angeboten benötigt werden, aber nicht ausreichend auf Lager sind. Direkt zum Lager um Bestellungen vorzubereiten.',
  tourQuickTimeTitle: 'Zeit erfassen',
  tourQuickTimeText: 'Zeiterfassung für deine Arbeitsstunden.',
  tourQuickScheduleTitle: 'Baustellenplanung',
  tourQuickScheduleText: 'Deine anstehenden Termine und Projekteinsätze.',
  tourQuickVacationTitle: 'Urlaub',
  tourQuickVacationText: 'Urlaubsanträge stellen und verwalten.',
  tourQuickMediaTitle: 'Ablage',
  tourQuickMediaText: 'Fotos und Dokumente zu Projekten hochladen.',
  demandWarningTitleSingular: 'Bestellbedarf: 1 Material unter Meldebestand',
  demandWarningTitlePlural: 'Bestellbedarf: {count} Materialien unter Meldebestand',
  demandNeeded: 'Bedarf',
  demandMore: 'weitere',
};

const dashboardEn = {
  title: 'Dashboard',
  infoText: 'The dashboard gives you a quick overview of all important areas.',
  infoItem1: 'View project status and current workload at a glance',
  infoItem2: 'Manage pending requests and approvals',
  infoItem3: 'Monitor working hours and active employees',
  infoItem4: 'View upcoming appointments and projects for the next days',
  infoItem5: 'Check revenue, open offers, and overdue invoices',
  infoItem6: 'Monitor stock levels and minimum inventory thresholds',
  infoItem7: 'Use quick access for time tracking, vacation, and media',
  welcome: 'Welcome',
  recordTime: 'Record time',
  sitePlanning: 'Site planning',
  vacation: 'Vacation',
  storage: 'Storage',
  projects: 'Projects',
  pendingRequests: 'Pending requests',
  timeEntries: 'Time entries',
  materialBookings: 'Material bookings',
  vacationRequests: 'Vacation requests',
  sickThisMonth: 'Sick notes this month',
  timeTracking: 'Time tracking',
  record: 'Record',
  activeEmployees: 'Active employees',
  totalHours: 'Total hours',
  absent: 'Absent',
  utilizationWeek: 'Utilization this week',
  noEntries: 'No entries',
  finance: 'Finance',
  all: 'All',
  revenueThisMonth: 'Revenue this month',
  openOffers: 'Open offers',
  overdueInvoices: 'Overdue invoices',
  nextSevenDays: 'Next 7 days',
  noAppointments: 'No appointments planned',
  lowStockExceeded: 'Minimum stock undershot',
  warehouse: 'Warehouse',
  min: 'Min',
  stockHealthy: 'All stock levels are healthy',
  startTour: 'Start tour',
  tourStatsTitle: 'Project Status',
  tourStatsText: 'See at a glance how many projects are in progress, offered, or ordered. Click a tile to open the filtered project list.',
  tourTimeTitle: 'Time Tracking Today',
  tourTimeText: 'Active employees, booked hours, and absences for today – right on the dashboard.',
  tourUtilizationTitle: 'Utilization This Week',
  tourUtilizationText: 'Weekly hours per employee at a glance. Quickly see who is fully booked and who still has capacity.',
  tourFinanceTitle: 'Finance',
  tourFinanceText: 'Revenue this month, open offers, and overdue invoices at a quick glance.',
  tourScheduleTitle: 'Next 7 Days',
  tourScheduleText: 'Upcoming appointments and project events for the next week – so you always know what\'s coming up.',
  tourPendingTitle: 'Pending Requests',
  tourPendingText: 'Here you can see time entries, material bookings, and vacation requests waiting for your approval.',
  tourWarehouseTitle: 'Warehouse',
  tourWarehouseText: 'Overview of stock levels. Warnings appear here for items below minimum stock and order requirements from open quotes. All clear means everything is in order.',
  tourWarehouseDemandTitle: 'Order requirements',
  tourWarehouseDemandText: 'Items needed in open quotes that are not sufficiently in stock. Go to the warehouse to prepare orders.',
  tourQuickTimeTitle: 'Record Time',
  tourQuickTimeText: 'Track your working hours here.',
  tourQuickScheduleTitle: 'Site Planning',
  tourQuickScheduleText: 'Your upcoming appointments and project assignments.',
  tourQuickVacationTitle: 'Vacation',
  tourQuickVacationText: 'Submit and manage your vacation requests.',
  tourQuickMediaTitle: 'Storage',
  tourQuickMediaText: 'Upload photos and documents to your projects.',
  demandWarningTitleSingular: 'Order needed: 1 material below reorder point',
  demandWarningTitlePlural: 'Order needed: {count} materials below reorder point',
  demandNeeded: 'Required',
  demandMore: 'more',
};

const dashboardFr = {
  title: 'Tableau de bord',
  infoText: 'Le tableau de bord vous offre une vue rapide de tous les domaines importants.',
  infoItem1: 'Voir l’état des projets et la charge de travail en un coup d’œil',
  infoItem2: 'Gérer les demandes en attente et les validations',
  infoItem3: 'Suivre les heures de travail et les employés actifs',
  infoItem4: 'Afficher les rendez-vous et projets à venir',
  infoItem5: 'Consulter le chiffre d’affaires, les offres et les factures en retard',
  infoItem6: 'Surveiller les niveaux de stock et les seuils minimaux',
  infoItem7: 'Utiliser les accès rapides pour le temps, les congés et les médias',
  welcome: 'Bienvenue',
  recordTime: 'Saisir le temps',
  sitePlanning: 'Planification chantier',
  vacation: 'Congés',
  storage: 'Stockage',
  projects: 'Projets',
  pendingRequests: 'Demandes en attente',
  timeEntries: 'Saisies de temps',
  materialBookings: 'Mouvements de matériel',
  vacationRequests: 'Demandes de congés',
  sickThisMonth: 'Arrêts maladie ce mois-ci',
  timeTracking: 'Suivi du temps',
  record: 'Saisir',
  activeEmployees: 'Employés actifs',
  totalHours: 'Heures totales',
  absent: 'Absent',
  utilizationWeek: 'Charge cette semaine',
  noEntries: 'Aucune entrée',
  finance: 'Finances',
  all: 'Tous',
  revenueThisMonth: 'Chiffre d\'affaires ce mois-ci',
  openOffers: 'Offres ouvertes',
  overdueInvoices: 'Factures en retard',
  nextSevenDays: '7 prochains jours',
  noAppointments: 'Aucun rendez-vous prévu',
  lowStockExceeded: 'Stock minimum dépassé',
  warehouse: 'Entrepôt',
  min: 'Min',
  stockHealthy: 'Tous les niveaux de stock sont sains',
  startTour: 'Lancer la visite guidée',
  tourStatsTitle: 'Statut des projets',
  tourStatsText: 'Voyez en un coup d\'œil combien de projets sont en cours, en offre ou commandés. Cliquez sur une tuile pour ouvrir la liste filtrée.',
  tourTimeTitle: 'Pointage aujourd\'hui',
  tourTimeText: 'Employés actifs, heures saisies et absences du jour directement sur le tableau de bord.',
  tourUtilizationTitle: 'Charge de travail cette semaine',
  tourUtilizationText: 'Heures hebdomadaires par employé en un coup d\'œil. Identifiez rapidement qui est disponible.',
  tourFinanceTitle: 'Finances',
  tourFinanceText: 'Chiffre d\'affaires du mois, offres ouvertes et factures en retard en un aperçu rapide.',
  tourScheduleTitle: '7 prochains jours',
  tourScheduleText: 'Rendez-vous et événements de projet de la semaine à venir – pour toujours savoir ce qui approche.',
  tourPendingTitle: 'Demandes en attente',
  tourPendingText: 'Ici vous voyez les saisies de temps, réservations de matériaux et demandes de congés en attente de votre approbation.',
  tourWarehouseTitle: 'Entrepôt',
  tourWarehouseText: 'Vue d\'ensemble des niveaux de stock. Des avertissements apparaissent pour les articles sous le seuil minimum et les besoins de commande des devis ouverts. Tout vert signifie que tout est en ordre.',
  tourWarehouseDemandTitle: 'Besoins de commande',
  tourWarehouseDemandText: 'Articles nécessaires dans des devis ouverts mais pas suffisamment en stock. Allez au magasin pour préparer les commandes.',
  tourQuickTimeTitle: 'Saisir le temps',
  tourQuickTimeText: 'Saisissez vos heures de travail ici.',
  tourQuickScheduleTitle: 'Planification chantier',
  tourQuickScheduleText: 'Vos prochains rendez-vous et affectations de projet.',
  tourQuickVacationTitle: 'Congés',
  tourQuickVacationText: 'Déposez et gérez vos demandes de congés.',
  tourQuickMediaTitle: 'Stockage',
  tourQuickMediaText: 'Téléversez photos et documents vers vos projets.',
  demandWarningTitleSingular: 'Commande requise : 1 matériau sous le seuil',
  demandWarningTitlePlural: 'Commande requise : {count} matériaux sous le seuil',
  demandNeeded: 'Requis',
  demandMore: 'de plus',
};

const dashboardIt = {
  title: 'Dashboard',
  infoText: 'La dashboard ti offre una panoramica rapida di tutte le aree importanti.',
  infoItem1: 'Visualizzare lo stato dei progetti e il carico di lavoro',
  infoItem2: 'Gestire richieste in sospeso e approvazioni',
  infoItem3: 'Monitorare ore di lavoro e dipendenti attivi',
  infoItem4: 'Visualizzare appuntamenti e progetti dei prossimi giorni',
  infoItem5: 'Controllare fatturato, offerte e fatture scadute',
  infoItem6: 'Monitorare livelli di magazzino e scorte minime',
  infoItem7: 'Utilizzare accessi rapidi per registrazione ore, ferie e media',
  welcome: 'Benvenuto',
  recordTime: 'Registra tempo',
  sitePlanning: 'Pianificazione cantieri',
  vacation: 'Ferie',
  storage: 'Archivio',
  projects: 'Progetti',
  pendingRequests: 'Richieste in sospeso',
  timeEntries: 'Registrazioni ore',
  materialBookings: 'Movimenti materiali',
  vacationRequests: 'Richieste di ferie',
  sickThisMonth: 'Assenze per malattia questo mese',
  timeTracking: 'Rilevazione presenze',
  record: 'Registra',
  activeEmployees: 'Dipendenti attivi',
  totalHours: 'Ore totali',
  absent: 'Assenti',
  utilizationWeek: 'Utilizzo settimana',
  noEntries: 'Nessuna voce',
  finance: 'Finanze',
  all: 'Tutti',
  revenueThisMonth: 'Fatturato del mese',
  openOffers: 'Offerte aperte',
  overdueInvoices: 'Fatture scadute',
  nextSevenDays: 'Prossimi 7 giorni',
  noAppointments: 'Nessun appuntamento pianificato',
  lowStockExceeded: 'Scorta minima raggiunta',
  warehouse: 'Magazzino',
  min: 'Min',
  stockHealthy: 'Tutti i livelli di stock sono in ordine',
  startTour: 'Avvia la guida',
  tourStatsTitle: 'Stato dei progetti',
  tourStatsText: 'Vedi a colpo d\'occhio quanti progetti sono in corso, in offerta o ordinati. Clicca su un riquadro per aprire la lista filtrata.',
  tourTimeTitle: 'Rilevazione presenze oggi',
  tourTimeText: 'Dipendenti attivi, ore registrate e assenze di oggi direttamente nella dashboard.',
  tourUtilizationTitle: 'Carico questa settimana',
  tourUtilizationText: 'Ore settimanali per dipendente in sintesi. Identifica subito chi è disponibile.',
  tourFinanceTitle: 'Finanze',
  tourFinanceText: 'Fatturato del mese, offerte aperte e fatture scadute in una rapida panoramica.',
  tourScheduleTitle: 'Prossimi 7 giorni',
  tourScheduleText: 'Appuntamenti ed eventi di progetto della prossima settimana – per sapere sempre cosa c\'è in programma.',
  tourPendingTitle: 'Richieste in attesa',
  tourPendingText: 'Qui vedi le timbrature, prenotazioni materiali e richieste ferie in attesa della tua approvazione.',
  tourWarehouseTitle: 'Magazzino',
  tourWarehouseText: 'Panoramica delle scorte. Avvisi per articoli sotto scorta minima e fabbisogni da preventivi aperti. Tutto verde significa che tutto è in ordine.',
  tourWarehouseDemandTitle: 'Fabbisogno ordini',
  tourWarehouseDemandText: 'Articoli richiesti in preventivi aperti ma non sufficientemente disponibili. Vai al magazzino per preparare gli ordini.',
  tourQuickTimeTitle: 'Registra ore',
  tourQuickTimeText: 'Registra qui le tue ore di lavoro.',
  tourQuickScheduleTitle: 'Pianificazione cantiere',
  tourQuickScheduleText: 'I tuoi prossimi appuntamenti e incarichi di progetto.',
  tourQuickVacationTitle: 'Ferie',
  tourQuickVacationText: 'Richiedi e gestisci le tue ferie.',
  tourQuickMediaTitle: 'Archivio',
  tourQuickMediaText: 'Carica foto e documenti nei tuoi progetti.',
  demandWarningTitleSingular: 'Ordine necessario: 1 materiale sotto la soglia',
  demandWarningTitlePlural: 'Ordine necessario: {count} materiali sotto la soglia',
  demandNeeded: 'Richiesto',
  demandMore: 'altri',
};

const dashboardPl = {
  title: 'Panel',
  infoText: 'Panel główny zapewnia szybki przegląd wszystkich ważnych obszarów.',
  infoItem1: 'Podgląd statusów projektów i obciążenia pracy',
  infoItem2: 'Zarządzanie oczekującymi zgłoszeniami i zatwierdzeniami',
  infoItem3: 'Monitorowanie godzin pracy i aktywnych pracowników',
  infoItem4: 'Przegląd nadchodzących terminów i projektów',
  infoItem5: 'Sprawdzanie przychodów, ofert i zaległych faktur',
  infoItem6: 'Monitorowanie stanów magazynowych i minimalnych poziomów',
  infoItem7: 'Szybki dostęp do czasu pracy, urlopów i mediów',
  welcome: 'Witamy',
  recordTime: 'Rejestruj czas',
  sitePlanning: 'Planowanie budowy',
  vacation: 'Urlop',
  storage: 'Archiwum',
  projects: 'Projekty',
  pendingRequests: 'Oczekujące wnioski',
  timeEntries: 'Wpisy czasu',
  materialBookings: 'Ruchy materiałowe',
  vacationRequests: 'Wnioski urlopowe',
  sickThisMonth: 'Zwolnienia chorobowe w tym miesiącu',
  timeTracking: 'Ewidencja czasu',
  record: 'Rejestruj',
  activeEmployees: 'Aktywni pracownicy',
  totalHours: 'Łączna liczba godzin',
  absent: 'Nieobecny',
  utilizationWeek: 'Wykorzystanie w tym tygodniu',
  noEntries: 'Brak wpisów',
  finance: 'Finanse',
  all: 'Wszystko',
  revenueThisMonth: 'Przychód w tym miesiącu',
  openOffers: 'Otwarte oferty',
  overdueInvoices: 'Przeterminowane faktury',
  nextSevenDays: 'Następne 7 dni',
  noAppointments: 'Brak zaplanowanych terminów',
  lowStockExceeded: 'Przekroczono minimum magazynowe',
  warehouse: 'Magazyn',
  min: 'Min',
  stockHealthy: 'Wszystkie stany magazynowe są prawidłowe',
  startTour: 'Uruchom przewodnik',
  tourStatsTitle: 'Status projektów',
  tourStatsText: 'Zobacz na pierwszy rzut oka ile projektów jest w toku, w ofercie lub zleconych. Kliknij kafelek aby otworzyć przefiltrowaną listę.',
  tourTimeTitle: 'Rejestracja czasu dziś',
  tourTimeText: 'Aktywni pracownicy, zarejestrowane godziny i nieobecności na dziś bezpośrednio na panelu.',
  tourUtilizationTitle: 'Obciążenie w tym tygodniu',
  tourUtilizationText: 'Godziny tygodniowe na pracownika w skrócie. Szybko sprawdź kto jest dostępny.',
  tourFinanceTitle: 'Finanse',
  tourFinanceText: 'Przychody w tym miesiącu, otwarte oferty i przeterminowane faktury w szybkim przeglądzie.',
  tourScheduleTitle: 'Następne 7 dni',
  tourScheduleText: 'Nadchodzące spotkania i zdarzenia projektowe następnego tygodnia – żebyś zawsze wiedział co czeka.',
  tourPendingTitle: 'Oczekujące wnioski',
  tourPendingText: 'Tu widzisz wpisy czasu, rezerwacje materiałów i wnioski urlopowe oczekujące na Twoją akceptację.',
  tourWarehouseTitle: 'Magazyn',
  tourWarehouseText: 'Przeglad stanow magazynowych. Ostrzezenia dla artykulow ponizej minimum i zapotrzebowania z otwartych ofert. Wszystko zielone oznacza, ze wszystko jest w porzadku.',
  tourWarehouseDemandTitle: 'Zapotrzebowanie na zamówienia',
  tourWarehouseDemandText: 'Artykuly potrzebne w otwartych ofertach ale nie dostepne w wystarczajacej ilosci. Przejdz do magazynu aby przygotowac zamowienia.',
  tourQuickTimeTitle: 'Rejestracja czasu',
  tourQuickTimeText: 'Rejestracja Twoich godzin pracy.',
  tourQuickScheduleTitle: 'Planowanie budowy',
  tourQuickScheduleText: 'Twoje nadchodzące terminy i zlecenia projektowe.',
  tourQuickVacationTitle: 'Urlop',
  tourQuickVacationText: 'Składaj i zarządzaj wnioskami urlopowymi.',
  tourQuickMediaTitle: 'Pliki',
  tourQuickMediaText: 'Przesyłaj zdjęcia i dokumenty do projektów.',
  demandWarningTitleSingular: 'Zamówienie wymagane: 1 materiał poniżej progu',
  demandWarningTitlePlural: 'Zamówienie wymagane: {count} materiałów poniżej progu',
  demandNeeded: 'Wymagane',
  demandMore: 'więcej',
};

const dashboardCs = {
  title: 'Nástěnka',
  infoText: 'Přehled poskytuje rychlý pohled na všechny důležité oblasti.',
  infoItem1: 'Zobrazení stavu projektů a vytížení',
  infoItem2: 'Správa čekajících požadavků a schválení',
  infoItem3: 'Sledování odpracovaných hodin a aktivních zaměstnanců',
  infoItem4: 'Zobrazení nadcházejících schůzek a projektů',
  infoItem5: 'Kontrola tržeb, nabídek a po splatnosti faktur',
  infoItem6: 'Sledování skladových zásob a minimálních limitů',
  infoItem7: 'Rychlý přístup k evidenci času, dovolené a médiím',
  welcome: 'Vítejte',
  recordTime: 'Zaznamenat čas',
  sitePlanning: 'Plánování stavby',
  vacation: 'Dovolená',
  storage: 'Úložiště',
  projects: 'Projekty',
  pendingRequests: 'Čekající požadavky',
  timeEntries: 'Časové záznamy',
  materialBookings: 'Pohyby materiálu',
  vacationRequests: 'Žádosti o dovolenou',
  sickThisMonth: 'Nemocenská tento měsíc',
  timeTracking: 'Evidence času',
  record: 'Zaznamenat',
  activeEmployees: 'Aktivní zaměstnanci',
  totalHours: 'Celkové hodiny',
  absent: 'Nepřítomen',
  utilizationWeek: 'Vytížení tento týden',
  noEntries: 'Žádné záznamy',
  finance: 'Finance',
  all: 'Vše',
  revenueThisMonth: 'Obrat tento měsíc',
  openOffers: 'Otevřené nabídky',
  overdueInvoices: 'Faktury po splatnosti',
  nextSevenDays: 'Příštích 7 dní',
  noAppointments: 'Žádné plánované schůzky',
  lowStockExceeded: 'Minimální zásoba překročena',
  warehouse: 'Sklad',
  min: 'Min',
  stockHealthy: 'Všechny skladové zásoby jsou v pořádku',
  startTour: 'Spustit průvodce',
  tourStatsTitle: 'Stav projektů',
  tourStatsText: 'Na první pohled vidíte kolik projektů je v realizaci, v nabídce nebo objednáno. Kliknutím na dlaždici otevřete filtrovaný seznam.',
  tourTimeTitle: 'Evidence času dnes',
  tourTimeText: 'Aktivní zaměstnanci, evidované hodiny a absence dnešního dne přímo na přehledu.',
  tourUtilizationTitle: 'Vytíženost tento týden',
  tourUtilizationText: 'Týdenní hodiny na zaměstnance v přehledu. Rychle zjistíte kdo má volnou kapacitu.',
  tourFinanceTitle: 'Finance',
  tourFinanceText: 'Tržby tohoto měsíce, otevřené nabídky a zpožděné faktury v rychlém přehledu.',
  tourScheduleTitle: 'Příštích 7 dní',
  tourScheduleText: 'Nadcházející termíny a projektové události příštího týdne – abyste vždy věděli co vás čeká.',
  tourPendingTitle: 'Čekající žádosti',
  tourPendingText: 'Zde vidíte záznamy o čase, rezervace materiálu a žádosti o dovolenou čekající na vaše schválení.',
  tourWarehouseTitle: 'Sklad',
  tourWarehouseText: 'Prehled stavu zasob. Upozorneni pro polozky pod minimalni zasobou a pozadavky z otevrenych nabidek. Vse zelene znamena ze je vse v poradku.',
  tourWarehouseDemandTitle: 'Potřeba objednávek',
  tourWarehouseDemandText: 'Polozky pozadovane v otevrenych nabidkach ale nedostatecne skladem. Prejdete do skladu a pripravte objednavky.',
  tourQuickTimeTitle: 'Evidence času',
  tourQuickTimeText: 'Evidence vašich pracovních hodin.',
  tourQuickScheduleTitle: 'Plánování staveniště',
  tourQuickScheduleText: 'Vaše nadcházející termíny a projektové úkoly.',
  tourQuickVacationTitle: 'Dovolená',
  tourQuickVacationText: 'Podávejte a spravujte žádosti o dovolenou.',
  tourQuickMediaTitle: 'Úložiště',
  tourQuickMediaText: 'Nahrajte fotografie a dokumenty ke svým projektům.',
  demandWarningTitleSingular: 'Objednávka potřebná: 1 materiál pod hranicí',
  demandWarningTitlePlural: 'Objednávka potřebná: {count} materiálů pod hranicí',
  demandNeeded: 'Požadováno',
  demandMore: 'dalších',
};

const customersDe = {
  title: 'Kunden',
  detailsTitle: 'Kundendetails',
  infoText: 'Hier verwaltest du alle deine Kunden und Kontakte.',
  infoItem1: 'Kunden anlegen, bearbeiten und löschen',
  infoItem2: 'Firmenkunden und Privatkunden getrennt erfassen',
  detailsInfoText: 'Diese Seite zeigt alle Informationen zu einem Kunden auf einen Blick.',
  detailsInfoItem1: 'Stammdaten wie Adresse, E-Mail und Zahlungsziel einsehen und bearbeiten',
  detailsInfoItem2: 'Ansprechpartner verwalten – mehrere Kontakte pro Kunde möglich',
  detailsInfoItem3: 'Alle zugehörigen Projekte direkt im Überblick sehen',
  back: 'Zurück',
  newCustomer: 'Neuer Kunde',
  searchPlaceholder: 'Suche nach Firma, Kontakt, Stadt...',
  noneFound: 'Keine Kunden gefunden',
  addFirst: 'Füge deinen ersten Kunden hinzu',
  startTour: 'Führung starten',
  tourNewTitle: 'Neuer Kunde',
  tourNewText: 'Legt einen neuen Kunden an – Firmenkunde oder Privatkunde.',
  tourModalTitle: 'Kundenformular',
  tourModalText: 'Hier trägst du Namen, Kontaktdaten und Adresse ein. Pflichtfelder sind mit * markiert.',
  tourSearchTitle: 'Suche & Filter',
  tourSearchText: 'Filtere deine Kunden nach Name, E-Mail oder Ort. Die Spalten sind auch sortierbar.',
  tourListTitle: 'Kundenliste',
  tourListText: 'Alle deine Kunden auf einen Blick. Klick auf das Lupen-Icon um die Detailseite zu öffnen.',
  tourRowTitle: 'Kundenzeile',
  tourRowText: 'Über die Icons kannst du Details öffnen, bearbeiten oder den Kunden löschen.',
  tourDetailEditTitle: 'Kunde bearbeiten',
  tourDetailEditText: 'Öffnet das Bearbeitungsformular – hier kannst du alle Stammdaten des Kunden ändern.',
  tourDetailModalTitle: 'Bearbeitungsformular',
  tourDetailModalText: 'Ändere Name, Kontaktdaten, Adresse, Zahlungsziel und Status. Speichere mit dem Button unten rechts.',
  tourDetailMasterdataTitle: 'Stammdaten',
  tourDetailMasterdataText: 'Hier siehst du alle hinterlegten Kontaktdaten und die Adresse des Kunden.',
  tourDetailContactsTitle: 'Ansprechpartner',
  tourDetailContactsText: 'Hinterlege mehrere Kontakte für diesen Kunden – z.B. verschiedene Abteilungen oder Zuständige.',
  tourDetailProjectsTitle: 'Projekte',
  tourDetailProjectsText: 'Alle Projekte, die diesem Kunden zugeordnet sind – klickbar für die Detailansicht.',
  company: 'Firma',
  contact: 'Kontakt',
  email: 'E-Mail',
  city: 'Ort',
  vatId: 'USt-IdNr.',
  status: 'Status',
  active: 'Aktiv',
  inactive: 'Inaktiv',
  details: 'Details',
  edit: 'Bearbeiten',
  delete: 'Löschen',
  editCustomer: 'Kunde bearbeiten',
  customerType: 'Kundentyp',
  companyType: 'Firma',
  privateType: 'Privatperson',
  companyName: 'Firmenname',
  name: 'Name',
  contactPerson: 'Ansprechpartner',
  phone: 'Telefon',
  street: 'Straße',
  zip: 'PLZ',
  notes: 'Notizen',
  cancel: 'Abbrechen',
  save: 'Speichern',
  create: 'Erstellen',
  enterName: 'Bitte einen Namen eingeben',
  saveError: 'Fehler beim Speichern',
  deleteConfirm: 'Kunde wirklich löschen',
  deleteError: 'Fehler beim Löschen',
  privateCustomer: 'Privatkunde',
  companyCustomer: 'Firmenkunde',
  masterData: 'Stammdaten',
  website: 'Website',
  address: 'Adresse',
  paymentTerms: 'Zahlungsziel',
  days: 'Tage',
  contacts: 'Ansprechpartner',
  add: 'Hinzufügen',
  noContacts: 'Noch keine Kontakte',
  primary: 'Haupt',
  projects: 'Projekte',
  noProjects: 'Keine Projekte',
  editContact: 'Kontakt bearbeiten',
  newContact: 'Neuer Kontakt',
  position: 'Position',
  primaryContact: 'Hauptkontakt',
  deleteContactConfirm: 'Kontakt löschen?',
  lockedByOther: 'Wird gerade bearbeitet von {name}',
  editLockedTooltip: 'Wird gerade von {name} bearbeitet'
};

const customersEn = {
  title: 'Customers',
  detailsTitle: 'Customer Details',
  infoText: 'Here you can manage all your customers and contacts.',
  infoItem1: 'Create, edit, and delete customers',
  infoItem2: 'Separately register company and private customers',
  detailsInfoText: 'This page shows all information about a customer at a glance.',
  detailsInfoItem1: 'View and edit master data such as address, email, and payment terms',
  detailsInfoItem2: 'Ansprechpartner verwalten – mehrere Kontakte pro Kunde möglich',
  detailsInfoItem3: 'Alle zugehörigen Projekte direkt im Überblick sehen',
  back: 'Back',
  newCustomer: 'New customer',
  searchPlaceholder: 'Search by company, contact, city...',
  noneFound: 'No customers found',
  addFirst: 'Add your first customer',
  startTour: 'Start tour',
  tourNewTitle: 'New customer',
  tourNewText: 'Creates a new customer – company or private.',
  tourModalTitle: 'Customer form',
  tourModalText: 'Enter name, contact details, and address here. Required fields are marked with *.',
  tourSearchTitle: 'Search & filter',
  tourSearchText: 'Filter your customers by name, email, or city. Columns are also sortable.',
  tourListTitle: 'Customer list',
  tourListText: 'All your customers at a glance. Click the magnifier icon to open the detail page.',
  tourRowTitle: 'Customer row',
  tourRowText: 'Use the icons to open details, edit, or delete the customer.',
  tourDetailEditTitle: 'Edit customer',
  tourDetailEditText: 'Opens the edit form – here you can change all master data for the customer.',
  tourDetailModalTitle: 'Edit form',
  tourDetailModalText: 'Change name, contact details, address, payment terms, and status. Save with the button in the lower right.',
  tourDetailMasterdataTitle: 'Master data',
  tourDetailMasterdataText: 'Here you see all stored contact details and the customer\'s address.',
  tourDetailContactsTitle: 'Contacts',
  tourDetailContactsText: 'Add multiple contacts for this customer – e.g. different departments or responsible persons.',
  tourDetailProjectsTitle: 'Projects',
  tourDetailProjectsText: 'All projects assigned to this customer – clickable to open the detail view.',
  company: 'Company',
  contact: 'Contact',
  email: 'Email',
  city: 'City',
  vatId: 'VAT ID',
  status: 'Status',
  active: 'Active',
  inactive: 'Inactive',
  details: 'Details',
  edit: 'Edit',
  delete: 'Delete',
  editCustomer: 'Edit customer',
  customerType: 'Customer type',
  companyType: 'Company',
  privateType: 'Private person',
  companyName: 'Company name',
  name: 'Name',
  contactPerson: 'Contact person',
  phone: 'Phone',
  street: 'Street',
  zip: 'ZIP',
  notes: 'Notes',
  cancel: 'Cancel',
  save: 'Save',
  create: 'Create',
  enterName: 'Please enter a name',
  saveError: 'Error while saving',
  deleteConfirm: 'Really delete customer',
  deleteError: 'Error while deleting',
  privateCustomer: 'Private customer',
  companyCustomer: 'Company customer',
  masterData: 'Master data',
  website: 'Website',
  address: 'Address',
  paymentTerms: 'Payment terms',
  days: 'days',
  contacts: 'Contacts',
  add: 'Add',
  noContacts: 'No contacts yet',
  primary: 'Primary',
  projects: 'Projects',
  noProjects: 'No projects',
  editContact: 'Edit contact',
  newContact: 'New contact',
  position: 'Position',
  primaryContact: 'Primary contact',
  deleteContactConfirm: 'Delete contact?',
  lockedByOther: 'Currently being edited by {name}',
  editLockedTooltip: 'Currently being edited by {name}'
};

const customersFr = {
  title: 'Clients',
  detailsTitle: 'Détails du client',
  infoText: 'Ici, vous gérez tous vos clients et contacts.',
  infoItem1: 'Créer, modifier et supprimer des clients',
  infoItem2: 'Gérer séparément les clients professionnels et particuliers',
  detailsInfoText: 'Cette page affiche toutes les informations d’un client en un coup d’œil.',
  detailsInfoItem1: 'Consulter et modifier les données de base telles que l’adresse, l’e-mail et le délai de paiement',
  detailsInfoItem2: 'Gérer les interlocuteurs – plusieurs contacts par client possibles',
  detailsInfoItem3: 'Voir directement tous les projets associés en un coup d’œil',
  back: 'Retour',
  newCustomer: 'Nouveau client',
  searchPlaceholder: 'Rechercher par societe, contact, ville...',
  noneFound: 'Aucun client trouve',
  addFirst: 'Ajoutez votre premier client',
  startTour: 'Lancer la visite guidée',
  tourNewTitle: 'Nouveau client',
  tourNewText: 'Crée un nouveau client – entreprise ou particulier.',
  tourModalTitle: 'Formulaire client',
  tourModalText: 'Saisissez le nom, les coordonnées et l\'adresse. Les champs obligatoires sont marqués d\'un *.',
  tourSearchTitle: 'Recherche & filtre',
  tourSearchText: 'Filtrez vos clients par nom, e-mail ou ville. Les colonnes sont aussi triables.',
  tourListTitle: 'Liste des clients',
  tourListText: 'Tous vos clients en un coup d\'œil. Cliquez sur la loupe pour ouvrir la page de détail.',
  tourRowTitle: 'Ligne client',
  tourRowText: 'Utilisez les icônes pour ouvrir les détails, modifier ou supprimer le client.',
  tourDetailEditTitle: 'Modifier le client',
  tourDetailEditText: 'Ouvre le formulaire de modification – modifiez toutes les données principales du client.',
  tourDetailModalTitle: 'Formulaire de modification',
  tourDetailModalText: 'Modifiez le nom, les coordonnées, l\'adresse, le délai de paiement et le statut.',
  tourDetailMasterdataTitle: 'Données principales',
  tourDetailMasterdataText: 'Toutes les coordonnées et l\'adresse enregistrées pour ce client.',
  tourDetailContactsTitle: 'Interlocuteurs',
  tourDetailContactsText: 'Ajoutez plusieurs contacts pour ce client – par ex. différents départements.',
  tourDetailProjectsTitle: 'Projets',
  tourDetailProjectsText: 'Tous les projets liés à ce client – cliquez pour ouvrir la vue de détail.',
  company: 'Societe',
  contact: 'Contact',
  email: 'E-mail',
  city: 'Ville',
  vatId: 'No TVA',
  status: 'Statut',
  active: 'Actif',
  inactive: 'Inactif',
  details: 'Details',
  edit: 'Modifier',
  delete: 'Supprimer',
  editCustomer: 'Modifier client',
  customerType: 'Type de client',
  companyType: 'Societe',
  privateType: 'Particulier',
  companyName: 'Nom de la societe',
  name: 'Nom',
  contactPerson: 'Personne de contact',
  phone: 'Telephone',
  street: 'Rue',
  zip: 'Code postal',
  notes: 'Notes',
  cancel: 'Annuler',
  save: 'Enregistrer',
  create: 'Creer',
  enterName: 'Veuillez saisir un nom',
  saveError: "Erreur lors de l'enregistrement",
  deleteConfirm: 'Supprimer vraiment le client',
  deleteError: 'Erreur lors de la suppression',
  privateCustomer: 'Client prive',
  companyCustomer: 'Client entreprise',
  masterData: 'Donnees de base',
  website: 'Site web',
  address: 'Adresse',
  paymentTerms: 'Delai de paiement',
  days: 'jours',
  contacts: 'Contacts',
  add: 'Ajouter',
  noContacts: 'Aucun contact pour le moment',
  primary: 'Principal',
  projects: 'Projets',
  noProjects: 'Aucun projet',
  editContact: 'Modifier contact',
  newContact: 'Nouveau contact',
  position: 'Fonction',
  primaryContact: 'Contact principal',
  deleteContactConfirm: 'Supprimer le contact ?',
  lockedByOther: 'Actuellement modifie par {name}',
  editLockedTooltip: 'Actuellement modifie par {name}'
};

const customersIt = {
  title: 'Clienti',
  detailsTitle: 'Dettagli cliente',
  infoText: 'Qui puoi gestire tutti i tuoi clienti e contatti.',
  infoItem1: 'Creare, modificare ed eliminare clienti',
  infoItem2: 'Gestire separatamente clienti aziendali e privati',
  detailsInfoText: 'Questa pagina mostra tutte le informazioni di un cliente a colpo d’occhio.',
  detailsInfoItem1: 'Visualizzare e modificare i dati principali come indirizzo, e-mail e termini di pagamento',
  detailsInfoItem2: 'Gestire i referenti – sono possibili più contatti per cliente',
  detailsInfoItem3: 'Visualizzare direttamente tutti i progetti associati',
  back: 'Indietro',
  newCustomer: 'Nuovo cliente',
  searchPlaceholder: 'Cerca per azienda, contatto, citta...',
  noneFound: 'Nessun cliente trovato',
  addFirst: 'Aggiungi il tuo primo cliente',
  startTour: 'Avvia la guida',
  tourNewTitle: 'Nuovo cliente',
  tourNewText: 'Crea un nuovo cliente – azienda o privato.',
  tourModalTitle: 'Modulo cliente',
  tourModalText: 'Inserisci nome, contatti e indirizzo. I campi obbligatori sono contrassegnati con *.',
  tourSearchTitle: 'Ricerca & filtro',
  tourSearchText: 'Filtra i clienti per nome, e-mail o città. Le colonne sono anche ordinabili.',
  tourListTitle: 'Lista clienti',
  tourListText: 'Tutti i tuoi clienti in sintesi. Clicca sulla lente per aprire la pagina di dettaglio.',
  tourRowTitle: 'Riga cliente',
  tourRowText: 'Usa le icone per aprire i dettagli, modificare o eliminare il cliente.',
  tourDetailEditTitle: 'Modifica cliente',
  tourDetailEditText: 'Apre il modulo di modifica – modifica tutti i dati principali del cliente.',
  tourDetailModalTitle: 'Modulo di modifica',
  tourDetailModalText: 'Modifica nome, contatti, indirizzo, termini di pagamento e stato.',
  tourDetailMasterdataTitle: 'Dati principali',
  tourDetailMasterdataText: 'Tutti i recapiti e l\'indirizzo memorizzati per questo cliente.',
  tourDetailContactsTitle: 'Referenti',
  tourDetailContactsText: 'Aggiungi più contatti per questo cliente – es. reparti diversi.',
  tourDetailProjectsTitle: 'Progetti',
  tourDetailProjectsText: 'Tutti i progetti assegnati a questo cliente – cliccabili per aprire il dettaglio.',
  company: 'Azienda',
  contact: 'Contatto',
  email: 'Email',
  city: 'Citta',
  vatId: 'Partita IVA',
  status: 'Stato',
  active: 'Attivo',
  inactive: 'Inattivo',
  details: 'Dettagli',
  edit: 'Modifica',
  delete: 'Elimina',
  editCustomer: 'Modifica cliente',
  customerType: 'Tipo cliente',
  companyType: 'Azienda',
  privateType: 'Privato',
  companyName: 'Nome azienda',
  name: 'Nome',
  contactPerson: 'Referente',
  phone: 'Telefono',
  street: 'Via',
  zip: 'CAP',
  notes: 'Note',
  cancel: 'Annulla',
  save: 'Salva',
  create: 'Crea',
  enterName: 'Inserisci un nome',
  saveError: 'Errore durante il salvataggio',
  deleteConfirm: 'Eliminare davvero il cliente',
  deleteError: "Errore durante l'eliminazione",
  privateCustomer: 'Cliente privato',
  companyCustomer: 'Cliente azienda',
  masterData: 'Dati anagrafici',
  website: 'Sito web',
  address: 'Indirizzo',
  paymentTerms: 'Termini di pagamento',
  days: 'giorni',
  contacts: 'Contatti',
  add: 'Aggiungi',
  noContacts: 'Nessun contatto ancora',
  primary: 'Principale',
  projects: 'Progetti',
  noProjects: 'Nessun progetto',
  editContact: 'Modifica contatto',
  newContact: 'Nuovo contatto',
  position: 'Posizione',
  primaryContact: 'Contatto principale',
  deleteContactConfirm: 'Eliminare il contatto?',
  lockedByOther: 'Attualmente in modifica da {name}',
  editLockedTooltip: 'Attualmente in modifica da {name}'
};

const customersPl = {
  title: 'Klienci',
  detailsTitle: 'Szczegóły klienta',
  infoText: 'Tutaj zarządzasz wszystkimi swoimi klientami i kontaktami.',
  infoItem1: 'Tworzenie, edytowanie i usuwanie klientów',
  infoItem2: 'Oddzielne zarządzanie klientami firmowymi i prywatnymi',
  detailsInfoText: 'Ta strona pokazuje wszystkie informacje o kliencie w jednym miejscu.',
  detailsInfoItem1: 'Przeglądanie i edytowanie danych podstawowych, takich jak adres, e-mail i termin płatności',
  detailsInfoItem2: 'Zarządzanie osobami kontaktowymi – możliwe jest dodanie wielu kontaktów do jednego klienta',
  detailsInfoItem3: 'Bezpośredni podgląd wszystkich powiązanych projektów',
  back: 'Powrot',
  newCustomer: 'Nowy klient',
  searchPlaceholder: 'Szukaj po firmie, kontakcie, miescie...',
  noneFound: 'Nie znaleziono klientow',
  addFirst: 'Dodaj pierwszego klienta',
  startTour: 'Uruchom przewodnik',
  tourNewTitle: 'Nowy klient',
  tourNewText: 'Tworzy nowego klienta – firmę lub osobę prywatną.',
  tourModalTitle: 'Formularz klienta',
  tourModalText: 'Wprowadź nazwę, dane kontaktowe i adres. Pola wymagane są oznaczone *.',
  tourSearchTitle: 'Wyszukiwanie i filtr',
  tourSearchText: 'Filtruj klientów według nazwy, e-maila lub miasta. Kolumny są też sortowalne.',
  tourListTitle: 'Lista klientów',
  tourListText: 'Wszyscy klienci na pierwszy rzut oka. Kliknij lupę aby otworzyć stronę szczegółów.',
  tourRowTitle: 'Wiersz klienta',
  tourRowText: 'Użyj ikon aby otworzyć szczegóły, edytować lub usunąć klienta.',
  tourDetailEditTitle: 'Edytuj klienta',
  tourDetailEditText: 'Otwiera formularz edycji – zmień wszystkie dane podstawowe klienta.',
  tourDetailModalTitle: 'Formularz edycji',
  tourDetailModalText: 'Zmień nazwę, dane kontaktowe, adres, termin płatności i status.',
  tourDetailMasterdataTitle: 'Dane podstawowe',
  tourDetailMasterdataText: 'Wszystkie zapisane dane kontaktowe i adres tego klienta.',
  tourDetailContactsTitle: 'Osoby kontaktowe',
  tourDetailContactsText: 'Dodaj wiele kontaktów dla tego klienta – np. różne działy.',
  tourDetailProjectsTitle: 'Projekty',
  tourDetailProjectsText: 'Wszystkie projekty przypisane do tego klienta – klikalne aby otworzyć szczegóły.',
  company: 'Firma',
  contact: 'Kontakt',
  email: 'E-mail',
  city: 'Miasto',
  vatId: 'NIP',
  status: 'Status',
  active: 'Aktywny',
  inactive: 'Nieaktywny',
  details: 'Szczegoly',
  edit: 'Edytuj',
  delete: 'Usun',
  editCustomer: 'Edytuj klienta',
  customerType: 'Typ klienta',
  companyType: 'Firma',
  privateType: 'Osoba prywatna',
  companyName: 'Nazwa firmy',
  name: 'Nazwa',
  contactPerson: 'Osoba kontaktowa',
  phone: 'Telefon',
  street: 'Ulica',
  zip: 'Kod pocztowy',
  notes: 'Notatki',
  cancel: 'Anuluj',
  save: 'Zapisz',
  create: 'Utworz',
  enterName: 'Wpisz nazwe',
  saveError: 'Blad podczas zapisywania',
  deleteConfirm: 'Na pewno usunac klienta',
  deleteError: 'Blad podczas usuwania',
  privateCustomer: 'Klient prywatny',
  companyCustomer: 'Klient firmowy',
  masterData: 'Dane podstawowe',
  website: 'Strona internetowa',
  address: 'Adres',
  paymentTerms: 'Termin platnosci',
  days: 'dni',
  contacts: 'Kontakty',
  add: 'Dodaj',
  noContacts: 'Brak kontaktow',
  primary: 'Glowny',
  projects: 'Projekty',
  noProjects: 'Brak projektow',
  editContact: 'Edytuj kontakt',
  newContact: 'Nowy kontakt',
  position: 'Stanowisko',
  primaryContact: 'Kontakt glowny',
  deleteContactConfirm: 'Usunac kontakt?',
  lockedByOther: 'Aktualnie edytowane przez {name}',
  editLockedTooltip: 'Aktualnie edytowane przez {name}'
};

const customersCs = {
  title: 'Zakaznici',
  detailsTitle: 'Detaily zákazníka',
  infoText: 'Zde spravujete všechny své zákazníky a kontakty.',
  infoItem1: 'Vytváření, úprava a mazání zákazníků',
  infoItem2: 'Oddělená správa firemních a soukromých zákazníků',
  detailsInfoText: 'Tato stránka zobrazuje všechny informace o zákazníkovi na jednom místě.',
  detailsInfoItem1: 'Zobrazení a úprava základních údajů, jako je adresa, e-mail a splatnost',
  detailsInfoItem2: 'Správa kontaktních osob – pro jednoho zákazníka je možné mít více kontaktů',
  detailsInfoItem3: 'Přímý přehled všech souvisejících projektů',
  back: 'Zpet',
  newCustomer: 'Novy zakaznik',
  searchPlaceholder: 'Hledat podle firmy, kontaktu, mesta...',
  noneFound: 'Nebyli nalezeni zadni zakaznici',
  addFirst: 'Pridajte prvniho zakaznika',
  startTour: 'Spustit průvodce',
  tourNewTitle: 'Nový zákazník',
  tourNewText: 'Vytvoří nového zákazníka – firmu nebo soukromou osobu.',
  tourModalTitle: 'Formulář zákazníka',
  tourModalText: 'Zadejte název, kontaktní údaje a adresu. Povinná pole jsou označena *.',
  tourSearchTitle: 'Vyhledávání a filtr',
  tourSearchText: 'Filtrujte zákazníky podle jména, e-mailu nebo města. Sloupce jsou také řaditelné.',
  tourListTitle: 'Seznam zákazníků',
  tourListText: 'Všichni zákazníci na první pohled. Kliknutím na lupu otevřete stránku podrobností.',
  tourRowTitle: 'Řádek zákazníka',
  tourRowText: 'Pomocí ikon otevřete podrobnosti, upravte nebo smažte zákazníka.',
  tourDetailEditTitle: 'Upravit zákazníka',
  tourDetailEditText: 'Otevře editační formulář – změňte všechna hlavní data zákazníka.',
  tourDetailModalTitle: 'Editační formulář',
  tourDetailModalText: 'Změňte jméno, kontaktní údaje, adresu, splatnost a stav.',
  tourDetailMasterdataTitle: 'Základní údaje',
  tourDetailMasterdataText: 'Všechny uložené kontaktní údaje a adresa tohoto zákazníka.',
  tourDetailContactsTitle: 'Kontaktní osoby',
  tourDetailContactsText: 'Přidejte více kontaktů pro tohoto zákazníka – např. různá oddělení.',
  tourDetailProjectsTitle: 'Projekty',
  tourDetailProjectsText: 'Všechny projekty přiřazené tomuto zákazníkovi – kliknutím otevřete detail.',
  company: 'Firma',
  contact: 'Kontakt',
  email: 'E-mail',
  city: 'Mesto',
  vatId: 'DIC',
  status: 'Stav',
  active: 'Aktivni',
  inactive: 'Neaktivni',
  details: 'Detaily',
  edit: 'Upravit',
  delete: 'Smazat',
  editCustomer: 'Upravit zakaznika',
  customerType: 'Typ zakaznika',
  companyType: 'Firma',
  privateType: 'Soukroma osoba',
  companyName: 'Nazev firmy',
  name: 'Nazev',
  contactPerson: 'Kontaktni osoba',
  phone: 'Telefon',
  street: 'Ulice',
  zip: 'PSC',
  notes: 'Poznamky',
  cancel: 'Zrusit',
  save: 'Ulozit',
  create: 'Vytvorit',
  enterName: 'Zadejte nazev',
  saveError: 'Chyba pri ukladani',
  deleteConfirm: 'Opravdu smazat zakaznika',
  deleteError: 'Chyba pri mazani',
  privateCustomer: 'Soukromy zakaznik',
  companyCustomer: 'Firemni zakaznik',
  masterData: 'Zakladni udaje',
  website: 'Web',
  address: 'Adresa',
  paymentTerms: 'Splatnost',
  days: 'dni',
  contacts: 'Kontakty',
  add: 'Pridat',
  noContacts: 'Zatim zadne kontakty',
  primary: 'Hlavni',
  projects: 'Projekty',
  noProjects: 'Zadne projekty',
  editContact: 'Upravit kontakt',
  newContact: 'Novy kontakt',
  position: 'Pozice',
  primaryContact: 'Hlavni kontakt',
  deleteContactConfirm: 'Smazat kontakt?',
  lockedByOther: 'Prave upravuje {name}',
  editLockedTooltip: 'Prave upravuje {name}'
};

const projectDe = {
  back: 'Zurück',
  noCustomer: 'Kein Kunde',
  edit: 'Bearbeiten',
  period: 'Zeitraum',
  budget: 'Budget',
  employees: 'Mitarbeiter',
  progress: 'Fortschritt',
  phases: 'Bauphasen',
  phase: 'Phase',
  noPhases: 'Noch keine Phasen angelegt',
  team: 'Team',
  add: 'Hinzufügen',
  noEmployeesAssigned: 'Noch keine Mitarbeiter zugewiesen',
  noMachinesAssigned: 'Noch keine Maschinen zugewiesen',
  details: 'Details',
  site: 'Baustelle',
  description: 'Beschreibung',
  financeOverview: 'Finanzübersicht',
  invoice: 'Rechnung',
  invoiced: 'Abgerechnet',
  paid: 'Bezahlt',
  openInvoices: 'Offen (Rechnungen)',
  timeValue: 'Zeitwert',
  open: 'Offen',
  materialValue: 'Materialwert',
  ofBudget: 'von Budget',
  invoices: 'Rechnungen',
  noInvoicesForProject: 'Noch keine Rechnungen für dieses Projekt',
  hoursPerEmployee: 'Stunden pro Mitarbeiter',
  total: 'Gesamt',
  totalInvoiced: 'Gesamt abgerechnet',
  totalOpen: 'Gesamt offen',
  noApprovedHours: 'Noch keine genehmigten Stunden erfasst',
  entry: 'Eintrag',
  entries: 'Einträge',
  unbookHours: 'Stunden ausbuchen',
  usedMaterials: 'Verwendete Materialien',
  noMaterialsBooked: 'Noch keine Materialien gebucht',
  unbookMaterial: 'Material ausbuchen',
  documentsPhotos: 'Dokumente und Fotos',
  toMediaManagement: 'Zur Medienverwaltung',
  mediaHint: 'Fotos, Bauplaene, Rechnungen und weitere Projektdateien zentral verwalten.',
  done: 'Fertig',
  siteManager: 'Bauleiter',
  employee: 'Mitarbeiter',
  subcontractor: 'Subunternehmer',
  foreman: 'Vorarbeiter',
  deposit: 'Abschlag',
  partialInvoice: 'Teilrechnung',
  finalInvoice: 'Schlussrechnung',
  editProject: 'Projekt bearbeiten',
  projectName: 'Projektname',
  streetPlaceholder: 'Musterstraße 1',
  cityPlaceholder: 'München',
  net: 'netto',
  editPhase: 'Phase bearbeiten',
  newPhase: 'Neue Phase',
  phaseNamePlaceholder: 'z.B. Rohbau',
  phaseTemplates: 'Vorlage wählen',
  bookings: 'Buchungen',
  noDirectMaterialBookings: 'Keine direkten Warenbuchungen gefunden.',
  noRemovalFromTime: 'Entnahmen über Zeiterfassung können hier nicht entfernt werden.',
  returnPortionHint: 'Der eingegebene Anteil wird zurückgebucht und der Lagerbestand wiederhergestellt.',
  hours: 'Stunden',
  noEntriesFound: 'Keine Einträge gefunden',
  unlinkHint: 'Bei voller Menge: Eintrag wird vom Projekt getrennt. Bei Teilmenge: Endzeit wird entsprechend angepasst.',
  addEmployee: 'Mitarbeiter hinzufügen',
  projectNameRequired: 'Projektname erforderlich',
  projectSaved: 'Projekt gespeichert',
  saveError: 'Fehler beim Speichern',
  deletePhaseConfirm: 'Phase löschen?',
  removeEmployeeConfirm: 'Mitarbeiter entfernen?',
  returnFullBooking: 'Gesamte Buchung zurückbuchen',
  of: 'von',
  returnBooking: 'zurückbuchen',
  returned: 'zurückgebucht',
  returnError: 'Fehler beim Zurückbuchen',
  unlinkFullEntry: 'Gesamten Eintrag vom Projekt trennen',
  unbookWithAdjust: 'ausbuchen (Endzeit wird angepasst)',
  unbooked: 'ausgebucht',
  genericError: 'Fehler',
  lockedByOther: 'Wird gerade bearbeitet von {name}',
  editLockedTooltip: 'Wird gerade von {name} bearbeitet'
};

const projectEn = {
  back: 'Back',
  noCustomer: 'No customer',
  edit: 'Edit',
  period: 'Period',
  budget: 'Budget',
  employees: 'Employees',
  progress: 'Progress',
  phases: 'Phases',
  phase: 'Phase',
  noPhases: 'No phases yet',
  team: 'Team',
  add: 'Add',
  noEmployeesAssigned: 'No employees assigned yet',
  noMachinesAssigned: 'No machines assigned yet',
  details: 'Details',
  site: 'Site',
  description: 'Description',
  financeOverview: 'Financial overview',
  invoice: 'Invoice',
  invoiced: 'Invoiced',
  paid: 'Paid',
  openInvoices: 'Open (invoices)',
  timeValue: 'Time value',
  open: 'Open',
  materialValue: 'Material value',
  ofBudget: 'of budget',
  invoices: 'Invoices',
  noInvoicesForProject: 'No invoices for this project yet',
  hoursPerEmployee: 'Hours per employee',
  total: 'Total',
  totalInvoiced: 'Total invoiced',
  totalOpen: 'Total open',
  noApprovedHours: 'No approved hours yet',
  entry: 'entry',
  entries: 'entries',
  unbookHours: 'Unbook hours',
  usedMaterials: 'Used materials',
  noMaterialsBooked: 'No materials booked yet',
  unbookMaterial: 'Unbook material',
  documentsPhotos: 'Documents and photos',
  toMediaManagement: 'To media management',
  mediaHint: 'Manage photos, plans, invoices and more project files centrally.',
  done: 'Done',
  siteManager: 'Site manager',
  employee: 'Employee',
  subcontractor: 'Subcontractor',
  foreman: 'Foreman',
  deposit: 'Deposit',
  partialInvoice: 'Partial invoice',
  finalInvoice: 'Final invoice',
  editProject: 'Edit project',
  projectName: 'Project name',
  streetPlaceholder: 'Sample Street 1',
  cityPlaceholder: 'Munich',
  net: 'net',
  editPhase: 'Edit phase',
  newPhase: 'New phase',
  phaseNamePlaceholder: 'e.g. shell construction',
  phaseTemplates: 'Select template',
  bookings: 'Bookings',
  noDirectMaterialBookings: 'No direct material bookings found.',
  noRemovalFromTime: 'Bookings created via time recording cannot be removed here.',
  returnPortionHint: 'The entered share is posted back and stock is restored.',
  hours: 'Hours',
  noEntriesFound: 'No entries found',
  unlinkHint: 'Full amount: entry is unlinked from project. Partial amount: end time is adjusted accordingly.',
  addEmployee: 'Add employee',
  projectNameRequired: 'Project name required',
  projectSaved: 'Project saved',
  saveError: 'Error while saving',
  deletePhaseConfirm: 'Delete phase?',
  removeEmployeeConfirm: 'Remove employee?',
  returnFullBooking: 'Return full booking',
  of: 'of',
  returnBooking: 'return',
  returned: 'returned',
  returnError: 'Return failed',
  unlinkFullEntry: 'Unlink full entry from project',
  unbookWithAdjust: 'unbook (end time will be adjusted)',
  unbooked: 'unbooked',
  genericError: 'Error',
  lockedByOther: 'Currently being edited by {name}',
  editLockedTooltip: 'Currently being edited by {name}'
};

const projectFr = {
  back: 'Retour',
  noCustomer: 'Aucun client',
  edit: 'Modifier',
  period: 'Periode',
  budget: 'Budget',
  employees: 'Employes',
  progress: 'Progression',
  phases: 'Phases',
  phase: 'Phase',
  noPhases: 'Aucune phase creee',
  team: 'Equipe',
  add: 'Ajouter',
  noEmployeesAssigned: 'Aucun employe assigne',
  noMachinesAssigned: 'Aucune machine assignee',
  details: 'Details',
  site: 'Chantier',
  description: 'Description',
  financeOverview: 'Apercu financier',
  invoice: 'Facture',
  invoiced: 'Facture',
  paid: 'Paye',
  openInvoices: 'Ouvert (factures)',
  timeValue: 'Valeur temps',
  open: 'Ouvert',
  materialValue: 'Valeur materiel',
  ofBudget: 'du budget',
  invoices: 'Factures',
  noInvoicesForProject: 'Pas encore de factures pour ce projet',
  hoursPerEmployee: 'Heures par employe',
  total: 'Total',
  totalInvoiced: 'Total facture',
  totalOpen: 'Total ouvert',
  noApprovedHours: 'Aucune heure approuvee enregistree',
  entry: 'Entree',
  entries: 'Entrees',
  unbookHours: 'Annuler heures',
  usedMaterials: 'Materiaux utilises',
  noMaterialsBooked: 'Aucun materiau enregistre',
  unbookMaterial: 'Annuler materiau',
  documentsPhotos: 'Documents et photos',
  toMediaManagement: 'Vers gestion des medias',
  mediaHint: 'Gerer centralement photos, plans, factures et autres fichiers projet.',
  done: 'Termine',
  siteManager: 'Chef de chantier',
  employee: 'Employe',
  subcontractor: 'Sous-traitant',
  foreman: 'Chef d\'equipe',
  deposit: 'Acompte',
  partialInvoice: 'Facture partielle',
  finalInvoice: 'Facture finale',
  editProject: 'Modifier projet',
  projectName: 'Nom du projet',
  streetPlaceholder: 'Rue Exemple 1',
  cityPlaceholder: 'Munich',
  net: 'net',
  editPhase: 'Modifier phase',
  newPhase: 'Nouvelle phase',
  phaseNamePlaceholder: 'p.ex. Gros oeuvre',
  phaseTemplates: 'Choisir un modèle',
  bookings: 'Reservations',
  noDirectMaterialBookings: 'Aucune reservation materiel directe trouvee.',
  noRemovalFromTime: 'Les retraits via saisie du temps ne peuvent pas etre supprimes ici.',
  returnPortionHint: 'La part saisie est recritee et le stock est restaure.',
  hours: 'Heures',
  noEntriesFound: 'Aucune entree trouvee',
  unlinkHint: 'Quantite complete: entree detachee du projet. Quantite partielle: heure de fin ajustee.',
  addEmployee: 'Ajouter employe',
  projectNameRequired: 'Nom du projet requis',
  projectSaved: 'Projet enregistre',
  saveError: 'Erreur lors de l\'enregistrement',
  deletePhaseConfirm: 'Supprimer la phase ?',
  removeEmployeeConfirm: 'Retirer employe ?',
  returnFullBooking: 'Restituer reservation complete',
  of: 'de',
  returnBooking: 'restituer',
  returned: 'restitue',
  returnError: 'Erreur lors de la restitution',
  unlinkFullEntry: 'Detacher entree complete du projet',
  unbookWithAdjust: 'annuler (heure de fin ajustee)',
  unbooked: 'annule',
  genericError: 'Erreur',
  lockedByOther: 'Actuellement modifie par {name}',
  editLockedTooltip: 'Actuellement modifie par {name}'
};

const projectIt = {
  back: 'Indietro',
  noCustomer: 'Nessun cliente',
  edit: 'Modifica',
  period: 'Periodo',
  budget: 'Budget',
  employees: 'Dipendenti',
  progress: 'Avanzamento',
  phases: 'Fasi',
  phase: 'Fase',
  noPhases: 'Nessuna fase creata',
  team: 'Team',
  add: 'Aggiungi',
  noEmployeesAssigned: 'Nessun dipendente assegnato',
  noMachinesAssigned: 'Nessuna macchina assegnata',
  details: 'Dettagli',
  site: 'Cantiere',
  description: 'Descrizione',
  financeOverview: 'Panoramica finanziaria',
  invoice: 'Fattura',
  invoiced: 'Fatturato',
  paid: 'Pagato',
  openInvoices: 'Aperto (fatture)',
  timeValue: 'Valore ore',
  open: 'Aperto',
  materialValue: 'Valore materiale',
  ofBudget: 'del budget',
  invoices: 'Fatture',
  noInvoicesForProject: 'Nessuna fattura per questo progetto',
  hoursPerEmployee: 'Ore per dipendente',
  total: 'Totale',
  totalInvoiced: 'Totale fatturato',
  totalOpen: 'Totale aperto',
  noApprovedHours: 'Nessuna ora approvata registrata',
  entry: 'Registrazione',
  entries: 'Registrazioni',
  unbookHours: 'Storna ore',
  usedMaterials: 'Materiali utilizzati',
  noMaterialsBooked: 'Nessun materiale registrato',
  unbookMaterial: 'Storna materiale',
  documentsPhotos: 'Documenti e foto',
  toMediaManagement: 'Vai alla gestione media',
  mediaHint: 'Gestisci centralmente foto, piani, fatture e altri file di progetto.',
  done: 'Fatto',
  siteManager: 'Capocantiere',
  employee: 'Dipendente',
  subcontractor: 'Subappaltatore',
  foreman: 'Caposquadra',
  deposit: 'Acconto',
  partialInvoice: 'Fattura parziale',
  finalInvoice: 'Fattura finale',
  editProject: 'Modifica progetto',
  projectName: 'Nome progetto',
  streetPlaceholder: 'Via Esempio 1',
  cityPlaceholder: 'Monaco',
  net: 'netto',
  editPhase: 'Modifica fase',
  newPhase: 'Nuova fase',
  phaseNamePlaceholder: 'es. Struttura grezza',
  phaseTemplates: 'Scegli modello',
  bookings: 'Prenotazioni',
  noDirectMaterialBookings: 'Nessuna prenotazione materiale diretta trovata.',
  noRemovalFromTime: 'I prelievi creati dalla rilevazione ore non possono essere rimossi qui.',
  returnPortionHint: 'La quota inserita viene riaccreditata e lo stock viene ripristinato.',
  hours: 'Ore',
  noEntriesFound: 'Nessuna registrazione trovata',
  unlinkHint: 'Quantita piena: registrazione scollegata dal progetto. Quantita parziale: ora di fine adeguata.',
  addEmployee: 'Aggiungi dipendente',
  projectNameRequired: 'Nome progetto obbligatorio',
  projectSaved: 'Progetto salvato',
  saveError: 'Errore durante il salvataggio',
  deletePhaseConfirm: 'Eliminare la fase?',
  removeEmployeeConfirm: 'Rimuovere dipendente?',
  returnFullBooking: 'Riporta prenotazione completa',
  of: 'di',
  returnBooking: 'riporta',
  returned: 'riportato',
  returnError: 'Errore durante il riporto',
  unlinkFullEntry: 'Scollega registrazione completa dal progetto',
  unbookWithAdjust: 'storna (ora di fine verra adeguata)',
  unbooked: 'stornato',
  genericError: 'Errore',
  lockedByOther: 'Attualmente in modifica da {name}',
  editLockedTooltip: 'Attualmente in modifica da {name}'
};

const projectPl = {
  back: 'Powrot',
  noCustomer: 'Brak klienta',
  edit: 'Edytuj',
  period: 'Okres',
  budget: 'Budzet',
  employees: 'Pracownicy',
  progress: 'Postep',
  phases: 'Etapy',
  phase: 'Etap',
  noPhases: 'Nie dodano jeszcze etapow',
  team: 'Zespol',
  add: 'Dodaj',
  noEmployeesAssigned: 'Brak przypisanych pracownikow',
  noMachinesAssigned: 'Brak przypisanych maszyn',
  details: 'Szczegoly',
  site: 'Budowa',
  description: 'Opis',
  financeOverview: 'Przeglad finansowy',
  invoice: 'Faktura',
  invoiced: 'Zafakturowano',
  paid: 'Oplacone',
  openInvoices: 'Otwarte (faktury)',
  timeValue: 'Wartosc czasu',
  open: 'Otwarte',
  materialValue: 'Wartosc materialu',
  ofBudget: 'z budzetu',
  invoices: 'Faktury',
  noInvoicesForProject: 'Brak faktur dla tego projektu',
  hoursPerEmployee: 'Godziny na pracownika',
  total: 'Razem',
  totalInvoiced: 'Razem zafakturowano',
  totalOpen: 'Razem otwarte',
  noApprovedHours: 'Brak zatwierdzonych godzin',
  entry: 'Wpis',
  entries: 'Wpisy',
  unbookHours: 'Wycofaj godziny',
  usedMaterials: 'Uzyte materialy',
  noMaterialsBooked: 'Nie zaksiegowano materialow',
  unbookMaterial: 'Wycofaj material',
  documentsPhotos: 'Dokumenty i zdjecia',
  toMediaManagement: 'Do zarzadzania mediami',
  mediaHint: 'Centralnie zarzadzaj zdjeciami, planami, fakturami i innymi plikami projektu.',
  done: 'Gotowe',
  siteManager: 'Kierownik budowy',
  employee: 'Pracownik',
  subcontractor: 'Podwykonawca',
  foreman: 'Brygadzista',
  deposit: 'Zaliczka',
  partialInvoice: 'Faktura czesciowa',
  finalInvoice: 'Faktura koncowa',
  editProject: 'Edytuj projekt',
  projectName: 'Nazwa projektu',
  streetPlaceholder: 'Przykladowa 1',
  cityPlaceholder: 'Monachium',
  net: 'netto',
  editPhase: 'Edytuj etap',
  newPhase: 'Nowy etap',
  phaseNamePlaceholder: 'np. Stan surowy',
  phaseTemplates: 'Wybierz szablon',
  bookings: 'Ksiegowania',
  noDirectMaterialBookings: 'Nie znaleziono bezposrednich ksiegowan materialowych.',
  noRemovalFromTime: 'Wycofanie utworzone przez ewidencje czasu nie moze byc tu usuniete.',
  returnPortionHint: 'Wprowadzona czesc zostanie zwrocona i stan magazynowy odtworzony.',
  hours: 'Godziny',
  noEntriesFound: 'Nie znaleziono wpisow',
  unlinkHint: 'Pelna ilosc: wpis zostanie odlaczony od projektu. Czesc: czas zakonczenia zostanie dopasowany.',
  addEmployee: 'Dodaj pracownika',
  projectNameRequired: 'Nazwa projektu jest wymagana',
  projectSaved: 'Projekt zapisany',
  saveError: 'Blad zapisu',
  deletePhaseConfirm: 'Usunac etap?',
  removeEmployeeConfirm: 'Usunac pracownika?',
  returnFullBooking: 'Zwroc pelne ksiegowanie',
  of: 'z',
  returnBooking: 'zwroc',
  returned: 'zwrocono',
  returnError: 'Blad zwrotu',
  unlinkFullEntry: 'Odlacz caly wpis od projektu',
  unbookWithAdjust: 'wycofaj (czas zakonczenia zostanie dopasowany)',
  unbooked: 'wycofano',
  genericError: 'Blad',
  lockedByOther: 'Aktualnie edytowane przez {name}',
  editLockedTooltip: 'Aktualnie edytowane przez {name}'
};

const projectCs = {
  back: 'Zpet',
  noCustomer: 'Bez zakaznika',
  edit: 'Upravit',
  period: 'Obdobi',
  budget: 'Rozpocet',
  employees: 'Zamestnanci',
  progress: 'Postup',
  phases: 'Faze',
  phase: 'Faze',
  noPhases: 'Zatim nejsou vytvoreny zadne faze',
  team: 'Tym',
  add: 'Pridat',
  noEmployeesAssigned: 'Zatim nejsou prirazeni zadni zamestnanci',
  noMachinesAssigned: 'Zatim nejsou prirazeny zadne stroje',
  details: 'Detaily',
  site: 'Stavba',
  description: 'Popis',
  financeOverview: 'Financni prehled',
  invoice: 'Faktura',
  invoiced: 'Vyfakturovano',
  paid: 'Zaplaceno',
  openInvoices: 'Otevrene (faktury)',
  timeValue: 'Hodnota casu',
  open: 'Otevrene',
  materialValue: 'Hodnota materialu',
  ofBudget: 'z rozpoctu',
  invoices: 'Faktury',
  noInvoicesForProject: 'Pro tento projekt zatim nejsou faktury',
  hoursPerEmployee: 'Hodiny na zamestnance',
  total: 'Celkem',
  totalInvoiced: 'Celkove vyfakturovano',
  totalOpen: 'Celkove otevreno',
  noApprovedHours: 'Zatim nejsou schvalene hodiny',
  entry: 'Zaznam',
  entries: 'Zaznamy',
  unbookHours: 'Odecti hodiny',
  usedMaterials: 'Pouzity material',
  noMaterialsBooked: 'Zatim nebyl zauctovan zadny material',
  unbookMaterial: 'Odecti material',
  documentsPhotos: 'Dokumenty a fotky',
  toMediaManagement: 'Do spravy medii',
  mediaHint: 'Spravujte centralne fotky, plany, faktury a dalsi projektove soubory.',
  done: 'Hotovo',
  siteManager: 'Stavbyvedouci',
  employee: 'Zamestnanec',
  subcontractor: 'Subdodavatel',
  foreman: 'Predak',
  deposit: 'Zaloha',
  partialInvoice: 'Dilci faktura',
  finalInvoice: 'Konecna faktura',
  editProject: 'Upravit projekt',
  projectName: 'Nazev projektu',
  streetPlaceholder: 'Ukazkova 1',
  cityPlaceholder: 'Mnichov',
  net: 'netto',
  editPhase: 'Upravit fazi',
  newPhase: 'Nova faze',
  phaseNamePlaceholder: 'napr. Hruba stavba',
  phaseTemplates: 'Vybrat šablonu',
  bookings: 'Zauctovani',
  noDirectMaterialBookings: 'Nenalezena zadna prima zauctovani materialu.',
  noRemovalFromTime: 'Odecty vytvorene pres evidenci casu zde nelze odstranit.',
  returnPortionHint: 'Zadany podil bude vracen a stav skladu obnoven.',
  hours: 'Hodiny',
  noEntriesFound: 'Nenalezeny zadne zaznamy',
  unlinkHint: 'Plne mnozstvi: zaznam se odpoji od projektu. Cast: cas konce se odpovidajicim zpusobem upravi.',
  addEmployee: 'Pridat zamestnance',
  projectNameRequired: 'Nazev projektu je povinny',
  projectSaved: 'Projekt ulozen',
  saveError: 'Chyba pri ukladani',
  deletePhaseConfirm: 'Smazat fazi?',
  removeEmployeeConfirm: 'Odebrat zamestnance?',
  returnFullBooking: 'Vratit cele zauctovani',
  of: 'z',
  returnBooking: 'vratit',
  returned: 'vraceno',
  returnError: 'Chyba pri vraceni',
  unlinkFullEntry: 'Odpojit cely zaznam od projektu',
  unbookWithAdjust: 'odecti (cas konce bude upraven)',
  unbooked: 'odecteno',
  genericError: 'Chyba',
  lockedByOther: 'Prave upravuje {name}',
  editLockedTooltip: 'Prave upravuje {name}'
};

const scheduleDe = {
  title: 'Baustellenplanung',
  infoText: "Diese Ansicht zeigt die Einsatz- und Terminplanung in einer Wochenübersicht. Du kannst zwischen Gesamt- und Projektansicht wechseln, Termine per Drag & Drop planen und Mitarbeiter direkt zuweisen.",
  infoItem1: "Ziehe Mitarbeiter per Drag & Drop auf einen Tag, um einen neuen Termin zu erstellen.",
  infoItem2: "Farben zeigen die Zugehörigkeit zu Projekten oder Abwesenheiten wie Urlaub oder Krankheit.",
  infoItem3: "Klicke auf einen Termin, um Details zu bearbeiten oder zu löschen.",
  prevWeek: 'Vorwoche',
  today: 'Heute',
  nextWeek: 'Nächste',
  appointment: 'Termin',
  overview: 'Gesamtübersicht',
  projectView: 'Projektansicht',
  createAppointment: 'Termin anlegen',
  noAppointments: 'Keine Termine',
  vacation: 'Urlaub',
  sick: 'Krank',
  project: 'Projekt',
  pleaseSelect: 'Bitte wählen',
  selectProject: 'Projekt auswählen',
  selectProjectHint: 'Wählen Sie ein Projekt um Mitarbeiter per Drag und Drop einzuplanen',
  planAssignment: 'Einsatz planen',
  onDate: 'ist am',
  userVacationCannotPlan: 'im Urlaub und kann nicht eingeplant werden',
  userAbsentCannotPlan: 'abwesend und kann nicht eingeplant werden',
  dragCreateHint: 'Ziehen um neuen Termin anzulegen',
  holiday: 'Feiertag',
  holidayConfirm: 'Der Zeitraum enthält einen Feiertag. Wie möchtest du vorgehen?',
  dialogTitle: 'Feiertag im Zeitraum',
  skipHoliday: 'Feiertag herausnehmen & darum buchen',
  bookAnyway: 'Trotzdem buchen (inkl. Feiertag)',
  startTour: 'Führung starten',
  tourNavTitle: 'Monatsnavigation',
  tourNavText: 'Blättere durch die Monate oder springe mit dem mittleren Button direkt zum aktuellen Monat.',
  tourCalendarTitle: 'Monatskalender',
  tourCalendarText: 'Klick auf einen Tag um Termine zu sehen oder neu anzulegen. Termine werden als farbige Balken angezeigt.',
  tourCalendarEmployeeText: 'Klick auf einen Tag um deine Termine und Projekteinsätze zu sehen. Termine werden als farbige Balken angezeigt.',
  tourNewTitle: 'Neuer Termin',
  tourNewText: 'Legt einen neuen Termin oder Einsatz an – für ein Projekt mit Mitarbeitern, Datum und Uhrzeit.',
  tourModalTitle: 'Terminformular',
  tourModalText: 'Titel, Projekt, Datum, Uhrzeit und Mitarbeiter eintragen. Mitarbeiter können per Drag & Drop aus der Seitenleiste zugewiesen werden.',
  tourToggleTitle: 'Ansicht wechseln',
  tourToggleText: 'Zwischen Gesamtübersicht aller Termine und projektbezogener Ansicht wechseln.',
  tourSidebarTitle: 'Mitarbeiter',
  tourSidebarText: 'Zeigt alle Mitarbeiter mit ihren Einsätzen im aktuellen Monat. Per Drag & Drop auf einen Kalendertag ziehen um schnell einen Termin anzulegen.',
  tourLegendTitle: 'Legende',
  tourLegendText: 'Farbcodes der Projekte, Urlaub (lila) und Krankmeldungen (rot) auf einen Blick.',
  dragPlanHint: 'Ziehen um einzuplanen',
  saveError: 'Termin konnte nicht gespeichert werden',
  deleteConfirm: 'Termin wirklich löschen?',
  employees: 'Mitarbeiter',
  thisWeek: 'diese Woche',
  thisMonth: 'diesen Monat',
  editAppointment: 'Termin bearbeiten',
  newAssignment: 'Neuer Einsatz',
  titleLabel: 'Titel',
  period: 'Zeitraum',
  description: 'Beschreibung',
  titlePlaceholder: 'z.B. Baustellenbesprechung',
  select: 'Auswaehlen',
  startTimeOptional: 'Startzeit (optional)',
  endTimeOptional: 'Endzeit (optional)',
  color: 'Farbe',
  additionalInfo: 'Weitere Informationen',
  drag: 'Ziehen'
};

const scheduleEn = {
  title: 'Site planning',
  infoText: "This view shows scheduling and assignments in a weekly overview. You can switch between overview and project mode, plan appointments via drag & drop, and assign employees directly.",
  infoItem1: "Drag and drop employees onto a day to create a new appointment.",
  infoItem2: "Colors indicate project assignments or absences such as vacation or sick leave.",
  infoItem3: "Click on an appointment to edit or delete its details.",
  prevWeek: 'Previous week',
  today: 'Today',
  nextWeek: 'Next',
  appointment: 'Appointment',
  overview: 'Overview',
  projectView: 'Project view',
  createAppointment: 'Create appointment',
  noAppointments: 'No appointments',
  vacation: 'Vacation',
  sick: 'Sick leave',
  project: 'Project',
  pleaseSelect: 'Please select',
  selectProject: 'Select project',
  selectProjectHint: 'Select a project to plan employees by drag and drop',
  planAssignment: 'Plan assignment',
  onDate: 'is on',
  userVacationCannotPlan: 'on vacation and cannot be planned',
  userAbsentCannotPlan: 'absent and cannot be planned',
  dragCreateHint: 'Drag to create a new appointment',
  holiday: 'Public holiday',
  holidayConfirm: 'The period contains a public holiday. How would you like to proceed?',
  dialogTitle: 'Public holiday in period',
  skipHoliday: 'Exclude holiday & book around it',
  bookAnyway: 'Book anyway (incl. holiday)',
  startTour: 'Start tour',
  tourNavTitle: 'Month navigation',
  tourNavText: 'Browse through months or jump to the current month with the centre button.',
  tourCalendarTitle: 'Monthly calendar',
  tourCalendarText: 'Click a day to view or create appointments. Appointments appear as coloured bars.',
  tourCalendarEmployeeText: 'Click a day to see your appointments and project assignments. Appointments appear as coloured bars.',
  tourNewTitle: 'New appointment',
  tourNewText: 'Creates a new appointment or assignment – for a project with employees, date and time.',
  tourModalTitle: 'Appointment form',
  tourModalText: 'Enter title, project, date, time and employees. Employees can also be assigned via drag & drop from the sidebar.',
  tourToggleTitle: 'Switch view',
  tourToggleText: 'Toggle between an overview of all appointments and a project-specific view.',
  tourSidebarTitle: 'Employees',
  tourSidebarText: 'Shows all employees with their assignments this month. Drag onto a calendar day to quickly create an appointment.',
  tourLegendTitle: 'Legend',
  tourLegendText: 'Colour codes for projects, vacation (purple) and sick leave (red) at a glance.',
  dragPlanHint: 'Drag to plan assignment',
  saveError: 'Appointment could not be saved',
  deleteConfirm: 'Delete appointment?',
  employees: 'Employees',
  thisWeek: 'this week',
  thisMonth: 'this month',
  editAppointment: 'Edit appointment',
  newAssignment: 'New assignment',
  titleLabel: 'Title',
  period: 'Period',
  description: 'Description',
  titlePlaceholder: 'e.g. site coordination',
  select: 'Select',
  startTimeOptional: 'Start time (optional)',
  endTimeOptional: 'End time (optional)',
  color: 'Color',
  additionalInfo: 'Additional information',
  drag: 'Drag'
};

const scheduleFr = {
  title: 'Planification chantier',
  infoText: "Cette vue affiche la planification des tâches et des rendez-vous dans une vue hebdomadaire. Vous pouvez basculer entre la vue globale et projet, planifier par glisser-déposer et assigner directement les employés.",
  infoItem1: "Glissez-déposez les employés sur un jour pour créer un nouveau rendez-vous.",
  infoItem2: "Les couleurs indiquent les projets ou les absences comme les congés ou les maladies.",
  infoItem3: "Cliquez sur un rendez-vous pour le modifier ou le supprimer.",
  prevWeek: 'Semaine precedente',
  today: "Aujourd'hui",
  nextWeek: 'Suivante',
  appointment: 'Rendez-vous',
  overview: "Vue d'ensemble",
  projectView: 'Vue projet',
  createAppointment: 'Creer un rendez-vous',
  noAppointments: 'Aucun rendez-vous',
  vacation: 'Conges',
  sick: 'Arret maladie',
  project: 'Projet',
  pleaseSelect: 'Veuillez choisir',
  selectProject: 'Choisir un projet',
  selectProjectHint: 'Choisissez un projet pour planifier les employes par glisser-deposer',
  planAssignment: 'Planifier affectation',
  onDate: 'est le',
  userVacationCannotPlan: 'en conges et ne peut pas etre planifie',
  userAbsentCannotPlan: 'absent et ne peut pas etre planifie',
  dragCreateHint: 'Glisser pour creer un rendez-vous',
  holiday: 'Jour férié',
  holidayConfirm: 'La période contient un jour férié. Comment souhaitez-vous procéder?',
  dialogTitle: 'Jour férié dans la période',
  skipHoliday: 'Exclure le jour férié et réserver autour',
  bookAnyway: 'Réserver quand même (incl. jour férié)',
  startTour: 'Lancer la visite guidée',
  tourNavTitle: 'Navigation mensuelle',
  tourNavText: 'Parcourez les mois ou revenez au mois actuel avec le bouton central.',
  tourCalendarTitle: 'Calendrier mensuel',
  tourCalendarText: 'Cliquez sur un jour pour voir ou créer des rendez-vous. Ils s\'affichent sous forme de barres colorées.',
  tourCalendarEmployeeText: 'Cliquez sur un jour pour voir vos rendez-vous et affectations. Ils s\'affichent sous forme de barres colorées.',
  tourNewTitle: 'Nouveau rendez-vous',
  tourNewText: 'Crée un nouveau rendez-vous ou affectation – pour un projet avec employés, date et heure.',
  tourModalTitle: 'Formulaire de rendez-vous',
  tourModalText: 'Saisissez titre, projet, date, heure et employés. Les employés peuvent aussi être assignés par glisser-déposer.',
  tourToggleTitle: 'Changer de vue',
  tourToggleText: 'Basculer entre la vue globale et la vue par projet.',
  tourSidebarTitle: 'Employés',
  tourSidebarText: 'Affiche tous les employés avec leurs affectations du mois. Glissez sur un jour pour créer rapidement un rendez-vous.',
  tourLegendTitle: 'Légende',
  tourLegendText: 'Codes couleur des projets, congés (violet) et arrêts maladie (rouge).',
  dragPlanHint: 'Glisser pour planifier',
  saveError: "Le rendez-vous n'a pas pu etre enregistre",
  deleteConfirm: 'Supprimer le rendez-vous ?',
  employees: 'Employes',
  thisWeek: 'cette semaine',
  thisMonth: 'ce mois-ci',
  editAppointment: 'Modifier rendez-vous',
  newAssignment: 'Nouvelle affectation',
  titleLabel: 'Titre',
  period: 'Periode',
  description: 'Description',
  titlePlaceholder: 'p.ex. Reunion chantier',
  select: 'Selectionner',
  startTimeOptional: 'Heure de debut (optionnel)',
  endTimeOptional: 'Heure de fin (optionnel)',
  color: 'Couleur',
  additionalInfo: 'Informations supplementaires',
  drag: 'Glisser'
};

const scheduleIt = {
  title: 'Pianificazione cantiere',
  infoText: "Questa vista mostra la pianificazione di attività e appuntamenti in una panoramica settimanale. Puoi passare tra vista generale e progetto, pianificare con drag & drop e assegnare direttamente i dipendenti.",
  infoItem1: "Trascina i dipendenti su un giorno per creare un nuovo appuntamento.",
  infoItem2: "I colori indicano progetti o assenze come ferie o malattia.",
  infoItem3: "Clicca su un appuntamento per modificarlo o eliminarlo.",
  prevWeek: 'Settimana precedente',
  today: 'Oggi',
  nextWeek: 'Successiva',
  appointment: 'Appuntamento',
  overview: 'Panoramica',
  projectView: 'Vista progetto',
  createAppointment: 'Crea appuntamento',
  noAppointments: 'Nessun appuntamento',
  vacation: 'Ferie',
  sick: 'Malattia',
  project: 'Progetto',
  pleaseSelect: 'Seleziona',
  selectProject: 'Seleziona progetto',
  selectProjectHint: 'Seleziona un progetto per pianificare i dipendenti con drag and drop',
  planAssignment: 'Pianifica assegnazione',
  onDate: 'e il',
  userVacationCannotPlan: 'in ferie e non puo essere pianificato',
  userAbsentCannotPlan: 'assente e non puo essere pianificato',
  dragCreateHint: 'Trascina per creare un nuovo appuntamento',
  holiday: 'Giorno festivo',
  holidayConfirm: 'Il periodo contiene un giorno festivo. Come vuoi procedere?',
  dialogTitle: 'Giorno festivo nel periodo',
  skipHoliday: 'Escludi il festivo e prenota attorno',
  bookAnyway: 'Prenota comunque (incl. festivo)',
  startTour: 'Avvia la guida',
  tourNavTitle: 'Navigazione mensile',
  tourNavText: 'Scorri i mesi o torna al mese corrente con il pulsante centrale.',
  tourCalendarTitle: 'Calendario mensile',
  tourCalendarText: 'Clicca su un giorno per vedere o creare appuntamenti. Appaiono come barre colorate.',
  tourCalendarEmployeeText: 'Clicca su un giorno per vedere i tuoi appuntamenti e incarichi. Appaiono come barre colorate.',
  tourNewTitle: 'Nuovo appuntamento',
  tourNewText: 'Crea un nuovo appuntamento o incarico – per un progetto con dipendenti, data e orario.',
  tourModalTitle: 'Modulo appuntamento',
  tourModalText: 'Inserisci titolo, progetto, data, orario e dipendenti. I dipendenti possono anche essere assegnati tramite drag & drop.',
  tourToggleTitle: 'Cambia vista',
  tourToggleText: 'Passa dalla panoramica generale alla vista per progetto.',
  tourSidebarTitle: 'Dipendenti',
  tourSidebarText: 'Mostra tutti i dipendenti con i loro incarichi nel mese. Trascina su un giorno per creare rapidamente un appuntamento.',
  tourLegendTitle: 'Legenda',
  tourLegendText: 'Codici colore dei progetti, ferie (viola) e assenze per malattia (rosso).',
  dragPlanHint: 'Trascina per pianificare',
  saveError: "L'appuntamento non puo essere salvato",
  deleteConfirm: 'Eliminare appuntamento?',
  employees: 'Dipendenti',
  thisWeek: 'questa settimana',
  thisMonth: 'questo mese',
  editAppointment: 'Modifica appuntamento',
  newAssignment: 'Nuova assegnazione',
  titleLabel: 'Titolo',
  period: 'Periodo',
  description: 'Descrizione',
  titlePlaceholder: 'es. Riunione cantiere',
  select: 'Seleziona',
  startTimeOptional: 'Ora inizio (opzionale)',
  endTimeOptional: 'Ora fine (opzionale)',
  color: 'Colore',
  additionalInfo: 'Informazioni aggiuntive',
  drag: 'Trascina'
};

const schedulePl = {
  title: 'Planowanie budowy',
  infoText: "Ten widok pokazuje planowanie zadań i terminów w układzie tygodniowym. Możesz przełączać między widokiem ogólnym a projektowym, planować metodą przeciągnij i upuść oraz przypisywać pracowników.",
  infoItem1: "Przeciągnij pracownika na dzień, aby utworzyć nowe spotkanie.",
  infoItem2: "Kolory oznaczają projekty lub nieobecności, takie jak urlop lub choroba.",
  infoItem3: "Kliknij wydarzenie, aby je edytować lub usunąć.",
  prevWeek: 'Poprzedni tydzien',
  today: 'Dzisiaj',
  nextWeek: 'Nastepny',
  appointment: 'Termin',
  overview: 'Przeglad',
  projectView: 'Widok projektu',
  createAppointment: 'Utworz termin',
  noAppointments: 'Brak terminow',
  vacation: 'Urlop',
  sick: 'Zwolnienie chorobowe',
  project: 'Projekt',
  pleaseSelect: 'Wybierz',
  selectProject: 'Wybierz projekt',
  selectProjectHint: 'Wybierz projekt, aby zaplanowac pracownikow metoda przeciagnij i upusc',
  planAssignment: 'Zaplanuj przydzial',
  onDate: 'jest dnia',
  userVacationCannotPlan: 'na urlopie i nie moze byc zaplanowany',
  userAbsentCannotPlan: 'nieobecny i nie moze byc zaplanowany',
  dragCreateHint: 'Przeciagnij, aby utworzyc nowy termin',
  holiday: 'Święto',
  holidayConfirm: 'Okres zawiera dzień świąteczny. Jak chcesz postąpić?',
  dialogTitle: 'Święto w okresie',
  skipHoliday: 'Wyklucz święto i zarezerwuj wokół niego',
  bookAnyway: 'Zarezerwuj mimo to (z świętem)',
  startTour: 'Uruchom przewodnik',
  tourNavTitle: 'Nawigacja miesięczna',
  tourNavText: 'Przeglądaj miesiące lub wróć do bieżącego miesiąca środkowym przyciskiem.',
  tourCalendarTitle: 'Kalendarz miesięczny',
  tourCalendarText: 'Kliknij dzień aby zobaczyć lub utworzyć terminy. Wyświetlają się jako kolorowe paski.',
  tourCalendarEmployeeText: 'Kliknij dzień aby zobaczyć swoje terminy i zlecenia. Wyświetlają się jako kolorowe paski.',
  tourNewTitle: 'Nowy termin',
  tourNewText: 'Tworzy nowy termin lub zlecenie – dla projektu z pracownikami, datą i godziną.',
  tourModalTitle: 'Formularz terminu',
  tourModalText: 'Wprowadź tytuł, projekt, datę, godzinę i pracowników. Pracownicy mogą być też przypisani przez przeciąganie.',
  tourToggleTitle: 'Zmień widok',
  tourToggleText: 'Przełącz między widokiem ogólnym a widokiem per projekt.',
  tourSidebarTitle: 'Pracownicy',
  tourSidebarText: 'Pokazuje wszystkich pracowników z ich zleceniami w danym miesiącu. Przeciągnij na dzień aby szybko utworzyć termin.',
  tourLegendTitle: 'Legenda',
  tourLegendText: 'Kody kolorów projektów, urlopu (fioletowy) i zwolnień chorobowych (czerwony).',
  dragPlanHint: 'Przeciagnij, aby zaplanowac',
  saveError: 'Nie mozna zapisac terminu',
  deleteConfirm: 'Usunac termin?',
  employees: 'Pracownicy',
  thisWeek: 'w tym tygodniu',
  thisMonth: 'w tym miesiacu',
  editAppointment: 'Edytuj termin',
  newAssignment: 'Nowy przydzial',
  titleLabel: 'Tytul',
  period: 'Okres',
  description: 'Opis',
  titlePlaceholder: 'np. Narada budowy',
  select: 'Wybierz',
  startTimeOptional: 'Godzina rozpoczecia (opcjonalnie)',
  endTimeOptional: 'Godzina zakonczenia (opcjonalnie)',
  color: 'Kolor',
  additionalInfo: 'Dodatkowe informacje',
  drag: 'Przeciagnij'
};

const scheduleCs = {
  title: 'Planovani stavby',
  infoText: "Ten widok pokazuje planowanie zadań i terminów w układzie tygodniowym. Możesz przełączać między widokiem ogólnym a projektowym, planować metodą przeciągnij i upuść oraz przypisywać pracowników.",
  infoItem1: "Przeciągnij pracownika na dzień, aby utworzyć nowe spotkanie.",
  infoItem2: "Kolory oznaczają projekty lub nieobecności, takie jak urlop lub choroba.",
  infoItem3: "Kliknij wydarzenie, aby je edytować lub usunąć.",
  prevWeek: 'Minuly tyden',
  today: 'Dnes',
  nextWeek: 'Dalsi',
  appointment: 'Termin',
  overview: 'Prehled',
  projectView: 'Pohled projektu',
  createAppointment: 'Vytvorit termin',
  noAppointments: 'Zadne terminy',
  vacation: 'Dovolena',
  sick: 'Nemocenska',
  project: 'Projekt',
  pleaseSelect: 'Vyberte',
  selectProject: 'Vyberte projekt',
  selectProjectHint: 'Vyberte projekt pro planovani zamestnancu pres pretazeni',
  planAssignment: 'Naplanovat nasazeni',
  onDate: 'je dne',
  userVacationCannotPlan: 'na dovolene a nelze jej naplanovat',
  userAbsentCannotPlan: 'nepritomny a nelze jej naplanovat',
  dragCreateHint: 'Pretahnete pro vytvoreni noveho terminu',
  holiday: 'Státní svátek',
  holidayConfirm: 'Období obsahuje státní svátek. Jak chcete pokračovat?',
  dialogTitle: 'Státní svátek v období',
  skipHoliday: 'Vynechat svátek a rezervovat kolem',
  bookAnyway: 'Rezervovat přesto (vč. svátku)',
  startTour: 'Spustit průvodce',
  tourNavTitle: 'Navigace měsícem',
  tourNavText: 'Procházejte měsíce nebo skočte na aktuální měsíc prostředním tlačítkem.',
  tourCalendarTitle: 'Měsíční kalendář',
  tourCalendarText: 'Kliknutím na den zobrazíte nebo vytvoříte termíny. Zobrazují se jako barevné pruhy.',
  tourCalendarEmployeeText: 'Kliknutím na den zobrazíte své termíny a projektové úkoly. Zobrazují se jako barevné pruhy.',
  tourNewTitle: 'Nový termín',
  tourNewText: 'Vytvoří nový termín nebo přiřazení – pro projekt se zaměstnanci, datem a časem.',
  tourModalTitle: 'Formulář termínu',
  tourModalText: 'Zadejte název, projekt, datum, čas a zaměstnance. Zaměstnance lze přidat také přetažením.',
  tourToggleTitle: 'Přepnout pohled',
  tourToggleText: 'Přepínání mezi celkovým přehledem a pohledem per projekt.',
  tourSidebarTitle: 'Zaměstnanci',
  tourSidebarText: 'Zobrazuje všechny zaměstnance s jejich úkoly v daném měsíci. Přetáhněte na den pro rychlé vytvoření termínu.',
  tourLegendTitle: 'Legenda',
  tourLegendText: 'Barevné kódy projektů, dovolené (fialová) a nemocenské (červená).',
  dragPlanHint: 'Pretahnete pro planovani',
  saveError: 'Termin se nepodarilo ulozit',
  deleteConfirm: 'Opravdu smazat termin?',
  employees: 'Zamestnanci',
  thisWeek: 'tento tyden',
  thisMonth: 'tento mesic',
  editAppointment: 'Upravit termin',
  newAssignment: 'Nove nasazeni',
  titleLabel: 'Nazev',
  period: 'Obdobi',
  description: 'Popis',
  titlePlaceholder: 'napr. Porada na stavbe',
  select: 'Vybrat',
  startTimeOptional: 'Cas zacatku (volitelne)',
  endTimeOptional: 'Cas konce (volitelne)',
  color: 'Barva',
  additionalInfo: 'Dalsi informace',
  drag: 'Pretahnout'
};

const timeDe = {
  title: 'Zeiterfassung',
  infoText: 'Hier erfasst du deine Arbeitszeiten – per Timer oder manuell.',
  infoItem1: 'Timer starten, pausieren und stoppen – die Zeit wird automatisch berechnet',
  infoItem2: 'Zeiten manuell nachtragen, z.B. für vergessene Einträge',
  infoItem3: 'Regiestunden mit Unterschrift erfassen und als PDF exportieren',
  infoItem4: 'Ausstehende Genehmigungen für Zeiten und Materialbuchungen könenn hier eingesehen und bearbeitet werden',
  subtitle: 'Zeiten erfassen und verwalten',
  start: 'Starten',
  pause: 'Pause',
  resume: 'Weiter',
  stop: 'Beenden',
  saveEntry: 'Eintrag speichern',
  startLabel: 'Start',
  endLabel: 'Ende',
  minutes: 'Min',
  net: 'Netto',
  project: 'Projekt',
  chooseProject: 'Bitte ein Projekt wählen',
  note: 'Notiz',
  cancel: 'Abbrechen',
  save: 'Speichern',
  running: 'Läuft',
  paused: 'Pausiert',
  ready: 'Bereit',
  enterNote: 'Bitte eine Notiz eingeben',
  entrySaved: 'Eintrag gespeichert',
  error: 'Fehler',
  startRequired: 'Startzeit erforderlich',
  endRequired: 'Endzeit erforderlich',
  noteRequired: 'Notiz erforderlich',
  submittedForApproval: 'Eintrag zur Genehmigung eingereicht',
  notePlaceholder: 'Was wurde gemacht?',
  rejectEntry: 'Eintrag ablehnen',
  reasonOptional: 'Grund (optional)',
  rejectPlaceholder: 'Optionaler Hinweis für den Mitarbeiter',
  rebook: 'Umbuchen',
  rebookSuccess: 'Eintrag erfolgreich umgebucht',
  rebookError: 'Umbuchen fehlgeschlagen',
  manualEntry: 'Manuelle Eingabe',
  startTour: 'Führung starten',
  tourTimerTitle: 'Timer',
  tourTimerText: 'Starte den Timer wenn du anfängst zu arbeiten, pausiere bei Bedarf und stoppe ihn am Ende. Du wirst dann nach Projekt und Tätigkeit gefragt.',
  tourStopModalTitle: 'Eintrag speichern',
  tourStopModalText: 'Nach dem Stopp siehst du eine Zusammenfassung. Wähle das Projekt, schreibe eine Notiz – und speichere oder brich ab.',
  tourMaterialsTitle: 'Material hinzufügen',
  tourMaterialsText: 'Hier kannst du direkt Materialien zum Zeiteintrag buchen – diese erscheinen dann in der Projektabrechnung und können einfach in Rechnungen übernommen werden.',
  tourManualTitle: 'Manuelle Eingabe',
  tourManualText: 'Hier kannst du Zeiten nachträglich eintragen – mit Start-/Endzeit, Projekt und Notiz.',
  tourPendingTitle: 'Ausstehende Genehmigungen',
  tourPendingText: 'Als Manager siehst du hier Einträge deiner Mitarbeiter, die noch auf Freigabe warten.',
  tourMatPendingTitle: 'Materialbuchungen',
  tourMatPendingText: 'Materialbuchungen aus Zeiteinträgen deiner Mitarbeiter, die noch genehmigt werden müssen – direkt freigeben oder ablehnen.',
  tourEntriesTitle: 'Meine Einträge',
  tourEntriesText: 'Alle deine gebuchten Zeiteinträge der letzten Tage – mit Status, Projekt und Nettodauer.',
  startTime: 'Startzeit',
  endTime: 'Endzeit',
  pendingApprovals: 'Ausstehende Genehmigungen',
  approve: 'Genehmigen',
  reject: 'Ablehnen',
  pendingMaterialBookings: 'Ausstehende Materialbuchungen',
  material: 'Material',
  rejectMaterialBooking: 'Materialbuchung ablehnen',
  latestEntries: 'Letzte Einträge',
  noEntries: 'Keine Einträge',
  noEntriesHint: 'Noch keine Zeiteinträge vorhanden.',
  time: 'Zeit',
  reason: 'Grund',
  discardCapturedEntryConfirm: 'Die erfasste Zeit wird endgültig verworfen. Wirklich abbrechen?',
  deleteEntryConfirm: 'Eintrag löschen?',
  regieHours: 'Regiestunden',
  regieTag: 'Regie',
  regieSignNow: 'Jetzt unterschreiben lassen',
  regieSignLater: 'Später gesammelt unterschreiben lassen',
  regieSignLaterHint: 'Der Eintrag wird als Regiestunden gespeichert. Die Unterschrift des Kunden wird später im Rahmen der Tagesfreigabe gesammelt eingeholt.',
  signatureTitle: 'Unterschrift erfassen',
  signatureHint: 'Bitte unterschreiben Sie im Feld, um den Regieeintrag nachweisbar zu speichern.',
  signatureMobileHint: 'Auf dem Handy funktioniert es im Querformat am besten.',
  signatureCapture: 'Unterschrift erfassen',
  signatureReplace: 'Unterschrift neu erfassen',
  signatureRequired: 'Unterschrift erforderlich',
  signerName: 'Name der unterschreibenden Person',
  signerNamePlaceholder: 'Name eingeben',
  signerNameRequired: 'Name der unterschreibenden Person erforderlich',
  signatureAvailable: 'Unterschrift vorhanden',
  signatureClear: 'Zurücksetzen',
  signatureApply: 'Unterschrift übernehmen',
  signatureFullscreenEnter: 'Vollbild',
  signatureFullscreenExit: 'Vollbild beenden',
  regiePdf: 'Regie-PDF',
  regiePdfError: 'Regie-PDF konnte nicht geöffnet werden',
  loading: 'Lädt',
  foremanSignoff: 'Regiestunden-Tagesfreigabe',
  foremanSignoffHint: 'Fasse die Regiestunden aller Mitarbeiter für einen Tag auf dieser Baustelle zusammen und lasse sie vom Kunden mit einer einzigen Unterschrift freigeben.',
  foremanProject: 'Projekt',
  foremanDate: 'Datum',
  foremanSigned: 'Unterschrift',
  foremanAlreadySigned: 'Bereits unterschrieben',
  foremanNoEntries: 'Keine Regiestunden für diesen Tag gefunden.',
  foremanSignButton: 'Tag freigeben',
  foremanSignSuccess: 'Tag erfolgreich freigegeben',
  tourForemanTitle: 'Vorarbeiter-Tagesfreigabe',
  tourForemanText: 'Als Vorarbeiter kannst du hier die Regiestunden aller Mitarbeiter für einen Tag auf deiner Baustelle zusammenfassen und vom Kunden in einem Schritt unterschreiben lassen.'
};

const timeEn = {
  title: 'Time tracking',
  infoText: 'Here you record your working hours – using the timer or manually.',
  infoItem1: 'Start, pause and stop the timer – time is calculated automatically',
  infoItem2: 'Add time entries manually, e.g. for forgotten entries',
  infoItem3: 'Record billable hours with signature and export as PDF',
  infoItem4: 'Pending approvals for time and material entries can be viewed and edited here',
  subtitle: 'Record and manage times',
  start: 'Start',
  pause: 'Pause',
  resume: 'Resume',
  stop: 'Stop',
  saveEntry: 'Save entry',
  startLabel: 'Start',
  endLabel: 'End',
  minutes: 'min',
  net: 'Net',
  project: 'Project',
  chooseProject: 'Please choose a project',
  note: 'Note',
  cancel: 'Cancel',
  save: 'Save',
  running: 'Running',
  paused: 'Paused',
  ready: 'Ready',
  enterNote: 'Please enter a note',
  entrySaved: 'Entry saved',
  error: 'Error',
  startRequired: 'Start time required',
  endRequired: 'End time required',
  noteRequired: 'Note required',
  submittedForApproval: 'Submitted for approval',
  notePlaceholder: 'What was done?',
  rejectEntry: 'Reject entry',
  reasonOptional: 'Reason (optional)',
  rejectPlaceholder: 'Optional note for the employee',
  rebook: 'Rebook',
  rebookSuccess: 'Entry rebooked successfully',
  rebookError: 'Rebooking failed',
  manualEntry: 'Manual entry',
  startTour: 'Start tour',
  tourTimerTitle: 'Timer',
  tourTimerText: 'Start the timer when you begin working, pause when needed, and stop at the end. You will then be asked for project and activity.',
  tourStopModalTitle: 'Save entry',
  tourStopModalText: 'After stopping you see a summary. Choose the project, write a note – then save or cancel.',
  tourMaterialsTitle: 'Add material',
  tourMaterialsText: 'Here you can book materials directly to the time entry – they appear in project billing and can easily be included in invoices.',
  tourManualTitle: 'Manual entry',
  tourManualText: 'Enter times retroactively here – with start/end time, project, and note.',
  tourPendingTitle: 'Pending approvals',
  tourPendingText: 'As a manager you see entries from your employees that are waiting for approval.',
  tourMatPendingTitle: 'Material bookings',
  tourMatPendingText: 'Material bookings from your employees\' time entries that still need approval – approve or reject directly.',
  tourEntriesTitle: 'My entries',
  tourEntriesText: 'All your booked time entries from recent days – with status, project and net duration.',
  startTime: 'Start time',
  endTime: 'End time',
  pendingApprovals: 'Pending approvals',
  approve: 'Approve',
  reject: 'Reject',
  pendingMaterialBookings: 'Pending material bookings',
  material: 'Material',
  rejectMaterialBooking: 'Reject material booking',
  latestEntries: 'Latest entries',
  noEntries: 'No entries',
  noEntriesHint: 'No time entries yet.',
  time: 'Time',
  reason: 'Reason',
  discardCapturedEntryConfirm: 'The recorded time entry will be permanently discarded. Do you really want to cancel?',
  deleteEntryConfirm: 'Delete entry?',
  regieHours: 'Regie hours',
  regieTag: 'Regie',
  regieSignNow: 'Sign now',
  regieSignLater: 'Collect signature later',
  regieSignLaterHint: 'The entry is saved as regie hours. The customer signature will be collected later, together with other entries, via the daily sign-off.',
  signatureTitle: 'Capture signature',
  signatureHint: 'Please sign in the field to store this regie entry with proof.',
  signatureMobileHint: 'Landscape orientation works best on phones.',
  signatureCapture: 'Capture signature',
  signatureReplace: 'Replace signature',
  signatureRequired: 'Signature required',
  signerName: 'Name of the signing person',
  signerNamePlaceholder: 'Enter name',
  signerNameRequired: 'Name of the signing person is required',
  signatureAvailable: 'Signature available',
  signatureClear: 'Clear',
  signatureApply: 'Apply signature',
  signatureFullscreenEnter: 'Fullscreen',
  signatureFullscreenExit: 'Exit fullscreen',
  regiePdf: 'Regie PDF',
  regiePdfError: 'Could not open regie PDF',
  loading: 'Loading',
  foremanSignoff: 'Daily foreman sign-off',
  foremanSignoffHint: 'Combine all employees\' regie hours for one day on this site and have the customer sign off once.',
  foremanProject: 'Project',
  foremanDate: 'Date',
  foremanSigned: 'Signature',
  foremanAlreadySigned: 'Already signed',
  foremanNoEntries: 'No regie hours found for this day.',
  foremanSignButton: 'Sign off day',
  foremanSignSuccess: 'Day signed off successfully',
  tourForemanTitle: 'Foreman daily sign-off',
  tourForemanText: 'As foreman you can combine all employees\' regie hours for a day on your site here and have the customer sign once for all of them.'
};

const timeFr = {
  title: 'Suivi du temps',
  infoText: 'Ici, vous enregistrez vos heures de travail – via le chronomètre ou manuellement.',
  infoItem1: 'Démarrer, mettre en pause et arrêter le chronomètre – le temps est calculé automatiquement',
  infoItem2: 'Saisir des heures manuellement, par exemple pour des entrées oubliées',
  infoItem3: 'Enregistrer des heures en régie avec signature et exporter en PDF',
  infoItem4: 'Les autorisations en attente concernant les réservations de temps et de matériel peuvent être consultées et modifiées ici',
  subtitle: 'Saisir et gerer les temps',
  start: 'Demarrer',
  pause: 'Pause',
  resume: 'Reprendre',
  stop: 'Arreter',
  saveEntry: 'Enregistrer entree',
  startLabel: 'Debut',
  endLabel: 'Fin',
  minutes: 'Min',
  net: 'Net',
  project: 'Projet',
  chooseProject: 'Veuillez choisir un projet',
  note: 'Note',
  cancel: 'Annuler',
  save: 'Enregistrer',
  running: 'En cours',
  paused: 'En pause',
  ready: 'Pret',
  enterNote: 'Veuillez saisir une note',
  entrySaved: 'Entree enregistree',
  error: 'Erreur',
  startRequired: 'Heure de debut requise',
  endRequired: 'Heure de fin requise',
  noteRequired: 'Note requise',
  submittedForApproval: 'Entree soumise pour approbation',
  notePlaceholder: 'Qu\'est-ce qui a ete fait ?',
  rejectEntry: 'Rejeter entree',
  reasonOptional: 'Motif (optionnel)',
  rejectPlaceholder: 'Note optionnelle pour l\'employe',
  rebook: 'Reimputer',
  rebookSuccess: 'Entree reimputee avec succes',
  rebookError: 'Echec de la reimputation',
  manualEntry: 'Saisie manuelle',
  startTour: 'Lancer la visite guidée',
  tourTimerTitle: 'Minuterie',
  tourTimerText: 'Démarrez le minuteur quand vous commencez, mettez en pause si besoin, arrêtez à la fin. Projet et note vous seront demandés.',
  tourStopModalTitle: 'Enregistrer la saisie',
  tourStopModalText: 'Après l\'arrêt vous voyez un résumé. Choisissez le projet, écrivez une note – puis enregistrez ou annulez.',
  tourMaterialsTitle: 'Ajouter du matériel',
  tourMaterialsText: 'Ici vous pouvez réserver du matériel directement sur la saisie de temps – il apparaît dans la facturation du projet et peut être facilement inclus dans les factures.',
  tourManualTitle: 'Saisie manuelle',
  tourManualText: 'Saisissez des heures rétroactivement ici – avec heure de début/fin, projet et note.',
  tourPendingTitle: 'Approbations en attente',
  tourPendingText: 'En tant que manager, vous voyez les entrées de vos employés en attente de validation.',
  tourMatPendingTitle: 'Réservations de matériel',
  tourMatPendingText: 'Réservations de matériel issues des saisies de temps de vos employés en attente d\'approbation – approuvez ou refusez directement.',
  tourEntriesTitle: 'Mes entrées',
  tourEntriesText: 'Toutes vos saisies de temps récentes – avec statut, projet et durée nette.',
  startTime: 'Heure de debut',
  endTime: 'Heure de fin',
  pendingApprovals: 'Approbations en attente',
  approve: 'Approuver',
  reject: 'Rejeter',
  pendingMaterialBookings: 'Reservations materiel en attente',
  material: 'Materiel',
  rejectMaterialBooking: 'Rejeter reservation materiel',
  latestEntries: 'Dernieres entrees',
  noEntries: 'Aucune entree',
  noEntriesHint: 'Aucune saisie de temps pour le moment.',
  time: 'Temps',
  reason: 'Motif',
  discardCapturedEntryConfirm: 'Le temps saisi sera supprime definitivement. Voulez-vous vraiment annuler ?',
  deleteEntryConfirm: 'Supprimer l\'entree ?',
  regieHours: 'Heures en regie',
  regieTag: 'Regie',
  regieSignNow: 'Faire signer maintenant',
  regieSignLater: 'Faire signer plus tard (collecte groupee)',
  regieSignLaterHint: 'L\'entree est enregistree comme heures en regie. La signature du client sera recueillie plus tard, groupee avec d\'autres entrees, via la validation journaliere.',
  signatureTitle: 'Capturer la signature',
  signatureHint: 'Veuillez signer dans le champ pour enregistrer cette entree de regie avec preuve.',
  signatureMobileHint: 'Le mode paysage fonctionne mieux sur smartphone.',
  signatureCapture: 'Capturer la signature',
  signatureReplace: 'Remplacer la signature',
  signatureRequired: 'Signature requise',
  signerName: 'Nom de la personne signataire',
  signerNamePlaceholder: 'Saisir le nom',
  signerNameRequired: 'Le nom de la personne signataire est requis',
  signatureAvailable: 'Signature disponible',
  signatureClear: 'Effacer',
  signatureApply: 'Valider la signature',
  signatureFullscreenEnter: 'Plein ecran',
  signatureFullscreenExit: 'Quitter plein ecran',
  regiePdf: 'PDF regie',
  regiePdfError: 'Impossible d\'ouvrir le PDF regie',
  loading: 'Chargement',
  foremanSignoff: 'Validation journaliere du chef d\'equipe',
  foremanSignoffHint: 'Regroupez les heures en regie de tous les employes pour une journee sur ce chantier et faites signer le client une seule fois.',
  foremanProject: 'Projet',
  foremanDate: 'Date',
  foremanSigned: 'Signature',
  foremanAlreadySigned: 'Deja signe',
  foremanNoEntries: 'Aucune heure en regie trouvee pour cette journee.',
  foremanSignButton: 'Valider la journee',
  foremanSignSuccess: 'Journee validee avec succes',
  tourForemanTitle: 'Validation journaliere du chef d\'equipe',
  tourForemanText: 'En tant que chef d\'equipe, vous pouvez ici regrouper les heures en regie de tous les employes pour une journee sur votre chantier et faire signer le client une seule fois.'
};

const timeIt = {
  title: 'Rilevazione ore',
  infoText: 'Qui registri le tue ore di lavoro – tramite timer o manualmente.',
  infoItem1: 'Avvia, metti in pausa e ferma il timer – il tempo viene calcolato automaticamente',
  infoItem2: 'Inserire ore manualmente, ad esempio per voci dimenticate',
  infoItem3: 'Registrare ore in regia con firma ed esportare come PDF',
  infoItem4: 'Qui è possibile visualizzare e modificare le autorizzazioni in sospeso relative alle prenotazioni di orari e materiali',
  subtitle: 'Registra e gestisci i tempi',
  start: 'Avvia',
  pause: 'Pausa',
  resume: 'Riprendi',
  stop: 'Termina',
  saveEntry: 'Salva registrazione',
  startLabel: 'Inizio',
  endLabel: 'Fine',
  minutes: 'Min',
  net: 'Netto',
  project: 'Progetto',
  chooseProject: 'Seleziona un progetto',
  note: 'Nota',
  cancel: 'Annulla',
  save: 'Salva',
  running: 'In corso',
  paused: 'In pausa',
  ready: 'Pronto',
  enterNote: 'Inserisci una nota',
  entrySaved: 'Registrazione salvata',
  error: 'Errore',
  startRequired: 'Ora di inizio obbligatoria',
  endRequired: 'Ora di fine obbligatoria',
  noteRequired: 'Nota obbligatoria',
  submittedForApproval: 'Registrazione inviata per approvazione',
  notePlaceholder: 'Cosa e stato fatto?',
  rejectEntry: 'Rifiuta registrazione',
  reasonOptional: 'Motivo (opzionale)',
  rejectPlaceholder: 'Nota opzionale per il dipendente',
  rebook: 'Riassegna',
  rebookSuccess: 'Voce riassegnata con successo',
  rebookError: 'Riassegnazione fallita',
  manualEntry: 'Inserimento manuale',
  startTour: 'Avvia la guida',
  tourTimerTitle: 'Timer',
  tourTimerText: 'Avvia il timer quando inizi a lavorare, metti in pausa se necessario, fermalo alla fine. Ti verrà chiesto progetto e nota.',
  tourStopModalTitle: 'Salva voce',
  tourStopModalText: 'Dopo lo stop vedi un riepilogo. Scegli il progetto, scrivi una nota – poi salva o annulla.',
  tourMaterialsTitle: 'Aggiungere materiale',
  tourMaterialsText: 'Qui puoi prenotare materiali direttamente sulla voce di tempo – appaiono nella fatturazione del progetto e si includono facilmente nelle fatture.',
  tourManualTitle: 'Inserimento manuale',
  tourManualText: 'Inserisci ore retroattivamente qui – con orario inizio/fine, progetto e nota.',
  tourPendingTitle: 'Approvazioni in attesa',
  tourPendingText: 'Come manager vedi le voci dei tuoi dipendenti in attesa di approvazione.',
  tourMatPendingTitle: 'Prenotazioni materiali',
  tourMatPendingText: 'Prenotazioni di materiali dai registri dei tuoi dipendenti in attesa di approvazione – approva o rifiuta direttamente.',
  tourEntriesTitle: 'Le mie voci',
  tourEntriesText: 'Tutte le tue ore registrate di recente – con stato, progetto e durata netta.',
  startTime: 'Ora di inizio',
  endTime: 'Ora di fine',
  pendingApprovals: 'Approvazioni in sospeso',
  approve: 'Approva',
  reject: 'Rifiuta',
  pendingMaterialBookings: 'Prenotazioni materiale in sospeso',
  material: 'Materiale',
  rejectMaterialBooking: 'Rifiuta prenotazione materiale',
  latestEntries: 'Ultime registrazioni',
  noEntries: 'Nessuna registrazione',
  noEntriesHint: 'Nessuna registrazione ore presente.',
  time: 'Tempo',
  reason: 'Motivo',
  discardCapturedEntryConfirm: 'Il tempo registrato verra eliminato definitivamente. Vuoi davvero annullare?',
  deleteEntryConfirm: 'Eliminare registrazione?',
  regieHours: 'Ore in regia',
  regieTag: 'Regia',
  regieSignNow: 'Firma subito',
  regieSignLater: 'Fai firmare piu tardi (raccolta collettiva)',
  regieSignLaterHint: 'La voce viene salvata come ore in regia. La firma del cliente verra raccolta piu tardi, insieme ad altre voci, tramite la convalida giornaliera.',
  signatureTitle: 'Acquisisci firma',
  signatureHint: 'Firma nel riquadro per salvare la registrazione in regia con prova.',
  signatureMobileHint: 'Su smartphone funziona meglio in orizzontale.',
  signatureCapture: 'Acquisisci firma',
  signatureReplace: 'Sostituisci firma',
  signatureRequired: 'Firma obbligatoria',
  signerName: 'Nome della persona firmataria',
  signerNamePlaceholder: 'Inserisci nome',
  signerNameRequired: 'Nome della persona firmataria obbligatorio',
  signatureAvailable: 'Firma disponibile',
  signatureClear: 'Cancella',
  signatureApply: 'Conferma firma',
  signatureFullscreenEnter: 'Schermo intero',
  signatureFullscreenExit: 'Esci da schermo intero',
  regiePdf: 'PDF regia',
  regiePdfError: 'Impossibile aprire il PDF regia',
  loading: 'Caricamento',
  foremanSignoff: 'Validazione giornaliera del caposquadra',
  foremanSignoffHint: 'Raggruppa le ore in regia di tutti i dipendenti per un giorno su questo cantiere e fai firmare il cliente una sola volta.',
  foremanProject: 'Progetto',
  foremanDate: 'Data',
  foremanSigned: 'Firma',
  foremanAlreadySigned: 'Gia firmato',
  foremanNoEntries: 'Nessuna ora in regia trovata per questo giorno.',
  foremanSignButton: 'Convalida giornata',
  foremanSignSuccess: 'Giornata convalidata con successo',
  tourForemanTitle: 'Validazione giornaliera del caposquadra',
  tourForemanText: 'Come caposquadra puoi raggruppare qui le ore in regia di tutti i dipendenti per un giorno sul tuo cantiere e far firmare il cliente una sola volta.'
};

const timePl = {
  title: 'Ewidencja czasu',
  infoText: 'Tutaj rejestrujesz swój czas pracy – za pomocą timera lub ręcznie.',
  infoItem1: 'Uruchamiaj, wstrzymuj i zatrzymuj timer – czas jest obliczany automatycznie',
  infoItem2: 'Ręczne dodawanie wpisów, np. dla zapomnianych godzin',
  infoItem3: 'Rejestrowanie godzin rozliczeniowych z podpisem i eksport do PDF',
  infoItem4: 'W tym miejscu można przeglądać i edytować oczekujące zatwierdzenia dotyczące rezerwacji czasu i materiałów',
  subtitle: 'Rejestruj i zarzadzaj czasem',
  start: 'Start',
  pause: 'Pauza',
  resume: 'Wznow',
  stop: 'Zakoncz',
  saveEntry: 'Zapisz wpis',
  startLabel: 'Start',
  endLabel: 'Koniec',
  minutes: 'Min',
  net: 'Netto',
  project: 'Projekt',
  chooseProject: 'Wybierz projekt',
  note: 'Notatka',
  cancel: 'Anuluj',
  save: 'Zapisz',
  running: 'W trakcie',
  paused: 'Wstrzymano',
  ready: 'Gotowe',
  enterNote: 'Wpisz notatke',
  entrySaved: 'Wpis zapisany',
  error: 'Blad',
  startRequired: 'Godzina startu wymagana',
  endRequired: 'Godzina konca wymagana',
  noteRequired: 'Notatka wymagana',
  submittedForApproval: 'Wpis przeslany do zatwierdzenia',
  notePlaceholder: 'Co zostalo wykonane?',
  rejectEntry: 'Odrzuc wpis',
  reasonOptional: 'Powod (opcjonalnie)',
  rejectPlaceholder: 'Opcjonalna notatka dla pracownika',
  rebook: 'Przeksiegowanie',
  rebookSuccess: 'Wpis pomyslnie przeksiegowany',
  rebookError: 'Przeksiegowanie nie powiodlo sie',
  manualEntry: 'Wpis reczny',
  startTour: 'Uruchom przewodnik',
  tourTimerTitle: 'Stoper',
  tourTimerText: 'Uruchom stoper gdy zaczynasz pracę, wstrzymaj w razie potrzeby, zatrzymaj na końcu. Zostaniesz zapytany o projekt i notatkę.',
  tourStopModalTitle: 'Zapisz wpis',
  tourStopModalText: 'Po zatrzymaniu widzisz podsumowanie. Wybierz projekt, napisz notatkę – a następnie zapisz lub anuluj.',
  tourMaterialsTitle: 'Dodaj materiał',
  tourMaterialsText: 'Tu możesz rezerwować materiały bezpośrednio do wpisu czasu – pojawiają się w rozliczeniu projektu i łatwo trafiają do faktur.',
  tourManualTitle: 'Wpis ręczny',
  tourManualText: 'Tu możesz wprowadzić godziny retrospektywnie – z godziną początku/końca, projektem i notatką.',
  tourPendingTitle: 'Oczekujące zatwierdzenia',
  tourPendingText: 'Jako manager widzisz tu wpisy pracowników oczekujące na zatwierdzenie.',
  tourMatPendingTitle: 'Rezerwacje materiałów',
  tourMatPendingText: 'Rezerwacje materiałów z wpisów czasu pracowników oczekujące na zatwierdzenie – zatwierdź lub odrzuć bezpośrednio.',
  tourEntriesTitle: 'Moje wpisy',
  tourEntriesText: 'Wszystkie Twoje ostatnio zarejestrowane godziny – ze statusem, projektem i czasem netto.',
  startTime: 'Godzina startu',
  endTime: 'Godzina konca',
  pendingApprovals: 'Oczekujace zatwierdzenia',
  approve: 'Zatwierdz',
  reject: 'Odrzuc',
  pendingMaterialBookings: 'Oczekujace rezerwacje materialu',
  material: 'Material',
  rejectMaterialBooking: 'Odrzuc rezerwacje materialu',
  latestEntries: 'Ostatnie wpisy',
  noEntries: 'Brak wpisow',
  noEntriesHint: 'Brak wpisow czasu.',
  time: 'Czas',
  reason: 'Powod',
  discardCapturedEntryConfirm: 'Zarejestrowany czas zostanie trwale odrzucony. Czy na pewno anulowac?',
  deleteEntryConfirm: 'Usunac wpis?',
  regieHours: 'Godziny regie',
  regieTag: 'Regie',
  regieSignNow: 'Podpisz teraz',
  regieSignLater: 'Podpis zbiorczy pozniej',
  regieSignLaterHint: 'Wpis zostanie zapisany jako godziny w trybie regie. Podpis klienta zostanie zebrany pozniej, razem z innymi wpisami, w ramach dziennej akceptacji.',
  signatureTitle: 'Zarejestruj podpis',
  signatureHint: 'Podpisz w polu, aby zapisac wpis regie z potwierdzeniem.',
  signatureMobileHint: 'Na telefonie najlepiej dziala w orientacji poziomej.',
  signatureCapture: 'Zarejestruj podpis',
  signatureReplace: 'Zmien podpis',
  signatureRequired: 'Podpis wymagany',
  signerName: 'Imie i nazwisko osoby podpisujacej',
  signerNamePlaceholder: 'Wpisz imie i nazwisko',
  signerNameRequired: 'Imie i nazwisko osoby podpisujacej jest wymagane',
  signatureAvailable: 'Podpis zapisany',
  signatureClear: 'Wyczysc',
  signatureApply: 'Zatwierdz podpis',
  signatureFullscreenEnter: 'Pelny ekran',
  signatureFullscreenExit: 'Zamknij pelny ekran',
  regiePdf: 'PDF regie',
  regiePdfError: 'Nie mozna otworzyc PDF regie',
  loading: 'Wczytywanie',
  foremanSignoff: 'Dzienna akceptacja brygadzisty',
  foremanSignoffHint: 'Zbierz godziny w trybie regie wszystkich pracownikow za jeden dzien na tej budowie i daj klientowi podpisac tylko raz.',
  foremanProject: 'Projekt',
  foremanDate: 'Data',
  foremanSigned: 'Podpis',
  foremanAlreadySigned: 'Juz podpisano',
  foremanNoEntries: 'Nie znaleziono godzin w trybie regie dla tego dnia.',
  foremanSignButton: 'Zatwierdz dzien',
  foremanSignSuccess: 'Dzien zatwierdzony',
  tourForemanTitle: 'Dzienna akceptacja brygadzisty',
  tourForemanText: 'Jako brygadzista mozesz tutaj zebrac godziny w trybie regie wszystkich pracownikow za jeden dzien na swojej budowie i dac klientowi podpisac tylko raz.'
};

const timeCs = {
  title: 'Evidence casu',
  infoText: 'Zde zaznamenáváte svou pracovní dobu – pomocí časovače nebo ručně.',
  infoItem1: 'Spustit, pozastavit a zastavit časovač – čas se vypočítá automaticky',
  infoItem2: 'Ruční zadávání záznamů, např. pro zapomenuté položky',
  infoItem3: 'Zaznamenávat hodiny s podpisem a exportovat jako PDF',
  infoItem4: 'Zde lze zobrazit a upravit nevyřízené schválení rezervací termínů a materiálu',
  subtitle: 'Zaznamenavejte a spravujte cas',
  start: 'Start',
  pause: 'Pauza',
  resume: 'Pokracovat',
  stop: 'Ukoncit',
  saveEntry: 'Ulozit zaznam',
  startLabel: 'Zacatek',
  endLabel: 'Konec',
  minutes: 'Min',
  net: 'Netto',
  project: 'Projekt',
  chooseProject: 'Vyberte projekt',
  note: 'Poznamka',
  cancel: 'Zrusit',
  save: 'Ulozit',
  running: 'Bezi',
  paused: 'Pozastaveno',
  ready: 'Pripraveno',
  enterNote: 'Zadejte poznamku',
  entrySaved: 'Zaznam ulozen',
  error: 'Chyba',
  startRequired: 'Cas startu je povinny',
  endRequired: 'Cas konce je povinny',
  noteRequired: 'Poznamka je povinna',
  submittedForApproval: 'Zaznam odeslan ke schvaleni',
  notePlaceholder: 'Co bylo provedeno?',
  rejectEntry: 'Odmitnout zaznam',
  reasonOptional: 'Duvod (volitelne)',
  rejectPlaceholder: 'Volitelna poznamka pro zamestnance',
  rebook: 'Prevest',
  rebookSuccess: 'Zaznam uspesne preveden',
  rebookError: 'Prevedeni se nezdarilo',
  manualEntry: 'Rucni zadani',
  startTour: 'Spustit průvodce',
  tourTimerTitle: 'Časomíra',
  tourTimerText: 'Spusťte časomíru když začínáte pracovat, pozastavte dle potřeby, zastavte na konci. Budete dotázáni na projekt a poznámku.',
  tourStopModalTitle: 'Uložit záznam',
  tourStopModalText: 'Po zastavení vidíte přehled. Vyberte projekt, napište poznámku – pak uložte nebo zrušte.',
  tourMaterialsTitle: 'Přidat materiál',
  tourMaterialsText: 'Zde lze rezervovat materiál přímo k záznamu času – zobrazí se ve fakturaci projektu a snadno se zahrne do faktur.',
  tourManualTitle: 'Ruční zadání',
  tourManualText: 'Zde zadávejte hodiny zpětně – s časem začátku/konce, projektem a poznámkou.',
  tourPendingTitle: 'Čekající schválení',
  tourPendingText: 'Jako manažer vidíte záznamy zaměstnanců čekající na schválení.',
  tourMatPendingTitle: 'Rezervace materiálu',
  tourMatPendingText: 'Rezervace materiálu ze záznamů zaměstnanců čekající na schválení – schvalte nebo zamítněte přímo.',
  tourEntriesTitle: 'Moje záznamy',
  tourEntriesText: 'Všechny vaše nedávno zaznamenané hodiny – se stavem, projektem a čistou dobou.',
  startTime: 'Cas startu',
  endTime: 'Cas konce',
  pendingApprovals: 'Cekajici schvaleni',
  approve: 'Schvalit',
  reject: 'Odmitnout',
  pendingMaterialBookings: 'Cekajici rezervace materialu',
  material: 'Material',
  rejectMaterialBooking: 'Odmitnout rezervaci materialu',
  latestEntries: 'Posledni zaznamy',
  noEntries: 'Zadne zaznamy',
  noEntriesHint: 'Zatim nejsou zadne zaznamy casu.',
  time: 'Cas',
  reason: 'Duvod',
  discardCapturedEntryConfirm: 'Zaznamenany cas bude trvale odstranen. Opravdu chcete zrusit?',
  deleteEntryConfirm: 'Smazat zaznam?',
  regieHours: 'Rezijni hodiny',
  regieTag: 'Rezie',
  regieSignNow: 'Podepsat ihned',
  regieSignLater: 'Podpis ziskat pozdeji hromadne',
  regieSignLaterHint: 'Zaznam se ulozi jako rezijni hodiny. Podpis klienta bude ziskan pozdeji, spolecne s dalsimi zaznamy, v ramci denniho schvaleni.',
  signatureTitle: 'Zachytit podpis',
  signatureHint: 'Podepiste se do pole, aby byl rezijni zaznam ulozen s dukazem.',
  signatureMobileHint: 'Na telefonu funguje nejlepe orientace na sirku.',
  signatureCapture: 'Zachytit podpis',
  signatureReplace: 'Nahradit podpis',
  signatureRequired: 'Podpis je povinny',
  signerName: 'Jmeno podepisujici osoby',
  signerNamePlaceholder: 'Zadejte jmeno',
  signerNameRequired: 'Jmeno podepisujici osoby je povinne',
  signatureAvailable: 'Podpis ulozen',
  signatureClear: 'Vymazat',
  signatureApply: 'Potvrdit podpis',
  signatureFullscreenEnter: 'Cela obrazovka',
  signatureFullscreenExit: 'Ukoncit celou obrazovku',
  regiePdf: 'Rezie PDF',
  regiePdfError: 'Nepodarilo se otevrit PDF rezie',
  loading: 'Nahravam',
  foremanSignoff: 'Denni schvaleni predaka',
  foremanSignoffHint: 'Shrnte rezijni hodiny vsech zamestnancu za jeden den na teto stavbe a necho klienta podepsat jen jednou.',
  foremanProject: 'Projekt',
  foremanDate: 'Datum',
  foremanSigned: 'Podpis',
  foremanAlreadySigned: 'Uz podepsano',
  foremanNoEntries: 'Pro tento den nebyly nalezeny zadne rezijni hodiny.',
  foremanSignButton: 'Schvalit den',
  foremanSignSuccess: 'Den byl uspesne schvalen',
  tourForemanTitle: 'Denni schvaleni predaka',
  tourForemanText: 'Jako predak muzes zde shrnout rezijni hodiny vsech zamestnancu za jeden den na tve stavbe a necho klienta podepsat jen jednou.'
};

const mediaDe = {
  title: 'Medienablage',
  infoText: "Diese Ansicht zeigt die Einsatz- und Terminplanung in einer Wochenübersicht. Du kannst zwischen Gesamt- und Projektansicht wechseln, Termine per Drag & Drop planen und Mitarbeiter direkt zuweisen.",
  infoText: 'Diese Ansicht zeigt deine hochgeladenen Dateien. Hier kannst du Dateien verwalten, z.B. Fotos, Baupläne, Lieferscheine oder Bestellungen.',
  infoItem1: 'Die Dateien sind nach interner Ablage und projektbezogenen Dateien sortiert',
  infoItem2: 'Du kannst jederzeit zwischen beiden Ansichten wechseln, um entweder projektbezogene Dateien oder interne Dokumente ohne Projektzuordnung zu sehen',
  infoItem3: 'Du kannst alle Dateien aller Mitarbeiter sehen, bearbeiten und löschen',
  infoItem4: 'Du kannst ein Projekt auswählen und siehst deine hochgeladenen Dateien',
  infoItem5: 'Du kannst nur deine Dateien sehen, bearbeiten und löschen',
  internalSubtitle: 'Interne Unterlagen ohne Projektzuordnung',
  allUploads: 'Alle Uploads aller Mitarbeiter',
  yourUploads: 'Deine hochgeladenen Dateien',
  projectScoped: 'Projektbezogen',
  projectScopedHint: 'Für Baustellen, Fotos und Plaene mit direktem Projektbezug',
  internalStorage: 'Interne Ablage',
  internalStorageHint: 'Für Lieferscheine, Bestellungen und Bestaetigungen ohne Projekt',
  selectProject: 'Projekt auswählen',
  all: 'Alle',
  uploadFiles: 'Dateien hochladen',
  prepareFiles: 'Datei(en) vorbereiten',
  cancel: 'Abbrechen',
  name: 'Name',
  description: 'Beschreibung',
  optional: 'optional',
  upload: 'Hochladen',
  open: 'Öffnen',
  download: 'Herunterladen',
  delete: 'Löschen',
  uploadFirstFiles: 'Lade die ersten Dateien hoch',
  selectProjectFirst: 'Wählen Sie ein Projekt aus',
  orSwitchInternal: 'oder wechseln Sie oben in die interne Ablage',
  uploadHintDesktopInternal: 'Dateien hierher ziehen oder klicken, um interne Dateien hochzuladen',
  uploadHintDesktop: 'Dateien hierher ziehen oder klicken, um projektbezogene Dateien hochzuladen',
  uploadHintMobileInternal: 'Tippen, um interne Dateien auszuwählen',
  uploadHintMobile: 'Tippen, um Projektdateien auszuwählen',
  noInternalFiles: 'Keine Dateien in der internen Ablage',
  noFiles: 'Keine Dateien gefunden',
  uploadTitlePlaceholder: 'z.B. Fundamentarbeiten Tag 1',
  uploadDescriptionPlaceholder: 'Kurze Beschreibung zur Datei',
  createSubfolder: 'Unterordner erstellen',
  manageSubfolders: 'Unterordner verwalten',
  allSubfolders: 'Alle Unterordner',
  noSubfolder: 'Kein Unterordner',
  newSubfolderPlaceholder: 'z.B. KW-14',
  addSubfolder: 'Unterordner anlegen',
  renameSubfolder: 'Umbenennen',
  deleteSubfolder: 'Löschen',
  deleteSubfolderConfirm: 'Unterordner "{name}" wirklich löschen?',
  subfolderNameInvalid: 'Bitte einen gültigen Unterordnernamen eingeben',
  subfolderCreateFailed: 'Unterordner konnte nicht erstellt werden',
  subfolderRenameFailed: 'Unterordner konnte nicht umbenannt werden',
  subfolderDeleteFailed: 'Unterordner konnte nicht gelöscht werden',
  deleteConfirm: 'Datei wirklich löschen?',
  uploadFailed: 'Upload fehlgeschlagen',
  storageQuotaExceeded: 'Speicherlimit erreicht. Im Trial-Plan sind maximal 5 GB verfügbar. Bitte upgraden Sie auf den Pro-Plan.',
  storageQuotaExceededPro: 'Speicherlimit erreicht. Sie können das Limit in der Kontoverwaltung hochstufen. Falls Sie nicht weiterkommen, wenden Sie sich gerne an den Support.',
  deleteNamedConfirm: '"{name}" wirklich löschen?',
  offlineQueued: 'Offline gespeichert. Upload wird automatisch synchronisiert.',
  offlineUnavailable: 'Offline-Speicherung nicht verfügbar. Bitte Verbindung herstellen und erneut versuchen.',
  offlineMode: 'Offline-Modus aktiv. Uploads werden lokal gespeichert und bei Verbindung automatisch hochgeladen.',
  startTour: 'Führung starten',
  tourScopeTitle: 'Bereich wählen',
  tourScopeText: 'Wechsle zwischen projektbezogenen Medien und internen Unterlagen, die keinem Projekt zugeordnet sind.',
  tourProjectTitle: 'Projekt auswählen',
  tourProjectText: 'Wähle das Projekt, dessen Medien du anzeigen oder hochladen möchtest.',
  tourFoldersTitle: 'Ordner',
  tourFoldersText: 'Fotos, Baupläne, Rechnungen, Verträge, Chat-Bilder und mehr – alles strukturiert in Ordnern.',
  tourSubfoldersTitle: 'Unterordner',
  tourSubfoldersText: 'Lege innerhalb eines Ordners Unterordner an – z.B. „Rohbau" unter Fotos – um Dateien noch feiner zu strukturieren.',
  tourUploadTitle: 'Dateien hochladen',
  tourUploadText: 'Klick oder Drag & Drop um Bilder, PDFs und Dokumente hochzuladen. Im Offline-Modus werden sie lokal gespeichert und automatisch synchronisiert.',
  tourGridTitle: 'Datei-Übersicht',
  tourGridText: 'Alle hochgeladenen Dateien auf einen Blick. Klick auf eine Datei zum Öffnen oder Vergrößern.',
  tourGridTextManager: 'Alle Dateien auf einen Blick. Als Manager kannst du jede Datei löschen – unabhängig wer sie hochgeladen hat.',
  tourGridTextEmployee: 'Deine hochgeladenen Dateien. Du siehst nur deine eigenen Uploads und kannst nur diese löschen.',
  tourInternalTitle: 'Interne Ablage',
  tourInternalText: 'Hier kannst du Dokumente ablegen, die keinem Projekt zugeordnet sind – z.B. allgemeine Vorlagen, Verträge oder interne Unterlagen.',
  pendingSync: 'Upload(s) warten auf Synchronisierung.',
  fileCount: 'Datei(en)',
  folders: {
    fotos: 'Fotos',
    bauplaene: 'Bauplaene',
    order: 'Bestellungen',
    delivery_note: 'Lieferscheine',
    rechnungen: 'Rechnungen',
    vertraege: 'Verträge',
    sonstiges: 'Sonstiges'
  }
};

const mediaEn = {
  title: 'Media storage',
  infoText: 'This view shows your uploaded files. Here you can manage files such as photos, blueprints, delivery notes, or purchase orders.',
  infoItem1: 'The files are sorted by internal storage location and project-related files',
  infoItem2: 'You can switch between the two views at any time to view either project-related files or internal documents without a project assignment',
  infoItem3: 'You can view, edit, and delete all files belonging to all employees',
  infoItem4: 'You can select a project and view your uploaded files',
  infoItem5: 'You can only view, edit, and delete your own files',
  internalSubtitle: 'Internal files without project assignment',
  allUploads: 'All uploads from all employees',
  yourUploads: 'Your uploaded files',
  projectScoped: 'Project based',
  projectScopedHint: 'For site files, photos and plans linked to projects',
  internalStorage: 'Internal storage',
  internalStorageHint: 'For delivery notes, orders and confirmations without project',
  selectProject: 'Select project',
  all: 'All',
  uploadFiles: 'Upload files',
  prepareFiles: 'file(s) to prepare',
  cancel: 'Cancel',
  name: 'Name',
  description: 'Description',
  optional: 'optional',
  upload: 'Upload',
  open: 'Open',
  download: 'Download',
  delete: 'Delete',
  uploadFirstFiles: 'Upload your first files',
  selectProjectFirst: 'Select a project',
  orSwitchInternal: 'or switch to internal storage above',
  uploadHintDesktopInternal: 'Drag files here or click to upload internal files',
  uploadHintDesktop: 'Drag files here or click to upload project files',
  uploadHintMobileInternal: 'Tap to choose internal files',
  uploadHintMobile: 'Tap to choose project files',
  noInternalFiles: 'No files in internal storage',
  noFiles: 'No files found',
  uploadTitlePlaceholder: 'e.g. Foundation work day 1',
  uploadDescriptionPlaceholder: 'Short file description',
  createSubfolder: 'Create subfolder',
  manageSubfolders: 'Manage subfolders',
  allSubfolders: 'All subfolders',
  noSubfolder: 'No subfolder',
  newSubfolderPlaceholder: 'e.g. CW-14',
  addSubfolder: 'Add subfolder',
  renameSubfolder: 'Rename',
  deleteSubfolder: 'Delete',
  deleteSubfolderConfirm: 'Delete subfolder "{name}"?',
  subfolderNameInvalid: 'Please enter a valid subfolder name',
  subfolderCreateFailed: 'Could not create subfolder',
  subfolderRenameFailed: 'Could not rename subfolder',
  subfolderDeleteFailed: 'Could not delete subfolder',
  deleteConfirm: 'Delete file?',
  uploadFailed: 'Upload failed',
  storageQuotaExceeded: 'Storage limit reached. The trial plan allows a maximum of 5 GB. Please upgrade to the Pro plan.',
  storageQuotaExceededPro: 'Storage limit reached. You can upgrade your limit in account management. If you need help, feel free to contact support.',
  deleteNamedConfirm: 'Really delete "{name}"?',
  offlineQueued: 'Saved offline. The upload will be synchronized automatically.',
  offlineUnavailable: 'Offline storage is not available. Please reconnect and try again.',
  offlineMode: 'Offline mode active. Uploads are stored locally and synced automatically when reconnected.',
  startTour: 'Start tour',
  tourScopeTitle: 'Choose scope',
  tourScopeText: 'Switch between project-related media and internal files not assigned to a project.',
  tourProjectTitle: 'Select project',
  tourProjectText: 'Choose the project whose media you want to view or upload.',
  tourFoldersTitle: 'Folders',
  tourFoldersText: 'Photos, plans, invoices, contracts, chat images and more – all structured in folders.',
  tourSubfoldersTitle: 'Subfolders',
  tourSubfoldersText: 'Create subfolders within a folder – e.g. "Shell construction" under Photos – for even finer organisation.',
  tourUploadTitle: 'Upload files',
  tourUploadText: 'Click or drag & drop to upload images, PDFs and documents. In offline mode they are saved locally and synced automatically.',
  tourGridTitle: 'File overview',
  tourGridText: 'All uploaded files at a glance. Click a file to open or enlarge it.',
  tourGridTextManager: 'All files at a glance. As a manager you can delete any file – regardless of who uploaded it.',
  tourGridTextEmployee: 'Your uploaded files. You can only see and delete your own uploads.',
  tourInternalTitle: 'Internal storage',
  tourInternalText: 'Here you can store documents not assigned to any project – e.g. general templates, contracts, or internal files.',
  pendingSync: 'upload(s) waiting for sync.',
  fileCount: 'file(s)',
  folders: {
    fotos: 'Photos',
    bauplaene: 'Plans',
    order: 'Orders',
    delivery_note: 'Delivery notes',
    rechnungen: 'Invoices',
    vertraege: 'Contracts',
    sonstiges: 'Other'
  }
};

const mediaFr = {
  title: 'Mediatheque',
  infoText : 'Cet affichage présente les fichiers que vous avez téléchargés. Vous pouvez y gérer vos fichiers, par exemple des photos, des plans de construction, des bons de livraison ou des commandes.',
  infoItem1 : 'Les fichiers sont classés par dossier interne et par projet',
  infoItem2 : 'Vous pouvez à tout moment passer d\'une vue à l\'autre pour afficher soit les fichiers liés à un projet, soit les documents internes non associés à un projet',
  infoItem3: 'Vous pouvez consulter, modifier et supprimer tous les fichiers de tous les collaborateurs',
  infoItem4: 'Vous pouvez sélectionner un projet et consulter les fichiers que vous y avez téléchargés',
  infoItem5: 'Vous ne pouvez consulter, modifier et supprimer que vos propres fichiers',
  internalSubtitle: 'Documents internes sans attribution de projet',
  allUploads: 'Tous les uploads de tous les employes',
  yourUploads: 'Vos fichiers televerses',
  projectScoped: 'Lie au projet',
  projectScopedHint: 'Pour fichiers chantier, photos et plans lies aux projets',
  internalStorage: 'Stockage interne',
  internalStorageHint: 'Pour bons de livraison, commandes et confirmations sans projet',
  selectProject: 'Choisir projet',
  all: 'Tous',
  uploadFiles: 'Televerser fichiers',
  prepareFiles: 'fichier(s) a preparer',
  cancel: 'Annuler',
  name: 'Nom',
  description: 'Description',
  optional: 'optionnel',
  upload: 'Televerser',
  open: 'Ouvrir',
  download: 'Telecharger',
  delete: 'Supprimer',
  uploadFirstFiles: 'Televersez vos premiers fichiers',
  selectProjectFirst: 'Choisissez un projet',
  orSwitchInternal: 'ou passez au stockage interne ci-dessus',
  uploadHintDesktopInternal: 'Glissez les fichiers ici ou cliquez pour televerser des fichiers internes',
  uploadHintDesktop: 'Glissez les fichiers ici ou cliquez pour televerser des fichiers projet',
  uploadHintMobileInternal: 'Touchez pour choisir des fichiers internes',
  uploadHintMobile: 'Touchez pour choisir des fichiers de projet',
  noInternalFiles: 'Aucun fichier dans le stockage interne',
  noFiles: 'Aucun fichier trouve',
  uploadTitlePlaceholder: 'p.ex. Travaux fondations jour 1',
  uploadDescriptionPlaceholder: 'Courte description du fichier',
  createSubfolder: 'Creer un sous-dossier',
  manageSubfolders: 'Gerer les sous-dossiers',
  allSubfolders: 'Tous les sous-dossiers',
  noSubfolder: 'Aucun sous-dossier',
  newSubfolderPlaceholder: 'p.ex. Semaine-14',
  addSubfolder: 'Ajouter sous-dossier',
  renameSubfolder: 'Renommer',
  deleteSubfolder: 'Supprimer',
  deleteSubfolderConfirm: 'Supprimer le sous-dossier "{name}" ?',
  subfolderNameInvalid: 'Veuillez saisir un nom de sous-dossier valide',
  subfolderCreateFailed: 'Impossible de creer le sous-dossier',
  subfolderRenameFailed: 'Impossible de renommer le sous-dossier',
  subfolderDeleteFailed: 'Impossible de supprimer le sous-dossier',
  deleteConfirm: 'Supprimer le fichier ?',
  uploadFailed: 'Echec du televersement',
  storageQuotaExceeded: 'Limite de stockage atteinte. Le plan d\'essai autorise 5 Go maximum. Veuillez passer au plan Pro.',
  storageQuotaExceededPro: 'Limite de stockage atteinte. Vous pouvez augmenter la limite dans la gestion de compte. Si vous avez besoin d\'aide, contactez le support.',
  deleteNamedConfirm: 'Supprimer vraiment "{name}" ?',
  offlineQueued: 'Enregistre hors ligne. Le televersement sera synchronise automatiquement.',
  offlineUnavailable: 'Le stockage hors ligne n\'est pas disponible. Reconnectez-vous puis reessayez.',
  offlineMode: 'Mode hors ligne actif. Les envois sont enregistrés localement et seront synchronisés automatiquement à la reconnexion.',
  startTour: 'Lancer la visite guidée',
  tourScopeTitle: 'Choisir la portée',
  tourScopeText: 'Passez entre les médias liés aux projets et les documents internes sans projet.',
  tourProjectTitle: 'Sélectionner un projet',
  tourProjectText: 'Choisissez le projet dont vous souhaitez afficher ou téléverser les médias.',
  tourFoldersTitle: 'Dossiers',
  tourFoldersText: 'Photos, plans, factures, contrats, images de chat et plus – tout structuré en dossiers.',
  tourSubfoldersTitle: 'Sous-dossiers',
  tourSubfoldersText: 'Créez des sous-dossiers dans un dossier – ex. « Gros œuvre » sous Photos – pour une organisation encore plus fine.',
  tourUploadTitle: 'Téléverser des fichiers',
  tourUploadText: 'Cliquez ou glissez-déposez pour téléverser images, PDF et documents. En mode hors ligne ils sont sauvegardés localement et synchronisés automatiquement.',
  tourGridTitle: 'Aperçu des fichiers',
  tourGridText: 'Tous les fichiers téléversés en un coup d\'œil. Cliquez sur un fichier pour l\'ouvrir ou l\'agrandir.',
  tourGridTextManager: 'Tous les fichiers en un coup d\'œil. En tant que manager vous pouvez supprimer n\'importe quel fichier – peu importe qui l\'a téléversé.',
  tourGridTextEmployee: 'Vos fichiers téléversés. Vous ne voyez et ne pouvez supprimer que vos propres envois.',
  tourInternalTitle: 'Stockage interne',
  tourInternalText: 'Ici vous pouvez stocker des documents sans projet – ex. modèles généraux, contrats ou documents internes.',
  pendingSync: 'envoi(s) en attente de synchronisation.',
  fileCount: 'fichier(s)',
  folders: {
    fotos: 'Photos',
    bauplaene: 'Plans',
    order: 'Commandes',
    delivery_note: 'Bons de livraison',
    rechnungen: 'Factures',
    vertraege: 'Contrats',
    sonstiges: 'Autre'
  }
};

const mediaIt = {
  title: 'Archivio media',
  infoText: 'Questa schermata mostra i file che hai caricato. Qui puoi gestire i file, ad esempio foto, progetti, bolle di consegna o ordini.',
  infoItem1: 'I file sono ordinati in base all\'archivio interno e ai file relativi ai progetti',
  infoItem2: 'Puoi passare in qualsiasi momento da una visualizzazione all\'altra per visualizzare i file relativi al progetto o i documenti interni senza assegnazione a un progetto',
  infoItem3: 'Puoi visualizzare, modificare ed eliminare tutti i file di tutti i collaboratori',
  infoItem4: 'Puoi selezionare un progetto e visualizzare i tuoi file caricati',
  infoItem5: 'Puoi visualizzare, modificare ed eliminare solo i tuoi file',
  internalSubtitle: 'Documenti interni senza assegnazione a progetto',
  allUploads: 'Tutti i caricamenti di tutti i dipendenti',
  yourUploads: 'I tuoi file caricati',
  projectScoped: 'Legato al progetto',
  projectScopedHint: 'Per file di cantiere, foto e planimetrie legati ai progetti',
  internalStorage: 'Archivio interno',
  internalStorageHint: 'Per bolle, ordini e conferme senza progetto',
  selectProject: 'Seleziona progetto',
  all: 'Tutti',
  uploadFiles: 'Carica file',
  prepareFiles: 'file da preparare',
  cancel: 'Annulla',
  name: 'Nome',
  description: 'Descrizione',
  optional: 'opzionale',
  upload: 'Carica',
  open: 'Apri',
  download: 'Scarica',
  delete: 'Elimina',
  uploadFirstFiles: 'Carica i tuoi primi file',
  selectProjectFirst: 'Seleziona un progetto',
  orSwitchInternal: 'oppure passa all\'archivio interno sopra',
  uploadHintDesktopInternal: 'Trascina i file qui o clicca per caricare file interni',
  uploadHintDesktop: 'Trascina i file qui o clicca per caricare file di progetto',
  uploadHintMobileInternal: 'Tocca per scegliere file interni',
  uploadHintMobile: 'Tocca per scegliere file di progetto',
  noInternalFiles: 'Nessun file nell\'archivio interno',
  noFiles: 'Nessun file trovato',
  uploadTitlePlaceholder: 'es. Lavori fondazioni giorno 1',
  uploadDescriptionPlaceholder: 'Breve descrizione del file',
  createSubfolder: 'Crea sottocartella',
  manageSubfolders: 'Gestisci sottocartelle',
  allSubfolders: 'Tutte le sottocartelle',
  noSubfolder: 'Nessuna sottocartella',
  newSubfolderPlaceholder: 'es. Settimana-14',
  addSubfolder: 'Aggiungi sottocartella',
  renameSubfolder: 'Rinomina',
  deleteSubfolder: 'Elimina',
  deleteSubfolderConfirm: 'Eliminare la sottocartella "{name}"?',
  subfolderNameInvalid: 'Inserisci un nome sottocartella valido',
  subfolderCreateFailed: 'Impossibile creare la sottocartella',
  subfolderRenameFailed: 'Impossibile rinominare la sottocartella',
  subfolderDeleteFailed: 'Impossibile eliminare la sottocartella',
  deleteConfirm: 'Eliminare file?',
  uploadFailed: 'Caricamento non riuscito',
  storageQuotaExceeded: 'Limite di archiviazione raggiunto. Il piano trial consente massimo 5 GB. Eseguire l\'upgrade al piano Pro.',
  storageQuotaExceededPro: 'Limite di archiviazione raggiunto. E possibile aumentare il limite nella gestione account. Per assistenza contattare il supporto.',
  deleteNamedConfirm: 'Eliminare davvero "{name}"?',
  offlineQueued: 'Salvato offline. Il caricamento verra sincronizzato automaticamente.',
  offlineUnavailable: 'Il salvataggio offline non e disponibile. Riconnettiti e riprova.',
  offlineMode: 'Modalità offline attiva. I caricamenti vengono salvati localmente e sincronizzati automaticamente alla riconnessione.',
  startTour: 'Avvia la guida',
  tourScopeTitle: 'Scegli ambito',
  tourScopeText: 'Passa tra media legati ai progetti e documenti interni non assegnati a un progetto.',
  tourProjectTitle: 'Seleziona progetto',
  tourProjectText: 'Scegli il progetto di cui vuoi visualizzare o caricare i media.',
  tourFoldersTitle: 'Cartelle',
  tourFoldersText: 'Foto, piani, fatture, contratti, immagini chat e altro – tutto strutturato in cartelle.',
  tourSubfoldersTitle: 'Sottocartelle',
  tourSubfoldersText: 'Crea sottocartelle all\'interno di una cartella – es. "Struttura grezza" sotto Foto – per un\'organizzazione ancora più fine.',
  tourUploadTitle: 'Carica file',
  tourUploadText: 'Clicca o trascina per caricare immagini, PDF e documenti. In modalità offline vengono salvati localmente e sincronizzati automaticamente.',
  tourGridTitle: 'Panoramica file',
  tourGridText: 'Tutti i file caricati in sintesi. Clicca su un file per aprirlo o ingrandirlo.',
  tourGridTextManager: 'Tutti i file in sintesi. Come manager puoi eliminare qualsiasi file – indipendentemente da chi lo ha caricato.',
  tourGridTextEmployee: 'I tuoi file caricati. Puoi vedere ed eliminare solo i tuoi upload.',
  tourInternalTitle: 'Archivio interno',
  tourInternalText: 'Qui puoi archiviare documenti non assegnati a nessun progetto – es. modelli generali, contratti o file interni.',
  pendingSync: 'caricamento/i in attesa di sincronizzazione.',
  fileCount: 'file',
  folders: {
    fotos: 'Foto',
    bauplaene: 'Planimetrie',
    order: 'Ordini',
    delivery_note: 'Bolle',
    rechnungen: 'Fatture',
    vertraege: 'Contratti',
    sonstiges: 'Altro'
  }
};

const mediaPl = {
  title: 'Archiwum mediow',
  infoText: 'Ten widok pokazuje przesłane przez Ciebie pliki. Tutaj możesz zarządzać plikami, np. zdjęciami, planami budowlanymi, dowodami dostawy lub zamówieniami.',
  infoItem1: 'Pliki są posortowane według wewnętrznego archiwum i plików związanych z projektami',
  infoItem2: 'W każdej chwili możesz przełączać się między tymi dwoma widokami, aby wyświetlić pliki związane z projektem lub dokumenty wewnętrzne bez przypisania do projektu',
  infoItem3: 'Możesz przeglądać, edytować i usuwać wszystkie pliki wszystkich pracowników',
  infoItem4: 'Możesz wybrać projekt i wyświetlić swoje przesłane pliki',
  infoItem5: 'Możesz przeglądać, edytować i usuwać tylko swoje pliki',
  internalSubtitle: 'Dokumenty wewnetrzne bez przypisania do projektu',
  allUploads: 'Wszystkie przeslania wszystkich pracownikow',
  yourUploads: 'Twoje przeslane pliki',
  projectScoped: 'Powiazane z projektem',
  projectScopedHint: 'Dla plikow budowy, zdjec i planow powiazanych z projektami',
  internalStorage: 'Archiwum wewnetrzne',
  internalStorageHint: 'Dla WZ, zamowien i potwierdzen bez projektu',
  selectProject: 'Wybierz projekt',
  all: 'Wszystkie',
  uploadFiles: 'Przeslij pliki',
  prepareFiles: 'plik(i) do przygotowania',
  cancel: 'Anuluj',
  name: 'Nazwa',
  description: 'Opis',
  optional: 'opcjonalne',
  upload: 'Przeslij',
  open: 'Otworz',
  download: 'Pobierz',
  delete: 'Usun',
  uploadFirstFiles: 'Przeslij swoje pierwsze pliki',
  selectProjectFirst: 'Wybierz projekt',
  orSwitchInternal: 'lub przelacz na archiwum wewnetrzne powyzej',
  uploadHintDesktopInternal: 'Przeciagnij pliki tutaj lub kliknij, aby przeslac pliki wewnetrzne',
  uploadHintDesktop: 'Przeciagnij pliki tutaj lub kliknij, aby przeslac pliki projektowe',
  uploadHintMobileInternal: 'Dotknij, aby wybrac pliki wewnetrzne',
  uploadHintMobile: 'Dotknij, aby wybrac pliki projektu',
  noInternalFiles: 'Brak plikow w archiwum wewnetrznym',
  noFiles: 'Nie znaleziono plikow',
  uploadTitlePlaceholder: 'np. Prace fundamentowe dzien 1',
  uploadDescriptionPlaceholder: 'Krotki opis pliku',
  createSubfolder: 'Utworz podfolder',
  manageSubfolders: 'Zarzadzaj podfolderami',
  allSubfolders: 'Wszystkie podfoldery',
  noSubfolder: 'Bez podfolderu',
  newSubfolderPlaceholder: 'np. Tydzien-14',
  addSubfolder: 'Dodaj podfolder',
  renameSubfolder: 'Zmien nazwe',
  deleteSubfolder: 'Usun',
  deleteSubfolderConfirm: 'Usunac podfolder "{name}"?',
  subfolderNameInvalid: 'Wpisz poprawna nazwe podfolderu',
  subfolderCreateFailed: 'Nie udalo sie utworzyc podfolderu',
  subfolderRenameFailed: 'Nie udalo sie zmienic nazwy podfolderu',
  subfolderDeleteFailed: 'Nie udalo sie usunac podfolderu',
  deleteConfirm: 'Usunac plik?',
  uploadFailed: 'Przesylanie nie powiodlo sie',
  storageQuotaExceeded: 'Osiagnieto limit miejsca. Plan trial umozliwia maksymalnie 5 GB. Przejdz na plan Pro.',
  storageQuotaExceededPro: 'Osiagnieto limit miejsca. Mozesz zwiekszyc limit w zarzadzaniu kontem. Jesli potrzebujesz pomocy, skontaktuj sie z pomoca techniczna.',
  deleteNamedConfirm: 'Na pewno usunac "{name}"?',
  offlineQueued: 'Zapisano offline. Przesylanie zostanie automatycznie zsynchronizowane.',
  offlineUnavailable: 'Tryb offline jest niedostepny. Polacz sie ponownie i sprobuj jeszcze raz.',
  offlineMode: 'Tryb offline aktywny. Przesyłania są zapisywane lokalnie i będą automatycznie synchronizowane po ponownym połączeniu.',
  startTour: 'Uruchom przewodnik',
  tourScopeTitle: 'Wybierz zakres',
  tourScopeText: 'Przełącz między mediami związanymi z projektami a dokumentami wewnętrznymi bez projektu.',
  tourProjectTitle: 'Wybierz projekt',
  tourProjectText: 'Wybierz projekt, którego media chcesz wyświetlić lub przesłać.',
  tourFoldersTitle: 'Foldery',
  tourFoldersText: 'Zdjęcia, plany, faktury, umowy, obrazy z czatu i inne – wszystko w folderach.',
  tourSubfoldersTitle: 'Podfoldery',
  tourSubfoldersText: 'Utwórz podfoldery w folderze – np. „Stan surowy" w Zdjęciach – dla lepszej organizacji.',
  tourUploadTitle: 'Prześlij pliki',
  tourUploadText: 'Kliknij lub przeciągnij, aby przesłać obrazy, PDF i dokumenty. W trybie offline są zapisywane lokalnie i synchronizowane automatycznie.',
  tourGridTitle: 'Przegląd plików',
  tourGridText: 'Wszystkie przesłane pliki na pierwszy rzut oka. Kliknij plik, aby go otworzyć lub powiększyć.',
  tourGridTextManager: 'Wszystkie pliki na pierwszy rzut oka. Jako manager możesz usunąć każdy plik – niezależnie kto go przesłał.',
  tourGridTextEmployee: 'Twoje przesłane pliki. Możesz widzieć i usuwać tylko własne pliki.',
  tourInternalTitle: 'Archiwum wewnętrzne',
  tourInternalText: 'Tu możesz przechowywać dokumenty bez projektu – np. ogólne szablony, umowy lub wewnętrzne pliki.',
  pendingSync: 'przesylanie/a oczekuje na synchronizacje.',
  fileCount: 'plik(i)',
  folders: {
    fotos: 'Zdjecia',
    bauplaene: 'Plany',
    order: 'Zamowienia',
    delivery_note: 'WZ',
    rechnungen: 'Faktury',
    vertraege: 'Umowy',
    sonstiges: 'Inne'
  }
};

const mediaCs = {
  title: 'Archiv medii',
  infoText: 'Tento pohled zobrazuje vaše nahrané soubory. Zde můžete spravovat soubory, např. fotografie, stavební plány, dodací listy nebo objednávky.',
  infoItem1: 'Soubory jsou seřazeny podle interního úložiště a podle projektů',
  infoItem2: 'Můžeš kdykoli přepínat mezi oběma zobrazeními, abys viděl buď soubory související s projektem, nebo interní dokumenty bez přiřazení k projektu',
  infoItem3: 'Můžeš zobrazit, upravovat a mazat všechny soubory všech zaměstnanců',
  infoItem4: 'Můžeš vybrat projekt a zobrazit své nahrané soubory',
  infoItem5: 'Můžeš zobrazit, upravovat a mazat pouze své soubory',
  internalSubtitle: 'Interne dokumenty bez prirazeni k projektu',
  allUploads: 'Vsechny nahrane soubory od vsech zamestnancu',
  yourUploads: 'Vase nahrane soubory',
  projectScoped: 'Vazano na projekt',
  projectScopedHint: 'Pro soubory stavby, fotky a plany prirazene k projektum',
  internalStorage: 'Interni uloziste',
  internalStorageHint: 'Pro dodaci listy, objednavky a potvrzeni bez projektu',
  selectProject: 'Vyberte projekt',
  all: 'Vse',
  uploadFiles: 'Nahrat soubory',
  prepareFiles: 'soubor(y) k priprave',
  cancel: 'Zrusit',
  name: 'Nazev',
  description: 'Popis',
  optional: 'volitelne',
  upload: 'Nahrat',
  open: 'Otevrit',
  download: 'Stahnout',
  delete: 'Smazat',
  uploadFirstFiles: 'Nahrajte sve prvni soubory',
  selectProjectFirst: 'Vyberte projekt',
  orSwitchInternal: 'nebo prepnite vyse na interni uloziste',
  uploadHintDesktopInternal: 'Pretahnete soubory sem nebo kliknete pro nahrani internich souboru',
  uploadHintDesktop: 'Pretahnete soubory sem nebo kliknete pro nahrani projektovych souboru',
  uploadHintMobileInternal: 'Klepnete pro vyber internich souboru',
  uploadHintMobile: 'Klepnete pro vyber projektovych souboru',
  noInternalFiles: 'V internim ulozisti nejsou zadne soubory',
  noFiles: 'Nenalezeny zadne soubory',
  uploadTitlePlaceholder: 'napr. Zakladove prace den 1',
  uploadDescriptionPlaceholder: 'Kratky popis souboru',
  createSubfolder: 'Vytvorit podslozku',
  manageSubfolders: 'Spravovat podslozky',
  allSubfolders: 'Vsechny podslozky',
  noSubfolder: 'Bez podslozky',
  newSubfolderPlaceholder: 'napr. TYDEN-14',
  addSubfolder: 'Pridat podslozku',
  renameSubfolder: 'Prejmenovat',
  deleteSubfolder: 'Smazat',
  deleteSubfolderConfirm: 'Smazat podslozku "{name}"?',
  subfolderNameInvalid: 'Zadejte platny nazev podslozky',
  subfolderCreateFailed: 'Podslozku se nepodarilo vytvorit',
  subfolderRenameFailed: 'Podslozku se nepodarilo prejmenovat',
  subfolderDeleteFailed: 'Podslozku se nepodarilo smazat',
  deleteConfirm: 'Opravdu smazat soubor?',
  uploadFailed: 'Nahrani selhalo',
  storageQuotaExceeded: 'Dosazeno limitu uloziste. Plan trial umoznuje max. 5 GB. Provedte upgrade na plan Pro.',
  storageQuotaExceededPro: 'Dosazeno limitu uloziste. Limit muzete zvysit ve sprave uctu. Pokud potrebujete pomoc, kontaktujte podporu.',
  deleteNamedConfirm: 'Opravdu smazat "{name}"?',
  offlineQueued: 'Ulozeno offline. Nahrani se automaticky synchronizuje.',
  offlineUnavailable: 'Offline uloziste neni dostupne. Obnovte pripojeni a zkuste to znovu.',
  offlineMode: 'Rezim offline aktivni. Nahravani jsou ukladana lokalne a automaticky synchronizovana po obnoveni pripojeni.',
  startTour: 'Spustit průvodce',
  tourScopeTitle: 'Vybrat rozsah',
  tourScopeText: 'Přepínání mezi médii spojenými s projekty a interními dokumenty bez projektu.',
  tourProjectTitle: 'Vybrat projekt',
  tourProjectText: 'Vyberte projekt, jehož média chcete zobrazit nebo nahrát.',
  tourFoldersTitle: 'Složky',
  tourFoldersText: 'Fotografie, plány, faktury, smlouvy, obrázky z chatu a další – vše ve složkách.',
  tourSubfoldersTitle: 'Podsložky',
  tourSubfoldersText: 'Vytvořte podsložky ve složce – např. „Hrubá stavba" pod Fotografie – pro ještě jemnější organizaci.',
  tourUploadTitle: 'Nahrát soubory',
  tourUploadText: 'Klikněte nebo přetáhněte pro nahrání obrázků, PDF a dokumentů. V režimu offline jsou uloženy lokálně a automaticky synchronizovány.',
  tourGridTitle: 'Přehled souborů',
  tourGridText: 'Všechny nahrané soubory na první pohled. Kliknutím na soubor jej otevřete nebo zvětšíte.',
  tourGridTextManager: 'Všechny soubory na první pohled. Jako manažer můžete smazat jakýkoli soubor – bez ohledu na to kdo ho nahrál.',
  tourGridTextEmployee: 'Vaše nahrané soubory. Vidíte a můžete mazat pouze vlastní nahrávky.',
  tourInternalTitle: 'Interní úložiště',
  tourInternalText: 'Zde ukládejte dokumenty bez projektu – např. obecné šablony, smlouvy nebo interní soubory.',
  pendingSync: 'nahrani ceka na synchronizaci.',
  fileCount: 'soubor(y)',
  folders: {
    fotos: 'Fotky',
    bauplaene: 'Plany',
    order: 'Objednavky',
    delivery_note: 'Dodaci listy',
    rechnungen: 'Faktury',
    vertraege: 'Smlouvy',
    sonstiges: 'Ostatni'
  }
};

const projectsDe = {
  title: 'Projekte',
  detailsTitle: 'Projektdetails',
  infoText: 'Hier verwaltest du alle Projekte und behältst Status, Fortschritt und Daten im Überblick.',
  infoItem1: 'Projekte erstellen, bearbeiten und löschen',
  infoItem2: 'Projekte nach Status, Kunde und Name filtern und sortieren',
  infoItem3: 'Projektstatus und Fortschritt im Überblick behalten',
  infoItem4: 'Kunden- und Budgetinformationen einsehen',
  detailsInfoText: 'Hier siehst du alle Details zum Projekt und behältst Zeiten, Materialien und Finanzen im Überblick.',
  detailsInfoItem1: 'Projektphasen und Fortschritt im Detail verfolgen',
  detailsInfoItem2: 'Arbeitszeiten pro Mitarbeiter einsehen und auswerten',
  detailsInfoItem3: 'Materialbuchungen und Kosten nachvollziehen',
  detailsInfoItem4: 'Rechnungen, Zahlungen und offene Beträge verwalten',
  detailsInfoItem5: 'Dem Projekt zugewiesene Mitarbeiter haben automatisch Zugang zum Projekt-Chat – beim Entfernen entfällt der Zugang',
  tourDetailKpiTitle: 'Projektkennzahlen',
  tourDetailKpiText: 'Zeitraum, Budget, Mitarbeiteranzahl und Gesamtfortschritt auf einen Blick.',
  tourDetailPhasesTitle: 'Bauphasen',
  tourDetailPhasesText: 'Unterteile das Projekt in Phasen mit eigenem Zeitstrahl – grün, gelb oder rot je nach verbleibender Zeit.',
  tourDetailTeamTitle: 'Projektteam',
  tourDetailTeamText: 'Mitarbeiter dem Projekt zuweisen. Zugewiesene Mitarbeiter erhalten automatisch Zugang zum Projekt-Chat.',
  tourDetailRapportTitle: 'Rapport',
  tourDetailRapportText: 'Zeiterfassung aller Mitarbeiter für dieses Projekt. Filtere nach Zeitraum und exportiere als PDF.',
  tourDetailMaterialsTitle: 'Materialien',
  tourDetailMaterialsText: 'Gebuchte Materialien für dieses Projekt – können direkt und einfach in Rechnungen eingebunden werden.',
  tourDetailAufmassTitle: 'Aufmaß',
  tourDetailAufmassText: 'Alle Aufmaße dieses Projekts. Öffne ein bestehendes oder lege direkt ein neues an. Freigegebene Aufmaße dienen als Basis für Rechnungen.',
  tourDetailEditTitle: 'Projekt bearbeiten',
  tourDetailEditText: 'Hier kannst du Name, Status, Zeitraum, Budget, Adresse und Beschreibung ändern.',
  tourDetailMachinesTitle: 'Maschinen',
  tourDetailMachinesText: 'Dem Projekt zugewiesene Maschinen und Geräte – können direkt in Rechnungen übernommen werden.',
  tourDetailVehiclesTitle: 'Fahrzeuge',
  tourDetailVehiclesText: 'Dem Projekt zugewiesene Fahrzeuge – können direkt in Rechnungen übernommen werden.',
  tourDetailDetailsTitle: 'Details',
  tourDetailDetailsText: 'Baustellenadresse und Projektbeschreibung. Die Adresse kann für Routenplanung und Rapporte genutzt werden.',
  tourDetailFinanceTitle: 'Finanzübersicht',
  tourDetailFinanceText: 'Rechnungssumme, eingegangene Zahlungen und offene Beträge. Direkt von hier eine neue Rechnung erstellen.',
  tourDetailHoursTitle: 'Stunden pro Mitarbeiter',
  tourDetailHoursText: 'Alle gebuchten Arbeitsstunden aufgeschlüsselt nach Mitarbeiter – offene Stunden können direkt in Rechnungen übernommen werden.',
  tourDetailMediaTitle: 'Dokumente & Fotos',
  tourDetailMediaText: 'Fotos, Pläne und Dokumente direkt am Projekt ablegen und abrufen.',
  count: 'Projekte',
  newProject: 'Neues Projekt',
  searchPlaceholder: 'Projekt suchen...',
  allStatuses: 'Alle Status',
  allCustomers: 'Alle Kunden',
  noProjects: 'Keine Projekte gefunden',
  createFirst: 'Erstelle dein erstes Projekt',
  startTour: 'Führung starten',
  tourNewTitle: 'Neues Projekt',
  tourNewText: 'Legt ein neues Projekt an – mit Name, Status, Zeitraum und Budget.',
  tourModalTitle: 'Projektformular',
  tourModalText: 'Hier trägst du Name, Status, Kunde, Start-/Enddatum und Budget ein. Pflichtfelder sind mit * markiert.',
  tourFilterTitle: 'Filter & Sortierung',
  tourFilterText: 'Filtere Projekte nach Name, Status oder Kunde. Sortierung nach Name, Datum oder Budget möglich.',
  tourGridTitle: 'Projektübersicht',
  tourGridText: 'Alle Projekte als Kacheln. Favoriten-Stern zum Hervorheben, Klick öffnet die Detailseite.',
  tourCardTitle: 'Projektkachel',
  tourCardText: 'Zeigt Status, Fortschritt, Kunde und Zeitraum. Klick führt zur vollständigen Projektdetailseite.',
  noCustomer: 'Kein Kunde',
  editProject: 'Projekt bearbeiten',
  projectName: 'Projektname',
  projectNamePlaceholder: 'z.B. Dachsanierung Musterstr.',
  customer: 'Kunde',
  budgetNet: 'Budget (netto)',
  startDate: 'Startdatum',
  endDate: 'Enddatum',
  siteAddress: 'Baustellenadresse',
  description: 'Beschreibung',
  descriptionPlaceholder: 'Projektbeschreibung...',
  street: 'Straße',
  city: 'Stadt',
  zip: 'PLZ',
  create: 'Erstellen',
  save: 'Speichern',
  cancel: 'Abbrechen',
  delete: 'Löschen',
  deleteConfirm: 'Projekt wirklich löschen?',
  nameRequired: 'Projektname erforderlich',
  customerRequired: 'Bitte einen Kunden auswählen',
  favorite: 'Als Favorit markieren',
  unfavorite: 'Favorit entfernen',
  lockedByOther: 'Wird gerade bearbeitet von {name}'
};

const projectsEn = {
  title: 'Projects',
  detailsTitle: 'Project Details',
  infoText: 'Here you manage all projects and keep track of their status, progress, and data.',
  infoItem1: 'Create, edit, and delete projects',
  infoItem2: 'Filter and sort projects by status, customer, and name',
  infoItem3: 'Keep an overview of project status and progress',
  infoItem4: 'View customer and budget information',
  detailsInfoText: 'Here you can view all project details and keep track of time, materials, and finances.',
  detailsInfoItem1: 'Track project phases and progress in detail',
  detailsInfoItem2: 'View and analyze working hours per employee',
  detailsInfoItem3: 'Review material bookings and costs',
  detailsInfoItem4: 'Manage invoices, payments, and outstanding amounts',
  detailsInfoItem5: 'Employees assigned to the project automatically get access to the project chat – removing them revokes access',
  tourDetailKpiTitle: 'Project KPIs',
  tourDetailKpiText: 'Timeframe, budget, team size, and overall progress at a glance.',
  tourDetailPhasesTitle: 'Construction phases',
  tourDetailPhasesText: 'Break the project into phases with individual timelines – green, yellow, or red based on remaining time.',
  tourDetailTeamTitle: 'Project team',
  tourDetailTeamText: 'Assign employees to the project. Assigned employees automatically get access to the project chat.',
  tourDetailRapportTitle: 'Rapport',
  tourDetailRapportText: 'Time tracking for all employees on this project. Filter by date range and export as PDF.',
  tourDetailMaterialsTitle: 'Materials',
  tourDetailMaterialsText: 'Materials booked to this project – can be included directly and easily in invoices.',
  tourDetailAufmassTitle: 'Measurements',
  tourDetailAufmassText: 'All measurements for this project. Open an existing one or create a new one directly. Approved measurements serve as the basis for invoices.',
  tourDetailEditTitle: 'Edit project',
  tourDetailEditText: 'Change name, status, timeframe, budget, address, and description here.',
  tourDetailMachinesTitle: 'Machines',
  tourDetailMachinesText: 'Machines and equipment assigned to this project – can be included directly in invoices.',
  tourDetailVehiclesTitle: 'Vehicles',
  tourDetailVehiclesText: 'Vehicles assigned to this project – can be included directly in invoices.',
  tourDetailDetailsTitle: 'Details',
  tourDetailDetailsText: 'Site address and project description. The address can be used for route planning and reports.',
  tourDetailFinanceTitle: 'Finance overview',
  tourDetailFinanceText: 'Invoice total, received payments, and outstanding amounts. Create a new invoice directly from here.',
  tourDetailHoursTitle: 'Hours per employee',
  tourDetailHoursText: 'All booked working hours broken down by employee – unbilled hours can be included directly in invoices.',
  tourDetailMediaTitle: 'Documents & photos',
  tourDetailMediaText: 'Store and access photos, plans, and documents directly on the project.',
  count: 'projects',
  newProject: 'New project',
  searchPlaceholder: 'Search project...',
  allStatuses: 'All statuses',
  allCustomers: 'All customers',
  noProjects: 'No projects found',
  createFirst: 'Create your first project',
  startTour: 'Start tour',
  tourNewTitle: 'New project',
  tourNewText: 'Creates a new project – with name, status, timeframe, and budget.',
  tourModalTitle: 'Project form',
  tourModalText: 'Enter name, status, customer, start/end date, and budget. Required fields are marked with *.',
  tourFilterTitle: 'Filter & sorting',
  tourFilterText: 'Filter projects by name, status, or customer. Sort by name, date, or budget.',
  tourGridTitle: 'Project overview',
  tourGridText: 'All projects as tiles. Star to mark favorites, click to open the detail page.',
  tourCardTitle: 'Project tile',
  tourCardText: 'Shows status, progress, customer and timeframe. Click opens the full project detail page.',
  noCustomer: 'No customer',
  editProject: 'Edit project',
  projectName: 'Project name',
  projectNamePlaceholder: 'e.g. Roof renovation Main St.',
  customer: 'Customer',
  budgetNet: 'Budget (net)',
  startDate: 'Start date',
  endDate: 'End date',
  siteAddress: 'Site address',
  description: 'Description',
  descriptionPlaceholder: 'Project description...',
  street: 'Street',
  city: 'City',
  zip: 'ZIP',
  create: 'Create',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  deleteConfirm: 'Delete project?',
  nameRequired: 'Project name required',
  customerRequired: 'Please select a customer',
  favorite: 'Mark as favourite',
  unfavorite: 'Remove favourite',
  lockedByOther: 'Currently being edited by {name}'
};

const projectsFr = {
  title: 'Projets',
  detailsTitle: 'Détails du projet',
  infoText: 'Ici, vous gérez tous les projets et gardez une vue d’ensemble sur leur statut, leur avancement et leurs données.',
  infoItem1: 'Créer, modifier et supprimer des projets',
  infoItem2: 'Filtrer et trier les projets par statut, client et nom',
  infoItem3: 'Garder une vue d’ensemble du statut et de l’avancement des projets',
  infoItem4: 'Consulter les informations clients et budget',
  detailsInfoText: 'Vous consultez ici tous les détails du projet et gardez une vue d’ensemble sur le temps, les matériaux et les finances.',
  detailsInfoItem1: 'Suivre les phases et l’avancement du projet en détail',
  detailsInfoItem2: 'Consulter et analyser les heures par employé',
  detailsInfoItem3: 'Suivre les consommations de matériaux et les coûts',
  detailsInfoItem4: 'Gérer les factures, paiements et montants ouverts',
  detailsInfoItem5: 'Les employes affectes au projet ont automatiquement acces au chat du projet – leur suppression retire cet acces',
  tourDetailKpiTitle: 'Indicateurs du projet',
  tourDetailKpiText: 'Période, budget, équipe et avancement global en un coup d\'œil.',
  tourDetailPhasesTitle: 'Phases de construction',
  tourDetailPhasesText: 'Divisez le projet en phases avec des barres de progression individuelles – vert, jaune ou rouge selon le temps restant.',
  tourDetailTeamTitle: 'Équipe projet',
  tourDetailTeamText: 'Affectez des employés au projet. Ils obtiennent automatiquement accès au chat du projet.',
  tourDetailRapportTitle: 'Rapport',
  tourDetailRapportText: 'Suivi du temps de tous les employés sur ce projet. Filtrez par période et exportez en PDF.',
  tourDetailMaterialsTitle: 'Matériaux',
  tourDetailMaterialsText: 'Matériaux réservés pour ce projet – peuvent être directement et facilement intégrés dans les factures.',
  tourDetailAufmassTitle: 'Métrés',
  tourDetailAufmassText: 'Tous les métrés de ce projet. Ouvrez un existant ou créez-en un nouveau directement. Les métrés validés servent de base pour les factures.',
  tourDetailEditTitle: 'Modifier le projet',
  tourDetailEditText: 'Modifiez le nom, statut, période, budget, adresse et description ici.',
  tourDetailMachinesTitle: 'Machines',
  tourDetailMachinesText: 'Machines et équipements affectés à ce projet – peuvent être directement intégrés dans les factures.',
  tourDetailVehiclesTitle: 'Véhicules',
  tourDetailVehiclesText: 'Véhicules affectés à ce projet – peuvent être directement intégrés dans les factures.',
  tourDetailDetailsTitle: 'Détails',
  tourDetailDetailsText: 'Adresse du chantier et description du projet. L\'adresse peut être utilisée pour la planification d\'itinéraire et les rapports.',
  tourDetailFinanceTitle: 'Vue financière',
  tourDetailFinanceText: 'Total facturé, paiements reçus et montants ouverts. Créez une nouvelle facture directement ici.',
  tourDetailHoursTitle: 'Heures par employé',
  tourDetailHoursText: 'Toutes les heures par employé – les heures non facturées peuvent être directement intégrées dans les factures.',
  tourDetailMediaTitle: 'Documents & photos',
  tourDetailMediaText: 'Stockez et consultez photos, plans et documents directement sur le projet.',
  count: 'projets',
  newProject: 'Nouveau projet',
  searchPlaceholder: 'Rechercher un projet...',
  allStatuses: 'Tous les statuts',
  allCustomers: 'Tous les clients',
  noProjects: 'Aucun projet trouve',
  createFirst: 'Creez votre premier projet',
  startTour: 'Lancer la visite guidée',
  tourNewTitle: 'Nouveau projet',
  tourNewText: 'Crée un nouveau projet – avec nom, statut, période et budget.',
  tourModalTitle: 'Formulaire projet',
  tourModalText: 'Saisissez nom, statut, client, dates et budget. Les champs obligatoires sont marqués *.',
  tourFilterTitle: 'Filtres & tri',
  tourFilterText: 'Filtrez par nom, statut ou client. Triez par nom, date ou budget.',
  tourGridTitle: 'Vue d\'ensemble',
  tourGridText: 'Tous les projets en tuiles. Étoile pour les favoris, clic pour ouvrir le détail.',
  tourCardTitle: 'Tuile projet',
  tourCardText: 'Affiche statut, avancement, client et période. Clic ouvre la page de détail.',
  noCustomer: 'Aucun client',
  editProject: 'Modifier projet',
  projectName: 'Nom du projet',
  projectNamePlaceholder: 'p.ex. Renovation toiture Rue Exemple',
  customer: 'Client',
  budgetNet: 'Budget (net)',
  startDate: 'Date de debut',
  endDate: 'Date de fin',
  siteAddress: 'Adresse chantier',
  description: 'Description',
  descriptionPlaceholder: 'Description du projet...',
  street: 'Rue',
  city: 'Ville',
  zip: 'Code postal',
  create: 'Creer',
  save: 'Enregistrer',
  cancel: 'Annuler',
  delete: 'Supprimer',
  deleteConfirm: 'Supprimer le projet ?',
  nameRequired: 'Nom du projet requis',
  customerRequired: 'Veuillez sélectionner un client',
  favorite: 'Marquer comme favori',
  unfavorite: 'Retirer des favoris',
  lockedByOther: 'Actuellement modifie par {name}'
};

const projectsIt = {
  title: 'Progetti',
  detailsTitle: 'Dettagli progetto',
  infoText: 'Qui gestisci tutti i progetti e mantieni il controllo su stato, avanzamento e dati.',
  infoItem1: 'Creare, modificare ed eliminare progetti',
  infoItem2: 'Filtrare e ordinare i progetti per stato, cliente e nome',
  infoItem3: 'Tenere sotto controllo lo stato e l’avanzamento dei progetti',
  infoItem4: 'Visualizzare informazioni su clienti e budget',
  detailsInfoText: 'Qui puoi visualizzare tutti i dettagli del progetto e tenere sotto controllo tempi, materiali e finanze.',
  detailsInfoItem1: 'Monitorare fasi e avanzamento del progetto in dettaglio',
  detailsInfoItem2: 'Visualizzare e analizzare le ore di lavoro per dipendente',
  detailsInfoItem3: 'Controllare materiali utilizzati e costi',
  detailsInfoItem4: 'Gestire fatture, pagamenti e importi aperti',
  detailsInfoItem5: 'I dipendenti assegnati al progetto hanno automaticamente accesso alla chat del progetto – la rimozione revoca l accesso',
  tourDetailKpiTitle: 'Indicatori progetto',
  tourDetailKpiText: 'Periodo, budget, team e avanzamento complessivo in sintesi.',
  tourDetailPhasesTitle: 'Fasi di costruzione',
  tourDetailPhasesText: 'Dividi il progetto in fasi con barre temporali individuali – verde, giallo o rosso in base al tempo rimanente.',
  tourDetailTeamTitle: 'Team di progetto',
  tourDetailTeamText: 'Assegna dipendenti al progetto. Ottengono automaticamente accesso alla chat del progetto.',
  tourDetailRapportTitle: 'Rapporto',
  tourDetailRapportText: 'Rilevazione ore di tutti i dipendenti su questo progetto. Filtra per periodo ed esporta in PDF.',
  tourDetailMaterialsTitle: 'Materiali',
  tourDetailMaterialsText: 'Materiali prenotati per questo progetto – possono essere inclusi direttamente e facilmente nelle fatture.',
  tourDetailAufmassTitle: 'Computi metrici',
  tourDetailAufmassText: 'Tutti i computi di questo progetto. Aprine uno esistente o creane uno nuovo direttamente. I computi approvati servono come base per le fatture.',
  tourDetailEditTitle: 'Modifica progetto',
  tourDetailEditText: 'Modifica nome, stato, periodo, budget, indirizzo e descrizione qui.',
  tourDetailMachinesTitle: 'Macchinari',
  tourDetailMachinesText: 'Macchinari e attrezzature assegnati a questo progetto – possono essere inclusi direttamente nelle fatture.',
  tourDetailVehiclesTitle: 'Veicoli',
  tourDetailVehiclesText: 'Veicoli assegnati a questo progetto – possono essere inclusi direttamente nelle fatture.',
  tourDetailDetailsTitle: 'Dettagli',
  tourDetailDetailsText: 'Indirizzo del cantiere e descrizione del progetto. L\'indirizzo può essere utilizzato per la pianificazione del percorso e i rapporti.',
  tourDetailFinanceTitle: 'Panoramica finanziaria',
  tourDetailFinanceText: 'Totale fatturato, pagamenti ricevuti e importi aperti. Crea una nuova fattura direttamente da qui.',
  tourDetailHoursTitle: 'Ore per dipendente',
  tourDetailHoursText: 'Tutte le ore per dipendente – le ore non fatturate possono essere incluse direttamente nelle fatture.',
  tourDetailMediaTitle: 'Documenti & foto',
  tourDetailMediaText: 'Salva e accedi a foto, piani e documenti direttamente nel progetto.',
  count: 'progetti',
  newProject: 'Nuovo progetto',
  searchPlaceholder: 'Cerca progetto...',
  allStatuses: 'Tutti gli stati',
  allCustomers: 'Tutti i clienti',
  noProjects: 'Nessun progetto trovato',
  createFirst: 'Crea il tuo primo progetto',
  startTour: 'Avvia la guida',
  tourNewTitle: 'Nuovo progetto',
  tourNewText: 'Crea un nuovo progetto – con nome, stato, periodo e budget.',
  tourModalTitle: 'Modulo progetto',
  tourModalText: 'Inserisci nome, stato, cliente, date e budget. I campi obbligatori sono contrassegnati con *.',
  tourFilterTitle: 'Filtri e ordinamento',
  tourFilterText: 'Filtra per nome, stato o cliente. Ordina per nome, data o budget.',
  tourGridTitle: 'Panoramica progetti',
  tourGridText: 'Tutti i progetti come riquadri. Stella per i preferiti, clic per aprire il dettaglio.',
  tourCardTitle: 'Riquadro progetto',
  tourCardText: 'Mostra stato, avanzamento, cliente e periodo. Clic apre la pagina di dettaglio.',
  noCustomer: 'Nessun cliente',
  editProject: 'Modifica progetto',
  projectName: 'Nome progetto',
  projectNamePlaceholder: 'es. Ristrutturazione tetto Via Esempio',
  customer: 'Cliente',
  budgetNet: 'Budget (netto)',
  startDate: 'Data inizio',
  endDate: 'Data fine',
  siteAddress: 'Indirizzo cantiere',
  description: 'Descrizione',
  descriptionPlaceholder: 'Descrizione progetto...',
  street: 'Via',
  city: 'Citta',
  zip: 'CAP',
  create: 'Crea',
  save: 'Salva',
  cancel: 'Annulla',
  delete: 'Elimina',
  deleteConfirm: 'Eliminare il progetto?',
  nameRequired: 'Nome progetto obbligatorio',
  customerRequired: 'Selezionare un cliente',
  favorite: 'Segna come preferito',
  unfavorite: 'Rimuovi dai preferiti',
  lockedByOther: 'Attualmente in modifica da {name}'
};

const projectsPl = {
  title: 'Projekty',
  detailsTitle: 'Szczegoly projektu',
  infoText: 'Tutaj zarządzasz wszystkimi projektami i masz podgląd na ich status, postęp i dane.',
  infoItem1: 'Tworzenie, edytowanie i usuwanie projektów',
  infoItem2: 'Filtrowanie i sortowanie projektów według statusu, klienta i nazwy',
  infoItem3: 'Monitorowanie statusu i postępu projektów',
  infoItem4: 'Podgląd informacji o klientach i budżecie',
  detailsInfoText: 'Tutaj możesz przeglądać wszystkie szczegóły projektu i kontrolować czas, materiały oraz finanse.',
  detailsInfoItem1: 'Śledzenie etapów i postępu projektu w szczegółach',
  detailsInfoItem2: 'Podgląd i analiza godzin pracy pracowników',
  detailsInfoItem3: 'Kontrola wykorzystanych materiałów i kosztów',
  detailsInfoItem4: 'Zarządzanie fakturami, płatnościami i należnościami',
  detailsInfoItem5: 'Pracownicy przypisani do projektu automatycznie uzyskuja dostep do czatu projektu – usuniecie odbiera dostep',
  tourDetailKpiTitle: 'Wskaźniki projektu',
  tourDetailKpiText: 'Okres, budżet, zespół i ogólny postęp na pierwszy rzut oka.',
  tourDetailPhasesTitle: 'Fazy budowy',
  tourDetailPhasesText: 'Podziel projekt na fazy z indywidualnymi paskami czasu – zielony, żółty lub czerwony w zależności od pozostałego czasu.',
  tourDetailTeamTitle: 'Zespół projektu',
  tourDetailTeamText: 'Przypisz pracowników do projektu. Automatycznie uzyskują dostęp do czatu projektu.',
  tourDetailRapportTitle: 'Raport',
  tourDetailRapportText: 'Rejestracja czasu wszystkich pracowników dla tego projektu. Filtruj według okresu i eksportuj do PDF.',
  tourDetailMaterialsTitle: 'Materiały',
  tourDetailMaterialsText: 'Materiały zarezerwowane dla tego projektu – mogą być bezpośrednio i łatwo uwzględnione w fakturach.',
  tourDetailAufmassTitle: 'Obmiary',
  tourDetailAufmassText: 'Wszystkie obmiary tego projektu. Otworz istniejacy lub utworz nowy bezposrednio. Zatwierdzone obmiary stanowia podstawe do faktur.',
  tourDetailEditTitle: 'Edytuj projekt',
  tourDetailEditText: 'Zmień nazwę, status, okres, budżet, adres i opis tutaj.',
  tourDetailMachinesTitle: 'Maszyny',
  tourDetailMachinesText: 'Maszyny i urządzenia przypisane do tego projektu – mogą być bezpośrednio uwzględnione w fakturach.',
  tourDetailVehiclesTitle: 'Pojazdy',
  tourDetailVehiclesText: 'Pojazdy przypisane do tego projektu – mogą być bezpośrednio uwzględnione w fakturach.',
  tourDetailDetailsTitle: 'Szczegoly',
  tourDetailDetailsText: 'Adres budowy i opis projektu. Adres moze byc uzywany do planowania trasy i raportow.',
  tourDetailFinanceTitle: 'Przegląd finansowy',
  tourDetailFinanceText: 'Suma faktur, otrzymane płatności i kwoty otwarte. Utwórz nową fakturę bezpośrednio stąd.',
  tourDetailHoursTitle: 'Godziny na pracownika',
  tourDetailHoursText: 'Wszystkie godziny według pracownika – nierozliczone godziny mogą być bezpośrednio uwzględnione w fakturach.',
  tourDetailMediaTitle: 'Dokumenty i zdjęcia',
  tourDetailMediaText: 'Przechowuj i pobieraj zdjęcia, plany i dokumenty bezpośrednio w projekcie.',
  count: 'projekty',
  newProject: 'Nowy projekt',
  searchPlaceholder: 'Szukaj projektu...',
  allStatuses: 'Wszystkie statusy',
  allCustomers: 'Wszyscy klienci',
  noProjects: 'Nie znaleziono projektow',
  createFirst: 'Utworz swoj pierwszy projekt',
  startTour: 'Uruchom przewodnik',
  tourNewTitle: 'Nowy projekt',
  tourNewText: 'Tworzy nowy projekt – z nazwą, statusem, okresem i budżetem.',
  tourModalTitle: 'Formularz projektu',
  tourModalText: 'Wprowadź nazwę, status, klienta, daty i budżet. Pola wymagane są oznaczone *.',
  tourFilterTitle: 'Filtry i sortowanie',
  tourFilterText: 'Filtruj według nazwy, statusu lub klienta. Sortuj według nazwy, daty lub budżetu.',
  tourGridTitle: 'Przegląd projektów',
  tourGridText: 'Wszystkie projekty jako kafelki. Gwiazdka dla ulubionych, klik otwiera szczegóły.',
  tourCardTitle: 'Kafelek projektu',
  tourCardText: 'Pokazuje status, postęp, klienta i okres. Klik otwiera pełną stronę szczegółów.',
  noCustomer: 'Brak klienta',
  editProject: 'Edytuj projekt',
  projectName: 'Nazwa projektu',
  projectNamePlaceholder: 'np. Remont dachu ul. Przykladowa',
  customer: 'Klient',
  budgetNet: 'Budzet (netto)',
  startDate: 'Data rozpoczecia',
  endDate: 'Data zakonczenia',
  siteAddress: 'Adres budowy',
  description: 'Opis',
  descriptionPlaceholder: 'Opis projektu...',
  street: 'Ulica',
  city: 'Miasto',
  zip: 'Kod pocztowy',
  create: 'Utworz',
  save: 'Zapisz',
  cancel: 'Anuluj',
  delete: 'Usun',
  deleteConfirm: 'Usunac projekt?',
  nameRequired: 'Nazwa projektu jest wymagana',
  customerRequired: 'Proszę wybrać klienta',
  favorite: 'Dodaj do ulubionych',
  unfavorite: 'Usun z ulubionych',
  lockedByOther: 'Aktualnie edytowane przez {name}'
};

const projectsCs = {
  title: 'Projekty',
  detailsTitle: 'Detaily projektu',
  infoText: 'Zde spravujete všechny projekty a máte přehled o jejich stavu, průběhu a datech.',
  infoItem1: 'Vytváření, úprava a mazání projektů',
  infoItem2: 'Filtrování a řazení projektů podle stavu, zákazníka a názvu',
  infoItem3: 'Sledování stavu a průběhu projektů',
  infoItem4: 'Zobrazení informací o zákaznících a rozpočtu',
  detailsInfoText: 'Zde si můžete zobrazit všechny detaily projektu a mít přehled o čase, materiálu a financích.',
  detailsInfoItem1: 'Sledování fází a postupu projektu do detailu',
  detailsInfoItem2: 'Zobrazení a analýza odpracovaných hodin zaměstnanců',
  detailsInfoItem3: 'Přehled použitých materiálů a nákladů',
  detailsInfoItem4: 'Správa faktur, plateb a neuhrazených částek',
  detailsInfoItem5: 'Zamestnanci prirazenı k projektu maji automaticky pristup k projektovemu chatu – odebranım se pristup odobere',
  tourDetailKpiTitle: 'Ukazatele projektu',
  tourDetailKpiText: 'Období, rozpočet, tým a celkový průběh na první pohled.',
  tourDetailPhasesTitle: 'Stavební fáze',
  tourDetailPhasesText: 'Rozdělte projekt do fází s individuálními časovými osami – zelená, žlutá nebo červená podle zbývajícího času.',
  tourDetailTeamTitle: 'Projektový tým',
  tourDetailTeamText: 'Přiřaďte zaměstnance k projektu. Automaticky získají přístup k projektovému chatu.',
  tourDetailRapportTitle: 'Výkaz',
  tourDetailRapportText: 'Evidence hodin všech zaměstnanců na tomto projektu. Filtrujte podle období a exportujte do PDF.',
  tourDetailMaterialsTitle: 'Materiály',
  tourDetailMaterialsText: 'Materiály rezervované pro tento projekt – lze je přímo a snadno zahrnout do faktur.',
  tourDetailAufmassTitle: 'Vykyzy vymeru',
  tourDetailAufmassText: 'Vsechny vykyzy tohoto projektu. Otevrte existujici nebo vytvorte novy. Schvalene vykyzy slouzi jako podklad pro faktury.',
  tourDetailEditTitle: 'Upravit projekt',
  tourDetailEditText: 'Změňte název, stav, období, rozpočet, adresu a popis zde.',
  tourDetailMachinesTitle: 'Stroje',
  tourDetailMachinesText: 'Stroje a zařízení přiřazené k tomuto projektu – lze je přímo zahrnout do faktur.',
  tourDetailVehiclesTitle: 'Vozidla',
  tourDetailVehiclesText: 'Vozidla přiřazená k tomuto projektu – lze je přímo zahrnout do faktur.',
  tourDetailDetailsTitle: 'Podrobnosti',
  tourDetailDetailsText: 'Adresa stavby a popis projektu. Adresu lze pouzit pro planovani trasy a sestavy.',
  tourDetailFinanceTitle: 'Finanční přehled',
  tourDetailFinanceText: 'Celková fakturovaná částka, přijaté platby a otevřené částky. Vytvořte novou fakturu přímo odsud.',
  tourDetailHoursTitle: 'Hodiny na zaměstnance',
  tourDetailHoursText: 'Všechny hodiny podle zaměstnance – nevyfakturované hodiny lze přímo zahrnout do faktur.',
  tourDetailMediaTitle: 'Dokumenty & fotografie',
  tourDetailMediaText: 'Ukládejte a přistupujte k fotografiím, plánům a dokumentům přímo v projektu.',
  count: 'projekty',
  newProject: 'Novy projekt',
  searchPlaceholder: 'Hledat projekt...',
  allStatuses: 'Vsechny stavy',
  allCustomers: 'Vsichni zakaznici',
  noProjects: 'Nenalezeny zadne projekty',
  createFirst: 'Vytvorte svuj prvni projekt',
  startTour: 'Spustit průvodce',
  tourNewTitle: 'Nový projekt',
  tourNewText: 'Vytvoří nový projekt – s názvem, stavem, obdobím a rozpočtem.',
  tourModalTitle: 'Formulář projektu',
  tourModalText: 'Zadejte název, stav, zákazníka, data a rozpočet. Povinná pole jsou označena *.',
  tourFilterTitle: 'Filtry a řazení',
  tourFilterText: 'Filtrujte podle názvu, stavu nebo zákazníka. Řaďte podle názvu, data nebo rozpočtu.',
  tourGridTitle: 'Přehled projektů',
  tourGridText: 'Všechny projekty jako dlaždice. Hvězda pro oblíbené, klik otevře detail.',
  tourCardTitle: 'Dlaždice projektu',
  tourCardText: 'Zobrazuje stav, průběh, zákazníka a období. Klik otevře plnou stránku detailu.',
  noCustomer: 'Bez zakaznika',
  editProject: 'Upravit projekt',
  projectName: 'Nazev projektu',
  projectNamePlaceholder: 'napr. Rekonstrukce strechy Ulice Ukazkova',
  customer: 'Zakaznik',
  budgetNet: 'Rozpocet (netto)',
  startDate: 'Datum zacatku',
  endDate: 'Datum konce',
  siteAddress: 'Adresa stavby',
  description: 'Popis',
  descriptionPlaceholder: 'Popis projektu...',
  street: 'Ulice',
  city: 'Mesto',
  zip: 'PSC',
  create: 'Vytvorit',
  save: 'Ulozit',
  cancel: 'Zrusit',
  delete: 'Smazat',
  deleteConfirm: 'Smazat projekt?',
  nameRequired: 'Nazev projektu je povinny',
  customerRequired: 'Prosím vyberte zákazníka',
  favorite: 'Oznacit jako oblibeny',
  unfavorite: 'Odebrat z oblibenych',
  lockedByOther: 'Prave upravuje {name}'
};

const materialPickerDe = {
  usedMaterial: 'Verwendetes Material',
  searchPlaceholder: 'Material suchen...',
  noneSelected: 'Kein Material ausgewählt'
};

const materialPickerEn = {
  usedMaterial: 'Used material',
  searchPlaceholder: 'Search material...',
  noneSelected: 'No material selected'
};

const materialPickerFr = {
  usedMaterial: 'Materiel utilise',
  searchPlaceholder: 'Rechercher materiel...',
  noneSelected: 'Aucun materiel selectionne'
};

const materialPickerIt = {
  usedMaterial: 'Materiale utilizzato',
  searchPlaceholder: 'Cerca materiale...',
  noneSelected: 'Nessun materiale selezionato'
};

const materialPickerPl = {
  usedMaterial: 'Uzyty material',
  searchPlaceholder: 'Szukaj materialu...',
  noneSelected: 'Nie wybrano materialu'
};

const materialPickerCs = {
  usedMaterial: 'Pouzity material',
  searchPlaceholder: 'Hledat material...',
  noneSelected: 'Neni vybran zadny material'
};

const materialViewDe = {
  title: 'Lager',
  infoText: 'Hier kannst du alle Materialien verwalten und den Lagerbestand einsehen.',
  infoItem1: 'Materialien erstellen, bearbeiten und löschen',
  infoItem2: 'Materialien nach Kategorie, Lieferant und Name filtern und sortieren',
  infoItem3: 'Lagerbestand und Lagerwert im Überblick behalten',
  infoItem4: 'Materialien ein- und ausbuchen auf Lager oder Projekten',
  infoItem5: 'Der Button "Alle löschbaren Artikel löschen" entfernt alle aktiven Artikel ohne Bestand und ohne Warenbewegung. So kannst du dein Lager aufräumen und alte Artikel entfernen.',
  item: 'Artikel',
  items: 'Artikel',
  inventory: 'Inventur',
  import: 'Import',
  connecting: 'Verbinde...',
  totalItems: 'Artikel gesamt',
  minimumStock: 'Meldebestand',
  categories: 'Kategorien',
  stockValue: 'Lagerwert',
  searchPlaceholder: 'Artikel suchen...',
  allCategories: 'Alle Kategorien',
  allSuppliers: 'Alle Lieferanten',
  onlyLowStock: 'Nur Meldebestand',
  articleNo: 'Artikel-Nr.',
  description: 'Bezeichnung',
  category: 'Kategorie',
  stock: 'Bestand',
  price: 'Preis',
  supplier: 'Lieferant',
  minimumStockBelow: 'Meldebestand unterschritten',
  searchAtSupplier: 'Beim Lieferanten suchen',
  stockMovement: 'Lagerbewegung',
  startTour: 'Führung starten',
  tourStatsTitle: 'Lagerübersicht',
  tourStatsText: 'Anzahl Artikel, Artikel unter Mindestbestand, Kategorien und Gesamtlagerwert auf einen Blick.',
  tourDemandTitle: 'Bestellbedarf',
  tourDemandText: 'Artikel, deren Lagerbestand unter dem Mindestbestand liegt oder die in offenen Angeboten benötigt werden. Direkt sichtbar damit du schnell reagieren kannst.',
  tourFilterTitle: 'Suche & Filter',
  tourFilterText: 'Filtere nach Suchbegriff, Kategorie, Lieferant oder zeige nur Artikel unter Mindestbestand.',
  tourTableTitle: 'Materialliste',
  tourTableText: 'Alle Artikel mit Bestand, Preis und Lagerort. Spalten sind sortierbar – klick öffnet die Detailansicht.',
  tourDetailTitle: 'Artikeldetails',
  tourDetailText: 'Alle Informationen zum Artikel: Beschreibung, Einheit, Preis, Lieferant und aktuelle Buchungen.',
  tourMovementTitle: 'Lagerbewegung buchen',
  tourMovementText: 'Wareneingang, Warenausgang oder Projektbuchung direkt hier erfassen. Projektbuchungen erscheinen automatisch in der Projektabrechnung und können in Rechnungen übernommen werden.',
  tourActionsTitle: 'Aktionen',
  tourActionsText: 'Neuen Artikel anlegen, per CSV importieren oder eine Inventur durchführen. Falls IDS Connect mit einem Lieferanten konfiguriert ist, können Artikel direkt aus dem Lieferantenkatalog ins System übernommen werden.',
  movement: 'Bewegung',
  back: 'Zurück',
  page: 'Seite',
  next: 'Weiter',
  editItem: 'Artikel bearbeiten',
  newItem: 'Neuer Artikel',
  descriptionPlaceholder: 'Dachziegel Braas Tegalit',
  unitPlaceholder: 'Stk.',
  purchasePriceNet: 'Einkaufspreis (netto)',
  categoryPlaceholder: 'Dach, Holz, ...',
  stockLocation: 'Lagerort',
  locationPlaceholder: 'Regal A3',
  noSupplier: 'Kein Lieferant',
  initialStock: 'Anfangsbestand',
  deactivate: 'Deaktivieren',
  deactivateConfirm: 'Artikel deaktivieren?',
  priceOptional: 'Preis (optional)',
  noProject: 'Kein Projekt',
  notePlaceholder: 'Lieferschein-Nr., ...',
  book: 'Buchen',
  format: 'Format',
  datanormGeneric: 'DATANORM (generisch)',
  csvColumnsHint: 'CSV-Datei mit Spalten',
  datanormHint: 'DATANORM-Datei wird generisch ausgelesen (A-Sätze, Semikolon oder Fixed-Width).',
  reactivateInactiveExisting: 'Inaktive vorhandene Artikel reaktivieren',
  reactivateInactiveHint: 'Wenn deaktiviert, bleiben bereits inaktive Treffer weiterhin inaktiv.',
  newCount: 'neu',
  updatedCount: 'aktualisiert',
  reactivatedCount: 'reaktiviert',
  linesRead: 'Zeilen gelesen',
  aRecordsDetected: 'A-Sätze erkannt',
  metaRowsIgnored: 'Metazeilen ignoriert',
  problemRowsSkipped: 'problematische Zeilen übersprungen',
  errors: 'Fehler',
  skippedRowsPreview: 'Übersprungene Zeilen (Auszug)',
  errorsPreview: 'Fehler (Auszug)',
  row: 'Zeile',
  importRunning: 'Import laeuft ...',
  runtime: 'Laufzeit',
  bookItemsIds: 'Artikel einbuchen (IDS Connect)',
  checkQuantitiesPrices: 'Mengen und Preise prüfen, dann als Wareneingang einbuchen.',
  autoCreateMissing: 'Artikel die noch nicht im Lager vorhanden sind werden automatisch angelegt.',
  movIn: 'Wareneingang',
  movOut: 'Entnahme',
  movReturn: 'Rückgabe',
  movCorrection: 'Korrektur',
  quantityPositive: 'Menge muss eine positive Zahl sein',
  movementBooked: 'Warenbewegung gebucht',
  bookError: 'Fehler beim Buchen',
  loadError: 'Daten konnten nicht geladen werden',
  itemsImported: 'Artikel importiert',
  importFailed: 'Import fehlgeschlagen',
  noDatanorm: 'Keine DATANORM-Daten gefunden',
  popupBlocked: 'Popup wurde blockiert. Bitte Popup-Blocker deaktivieren.',
  noItemsFromCatalog: 'Keine Artikel aus dem Katalog empfangen',
  unitPiece: 'Stk.',
  catalogOpenError: 'Katalog konnte nicht geöffnet werden',
  idsOrderNote: 'IDS Connect Bestellung',
  itemsBookedAsGoodsReceipt: 'Artikel als Wareneingang eingebucht',
  bookingError: 'Fehler beim Einbuchen',
  delete: 'Löschen',
  deleteConfirm: 'Artikel wirklich löschen? Dies kann nicht rückgängig gemacht werden.',
  cannotDelete: 'Dieser Artikel kann nicht gelöscht werden',
  cannotDeleteHasStock: 'Artikel mit Bestand können nicht gelöscht werden',
  cannotDeleteHasMovements: 'Artikel mit Warenbewegungen können nicht gelöscht werden',
  deletedSuccessfully: 'Artikel gelöscht',
  deleteError: 'Fehler beim Löschen',
  deleteAll: 'Alle löschen',
  deleteAllBySupplier: 'Alle Materialien dieses Lieferanten löschen',
  deleteDeletableAll: 'Alle löschbaren Materialien löschen',
  deleteDeletableBySupplier: 'Löschbare Materialien des Lieferanten löschen',
  deleteDeletableConfirmAll: 'Wirklich alle löschbaren Materialien löschen? Gelöscht werden nur aktive Materialien ohne Bestand und ohne Warenbewegung.',
  deleteDeletableConfirmSupplier: 'Wirklich alle löschbaren Materialien von "{supplier}" löschen? Gelöscht werden nur aktive Materialien ohne Bestand und ohne Warenbewegung.',
  deleteDeletableSuccess: '{deleted} Materialien gelöscht, {skipped} übersprungen',
  deleteDeletableNoneFound: 'Keine löschbaren Materialien gefunden',
  details: 'Details',
  longText: 'Langtext',
  longTextPlaceholder: 'Optionaler Langtext',
  noLongText: 'Kein Langtext vorhanden',
  demandWarningTitleSingular: 'Bestellbedarf: 1 Material unter Meldebestand',
  demandWarningTitlePlural: 'Bestellbedarf: {count} Materialien unter Meldebestand',
  demandInOffers: 'Bedarf aus Angeboten',
  stockCurrent: 'Aktueller Bestand',
  shortage: 'Fehlmenge',
  scan: 'Scannen',
  qrLabel: 'QR-Label drucken',
  qrLabelError: 'QR-Label konnte nicht erstellt werden',
  selectItems: 'Artikel auswählen',
  selected: 'ausgewählt',
  printLabelsSelected: 'QR-Labels drucken (Auswahl)',
  scanChoiceTitle: 'Artikel gescannt',
  scanCheckStock: 'Bestand prüfen/buchen',
  scanForInventory: 'Für Inventur zählen',
  scanNotFound: 'Kein Artikel zu diesem QR-Code gefunden',
  selectAllFiltered: 'Alle auswählen',
  printLabelsMultiplePdfs: '{count} PDF-Dateien wurden geöffnet (je bis zu 200 Labels)',
  lockedByOther: 'Wird gerade bearbeitet von {name}',
};

const materialViewEn = {
  title: 'Warehouse',
  infoText: 'Here you can manage all materials and view inventory.',
  infoItem1: 'Create, edit, and delete materials',
  infoItem2: 'Filter and sort materials by category, supplier, and name',
  infoItem3: 'Keep an overview of inventory and stock value',
  infoItem4: 'Book materials in and out of inventory or projects',
  infoItem5: 'The "Delete all deletable items" button removes all active items without stock and without stock movements. This allows you to clean up your inventory and remove old items.',
  item: 'Item',
  items: 'items',
  inventory: 'Inventory count',
  import: 'Import',
  connecting: 'Connecting...',
  totalItems: 'Total items',
  minimumStock: 'Minimum stock',
  categories: 'Categories',
  stockValue: 'Stock value',
  searchPlaceholder: 'Search items...',
  allCategories: 'All categories',
  allSuppliers: 'All suppliers',
  onlyLowStock: 'Only low stock',
  articleNo: 'Article no.',
  description: 'Description',
  category: 'Category',
  stock: 'Stock',
  price: 'Price',
  supplier: 'Supplier',
  minimumStockBelow: 'Minimum stock undershot',
  searchAtSupplier: 'Search at supplier',
  stockMovement: 'Stock movement',
  startTour: 'Start tour',
  tourStatsTitle: 'Warehouse overview',
  tourStatsText: 'Number of items, items below minimum stock, categories and total stock value at a glance.',
  tourDemandTitle: 'Order requirements',
  tourDemandText: 'Items whose stock is below the minimum or that are needed in open quotes. Shown prominently so you can act quickly.',
  tourFilterTitle: 'Search & filter',
  tourFilterText: 'Filter by search term, category, supplier, or show only items below minimum stock.',
  tourTableTitle: 'Material list',
  tourTableText: 'All items with stock, price and storage location. Columns are sortable – click opens the detail view.',
  tourDetailTitle: 'Item details',
  tourDetailText: 'All information about the item: description, unit, price, supplier and current bookings.',
  tourMovementTitle: 'Book stock movement',
  tourMovementText: 'Record goods receipt, goods issue or project booking directly here. Project bookings appear automatically in project billing and can be included in invoices.',
  tourActionsTitle: 'Actions',
  tourActionsText: 'Create a new item, import via CSV, or run a stocktake. If IDS Connect is configured with a supplier, items can be imported directly from the supplier catalogue into the system.',
  movement: 'Movement',
  back: 'Back',
  page: 'Page',
  next: 'Next',
  editItem: 'Edit item',
  newItem: 'New item',
  descriptionPlaceholder: 'Roof tile Braas Tegalit',
  unitPlaceholder: 'pcs',
  purchasePriceNet: 'Purchase price (net)',
  categoryPlaceholder: 'Roof, wood, ...',
  stockLocation: 'Stock location',
  locationPlaceholder: 'Shelf A3',
  noSupplier: 'No supplier',
  initialStock: 'Initial stock',
  deactivate: 'Deactivate',
  deactivateConfirm: 'Deactivate item?',
  priceOptional: 'Price (optional)',
  noProject: 'No project',
  notePlaceholder: 'Delivery note no., ...',
  book: 'Book',
  format: 'Format',
  datanormGeneric: 'DATANORM (generic)',
  csvColumnsHint: 'CSV file with columns',
  datanormHint: 'DATANORM file is parsed generically (A-records, semicolon, or fixed-width).',
  reactivateInactiveExisting: 'Reactivate inactive existing items',
  reactivateInactiveHint: 'If disabled, already inactive matches remain inactive.',
  newCount: 'new',
  updatedCount: 'updated',
  reactivatedCount: 'reactivated',
  linesRead: 'lines read',
  aRecordsDetected: 'A-records detected',
  metaRowsIgnored: 'meta rows ignored',
  problemRowsSkipped: 'problematic rows skipped',
  errors: 'errors',
  skippedRowsPreview: 'Skipped rows (preview)',
  errorsPreview: 'Errors (preview)',
  row: 'Row',
  importRunning: 'Import running ...',
  runtime: 'Runtime',
  bookItemsIds: 'Book items (IDS Connect)',
  checkQuantitiesPrices: 'Check quantities and prices, then book as goods receipt.',
  autoCreateMissing: 'Items not yet in warehouse are created automatically.',
  movIn: 'Goods receipt',
  movOut: 'Withdrawal',
  movReturn: 'Return',
  movCorrection: 'Correction',
  quantityPositive: 'Quantity must be a positive number',
  movementBooked: 'Stock movement booked',
  bookError: 'Booking failed',
  itemsImported: 'items imported',
  importFailed: 'Import failed',
  noDatanorm: 'No DATANORM data found',
  popupBlocked: 'Popup was blocked. Please disable popup blocker.',
  noItemsFromCatalog: 'No items received from catalog',
  unitPiece: 'pcs',
  catalogOpenError: 'Could not open catalog',
  idsOrderNote: 'IDS Connect order',
  itemsBookedAsGoodsReceipt: 'items booked as goods receipt',
  bookingError: 'Booking failed',
  delete: 'Delete',
  deleteConfirm: 'Delete item? This cannot be undone.',
  cannotDelete: 'This item cannot be deleted',
  cannotDeleteHasStock: 'Items with stock cannot be deleted',
  cannotDeleteHasMovements: 'Items with stock movements cannot be deleted',
  deletedSuccessfully: 'Item deleted',
  deleteError: 'Error deleting item',
  deleteAll: 'Delete all',
  deleteAllBySupplier: 'Delete all items from this supplier',
  deleteDeletableAll: 'Delete all deletable items',
  deleteDeletableBySupplier: 'Delete deletable items for supplier',
  deleteDeletableConfirmAll: 'Delete all deletable items? Only active items without stock and without stock movements will be deleted.',
  deleteDeletableConfirmSupplier: 'Delete all deletable items for "{supplier}"? Only active items without stock and without stock movements will be deleted.',
  deleteDeletableSuccess: '{deleted} items deleted, {skipped} skipped',
  deleteDeletableNoneFound: 'No deletable items found',
  deletedCount: '{count} items deleted',
  details: 'Details',
  longText: 'Long text',
  longTextPlaceholder: 'Optional long text',
  noLongText: 'No long text available',
  demandWarningTitleSingular: 'Order needed: 1 material below reorder point',
  demandWarningTitlePlural: 'Order needed: {count} materials below reorder point',
  demandInOffers: 'Required by offers',
  stockCurrent: 'Current stock',
  shortage: 'Shortage',
  scan: 'Scan',
  qrLabel: 'Print QR label',
  qrLabelError: 'Could not create QR label',
  selectItems: 'Select items',
  selected: 'selected',
  printLabelsSelected: 'Print QR labels (selection)',
  scanChoiceTitle: 'Item scanned',
  scanCheckStock: 'Check / book stock',
  scanForInventory: 'Count for inventory',
  scanNotFound: 'No item found for this QR code',
  selectAllFiltered: 'Select all',
  printLabelsMultiplePdfs: '{count} PDF files were opened (up to 200 labels each)',
  lockedByOther: 'Currently being edited by {name}',
};

const materialViewFr = {
  title: 'Entrepot',
  infoText: 'Ici, vous pouvez gérer tous les matériaux et voir l\'inventaire.',
  infoItem1: 'Créer, modifier et supprimer des matériaux',
  infoItem2: 'Filtrer et trier les matériaux par catégorie, fournisseur et nom',
  infoItem3: 'Garder une vue d\'ensemble de l\'inventaire et de la valeur du stock',
  infoItem4: 'Enregistrer les matériaux dans et hors de l\'inventaire ou des projets',
  infoItem5: 'Le bouton "Supprimer tous les articles supprimables" supprime tous les articles actifs sans stock et sans mouvements de stock. Cela vous permet de nettoyer votre inventaire et de supprimer les anciens articles.',
  item: 'Article',
  items: 'articles',
  inventory: 'Inventaire',
  import: 'Import',
  connecting: 'Connexion...',
  totalItems: 'Articles au total',
  minimumStock: 'Stock minimum',
  categories: 'Categories',
  stockValue: 'Valeur du stock',
  searchPlaceholder: 'Rechercher articles...',
  allCategories: 'Toutes les categories',
  allSuppliers: 'Tous les fournisseurs',
  onlyLowStock: 'Seulement stock minimum',
  articleNo: 'No article',
  description: 'Designation',
  category: 'Categorie',
  stock: 'Stock',
  price: 'Prix',
  supplier: 'Fournisseur',
  minimumStockBelow: 'Stock minimum depasse',
  searchAtSupplier: 'Rechercher chez le fournisseur',
  stockMovement: 'Mouvement de stock',
  startTour: 'Lancer la visite guidée',
  tourStatsTitle: 'Vue d\'ensemble du stock',
  tourStatsText: 'Nombre d\'articles, articles en dessous du stock minimum, catégories et valeur totale du stock.',
  tourDemandTitle: 'Besoins de commande',
  tourDemandText: 'Articles dont le stock est inférieur au minimum ou nécessaires dans des devis ouverts. Affiché en évidence pour réagir rapidement.',
  tourFilterTitle: 'Recherche & filtre',
  tourFilterText: 'Filtrez par terme de recherche, catégorie, fournisseur ou affichez uniquement les articles en dessous du stock minimum.',
  tourTableTitle: 'Liste des matériaux',
  tourTableText: 'Tous les articles avec stock, prix et emplacement. Les colonnes sont triables – un clic ouvre la vue détail.',
  tourDetailTitle: 'Détails de l\'article',
  tourDetailText: 'Toutes les informations sur l\'article : description, unité, prix, fournisseur et réservations en cours.',
  tourMovementTitle: 'Enregistrer un mouvement',
  tourMovementText: 'Saisissez une entrée, sortie ou réservation projet ici. Les réservations projet apparaissent automatiquement dans la facturation et peuvent être incluses dans les factures.',
  tourActionsTitle: 'Actions',
  tourActionsText: 'Créer un article, importer via CSV ou effectuer un inventaire. Si IDS Connect est configuré avec un fournisseur, les articles peuvent être importés directement depuis le catalogue fournisseur.',
  movement: 'Mouvement',
  back: 'Retour',
  page: 'Page',
  next: 'Suivant',
  editItem: 'Modifier article',
  newItem: 'Nouvel article',
  descriptionPlaceholder: 'Tuile Braas Tegalit',
  unitPlaceholder: 'pcs',
  purchasePriceNet: 'Prix d\'achat (net)',
  categoryPlaceholder: 'Toit, bois, ...',
  stockLocation: 'Emplacement stock',
  locationPlaceholder: 'Etagere A3',
  noSupplier: 'Aucun fournisseur',
  initialStock: 'Stock initial',
  deactivate: 'Desactiver',
  deactivateConfirm: 'Desactiver article ?',
  priceOptional: 'Prix (optionnel)',
  noProject: 'Aucun projet',
  notePlaceholder: 'No bon de livraison, ...',
  book: 'Comptabiliser',
  format: 'Format',
  datanormGeneric: 'DATANORM (generique)',
  csvColumnsHint: 'Fichier CSV avec colonnes',
  datanormHint: 'Le fichier DATANORM est lu de facon generique (enregistrements A, point-virgule ou largeur fixe).',
  reactivateInactiveExisting: 'Reactiver les articles existants inactifs',
  reactivateInactiveHint: 'Si desactive, les correspondances deja inactives restent inactives.',
  newCount: 'nouveau',
  updatedCount: 'mis a jour',
  reactivatedCount: 'reactives',
  linesRead: 'lignes lues',
  aRecordsDetected: 'enregistrements A detectes',
  metaRowsIgnored: 'lignes meta ignorees',
  problemRowsSkipped: 'lignes problematiques ignorees',
  errors: 'erreurs',
  skippedRowsPreview: 'Lignes ignorees (apercu)',
  errorsPreview: 'Erreurs (apercu)',
  row: 'Ligne',
  importRunning: 'Import en cours ...',
  runtime: 'Duree',
  bookItemsIds: 'Comptabiliser articles (IDS Connect)',
  checkQuantitiesPrices: 'Verifier quantites et prix, puis comptabiliser en entree de marchandises.',
  autoCreateMissing: 'Les articles qui ne sont pas encore en stock sont crees automatiquement.',
  movIn: 'Entree de marchandises',
  movOut: 'Sortie',
  movReturn: 'Retour',
  movCorrection: 'Correction',
  quantityPositive: 'La quantite doit etre un nombre positif',
  movementBooked: 'Mouvement de stock comptabilise',
  bookError: 'Erreur de comptabilisation',
  itemsImported: 'articles importes',
  importFailed: 'Import echoue',
  noDatanorm: 'Aucune donnee DATANORM trouvee',
  popupBlocked: 'La popup a ete bloquee. Veuillez desactiver le bloqueur de popups.',
  noItemsFromCatalog: 'Aucun article recu du catalogue',
  unitPiece: 'pcs',
  catalogOpenError: 'Impossible d\'ouvrir le catalogue',
  idsOrderNote: 'Commande IDS Connect',
  itemsBookedAsGoodsReceipt: 'articles comptabilises en entree de marchandises',
  bookingError: 'Erreur de comptabilisation',
  delete: 'Supprimer',
  deleteConfirm: 'Supprimer l\'article? Cela ne peut pas etre annule.',
  cannotDelete: 'Cet article ne peut pas etre supprime',
  cannotDeleteHasStock: 'Les articles en stock ne peuvent pas etre supprimes',
  cannotDeleteHasMovements: 'Les articles avec mouvements ne peuvent pas etre supprimes',
  deletedSuccessfully: 'Article supprime',
  deleteError: 'Erreur lors de la suppression',
  deleteAll: 'Tout supprimer',
  deleteAllBySupplier: 'Supprimer tous les articles de ce fournisseur',
  deleteDeletableAll: 'Supprimer tous les articles supprimables',
  deleteDeletableBySupplier: 'Supprimer les articles supprimables du fournisseur',
  deleteDeletableConfirmAll: 'Supprimer tous les articles supprimables ? Seuls les articles actifs sans stock et sans mouvement de stock seront supprimes.',
  deleteDeletableConfirmSupplier: 'Supprimer tous les articles supprimables de "{supplier}" ? Seuls les articles actifs sans stock et sans mouvement de stock seront supprimes.',
  deleteDeletableSuccess: '{deleted} articles supprimes, {skipped} ignores',
  deleteDeletableNoneFound: 'Aucun article supprimable trouve',
  deletedCount: '{count} articles supprimes',
  details: 'Details',
  longText: 'Texte long',
  longTextPlaceholder: 'Texte long optionnel',
  noLongText: 'Aucun texte long disponible',
  demandWarningTitleSingular: 'Commande requise : 1 matériau sous le seuil',
  demandWarningTitlePlural: 'Commande requise : {count} matériaux sous le seuil',
  demandInOffers: 'Requis par offres',
  stockCurrent: 'Stock actuel',
  shortage: 'Manque',
  scan: 'Scanner',
  qrLabel: 'Imprimer l\'etiquette QR',
  qrLabelError: 'Impossible de creer l\'etiquette QR',
  selectItems: 'Selectionner des articles',
  selected: 'selectionne(s)',
  printLabelsSelected: 'Imprimer les etiquettes QR (selection)',
  scanChoiceTitle: 'Article scanne',
  scanCheckStock: 'Verifier / saisir le stock',
  scanForInventory: 'Compter pour l\'inventaire',
  scanNotFound: 'Aucun article trouve pour ce QR code',
  selectAllFiltered: 'Tout selectionner',
  printLabelsMultiplePdfs: '{count} fichiers PDF ont ete ouverts (jusqu\'a 200 etiquettes chacun)',
  lockedByOther: 'Actuellement modifie par {name}',
};

const materialViewIt = {
  title: 'Magazzino',
  infoText: 'Qui puoi gestire tutti i materiali e vedere l\'inventario.',
  infoItem1: 'Creare, modificare ed eliminare materiali',
  infoItem2: 'Filtrare e ordinare i materiali per categoria, fornitore e nome',
  infoItem3: 'Tenere sotto controllo l\'inventario e il valore dello stock',
  infoItem4: 'Registrare i materiali in entrata e uscita dall\'inventario o dai progetti',
  infoItem5: 'Il pulsante "Elimina tutti gli articoli eliminabili" rimuove tutti gli articoli attivi senza stock e senza movimenti di magazzino. Questo ti permette di pulire il tuo inventario e rimuovere i vecchi articoli.',
  item: 'Articolo',
  items: 'articoli',
  inventory: 'Inventario',
  import: 'Importa',
  connecting: 'Connessione...',
  totalItems: 'Articoli totali',
  minimumStock: 'Scorta minima',
  categories: 'Categorie',
  stockValue: 'Valore magazzino',
  searchPlaceholder: 'Cerca articoli...',
  allCategories: 'Tutte le categorie',
  allSuppliers: 'Tutti i fornitori',
  onlyLowStock: 'Solo scorta minima',
  articleNo: 'Codice articolo',
  description: 'Descrizione',
  category: 'Categoria',
  stock: 'Giacenza',
  price: 'Prezzo',
  supplier: 'Fornitore',
  minimumStockBelow: 'Scorta minima superata',
  searchAtSupplier: 'Cerca presso fornitore',
  stockMovement: 'Movimento di magazzino',
  startTour: 'Avvia la guida',
  tourStatsTitle: 'Panoramica magazzino',
  tourStatsText: 'Numero di articoli, articoli sotto scorta minima, categorie e valore totale del magazzino.',
  tourDemandTitle: 'Fabbisogno ordini',
  tourDemandText: 'Articoli con scorta sotto il minimo o necessari in preventivi aperti. Mostrato in evidenza per reagire rapidamente.',
  tourFilterTitle: 'Ricerca & filtro',
  tourFilterText: 'Filtra per termine, categoria, fornitore o mostra solo articoli sotto scorta minima.',
  tourTableTitle: 'Lista materiali',
  tourTableText: 'Tutti gli articoli con scorte, prezzo e ubicazione. Le colonne sono ordinabili – clic apre il dettaglio.',
  tourDetailTitle: 'Dettagli articolo',
  tourDetailText: 'Tutte le informazioni sull\'articolo: descrizione, unità, prezzo, fornitore e prenotazioni attuali.',
  tourMovementTitle: 'Registrare movimento',
  tourMovementText: 'Registra entrata, uscita o prenotazione progetto direttamente qui. Le prenotazioni progetto appaiono automaticamente nella fatturazione e possono essere incluse nelle fatture.',
  tourActionsTitle: 'Azioni',
  tourActionsText: 'Creare un articolo, importare via CSV o eseguire un inventario. Se IDS Connect è configurato con un fornitore, gli articoli possono essere importati direttamente dal catalogo fornitore.',
  movement: 'Movimento',
  back: 'Indietro',
  page: 'Pagina',
  next: 'Avanti',
  editItem: 'Modifica articolo',
  newItem: 'Nuovo articolo',
  descriptionPlaceholder: 'Tegola Braas Tegalit',
  unitPlaceholder: 'pz',
  purchasePriceNet: 'Prezzo acquisto (netto)',
  categoryPlaceholder: 'Tetto, legno, ...',
  stockLocation: 'Posizione magazzino',
  locationPlaceholder: 'Scaffale A3',
  noSupplier: 'Nessun fornitore',
  initialStock: 'Giacenza iniziale',
  deactivate: 'Disattiva',
  deactivateConfirm: 'Disattivare articolo?',
  priceOptional: 'Prezzo (opzionale)',
  noProject: 'Nessun progetto',
  notePlaceholder: 'Nr. bolla, ...',
  book: 'Registra',
  format: 'Formato',
  datanormGeneric: 'DATANORM (generico)',
  csvColumnsHint: 'File CSV con colonne',
  datanormHint: 'Il file DATANORM viene letto in modo generico (record A, punto e virgola o larghezza fissa).',
  reactivateInactiveExisting: 'Riattiva articoli esistenti inattivi',
  reactivateInactiveHint: 'Se disattivato, le corrispondenze gia inattive restano inattive.',
  newCount: 'nuovi',
  updatedCount: 'aggiornati',
  reactivatedCount: 'riattivati',
  linesRead: 'righe lette',
  aRecordsDetected: 'record A rilevati',
  metaRowsIgnored: 'righe meta ignorate',
  problemRowsSkipped: 'righe problematiche saltate',
  errors: 'errori',
  skippedRowsPreview: 'Righe saltate (anteprima)',
  errorsPreview: 'Errori (anteprima)',
  row: 'Riga',
  importRunning: 'Import in corso ...',
  runtime: 'Durata',
  bookItemsIds: 'Registra articoli (IDS Connect)',
  checkQuantitiesPrices: 'Controlla quantita e prezzi, poi registra come entrata merce.',
  autoCreateMissing: 'Gli articoli non ancora presenti a magazzino vengono creati automaticamente.',
  movIn: 'Entrata merce',
  movOut: 'Prelievo',
  movReturn: 'Reso',
  movCorrection: 'Correzione',
  quantityPositive: 'La quantita deve essere un numero positivo',
  movementBooked: 'Movimento registrato',
  bookError: 'Registrazione non riuscita',
  itemsImported: 'articoli importati',
  importFailed: 'Import non riuscito',
  noDatanorm: 'Nessun dato DATANORM trovato',
  popupBlocked: 'Popup bloccato. Disattiva il blocco popup.',
  noItemsFromCatalog: 'Nessun articolo ricevuto dal catalogo',
  unitPiece: 'pz',
  catalogOpenError: 'Impossibile aprire catalogo',
  idsOrderNote: 'Ordine IDS Connect',
  itemsBookedAsGoodsReceipt: 'articoli registrati come entrata merce',
  bookingError: 'Errore durante registrazione',
  delete: 'Elimina',
  deleteConfirm: 'Eliminare l\'articolo? Questa azione non puo essere annullata.',
  cannotDelete: 'Questo articolo non puo essere eliminato',
  cannotDeleteHasStock: 'Gli articoli con stock non possono essere eliminati',
  cannotDeleteHasMovements: 'Gli articoli con movimenti non possono essere eliminati',
  deletedSuccessfully: 'Articolo eliminato',
  deleteError: 'Errore durante l\'eliminazione',
  deleteAll: 'Elimina tutto',
  deleteAllBySupplier: 'Elimina tutti gli articoli da questo fornitore',
  deleteDeletableAll: 'Elimina tutti gli articoli eliminabili',
  deleteDeletableBySupplier: 'Elimina articoli eliminabili del fornitore',
  deleteDeletableConfirmAll: 'Eliminare tutti gli articoli eliminabili? Verranno eliminati solo gli articoli attivi senza giacenza e senza movimenti di magazzino.',
  deleteDeletableConfirmSupplier: 'Eliminare tutti gli articoli eliminabili di "{supplier}"? Verranno eliminati solo gli articoli attivi senza giacenza e senza movimenti di magazzino.',
  deleteDeletableSuccess: '{deleted} articoli eliminati, {skipped} saltati',
  deleteDeletableNoneFound: 'Nessun articolo eliminabile trovato',
  deletedCount: '{count} articoli eliminati',
  details: 'Dettagli',
  longText: 'Testo lungo',
  longTextPlaceholder: 'Testo lungo opzionale',
  noLongText: 'Nessun testo lungo disponibile',
  demandWarningTitleSingular: 'Ordine necessario: 1 materiale sotto la soglia',
  demandWarningTitlePlural: 'Ordine necessario: {count} materiali sotto la soglia',
  demandInOffers: 'Richiesto dalle offerte',
  stockCurrent: 'Scorte attuali',
  shortage: 'Carenza',
  scan: 'Scansiona',
  qrLabel: 'Stampa etichetta QR',
  qrLabelError: 'Impossibile creare l\'etichetta QR',
  selectItems: 'Seleziona articoli',
  selected: 'selezionati',
  printLabelsSelected: 'Stampa etichette QR (selezione)',
  scanChoiceTitle: 'Articolo scansionato',
  scanCheckStock: 'Verifica / registra giacenza',
  scanForInventory: 'Conta per inventario',
  scanNotFound: 'Nessun articolo trovato per questo QR code',
  selectAllFiltered: 'Seleziona tutto',
  printLabelsMultiplePdfs: '{count} file PDF sono stati aperti (fino a 200 etichette ciascuno)',
  lockedByOther: 'Attualmente in modifica da {name}',
};

const materialViewPl = {
  title: 'Magazyn',
  infoText: 'Tutaj możesz zarządzać wszystkimi materiałami i przeglądać stan magazynu.',
  infoItem1: 'Tworzenie, edytowanie i usuwanie materiałów',
  infoItem2: 'Filtrowanie i sortowanie materiałów według kategorii, dostawcy i nazwy',
  infoItem3: 'Utrzymywanie przeglądu stanu magazynu i wartości zapasów',
  infoItem4: 'Księgowanie materiałów przychodzących i wychodzących z magazynu lub projektów',
  infoItem5: 'Przycisk "Usuń wszystkie usuwalne artykuły" usuwa wszystkie aktywne artykuły bez zapasu i bez ruchów magazynowych. Dzięki temu możesz posprzątać swój magazyn i usunąć stare artykuły.',
  item: 'Artykul',
  items: 'artykuly',
  inventory: 'Inwentaryzacja',
  import: 'Import',
  connecting: 'Laczenie...',
  totalItems: 'Artykuly lacznie',
  minimumStock: 'Stan minimalny',
  categories: 'Kategorie materialowe',
  stockValue: 'Wartosc magazynu',
  searchPlaceholder: 'Szukaj artykulow...',
  allCategories: 'Wszystkie kategorie',
  allSuppliers: 'Wszyscy dostawcy',
  onlyLowStock: 'Tylko stan minimalny',
  articleNo: 'Nr artykulu',
  description: 'Opis',
  category: 'Kategoria',
  stock: 'Stan',
  price: 'Cena',
  supplier: 'Dostawca',
  minimumStockBelow: 'Przekroczono stan minimalny',
  searchAtSupplier: 'Szukaj u dostawcy',
  stockMovement: 'Ruch magazynowy',
  startTour: 'Uruchom przewodnik',
  tourStatsTitle: 'Przegląd magazynu',
  tourStatsText: 'Liczba artykułów, artykuły poniżej minimum, kategorie i łączna wartość magazynu.',
  tourDemandTitle: 'Zapotrzebowanie na zamówienia',
  tourDemandText: 'Artykuły, których stan jest poniżej minimum lub są potrzebne w otwartych ofertach. Widoczne wyraźnie, by szybko zareagować.',
  tourFilterTitle: 'Wyszukiwanie i filtr',
  tourFilterText: 'Filtruj według frazy, kategorii, dostawcy lub pokaż tylko artykuły poniżej stanu minimalnego.',
  tourTableTitle: 'Lista materiałów',
  tourTableText: 'Wszystkie artykuły z zapasem, ceną i lokalizacją. Kolumny są sortowalne – klik otwiera szczegóły.',
  tourDetailTitle: 'Szczegóły artykułu',
  tourDetailText: 'Wszystkie informacje o artykule: opis, jednostka, cena, dostawca i aktualne rezerwacje.',
  tourMovementTitle: 'Zaksięguj ruch magazynowy',
  tourMovementText: 'Wprowadź przyjęcie, wydanie lub rezerwację projektu. Rezerwacje projektu pojawiają się automatycznie w rozliczeniu projektu i można je uwzględnić w fakturach.',
  tourActionsTitle: 'Akcje',
  tourActionsText: 'Utwórz artykuł, importuj przez CSV lub przeprowadź inwentaryzację. Jeśli IDS Connect jest skonfigurowany z dostawcą, artykuły można importować bezpośrednio z katalogu dostawcy.',
  movement: 'Ruch',
  back: 'Powrot',
  page: 'Strona',
  next: 'Dalej',
  editItem: 'Edytuj artykul',
  newItem: 'Nowy artykul',
  descriptionPlaceholder: 'Dachowka Braas Tegalit',
  unitPlaceholder: 'szt.',
  purchasePriceNet: 'Cena zakupu (netto)',
  categoryPlaceholder: 'Dach, drewno, ...',
  stockLocation: 'Lokalizacja magazynowa',
  locationPlaceholder: 'Regal A3',
  noSupplier: 'Brak dostawcy',
  initialStock: 'Stan poczatkowy',
  deactivate: 'Dezaktywuj',
  deactivateConfirm: 'Dezaktywowac artykul?',
  priceOptional: 'Cena (opcjonalnie)',
  noProject: 'Brak projektu',
  notePlaceholder: 'Nr WZ, ...',
  book: 'Ksieguj',
  format: 'Format',
  datanormGeneric: 'DATANORM (generyczny)',
  csvColumnsHint: 'Plik CSV z kolumnami',
  datanormHint: 'Plik DATANORM jest odczytywany generycznie (rekordy A, srednik lub stala szerokosc).',
  reactivateInactiveExisting: 'Reaktywuj istniejace nieaktywne artykuly',
  reactivateInactiveHint: 'Gdy wylaczone, juz nieaktywne dopasowania pozostaja nieaktywne.',
  newCount: 'nowe',
  updatedCount: 'zaktualizowane',
  reactivatedCount: 'reaktywowane',
  linesRead: 'odczytane wiersze',
  aRecordsDetected: 'wykryto rekordy A',
  metaRowsIgnored: 'zignorowano wiersze meta',
  problemRowsSkipped: 'pominieto problematyczne wiersze',
  errors: 'bledy',
  skippedRowsPreview: 'Pominiete wiersze (podglad)',
  errorsPreview: 'Bledy (podglad)',
  row: 'Wiersz',
  importRunning: 'Import trwa ...',
  runtime: 'Czas trwania',
  bookItemsIds: 'Ksieguj artykuly (IDS Connect)',
  checkQuantitiesPrices: 'Sprawdz ilosci i ceny, nastepnie zaksieguj jako przyjecie towaru.',
  autoCreateMissing: 'Artykuly, ktorych nie ma jeszcze w magazynie, sa tworzone automatycznie.',
  movIn: 'Przyjecie towaru',
  movOut: 'Wydanie',
  movReturn: 'Zwrot',
  movCorrection: 'Korekta',
  quantityPositive: 'Ilosc musi byc liczba dodatnia',
  movementBooked: 'Ruch magazynowy zaksiegowany',
  bookError: 'Ksiegowanie nieudane',
  itemsImported: 'zaimportowane artykuly',
  importFailed: 'Import nieudany',
  noDatanorm: 'Nie znaleziono danych DATANORM',
  popupBlocked: 'Popup zostal zablokowany. Wylacz blokowanie popupow.',
  noItemsFromCatalog: 'Nie otrzymano artykulow z katalogu',
  unitPiece: 'szt.',
  catalogOpenError: 'Nie mozna otworzyc katalogu',
  idsOrderNote: 'Zamowienie IDS Connect',
  itemsBookedAsGoodsReceipt: 'artykuly zaksiegowano jako przyjecie towaru',
  bookingError: 'Blad ksiegowania',
  delete: 'Usunac',
  deleteConfirm: 'Usunac towar? Tej operacji nie mozna cofnac.',
  cannotDelete: 'Tego towaru nie mozna usunac',
  cannotDeleteHasStock: 'Towary posiadajace zapas nie moga byc usuwane',
  cannotDeleteHasMovements: 'Towary z ruchami magazynowymi nie moga byc usuwane',
  deletedSuccessfully: 'Towar usuniety',
  deleteError: 'Blad przy usuwaniu towaru',
  deleteAll: 'Usun wszystko',
  deleteAllBySupplier: 'Usun wszystkie artykuly tego dostawcy',
  deleteDeletableAll: 'Usun wszystkie usuwalne artykuly',
  deleteDeletableBySupplier: 'Usun usuwalne artykuly dostawcy',
  deleteDeletableConfirmAll: 'Usunac wszystkie usuwalne artykuly? Usuniete zostana tylko aktywne artykuly bez stanu i bez ruchow magazynowych.',
  deleteDeletableConfirmSupplier: 'Usunac wszystkie usuwalne artykuly dostawcy "{supplier}"? Usuniete zostana tylko aktywne artykuly bez stanu i bez ruchow magazynowych.',
  deleteDeletableSuccess: 'Usunieto {deleted} artykulow, pominieto {skipped}',
  deleteDeletableNoneFound: 'Nie znaleziono usuwalnych artykulow',
  deletedCount: 'Usunieto {count} towarow',
  details: 'Szczegoly',
  longText: 'Opis rozszerzony',
  longTextPlaceholder: 'Opcjonalny opis rozszerzony',
  noLongText: 'Brak opisu rozszerzonego',
  demandWarningTitleSingular: 'Zamówienie wymagane: 1 materiał poniżej progu',
  demandWarningTitlePlural: 'Zamówienie wymagane: {count} materiałów poniżej progu',
  demandInOffers: 'Wymagane przez oferty',
  stockCurrent: 'Aktualny stan',
  shortage: 'Niedobór',
  scan: 'Skanuj',
  qrLabel: 'Drukuj etykiete QR',
  qrLabelError: 'Nie udalo sie utworzyc etykiety QR',
  selectItems: 'Wybierz artykuly',
  selected: 'wybranych',
  printLabelsSelected: 'Drukuj etykiety QR (wybor)',
  scanChoiceTitle: 'Zeskanowano artykul',
  scanCheckStock: 'Sprawdz / zaksieguj stan',
  scanForInventory: 'Policz do inwentaryzacji',
  scanNotFound: 'Nie znaleziono artykulu dla tego kodu QR',
  selectAllFiltered: 'Zaznacz wszystko',
  printLabelsMultiplePdfs: 'Otwarto {count} plikow PDF (po maksymalnie 200 etykiet)',
  lockedByOther: 'Aktualnie edytowane przez {name}',
};

const materialViewCs = {
  title: 'Sklad',
  infoText: 'Zde můžete spravovat všechny materiály a zobrazit inventuru.',
  infoItem1: 'Vytvářet, upravovat a mazat materiály',
  infoItem2: 'Filtrovat a třídit materiály podle kategorie, dodavatele a názvu',
  infoItem3: 'Mít přehled o inventu a hodnotě zásob',
  infoItem4: 'Zaúčtovat materiály příchozí a odchozí ze skladu nebo projektů',
  infoItem5: 'Tlačítko "Smazat všechny smazatelné položky" odstraní všechny aktivní položky bez zásob a bez pohybů skladu. To vám umožní uklidit váš sklad a odstranit staré položky.',
  item: 'Polozka',
  items: 'polozky',
  inventory: 'Inventura',
  import: 'Import',
  connecting: 'Pripojovani...',
  totalItems: 'Polozky celkem',
  minimumStock: 'Minimalni zasoba',
  categories: 'Kategorie materialu',
  stockValue: 'Hodnota skladu',
  searchPlaceholder: 'Hledat polozky...',
  allCategories: 'Vsechny kategorie',
  allSuppliers: 'Vsichni dodavatele',
  onlyLowStock: 'Jen minimalni zasoba',
  articleNo: 'Cislo polozky',
  description: 'Popis',
  category: 'Kategorie',
  stock: 'Zasoba',
  price: 'Cena',
  supplier: 'Dodavatel',
  minimumStockBelow: 'Minimalni zasoba prekrocena',
  searchAtSupplier: 'Hledat u dodavatele',
  stockMovement: 'Pohyb skladu',
  startTour: 'Spustit průvodce',
  tourStatsTitle: 'Přehled skladu',
  tourStatsText: 'Počet položek, položky pod minimální zásobou, kategorie a celková hodnota skladu.',
  tourDemandTitle: 'Potřeba objednávek',
  tourDemandText: 'Položky, jejichž stav je pod minimem nebo jsou potřeba v otevřených nabídkách. Zobrazeno výrazně pro rychlou reakci.',
  tourFilterTitle: 'Hledání a filtr',
  tourFilterText: 'Filtrujte podle pojmu, kategorie, dodavatele nebo zobrazte pouze položky pod minimální zásobou.',
  tourTableTitle: 'Seznam materiálů',
  tourTableText: 'Všechny položky s zásobou, cenou a umístěním. Sloupce jsou řaditelné – klik otevře detail.',
  tourDetailTitle: 'Detail položky',
  tourDetailText: 'Všechny informace o položce: popis, jednotka, cena, dodavatel a aktuální rezervace.',
  tourMovementTitle: 'Zaznamenat pohyb',
  tourMovementText: 'Zaznamenejte příjem, výdej nebo rezervaci projektu přímo zde. Rezervace projektu se automaticky zobrazí ve fakturaci projektu a mohou být zahrnuty do faktur.',
  tourActionsTitle: 'Akce',
  tourActionsText: 'Vytvořte položku, importujte přes CSV nebo proveďte inventuru. Pokud je IDS Connect nakonfigurován s dodavatelem, lze položky importovat přímo z katalogu dodavatele.',
  movement: 'Pohyb',
  back: 'Zpet',
  page: 'Strana',
  next: 'Dalsi',
  editItem: 'Upravit polozku',
  newItem: 'Nova polozka',
  descriptionPlaceholder: 'Stresni taska Braas Tegalit',
  unitPlaceholder: 'ks',
  purchasePriceNet: 'Nakupni cena (netto)',
  categoryPlaceholder: 'Strecha, drevo, ...',
  stockLocation: 'Umisteni skladu',
  locationPlaceholder: 'Regal A3',
  noSupplier: 'Bez dodavatele',
  initialStock: 'Pocatecni zasoba',
  deactivate: 'Deaktivovat',
  deactivateConfirm: 'Deaktivovat polozku?',
  priceOptional: 'Cena (volitelne)',
  noProject: 'Bez projektu',
  notePlaceholder: 'C. dodaciho listu, ...',
  book: 'Zauctovat',
  format: 'Format',
  datanormGeneric: 'DATANORM (obecny)',
  csvColumnsHint: 'CSV soubor se sloupci',
  datanormHint: 'Soubor DATANORM se nacita obecne (A-zaznamy, strednik nebo pevna sirka).',
  reactivateInactiveExisting: 'Znovu aktivovat existujici neaktivni polozky',
  reactivateInactiveHint: 'Pokud je vypnuto, jiz neaktivni shody zustanou neaktivni.',
  newCount: 'nove',
  updatedCount: 'aktualizovano',
  reactivatedCount: 'znovu aktivovano',
  linesRead: 'nactenych radku',
  aRecordsDetected: 'detekovany A-zaznamy',
  metaRowsIgnored: 'meta radky ignorovany',
  problemRowsSkipped: 'problematicke radky preskoceny',
  errors: 'chyby',
  skippedRowsPreview: 'Preskocene radky (nahled)',
  errorsPreview: 'Chyby (nahled)',
  row: 'Radek',
  importRunning: 'Import probiha ...',
  runtime: 'Doba behu',
  bookItemsIds: 'Zauctovat polozky (IDS Connect)',
  checkQuantitiesPrices: 'Zkontrolujte mnozstvi a ceny, pote zauctujte jako prijem zbozi.',
  autoCreateMissing: 'Polozky, ktere jeste nejsou na sklade, budou automaticky vytvoreny.',
  movIn: 'Prijem zbozi',
  movOut: 'Vydej',
  movReturn: 'Vraceni',
  movCorrection: 'Korekce',
  quantityPositive: 'Mnozstvi musi byt kladne cislo',
  movementBooked: 'Pohyb skladu zauctovan',
  bookError: 'Zauctovani selhalo',
  itemsImported: 'polozky importovany',
  importFailed: 'Import selhal',
  noDatanorm: 'Nenalezena zadna DATANORM data',
  popupBlocked: 'Popup byl zablokovan. Vypnete blokator popup oken.',
  noItemsFromCatalog: 'Z katalogu nebyly prijaty zadne polozky',
  unitPiece: 'ks',
  catalogOpenError: 'Katalog se nepodarilo otevrit',
  idsOrderNote: 'Objednavka IDS Connect',
  itemsBookedAsGoodsReceipt: 'polozky zauctovany jako prijem zbozi',
  bookingError: 'Chyba pri zauctovani',
  delete: 'Smazat',
  deleteConfirm: 'Smazat polozku? Tuto operaci nelze vratit zpet.',
  cannotDelete: 'Tato polozka nemu\ue017e byt smazana',
  cannotDeleteHasStock: 'Polozky se skladem nemohou byt smazany',
  cannotDeleteHasMovements: 'Polozky s pohyby skladem nemohou byt smazany',
  deletedSuccessfully: 'Polozka smazana',
  deleteError: 'Chyba pri mazani polozky',
  deleteAll: 'Smazat vse',
  deleteAllBySupplier: 'Smazat vse polozky od tohoto dodavatele',
  deleteDeletableAll: 'Smazat vse smazatelne polozky',
  deleteDeletableBySupplier: 'Smazat smazatelne polozky dodavatele',
  deleteDeletableConfirmAll: 'Opravdu smazat vse smazatelne polozky? Smazany budou pouze aktivni polozky bez zasoby a bez skladovych pohybu.',
  deleteDeletableConfirmSupplier: 'Opravdu smazat vse smazatelne polozky dodavatele "{supplier}"? Smazany budou pouze aktivni polozky bez zasoby a bez skladovych pohybu.',
  deleteDeletableSuccess: 'Smazano {deleted} polozek, preskoceno {skipped}',
  deleteDeletableNoneFound: 'Nebyly nalezeny zadne smazatelne polozky',
  deletedCount: 'Smazan {count} polozek',
  details: 'Detaily',
  longText: 'Dlouhy text',
  longTextPlaceholder: 'Volitelny dlouhy text',
  noLongText: 'Neni k dispozici zadny dlouhy text',
  demandWarningTitleSingular: 'Objednávka potřebná: 1 materiál pod hranicí',
  demandWarningTitlePlural: 'Objednávka potřebná: {count} materiálů pod hranicí',
  demandInOffers: 'Požadováno nabídkami',
  stockCurrent: 'Aktuální zásoba',
  shortage: 'Nedostatek',
  scan: 'Skenovat',
  qrLabel: 'Vytisknout QR stitek',
  qrLabelError: 'QR stitek se nepodarilo vytvorit',
  selectItems: 'Vybrat polozky',
  selected: 'vybrano',
  printLabelsSelected: 'Vytisknout QR stitky (vyber)',
  scanChoiceTitle: 'Polozka naskenovana',
  scanCheckStock: 'Zkontrolovat / zaknihovat stav',
  scanForInventory: 'Spocitat pro inventuru',
  scanNotFound: 'Pro tento QR kod nebyla nalezena zadna polozka',
  selectAllFiltered: 'Vybrat vse',
  printLabelsMultiplePdfs: 'Bylo otevreno {count} PDF souboru (max. 200 stitku kazdy)',
  lockedByOther: 'Prave upravuje {name}',
};

const supplierViewDe = {
  title: 'Lieferanten',
  infoText: 'Hier kannst du Lieferanten verwalten.',
  infoItem1: 'Lieferanten anlegen, bearbeiten und löschen',
  infoItem2: 'Lieferantenübersicht mit Such- und Filterfunktion',
  infoItem3: 'Lieferantendetails mit Kontaktinformationen',
  suppliers: 'Lieferanten',
  newSupplier: 'Neuer Lieferant',
  noneYet: 'Noch keine Lieferanten',
  startTour: 'Führung starten',
  tourSearchTitle: 'Suche',
  tourSearchText: 'Filtere Lieferanten nach Name, Ansprechpartner oder Ort.',
  tourTableTitle: 'Lieferantenliste',
  tourTableText: 'Alle Lieferanten mit Ansprechpartner, E-Mail, Ort und Anzahl verknüpfter Materialien. Spalten sind sortierbar.',
  tourNewTitle: 'Neuer Lieferant',
  tourNewText: 'Legt einen neuen Lieferanten an – Lieferanten können dann Materialien zugeordnet werden.',
  tourModalTitle: 'Lieferantenformular',
  tourModalText: 'Name, Ansprechpartner, Kontaktdaten, Adresse und optionale Lieferantennummer erfassen.',
  editSupplier: 'Lieferant bearbeiten',
  supplierNo: 'Lieferanten-Nr.',
  deleteConfirm: 'Lieferant löschen?',
  lockedByOther: 'Wird gerade bearbeitet von {name}'
};

const supplierViewEn = {
  title: 'Suppliers',
  infoText: 'Here you can manage suppliers.',
  infoItem1: 'Create, edit and delete suppliers',
  infoItem2: 'Supplier overview with search and filter functionality',
  infoItem3: 'Supplier details with contact information',
  suppliers: 'suppliers',
  newSupplier: 'New supplier',
  noneYet: 'No suppliers yet',
  startTour: 'Start tour',
  tourSearchTitle: 'Search',
  tourSearchText: 'Filter suppliers by name, contact person or city.',
  tourTableTitle: 'Supplier list',
  tourTableText: 'All suppliers with contact, email, city and number of linked materials. Columns are sortable.',
  tourNewTitle: 'New supplier',
  tourNewText: 'Creates a new supplier – suppliers can then be assigned to materials.',
  tourModalTitle: 'Supplier form',
  tourModalText: 'Enter name, contact person, contact details, address and optional supplier number.',
  editSupplier: 'Edit supplier',
  supplierNo: 'Supplier no.',
  deleteConfirm: 'Delete supplier?',
  lockedByOther: 'Currently being edited by {name}'
};

const supplierViewFr = {
  title: 'Fournisseurs',
  infoText: 'Ici, vous pouvez gérer les fournisseurs.',
  infoItem1: 'Créer, modifier et supprimer des fournisseurs',
  infoItem2: 'Vue d\'ensemble des fournisseurs avec fonction de recherche et de filtrage',
  infoItem3: 'Détails du fournisseur avec informations de contact',
  suppliers: 'fournisseurs',
  newSupplier: 'Nouveau fournisseur',
  noneYet: 'Aucun fournisseur pour le moment',
  startTour: 'Lancer la visite guidée',
  tourSearchTitle: 'Recherche',
  tourSearchText: 'Filtrez les fournisseurs par nom, interlocuteur ou ville.',
  tourTableTitle: 'Liste des fournisseurs',
  tourTableText: 'Tous les fournisseurs avec interlocuteur, e-mail, ville et nombre de matériaux liés. Les colonnes sont triables.',
  tourNewTitle: 'Nouveau fournisseur',
  tourNewText: 'Crée un nouveau fournisseur – les fournisseurs peuvent ensuite être assignés aux matériaux.',
  tourModalTitle: 'Formulaire fournisseur',
  tourModalText: 'Saisissez nom, interlocuteur, coordonnées, adresse et numéro fournisseur optionnel.',
  editSupplier: 'Modifier fournisseur',
  supplierNo: 'No fournisseur',
  deleteConfirm: 'Supprimer fournisseur ?',
  lockedByOther: 'Actuellement modifie par {name}'
};

const supplierViewIt = {
  title: 'Fornitori',
  infoText: 'Qui puoi gestire i fornitori.',
  infoItem1: 'Creare, modificare e eliminare fornitori',
  infoItem2: 'Panoramica dei fornitori con funzionalità di ricerca e filtraggio',
  infoItem3: 'Dettagli del fornitore con informazioni di contatto',
  suppliers: 'fornitori',
  newSupplier: 'Nuovo fornitore',
  noneYet: 'Nessun fornitore al momento',
  startTour: 'Avvia la guida',
  tourSearchTitle: 'Ricerca',
  tourSearchText: 'Filtra i fornitori per nome, referente o città.',
  tourTableTitle: 'Lista fornitori',
  tourTableText: 'Tutti i fornitori con referente, e-mail, città e numero di materiali collegati. Le colonne sono ordinabili.',
  tourNewTitle: 'Nuovo fornitore',
  tourNewText: 'Crea un nuovo fornitore – i fornitori possono poi essere assegnati ai materiali.',
  tourModalTitle: 'Modulo fornitore',
  tourModalText: 'Inserisci nome, referente, contatti, indirizzo e numero fornitore opzionale.',
  editSupplier: 'Modifica fornitore',
  supplierNo: 'Codice fornitore',
  deleteConfirm: 'Eliminare fornitore?',
  lockedByOther: 'Attualmente in modifica da {name}'
};

const supplierViewPl = {
  title: 'Dostawcy',
  infoText: 'Tutaj możesz zarządzać dostawcami.',
  infoItem1: 'Tworzenie, edytowanie i usuwanie dostawców',
  infoItem2: 'Przegląd dostawców z funkcją wyszukiwania i filtrowania',
  infoItem3: 'Szczegóły dostawcy z informacjami kontaktowymi',
  suppliers: 'dostawcy',
  newSupplier: 'Nowy dostawca',
  noneYet: 'Brak dostawcow',
  startTour: 'Uruchom przewodnik',
  tourSearchTitle: 'Wyszukiwanie',
  tourSearchText: 'Filtruj dostawców według nazwy, osoby kontaktowej lub miasta.',
  tourTableTitle: 'Lista dostawców',
  tourTableText: 'Wszyscy dostawcy z osobą kontaktową, e-mailem, miastem i liczbą powiązanych materiałów. Kolumny są sortowalne.',
  tourNewTitle: 'Nowy dostawca',
  tourNewText: 'Tworzy nowego dostawcę – dostawcy mogą być następnie przypisani do materiałów.',
  tourModalTitle: 'Formularz dostawcy',
  tourModalText: 'Wprowadź nazwę, osobę kontaktową, dane kontaktowe, adres i opcjonalny numer dostawcy.',
  editSupplier: 'Edytuj dostawce',
  supplierNo: 'Nr dostawcy',
  deleteConfirm: 'Usunac dostawce?',
  lockedByOther: 'Aktualnie edytowane przez {name}'
};

const supplierViewCs = {
  title: 'Dodavatele',
  infoText: 'Zde můžete spravovat dodavatele.',
  infoItem1: 'Vytvářet, upravovat a mazat dodavatele',
  infoItem2: 'Přehled dodavatelů s funkcí hledání a filtrování',
  infoItem3: 'Detaily dodavatele s kontaktními informacemi',
  suppliers: 'dodavatele',
  newSupplier: 'Novy dodavatel',
  noneYet: 'Zatim zadni dodavatele',
  startTour: 'Spustit průvodce',
  tourSearchTitle: 'Vyhledávání',
  tourSearchText: 'Filtrujte dodavatele podle názvu, kontaktní osoby nebo města.',
  tourTableTitle: 'Seznam dodavatelů',
  tourTableText: 'Všichni dodavatelé s kontaktní osobou, e-mailem, městem a počtem propojených materiálů. Sloupce jsou řaditelné.',
  tourNewTitle: 'Nový dodavatel',
  tourNewText: 'Vytvoří nového dodavatele – dodavatelé pak mohou být přiřazeni k materiálům.',
  tourModalTitle: 'Formulář dodavatele',
  tourModalText: 'Zadejte název, kontaktní osobu, kontaktní údaje, adresu a volitelné číslo dodavatele.',
  editSupplier: 'Upravit dodavatele',
  supplierNo: 'Cislo dodavatele',
  deleteConfirm: 'Smazat dodavatele?',
  lockedByOther: 'Prave upravuje {name}'
};

const importWizardDe = {
  button: 'Importieren',
  title: 'Stammdaten-Import',
  stepOf: 'Schritt {step} von {total}',
  chooseEntityHint: 'Welche Daten möchtest du importieren?',
  noEntities: 'Keine importierbaren Daten verfügbar.',
  uploadHint: 'CSV- oder Excel-Datei (.xlsx) hochladen.',
  analyzing: 'Datei wird gelesen …',
  analyzeError: 'Datei konnte nicht gelesen werden.',
  targetField: 'Zielfeld',
  sourceColumn: 'Quellspalte',
  notMapped: '– nicht zuordnen –',
  loadTemplate: 'Gespeicherte Zuordnung laden …',
  templateNamePlaceholder: 'Name für Vorlage',
  saveTemplate: 'Als Vorlage speichern',
  templateSaved: 'Vorlage gespeichert.',
  truncatedHint: 'Datei hat mehr als {max} Zeilen, es werden nur die ersten {max} importiert.',
  duplicateStrategy: 'Bei bestehenden Datensätzen',
  strategySkip: 'Überspringen',
  strategyUpdate: 'Aktualisieren',
  strategyCreate: 'Trotzdem neu anlegen',
  ok: 'OK',
  invalid: 'Fehlerhaft',
  duplicatesFound: 'Duplikate',
  status: 'Status',
  error: 'Fehler',
  duplicate: 'Duplikat',
  next: 'Weiter',
  startImport: 'Import starten',
  newCount: 'neu angelegt',
  updatedCount: 'aktualisiert',
  skippedCount: 'übersprungen',
  undo: 'Rückgängig machen',
  reverted: 'Import wurde rückgängig gemacht.',
  undoSuccess: 'Import wurde rückgängig gemacht.',
  importSuccess: 'Import abgeschlossen.',
  importError: 'Import fehlgeschlagen.',
  loadError: 'Daten konnten nicht geladen werden.',
  settingsCardTitle: 'Stammdaten-Import',
  settingsCardHint: 'Kunden-, Lieferanten- und weitere Stammdaten aus einem anderen System übernehmen.',
  history: 'Letzte Importe',
  noHistory: 'Noch keine Importe.',
  entity: 'Daten',
  date: 'Datum',
};

const importWizardEn = {
  button: 'Import',
  title: 'Master Data Import',
  stepOf: 'Step {step} of {total}',
  chooseEntityHint: 'Which data would you like to import?',
  noEntities: 'No importable data available.',
  uploadHint: 'Upload a CSV or Excel (.xlsx) file.',
  analyzing: 'Reading file …',
  analyzeError: 'File could not be read.',
  targetField: 'Target field',
  sourceColumn: 'Source column',
  notMapped: '– do not map –',
  loadTemplate: 'Load saved mapping …',
  templateNamePlaceholder: 'Mapping name',
  saveTemplate: 'Save as template',
  templateSaved: 'Template saved.',
  truncatedHint: 'File has more than {max} rows, only the first {max} will be imported.',
  duplicateStrategy: 'For existing records',
  strategySkip: 'Skip',
  strategyUpdate: 'Update',
  strategyCreate: 'Create anyway',
  ok: 'OK',
  invalid: 'Invalid',
  duplicatesFound: 'duplicates',
  status: 'Status',
  error: 'Error',
  duplicate: 'Duplicate',
  next: 'Next',
  startImport: 'Start import',
  newCount: 'created',
  updatedCount: 'updated',
  skippedCount: 'skipped',
  undo: 'Undo',
  reverted: 'Import was reverted.',
  undoSuccess: 'Import was reverted.',
  importSuccess: 'Import completed.',
  importError: 'Import failed.',
  loadError: 'Data could not be loaded.',
  settingsCardTitle: 'Master Data Import',
  settingsCardHint: 'Bring in customers, suppliers and other master data from another system.',
  history: 'Recent imports',
  noHistory: 'No imports yet.',
  entity: 'Data',
  date: 'Date',
};

const importWizardFr = {
  button: 'Importer',
  title: 'Import de données de base',
  stepOf: 'Étape {step} sur {total}',
  chooseEntityHint: 'Quelles données souhaitez-vous importer ?',
  noEntities: 'Aucune donnée importable disponible.',
  uploadHint: 'Charger un fichier CSV ou Excel (.xlsx).',
  analyzing: 'Lecture du fichier …',
  analyzeError: 'Le fichier n\'a pas pu être lu.',
  targetField: 'Champ cible',
  sourceColumn: 'Colonne source',
  notMapped: '– ne pas associer –',
  loadTemplate: 'Charger un mappage enregistré …',
  templateNamePlaceholder: 'Nom du mappage',
  saveTemplate: 'Enregistrer comme modèle',
  templateSaved: 'Modèle enregistré.',
  truncatedHint: 'Le fichier contient plus de {max} lignes, seules les {max} premières seront importées.',
  duplicateStrategy: 'Pour les enregistrements existants',
  strategySkip: 'Ignorer',
  strategyUpdate: 'Mettre à jour',
  strategyCreate: 'Créer quand même',
  ok: 'OK',
  invalid: 'Invalide',
  duplicatesFound: 'doublons',
  status: 'Statut',
  error: 'Erreur',
  duplicate: 'Doublon',
  next: 'Suivant',
  startImport: 'Démarrer l\'import',
  newCount: 'créés',
  updatedCount: 'mis à jour',
  skippedCount: 'ignorés',
  undo: 'Annuler',
  reverted: 'L\'import a été annulé.',
  undoSuccess: 'L\'import a été annulé.',
  importSuccess: 'Import terminé.',
  importError: 'Échec de l\'import.',
  loadError: 'Les données n\'ont pas pu être chargées.',
  settingsCardTitle: 'Import de données de base',
  settingsCardHint: 'Reprendre les clients, fournisseurs et autres données de base d\'un autre système.',
  history: 'Imports récents',
  noHistory: 'Aucun import pour le moment.',
  entity: 'Données',
  date: 'Date',
};

const importWizardIt = {
  button: 'Importa',
  title: 'Importazione anagrafiche',
  stepOf: 'Passo {step} di {total}',
  chooseEntityHint: 'Quali dati vuoi importare?',
  noEntities: 'Nessun dato importabile disponibile.',
  uploadHint: 'Carica un file CSV o Excel (.xlsx).',
  analyzing: 'Lettura del file …',
  analyzeError: 'Impossibile leggere il file.',
  targetField: 'Campo di destinazione',
  sourceColumn: 'Colonna di origine',
  notMapped: '– non associare –',
  loadTemplate: 'Carica mappatura salvata …',
  templateNamePlaceholder: 'Nome mappatura',
  saveTemplate: 'Salva come modello',
  templateSaved: 'Modello salvato.',
  truncatedHint: 'Il file ha più di {max} righe, verranno importate solo le prime {max}.',
  duplicateStrategy: 'Per i record esistenti',
  strategySkip: 'Salta',
  strategyUpdate: 'Aggiorna',
  strategyCreate: 'Crea comunque',
  ok: 'OK',
  invalid: 'Non valido',
  duplicatesFound: 'duplicati',
  status: 'Stato',
  error: 'Errore',
  duplicate: 'Duplicato',
  next: 'Avanti',
  startImport: 'Avvia importazione',
  newCount: 'creati',
  updatedCount: 'aggiornati',
  skippedCount: 'saltati',
  undo: 'Annulla',
  reverted: 'L\'importazione è stata annullata.',
  undoSuccess: 'L\'importazione è stata annullata.',
  importSuccess: 'Importazione completata.',
  importError: 'Importazione fallita.',
  loadError: 'Impossibile caricare i dati.',
  settingsCardTitle: 'Importazione anagrafiche',
  settingsCardHint: 'Importa clienti, fornitori e altre anagrafiche da un altro sistema.',
  history: 'Importazioni recenti',
  noHistory: 'Nessuna importazione ancora.',
  entity: 'Dati',
  date: 'Data',
};

const importWizardPl = {
  button: 'Importuj',
  title: 'Import danych podstawowych',
  stepOf: 'Krok {step} z {total}',
  chooseEntityHint: 'Które dane chcesz zaimportować?',
  noEntities: 'Brak dostepnych danych do importu.',
  uploadHint: 'Przeslij plik CSV lub Excel (.xlsx).',
  analyzing: 'Odczytywanie pliku …',
  analyzeError: 'Nie udalo sie odczytac pliku.',
  targetField: 'Pole docelowe',
  sourceColumn: 'Kolumna zrodlowa',
  notMapped: '– nie przypisuj –',
  loadTemplate: 'Wczytaj zapisane mapowanie …',
  templateNamePlaceholder: 'Nazwa mapowania',
  saveTemplate: 'Zapisz jako szablon',
  templateSaved: 'Szablon zapisany.',
  truncatedHint: 'Plik ma wiecej niz {max} wierszy, zaimportowane zostana tylko pierwsze {max}.',
  duplicateStrategy: 'Dla istniejacych rekordow',
  strategySkip: 'Pomin',
  strategyUpdate: 'Aktualizuj',
  strategyCreate: 'Utworz mimo to',
  ok: 'OK',
  invalid: 'Nieprawidlowy',
  duplicatesFound: 'duplikaty',
  status: 'Status',
  error: 'Blad',
  duplicate: 'Duplikat',
  next: 'Dalej',
  startImport: 'Rozpocznij import',
  newCount: 'utworzono',
  updatedCount: 'zaktualizowano',
  skippedCount: 'pominieto',
  undo: 'Cofnij',
  reverted: 'Import zostal cofniety.',
  undoSuccess: 'Import zostal cofniety.',
  importSuccess: 'Import zakonczony.',
  importError: 'Import nie powiodl sie.',
  loadError: 'Nie udalo sie zaladowac danych.',
  settingsCardTitle: 'Import danych podstawowych',
  settingsCardHint: 'Przenies klientow, dostawcow i inne dane podstawowe z innego systemu.',
  history: 'Ostatnie importy',
  noHistory: 'Brak importow.',
  entity: 'Dane',
  date: 'Data',
};

const importWizardCs = {
  button: 'Importovat',
  title: 'Import kmenovych dat',
  stepOf: 'Krok {step} z {total}',
  chooseEntityHint: 'Ktera data chcete importovat?',
  noEntities: 'Zadna data k importu nejsou k dispozici.',
  uploadHint: 'Nahrajte soubor CSV nebo Excel (.xlsx).',
  analyzing: 'Cteni souboru …',
  analyzeError: 'Soubor se nepodarilo precist.',
  targetField: 'Cilove pole',
  sourceColumn: 'Zdrojovy sloupec',
  notMapped: '– nepriradit –',
  loadTemplate: 'Nacist ulozene mapovani …',
  templateNamePlaceholder: 'Nazev mapovani',
  saveTemplate: 'Ulozit jako sablonu',
  templateSaved: 'Sablona ulozena.',
  truncatedHint: 'Soubor ma vice nez {max} radku, importovano bude pouze prvnich {max}.',
  duplicateStrategy: 'U existujicich zaznamu',
  strategySkip: 'Preskocit',
  strategyUpdate: 'Aktualizovat',
  strategyCreate: 'Presto vytvorit',
  ok: 'OK',
  invalid: 'Neplatny',
  duplicatesFound: 'duplicity',
  status: 'Stav',
  error: 'Chyba',
  duplicate: 'Duplicita',
  next: 'Dale',
  startImport: 'Spustit import',
  newCount: 'vytvoreno',
  updatedCount: 'aktualizovano',
  skippedCount: 'preskoceno',
  undo: 'Vratit zpet',
  reverted: 'Import byl vracen zpet.',
  undoSuccess: 'Import byl vracen zpet.',
  importSuccess: 'Import dokoncen.',
  importError: 'Import se nezdaril.',
  loadError: 'Data se nepodarilo nacist.',
  settingsCardTitle: 'Import kmenovych dat',
  settingsCardHint: 'Prevezte zakazniky, dodavatele a dalsi kmenova data z jineho systemu.',
  history: 'Posledni importy',
  noHistory: 'Zatim zadne importy.',
  entity: 'Data',
  date: 'Datum',
};

const calcDe = {
  title: 'Zimmerer-Kalkulator',
  subtitle: 'Mit custom Templates für Manager.',
  overviewTitle: 'Zimmerer-Kalkulationen',
  overviewSubtitle: 'Wähle eine Berechnung für Dachstuhl oder Abbund.',
  availableCalculations: 'Verfügbare Kalkulationen',
  backToOverview: 'Zurück zur Übersicht',
  inputValues: 'Eingabewerte',
  calculate: 'Berechnen',
  reset: 'Zurücksetzen',
  templateHint: 'Nutze Manager-Vorlagen oder eigene Templates.',
  result: 'Ergebnis',
  exportSave: 'Export und Projekt speichern',
  exportPdf: 'Als PDF exportieren',
  project: 'Projekt',
  openAsOfferDraft: 'Als neues Angebot öffnen',
  saveToProject: 'In Projekt speichern',
  notes: 'Hinweise',
  note1: 'Rechner ist als erste Abschätzung gedacht und ersetzt keine Fachplanung.',
  note2: 'Verwende immer die gültigen Normen (DIN 1052, EN 1995-1-1) bei statischer Bemessung.',
  note3: 'Materialverlust, Verbindungsmittel und Sparrenkappen sind zusätzlich zu planen.',
  projectsLoadFailed: 'Projekte laden fehlgeschlagen',
  inputsLabel: 'Eingaben',
  resultsLabel: 'Ergebnisse',
  pdfCreating: 'PDF wird erstellt...',
  pdfSaved: 'PDF gespeichert!',
  pdfExportFailed: 'PDF Export fehlgeschlagen',
  chooseProject: 'Bitte Projekt wählen.',
  projectNotFound: 'Projekt nicht gefunden',
  unitPiece: 'Stk',
  savedOn: 'gespeichert am',
  savedToProject: 'Kalkulation als Dokument gespeichert.',
  projectSaveFailed: 'Speicherung ins Projekt fehlerhaft',
  saveFailed: 'Speichern fehlgeschlagen',
  creatingOffer: 'Angebot wird erstellt...',
  offerCreatedOpening: 'Angebot erstellt. Öffne Bearbeitung...',
  offerDraftPrepared: 'Angebotsentwurf vorbereitet. Öffne neue Angebotsmaske...',
  noOfferLineItems: 'Keine gültigen Angebotspositionen aus der Kalkulation vorhanden.',
  roofTypes: {
    satteldach: 'Satteldach',
    pultdach: 'Pultdach',
    walmdach: 'Walmdach',
    krueppelwalmdach: 'Krüppelwalmdach',
    mansarddach: 'Mansarddach',
    flachdach: 'Flachdach (Wohnbau)',
    landwirtschaft: 'Landwirtschaftlicher Dachstuhl'
  },
  modes: {
    all: 'Alles (Dachstuhl + Lattung + Deckung)',
    frame: 'Nur Dachstuhl',
    lathing: 'Nur Dachlattung',
    covering: 'Nur Dachdeckung'
  },
  sections: {
    general: 'Allgemein',
    baseData: 'Grunddaten',
    roofTypeSpecific: 'Dachart-spezifisch',
    dormers: 'Gauben',
    frame: 'Dachstuhl',
    lathing: 'Dachlattung',
    covering: 'Dachdeckung',
    costs: 'Kosten'
  },
  fields: {
    roofType: 'Dachart',
    calcMode: 'Berechnungsbereich',
    widthM: 'Gebäude-Breite (m)',
    lengthM: 'Gebäude-Länge (m)',
    roofPitch: 'Dachneigung (deg)',
    rafterSpacing: 'Sparrenabstand (cm)',
    rafterWidth: 'Sparrenbreite (mm)',
    rafterHeight: 'Sparrenhöhe (mm)',
    rafterOverhang: 'Sparren-Überstand (m)',
    beamLength: 'Balkenlänge (m)',
    beamWidth: 'Balkenbreite (mm)',
    beamHeight: 'Balkenhöhe (mm)',
    beamSpacing: 'Balkenabstand (cm)',
    spanWidth: 'Spannweite (m)',
    spanLength: 'Spannlänge (m)',
    units: 'Anzahl Elemente',
    timePerUnit: 'Zeit pro Element (h)',
    workers: 'Monteure',
    overheadPercent: 'Zuschlag prozentual',
    machineHoursPerUnit: 'Maschinenstunden pro Element',
    safetyFactor: 'Pufferfaktor',
    formworkArea: 'Schalfläche (m2)',
    formworkThickness: 'Schalungsstärke (mm)',
    efficiency: 'Effizienz',
    laborPerSquareMeter: 'Arbeitszeit pro m2 (h)',
    concreteSurface: 'Betonfläche (m2)',
    concreteDepth: 'Betontiefe (m)',
    insulationArea: 'Daemmfläche (m2)',
    lambdaValue: 'Lambda (W/mK)',
    layerThickness: 'Schichtdicke (mm)',
    density: 'Dichte (kg/m3)',
    cutLossPercent: 'Schnittverlust (%)',
    roofWidth: 'Dachbreite (m)',
    roofLength: 'Dachlänge (m)',
    tileWidth: 'Dachziegelbreite (mm)',
    tileHeight: 'Dachziegelhöhe (mm)',
    tileCoverageFactor: 'Deckmass-Faktor Dachziegel',
    timberPriceM3: 'Holzpreis (EUR/m3)',
    battenPriceLm: 'Lattungspreis (EUR/lfm)',
    frameLaborRate: 'Arbeitszeit Dachstuhl (h/m3)',
    lathLaborRate: 'Arbeitszeit Lattung (h/m2)',
    coverLaborRate: 'Arbeitszeit Deckung (h/m2)',
    hourlyRate: 'Stundensatz (EUR/h)',
    mansardUpperPitch: 'Mansarde obere Dachneigung (deg)',
    mansardLowerPitch: 'Mansarde untere Dachneigung (deg)',
    walmShare: 'Walmlänge-Anteil (0-1)',
    flatSlopeDeg: 'Flachdachgefälle (deg)',
    dormerCount: 'Anzahl Dachgauben',
    dormerWidth: 'Gaubenbreite (m)',
    dormerDepth: 'Gaubentiefe (m)',
    dormerPitch: 'Gaubenneigung (deg)',
    piecePriceEuro: 'Stückpreis (EUR)',
    battenSpacing: 'Lattenabstand (cm)',
    battenLength: 'Lattenlänge (m)',
    overlap: 'Überhang (m)'
  },
  outputs: {
    roofAreaBase: 'Dachfläche Basis (m2)',
    roofAreaTotal: 'Dachfläche inkl. Gauben (m2)',
    dormerArea: 'Zusatzfläche Gauben (m2)',
    rafterLength: 'Sparrenlänge (m)',
    raftersPerSide: 'Sparren pro Seite',
    totalRafters: 'Gesamtanzahl Sparren',
    roofArea: 'Dachfläche (m2)',
    rafterVolume: 'Holzvolumen Sparren (m3)',
    ridgeHeight: 'Dachfirsthöhe (m)',
    beamVolume: 'Volumen je Balken (m3)',
    beamsAlongWidth: 'Balken je Breite',
    beamsTotal: 'Gesamtanzahl Balken',
    totalWoodVolume: 'Gesamtvolumen (m3)',
    cuttingLength: 'Schnittlänge (m)',
    totalHours: 'Gesamtstunden (h)',
    personDays: 'Personentage',
    machineHoursTotal: 'Maschinenstunden gesamt',
    withOverhead: 'Mit Zuschlag (h)',
    effectiveHours: 'Einsatzstunden (h)',
    requiredFormwork: 'Benötigte Schalfläche (m2)',
    formworkPanels: 'Schalungspaneele (Stk)',
    estimatedLabor: 'Arbeitsstunden (h)',
    concreteVolume: 'Betonmenge (m3)',
    wastageLoss: 'Verlustreserve (m3)',
    insulationVolume: 'Dämmvolumen (m3)',
    materialWeight: 'Materialgewicht (kg)',
    rValue: 'Wärmedurchlasswiderstand (m2K/W)',
    workHours: 'Arbeitsstunden (h)',
    areaWithLoss: 'Fläche inkl. Verlust (m2)',
    tileCount: 'Plattenanzahl',
    materialCost: 'Materialkosten (EUR)',
    laborHours: 'Arbeitsstunden (h)',
    totalCost: 'Gesamtkosten (EUR)',
    numberOfLaths: 'Anzahl Lattenreihen',
    totalLathLength: 'Gesamtlaengenbedarf (m)',
    lathPieces: 'Benötigte Latten (Stk)',
    frameLaborHours: 'Arbeitszeit Dachstuhl (h)',
    frameCost: 'Kosten Dachstuhl (EUR)',
    battenLines: 'Anzahl Lattenreihen',
    lathingLaborHours: 'Arbeitszeit Lattung (h)',
    lathingCost: 'Kosten Lattung (EUR)',
    coveringLaborHours: 'Arbeitszeit Deckung (h)',
    coveringCost: 'Kosten Dachdeckung (EUR)'
  },
  types: {
    roofSystem: {
      title: 'Dachstuhl / Dachlattung / Dachdeckung',
      longDescription: 'Dachart wählen und Positionen für Dachstuhl, Lattung und Deckung gemeinsam kalkulieren.'
    },
    roof: {
      title: 'Dachstuhl-Berechnung',
      description: 'Fläche, Sparren, Firsthöhe, Volumen.',
      longDescription: 'Standard-Dachstuhl-Vorlage für Sparren- und Dachflächen.'
    },
    abbund: {
      title: 'Abbund-Kalkulation',
      description: 'Materialmenge, Balkenanzahl, Volumen, Schnittlänge.',
      longDescription: 'Berechnet Balkenanzahl, Volumen und Schnittlänge für Abbundpläne.'
    },
    montage: {
      title: 'Montage-Kalkulation',
      description: 'Arbeitsstunden, Maschinenlaufzeit, Personentage.',
      longDescription: 'Berechnet benötigte Montagezeit, Personentage und Maschinenstunden.'
    },
    schalung: {
      title: 'Schalung-Kalkulation',
      description: 'Schalfläche, Mengenbedarf, Arbeitszeit.',
      longDescription: 'Berechnet benötigte Schalfläche, Betonmenge und Arbeitszeiten.'
    },
    daemmung: {
      title: 'Dämmung-Kalkulation',
      description: 'Fläche, Dämmstoffbedarf, U-Wert, Arbeitsstunden.',
      longDescription: 'Berechnet Materialbedarf, Waermeleitwert und Arbeitszeit für Dämmung.'
    },
    dachlattung: {
      title: 'Dachlattung-Kalkulation',
      description: 'Lattenabstand, Anzahl Latten, Materiallänge.',
      longDescription: 'Berechnet Anzahl Latten, Gesamtmateriallänge und Montagezeit.'
    },
    dachdeckung: {
      title: 'Dachdeckung-Kalkulation',
      description: 'Plattenbedarf, Überlappung, Dachfläche, Kosten.',
      longDescription: 'Berechnet Dachfläche, Plattenbedarf, Arbeitszeit und Kosten.'
    }
  },
  offerPositions: 'Angebotspositionen',
  technicalDetails: 'Berechnungsdetails',
  loadCatalog: 'Material aus Katalog laden',
  catalogLoaded: '{count} Materialien geladen',
  manual: 'Manuell',
  laborPos: 'Arbeitsposition',
  posDescription: 'Bezeichnung',
  posQty: 'Menge',
  posUnit: 'Einh.',
  posCatalog: 'Material (Katalog)',
  posEp: 'EP (€)',
  posGp: 'GP (€)',
  totalNet: 'Gesamt netto',
  linkMaterial: 'Material verknüpfen',
  searchMaterial: 'Material suchen…',
  noMaterialsFound: 'Keine Materialien gefunden',
  linked: 'Verknüpft',
  clearLink: 'Verknüpfung entfernen',
  pos: {
    frameMontage: 'Dachstuhl montieren',
    batten: 'Dachlatte',
    lathingMontage: 'Lattung verlegen',
    roofTile: 'Dachziegel',
    coveringMontage: 'Dachdeckung montieren',
    beam: 'Balken',
    abbundWork: 'Abbund / Zimmererarbeit',
    montageLabor: 'Montageleistung',
    machineLabor: 'Maschineneinsatz',
    formworkPanels: 'Schalungspaneele',
    formworkLabor: 'Schalungsarbeit',
    insulation: 'Dämmstoff',
    insulationLabor: 'Dämmung einbauen',
  },
  machines: 'Maschinen',
  addMachine: 'Maschine hinzufügen',
  machine: 'Maschine',
  selectMachine: 'Maschine wählen',
  noMachinesAdded: 'Keine Maschinen hinzugefügt.',
  vehicles: 'Fahrzeuge',
  addVehicle: 'Fahrzeug hinzufügen',
  vehicle: 'Fahrzeug',
  selectVehicle: 'Fahrzeug wählen',
  noVehiclesAdded: 'Keine Fahrzeuge hinzugefügt.',
  days: 'Tage',
  dailyRate: 'Tagessatz (€)',
  workdays: 'Arbeitstage',
  from: 'Von',
  to: 'Bis',
  total: 'Gesamt',
};

const calcEn = {
  title: 'Carpentry calculator',
  subtitle: 'With custom templates for managers.',
  overviewTitle: 'Carpentry calculations',
  overviewSubtitle: 'Choose a calculation for roof framing or timber cutting.',
  availableCalculations: 'Available calculations',
  backToOverview: 'Back to overview',
  inputValues: 'Input values',
  calculate: 'Calculate',
  reset: 'Reset',
  templateHint: 'Use manager templates or your own templates.',
  result: 'Result',
  exportSave: 'Export and save to project',
  exportPdf: 'Export as PDF',
  project: 'Project',
  openAsOfferDraft: 'Open as new offer',
  saveToProject: 'Save to project',
  notes: 'Notes',
  note1: 'This calculator is intended as an initial estimate and does not replace professional planning.',
  note2: 'Always apply valid standards (DIN 1052, EN 1995-1-1) for structural dimensioning.',
  note3: 'Material loss, fasteners and rafter caps must be planned additionally.',
  projectsLoadFailed: 'Failed to load projects',
  inputsLabel: 'Inputs',
  resultsLabel: 'Results',
  pdfCreating: 'Creating PDF...',
  pdfSaved: 'PDF saved!',
  pdfExportFailed: 'PDF export failed',
  chooseProject: 'Please choose a project.',
  projectNotFound: 'Project not found',
  unitPiece: 'pcs',
  savedOn: 'saved on',
  savedToProject: 'Calculation saved as document.',
  projectSaveFailed: 'Saving to project failed',
  saveFailed: 'Save failed',
  creatingOffer: 'Creating offer...',
  offerCreatedOpening: 'Offer created. Opening editor...',
  offerDraftPrepared: 'Offer draft prepared. Opening new offer form...',
  noOfferLineItems: 'No valid offer line items available from this calculation.',
  roofTypes: {
    satteldach: 'Gable roof',
    pultdach: 'Shed roof',
    walmdach: 'Hip roof',
    krueppelwalmdach: 'Half-hip roof',
    mansarddach: 'Mansard roof',
    flachdach: 'Flat roof (residential)',
    landwirtschaft: 'Agricultural roof truss'
  },
  modes: {
    all: 'All (frame + lathing + covering)',
    frame: 'Frame only',
    lathing: 'Lathing only',
    covering: 'Covering only'
  },
  sections: {
    general: 'General',
    baseData: 'Base data',
    roofTypeSpecific: 'Roof-type specific',
    dormers: 'Dormers',
    frame: 'Roof frame',
    lathing: 'Roof lathing',
    covering: 'Roof covering',
    costs: 'Costs'
  },
  fields: {
    roofType: 'Roof type',
    calcMode: 'Calculation scope',
    widthM: 'Building width (m)',
    lengthM: 'Building length (m)',
    roofPitch: 'Roof pitch (deg)',
    rafterSpacing: 'Rafter spacing (cm)',
    rafterWidth: 'Rafter width (mm)',
    rafterHeight: 'Rafter height (mm)',
    rafterOverhang: 'Rafter overhang (m)',
    beamLength: 'Beam length (m)',
    beamWidth: 'Beam width (mm)',
    beamHeight: 'Beam height (mm)',
    beamSpacing: 'Beam spacing (cm)',
    spanWidth: 'Span width (m)',
    spanLength: 'Span length (m)',
    units: 'Number of elements',
    timePerUnit: 'Time per element (h)',
    workers: 'Installers',
    overheadPercent: 'Overhead percent',
    machineHoursPerUnit: 'Machine hours per element',
    safetyFactor: 'Safety factor',
    formworkArea: 'Formwork area (m2)',
    formworkThickness: 'Formwork thickness (mm)',
    efficiency: 'Efficiency',
    laborPerSquareMeter: 'Labor time per m2 (h)',
    concreteSurface: 'Concrete surface (m2)',
    concreteDepth: 'Concrete depth (m)',
    insulationArea: 'Insulation area (m2)',
    lambdaValue: 'Lambda (W/mK)',
    layerThickness: 'Layer thickness (mm)',
    density: 'Density (kg/m3)',
    cutLossPercent: 'Cut loss (%)',
    roofWidth: 'Roof width (m)',
    roofLength: 'Roof length (m)',
    tileWidth: 'Tile width (mm)',
    tileHeight: 'Tile height (mm)',
    tileCoverageFactor: 'Tile coverage factor',
    timberPriceM3: 'Timber price (EUR/m3)',
    battenPriceLm: 'Batten price (EUR/lm)',
    frameLaborRate: 'Frame labor time (h/m3)',
    lathLaborRate: 'Lathing labor time (h/m2)',
    coverLaborRate: 'Covering labor time (h/m2)',
    hourlyRate: 'Hourly rate (EUR/h)',
    mansardUpperPitch: 'Mansard upper pitch (deg)',
    mansardLowerPitch: 'Mansard lower pitch (deg)',
    walmShare: 'Hip length share (0-1)',
    flatSlopeDeg: 'Flat roof slope (deg)',
    dormerCount: 'Dormer count',
    dormerWidth: 'Dormer width (m)',
    dormerDepth: 'Dormer depth (m)',
    dormerPitch: 'Dormer pitch (deg)',
    piecePriceEuro: 'Unit price (EUR)',
    battenSpacing: 'Batten spacing (cm)',
    battenLength: 'Batten length (m)',
    overlap: 'Overhang (m)'
  },
  outputs: {
    roofAreaBase: 'Base roof area (m2)',
    roofAreaTotal: 'Roof area incl. dormers (m2)',
    dormerArea: 'Additional dormer area (m2)',
    rafterLength: 'Rafter length (m)',
    raftersPerSide: 'Rafters per side',
    totalRafters: 'Total rafters',
    roofArea: 'Roof area (m2)',
    rafterVolume: 'Rafter wood volume (m3)',
    ridgeHeight: 'Ridge height (m)',
    beamVolume: 'Volume per beam (m3)',
    beamsAlongWidth: 'Beams along width',
    beamsTotal: 'Total beams',
    totalWoodVolume: 'Total wood volume (m3)',
    cuttingLength: 'Cut length (m)',
    totalHours: 'Total hours (h)',
    personDays: 'Person days',
    machineHoursTotal: 'Total machine hours',
    withOverhead: 'With overhead (h)',
    effectiveHours: 'Effective hours (h)',
    requiredFormwork: 'Required formwork area (m2)',
    formworkPanels: 'Formwork panels (pcs)',
    estimatedLabor: 'Labor hours (h)',
    concreteVolume: 'Concrete volume (m3)',
    wastageLoss: 'Wastage reserve (m3)',
    insulationVolume: 'Insulation volume (m3)',
    materialWeight: 'Material weight (kg)',
    rValue: 'Thermal resistance (m2K/W)',
    workHours: 'Work hours (h)',
    areaWithLoss: 'Area incl. loss (m2)',
    tileCount: 'Tile count',
    materialCost: 'Material cost (EUR)',
    laborHours: 'Labor hours (h)',
    totalCost: 'Total cost (EUR)',
    numberOfLaths: 'Number of batten rows',
    totalLathLength: 'Total lath length (m)',
    lathPieces: 'Required laths (pcs)',
    frameLaborHours: 'Frame labor time (h)',
    frameCost: 'Frame cost (EUR)',
    battenLines: 'Number of batten rows',
    lathingLaborHours: 'Lathing labor time (h)',
    lathingCost: 'Lathing cost (EUR)',
    coveringLaborHours: 'Covering labor time (h)',
    coveringCost: 'Covering cost (EUR)'
  },
  types: {
    roofSystem: {
      title: 'Roof frame / Lathing / Covering',
      longDescription: 'Choose roof type and calculate roof frame, lathing and covering in one workflow.'
    },
    roof: {
      title: 'Roof framing calculation',
      description: 'Area, rafters, ridge height, volume.',
      longDescription: 'Standard roof framing template for rafters and roof areas.'
    },
    abbund: {
      title: 'Timber cutting calculation',
      description: 'Material amount, beam count, volume, cut length.',
      longDescription: 'Calculates beam count, volume and cut length for cutting plans.'
    },
    montage: {
      title: 'Assembly calculation',
      description: 'Work hours, machine runtime, person days.',
      longDescription: 'Calculates required assembly time, person days and machine hours.'
    },
    schalung: {
      title: 'Formwork calculation',
      description: 'Formwork area, quantity demand, labor time.',
      longDescription: 'Calculates required formwork area, concrete volume and labor times.'
    },
    daemmung: {
      title: 'Insulation calculation',
      description: 'Area, insulation demand, U-value, work hours.',
      longDescription: 'Calculates material demand, thermal conductivity and labor time for insulation.'
    },
    dachlattung: {
      title: 'Battens calculation',
      description: 'Batten spacing, number of battens, material length.',
      longDescription: 'Calculates number of battens, total material length and installation time.'
    },
    dachdeckung: {
      title: 'Roof covering calculation',
      description: 'Tile demand, overlap, roof area, cost.',
      longDescription: 'Calculates roof area, tile demand, labor time and costs.'
    }
  },
  offerPositions: 'Offer positions',
  technicalDetails: 'Technical details',
  loadCatalog: 'Load material from catalog',
  catalogLoaded: '{count} materials loaded',
  manual: 'Manual',
  laborPos: 'Labor position',
  posDescription: 'Description',
  posQty: 'Qty',
  posUnit: 'Unit',
  posCatalog: 'Material (catalog)',
  posEp: 'Unit price',
  posGp: 'Total',
  totalNet: 'Total net',
  linkMaterial: 'Link material',
  searchMaterial: 'Search material…',
  noMaterialsFound: 'No materials found',
  linked: 'Linked',
  clearLink: 'Remove link',
  pos: {
    frameMontage: 'Erect roof frame',
    batten: 'Roofing batten',
    lathingMontage: 'Install battens',
    roofTile: 'Roof tile',
    coveringMontage: 'Install roof covering',
    beam: 'Beam',
    abbundWork: 'Timber cutting / carpentry',
    montageLabor: 'Assembly labor',
    machineLabor: 'Machine use',
    formworkPanels: 'Formwork panels',
    formworkLabor: 'Formwork labor',
    insulation: 'Insulation material',
    insulationLabor: 'Install insulation',
  },
  machines: 'Machines',
  addMachine: 'Add machine',
  machine: 'Machine',
  selectMachine: 'Select machine',
  noMachinesAdded: 'No machines added.',
  vehicles: 'Vehicles',
  addVehicle: 'Add vehicle',
  vehicle: 'Vehicle',
  selectVehicle: 'Select vehicle',
  noVehiclesAdded: 'No vehicles added.',
  days: 'Days',
  dailyRate: 'Daily rate (€)',
  workdays: 'Working days',
  from: 'From',
  to: 'To',
  total: 'Total',
};

const calcFr = {
  title: 'Calculateur charpente',
  subtitle: 'Avec des modeles personnalises pour managers.',
  overviewTitle: 'Calculs de charpente',
  overviewSubtitle: 'Choisissez un calcul pour charpente de toit ou taille bois.',
  availableCalculations: 'Calculs disponibles',
  backToOverview: "Retour a la vue d'ensemble",
  inputValues: 'Valeurs d\'entree',
  calculate: 'Calculer',
  reset: 'Reinitialiser',
  templateHint: 'Utilisez des modeles manager ou vos propres modeles.',
  result: 'Resultat',
  exportSave: 'Exporter et enregistrer au projet',
  exportPdf: 'Exporter en PDF',
  project: 'Projet',
  openAsOfferDraft: 'Ouvrir comme nouvelle offre',
  saveToProject: 'Enregistrer au projet',
  notes: 'Notes',
  note1: 'Ce calculateur sert d\'estimation initiale et ne remplace pas une planification professionnelle.',
  note2: 'Appliquez toujours les normes valides (DIN 1052, EN 1995-1-1) pour le dimensionnement structurel.',
  note3: 'Les pertes de materiaux, fixations et coupes de chevrons doivent etre planifiees en plus.',
  projectsLoadFailed: 'Echec du chargement des projets',
  inputsLabel: 'Entrees',
  resultsLabel: 'Resultats',
  pdfCreating: 'Creation du PDF...',
  pdfSaved: 'PDF enregistre !',
  pdfExportFailed: 'Export PDF echoue',
  chooseProject: 'Veuillez choisir un projet.',
  projectNotFound: 'Projet introuvable',
  unitPiece: 'pcs',
  savedOn: 'enregistre le',
  savedToProject: 'Calcul enregistre comme document.',
  projectSaveFailed: 'Enregistrement au projet echoue',
  saveFailed: 'Enregistrement echoue',
  creatingOffer: 'Creation de l\'offre...',
  offerCreatedOpening: 'Offre creee. Ouverture de l\'editeur...',
  offerDraftPrepared: 'Brouillon d\'offre préparé. Ouverture du nouveau formulaire...',
  noOfferLineItems: 'Aucune position d\'offre valable issue de ce calcul.',
  roofTypes: {
    satteldach: 'Toit a deux pans',
    pultdach: 'Toit monopente',
    walmdach: 'Toit en croupe',
    krueppelwalmdach: 'Toit demi-croupe',
    mansarddach: 'Toit mansarde',
    flachdach: 'Toit plat (residentiel)',
    landwirtschaft: 'Charpente agricole'
  },
  modes: {
    all: 'Tout (charpente + lattes + couverture)',
    frame: 'Charpente uniquement',
    lathing: 'Lattage uniquement',
    covering: 'Couverture uniquement'
  },
  sections: {
    general: 'General',
    baseData: 'Donnees de base',
    roofTypeSpecific: 'Specifique au type de toit',
    dormers: 'Lucarnes',
    frame: 'Charpente',
    lathing: 'Lattage',
    covering: 'Couverture',
    costs: 'Couts'
  },
  fields: {
    roofType: 'Type de toit',
    calcMode: 'Perimetre de calcul',
    widthM: 'Largeur du batiment (m)',
    lengthM: 'Longueur du batiment (m)',
    roofPitch: 'Pente du toit (deg)',
    rafterSpacing: 'Espacement des chevrons (cm)',
    rafterWidth: 'Largeur chevron (mm)',
    rafterHeight: 'Hauteur chevron (mm)',
    rafterOverhang: 'Debord chevron (m)',
    beamLength: 'Longueur poutre (m)',
    beamWidth: 'Largeur poutre (mm)',
    beamHeight: 'Hauteur poutre (mm)',
    beamSpacing: 'Espacement poutres (cm)',
    spanWidth: 'Portee largeur (m)',
    spanLength: 'Portee longueur (m)',
    units: 'Nombre d\'elements',
    timePerUnit: 'Temps par element (h)',
    workers: 'Monteurs',
    overheadPercent: 'Pourcentage de majoration',
    machineHoursPerUnit: 'Heures machine par element',
    safetyFactor: 'Facteur de securite',
    formworkArea: 'Surface de coffrage (m2)',
    formworkThickness: 'Epaisseur coffrage (mm)',
    efficiency: 'Efficacite',
    laborPerSquareMeter: 'Temps de travail par m2 (h)',
    concreteSurface: 'Surface beton (m2)',
    concreteDepth: 'Profondeur beton (m)',
    insulationArea: 'Surface isolation (m2)',
    lambdaValue: 'Lambda (W/mK)',
    layerThickness: 'Epaisseur couche (mm)',
    density: 'Densite (kg/m3)',
    cutLossPercent: 'Perte de coupe (%)',
    roofWidth: 'Largeur toiture (m)',
    roofLength: 'Longueur toiture (m)',
    tileWidth: 'Largeur tuile (mm)',
    tileHeight: 'Hauteur tuile (mm)',
    tileCoverageFactor: 'Facteur de couverture tuile',
    timberPriceM3: 'Prix bois (EUR/m3)',
    battenPriceLm: 'Prix lattes (EUR/ml)',
    frameLaborRate: 'Temps charpente (h/m3)',
    lathLaborRate: 'Temps lattage (h/m2)',
    coverLaborRate: 'Temps couverture (h/m2)',
    hourlyRate: 'Taux horaire (EUR/h)',
    mansardUpperPitch: 'Pente mansarde haute (deg)',
    mansardLowerPitch: 'Pente mansarde basse (deg)',
    walmShare: 'Part de longueur de croupe (0-1)',
    flatSlopeDeg: 'Pente toit plat (deg)',
    dormerCount: 'Nombre de lucarnes',
    dormerWidth: 'Largeur lucarne (m)',
    dormerDepth: 'Profondeur lucarne (m)',
    dormerPitch: 'Pente lucarne (deg)',
    piecePriceEuro: 'Prix unitaire (EUR)',
    battenSpacing: 'Espacement liteaux (cm)',
    battenLength: 'Longueur liteau (m)',
    overlap: 'Recouvrement (m)'
  },
  outputs: {
    roofAreaBase: 'Surface toiture de base (m2)',
    roofAreaTotal: 'Surface toiture incl. lucarnes (m2)',
    dormerArea: 'Surface lucarnes supplementaire (m2)',
    rafterLength: 'Longueur chevron (m)',
    raftersPerSide: 'Chevrons par cote',
    totalRafters: 'Total chevrons',
    roofArea: 'Surface toiture (m2)',
    rafterVolume: 'Volume bois chevrons (m3)',
    ridgeHeight: 'Hauteur faitage (m)',
    beamVolume: 'Volume par poutre (m3)',
    beamsAlongWidth: 'Poutres sur la largeur',
    beamsTotal: 'Total poutres',
    totalWoodVolume: 'Volume bois total (m3)',
    cuttingLength: 'Longueur de coupe (m)',
    totalHours: 'Heures totales (h)',
    personDays: 'Jours-homme',
    machineHoursTotal: 'Heures machine totales',
    withOverhead: 'Avec majoration (h)',
    effectiveHours: 'Heures effectives (h)',
    requiredFormwork: 'Surface coffrage requise (m2)',
    formworkPanels: 'Panneaux coffrage (pcs)',
    estimatedLabor: 'Heures de travail (h)',
    concreteVolume: 'Volume beton (m3)',
    wastageLoss: 'Reserve de perte (m3)',
    insulationVolume: 'Volume isolation (m3)',
    materialWeight: 'Poids materiau (kg)',
    rValue: 'Resistance thermique (m2K/W)',
    workHours: 'Heures de travail (h)',
    areaWithLoss: 'Surface avec perte (m2)',
    tileCount: 'Nombre de tuiles',
    materialCost: 'Cout materiau (EUR)',
    laborHours: 'Heures de travail (h)',
    totalCost: 'Cout total (EUR)',
    numberOfLaths: 'Nombre de rangees de liteaux',
    totalLathLength: 'Longueur totale liteaux (m)',
    lathPieces: 'Liteaux requis (pcs)',
    frameLaborHours: 'Temps charpente (h)',
    frameCost: 'Cout charpente (EUR)',
    battenLines: 'Nombre de rangees de liteaux',
    lathingLaborHours: 'Temps lattage (h)',
    lathingCost: 'Cout lattage (EUR)',
    coveringLaborHours: 'Temps couverture (h)',
    coveringCost: 'Cout couverture (EUR)'
  },
  types: {
    roofSystem: {
      title: 'Charpente / Lattage / Couverture',
      longDescription: 'Choisissez le type de toit et calculez charpente, lattage et couverture ensemble.'
    },
    roof: {
      title: 'Calcul charpente toiture',
      description: 'Surface, chevrons, hauteur faitage, volume.',
      longDescription: 'Modele standard de charpente pour chevrons et surfaces de toit.'
    },
    abbund: {
      title: 'Calcul taille bois',
      description: 'Quantite materiau, nombre poutres, volume, longueur coupe.',
      longDescription: 'Calcule nombre de poutres, volume et longueur de coupe pour plans de taille.'
    },
    montage: {
      title: 'Calcul montage',
      description: 'Heures de travail, duree machine, jours-homme.',
      longDescription: 'Calcule le temps de montage requis, les jours-homme et les heures machine.'
    },
    schalung: {
      title: 'Calcul coffrage',
      description: 'Surface coffrage, besoin quantite, temps travail.',
      longDescription: 'Calcule la surface de coffrage requise, le volume de beton et les temps de travail.'
    },
    daemmung: {
      title: 'Calcul isolation',
      description: 'Surface, besoin isolation, valeur U, heures travail.',
      longDescription: 'Calcule le besoin en materiau, la conductivite thermique et le temps de travail pour isolation.'
    },
    dachlattung: {
      title: 'Calcul liteaux',
      description: 'Espacement liteaux, nombre liteaux, longueur materiau.',
      longDescription: 'Calcule le nombre de liteaux, la longueur totale de materiau et le temps de pose.'
    },
    dachdeckung: {
      title: 'Calcul couverture toiture',
      description: 'Besoin tuiles, recouvrement, surface toiture, cout.',
      longDescription: 'Calcule la surface de toiture, le besoin en tuiles, le temps de travail et les couts.'
    }
  },
  offerPositions: 'Positions de devis',
  technicalDetails: 'Détails techniques',
  loadCatalog: 'Charger matériaux du catalogue',
  catalogLoaded: '{count} matériaux chargés',
  manual: 'Manuel',
  laborPos: 'Position main-d\'œuvre',
  posDescription: 'Désignation',
  posQty: 'Qté',
  posUnit: 'Unité',
  posCatalog: 'Matériau (catalogue)',
  posEp: 'PU (€)',
  posGp: 'PT (€)',
  totalNet: 'Total HT',
  linkMaterial: 'Lier matériau',
  searchMaterial: 'Chercher matériau…',
  noMaterialsFound: 'Aucun matériau trouvé',
  linked: 'Lié',
  clearLink: 'Supprimer le lien',
  pos: {
    frameMontage: 'Monter la charpente',
    batten: 'Latte de toiture',
    lathingMontage: 'Poser les lattes',
    roofTile: 'Tuile',
    coveringMontage: 'Poser la couverture',
    beam: 'Poutre',
    abbundWork: 'Taille bois / charpenterie',
    montageLabor: 'Main-d\'œuvre montage',
    machineLabor: 'Utilisation machine',
    formworkPanels: 'Panneaux de coffrage',
    formworkLabor: 'Travail de coffrage',
    insulation: 'Isolant',
    insulationLabor: 'Poser l\'isolation',
  },
  machines: 'Machines',
  addMachine: 'Ajouter machine',
  machine: 'Machine',
  selectMachine: 'Choisir machine',
  noMachinesAdded: 'Aucune machine ajoutée.',
  vehicles: 'Véhicules',
  addVehicle: 'Ajouter véhicule',
  vehicle: 'Véhicule',
  selectVehicle: 'Choisir véhicule',
  noVehiclesAdded: 'Aucun véhicule ajouté.',
  days: 'Jours',
  dailyRate: 'Tarif journalier (€)',
  workdays: 'Jours ouvrables',
  from: 'Du',
  to: 'Au',
  total: 'Total',
};

const calcIt = {
  title: 'Calcolatore carpenteria',
  subtitle: 'Con modelli personalizzati per manager.',
  overviewTitle: 'Calcoli di carpenteria',
  overviewSubtitle: 'Scegli un calcolo per struttura tetto o taglio legno.',
  availableCalculations: 'Calcoli disponibili',
  backToOverview: 'Torna alla panoramica',
  inputValues: 'Valori di input',
  calculate: 'Calcola',
  reset: 'Reimposta',
  templateHint: 'Usa modelli manager o i tuoi modelli personalizzati.',
  result: 'Risultato',
  exportSave: 'Esporta e salva nel progetto',
  exportPdf: 'Esporta come PDF',
  project: 'Progetto',
  openAsOfferDraft: 'Apri come nuova offerta',
  saveToProject: 'Salva nel progetto',
  notes: 'Note',
  note1: 'Questo calcolatore e una stima iniziale e non sostituisce una progettazione professionale.',
  note2: 'Applica sempre le norme valide (DIN 1052, EN 1995-1-1) per il dimensionamento strutturale.',
  note3: 'Perdite di materiale, fissaggi e tagli devono essere pianificati separatamente.',
  projectsLoadFailed: 'Caricamento progetti non riuscito',
  inputsLabel: 'Input',
  resultsLabel: 'Risultati',
  pdfCreating: 'Creazione PDF...',
  pdfSaved: 'PDF salvato!',
  pdfExportFailed: 'Esportazione PDF non riuscita',
  chooseProject: 'Seleziona un progetto.',
  projectNotFound: 'Progetto non trovato',
  unitPiece: 'pz',
  savedOn: 'salvato il',
  savedToProject: 'Calcolo salvato come documento.',
  projectSaveFailed: 'Salvataggio nel progetto non riuscito',
  saveFailed: 'Salvataggio non riuscito',
  creatingOffer: 'Creazione offerta in corso...',
  offerCreatedOpening: 'Offerta creata. Apertura dell\'editor...',
  offerDraftPrepared: 'Bozza dell\'offerta pronta. Apertura del nuovo modulo offerta...',
  noOfferLineItems: 'Nessuna riga offerta valida disponibile da questo calcolo.',
  roofTypes: {
    satteldach: 'Tetto a due falde',
    pultdach: 'Tetto a falda unica',
    walmdach: 'Tetto a padiglione',
    krueppelwalmdach: 'Tetto a semipadiglione',
    mansarddach: 'Tetto mansardato',
    flachdach: 'Tetto piano (residenziale)',
    landwirtschaft: 'Capriata agricola'
  },
  modes: {
    all: 'Tutto (struttura + listellatura + copertura)',
    frame: 'Solo struttura tetto',
    lathing: 'Solo listellatura tetto',
    covering: 'Solo copertura tetto'
  },
  sections: {
    general: 'Generale',
    baseData: 'Dati base',
    roofTypeSpecific: 'Specifico tipo tetto',
    dormers: 'Abbaini',
    frame: 'Struttura tetto',
    lathing: 'Listellatura',
    covering: 'Copertura',
    costs: 'Costi'
  },
  fields: {
    roofType: 'Tipo di tetto',
    calcMode: 'Ambito di calcolo',
    widthM: 'Larghezza edificio (m)',
    lengthM: 'Lunghezza edificio (m)',
    roofPitch: 'Pendenza tetto (deg)',
    rafterSpacing: 'Interasse travetti (cm)',
    rafterWidth: 'Larghezza travetto (mm)',
    rafterHeight: 'Altezza travetto (mm)',
    rafterOverhang: 'Sporgenza travetto (m)',
    beamLength: 'Lunghezza trave (m)',
    beamWidth: 'Larghezza trave (mm)',
    beamHeight: 'Altezza trave (mm)',
    beamSpacing: 'Interasse travi (cm)',
    spanWidth: 'Luce larghezza (m)',
    spanLength: 'Luce lunghezza (m)',
    units: 'Numero elementi',
    timePerUnit: 'Tempo per elemento (h)',
    workers: 'Installatori',
    overheadPercent: 'Percentuale maggiorazione',
    machineHoursPerUnit: 'Ore macchina per elemento',
    safetyFactor: 'Fattore di sicurezza',
    formworkArea: 'Area casseratura (m2)',
    formworkThickness: 'Spessore casseratura (mm)',
    efficiency: 'Efficienza',
    laborPerSquareMeter: 'Tempo lavoro per m2 (h)',
    concreteSurface: 'Superficie calcestruzzo (m2)',
    concreteDepth: 'Profondita calcestruzzo (m)',
    insulationArea: 'Area isolamento (m2)',
    lambdaValue: 'Lambda (W/mK)',
    layerThickness: 'Spessore strato (mm)',
    density: 'Densita (kg/m3)',
    cutLossPercent: 'Perdita di taglio (%)',
    roofWidth: 'Larghezza tetto (m)',
    roofLength: 'Lunghezza tetto (m)',
    tileWidth: 'Larghezza tegola (mm)',
    tileHeight: 'Altezza tegola (mm)',
    tileCoverageFactor: 'Fattore copertura tegola',
    timberPriceM3: 'Prezzo legno (EUR/m3)',
    battenPriceLm: 'Prezzo listelli (EUR/ml)',
    frameLaborRate: 'Tempo struttura (h/m3)',
    lathLaborRate: 'Tempo listellatura (h/m2)',
    coverLaborRate: 'Tempo copertura (h/m2)',
    hourlyRate: 'Tariffa oraria (EUR/h)',
    mansardUpperPitch: 'Pendenza mansarda superiore (deg)',
    mansardLowerPitch: 'Pendenza mansarda inferiore (deg)',
    walmShare: 'Quota lunghezza padiglione (0-1)',
    flatSlopeDeg: 'Pendenza tetto piano (deg)',
    dormerCount: 'Numero abbaini',
    dormerWidth: 'Larghezza abbaino (m)',
    dormerDepth: 'Profondita abbaino (m)',
    dormerPitch: 'Pendenza abbaino (deg)',
    piecePriceEuro: 'Prezzo unitario (EUR)',
    battenSpacing: 'Interasse listelli (cm)',
    battenLength: 'Lunghezza listello (m)',
    overlap: 'Sovrapposizione (m)'
  },
  outputs: {
    roofAreaBase: 'Area tetto base (m2)',
    roofAreaTotal: 'Area tetto incl. abbaini (m2)',
    dormerArea: 'Area aggiuntiva abbaini (m2)',
    rafterLength: 'Lunghezza travetto (m)',
    raftersPerSide: 'Travetti per lato',
    totalRafters: 'Totale travetti',
    roofArea: 'Area tetto (m2)',
    rafterVolume: 'Volume legno travetti (m3)',
    ridgeHeight: 'Altezza colmo (m)',
    beamVolume: 'Volume per trave (m3)',
    beamsAlongWidth: 'Travi in larghezza',
    beamsTotal: 'Totale travi',
    totalWoodVolume: 'Volume legno totale (m3)',
    cuttingLength: 'Lunghezza taglio (m)',
    totalHours: 'Ore totali (h)',
    personDays: 'Giornate uomo',
    machineHoursTotal: 'Ore macchina totali',
    withOverhead: 'Con maggiorazione (h)',
    effectiveHours: 'Ore effettive (h)',
    requiredFormwork: 'Area casseratura richiesta (m2)',
    formworkPanels: 'Pannelli casseratura (pz)',
    estimatedLabor: 'Ore lavoro (h)',
    concreteVolume: 'Volume calcestruzzo (m3)',
    wastageLoss: 'Riserva scarto (m3)',
    insulationVolume: 'Volume isolamento (m3)',
    materialWeight: 'Peso materiale (kg)',
    rValue: 'Resistenza termica (m2K/W)',
    workHours: 'Ore lavoro (h)',
    areaWithLoss: 'Area incl. scarto (m2)',
    tileCount: 'Numero tegole',
    materialCost: 'Costo materiale (EUR)',
    laborHours: 'Ore lavoro (h)',
    totalCost: 'Costo totale (EUR)',
    numberOfLaths: 'Numero file listelli',
    totalLathLength: 'Lunghezza totale listelli (m)',
    lathPieces: 'Listelli richiesti (pz)',
    frameLaborHours: 'Tempo struttura (h)',
    frameCost: 'Costo struttura (EUR)',
    battenLines: 'Numero file listelli',
    lathingLaborHours: 'Tempo listellatura (h)',
    lathingCost: 'Costo listellatura (EUR)',
    coveringLaborHours: 'Tempo copertura (h)',
    coveringCost: 'Costo copertura (EUR)'
  },
  types: {
    roofSystem: {
      title: 'Struttura tetto / Listellatura / Copertura',
      longDescription: 'Scegli il tipo di tetto e calcola insieme struttura, listellatura e copertura.'
    },
    roof: {
      title: 'Calcolo struttura tetto',
      description: 'Area, travetti, altezza colmo, volume.',
      longDescription: 'Modello standard struttura tetto per travetti e superfici tetto.'
    },
    abbund: {
      title: 'Calcolo taglio legno',
      description: 'Quantita materiale, numero travi, volume, lunghezza taglio.',
      longDescription: 'Calcola numero travi, volume e lunghezza taglio per piani di taglio.'
    },
    montage: {
      title: 'Calcolo montaggio',
      description: 'Ore lavoro, durata macchina, giornate uomo.',
      longDescription: 'Calcola tempo di montaggio richiesto, giornate uomo e ore macchina.'
    },
    schalung: {
      title: 'Calcolo casseratura',
      description: 'Area casseratura, fabbisogno quantita, tempo lavoro.',
      longDescription: 'Calcola area casseratura richiesta, volume calcestruzzo e tempi di lavoro.'
    },
    daemmung: {
      title: 'Calcolo isolamento',
      description: 'Area, fabbisogno isolamento, valore U, ore lavoro.',
      longDescription: 'Calcola fabbisogno materiale, conducibilita termica e tempo lavoro per isolamento.'
    },
    dachlattung: {
      title: 'Calcolo listelli',
      description: 'Interasse listelli, numero listelli, lunghezza materiale.',
      longDescription: 'Calcola numero listelli, lunghezza totale materiale e tempo installazione.'
    },
    dachdeckung: {
      title: 'Calcolo copertura tetto',
      description: 'Fabbisogno tegole, sovrapposizione, area tetto, costo.',
      longDescription: 'Calcola area tetto, fabbisogno tegole, tempo lavoro e costi.'
    }
  },
  offerPositions: 'Posizioni offerta',
  technicalDetails: 'Dettagli tecnici',
  loadCatalog: 'Carica materiali dal catalogo',
  catalogLoaded: '{count} materiali caricati',
  manual: 'Manuale',
  laborPos: 'Posizione manodopera',
  posDescription: 'Descrizione',
  posQty: 'Qtà',
  posUnit: 'Um.',
  posCatalog: 'Materiale (catalogo)',
  posEp: 'PU (€)',
  posGp: 'PT (€)',
  totalNet: 'Totale netto',
  linkMaterial: 'Collega materiale',
  searchMaterial: 'Cerca materiale…',
  noMaterialsFound: 'Nessun materiale trovato',
  linked: 'Collegato',
  clearLink: 'Rimuovi collegamento',
  pos: {
    frameMontage: 'Montare la struttura',
    batten: 'Listello di copertura',
    lathingMontage: 'Posare listelli',
    roofTile: 'Tegola',
    coveringMontage: 'Posare copertura tetto',
    beam: 'Trave',
    abbundWork: 'Taglio legno / lavoro carpenteria',
    montageLabor: 'Manodopera montaggio',
    machineLabor: 'Utilizzo macchina',
    formworkPanels: 'Pannelli cassaforma',
    formworkLabor: 'Lavoro cassaforma',
    insulation: 'Materiale isolante',
    insulationLabor: 'Installare isolamento',
  },
  machines: 'Macchinari',
  addMachine: 'Aggiungi macchinario',
  machine: 'Macchinario',
  selectMachine: 'Seleziona macchinario',
  noMachinesAdded: 'Nessun macchinario aggiunto.',
  vehicles: 'Veicoli',
  addVehicle: 'Aggiungi veicolo',
  vehicle: 'Veicolo',
  selectVehicle: 'Seleziona veicolo',
  noVehiclesAdded: 'Nessun veicolo aggiunto.',
  days: 'Giorni',
  dailyRate: 'Tariffa giornaliera (€)',
  workdays: 'Giorni lavorativi',
  from: 'Dal',
  to: 'Al',
  total: 'Totale',
};

// --- EXPORT PATCH ---
export default {
  de: {
    // ...existing code...
    vehicles: vehiclesDe,
    machines: machinesDe,
  },
  en: {
    // ...existing code...
    vehicles: vehiclesEn,
    machines: machinesEn,
  },
  fr: {
    // ...existing code...
    vehicles: vehiclesFr,
    machines: machinesFr,
  },
  it: {
    // ...existing code...
    vehicles: vehiclesIt,
    machines: machinesIt,
  },
  pl: {
    // ...existing code...
    vehicles: vehiclesPl,
    machines: machinesPl,

  },
  cs: {
    // ...existing code...
    vehicles: vehiclesCs,
    machines: machinesCs,
  },
};

const calcPl = {
  title: 'Kalkulator ciesielski',
  subtitle: 'Z niestandardowymi szablonami dla managerow.',
  overviewTitle: 'Kalkulacje ciesielskie',
  overviewSubtitle: 'Wybierz kalkulacje dla konstrukcji dachu lub obrobki drewna.',
  availableCalculations: 'Dostepne kalkulacje',
  backToOverview: 'Powrot do przegladu',
  inputValues: 'Wartosci wejsciowe',
  calculate: 'Oblicz',
  reset: 'Resetuj',
  templateHint: 'Uzyj szablonow managera albo wlasnych.',
  result: 'Wynik',
  exportSave: 'Eksportuj i zapisz do projektu',
  exportPdf: 'Eksportuj jako PDF',
  project: 'Projekt',
  openAsOfferDraft: 'Otwórz jako nową ofertę',
  saveToProject: 'Zapisz do projektu',
  notes: 'Uwagi',
  note1: 'Ten kalkulator sluzy jako wstepna estymacja i nie zastepuje profesjonalnego planowania.',
  note2: 'Zawsze stosuj obowiazujace normy (DIN 1052, EN 1995-1-1) dla wymiarowania konstrukcyjnego.',
  note3: 'Straty materialu, laczniki i obrobki krokwi nalezy zaplanowac dodatkowo.',
  projectsLoadFailed: 'Ladowanie projektow nieudane',
  inputsLabel: 'Dane wejsciowe',
  resultsLabel: 'Wyniki',
  pdfCreating: 'Tworzenie PDF...',
  pdfSaved: 'PDF zapisany!',
  pdfExportFailed: 'Eksport PDF nieudany',
  chooseProject: 'Wybierz projekt.',
  projectNotFound: 'Nie znaleziono projektu',
  unitPiece: 'szt',
  savedOn: 'zapisano',
  savedToProject: 'Kalkulacja zapisana jako dokument.',
  projectSaveFailed: 'Zapis do projektu nieudany',
  saveFailed: 'Zapis nieudany',
  creatingOffer: 'Tworzenie oferty...',
  offerCreatedOpening: 'Oferta utworzona. Otwieram edytor...',
  offerDraftPrepared: 'Szkic oferty przygotowany. Otwieram nowy formularz oferty...',
  noOfferLineItems: 'Brak prawidlowych pozycji oferty z tej kalkulacji.',
  roofTypes: {
    satteldach: 'Dach dwuspadowy',
    pultdach: 'Dach jednospadowy',
    walmdach: 'Dach czterospadowy',
    krueppelwalmdach: 'Dach polszczytowy',
    mansarddach: 'Dach mansardowy',
    flachdach: 'Dach plaski (mieszkalny)',
    landwirtschaft: 'Wiezba rolnicza'
  },
  modes: {
    all: 'Wszystko (wiezba + laty + pokrycie)',
    frame: 'Tylko wiezba dachowa',
    lathing: 'Tylko lacenie',
    covering: 'Tylko pokrycie dachu'
  },
  sections: {
    general: 'Ogolne',
    baseData: 'Dane bazowe',
    roofTypeSpecific: 'Specyficzne dla typu dachu',
    dormers: 'Lukarny',
    frame: 'Wiezba dachowa',
    lathing: 'Lacenie',
    covering: 'Pokrycie',
    costs: 'Koszty'
  },
  fields: {
    roofType: 'Typ dachu',
    calcMode: 'Zakres obliczen',
    widthM: 'Szerokosc budynku (m)',
    lengthM: 'Dlugosc budynku (m)',
    roofPitch: 'Nachylenie dachu (deg)',
    rafterSpacing: 'Rozstaw krokwi (cm)',
    rafterWidth: 'Szerokosc krokwi (mm)',
    rafterHeight: 'Wysokosc krokwi (mm)',
    rafterOverhang: 'Wysieg krokwi (m)',
    beamLength: 'Dlugosc belki (m)',
    beamWidth: 'Szerokosc belki (mm)',
    beamHeight: 'Wysokosc belki (mm)',
    beamSpacing: 'Rozstaw belek (cm)',
    spanWidth: 'Rozpietosc szerokosc (m)',
    spanLength: 'Rozpietosc dlugosc (m)',
    units: 'Liczba elementow',
    timePerUnit: 'Czas na element (h)',
    workers: 'Monterzy',
    overheadPercent: 'Narzu procentowy',
    machineHoursPerUnit: 'Godziny maszynowe na element',
    safetyFactor: 'Wspolczynnik bezpieczenstwa',
    formworkArea: 'Powierzchnia szalunku (m2)',
    formworkThickness: 'Grubosc szalunku (mm)',
    efficiency: 'Efektywnosc',
    laborPerSquareMeter: 'Czas pracy na m2 (h)',
    concreteSurface: 'Powierzchnia betonu (m2)',
    concreteDepth: 'Glebokosc betonu (m)',
    insulationArea: 'Powierzchnia izolacji (m2)',
    lambdaValue: 'Lambda (W/mK)',
    layerThickness: 'Grubosc warstwy (mm)',
    density: 'Gestosc (kg/m3)',
    cutLossPercent: 'Strata ciecia (%)',
    roofWidth: 'Szerokosc dachu (m)',
    roofLength: 'Dlugosc dachu (m)',
    tileWidth: 'Szerokosc dachowki (mm)',
    tileHeight: 'Wysokosc dachowki (mm)',
    tileCoverageFactor: 'Wspolczynnik krycia dachowki',
    timberPriceM3: 'Cena drewna (EUR/m3)',
    battenPriceLm: 'Cena lat (EUR/mb)',
    frameLaborRate: 'Czas wiezby (h/m3)',
    lathLaborRate: 'Czas lacenia (h/m2)',
    coverLaborRate: 'Czas pokrycia (h/m2)',
    hourlyRate: 'Stawka godzinowa (EUR/h)',
    mansardUpperPitch: 'Nachylenie gorne mansardy (deg)',
    mansardLowerPitch: 'Nachylenie dolne mansardy (deg)',
    walmShare: 'Udzial dlugosci polaci (0-1)',
    flatSlopeDeg: 'Spadek dachu plaskiego (deg)',
    dormerCount: 'Liczba lukarn',
    dormerWidth: 'Szerokosc lukarny (m)',
    dormerDepth: 'Glebokosc lukarny (m)',
    dormerPitch: 'Nachylenie lukarny (deg)',
    piecePriceEuro: 'Cena jednostkowa (EUR)',
    battenSpacing: 'Rozstaw lat (cm)',
    battenLength: 'Dlugosc laty (m)',
    overlap: 'Zaklad (m)'
  },
  outputs: {
    roofAreaBase: 'Bazowa powierzchnia dachu (m2)',
    roofAreaTotal: 'Powierzchnia dachu z lukarnami (m2)',
    dormerArea: 'Dodatkowa powierzchnia lukarn (m2)',
    rafterLength: 'Dlugosc krokwi (m)',
    raftersPerSide: 'Krokwie na strone',
    totalRafters: 'Lacznie krokwi',
    roofArea: 'Powierzchnia dachu (m2)',
    rafterVolume: 'Objetosc drewna krokwi (m3)',
    ridgeHeight: 'Wysokosc kalenicy (m)',
    beamVolume: 'Objetosc na belke (m3)',
    beamsAlongWidth: 'Belki wzdluz szerokosci',
    beamsTotal: 'Lacznie belek',
    totalWoodVolume: 'Calkowita objetosc drewna (m3)',
    cuttingLength: 'Dlugosc ciecia (m)',
    totalHours: 'Lacznie godzin (h)',
    personDays: 'Dni osobowe',
    machineHoursTotal: 'Lacznie godzin maszynowych',
    withOverhead: 'Z narzutem (h)',
    effectiveHours: 'Godziny efektywne (h)',
    requiredFormwork: 'Wymagana powierzchnia szalunku (m2)',
    formworkPanels: 'Plyty szalunkowe (szt)',
    estimatedLabor: 'Godziny pracy (h)',
    concreteVolume: 'Objetosc betonu (m3)',
    wastageLoss: 'Rezerwa strat (m3)',
    insulationVolume: 'Objetosc izolacji (m3)',
    materialWeight: 'Masa materialu (kg)',
    rValue: 'Opor cieplny (m2K/W)',
    workHours: 'Godziny pracy (h)',
    areaWithLoss: 'Powierzchnia ze strata (m2)',
    tileCount: 'Liczba dachowek',
    materialCost: 'Koszt materialu (EUR)',
    laborHours: 'Godziny pracy (h)',
    totalCost: 'Koszt calkowity (EUR)',
    numberOfLaths: 'Liczba rzedow lat',
    totalLathLength: 'Laczna dlugosc lat (m)',
    lathPieces: 'Wymagane laty (szt)',
    frameLaborHours: 'Czas wiezby (h)',
    frameCost: 'Koszt wiezby (EUR)',
    battenLines: 'Liczba rzedow lat',
    lathingLaborHours: 'Czas lacenia (h)',
    lathingCost: 'Koszt lacenia (EUR)',
    coveringLaborHours: 'Czas pokrycia (h)',
    coveringCost: 'Koszt pokrycia (EUR)'
  },
  types: {
    roofSystem: {
      title: 'Wiezba / Laty / Pokrycie',
      longDescription: 'Wybierz typ dachu i licz razem wiezbe, lacenie i pokrycie.'
    },
    roof: {
      title: 'Kalkulacja konstrukcji dachu',
      description: 'Powierzchnia, krokwie, wysokosc kalenicy, objetosc.',
      longDescription: 'Standardowy szablon konstrukcji dachu dla krokwi i powierzchni dachu.'
    },
    abbund: {
      title: 'Kalkulacja obrobki drewna',
      description: 'Ilosc materialu, liczba belek, objetosc, dlugosc ciecia.',
      longDescription: 'Oblicza liczbe belek, objetosc i dlugosc ciecia dla planow obrobki.'
    },
    montage: {
      title: 'Kalkulacja montazu',
      description: 'Godziny pracy, czas maszyny, dni osobowe.',
      longDescription: 'Oblicza wymagany czas montazu, dni osobowe i godziny maszynowe.'
    },
    schalung: {
      title: 'Kalkulacja szalunku',
      description: 'Powierzchnia szalunku, zapotrzebowanie, czas pracy.',
      longDescription: 'Oblicza wymagana powierzchnie szalunku, objetosc betonu i czasy pracy.'
    },
    daemmung: {
      title: 'Kalkulacja izolacji',
      description: 'Powierzchnia, zapotrzebowanie izolacji, wartosc U, godziny pracy.',
      longDescription: 'Oblicza zapotrzebowanie materialu, przewodnosc cieplna i czas pracy dla izolacji.'
    },
    dachlattung: {
      title: 'Kalkulacja lat',
      description: 'Rozstaw lat, liczba lat, dlugosc materialu.',
      longDescription: 'Oblicza liczbe lat, laczna dlugosc materialu i czas montazu.'
    },
    dachdeckung: {
      title: 'Kalkulacja pokrycia dachu',
      description: 'Zapotrzebowanie dachowek, zaklad, powierzchnia dachu, koszt.',
      longDescription: 'Oblicza powierzchnie dachu, zapotrzebowanie dachowek, czas pracy i koszty.'
    }
  },
  offerPositions: 'Pozycje oferty',
  technicalDetails: 'Szczegóły techniczne',
  loadCatalog: 'Załaduj materiały z katalogu',
  catalogLoaded: '{count} materiałów załadowanych',
  manual: 'Ręcznie',
  laborPos: 'Pozycja robocizny',
  posDescription: 'Opis',
  posQty: 'Ilość',
  posUnit: 'Jedn.',
  posCatalog: 'Materiał (katalog)',
  posEp: 'JC (€)',
  posGp: 'WC (€)',
  totalNet: 'Razem netto',
  linkMaterial: 'Powiąż materiał',
  searchMaterial: 'Szukaj materiału…',
  noMaterialsFound: 'Nie znaleziono materiałów',
  linked: 'Powiązano',
  clearLink: 'Usuń powiązanie',
  pos: {
    frameMontage: 'Montaż więźby',
    batten: 'Łata dachowa',
    lathingMontage: 'Układanie łat',
    roofTile: 'Dachówka',
    coveringMontage: 'Montaż pokrycia',
    beam: 'Belka',
    abbundWork: 'Obróbka drewna / ciesielstwo',
    montageLabor: 'Robocizna montaż',
    machineLabor: 'Praca maszyny',
    formworkPanels: 'Płyty szalunkowe',
    formworkLabor: 'Praca szalunkowa',
    insulation: 'Materiał izolacyjny',
    insulationLabor: 'Montaż izolacji',
  },
  machines: 'Maszyny',
  addMachine: 'Dodaj maszynę',
  machine: 'Maszyna',
  selectMachine: 'Wybierz maszynę',
  noMachinesAdded: 'Brak maszyn.',
  vehicles: 'Pojazdy',
  addVehicle: 'Dodaj pojazd',
  vehicle: 'Pojazd',
  selectVehicle: 'Wybierz pojazd',
  noVehiclesAdded: 'Brak pojazdów.',
  days: 'Dni',
  dailyRate: 'Stawka dzienna (€)',
  workdays: 'Dni robocze',
  from: 'Od',
  to: 'Do',
  total: 'Łącznie',
};

const calcCs = {
  title: 'Tesarska kalkulacka',
  subtitle: 'S vlastnimi sablonami pro manazery.',
  overviewTitle: 'Tesarske vypocty',
  overviewSubtitle: 'Vyberte vypocet pro konstrukci strechy nebo opracovani dreva.',
  availableCalculations: 'Dostupne vypocty',
  backToOverview: 'Zpet na prehled',
  inputValues: 'Vstupni hodnoty',
  calculate: 'Vypocitat',
  reset: 'Resetovat',
  templateHint: 'Pouzijte manazerske sablony nebo vlastni sablony.',
  result: 'Vysledek',
  exportSave: 'Exportovat a ulozit do projektu',
  exportPdf: 'Exportovat jako PDF',
  project: 'Projekt',
  openAsOfferDraft: 'Otevřít jako novou nabídku',
  saveToProject: 'Ulozit do projektu',
  notes: 'Poznamky',
  note1: 'Tato kalkulacka slouzi jako prvotni odhad a nenahrazuje odborny navrh.',
  note2: 'Vzdy pouzijte platne normy (DIN 1052, EN 1995-1-1) pro staticke dimenzovani.',
  note3: 'Ztraty materialu, spojovaci prvky a dalsi opracovani je nutne planovat navic.',
  projectsLoadFailed: 'Nacteni projektu se nezdarilo',
  inputsLabel: 'Vstupy',
  resultsLabel: 'Vysledky',
  pdfCreating: 'Vytvarim PDF...',
  pdfSaved: 'PDF ulozeno!',
  pdfExportFailed: 'Export PDF selhal',
  chooseProject: 'Vyberte projekt.',
  projectNotFound: 'Projekt nenalezen',
  unitPiece: 'ks',
  savedOn: 'ulozeno',
  savedToProject: 'Vypocet ulozen jako dokument.',
  projectSaveFailed: 'Ulozeni do projektu se nezdarilo',
  saveFailed: 'Ulozeni selhalo',
  creatingOffer: 'Vytvarim nabidku...',
  offerCreatedOpening: 'Nabidka vytvorena. Oteviram editor...',
  offerDraftPrepared: 'Koncept nabídky připraven. Otevírám nový formulář nabídky...',
  noOfferLineItems: 'Z tohoto vypoctu nejsou dostupne zadne platne polozky nabidky.',
  roofTypes: {
    satteldach: 'Sedlova strecha',
    pultdach: 'Pultova strecha',
    walmdach: 'Valbova strecha',
    krueppelwalmdach: 'Polovalbova strecha',
    mansarddach: 'Mansardova strecha',
    flachdach: 'Plocha strecha (bydleni)',
    landwirtschaft: 'Zemedelsky krov'
  },
  modes: {
    all: 'Vse (krov + late + krytina)',
    frame: 'Pouze krov',
    lathing: 'Pouze latovani',
    covering: 'Pouze stresni krytina'
  },
  sections: {
    general: 'Obecne',
    baseData: 'Zakladni data',
    roofTypeSpecific: 'Specificke pro typ strechy',
    dormers: 'Vikyre',
    frame: 'Krov',
    lathing: 'Latovani',
    covering: 'Krytina',
    costs: 'Naklady'
  },
  fields: {
    roofType: 'Typ strechy',
    calcMode: 'Rozsah vypoctu',
    widthM: 'Sirka budovy (m)',
    lengthM: 'Delka budovy (m)',
    roofPitch: 'Sklon strechy (deg)',
    rafterSpacing: 'Roztec krokvi (cm)',
    rafterWidth: 'Sirka krokve (mm)',
    rafterHeight: 'Vyska krokve (mm)',
    rafterOverhang: 'Presah krokve (m)',
    beamLength: 'Delka nosniku (m)',
    beamWidth: 'Sirka nosniku (mm)',
    beamHeight: 'Vyska nosniku (mm)',
    beamSpacing: 'Roztec nosniku (cm)',
    spanWidth: 'Rozpeti sirka (m)',
    spanLength: 'Rozpeti delka (m)',
    units: 'Pocet prvku',
    timePerUnit: 'Cas na prvek (h)',
    workers: 'Monteri',
    overheadPercent: 'Rezije v procentech',
    machineHoursPerUnit: 'Strojni hodiny na prvek',
    safetyFactor: 'Bezpecnostni faktor',
    formworkArea: 'Plocha bedneni (m2)',
    formworkThickness: 'Tloustka bedneni (mm)',
    efficiency: 'Efektivita',
    laborPerSquareMeter: 'Pracovni cas na m2 (h)',
    concreteSurface: 'Plocha betonu (m2)',
    concreteDepth: 'Hloubka betonu (m)',
    insulationArea: 'Plocha izolace (m2)',
    lambdaValue: 'Lambda (W/mK)',
    layerThickness: 'Tloustka vrstvy (mm)',
    density: 'Hustota (kg/m3)',
    cutLossPercent: 'Ztrata rezem (%)',
    roofWidth: 'Sirka strechy (m)',
    roofLength: 'Delka strechy (m)',
    tileWidth: 'Sirka tasky (mm)',
    tileHeight: 'Vyska tasky (mm)',
    tileCoverageFactor: 'Koeficient kryti tasky',
    timberPriceM3: 'Cena dreva (EUR/m3)',
    battenPriceLm: 'Cena lati (EUR/bm)',
    frameLaborRate: 'Cas krovu (h/m3)',
    lathLaborRate: 'Cas latovani (h/m2)',
    coverLaborRate: 'Cas krytiny (h/m2)',
    hourlyRate: 'Hodinova sazba (EUR/h)',
    mansardUpperPitch: 'Horni sklon mansardy (deg)',
    mansardLowerPitch: 'Dolni sklon mansardy (deg)',
    walmShare: 'Podil delky valby (0-1)',
    flatSlopeDeg: 'Sklon ploche strechy (deg)',
    dormerCount: 'Pocet vikyru',
    dormerWidth: 'Sirka vikyre (m)',
    dormerDepth: 'Hloubka vikyre (m)',
    dormerPitch: 'Sklon vikyre (deg)',
    piecePriceEuro: 'Cena za kus (EUR)',
    battenSpacing: 'Roztec lati (cm)',
    battenLength: 'Delka late (m)',
    overlap: 'Presah (m)'
  },
  outputs: {
    roofAreaBase: 'Zakladni plocha strechy (m2)',
    roofAreaTotal: 'Plocha strechy vc. vikyru (m2)',
    dormerArea: 'Dodatecna plocha vikyru (m2)',
    rafterLength: 'Delka krokve (m)',
    raftersPerSide: 'Krokve na stranu',
    totalRafters: 'Celkem krokvi',
    roofArea: 'Plocha strechy (m2)',
    rafterVolume: 'Objem dreva krokvi (m3)',
    ridgeHeight: 'Vyska hrebenace (m)',
    beamVolume: 'Objem na nosnik (m3)',
    beamsAlongWidth: 'Nosniky pres sirku',
    beamsTotal: 'Celkem nosniku',
    totalWoodVolume: 'Celkovy objem dreva (m3)',
    cuttingLength: 'Delka rezu (m)',
    totalHours: 'Celkove hodiny (h)',
    personDays: 'Osobodni',
    machineHoursTotal: 'Celkove strojni hodiny',
    withOverhead: 'S reziji (h)',
    effectiveHours: 'Efektivni hodiny (h)',
    requiredFormwork: 'Pozadovana plocha bedneni (m2)',
    formworkPanels: 'Panely bedneni (ks)',
    estimatedLabor: 'Pracovni hodiny (h)',
    concreteVolume: 'Objem betonu (m3)',
    wastageLoss: 'Rezerva ztrat (m3)',
    insulationVolume: 'Objem izolace (m3)',
    materialWeight: 'Hmotnost materialu (kg)',
    rValue: 'Tepelny odpor (m2K/W)',
    workHours: 'Pracovni hodiny (h)',
    areaWithLoss: 'Plocha vc. ztrat (m2)',
    tileCount: 'Pocet taskek',
    materialCost: 'Naklady na material (EUR)',
    laborHours: 'Pracovni hodiny (h)',
    totalCost: 'Celkove naklady (EUR)',
    numberOfLaths: 'Pocet rad lati',
    totalLathLength: 'Celkova delka lati (m)',
    lathPieces: 'Potrebne late (ks)',
    frameLaborHours: 'Cas krovu (h)',
    frameCost: 'Naklady krovu (EUR)',
    battenLines: 'Pocet rad lati',
    lathingLaborHours: 'Cas latovani (h)',
    lathingCost: 'Naklady latovani (EUR)',
    coveringLaborHours: 'Cas krytiny (h)',
    coveringCost: 'Naklady krytiny (EUR)'
  },
  types: {
    roofSystem: {
      title: 'Krov / Latovani / Krytina',
      longDescription: 'Vyberte typ strechy a spocitejte krov, latovani i krytinu v jednom kroku.'
    },
    roof: {
      title: 'Vypocet konstrukce strechy',
      description: 'Plocha, krokve, vyska hrebenace, objem.',
      longDescription: 'Standardni sablona konstrukce strechy pro krokve a plochy strechy.'
    },
    abbund: {
      title: 'Vypocet opracovani dreva',
      description: 'Mnozstvi materialu, pocet nosniku, objem, delka rezu.',
      longDescription: 'Pocita pocet nosniku, objem a delku rezu pro vykresy opracovani.'
    },
    montage: {
      title: 'Vypocet montaze',
      description: 'Pracovni hodiny, doba stroje, osobodni.',
      longDescription: 'Pocita potrebny cas montaze, osobodni a strojni hodiny.'
    },
    schalung: {
      title: 'Vypocet bedneni',
      description: 'Plocha bedneni, mnozstvi, pracovni cas.',
      longDescription: 'Pocita pozadovanou plochu bedneni, objem betonu a pracovni casy.'
    },
    daemmung: {
      title: 'Vypocet izolace',
      description: 'Plocha, potreba izolace, U-hodnota, pracovni hodiny.',
      longDescription: 'Pocita potrebu materialu, tepelnou vodivost a pracovni cas pro izolaci.'
    },
    dachlattung: {
      title: 'Vypocet lati',
      description: 'Roztec lati, pocet lati, delka materialu.',
      longDescription: 'Pocita pocet lati, celkovou delku materialu a cas montaze.'
    },
    dachdeckung: {
      title: 'Vypocet krytiny strechy',
      description: 'Potreba taskek, presah, plocha strechy, naklady.',
      longDescription: 'Pocita plochu strechy, potrebu taskek, pracovni cas a naklady.'
    }
  },
  offerPositions: 'Pozice nabídky',
  technicalDetails: 'Technické detaily',
  loadCatalog: 'Načíst materiály z katalogu',
  catalogLoaded: '{count} materiálů načteno',
  manual: 'Ručně',
  laborPos: 'Pracovní pozice',
  posDescription: 'Popis',
  posQty: 'Množství',
  posUnit: 'Jedn.',
  posCatalog: 'Materiál (katalog)',
  posEp: 'JC (€)',
  posGp: 'CC (€)',
  totalNet: 'Celkem netto',
  linkMaterial: 'Propojit materiál',
  searchMaterial: 'Hledat materiál…',
  noMaterialsFound: 'Žádné materiály nenalezeny',
  linked: 'Propojeno',
  clearLink: 'Odstranit propojení',
  pos: {
    frameMontage: 'Montáž krovu',
    batten: 'Střešní lata',
    lathingMontage: 'Kladení latí',
    roofTile: 'Střešní taška',
    coveringMontage: 'Montáž krytiny',
    beam: 'Nosník',
    abbundWork: 'Opracování dřeva / tesařství',
    montageLabor: 'Pracovní síla montáž',
    machineLabor: 'Strojní práce',
    formworkPanels: 'Bednící desky',
    formworkLabor: 'Bednářské práce',
    insulation: 'Izolační materiál',
    insulationLabor: 'Montáž izolace',
  },
  machines: 'Stroje',
  addMachine: 'Přidat stroj',
  machine: 'Stroj',
  selectMachine: 'Vybrat stroj',
  noMachinesAdded: 'Žádné stroje nepřidány.',
  vehicles: 'Vozidla',
  addVehicle: 'Přidat vozidlo',
  vehicle: 'Vozidlo',
  selectVehicle: 'Vybrat vozidlo',
  noVehiclesAdded: 'Žádná vozidla nepřidána.',
  days: 'Dny',
  dailyRate: 'Denní sazba (€)',
  workdays: 'Pracovní dny',
  from: 'Od',
  to: 'Do',
  total: 'Celkem',
};

const reportDe = {
  title: 'Berichte',
  infoText: 'Hier können Sie Berichte zu den verschiedenen Projekten erstellen und exportieren.',
  infoItem1: 'Wählen Sie den gewünschten Zeitraum und die Gruppierung aus, um die Zeitauswertungen anzuzeigen.',
  infoItem2: 'Sie können die Berichte als CSV-Datei exportieren, um sie in Excel oder anderen Programmen weiter zu analysieren.',
  infoItem3: 'Die Berichte enthalten detaillierte Informationen über die Arbeitszeiten und Ausgaben der Projekte.',
  infoItem4: 'Sie können die Berichte nach verschiedenen Kriterien filtern, um gezielte Analysen durchzuführen.',
  infoItem5: 'Nutzen Sie die Berichte, um die Effizienz Ihrer Projekte zu überwachen und Optimierungspotenziale zu identifizieren.',
  subtitle: 'Zeitauswertungen exportieren',
  csvExport: 'CSV Export',
  from: 'Von',
  to: 'Bis',
  grouping: 'Gruppierung',
  byProject: 'Nach Projekt',
  byEmployee: 'Nach Mitarbeiter',
  byDay: 'Nach Tag',
  loading: 'Lädt...',
  show: 'Anzeigen',
  today: 'Heute',
  thisWeek: 'Diese Woche',
  thisMonth: 'Dieser Monat',
  lastMonth: 'Letzter Monat',
  total: 'Gesamt',
  details: 'Detailansicht',
  hours: 'Stunden',
  share: 'Anteil',
  noReport: 'Kein Bericht',
  chooseRangeHint: 'Zeitraum wählen und "Anzeigen" klicken',
  startTour: 'Führung starten',
  tourFilterTitle: 'Filter & Zeitraum',
  tourFilterText: 'Wähle Von/Bis-Datum und Gruppierung – nach Projekt, Mitarbeiter oder Tag. Schnellbuttons für heute, diese Woche und diesen Monat sind ebenfalls verfügbar.',
  tourChartTitle: 'Balkendiagramm',
  tourChartText: 'Die Stunden werden als Balken visualisiert – so erkennst du auf einen Blick welche Projekte oder Mitarbeiter am meisten Zeit buchen.',
  tourTableTitle: 'Detailtabelle',
  tourTableText: 'Exakte Stundenwerte und prozentuale Anteile je Zeile – hilfreich für Auswertungen und Projektabrechnung.',
  tourCsvTitle: 'CSV Export',
  tourCsvText: 'Exportiere die Auswertung als CSV-Datei für Excel oder andere Tools zur weiteren Analyse.',
  hoursByProject: 'Stunden nach Projekt',
  hoursByEmployee: 'Stunden nach Mitarbeiter',
  hoursByDay: 'Stunden nach Tag',
  project: 'Projekt',
  employee: 'Mitarbeiter',
  day: 'Tag',
  loadError: 'Fehler beim Laden',
  exportError: 'Fehler beim Export'
};

const reportEn = {
  title: 'Reports',
  infoText: 'Here you can create and export reports for the different projects.',
  infoItem1: 'Select the desired time range and grouping to view the time evaluations.',
  infoItem2: 'You can export the reports as a CSV file to further analyze them in Excel or other programs.',
  infoItem3: 'The reports contain detailed information about the working hours and expenses of the projects.',
  infoItem4: 'You can filter the reports by different criteria to perform targeted analyses.',
  infoItem5: 'Use the reports to monitor the efficiency of your projects and identify optimization potentials.',
  subtitle: 'Export time evaluations',
  csvExport: 'CSV export',
  from: 'From',
  to: 'To',
  grouping: 'Grouping',
  byProject: 'By project',
  byEmployee: 'By employee',
  byDay: 'By day',
  loading: 'Loading...',
  show: 'Show',
  today: 'Today',
  thisWeek: 'This week',
  thisMonth: 'This month',
  lastMonth: 'Last month',
  total: 'Total',
  details: 'Details',
  hours: 'Hours',
  share: 'Share',
  noReport: 'No report',
  chooseRangeHint: 'Choose range and click "Show"',
  startTour: 'Start tour',
  tourFilterTitle: 'Filter & date range',
  tourFilterText: 'Choose from/to dates and grouping – by project, employee or day. Quick buttons for today, this week and this month are also available.',
  tourChartTitle: 'Bar chart',
  tourChartText: 'Hours are visualised as bars – at a glance you can see which projects or employees book the most time.',
  tourTableTitle: 'Detail table',
  tourTableText: 'Exact hour values and percentage shares per row – useful for evaluations and project billing.',
  tourCsvTitle: 'CSV export',
  tourCsvText: 'Export the report as a CSV file for Excel or other tools for further analysis.',
  hoursByProject: 'Hours by project',
  hoursByEmployee: 'Hours by employee',
  hoursByDay: 'Hours by day',
  project: 'Project',
  employee: 'Employee',
  day: 'Day',
  loadError: 'Loading failed',
  exportError: 'Export failed'
};

const reportFr = {
  title: 'Rapports',
  infoText: 'Ici, vous pouvez créer et exporter des rapports pour les différents projets.',
  infoItem1: 'Sélectionnez la période souhaitée et le regroupement pour voir les évaluations temporelles.',
  infoItem2: 'Vous pouvez exporter les rapports sous forme de fichier CSV pour les analyser davantage dans Excel ou d\'autres programmes.',
  infoItem3: 'Les rapports contiennent des informations détaillées sur les heures de travail et les dépenses des projets.',
  infoItem4: 'Vous pouvez filtrer les rapports par différents critères pour effectuer des analyses ciblées.',
  infoItem5: 'Utilisez les rapports pour surveiller l\'efficacité de vos projets et identifier les opportunités d\'optimisation.',
  subtitle: 'Exporter les analyses de temps',
  csvExport: 'Export CSV',
  from: 'De',
  to: 'A',
  grouping: 'Regroupement',
  byProject: 'Par projet',
  byEmployee: 'Par employe',
  byDay: 'Par jour',
  loading: 'Chargement...',
  show: 'Afficher',
  today: "Aujourd'hui",
  thisWeek: 'Cette semaine',
  thisMonth: 'Ce mois-ci',
  lastMonth: 'Mois dernier',
  total: 'Total',
  details: 'Details',
  hours: 'Heures',
  share: 'Part',
  noReport: 'Aucun rapport',
  chooseRangeHint: 'Choisissez la periode puis cliquez sur "Afficher"',
  startTour: 'Lancer la visite guidée',
  tourFilterTitle: 'Filtres & période',
  tourFilterText: 'Choisissez les dates de début/fin et le regroupement – par projet, employé ou jour. Des boutons rapides sont disponibles pour aujourd\'hui, cette semaine et ce mois.',
  tourChartTitle: 'Diagramme à barres',
  tourChartText: 'Les heures sont visualisées sous forme de barres – en un coup d\'œil vous voyez quels projets ou employés réservent le plus de temps.',
  tourTableTitle: 'Tableau détaillé',
  tourTableText: 'Valeurs exactes et pourcentages par ligne – utile pour les analyses et la facturation de projets.',
  tourCsvTitle: 'Export CSV',
  tourCsvText: 'Exportez le rapport en fichier CSV pour Excel ou d\'autres outils d\'analyse.',
  hoursByProject: 'Heures par projet',
  hoursByEmployee: 'Heures par employe',
  hoursByDay: 'Heures par jour',
  project: 'Projet',
  employee: 'Employe',
  day: 'Jour',
  loadError: 'Erreur de chargement',
  exportError: 'Erreur d\'export'
};

const reportIt = {
  title: 'Report',
  infoText: 'Qui puoi creare ed esportare report per i diversi progetti.',
  infoItem1: 'Seleziona l\'intervallo di tempo desiderato e il raggruppamento per visualizzare le valutazioni temporali.',
  infoItem2: 'Puoi esportare i report come file CSV per analizzarli ulteriormente in Excel o altri programmi.',
  infoItem3: 'I report contengono informazioni dettagliate sulle ore di lavoro e sulle spese dei progetti.',
  infoItem4: 'Puoi filtrare i report secondo diversi criteri per effettuare analisi mirate.',
  infoItem5: 'Utilizza i report per monitorare l\'efficienza dei tuoi progetti e identificare potenziali opportunità di ottimizzazione.',
  subtitle: 'Esporta analisi tempi',
  csvExport: 'Export CSV',
  from: 'Da',
  to: 'A',
  grouping: 'Raggruppamento',
  byProject: 'Per progetto',
  byEmployee: 'Per dipendente',
  byDay: 'Per giorno',
  loading: 'Caricamento...',
  show: 'Mostra',
  today: 'Oggi',
  thisWeek: 'Questa settimana',
  thisMonth: 'Questo mese',
  lastMonth: 'Mese scorso',
  total: 'Totale',
  details: 'Dettagli',
  hours: 'Ore',
  share: 'Quota',
  noReport: 'Nessun report',
  chooseRangeHint: 'Scegli intervallo e clicca "Mostra"',
  startTour: 'Avvia la guida',
  tourFilterTitle: 'Filtri & periodo',
  tourFilterText: 'Scegli date da/a e raggruppamento – per progetto, dipendente o giorno. Pulsanti rapidi per oggi, questa settimana e questo mese.',
  tourChartTitle: 'Grafico a barre',
  tourChartText: 'Le ore sono visualizzate come barre – a colpo d\'occhio vedi quali progetti o dipendenti prenotano più tempo.',
  tourTableTitle: 'Tabella di dettaglio',
  tourTableText: 'Valori esatti e percentuali per riga – utile per analisi e fatturazione progetti.',
  tourCsvTitle: 'Esporta CSV',
  tourCsvText: 'Esporta il report come file CSV per Excel o altri strumenti di analisi.',
  hoursByProject: 'Ore per progetto',
  hoursByEmployee: 'Ore per dipendente',
  hoursByDay: 'Ore per giorno',
  project: 'Progetto',
  employee: 'Dipendente',
  day: 'Giorno',
  loadError: 'Caricamento non riuscito',
  exportError: 'Export non riuscito'
};

const reportPl = {
  title: 'Raporty',
  infoText: 'Tutaj możesz tworzyć i eksportować raporty dla różnych projektów.',
  infoItem1: 'Wybierz żądany zakres czasu i grupowanie, aby wyświetlić oceny czasowe.',
  infoItem2: 'Możesz eksportować raporty jako plik CSV, aby dalej je analizować w Excelu lub innych programach.',
  infoItem3: 'Raporty zawierają szczegółowe informacje o godzinach pracy i kosztach projektów.',
  infoItem4: 'Możesz filtrować raporty według różnych kryteriów, aby przeprowadzać celowane analizy.',
  infoItem5: 'Używaj raportów do monitorowania efektywności swoich projektów i identyfikowania potencjalnych możliwości optymalizacji.',
  subtitle: 'Eksportuj analizy czasu',
  csvExport: 'Eksport CSV',
  from: 'Od',
  to: 'Do',
  grouping: 'Grupowanie',
  byProject: 'Wedlug projektu',
  byEmployee: 'Wedlug pracownika',
  byDay: 'Wedlug dnia',
  loading: 'Ladowanie...',
  show: 'Pokaz',
  today: 'Dzisiaj',
  thisWeek: 'Ten tydzien',
  thisMonth: 'Ten miesiac',
  lastMonth: 'Poprzedni miesiac',
  total: 'Razem',
  details: 'Szczegoly',
  hours: 'Godziny',
  share: 'Udzial',
  noReport: 'Brak raportu',
  chooseRangeHint: 'Wybierz zakres i kliknij "Pokaz"',
  startTour: 'Uruchom przewodnik',
  tourFilterTitle: 'Filtry i zakres dat',
  tourFilterText: 'Wybierz daty od/do i grupowanie – według projektu, pracownika lub dnia. Dostępne są przyciski szybkiego wyboru dla dziś, tego tygodnia i miesiąca.',
  tourChartTitle: 'Wykres słupkowy',
  tourChartText: 'Godziny są wizualizowane jako słupki – na pierwszy rzut oka widać które projekty lub pracownicy rezerwują najwięcej czasu.',
  tourTableTitle: 'Tabela szczegółów',
  tourTableText: 'Dokładne wartości godzin i udziały procentowe per wiersz – przydatne do analiz i rozliczeń projektów.',
  tourCsvTitle: 'Eksport CSV',
  tourCsvText: 'Eksportuj raport jako plik CSV do Excela lub innych narzędzi analizy.',
  hoursByProject: 'Godziny wedlug projektu',
  hoursByEmployee: 'Godziny wedlug pracownika',
  hoursByDay: 'Godziny wedlug dnia',
  project: 'Projekt',
  employee: 'Pracownik',
  day: 'Dzien',
  loadError: 'Blad ladowania',
  exportError: 'Blad eksportu'
};

const reportCs = {
  title: 'Reporty',
  infoText: 'Zde můžete vytvářet a exportovat reporty pro různé projekty.',
  infoItem1: 'Vyberte požadované období a skupinování pro zobrazení časových hodnocení.',
  infoItem2: 'Můžete exportovat reporty jako soubor CSV pro další analýzu v Excelu nebo jiných programech.',
  infoItem3: 'Reporty obsahují podrobné informace o pracovních hodinách a nákladech projektů.',
  infoItem4: 'Můžete filtrovat reporty podle různých kritérií pro provádění cílených analýz.',
  infoItem5: 'Používejte reporty k monitorování efektivity vašich projektů a identifikaci potenciálních příležitostí pro optimalizaci.',
  subtitle: 'Export časových vyhodnocení',
  csvExport: 'CSV export',
  from: 'Od',
  to: 'Do',
  grouping: 'Seskupení',
  byProject: 'Podle projektu',
  byEmployee: 'Podle zaměstnance',
  byDay: 'Podle dne',
  loading: 'Nahrávám...',
  show: 'Zobrazit',
  today: 'Dnes',
  thisWeek: 'Tento tyden',
  thisMonth: 'Tento mesic',
  lastMonth: 'Minuly mesic',
  total: 'Celkem',
  details: 'Detaily',
  hours: 'Hodiny',
  share: 'Podil',
  noReport: 'Zadny report',
  chooseRangeHint: 'Vyberte rozsah a kliknete na "Zobrazit"',
  startTour: 'Spustit průvodce',
  tourFilterTitle: 'Filtry a časové období',
  tourFilterText: 'Zvolte datum od/do a seskupení – podle projektu, zaměstnance nebo dne. K dispozici jsou rychlá tlačítka pro dnes, tento týden a měsíc.',
  tourChartTitle: 'Sloupcový graf',
  tourChartText: 'Hodiny jsou vizualizovány jako sloupce – na první pohled vidíte které projekty nebo zaměstnanci rezervují nejvíce času.',
  tourTableTitle: 'Detailní tabulka',
  tourTableText: 'Přesné hodnoty hodin a procentní podíly na řádek – užitečné pro analýzy a fakturaci projektů.',
  tourCsvTitle: 'Export CSV',
  tourCsvText: 'Exportujte výkaz jako soubor CSV pro Excel nebo jiné analytické nástroje.',
  hoursByProject: 'Hodiny podle projektu',
  hoursByEmployee: 'Hodiny podle zamestnance',
  hoursByDay: 'Hodiny podle dne',
  project: 'Projekt',
  employee: 'Zamestnanec',
  day: 'Den',
  loadError: 'Nacteni selhalo',
  exportError: 'Export selhal'
};

const vacationDe = {
  title: 'Urlaubsverwaltung',
  infoText: 'Hier kannst du deinen Urlaub beantragen und verwalten.',
  infoItem1: 'Dein Gesamturlaub wird angezeigt, inklusive genommener und verbleibender Tage.',
  infoItem2: 'Du kannst neue Urlaubsanträge stellen und den Status deiner Anträge verfolgen.',
  infoItem3: 'Du kannst Anträge zurückziehen, solange sie noch nicht genehmigt oder abgelehnt wurden.',
  infoItem4: 'Wenn du während deines Urlaubs krank wirst, kannst du eine Rückbuchung der betroffenen Tage beantragen.',
  infoItem5: 'In der Teamansicht kannst du alle Anträge deines Teams sehen und verwalten (nur für Teamleiter).',
  subtitle: 'Urlaub beantragen und verwalten',
  totalVacation: 'Gesamturlaub',
  used: 'Genommen',
  remaining: 'Verbleibend',
  day: 'Tag',
  days: 'Tage',
  of: 'von',
  newRequest: 'Neuen Urlaubsantrag stellen',
  workdays: 'Werktage',
  workday: 'Arbeitstag',
  workdaysPlural: 'Arbeitstage',
  optional: 'Optional...',
  submitRequest: 'Antrag stellen',
  holidayNotAllowed: 'Buchung an Feiertagen nicht möglich',
  startTour: 'Führung starten',
  tourStatsTitle: 'Urlaubskonto',
  tourStatsText: 'Deine Gesamttage, bereits verbrauchte Tage und der verbleibende Resturlaub für dieses Jahr.',
  tourRequestTitle: 'Urlaub beantragen',
  tourRequestText: 'Wähle Start- und Enddatum – Arbeitstage werden automatisch berechnet. Mit einem optionalen Hinweis absenden.',
  tourMyTitle: 'Meine Anträge',
  tourMyText: 'Alle deine eingereichten Urlaubsanträge mit Status (ausstehend, genehmigt, abgelehnt). Ausstehende Anträge können storniert werden. Erkrankst du an einem genehmigten Urlaubstag, kann dieser mit ärztlichem Attest zurückgebucht werden.',
  tourTeamTitle: 'Team-Anträge',
  tourTeamText: 'Als Manager siehst du hier alle Urlaubsanträge deines Teams und kannst sie direkt genehmigen oder ablehnen.',
  myRequests: 'Meine Anträge',
  allRequestsTeam: 'Alle Anträge (Team)',
  noRequests: 'Keine Anträge',
  withdrawRequest: 'Antrag zurückziehen',
  actions: 'Aktionen',
  approve: 'Genehmigen',
  reject: 'Ablehnen',
  periodRequired: 'Zeitraum erforderlich',
  requestSubmitted: 'Urlaubsantrag gestellt',
  submitError: 'Fehler beim Stellen des Antrags',
  withdrawConfirm: 'Antrag zurückziehen?',
  withdrawn: 'Zurückgezogen',
  approved: 'Genehmigt',
  rejected: 'Abgelehnt',
  sickRebookBtn: 'Krank während Urlaub',
  sickRebookTitle: 'Urlaubstage zurückbuchen',
  sickRebookDesc: 'Geben Sie den Krankheitszeitraum an, der in den Urlaubszeitraum fiel. Überschneidende Arbeitstage werden Ihnen gutgeschrieben.',
  sickRebookNote: 'Hinweis (optional)',
  sickRebookCancel: 'Abbrechen',
  sickRebookError: 'Fehler beim Zurückbuchen',
  sickRebookAlready: 'Krank gemeldet',
  sickRebookDay: 'Tag zurückgebucht',
  sickRebookDays: 'Tage zurückgebucht',
  sickRebookRejectedRangeError: 'Dieser Zeitraum wurde bereits abgelehnt. Bitte wählen Sie andere Urlaubstage.',
  sickRebookSubmit: ' Rückbuchung beantragen',
  sickRebookRequested: 'Rückbuchungsantrag wurde eingereicht',
  sickRebookPending: 'Rückbuchung angefragt',
  sickRebookApprove: 'Rückbuchung genehmigen',
  sickRebookReject: 'Rückbuchung ablehnen',
  sickRebookApproved: 'Rückbuchung genehmigt',
  sickRebookRejected: 'Rückbuchung abgelehnt',
  sickRebookReviewError: 'Fehler bei der Entscheidung'
};

const vacationEn = {
  title: 'Vacation management',
  infoText: 'Here you can create and export reports for different projects.',
  infoItem1: 'Select the desired time period and grouping to view temporal evaluations.',
  infoItem2: 'You can export reports as a CSV file for further analysis in Excel or other programs.',
  infoItem3: 'Reports contain detailed information about work hours and project expenses.',
  infoItem4: 'You can filter reports by different criteria to perform targeted analyses.',
  infoItem5: 'Use reports to monitor the efficiency of your projects and identify potential optimization opportunities.',
  subtitle: 'Request and manage vacation',
  totalVacation: 'Total vacation',
  used: 'Used',
  remaining: 'Remaining',
  day: 'day',
  days: 'days',
  of: 'of',
  newRequest: 'Submit new vacation request',
  workdays: 'Workdays',
  workday: 'workday',
  workdaysPlural: 'workdays',
  optional: 'Optional...',
  submitRequest: 'Submit request',
  holidayNotAllowed: 'Booking on public holidays not possible',
  startTour: 'Start tour',
  tourStatsTitle: 'Vacation balance',
  tourStatsText: 'Your total days, days already used, and remaining vacation for this year.',
  tourRequestTitle: 'Request vacation',
  tourRequestText: 'Choose start and end date – working days are calculated automatically. Submit with an optional note.',
  tourMyTitle: 'My requests',
  tourMyText: 'All your submitted vacation requests with status (pending, approved, rejected). Pending requests can be cancelled. If you fall ill on an approved vacation day, it can be reversed with a medical certificate.',
  tourTeamTitle: 'Team requests',
  tourTeamText: 'As a manager you see all vacation requests from your team and can approve or reject them directly.',
  myRequests: 'My requests',
  allRequestsTeam: 'All requests (team)',
  noRequests: 'No requests',
  withdrawRequest: 'Withdraw request',
  actions: 'Actions',
  approve: 'Approve',
  reject: 'Reject',
  periodRequired: 'Date range required',
  requestSubmitted: 'Vacation request submitted',
  submitError: 'Failed to submit request',
  withdrawConfirm: 'Withdraw request?',
  withdrawn: 'Withdrawn',
  approved: 'Approved',
  rejected: 'Rejected',
  sickRebookBtn: 'Sick during vacation',
  sickRebookTitle: 'Reclaim vacation days',
  sickRebookDesc: 'Enter the sick period that overlapped with your vacation. Overlapping workdays will be credited back.',
  sickRebookNote: 'Note (optional)',
  sickRebookCancel: 'Cancel',
  sickRebookError: 'Failed to reclaim days',
  sickRebookAlready: 'Illness reported',
  sickRebookDay: 'day reclaimed',
  sickRebookDays: 'days reclaimed',
  sickRebookRejectedRangeError: 'This range was already rejected. Please choose different vacation days.',
  sickRebookSubmit: 'Request rebooking',
  sickRebookRequested: 'Rebooking request submitted',
  sickRebookPending: 'Rebooking requested',
  sickRebookApprove: 'Approve rebooking',
  sickRebookReject: 'Reject rebooking',
  sickRebookApproved: 'Rebooking approved',
  sickRebookRejected: 'Rebooking rejected',
  sickRebookReviewError: 'Decision failed'
};

const vacationFr = {
  title: 'Gestion des conges',
  infoText: 'Ici, vous pouvez créer et exporter des rapports pour différents projets.',
  infoItem1: 'Sélectionnez la période souhaitée et le regroupement pour visualiser les évaluations temporelles.',
  infoItem2: 'Vous pouvez exporter les rapports sous forme de fichier CSV pour une analyse supplémentaire dans Excel ou d\'autres programmes.',
  infoItem3: 'Les rapports contiennent des informations détaillées sur les heures de travail et les dépenses des projets.',
  infoItem4: 'Vous pouvez filtrer les rapports par différents critères pour effectuer des analyses ciblées.',
  infoItem5: 'Utilisez les rapports pour surveiller l\'efficacité de vos projets et identifier les opportunités d\'optimisation potentielles.',
  subtitle: 'Demander et gerer les conges',
  totalVacation: 'Conges totaux',
  used: 'Pris',
  remaining: 'Restant',
  day: 'jour',
  days: 'jours',
  of: 'de',
  newRequest: 'Soumettre une nouvelle demande de conges',
  workdays: 'Jours ouvrables',
  workday: 'jour ouvrable',
  workdaysPlural: 'jours ouvrables',
  optional: 'Optionnel...',
  submitRequest: 'Soumettre demande',
  holidayNotAllowed: 'Réservation les jours fériés impossible',
  startTour: 'Lancer la visite guidée',
  tourStatsTitle: 'Solde de congés',
  tourStatsText: 'Vos jours totaux, jours déjà utilisés et congés restants pour cette année.',
  tourRequestTitle: 'Demander des congés',
  tourRequestText: 'Choisissez date de début et de fin – les jours ouvrables sont calculés automatiquement. Envoyez avec une note optionnelle.',
  tourMyTitle: 'Mes demandes',
  tourMyText: 'Toutes vos demandes de congés avec statut (en attente, approuvée, refusée). Les demandes en attente peuvent être annulées. En cas de maladie un jour de congé approuvé, il peut être annulé avec un certificat médical.',
  tourTeamTitle: 'Demandes de l\'équipe',
  tourTeamText: 'En tant que manager vous voyez toutes les demandes de congés de votre équipe et pouvez les approuver ou refuser directement.',
  myRequests: 'Mes demandes',
  allRequestsTeam: 'Toutes les demandes (equipe)',
  noRequests: 'Aucune demande',
  withdrawRequest: 'Retirer la demande',
  actions: 'Actions',
  approve: 'Approuver',
  reject: 'Rejeter',
  periodRequired: 'Periode requise',
  requestSubmitted: 'Demande de conges soumise',
  submitError: 'Echec de soumission de la demande',
  withdrawConfirm: 'Retirer la demande ?',
  withdrawn: 'Retiree',
  approved: 'Approuvee',
  rejected: 'Rejetee',
  sickRebookBtn: 'Maladie pendant conge',
  sickRebookTitle: 'Recuperer les jours de conge',
  sickRebookDesc: 'Indiquez la periode de maladie qui chevauchait vos conges. Les jours ouvrables en chevauchement vous seront restitues.',
  sickRebookNote: 'Remarque (optionnel)',
  sickRebookCancel: 'Annuler',
  sickRebookError: 'Echec de la recuperation des jours',
  sickRebookAlready: 'Maladie signalee',
  sickRebookDay: 'jour recupere',
  sickRebookDays: 'jours recuperes',
  sickRebookRejectedRangeError: 'Cette periode a deja ete refusee. Veuillez choisir d\'autres jours de conge.',
  sickRebookSubmit: 'Demander la recuperation',
  sickRebookRequested: 'Demande de recuperation envoyee',
  sickRebookPending: 'Recuperation demandee',
  sickRebookApprove: 'Approuver la recuperation',
  sickRebookReject: 'Refuser la recuperation',
  sickRebookApproved: 'Recuperation approuvee',
  sickRebookRejected: 'Recuperation refusee',
  sickRebookReviewError: 'Echec de la decision'
};

const vacationIt = {
  title: 'Gestione ferie',
  infoText: 'Qui puoi creare ed esportare report per diversi progetti.',
  infoItem1: 'Seleziona il periodo di tempo desiderato e il raggruppamento per visualizzare le valutazioni temporali.',
  infoItem2: 'Puoi esportare i report come file CSV per ulteriori analisi in Excel o altri programmi.',
  infoItem3: 'I report contengono informazioni dettagliate sulle ore di lavoro e sulle spese dei progetti.',
  infoItem4: 'Puoi filtrare i report per diversi criteri per effettuare analisi mirate.',
  infoItem5: 'Utilizza i report per monitorare l\'efficienza dei tuoi progetti e identificare potenziali opportunità di ottimizzazione.',
  subtitle: 'Richiedi e gestisci ferie',
  totalVacation: 'Ferie totali',
  used: 'Usati',
  remaining: 'Residui',
  day: 'giorno',
  days: 'giorni',
  of: 'di',
  newRequest: 'Invia nuova richiesta ferie',
  workdays: 'Giorni lavorativi',
  workday: 'giorno lavorativo',
  workdaysPlural: 'giorni lavorativi',
  optional: 'Opzionale...',
  submitRequest: 'Invia richiesta',
  holidayNotAllowed: 'Prenotazione nei giorni festivi non possibile',
  startTour: 'Avvia la guida',
  tourStatsTitle: 'Saldo ferie',
  tourStatsText: 'I tuoi giorni totali, giorni già usati e ferie rimanenti per quest\'anno.',
  tourRequestTitle: 'Richiedere ferie',
  tourRequestText: 'Scegli data inizio e fine – i giorni lavorativi vengono calcolati automaticamente. Invia con una nota opzionale.',
  tourMyTitle: 'Le mie richieste',
  tourMyText: 'Tutte le tue richieste di ferie con stato (in attesa, approvata, rifiutata). Le richieste in attesa possono essere annullate. In caso di malattia in un giorno di ferie approvato, può essere annullato con certificato medico.',
  tourTeamTitle: 'Richieste del team',
  tourTeamText: 'Come manager vedi tutte le richieste di ferie del tuo team e puoi approvarle o rifiutarle direttamente.',
  myRequests: 'Le mie richieste',
  allRequestsTeam: 'Tutte le richieste (team)',
  noRequests: 'Nessuna richiesta',
  withdrawRequest: 'Ritira richiesta',
  actions: 'Azioni',
  approve: 'Approva',
  reject: 'Rifiuta',
  periodRequired: 'Intervallo date richiesto',
  requestSubmitted: 'Richiesta ferie inviata',
  submitError: 'Invio richiesta non riuscito',
  withdrawConfirm: 'Ritirare la richiesta?',
  withdrawn: 'Ritirata',
  approved: 'Approvata',
  rejected: 'Rifiutata',
  sickRebookBtn: 'Malattia durante ferie',
  sickRebookTitle: 'Recupera giorni ferie',
  sickRebookDesc: 'Inserisci il periodo di malattia che ha coinciso con le ferie. I giorni lavorativi sovrapposti ti verranno accreditati.',
  sickRebookNote: 'Nota (opzionale)',
  sickRebookCancel: 'Annulla',
  sickRebookError: 'Recupero giorni non riuscito',
  sickRebookAlready: 'Malattia segnalata',
  sickRebookDay: 'giorno recuperato',
  sickRebookDays: 'giorni recuperati',
  sickRebookRejectedRangeError: 'Questo intervallo e gia stato rifiutato. Seleziona altri giorni di ferie.',
  sickRebookSubmit: 'Richiedi riaccredito',
  sickRebookRequested: 'Richiesta di riaccredito inviata',
  sickRebookPending: 'Riaccredito richiesto',
  sickRebookApprove: 'Approva riaccredito',
  sickRebookReject: 'Rifiuta riaccredito',
  sickRebookApproved: 'Riaccredito approvato',
  sickRebookRejected: 'Riaccredito rifiutato',
  sickRebookReviewError: 'Decisione non riuscita'
};

const vacationPl = {
  title: 'Zarzadzanie urlopami',
  subtitle: 'Skladaj i zarzadzaj wnioskami urlopowymi',
  infoText: 'Tutaj mozesz tworzyc i eksportowac raporty dla różnych projektów.',
  infoItem1: 'Wybierz żądany okres czasu i grupowanie, aby wyświetlić oceny czasowe.',
  infoItem2: 'Możesz eksportować raporty jako plik CSV do dalszej analizy w Excelu lub innych programach.',
  infoItem3: 'Raporty zawierają szczegółowe informacje o godzinach pracy i kosztach projektów.',
  infoItem4: 'Możesz filtrować raporty według różnych kryteriów, aby przeprowadzić celne analizy.',
  infoItem5: 'Używaj raportów do monitorowania efektywności swoich projektów i identyfikowania potencjalnych możliwości optymalizacji.',
  totalVacation: 'Urlop laczny',
  used: 'Wykorzystano',
  remaining: 'Pozostalo',
  day: 'dzien',
  days: 'dni',
  of: 'z',
  newRequest: 'Zloz nowy wniosek urlopowy',
  workdays: 'Dni robocze',
  workday: 'dzien roboczy',
  workdaysPlural: 'dni robocze',
  optional: 'Opcjonalnie...',
  submitRequest: 'Zloz wniosek',
  holidayNotAllowed: 'Rezerwacja w dni świąteczne niemożliwa',
  startTour: 'Uruchom przewodnik',
  tourStatsTitle: 'Saldo urlopowe',
  tourStatsText: 'Twoje łączne dni, już wykorzystane dni i pozostały urlop na ten rok.',
  tourRequestTitle: 'Złóż wniosek urlopowy',
  tourRequestText: 'Wybierz datę początku i końca – dni robocze są obliczane automatycznie. Wyślij z opcjonalną notatką.',
  tourMyTitle: 'Moje wnioski',
  tourMyText: 'Wszystkie Twoje wnioski urlopowe ze statusem (oczekujący, zatwierdzony, odrzucony). Oczekujące wnioski można anulować. W razie choroby w zatwierdzonym dniu urlopu można go cofnąć za pomocą zaświadczenia lekarskiego.',
  tourTeamTitle: 'Wnioski zespołu',
  tourTeamText: 'Jako manager widzisz wszystkie wnioski urlopowe swojego zespołu i możesz je bezpośrednio zatwierdzić lub odrzucić.',
  myRequests: 'Moje wnioski',
  allRequestsTeam: 'Wszystkie wnioski (zespol)',
  noRequests: 'Brak wnioskow',
  withdrawRequest: 'Wycofaj wniosek',
  actions: 'Akcje',
  approve: 'Zatwierdz',
  reject: 'Odrzuc',
  periodRequired: 'Wymagany zakres dat',
  requestSubmitted: 'Wniosek urlopowy zlozony',
  submitError: 'Nie udalo sie zlozyc wniosku',
  withdrawConfirm: 'Wycofac wniosek?',
  withdrawn: 'Wycofany',
  approved: 'Zatwierdzony',
  rejected: 'Odrzucony',
  sickRebookBtn: 'Choroba podczas urlopu',
  sickRebookTitle: 'Odzyskaj dni urlopu',
  sickRebookDesc: 'Podaj okres choroby, ktory pokryl sie z urlopem. Pokrywajace sie dni robocze zostana Ci zwrocone.',
  sickRebookNote: 'Uwaga (opcjonalnie)',
  sickRebookCancel: 'Anuluj',
  sickRebookError: 'Nie udalo sie odzyskac dni',
  sickRebookAlready: 'Choroba zgloszona',
  sickRebookDay: 'dzien odzyskany',
  sickRebookDays: 'dni odzyskane',
  sickRebookRejectedRangeError: 'Ten zakres zostal juz odrzucony. Wybierz inne dni urlopu.',
  sickRebookSubmit: 'Zloz wniosek o zwrot',
  sickRebookRequested: 'Wniosek o zwrot zostal wyslany',
  sickRebookPending: 'Zwrot oczekuje',
  sickRebookApprove: 'Zatwierdz zwrot',
  sickRebookReject: 'Odrzuc zwrot',
  sickRebookApproved: 'Zwrot zatwierdzony',
  sickRebookRejected: 'Zwrot odrzucony',
  sickRebookReviewError: 'Decyzja nie powiodla sie'
};

const vacationCs = {
  title: 'Sprava dovolene',
  infoText: 'Zde muzete vytvaret a exportovat reporty pro ruzne projekty.',
  infoItem1: 'Vyberte pozadovany obdobi a seskupeni, abyste zobrazeni casove ohodnoceni.',
  infoItem2: 'Muzete exportovat reporty jako soubor CSV pro dalsi analyzu v Excelu nebo jinych programech.',
  infoItem3: 'Reporty obsahuj detailni informace o pracovnich hodinach a kositech projektu.',
  infoItem4: 'Muzete filtrovat reporty podle ruznych kriterii, aby provadeli cilene analyzy.',
  infoItem5: 'Pouzivejte reporty k monitorovani efektivity vasich projektu a identifikaci potencialnich moznosti optimalizace.',
  subtitle: 'Zadejte a spravujte dovolenou',
  totalVacation: 'Celkova dovolena',
  used: 'Vycerpano',
  remaining: 'Zbyva',
  day: 'den',
  days: 'dny',
  of: 'z',
  newRequest: 'Podat novou zadost o dovolenou',
  workdays: 'Pracovni dny',
  workday: 'pracovni den',
  workdaysPlural: 'pracovni dny',
  optional: 'Volitelne...',
  submitRequest: 'Odeslat zadost',
  holidayNotAllowed: 'Rezervace ve státní svátky není možná',
  startTour: 'Spustit průvodce',
  tourStatsTitle: 'Zůstatek dovolené',
  tourStatsText: 'Celkový počet dní, již vyčerpané dny a zbývající dovolená na tento rok.',
  tourRequestTitle: 'Požádat o dovolenou',
  tourRequestText: 'Zvolte datum začátku a konce – pracovní dny se počítají automaticky. Odešlete s volitelnou poznámkou.',
  tourMyTitle: 'Moje žádosti',
  tourMyText: 'Všechny vaše žádosti o dovolenou se stavem (čeká, schválena, zamítnuta). Čekající žádosti lze zrušit. V případě nemoci v den schválené dovolené ji lze vrátit s lékařským potvrzením.',
  tourTeamTitle: 'Žádosti týmu',
  tourTeamText: 'Jako manažer vidíte všechny žádosti o dovolenou svého týmu a můžete je přímo schválit nebo zamítnout.',
  myRequests: 'Moje zadosti',
  allRequestsTeam: 'Vsechny zadosti (tym)',
  noRequests: 'Zadne zadosti',
  withdrawRequest: 'Stahnout zadost',
  actions: 'Akce',
  approve: 'Schvalit',
  reject: 'Odmitnout',
  periodRequired: 'Rozsah dat je povinny',
  requestSubmitted: 'Zadost o dovolenou odeslana',
  submitError: 'Odeslani zadosti selhalo',
  withdrawConfirm: 'Stahnout zadost?',
  withdrawn: 'Stazeno',
  approved: 'Schvaleno',
  rejected: 'Odmitnuto',
  sickRebookBtn: 'Nemoc behem dovolene',
  sickRebookTitle: 'Vratit dny dovolene',
  sickRebookDesc: 'Zadejte obdobi nemoci, ktere se prekryvalo s dovolenou. Prekryvajici se pracovni dny vam budou pripocteny.',
  sickRebookNote: 'Poznamka (volitelne)',
  sickRebookCancel: 'Zrusit',
  sickRebookError: 'Vraceni dni selhalo',
  sickRebookAlready: 'Nemoc hlasena',
  sickRebookDay: 'den vracen',
  sickRebookDays: 'dny vraceny',
  sickRebookRejectedRangeError: 'Toto obdobi uz bylo zamitnuto. Vyberte jine dny dovolene.',
  sickRebookSubmit: 'Pozadat o vraceni',
  sickRebookRequested: 'Zadost o vraceni odeslana',
  sickRebookPending: 'Vraceni pozadano',
  sickRebookApprove: 'Schvalit vraceni',
  sickRebookReject: 'Zamitnout vraceni',
  sickRebookApproved: 'Vraceni schvaleno',
  sickRebookRejected: 'Vraceni zamitnuto',
  sickRebookReviewError: 'Rozhodnuti selhalo'
};

const sickDe = {
  title: 'Krankmeldungen',
  infoText: 'Hier kannst du Krankmeldungen einreichen und verwalten.',
  infoItem1: 'Du kannst deine Krankmeldungen einsehen und neue Krankmeldungen einreichen.',
  infoItem2: 'Wenn du krank wirst, kannst du eine Krankmeldung einreichen und stattdessen Urlaubstage zurückbuchen, wenn die Krankmeldung mit einem bereits genehmigten Urlaubszeitraum überlappt.',
  infoItem3: 'Krankmeldungen können nur zurückgezogen werden, solange sie noch nicht bestätigt wurden.',
  infoItem4: 'Wenn du während deines Urlaubs krank wirst, kannst du eine Rückbuchung der betroffenen Tage beantragen.',
  infoItem5: 'In der Teamansicht kannst du alle Krankmeldungen deines Teams einsehen und verwalten (nur für Teamleiter).',
  infoItem6: 'Du kannst festlegen, ab wie vielen Kranktagen ein ärztliches Attest erforderlich ist. Alle Krankmeldungen, die diesen Zeitraum überschreiten, müssen mit einem Attest eingereicht werden (nur für Teamleiter).',
  subtitle: 'Krankmeldung einreichen und verwalten',
  teamOverview: 'Übersicht Team',
  noneInYear: 'Keine Krankmeldungen in',
  incidents: 'Vorfälle',
  sickDays: 'Kranktage',
  open: 'offen',
  allConfirmed: 'alle bestätigt',
  filtered: 'Gefiltert',
  clearFilter: 'Filter aufheben',
  certificateRequiredFrom: 'Attest erforderlich ab',
  sickDay: 'Kranktag',
  sickDaysDative: 'Kranktagen',
  submitSickLeave: 'Krankmeldung einreichen',
  startTour: 'Führung starten',
  tourTeamTitle: 'Team-Übersicht',
  tourTeamText: 'Als Manager siehst du hier alle Krankmeldungen deines Teams – Anzahl der Vorfälle, Krankheitstage und ob Atteste noch fehlen.',
  tourAttestTitle: 'Attest-Schwelle',
  tourAttestText: 'Hier legst du ab wie vielen Krankheitstagen ein Attest erforderlich ist. Mitarbeiter werden darüber informiert.',
  tourFormTitle: 'Krankmeldung einreichen',
  tourFormText: 'Zeitraum eingeben und Meldung absenden. Im Offline-Modus wird sie gespeichert und automatisch synchronisiert.',
  tourListTitle: 'Meine Krankmeldungen',
  tourListText: 'Alle Einträge auf einen Blick. Falls ein Attest erforderlich ist, wird es hier angezeigt.',
  optional: 'Optional...',
  workday: 'Werktag',
  workdays: 'Werktage',
  certificateRequired: 'Attest erforderlich',
  allSickLeaves: 'Alle Krankmeldungen',
  mySickLeaves: 'Meine Krankmeldungen',
  certificate: 'Attest',
  acknowledge: 'Zur Kenntnis',
  acknowledged: 'Zur Kenntnis genommen',
  confirmed: 'Bestätigt',
  periodRequired: 'Zeitraum erforderlich',
  endBeforeStart: 'Enddatum vor Startdatum',
  submitted: 'Krankmeldung eingereicht',
  ackError: 'Fehler beim Bestätigen',
  deleteConfirm: 'Krankmeldung löschen?',
  deleted: 'Gelöscht'
};

const sickEn = {
  title: 'Sick leave',
  infoText: 'Here you can submit and manage sick leaves.',
  infoItem1: 'You can view your sick leaves and submit new ones.',
  infoItem2: 'If you become ill, you can submit a sick leave and book back the affected days if the sick leave overlaps with an already approved leave period.',
  infoItem3: 'Sick leaves can only be withdrawn while they are not yet confirmed.',
  infoItem4: 'If you become ill during your leave, you can request a backbooking of the affected days.',
  infoItem5: 'In the team view, you can see all sick leaves of your team (only for team leaders).',
  infoItem6: 'You can specify from how many sick days a medical certificate is required. All sick leaves that exceed this period must be submitted with a certificate (only for team leaders).',
  teamOverview: 'Team overview',
  noneInYear: 'No sick leaves in',
  incidents: 'Incidents',
  sickDays: 'Sick days',
  open: 'open',
  allConfirmed: 'all confirmed',
  filtered: 'Filtered',
  clearFilter: 'Clear filter',
  certificateRequiredFrom: 'Certificate required from',
  sickDay: 'sick day',
  sickDaysDative: 'sick days',
  submitSickLeave: 'Submit sick leave',
  startTour: 'Start tour',
  tourTeamTitle: 'Team overview',
  tourTeamText: 'As a manager you see all sick leaves of your team – number of incidents, sick days, and whether certificates are still missing.',
  tourAttestTitle: 'Certificate threshold',
  tourAttestText: 'Set from how many sick days a medical certificate is required. Employees are informed about this.',
  tourFormTitle: 'Submit sick leave',
  tourFormText: 'Enter the period and submit. In offline mode it is saved and synced automatically.',
  tourListTitle: 'My sick leaves',
  tourListText: 'All entries at a glance. If a certificate is required, it is shown here.',
  optional: 'Optional...',
  workday: 'workday',
  workdays: 'workdays',
  certificateRequired: 'Certificate required',
  allSickLeaves: 'All sick leaves',
  mySickLeaves: 'My sick leaves',
  certificate: 'Certificate',
  acknowledge: 'Acknowledge',
  acknowledged: 'Acknowledged',
  confirmed: 'Confirmed',
  periodRequired: 'Date range required',
  endBeforeStart: 'End date before start date',
  submitted: 'Sick leave submitted',
  ackError: 'Acknowledge failed',
  deleteConfirm: 'Delete sick leave?',
  deleted: 'Deleted'
};

const sickFr = {
  title: 'Arrets maladie',
  infoText: 'Ici, vous pouvez soumettre et gérer les congés maladie.',
  infoItem1: 'Vous pouvez visualiser vos congés maladie et en soumettre de nouveaux.',
  infoItem2: 'Si vous tombez malade, vous pouvez soumettre un congé maladie et reporter les jours affectés si le congé maladie chevauche une période de congé déjà approuvée.',
  infoItem3: 'Les congés maladie ne peuvent être retirés que s\'ils ne sont pas encore confirmés.',
  infoItem4: 'Si vous tombez malade pendant vos congés, vous pouvez demander un report des jours affectés.',
  infoItem5: 'Dans la vue équipe, vous pouvez voir tous les congés maladie de votre équipe (uniquement pour les responsables d\'équipe).',
  infoItem6: 'Vous pouvez spécifier à partir de combien de jours de maladie un certificat médical est requis. Tous les congés maladie dépassant cette période doivent être soumis avec un certificat (uniquement pour les responsables d\'équipe).',
  teamOverview: 'Apercu equipe',
  noneInYear: 'Aucun arret maladie en',
  incidents: 'Incidents',
  sickDays: 'Jours maladie',
  open: 'ouvert',
  allConfirmed: 'tout confirme',
  filtered: 'Filtre',
  clearFilter: 'Effacer filtre',
  certificateRequiredFrom: 'Certificat requis a partir de',
  sickDay: 'jour maladie',
  sickDaysDative: 'jours maladie',
  submitSickLeave: 'Soumettre arret maladie',
  startTour: 'Lancer la visite guidée',
  tourTeamTitle: 'Vue d\'ensemble équipe',
  tourTeamText: 'En tant que manager vous voyez tous les arrêts maladie de votre équipe – nombre d\'incidents, jours et certificats manquants.',
  tourAttestTitle: 'Seuil de certificat',
  tourAttestText: 'Définissez à partir de combien de jours un certificat médical est requis. Les employés en sont informés.',
  tourFormTitle: 'Déclarer un arrêt maladie',
  tourFormText: 'Saisissez la période et envoyez. En mode hors ligne la déclaration est sauvegardée et synchronisée automatiquement.',
  tourListTitle: 'Mes arrêts maladie',
  tourListText: 'Tous les entrées en un coup d\'œil. Si un certificat est requis, il est indiqué ici.',
  optional: 'Optionnel...',
  workday: 'jour ouvrable',
  workdays: 'jours ouvrables',
  certificateRequired: 'Certificat requis',
  allSickLeaves: 'Tous les arrets maladie',
  mySickLeaves: 'Mes arrets maladie',
  certificate: 'Certificat',
  acknowledge: 'Prendre connaissance',
  acknowledged: 'Pris en compte',
  confirmed: 'Confirme',
  periodRequired: 'Periode requise',
  endBeforeStart: 'Date de fin avant date de debut',
  submitted: 'Arret maladie soumis',
  ackError: 'Echec de confirmation',
  deleteConfirm: 'Supprimer arret maladie ?',
  deleted: 'Supprime'
};

const sickIt = {
  title: 'Malattia',
  infoText: 'Qui puoi inviare e gestire le malattie.',
  infoItem1: 'Puoi visualizzare le tue malattie e inviarne di nuove.',
  infoItem2: 'Se ti ammali, puoi inviare una malattia e recuperare i giorni interessati se la malattia coincide con un periodo di ferie già approvato.',
  infoItem3: 'Le malattie possono essere ritirate solo se non sono ancora confermate.',
  infoItem4: 'Se ti ammali durante le ferie, puoi richiedere un recupero dei giorni interessati.',
  infoItem5: 'Nella vista del team, puoi vedere tutte le malattie del tuo team (solo per i capi squadra).',
  infoItem6: 'Puoi specificare da quanti giorni di malattia è richiesto un certificato medico. Tutte le malattie che superano questo periodo devono essere inviate con un certificato (solo per i capi squadra).',
  teamOverview: 'Panoramica team',
  noneInYear: 'Nessuna malattia in',
  incidents: 'Casi',
  sickDays: 'Giorni malattia',
  open: 'aperto',
  allConfirmed: 'tutto confermato',
  filtered: 'Filtrato',
  clearFilter: 'Rimuovi filtro',
  certificateRequiredFrom: 'Certificato richiesto da',
  sickDay: 'giorno malattia',
  sickDaysDative: 'giorni malattia',
  submitSickLeave: 'Invia malattia',
  startTour: 'Avvia la guida',
  tourTeamTitle: 'Panoramica team',
  tourTeamText: 'Come manager vedi tutti i congedi per malattia del tuo team – numero di episodi, giorni e certificati mancanti.',
  tourAttestTitle: 'Soglia certificato',
  tourAttestText: 'Imposta da quanti giorni è richiesto un certificato medico. I dipendenti vengono informati.',
  tourFormTitle: 'Dichiarare malattia',
  tourFormText: 'Inserisci il periodo e invia. In modalità offline viene salvato e sincronizzato automaticamente.',
  tourListTitle: 'I miei congedi',
  tourListText: 'Tutte le voci in sintesi. Se è richiesto un certificato, viene mostrato qui.',
  optional: 'Opzionale...',
  workday: 'giorno lavorativo',
  workdays: 'giorni lavorativi',
  certificateRequired: 'Certificato richiesto',
  allSickLeaves: 'Tutte le malattie',
  mySickLeaves: 'Le mie malattie',
  certificate: 'Certificato',
  acknowledge: 'Prendi visione',
  acknowledged: 'Presa visione',
  confirmed: 'Confermato',
  periodRequired: 'Intervallo date richiesto',
  endBeforeStart: 'Data fine prima di data inizio',
  submitted: 'Malattia inviata',
  ackError: 'Conferma non riuscita',
  deleteConfirm: 'Eliminare malattia?',
  deleted: 'Eliminata'
};

const sickPl = {
  title: 'Zwolnienia chorobowe',
  infoText: 'Tutaj możesz przesyłać i zarządzać zezwoleniami na chorobę.',
  infoItem1: 'Możesz przeglądać swoje zezwolenia na chorobę i przesyłać nowe.',
  infoItem2: 'Jeśli zachorujesz, możesz przesłać zezwolenie na chorobę i odzyskać dni, które zostały dotknięte, jeśli zezwolenie na chorobę pokrywa okres urlopu już zatwierdzony.',
  infoItem3: 'Zezwolenia na chorobę mogą być wycoływane tylko wtedy, gdy nie zostały jeszcze potwierdzone.',
  infoItem4: 'Jeśli zachorujesz podczas urlopu, możesz zażądać odrocenia dni, które zostały dotknięte.',
  infoItem5: 'W widoku zespołu możesz zobaczyć wszystkie zezwolenia na chorobę swojego zespołu (tylko dla kierowników zespołów).',
  infoItem6: 'Możesz określić, od ilu dni choroby jest wymagany certyfikat medyczny. Wszystkie zezwolenia na chorobę przekraczające ten okres muszą być przesłane z certyfikatem (tylko dla kierowników zespołów).',
  teamOverview: 'Przeglad zespolu',
  noneInYear: 'Brak zwolnien chorobowych w',
  incidents: 'Przypadki',
  sickDays: 'Dni chorobowe',
  open: 'otwarte',
  allConfirmed: 'wszystkie potwierdzone',
  filtered: 'Przefiltrowane',
  clearFilter: 'Wyczysc filtr',
  certificateRequiredFrom: 'Zaswiadczenie wymagane od',
  sickDay: 'dzien chorobowy',
  sickDaysDative: 'dniach chorobowych',
  submitSickLeave: 'Zglos chorobowe',
  startTour: 'Uruchom przewodnik',
  tourTeamTitle: 'Przegląd zespołu',
  tourTeamText: 'Jako manager widzisz wszystkie zwolnienia lekarskie swojego zespołu – incydenty, dni chorobowe i brakujące zaświadczenia.',
  tourAttestTitle: 'Próg zaświadczenia',
  tourAttestText: 'Ustaw od ilu dni wymagane jest zaświadczenie lekarskie. Pracownicy są o tym informowani.',
  tourFormTitle: 'Zgłoś zwolnienie',
  tourFormText: 'Wprowadź okres i wyślij. W trybie offline jest zapisywane i synchronizowane automatycznie.',
  tourListTitle: 'Moje zwolnienia',
  tourListText: 'Wszystkie wpisy na pierwszy rzut oka. Jeśli wymagane jest zaświadczenie, jest to pokazane tutaj.',
  optional: 'Opcjonalnie...',
  workday: 'dzien roboczy',
  workdays: 'dni robocze',
  certificateRequired: 'Zaswiadczenie wymagane',
  allSickLeaves: 'Wszystkie zwolnienia chorobowe',
  mySickLeaves: 'Moje zwolnienia chorobowe',
  certificate: 'Zaswiadczenie',
  acknowledge: 'Potwierdz odbior',
  acknowledged: 'Potwierdzono odbior',
  confirmed: 'Potwierdzone',
  periodRequired: 'Wymagany zakres dat',
  endBeforeStart: 'Data zakonczenia przed data rozpoczecia',
  submitted: 'Zwolnienie chorobowe zgloszone',
  ackError: 'Blad potwierdzenia',
  deleteConfirm: 'Usunac zwolnienie chorobowe?',
  deleted: 'Usunieto'
};

const sickCs = {
  title: 'Nemocenska',
  infoText: 'Zde muzete zadat a spravovat nemocenske.',
  infoItem1: 'Muzete zobrazit sve nemocenske a zadat nove.',
  infoItem2: 'Kdyz onemocnite, muzete zadat nemocenskou a zpetne si vratit postizene dny, pokud se nemocenska prekryva s jiz schvalenou dovolenkou.',
  infoItem3: 'Nemocenske lze stahnout pouze pokud jeste nebyly potvrzeny.',
  infoItem4: 'Kdyz onemocnite behem dovolene, muzete pozadat o zpetne vrateni postizenych dnu.',
  infoItem5: 'V prehledu tymu muzete videt vsechny nemocenske sveho tymu (pouze pro vedouci tymu).',
  infoItem6: 'Muzete specifikovat, od kolika dni nemoci je pozadovano lekarske potvrzeni. Vsechny nemocenske, ktere tento period prekroci, musi byt zadany s potvrzenim (pouze pro vedouci tymu).',
  teamOverview: 'Prehled tymu',
  noneInYear: 'Zadna nemocenska v',
  incidents: 'Pripady',
  sickDays: 'Dny nemoci',
  open: 'otevrene',
  allConfirmed: 'vse potvrzeno',
  filtered: 'Filtrovano',
  clearFilter: 'Zrusit filtr',
  certificateRequiredFrom: 'Potvrzeni povinne od',
  sickDay: 'den nemoci',
  sickDaysDative: 'dnech nemoci',
  submitSickLeave: 'Odeslat nemocenskou',
  startTour: 'Spustit průvodce',
  tourTeamTitle: 'Přehled týmu',
  tourTeamText: 'Jako manažer vidíte všechny nemocenské svého týmu – počet incidentů, dny a chybějící potvrzení.',
  tourAttestTitle: 'Práh potvrzení',
  tourAttestText: 'Nastavte od kolika dnů je vyžadováno lékařské potvrzení. Zaměstnanci jsou o tom informováni.',
  tourFormTitle: 'Nahlásit nemoc',
  tourFormText: 'Zadejte období a odešlete. V offline režimu je uloženo a automaticky synchronizováno.',
  tourListTitle: 'Moje nemocenské',
  tourListText: 'Všechny záznamy na první pohled. Pokud je vyžadováno potvrzení, je zde zobrazeno.',
  optional: 'Volitelne...',
  workday: 'pracovni den',
  workdays: 'pracovni dny',
  certificateRequired: 'Potvrzeni vyzadovano',
  allSickLeaves: 'Vsechny nemocenske',
  mySickLeaves: 'Moje nemocenske',
  certificate: 'Potvrzeni',
  acknowledge: 'Vzato na vedomi',
  acknowledged: 'Vzato na vedomi',
  confirmed: 'Potvrzeno',
  periodRequired: 'Rozsah dat je povinny',
  endBeforeStart: 'Datum konce pred datem zacatku',
  submitted: 'Nemocenska odeslana',
  ackError: 'Potvrzeni selhalo',
  deleteConfirm: 'Smazat nemocenskou?',
  deleted: 'Smazano'
};

const payrollDe = {
  title: 'Lohnverarbeitung',
  infoText: 'Hier kannst du die Gehaltsabrechnungen deiner Mitarbeiter verwalten.',
  infoItem1: 'Du kannst die Arbeitszeiten, Urlaubstage, Kranktage und andere relevante Informationen deiner Mitarbeiter einsehen und verwalten.',
  infoItem2: 'Du kannst die Gehaltsabrechnungen für einen bestimmten Monat erstellen und exportieren, um sie in deinem Lohnabrechnungsprogramm zu verwenden.',
  infoItem3: 'Die Gehaltsabrechnungen enthalten detaillierte Informationen über die Arbeitszeiten, Überstunden, Urlaubstage, Kranktage und andere relevante Informationen deiner Mitarbeiter.',
  infoItem4: 'Du kannst die Gehaltsabrechnungen im CSV- oder DATEV-Format exportieren.',
  workdays: 'Werktage',
  startTour: 'Führung starten',
  tourNavTitle: 'Monatsauswahl',
  tourNavText: 'Navigiere mit den Pfeilen durch die Monate. Die Abrechnung wird jeweils monatlich erstellt.',
  tourHolidaysTitle: 'Feiertage',
  tourHolidaysText: 'Feiertage des gewählten Monats – automatisch anhand des Bundeslands aus den Einstellungen ermittelt.',
  tourKpisTitle: 'Monatskennzahlen',
  tourKpisText: 'Übersicht aller Mitarbeiter: geleistete Stunden, Überstunden, Urlaubs- und Krankheitstage, KUG-Stunden und Bruttolohnsumme.',
  tourTableTitle: 'Mitarbeitertabelle',
  tourTableText: 'Detailzeile pro Mitarbeiter – Soll/Ist-Stunden, Urlaub, Krankheit, KUG und Bruttogehalt. Per Klick auf eine Zeile lassen sich Korrekturen manuell erfassen.',
  tourEditModalTitle: 'Manuelle Korrektur',
  tourEditModalText: 'Hier kannst du KUG-Stunden, Feiertage, Extrastunden und eine Notiz für diesen Mitarbeiter manuell erfassen oder korrigieren.',
  tourExportModalTitle: 'Export-Dialog',
  tourExportModalText: 'Wähle welche Mitarbeiter exportiert werden sollen – alle oder nur bestimmte. Vorlagen lassen sich speichern um dieselbe Auswahl monatlich wiederzuverwenden.',
  tourExportTitle: 'Export',
  tourExportText: 'CSV für eigene Analysen oder direkt als DATEV-Format für die Lohnbuchhaltung exportieren.',
  holiday: 'Feiertag',
  holidays: 'Feiertage',
  csvExport: 'CSV',
  datevExport: 'DATEV LODAS',
  holidaysLabel: 'Feiertage',
  employees: 'Mitarbeiter',
  actualHours: 'Ist-Stunden',
  overtime: 'Überstunden',
  vacationDays: 'Urlaubstage',
  sickDays: 'Kranktage',
  kugHours: 'KUG-Stunden',
  grossTotal: 'Brutto gesamt',
  personnelNo: 'Pers.-Nr.',
  targetHoursShort: 'Soll-h',
  actualHoursShort: 'Ist-h',
  overtimeShort: 'Überstd.',
  vacationShort: 'Urlaub',
  sickShort: 'Krank',
  holidaysShort: 'Feiertage',
  kugShort: 'KUG-h',
  compensation: 'Vergütung',
  gross: 'Brutto',
  auto: 'auto',
  suggestion: 'Vorschlag',
  salary: 'Gehalt',
  wage: 'Lohn',
  month: 'Monat',
  targetHours: 'Soll-Stunden',
  seasonalKugHours: 'Saison-KUG (Stunden)',
  suggestionBasedOnMissing: 'Vorschlag basierend auf Fehlstunden',
  applySuggestion: 'Vorschlag übernehmen',
  holidaysDays: 'Feiertage (Tage)',
  automatic: 'Automatisch',
  extraHours: 'Extra-Stunden',
  extraHoursHint: 'Werden zur Ist-Zeit addiert',
  costCenter: 'Kostenstelle',
  compensationType: 'Vergütungsart',
  hourlyRate: 'Stundenlohn',
  monthlySalary: 'Monatsgehalt',
  grossWage: 'Brutto-Lohn',
  brtvMode: 'BRTV Bau aktiv ({hours} h/Woche)'
};

const payrollEn = {
  title: 'Payroll processing',
  infoText: 'Here you can manage the payroll of your employees.',
  infoItem1: 'You can view and manage the working hours, vacation days, sick days and other relevant information of your employees.',
  infoItem2: 'You can create and export payroll statements for a specific month to use in your payroll software.',
  infoItem3: 'The payroll statements contain detailed information about the working hours, overtime, vacation days, sick days and other relevant information of your employees.',
  infoItem4: 'You can export the payroll statements in CSV or DATEV format.',
  workdays: 'workdays',
  startTour: 'Start tour',
  tourNavTitle: 'Month selection',
  tourNavText: 'Navigate through months using the arrows. Payroll is generated on a monthly basis.',
  tourHolidaysTitle: 'Public holidays',
  tourHolidaysText: 'Holidays for the selected month – determined automatically based on the federal state in settings.',
  tourKpisTitle: 'Monthly KPIs',
  tourKpisText: 'Overview of all employees: hours worked, overtime, vacation and sick days, short-time work hours and gross payroll total.',
  tourTableTitle: 'Employee table',
  tourTableText: 'Detail row per employee – target/actual hours, vacation, sick leave, short-time work and gross salary. Click a row to enter manual corrections.',
  tourEditModalTitle: 'Manual correction',
  tourEditModalText: 'Here you can manually enter or correct short-time work hours, public holidays, extra hours, and a note for this employee.',
  tourExportModalTitle: 'Export dialog',
  tourExportModalText: 'Choose which employees to export – all or only specific ones. Templates can be saved to reuse the same selection every month.',
  tourExportTitle: 'Export',
  tourExportText: 'Export as CSV for your own analysis or directly in DATEV format for payroll accounting.',
  holiday: 'holiday',
  holidays: 'holidays',
  csvExport: 'CSV',
  datevExport: 'DATEV LODAS',
  holidaysLabel: 'Holidays',
  employees: 'Employees',
  actualHours: 'Actual hours',
  overtime: 'Overtime',
  vacationDays: 'Vacation days',
  sickDays: 'Sick days',
  kugHours: 'KUG hours',
  grossTotal: 'Gross total',
  personnelNo: 'Personnel no.',
  targetHoursShort: 'Target-h',
  actualHoursShort: 'Actual-h',
  overtimeShort: 'Overtime',
  vacationShort: 'Vacation',
  sickShort: 'Sick',
  holidaysShort: 'Holidays',
  kugShort: 'KUG-h',
  compensation: 'Compensation',
  gross: 'Gross',
  auto: 'auto',
  suggestion: 'Suggestion',
  salary: 'Salary',
  wage: 'Wage',
  month: 'Month',
  targetHours: 'Target hours',
  seasonalKugHours: 'Seasonal KUG (hours)',
  suggestionBasedOnMissing: 'Suggestion based on missing hours',
  applySuggestion: 'Apply suggestion',
  holidaysDays: 'Holidays (days)',
  automatic: 'Automatic',
  extraHours: 'Extra hours',
  extraHoursHint: 'Added to actual hours',
  costCenter: 'Cost center',
  compensationType: 'Compensation type',
  hourlyRate: 'Hourly rate',
  monthlySalary: 'Monthly salary',
  grossWage: 'Gross wage',
  brtvMode: 'BRTV Construction active ({hours} h/week)'
};

const payrollFr = {
  title: 'Traitement de paie',
  infoText: 'Ici, vous pouvez gérer la paie de vos employés.',
  infoItem1: 'Vous pouvez visualiser et gérer les heures de travail, les jours de congé, les jours de maladie et autres informations pertinentes de vos employés.',
  infoItem2: 'Vous pouvez créer et exporter des relevés de paie pour un mois spécifique à utiliser dans votre logiciel de paie.',
  infoItem3: 'Les relevés de paie contiennent des informations détaillées sur les heures de travail, les heures supplémentaires, les jours de congé, les jours de maladie et autres informations pertinentes de vos employés.',
  infoItem4: 'Vous pouvez exporter les relevés de paie au format CSV ou DATEV.',
  workdays: 'jours ouvrables',
  holiday: 'jour ferie',
  holidays: 'jours feries',
  csvExport: 'CSV',
  datevExport: 'DATEV LODAS',
  holidaysLabel: 'Jours feries',
  employees: 'Employes',
  actualHours: 'Heures reelles',
  overtime: 'Heures supplementaires',
  vacationDays: 'Jours de conges',
  sickDays: 'Jours maladie',
  kugHours: 'Heures KUG',
  grossTotal: 'Brut total',
  personnelNo: 'No personnel',
  targetHoursShort: 'Cible-h',
  actualHoursShort: 'Reel-h',
  overtimeShort: 'Supp.',
  vacationShort: 'Conges',
  sickShort: 'Maladie',
  holidaysShort: 'Feries',
  kugShort: 'KUG-h',
  compensation: 'Remuneration',
  gross: 'Brut',
  auto: 'auto',
  suggestion: 'Suggestion',
  salary: 'Salaire',
  wage: 'Salaire horaire',
  month: 'Mois',
  targetHours: 'Heures cibles',
  seasonalKugHours: 'KUG saisonnier (heures)',
  suggestionBasedOnMissing: 'Suggestion basee sur heures manquantes',
  applySuggestion: 'Appliquer suggestion',
  holidaysDays: 'Jours feries (jours)',
  automatic: 'Automatique',
  extraHours: 'Heures supplementaires',
  extraHoursHint: 'Ajoutees aux heures reelles',
  costCenter: 'Centre de couts',
  compensationType: 'Type de remuneration',
  hourlyRate: 'Taux horaire',
  monthlySalary: 'Salaire mensuel',
  grossWage: 'Salaire brut',
  brtvMode: 'BRTV BTP actif ({hours} h/semaine)',
  startTour: 'Lancer la visite guidée',
  tourNavTitle: 'Sélection du mois',
  tourNavText: 'Naviguez entre les mois avec les flèches. La paie est générée mensuellement.',
  tourHolidaysTitle: 'Jours fériés',
  tourHolidaysText: 'Jours fériés du mois sélectionné – déterminés automatiquement selon l\'état fédéral dans les paramètres.',
  tourKpisTitle: 'Indicateurs mensuels',
  tourKpisText: 'Vue d\'ensemble: heures travaillées, heures supplémentaires, congés, jours de maladie, heures KUG et masse salariale brute.',
  tourTableTitle: 'Tableau employés',
  tourTableText: 'Ligne de détail par employé – heures théoriques/réelles, congés, maladie, KUG et salaire brut. Cliquez sur une ligne pour des corrections manuelles.',
  tourEditModalTitle: 'Correction manuelle',
  tourEditModalText: 'Ici vous pouvez saisir ou corriger les heures de chômage partiel, jours fériés, heures supplémentaires et une note pour cet employé.',
  tourExportModalTitle: 'Dialogue d\'export',
  tourExportModalText: 'Choisissez quels employés exporter – tous ou seulement certains. Des modèles peuvent être sauvegardés pour réutiliser la même sélection chaque mois.',
  tourExportTitle: 'Export',
  tourExportText: 'Exportez en CSV pour vos analyses ou directement au format DATEV pour la comptabilité salariale.',
};

const payrollIt = {
  title: 'Elaborazione paghe',
  infoText: 'Qui puoi gestire le paghe dei tuoi dipendenti.',
  infoItem1: 'Puoi visualizzare e gestire le ore lavorate, i giorni di ferie, i giorni di malattia e altre informazioni rilevanti dei tuoi dipendenti.',
  infoItem2: 'Puoi creare ed esportare le buste paga per un mese specifico da utilizzare nel tuo software di elaborazione paghe.',
  infoItem3: 'Le buste paga contengono informazioni dettagliate sulle ore lavorate, le ore straordinarie, i giorni di ferie, i giorni di malattia e altre informazioni rilevanti dei tuoi dipendenti.',
  infoItem4: 'Puoi esportare le buste paga in formato CSV o DATEV.',
  workdays: 'giorni lavorativi',
  holiday: 'festivo',
  holidays: 'festivi',
  csvExport: 'CSV',
  datevExport: 'DATEV LODAS',
  holidaysLabel: 'Festivita',
  employees: 'Dipendenti',
  actualHours: 'Ore effettive',
  overtime: 'Straordinari',
  vacationDays: 'Giorni ferie',
  sickDays: 'Giorni malattia',
  kugHours: 'Ore KUG',
  grossTotal: 'Lordo totale',
  personnelNo: 'Nr personale',
  targetHoursShort: 'Target-h',
  actualHoursShort: 'Effettive-h',
  overtimeShort: 'Straord.',
  vacationShort: 'Ferie',
  sickShort: 'Mal.',
  holidaysShort: 'Festivi',
  kugShort: 'KUG-h',
  compensation: 'Compenso',
  gross: 'Lordo',
  auto: 'auto',
  suggestion: 'Suggerimento',
  salary: 'Stipendio',
  wage: 'Paga',
  month: 'Mese',
  targetHours: 'Ore target',
  seasonalKugHours: 'KUG stagionale (ore)',
  suggestionBasedOnMissing: 'Suggerimento basato su ore mancanti',
  applySuggestion: 'Applica suggerimento',
  holidaysDays: 'Festivita (giorni)',
  automatic: 'Automatico',
  extraHours: 'Ore extra',
  extraHoursHint: 'Aggiunte alle ore effettive',
  costCenter: 'Centro di costo',
  compensationType: 'Tipo di compenso',
  hourlyRate: 'Tariffa oraria',
  monthlySalary: 'Stipendio mensile',
  grossWage: 'Paga lorda',
  brtvMode: 'BRTV Edilizia attivo ({hours} h/settimana)',
  startTour: 'Avvia la guida',
  tourNavTitle: 'Selezione mese',
  tourNavText: 'Naviga tra i mesi con le frecce. La busta paga viene generata mensilmente.',
  tourHolidaysTitle: 'Festività',
  tourHolidaysText: 'Festività del mese selezionato – determinate automaticamente in base allo stato federale nelle impostazioni.',
  tourKpisTitle: 'KPI mensili',
  tourKpisText: 'Panoramica: ore lavorate, straordinari, ferie, giorni malattia, ore KUG e totale lordo.',
  tourTableTitle: 'Tabella dipendenti',
  tourTableText: 'Riga di dettaglio per dipendente – ore teoriche/reali, ferie, malattia, KUG e stipendio lordo. Clic su una riga per correzioni manuali.',
  tourEditModalTitle: 'Correzione manuale',
  tourEditModalText: 'Qui puoi inserire o correggere ore di cassa integrazione, festività, ore extra e una nota per questo dipendente.',
  tourExportModalTitle: 'Dialogo esportazione',
  tourExportModalText: 'Scegli quali dipendenti esportare – tutti o solo alcuni. I modelli possono essere salvati per riutilizzare la stessa selezione ogni mese.',
  tourExportTitle: 'Esportazione',
  tourExportText: 'Esporta in CSV per analisi proprie o direttamente in formato DATEV per la contabilità salariale.',
};

const payrollPl = {
  title: 'Przetwarzanie plac',
  infoText: 'Tutaj możesz zarządzać płacami swoich pracowników.',
  infoItem1: 'Możesz przeglądać i zarządzać godzinami pracy, dniami urlopowymi, dniami chorobowymi i innymi istotnymi informacjami swoich pracowników.',
  infoItem2: 'Możesz tworzyć i eksportować paski płac dla konkretnego miesiąca, aby użyć ich w swoim oprogramowaniu płacowym.',
  infoItem3: 'Paski płac zawierają szczegółowe informacje o godzinach pracy, nadgodzinach, dniach urlopowych, dniach chorobowych i innych istotnych informacjach swoich pracowników.',
  infoItem4: 'Możesz eksportować paski płac w formacie CSV lub DATEV.',
  workdays: 'dni robocze',
  holiday: 'swieto',
  holidays: 'swieta',
  csvExport: 'CSV',
  datevExport: 'DATEV LODAS',
  holidaysLabel: 'Swieta',
  employees: 'Pracownicy',
  actualHours: 'Godziny rzeczywiste',
  overtime: 'Nadgodziny',
  vacationDays: 'Dni urlopu',
  sickDays: 'Dni chorobowe',
  kugHours: 'Godziny KUG',
  grossTotal: 'Lacznie brutto',
  personnelNo: 'Nr personalny',
  targetHoursShort: 'Plan-h',
  actualHoursShort: 'Rzecz-h',
  overtimeShort: 'Nadg.',
  vacationShort: 'Urlop',
  sickShort: 'Chor.',
  holidaysShort: 'Swieta',
  kugShort: 'KUG-h',
  compensation: 'Wynagrodzenie',
  gross: 'Brutto',
  auto: 'auto',
  suggestion: 'Sugestia',
  salary: 'Pensja',
  wage: 'Stawka',
  month: 'Miesiac',
  targetHours: 'Godziny planowane',
  seasonalKugHours: 'Sezonowy KUG (godziny)',
  suggestionBasedOnMissing: 'Sugestia na podstawie brakujacych godzin',
  applySuggestion: 'Zastosuj sugestie',
  holidaysDays: 'Swieta (dni)',
  automatic: 'Automatycznie',
  extraHours: 'Godziny dodatkowe',
  extraHoursHint: 'Dodawane do czasu rzeczywistego',
  costCenter: 'Centrum kosztow',
  compensationType: 'Rodzaj wynagrodzenia',
  hourlyRate: 'Stawka godzinowa',
  monthlySalary: 'Pensja miesieczna',
  grossWage: 'Wynagrodzenie brutto',
  brtvMode: 'BRTV Budownictwo aktywne ({hours} h/tydzien)',
  startTour: 'Uruchom przewodnik',
  tourNavTitle: 'Wybór miesiąca',
  tourNavText: 'Nawiguj między miesiącami strzałkami. Lista płac jest generowana miesięcznie.',
  tourHolidaysTitle: 'Święta',
  tourHolidaysText: 'Święta wybranego miesiąca – wyznaczane automatycznie na podstawie landu w ustawieniach.',
  tourKpisTitle: 'Wskaźniki miesięczne',
  tourKpisText: 'Przegląd: przepracowane godziny, nadgodziny, urlopy, dni chorobowe, godziny KUG i suma brutto.',
  tourTableTitle: 'Tabela pracowników',
  tourTableText: 'Wiersz szczegółów na pracownika – godziny planowane/rzeczywiste, urlop, choroba, KUG i wynagrodzenie brutto. Kliknij wiersz aby wprowadzić korekty.',
  tourEditModalTitle: 'Ręczna korekta',
  tourEditModalText: 'Tu możesz ręcznie wprowadzić lub poprawić godziny KUG, święta, dodatkowe godziny i notatkę dla tego pracownika.',
  tourExportModalTitle: 'Dialog eksportu',
  tourExportModalText: 'Wybierz których pracowników eksportować – wszystkich lub tylko wybranych. Szablony można zapisać aby ponownie użyć tego samego wyboru co miesiąc.',
  tourExportTitle: 'Eksport',
  tourExportText: 'Eksportuj jako CSV do własnych analiz lub w formacie DATEV dla działu płac.',
};

const payrollCs = {
  title: 'Zpracovani mezd',
  infoText: 'Zde můžete spravovat platy svých zaměstnanců.',
  infoItem1: 'Můžete prohlížet a spravovat pracovní hodiny, dovolené, nemoci a jiné důležité informace o svých zaměstnancích.',
  infoItem2: 'Můžete vytvářet a exportovat výplatní pásy pro konkrétní měsíc, které můžete použít ve svém platebním softwaru.',
  infoItem3: 'Výplatní pásy obsahují podrobné informace o pracovních hodinách, přesčasech, dovolených, nemocích a jiných důležitých informacích o vašich zaměstnancích.',
  infoItem4: 'Můžete exportovat výplatní pásy ve formátu CSV nebo DATEV.',
  workdays: 'pracovni dny',
  holiday: 'svatek',
  holidays: 'svatky',
  csvExport: 'CSV',
  datevExport: 'DATEV LODAS',
  holidaysLabel: 'Svatky',
  employees: 'Zamestnanci',
  actualHours: 'Skutecne hodiny',
  overtime: 'Prescasy',
  vacationDays: 'Dny dovolene',
  sickDays: 'Dny nemoci',
  kugHours: 'Hodiny KUG',
  grossTotal: 'Hruby soucet',
  personnelNo: 'Osobni cislo',
  targetHoursShort: 'Plan-h',
  actualHoursShort: 'Skut-h',
  overtimeShort: 'Prescas',
  vacationShort: 'Dovolena',
  sickShort: 'Nemoc',
  holidaysShort: 'Svatky',
  kugShort: 'KUG-h',
  compensation: 'Odmena',
  gross: 'Hrube',
  auto: 'auto',
  suggestion: 'Navrh',
  salary: 'Plat',
  wage: 'Mzda',
  month: 'Mesic',
  targetHours: 'Planovane hodiny',
  seasonalKugHours: 'Sezonni KUG (hodiny)',
  suggestionBasedOnMissing: 'Navrh podle chybejicich hodin',
  applySuggestion: 'Pouzit navrh',
  holidaysDays: 'Svatky (dny)',
  automatic: 'Automaticky',
  extraHours: 'Hodiny navic',
  extraHoursHint: 'Prictou se ke skutecnemu casu',
  costCenter: 'Nakladove stredisko',
  compensationType: 'Typ odmeny',
  hourlyRate: 'Hodinova sazba',
  monthlySalary: 'Mesicni plat',
  grossWage: 'Hruba mzda',
  brtvMode: 'BRTV Stavebnictvi aktivni ({hours} h/tyden)',
  startTour: 'Spustit průvodce',
  tourNavTitle: 'Výběr měsíce',
  tourNavText: 'Procházejte měsíce šipkami. Výplatní listina se generuje měsíčně.',
  tourHolidaysTitle: 'Státní svátky',
  tourHolidaysText: 'Svátky vybraného měsíce – automaticky určeny podle spolkové země v nastavení.',
  tourKpisTitle: 'Měsíční ukazatele',
  tourKpisText: 'Přehled: odpracované hodiny, přesčasy, dovolená, dny nemoci, hodiny KUG a celková hrubá mzda.',
  tourTableTitle: 'Tabulka zaměstnanců',
  tourTableText: 'Detailní řádek na zaměstnance – plánované/skutečné hodiny, dovolená, nemoc, KUG a hrubá mzda. Kliknutím na řádek zadáte ruční korekce.',
  tourEditModalTitle: 'Ruční korekce',
  tourEditModalText: 'Zde můžete ručně zadat nebo opravit hodiny zkráceného pracovního úvazku, svátky, přesčasy a poznámku pro tohoto zaměstnance.',
  tourExportModalTitle: 'Dialog exportu',
  tourExportModalText: 'Vyberte které zaměstnance exportovat – všechny nebo jen některé. Šablony lze uložit pro opakované použití stejného výběru každý měsíc.',
  tourExportTitle: 'Export',
  tourExportText: 'Exportujte jako CSV pro vlastní analýzy nebo přímo ve formátu DATEV pro účetnictví mezd.',
};

const documentsDe = {
  offerInfoText: 'Hier kannst du deine Angebote verwalten.',
  offerInfoItem1: 'Du kannst Angebote erstellen, bearbeiten und löschen.',
  offerInfoItem2: 'Du kannst Angebote in Rechnungen umwandeln.',
  offerInfoItem3: 'Du kannst Angebote aufrufen und anzeigen lassen.',
  offerDetailTitle: 'Angebotsdetails',
  offerDetailInfoText: 'Hier findest du alle Details zu diesem Angebot.',
  offerDetailInfoItem1: 'Ist das Angebot im Status "Entwurf", kannst du das Angebot bearbeiten.',
  offerDetailInfoItem2: 'Ist das Angebot im Status "Angenommen", kannst du das Angebot nicht mehr bearbeiten, jedoch in eine Rechnung umwandeln.',
  offerDetailInfoItem3: 'Du kannst das Angebot per E-Mail versenden, als PDF anzeigen und herunterladen oder im GAEB Format exportieren.',
  offerDetailInfoItem4: 'Du kannst alle Positionen des Angebots einsehen inklusive Beschreibung, Menge, Einzelpreis, Zwischensumme und die Endsumme netto sowie Brutto.',
  invoiceInfoText: 'Hier kannst du deine Rechnungen verwalten.',
  invoiceInfoItem1: 'Du kannst Rechnungen erstellen, bearbeiten und löschen.',
  invoiceInfoItem2: 'Du kannst die Rechnungen aufrufen und anzeigen lassen.',
  invoiceDetailTitle: 'Rechnungsdetails',
  invoiceDetailInfoText: 'Hier findest du alle Details zu dieser Rechnung.',
  invoiceDetailInfoItem1: 'Ist die Rechnung im Status "Entwurf", kannst du die Rechnung bearbeiten.',
  invoiceDetailInfoItem2: 'Ist die Rechnung im Status "Versendet", "Bezahlt" oder "Storniert", kannst du die Rechnung nicht mehr bearbeiten.',
  invoiceDetailInfoItem3: 'Du kannst die Rechnung per E-Mail versenden, als PDF anzeigen und herunterladen, als eRechnung (ZUGFeRD 2.x) exportieren oder im GAEB Format exportieren.',
  invoiceDetailInfoItem4: 'Du kannst alle Positionen des Angebots einsehen inklusive Beschreibung, Menge, Einzelpreis, Zwischensumme und die Endsumme netto sowie Brutto.',
  edit: 'Bearbeiten',
  sendByEmail: 'Per E-Mail versenden',
  send: 'Senden',
  openPdf: 'PDF anzeigen / herunterladen',
  downloadEInvoice: 'ZUGFeRD 2.x eRechnung (EN16931) herunterladen',
  exportOffer: 'Angebot exportieren',
  exportAward: 'Auftragserteilung exportieren',
  exportMeasurement: 'Aufmaß exportieren',
  exportFinalInvoice: 'Schlussrechnung exportieren',
  customer: 'Kunde',
  vatId: 'USt-Id',
  date: 'Datum',
  due: 'Fällig',
  validUntil: 'Gültig bis',
  paidOn: 'Bezahlt am',
  skonto: 'Skonto',
  total: 'Gesamtbetrag',
  discount: 'Rabatt',
  createdBy: 'Erstellt von',
  positions: 'Positionen',
  description: 'Beschreibung',
  quantity: 'Menge',
  unit: 'Einheit',
  unitPrice: 'Einzelpreis',
  netSubtotal: 'Zwischensumme Netto',
  taxNotice: 'Steuerhinweis',
  notes: 'Notizen',
  footer: 'Fußzeile',
  recordPayment: 'Zahlungseingang erfassen',
  receivedAmount: 'Eingegangener Betrag',
  skontoWithin: 'bei Zahlung innerhalb',
  days: 'Tage',
  cancel: 'Abbrechen',
  confirmPayment: 'Zahlung vermerken',
  changeStatus: 'Status ändern',
  setStatusTo: 'Status setzen auf',
  change: 'Ändern',
  statusChangedTo: 'Status geändert auf',
  statusChangeNotPossible: 'Statuswechsel nicht möglich',
  paymentRecorded: 'Zahlung vermerkt',
  saveError: 'Fehler beim Speichern',
  accepted: 'akzeptiert',
  notFound: 'Dokument nicht gefunden',
  inclTax: 'inkl.',
  vat: 'MwSt',
  vatReverseCharge: 'MwSt. (Reverse Charge)',
  reverseChargeNote: 'Reverse Charge - Steuerschuldnerschaft des Leistungsempfängers.',
  convertToInvoiceTitle: 'Zu Rechnung konvertieren',
  convertToInvoiceMessage: 'Angebot in eine Rechnung umwandeln:',
  convertToInvoiceHint: 'Das Angebot wird als "Berechnet" markiert.',
  createInvoice: 'Rechnung erstellen',
  invoiceCreated: 'Rechnung erstellt:',
  convertError: 'Fehler beim Konvertieren',
  emailSent: 'E-Mail erfolgreich versendet',
  recipient: 'Empfänger',
  subject: 'Betreff',
  message: 'Nachricht',
  messagePlaceholder: 'Sehr geehrte Damen und Herren,...',
  openTestPreview: 'Test-Vorschau öffnen',
  sending: 'Wird gesendet...',
  sendError: 'Fehler beim Senden',
  searchPlaceholder: 'Suchen nach Nummer, Kunde oder Projekt',
  allStatuses: 'Alle Status',
  reset: 'Zurücksetzen',
  results: 'Ergebnisse',
  noOffers: 'Keine Angebote vorhanden',
  noInvoices: 'Keine Rechnungen vorhanden',
  noCreditNotes: 'Keine Gutschriften vorhanden',
  firstOffer: 'Erstelle dein erstes Angebot.',
  startTour: 'Führung starten',
  tourOfferFilterTitle: 'Filter', tourOfferFilterText: 'Angebote nach Nummer, Kunde oder Status filtern. Status: Entwurf → Versendet → Angenommen / Abgelehnt / Berechnet.',
  tourOfferTableTitle: 'Angebotsliste', tourOfferTableText: 'Alle Angebote mit Gültig-bis-Datum und Status. Löschen ist nur möglich solange das Angebot noch im Status "Entwurf" ist – danach nicht mehr.',
  tourOfferNewTitle: 'Angebot erstellen & umwandeln', tourOfferNewText: 'Neues Angebot anlegen. Hat ein Angebot den Status "Angenommen", kann es per Klick direkt in eine Rechnung umgewandelt werden. Die Rechnungsdetails werden automatisch übernommen.',
  tourInvoiceTabsTitle: 'Rechnungen & Gutschriften', tourInvoiceTabsText: 'Zwischen Rechnungen und Gutschriften wechseln. Gutschriften werden bei Rücksendungen oder Korrekturen zu bereits gestellten Rechnungen ausgestellt.',
  tourInvoiceFilterTitle: 'Filter', tourInvoiceFilterText: 'Rechnungen nach Nummer, Kunde oder Status filtern. Status: Entwurf → Versendet → Angenommen → Bezahlt / Storniert.',
  tourInvoiceTableTitle: 'Rechnungsliste', tourInvoiceTableText: 'Alle Rechnungen mit Fälligkeitsdatum und Zahlungsstatus. Überfällige werden rot markiert. Löschen ist nur im Status "Entwurf" möglich.',
  tourInvoiceNewTitle: 'Neue Rechnung', tourInvoiceNewText: 'Neue Rechnung anlegen – direkt oder aus einem angenommenen Angebot heraus. Nach Zahlungseingang den Status auf "Bezahlt" setzen.',
  tourCreditNoteTabTitle: 'Gutschriften', tourCreditNoteTabText: 'Der Gutschriften-Reiter zeigt alle ausgestellten Gutschriften. Eine Gutschrift korrigiert oder storniert eine bereits versendete Rechnung.',
  tourCreditNoteFilterTitle: 'Gutschriften-Filter', tourCreditNoteFilterText: 'Gutschriften nach Nummer, Kunde oder Status filtern. Status: Entwurf → Versendet → Angenommen → Bezahlt.',
  tourCreditNoteTableTitle: 'Gutschriftenliste', tourCreditNoteTableText: 'Alle Gutschriften mit Datum, Betrag und Status. Löschen ist wie bei Rechnungen nur im Status "Entwurf" möglich.',
  tourDetailMetaTitle: 'Kopfdaten', tourDetailMetaOfferText: 'Kunde, Angebotsdatum, Gültig-bis, Gesamtbetrag und Projektzuordnung.',
  tourDetailMetaInvoiceText: 'Kunde, Rechnungsdatum, Fälligkeitsdatum, Gesamtbetrag und Projektzuordnung. Überfällige Beträge werden farblich hervorgehoben.',
  tourDetailMetaCreditText: 'Kunde, Datum, Betrag und Verweis auf die ursprüngliche Rechnung die korrigiert wird.',
  tourDetailPositionsTitle: 'Positionen', tourDetailPositionsText: 'Alle Leistungen und Materialien mit Menge, Einheitspreis und Gesamtpreis. Darunter: Netto, MwSt. und Brutto.',
  tourDetailOfferStatusTitle: 'Status', tourDetailOfferStatusText: 'Status ändern: Entwurf → Versendet → Angenommen / Abgelehnt. Löschen ist nur im Status "Entwurf" möglich. Nach dem Versenden kann der Status nicht zurückgesetzt werden.',
  tourDetailOfferActionsTitle: 'Aktionen', tourDetailOfferActionsText: 'E-Mail versenden, PDF öffnen, GAEB exportieren. Ist das Angebot "Angenommen", erscheint der Button "→ Rechnung erstellen" um es direkt umzuwandeln.',
  tourDetailInvoiceStatusTitle: 'Status', tourDetailInvoiceStatusText: 'Status ändern: Entwurf → Versendet → Angenommen → Bezahlt / Storniert. Löschen nur im "Entwurf". Bezahlt setzen über den Status-Dropdown.',
  tourDetailInvoiceActionsTitle: 'Aktionen', tourDetailInvoiceActionsText: 'E-Mail senden, PDF und eRechnung (ZUGFeRD) herunterladen, GAEB exportieren. Wurde die Rechnung versendet, kann eine Gutschrift erstellt werden.',
  tourDetailCreditStatusTitle: 'Status', tourDetailCreditStatusText: 'Status ändern: Entwurf → Versendet → Angenommen → Bezahlt. Löschen ist nur im "Entwurf" möglich.',
  tourDetailCreditActionsTitle: 'Aktionen', tourDetailCreditActionsText: 'E-Mail versenden, PDF und eRechnung herunterladen. Eine Gutschrift referenziert immer die ursprüngliche Rechnung.',
  tourDetailNotesTitle: 'Notizen & Fußzeile', tourDetailNotesText: 'Interne Notizen, Zahlungshinweise oder Standardtexte die am Ende des Dokuments erscheinen.',
  firstInvoice: 'Erstelle deine erste Rechnung.',
  firstCreditNote: 'Erstelle deine erste Gutschrift.',
  number: 'Nummer',
  amount: 'Betrag',
  status: 'Status',
  details: 'Details',
  convertToInvoice: 'In Rechnung umwandeln',
  createCreditNote: 'Gutschrift erstellen',
  createCreditNoteTitle: 'Gutschrift erstellen',
  createCreditNoteMessage: 'Gutschrift aus Rechnung erstellen:',
  createCreditNoteError: 'Fehler beim Erstellen der Gutschrift',
  creditNoteCreated: 'Gutschrift erstellt:',
  originalInvoice: 'Zugehörige Rechnung',
  creditNoteInfoText: 'Hier kannst du deine Gutschriften verwalten.',
  creditNoteInfoItem1: 'Du kannst Gutschriften zu bestehenden Rechnungen erstellen oder eigenständige Gutschriften anlegen.',
  creditNoteInfoItem2: 'Gutschriften erhalten eine eigene Nummer (GS-...) und werden separat verwaltet.',
  delete: 'Löschen',
  confirmDelete: 'wirklich löschen?',
  deleteIrreversible: 'Dieser Vorgang kann nicht rückgängig gemacht werden.',
  offerDeleteHint: 'Das Angebot wird dauerhaft entfernt.',
  invoiceDeleteHint: 'Die Rechnung wird dauerhaft entfernt.',
  deleteError: 'Fehler beim Löschen',
  unknownError: 'Unbekannter Fehler',
  loadError: 'Fehler beim Laden',
  saveError: 'Fehler beim Speichern',
  deleteConfirm: 'Wirklich löschen?',
  lockedByOther: 'Wird gerade bearbeitet von {name}',
  editLockedTooltip: 'Wird gerade von {name} bearbeitet',
};

const documentsEn = {
  offerInfoText: 'Here you can manage your offers.',
  offerInfoItem1: 'You can create, edit and delete offers.',
  offerInfoItem2: 'You can convert offers into invoices.',
  offerInfoItem3: 'You can view and display offers.',
  invoiceInfoText: 'Here you can manage your invoices.',
  invoiceInfoItem1: 'You can create, edit and delete invoices.',
  invoiceInfoItem2: 'You can view and display invoices.',
  edit: 'Edit',
  sendByEmail: 'Send by email',
  send: 'Send',
  openPdf: 'Open / download PDF',
  downloadEInvoice: 'Download ZUGFeRD 2.x e-invoice (EN16931)',
  exportOffer: 'Export offer',
  exportAward: 'Export award',
  exportMeasurement: 'Export measurement',
  exportFinalInvoice: 'Export final invoice',
  customer: 'Customer',
  vatId: 'VAT ID',
  date: 'Date',
  due: 'Due',
  validUntil: 'Valid until',
  paidOn: 'Paid on',
  skonto: 'Cash discount',
  total: 'Total amount',
  discount: 'Discount',
  createdBy: 'Created by',
  positions: 'Line items',
  description: 'Description',
  quantity: 'Quantity',
  unit: 'Unit',
  unitPrice: 'Unit price',
  netSubtotal: 'Net subtotal',
  taxNotice: 'Tax notice',
  notes: 'Notes',
  footer: 'Footer',
  recordPayment: 'Record payment',
  receivedAmount: 'Received amount',
  skontoWithin: 'if paid within',
  days: 'days',
  cancel: 'Cancel',
  confirmPayment: 'Confirm payment',
  changeStatus: 'Change status',
  setStatusTo: 'Set status to',
  change: 'Change',
  statusChangedTo: 'Status changed to',
  statusChangeNotPossible: 'Status change not possible',
  paymentRecorded: 'Payment recorded',
  saveError: 'Error while saving',
  accepted: 'accepted',
  notFound: 'Document not found',
  inclTax: 'incl.',
  vat: 'VAT',
  vatReverseCharge: 'VAT (Reverse charge)',
  reverseChargeNote: 'Reverse charge - tax liability of the recipient.',
  convertToInvoiceTitle: 'Convert to invoice',
  convertToInvoiceMessage: 'Convert offer to invoice:',
  convertToInvoiceHint: 'The offer will be marked as "Invoiced".',
  createInvoice: 'Create invoice',
  invoiceCreated: 'Invoice created:',
  convertError: 'Error during conversion',
  emailSent: 'Email sent successfully',
  recipient: 'Recipient',
  subject: 'Subject',
  message: 'Message',
  messagePlaceholder: 'Dear Sir or Madam,...',
  openTestPreview: 'Open test preview',
  sending: 'Sending...',
  sendError: 'Sending failed',
  searchPlaceholder: 'Search by number, customer or project',
  allStatuses: 'All statuses',
  reset: 'Reset',
  results: 'results',
  noOffers: 'No offers available',
  noInvoices: 'No invoices available',
  noCreditNotes: 'No credit notes available',
  firstOffer: 'Create your first offer.',
  startTour: 'Start tour',
  tourOfferFilterTitle: 'Filter', tourOfferFilterText: 'Filter offers by number, customer or status. Status: Draft → Sent → Accepted / Rejected / Invoiced.',
  tourOfferTableTitle: 'Offer list', tourOfferTableText: 'All offers with valid-until date and status. Deletion is only possible while the offer is still in "Draft" status – not after that.',
  tourOfferNewTitle: 'Create & convert offer', tourOfferNewText: 'Create a new offer. If an offer has status "Accepted" it can be converted directly into an invoice with one click. All details are transferred automatically.',
  tourInvoiceTabsTitle: 'Invoices & credit notes', tourInvoiceTabsText: 'Switch between invoices and credit notes. Credit notes are issued for returns or corrections to already sent invoices.',
  tourInvoiceFilterTitle: 'Filter', tourInvoiceFilterText: 'Filter invoices by number, customer or status. Status: Draft → Sent → Accepted → Paid / Cancelled.',
  tourInvoiceTableTitle: 'Invoice list', tourInvoiceTableText: 'All invoices with due date and payment status. Overdue ones are marked in red. Deletion is only possible in "Draft" status.',
  tourInvoiceNewTitle: 'New invoice', tourInvoiceNewText: 'Create a new invoice – directly or from an accepted offer. After receiving payment set the status to "Paid".',
  tourCreditNoteTabTitle: 'Credit notes', tourCreditNoteTabText: 'The credit notes tab shows all issued credit notes. A credit note corrects or cancels an already sent invoice.',
  tourCreditNoteFilterTitle: 'Credit note filter', tourCreditNoteFilterText: 'Filter credit notes by number, customer or status. Status: Draft → Sent → Accepted → Paid.',
  tourCreditNoteTableTitle: 'Credit note list', tourCreditNoteTableText: 'All credit notes with date, amount and status. Deletion is only possible in "Draft" status, same as invoices.',
  tourDetailMetaTitle: 'Header data', tourDetailMetaOfferText: 'Customer, offer date, valid-until, total amount and project assignment.',
  tourDetailMetaInvoiceText: 'Customer, invoice date, due date, total amount and project. Overdue amounts are highlighted.',
  tourDetailMetaCreditText: 'Customer, date, amount and reference to the original invoice being corrected.',
  tourDetailPositionsTitle: 'Line items', tourDetailPositionsText: 'All services and materials with quantity, unit price and total. Below: net, VAT and gross total.',
  tourDetailOfferStatusTitle: 'Status', tourDetailOfferStatusText: 'Change status: Draft → Sent → Accepted / Rejected. Deletion is only possible in "Draft". Status cannot be reverted after sending.',
  tourDetailOfferActionsTitle: 'Actions', tourDetailOfferActionsText: 'Send by email, open PDF, GAEB export. Once the offer is "Accepted" a "→ Create invoice" button appears to convert it directly.',
  tourDetailInvoiceStatusTitle: 'Status', tourDetailInvoiceStatusText: 'Change status: Draft → Sent → Accepted → Paid / Cancelled. Delete only in "Draft". Set paid via the status dropdown.',
  tourDetailInvoiceActionsTitle: 'Actions', tourDetailInvoiceActionsText: 'Send email, download PDF and e-invoice (ZUGFeRD), GAEB export. Once sent a credit note can be created.',
  tourDetailCreditStatusTitle: 'Status', tourDetailCreditStatusText: 'Change status: Draft → Sent → Accepted → Paid. Deletion is only possible in "Draft".',
  tourDetailCreditActionsTitle: 'Actions', tourDetailCreditActionsText: 'Send by email, download PDF and e-invoice. A credit note always references the original invoice.',
  tourDetailNotesTitle: 'Notes & footer', tourDetailNotesText: 'Internal notes, payment instructions or standard texts that appear at the end of the document.',
  firstInvoice: 'Create your first invoice.',
  firstCreditNote: 'Create your first credit note.',
  number: 'Number',
  amount: 'Amount',
  status: 'Status',
  details: 'Details',
  convertToInvoice: 'Convert to invoice',
  createCreditNote: 'Create credit note',
  createCreditNoteTitle: 'Create credit note',
  createCreditNoteMessage: 'Create credit note from invoice:',
  createCreditNoteError: 'Error creating credit note',
  creditNoteCreated: 'Credit note created:',
  originalInvoice: 'Related invoice',
  creditNoteInfoText: 'Here you can manage your credit notes.',
  creditNoteInfoItem1: 'You can create credit notes from existing invoices or create standalone credit notes.',
  creditNoteInfoItem2: 'Credit notes have their own number series (GS-...) and are managed separately.',
  delete: 'Delete',
  confirmDelete: 'really delete?',
  deleteIrreversible: 'This action cannot be undone.',
  offerDeleteHint: 'The offer will be permanently deleted.',
  invoiceDeleteHint: 'The invoice will be permanently deleted.',
  deleteError: 'Delete failed',
  unknownError: 'Unknown error',
  loadError: 'Error loading data',
  saveError: 'Error saving data',
  deleteConfirm: 'Really delete?',
  lockedByOther: 'Currently being edited by {name}',
  editLockedTooltip: 'Currently being edited by {name}',
};

const documentsFr = {
  offerInfoText: 'Ici, vous pouvez gérer vos offres.',
  offerInfoItem1: 'Vous pouvez créer, modifier et supprimer des offres.',
  offerInfoItem2: 'Vous pouvez convertir des offres en factures.',
  offerInfoItem3: 'Vous pouvez afficher les offres.',
  invoiceInfoText: 'Ici, vous pouvez gérer vos factures.',
  invoiceInfoItem1: 'Vous pouvez créer, modifier et supprimer des factures.',
  invoiceInfoItem2: 'Vous pouvez afficher les factures.',
  edit: 'Modifier',
  sendByEmail: 'Envoyer par e-mail',
  send: 'Envoyer',
  openPdf: 'Ouvrir / telecharger le PDF',
  downloadEInvoice: 'Telecharger la facture electronique ZUGFeRD 2.x (EN16931)',
  exportOffer: 'Exporter le devis',
  exportAward: 'Exporter l\'attribution',
  exportMeasurement: 'Exporter le metrage',
  exportFinalInvoice: 'Exporter la facture finale',
  customer: 'Client',
  vatId: 'TVA intracom',
  date: 'Date',
  due: 'Echeance',
  validUntil: 'Valable jusqu\'au',
  paidOn: 'Paye le',
  skonto: 'Escompte',
  total: 'Montant total',
  discount: 'Remise',
  createdBy: 'Cree par',
  positions: 'Positions',
  description: 'Description',
  quantity: 'Quantite',
  unit: 'Unite',
  unitPrice: 'Prix unitaire',
  netSubtotal: 'Sous-total net',
  taxNotice: 'Mention fiscale',
  notes: 'Notes',
  footer: 'Pied de page',
  recordPayment: 'Enregistrer le paiement',
  receivedAmount: 'Montant recu',
  skontoWithin: 'en cas de paiement sous',
  days: 'jours',
  cancel: 'Annuler',
  confirmPayment: 'Confirmer le paiement',
  changeStatus: 'Changer le statut',
  setStatusTo: 'Definir le statut sur',
  change: 'Changer',
  statusChangedTo: 'Statut change en',
  statusChangeNotPossible: 'Changement de statut impossible',
  paymentRecorded: 'Paiement enregistre',
  saveError: 'Erreur lors de l\'enregistrement',
  accepted: 'accepte',
  notFound: 'Document introuvable',
  inclTax: 'incl.',
  vat: 'TVA',
  vatReverseCharge: 'TVA (autoliquidation)',
  reverseChargeNote: 'Autoliquidation - la TVA est due par le preneur.',
  convertToInvoiceTitle: 'Convertir en facture',
  convertToInvoiceMessage: 'Convertir le devis en facture :',
  convertToInvoiceHint: 'Le devis sera marque comme "Facture".',
  createInvoice: 'Creer une facture',
  invoiceCreated: 'Facture creee :',
  convertError: 'Erreur lors de la conversion',
  emailSent: 'E-mail envoye avec succes',
  recipient: 'Destinataire',
  subject: 'Objet',
  message: 'Message',
  messagePlaceholder: 'Madame, Monsieur, ...',
  openTestPreview: 'Ouvrir l\'aperçu de test',
  sending: 'Envoi en cours...',
  sendError: 'Erreur lors de l\'envoi',
  searchPlaceholder: 'Rechercher par numero, client ou projet',
  allStatuses: 'Tous les statuts',
  reset: 'Reinitialiser',
  results: 'resultats',
  noOffers: 'Aucun devis disponible',
  noInvoices: 'Aucune facture disponible',
  noCreditNotes: 'Aucun avoir disponible',
  firstOffer: 'Creez votre premier devis.',
  startTour: 'Lancer la visite guidée',
  tourOfferFilterTitle: 'Filtre', tourOfferFilterText: 'Filtrez les devis par numéro, client ou statut. Statuts : Brouillon → Envoyé → Accepté / Refusé / Facturé.',
  tourOfferTableTitle: 'Liste des devis', tourOfferTableText: 'Tous les devis avec date de validité et statut. La suppression n\'est possible qu\'en statut "Brouillon".',
  tourOfferNewTitle: 'Créer & convertir devis', tourOfferNewText: 'Créez un nouveau devis. Un devis "Accepté" peut être converti en facture d\'un clic – tous les détails sont repris automatiquement.',
  tourInvoiceTabsTitle: 'Factures & avoirs', tourInvoiceTabsText: 'Basculez entre factures et avoirs. Les avoirs corrigent ou annulent des factures déjà envoyées.',
  tourInvoiceFilterTitle: 'Filtre', tourInvoiceFilterText: 'Filtrez par numéro, client ou statut. Statuts : Brouillon → Envoyé → Accepté → Payée / Annulée.',
  tourInvoiceTableTitle: 'Liste des factures', tourInvoiceTableText: 'Toutes les factures avec échéance et statut. Les en retard sont en rouge. Suppression possible en "Brouillon" seulement.',
  tourInvoiceNewTitle: 'Nouvelle facture', tourInvoiceNewText: 'Créez une nouvelle facture – directement ou depuis un devis accepté. Après paiement mettez le statut à "Payée".',
  tourCreditNoteTabTitle: 'Avoirs', tourCreditNoteTabText: 'L\'onglet avoirs affiche tous les avoirs émis. Un avoir corrige ou annule une facture déjà envoyée.',
  tourCreditNoteFilterTitle: 'Filtre avoirs', tourCreditNoteFilterText: 'Filtrez les avoirs par numéro, client ou statut. Statuts : Brouillon → Envoyé → Accepté → Payé.',
  tourCreditNoteTableTitle: 'Liste des avoirs', tourCreditNoteTableText: 'Tous les avoirs avec date, montant et statut. La suppression n\'est possible qu\'en "Brouillon".',
  tourDetailMetaTitle: 'En-tête', tourDetailMetaOfferText: 'Client, date du devis, date de validité, montant total et projet.',
  tourDetailMetaInvoiceText: 'Client, date de facturation, échéance, montant total et projet. Les montants en retard sont mis en évidence.',
  tourDetailMetaCreditText: 'Client, date, montant et référence à la facture d\'origine corrigée.',
  tourDetailPositionsTitle: 'Lignes', tourDetailPositionsText: 'Toutes les prestations et matériaux avec quantité, prix unitaire et total. En dessous : HT, TVA et TTC.',
  tourDetailOfferStatusTitle: 'Statut', tourDetailOfferStatusText: 'Changer le statut : Brouillon → Envoyé → Accepté / Refusé. Suppression possible seulement en "Brouillon". Impossible de revenir en arrière après envoi.',
  tourDetailOfferActionsTitle: 'Actions', tourDetailOfferActionsText: 'Envoyer par e-mail, ouvrir PDF, exporter GAEB. Si le devis est "Accepté" un bouton "→ Créer facture" apparaît pour convertir directement.',
  tourDetailInvoiceStatusTitle: 'Statut', tourDetailInvoiceStatusText: 'Changer le statut : Brouillon → Envoyé → Accepté → Payée / Annulée. Suppression seulement en "Brouillon". Statut "Payée" via le menu déroulant.',
  tourDetailInvoiceActionsTitle: 'Actions', tourDetailInvoiceActionsText: 'Envoyer e-mail, télécharger PDF et e-facture (ZUGFeRD), exporter GAEB. Une fois envoyée un avoir peut être créé.',
  tourDetailCreditStatusTitle: 'Statut', tourDetailCreditStatusText: 'Changer le statut : Brouillon → Envoyé → Accepté → Payé. Suppression possible seulement en "Brouillon".',
  tourDetailCreditActionsTitle: 'Actions', tourDetailCreditActionsText: 'Envoyer par e-mail, télécharger PDF et e-facture. Un avoir fait toujours référence à la facture d\'origine.',
  tourDetailNotesTitle: 'Notes & pied de page', tourDetailNotesText: 'Notes internes, instructions de paiement ou textes standard qui apparaissent en bas du document.',
  firstInvoice: 'Creez votre premiere facture.',
  firstCreditNote: 'Creez votre premier avoir.',
  number: 'Numero',
  amount: 'Montant',
  status: 'Statut',
  details: 'Details',
  convertToInvoice: 'Convertir en facture',
  createCreditNote: 'Creer un avoir',
  createCreditNoteTitle: 'Creer un avoir',
  createCreditNoteMessage: 'Creer un avoir depuis la facture :',
  createCreditNoteError: 'Erreur lors de la creation de l\'avoir',
  creditNoteCreated: 'Avoir cree :',
  originalInvoice: 'Facture associee',
  creditNoteInfoText: 'Ici vous pouvez gerer vos avoirs.',
  creditNoteInfoItem1: 'Vous pouvez creer des avoirs depuis des factures existantes ou creer des avoirs independants.',
  creditNoteInfoItem2: 'Les avoirs ont leur propre serie de numeros (GS-...) et sont geres separement.',
  delete: 'Supprimer',
  confirmDelete: 'supprimer vraiment ?',
  deleteIrreversible: 'Cette action est irreversible.',
  offerDeleteHint: 'Le devis sera supprime definitivement.',
  invoiceDeleteHint: 'La facture sera supprimee definitivement.',
  deleteError: 'Erreur lors de la suppression',
  unknownError: 'Erreur inconnue',
  loadError: 'Erreur de chargement',
  saveError: 'Erreur lors de l\'enregistrement',
  deleteConfirm: 'Vraiment supprimer ?',
  lockedByOther: 'Actuellement modifie par {name}',
  editLockedTooltip: 'Actuellement modifie par {name}',
};
const documentsIt = {
  offerInfoText: 'Qui puoi gestire le tue offerte.',
  offerInfoItem1: 'Puoi creare, modificare ed eliminare le offerte.',
  offerInfoItem2: 'Puoi convertire le offerte in fatture.',
  offerInfoItem3: 'Puoi visualizzare le offerte.',
  invoiceInfoText: 'Qui puoi gestire le tue fatture.',
  invoiceInfoItem1: 'Puoi creare, modificare ed eliminare le fatture.',
  invoiceInfoItem2: 'Puoi visualizzare le fatture.',
  edit: 'Modifica',
  sendByEmail: 'Invia via e-mail',
  send: 'Invia',
  openPdf: 'Apri / scarica PDF',
  downloadEInvoice: 'Scarica e-fattura ZUGFeRD 2.x (EN16931)',
  exportOffer: 'Esporta offerta',
  exportAward: 'Esporta aggiudicazione',
  exportMeasurement: 'Esporta misurazione',
  exportFinalInvoice: 'Esporta fattura finale',
  customer: 'Cliente',
  vatId: 'Partita IVA',
  date: 'Data',
  due: 'Scadenza',
  validUntil: 'Valido fino al',
  paidOn: 'Pagato il',
  skonto: 'Sconto cassa',
  total: 'Importo totale',
  discount: 'Sconto',
  createdBy: 'Creato da',
  positions: 'Posizioni',
  description: 'Descrizione',
  quantity: 'Quantita',
  unit: 'Unita',
  unitPrice: 'Prezzo unitario',
  netSubtotal: 'Subtotale netto',
  taxNotice: 'Nota fiscale',
  notes: 'Note',
  footer: 'Piè di pagina',
  recordPayment: 'Registra pagamento',
  receivedAmount: 'Importo ricevuto',
  skontoWithin: 'se pagato entro',
  days: 'giorni',
  cancel: 'Annulla',
  confirmPayment: 'Conferma pagamento',
  changeStatus: 'Cambia stato',
  setStatusTo: 'Imposta stato a',
  change: 'Cambia',
  statusChangedTo: 'Stato cambiato in',
  statusChangeNotPossible: 'Cambio stato non possibile',
  paymentRecorded: 'Pagamento registrato',
  saveError: 'Errore durante il salvataggio',
  accepted: 'accettato',
  notFound: 'Documento non trovato',
  inclTax: 'incl.',
  vat: 'IVA',
  vatReverseCharge: 'IVA (Reverse charge)',
  reverseChargeNote: 'Reverse charge - imposta a carico del destinatario.',
  convertToInvoiceTitle: 'Converti in fattura',
  convertToInvoiceMessage: 'Convertire l\'offerta in fattura:',
  convertToInvoiceHint: 'L\'offerta verra contrassegnata come "Fatturato".',
  createInvoice: 'Crea fattura',
  invoiceCreated: 'Fattura creata:',
  convertError: 'Errore durante la conversione',
  emailSent: 'E-mail inviata con successo',
  recipient: 'Destinatario',
  subject: 'Oggetto',
  message: 'Messaggio',
  messagePlaceholder: 'Gentili Signore e Signori,...',
  openTestPreview: 'Apri anteprima test',
  sending: 'Invio in corso...',
  sendError: 'Invio non riuscito',
  searchPlaceholder: 'Cerca per numero, cliente o progetto',
  allStatuses: 'Tutti gli stati',
  reset: 'Reimposta',
  results: 'risultati',
  noOffers: 'Nessuna offerta disponibile',
  noInvoices: 'Nessuna fattura disponibile',
  noCreditNotes: 'Nessuna nota di credito disponibile',
  firstOffer: 'Crea la tua prima offerta.',
  startTour: 'Avvia la guida',
  tourOfferFilterTitle: 'Filtro', tourOfferFilterText: 'Filtra le offerte per numero, cliente o stato. Stati: Bozza → Inviata → Accettata / Rifiutata / Fatturata.',
  tourOfferTableTitle: 'Lista offerte', tourOfferTableText: 'Tutte le offerte con data di validità e stato. L\'eliminazione è possibile solo in stato "Bozza".',
  tourOfferNewTitle: 'Crea & converti offerta', tourOfferNewText: 'Crea una nuova offerta. Un\'offerta "Accettata" può essere convertita in fattura con un clic – tutti i dettagli vengono ripresi automaticamente.',
  tourInvoiceTabsTitle: 'Fatture & note di credito', tourInvoiceTabsText: 'Passa tra fatture e note di credito. Le note di credito correggono o annullano fatture già inviate.',
  tourInvoiceFilterTitle: 'Filtro', tourInvoiceFilterText: 'Filtra per numero, cliente o stato. Stati: Bozza → Inviata → Accettata → Pagata / Annullata.',
  tourInvoiceTableTitle: 'Lista fatture', tourInvoiceTableText: 'Tutte le fatture con scadenza e stato. Le scadute sono in rosso. Eliminazione possibile solo in "Bozza".',
  tourInvoiceNewTitle: 'Nuova fattura', tourInvoiceNewText: 'Crea una fattura – direttamente o da un\'offerta accettata. Dopo il pagamento imposta lo stato su "Pagata".',
  tourCreditNoteTabTitle: 'Note di credito', tourCreditNoteTabText: 'La scheda mostra tutte le note di credito emesse. Una nota di credito corregge o annulla una fattura già inviata.',
  tourCreditNoteFilterTitle: 'Filtro note credito', tourCreditNoteFilterText: 'Filtra per numero, cliente o stato. Stati: Bozza → Inviata → Accettata → Pagata.',
  tourCreditNoteTableTitle: 'Lista note credito', tourCreditNoteTableText: 'Tutte le note di credito con data, importo e stato. Eliminazione solo in "Bozza".',
  tourDetailMetaTitle: 'Intestazione', tourDetailMetaOfferText: 'Cliente, data offerta, data validità, importo totale e progetto.',
  tourDetailMetaInvoiceText: 'Cliente, data fattura, scadenza, importo totale e progetto. Importi scaduti evidenziati.',
  tourDetailMetaCreditText: 'Cliente, data, importo e riferimento alla fattura originale corretta.',
  tourDetailPositionsTitle: 'Voci', tourDetailPositionsText: 'Tutte le prestazioni e materiali con quantità, prezzo unitario e totale. Sotto: netto, IVA e lordo.',
  tourDetailOfferStatusTitle: 'Stato', tourDetailOfferStatusText: 'Cambia stato: Bozza → Inviata → Accettata / Rifiutata. Eliminazione solo in "Bozza". Impossibile tornare indietro dopo l\'invio.',
  tourDetailOfferActionsTitle: 'Azioni', tourDetailOfferActionsText: 'Invia e-mail, apri PDF, esporta GAEB. Se accettata appare il pulsante "→ Crea fattura" per convertire direttamente.',
  tourDetailInvoiceStatusTitle: 'Stato', tourDetailInvoiceStatusText: 'Cambia stato: Bozza → Inviata → Accettata → Pagata / Annullata. Eliminazione solo in "Bozza". "Pagata" tramite il menu a discesa.',
  tourDetailInvoiceActionsTitle: 'Azioni', tourDetailInvoiceActionsText: 'Invia e-mail, scarica PDF ed e-fattura (ZUGFeRD), esporta GAEB. Una volta inviata si può creare una nota di credito.',
  tourDetailCreditStatusTitle: 'Stato', tourDetailCreditStatusText: 'Cambia stato: Bozza → Inviata → Accettata → Pagata. Eliminazione solo in "Bozza".',
  tourDetailCreditActionsTitle: 'Azioni', tourDetailCreditActionsText: 'Invia e-mail, scarica PDF ed e-fattura. Una nota di credito fa sempre riferimento alla fattura originale.',
  tourDetailNotesTitle: 'Note & piè di pagina', tourDetailNotesText: 'Note interne, istruzioni di pagamento o testi standard che appaiono in fondo al documento.',
  firstInvoice: 'Crea la tua prima fattura.',
  firstCreditNote: 'Crea la tua prima nota di credito.',
  number: 'Numero',
  amount: 'Importo',
  status: 'Stato',
  details: 'Dettagli',
  convertToInvoice: 'Converti in fattura',
  createCreditNote: 'Crea nota di credito',
  createCreditNoteTitle: 'Crea nota di credito',
  createCreditNoteMessage: 'Crea nota di credito dalla fattura:',
  createCreditNoteError: 'Errore nella creazione della nota di credito',
  creditNoteCreated: 'Nota di credito creata:',
  originalInvoice: 'Fattura correlata',
  creditNoteInfoText: 'Qui puoi gestire le tue note di credito.',
  creditNoteInfoItem1: 'Puoi creare note di credito da fatture esistenti o creare note di credito autonome.',
  creditNoteInfoItem2: 'Le note di credito hanno una propria serie di numeri (GS-...) e vengono gestite separatamente.',
  delete: 'Elimina',
  confirmDelete: 'eliminare davvero?',
  deleteIrreversible: 'Questa azione non puo essere annullata.',
  offerDeleteHint: 'L\'offerta verra eliminata definitivamente.',
  invoiceDeleteHint: 'La fattura verra eliminata definitivamente.',
  deleteError: 'Eliminazione non riuscita',
  unknownError: 'Errore sconosciuto',
  loadError: 'Errore di caricamento',
  saveError: 'Errore durante il salvataggio',
  deleteConfirm: 'Eliminare davvero?',
  lockedByOther: 'Attualmente in modifica da {name}',
  editLockedTooltip: 'Attualmente in modifica da {name}',
};
const documentsPl = {
  offerInfoText: 'Tutaj możesz zarządzać swoimi ofertami.',
  offerInfoItem1: 'Możesz tworzyć, edytować i usuwać oferty.',
  offerInfoItem2: 'Możesz konwertować oferty na faktury.',
  offerInfoItem3: 'Możesz wyświetlać oferty.',
  invoiceInfoText: 'Tutaj możesz zarządzać swoimi fakturami.',
  invoiceInfoItem1: 'Możesz tworzyć, edytować i usuwać faktury.',
  invoiceInfoItem2: 'Możesz wyświetlać faktury.',
  edit: 'Edytuj',
  sendByEmail: 'Wyslij e-mailem',
  send: 'Wyslij',
  openPdf: 'Otworz / pobierz PDF',
  downloadEInvoice: 'Pobierz e-fakture ZUGFeRD 2.x (EN16931)',
  exportOffer: 'Eksportuj oferte',
  exportAward: 'Eksportuj zlecenie',
  exportMeasurement: 'Eksportuj obmiar',
  exportFinalInvoice: 'Eksportuj fakture koncowa',
  customer: 'Klient',
  vatId: 'NIP UE',
  date: 'Data',
  due: 'Termin',
  validUntil: 'Wazne do',
  paidOn: 'Oplacono dnia',
  skonto: 'Skonto',
  total: 'Kwota laczna',
  discount: 'Rabat',
  createdBy: 'Utworzyl',
  positions: 'Pozycje',
  description: 'Opis',
  quantity: 'Ilosc',
  unit: 'Jednostka',
  unitPrice: 'Cena jednostkowa',
  netSubtotal: 'Suma netto',
  taxNotice: 'Uwaga podatkowa',
  notes: 'Notatki',
  footer: 'Stopka',
  recordPayment: 'Zarejestruj platnosc',
  receivedAmount: 'Kwota otrzymana',
  skontoWithin: 'przy platnosci w ciagu',
  days: 'dni',
  cancel: 'Anuluj',
  confirmPayment: 'Potwierdz platnosc',
  changeStatus: 'Zmien status',
  setStatusTo: 'Ustaw status na',
  change: 'Zmien',
  statusChangedTo: 'Status zmieniono na',
  statusChangeNotPossible: 'Zmiana statusu niemozliwa',
  paymentRecorded: 'Platnosc zapisana',
  saveError: 'Blad zapisu',
  accepted: 'zaakceptowano',
  notFound: 'Nie znaleziono dokumentu',
  inclTax: 'w tym',
  vat: 'VAT',
  vatReverseCharge: 'VAT (odwrotne obciazenie)',
  reverseChargeNote: 'Odwrotne obciazenie - podatek rozlicza nabywca.',
  convertToInvoiceTitle: 'Konwertuj na fakture',
  convertToInvoiceMessage: 'Konwertowac oferte na fakture:',
  convertToInvoiceHint: 'Oferta zostanie oznaczona jako "Zafakturowane".',
  createInvoice: 'Utworz fakture',
  invoiceCreated: 'Utworzono fakture:',
  convertError: 'Blad konwersji',
  emailSent: 'E-mail wyslany pomyslnie',
  recipient: 'Odbiorca',
  subject: 'Temat',
  message: 'Wiadomosc',
  messagePlaceholder: 'Szanowni Panstwo,...',
  openTestPreview: 'Otworz podglad testowy',
  sending: 'Wysylanie...',
  sendError: 'Wysylka nieudana',
  searchPlaceholder: 'Szukaj po numerze, kliencie lub projekcie',
  allStatuses: 'Wszystkie statusy',
  reset: 'Resetuj',
  results: 'wyniki',
  noOffers: 'Brak ofert',
  noInvoices: 'Brak faktur',
  noCreditNotes: 'Brak faktur korygujacych',
  firstOffer: 'Utworz pierwsza oferte.',
  startTour: 'Uruchom przewodnik',
  tourOfferFilterTitle: 'Filtr', tourOfferFilterText: 'Filtruj oferty według numeru, klienta lub statusu. Statusy: Szkic → Wysłana → Zaakceptowana / Odrzucona / Zafakturowana.',
  tourOfferTableTitle: 'Lista ofert', tourOfferTableText: 'Wszystkie oferty z datą ważności i statusem. Usunięcie jest możliwe tylko w statusie "Szkic".',
  tourOfferNewTitle: 'Utwórz i konwertuj ofertę', tourOfferNewText: 'Utwórz nową ofertę. Zaakceptowana oferta może być przekształcona w fakturę jednym klikiem – wszystkie dane są automatycznie przejęte.',
  tourInvoiceTabsTitle: 'Faktury i korekty', tourInvoiceTabsText: 'Przełącz między fakturami a korektami. Korekty korygują lub anulują już wysłane faktury.',
  tourInvoiceFilterTitle: 'Filtr', tourInvoiceFilterText: 'Filtruj według numeru, klienta lub statusu. Statusy: Szkic → Wysłana → Zaakceptowana → Zapłacona / Anulowana.',
  tourInvoiceTableTitle: 'Lista faktur', tourInvoiceTableText: 'Wszystkie faktury z terminem i statusem. Przeterminowane są czerwone. Usunięcie tylko w statusie "Szkic".',
  tourInvoiceNewTitle: 'Nowa faktura', tourInvoiceNewText: 'Utwórz fakturę – bezpośrednio lub z zaakceptowanej oferty. Po otrzymaniu płatności ustaw status na "Zapłacona".',
  tourCreditNoteTabTitle: 'Korekty', tourCreditNoteTabText: 'Zakładka pokazuje wszystkie wystawione korekty. Korekta poprawia lub anuluje już wysłaną fakturę.',
  tourCreditNoteFilterTitle: 'Filtr korekt', tourCreditNoteFilterText: 'Filtruj korekty według numeru, klienta lub statusu. Statusy: Szkic → Wysłana → Zaakceptowana → Zapłacona.',
  tourCreditNoteTableTitle: 'Lista korekt', tourCreditNoteTableText: 'Wszystkie korekty z datą, kwotą i statusem. Usunięcie możliwe tylko w "Szkicu".',
  tourDetailMetaTitle: 'Nagłówek', tourDetailMetaOfferText: 'Klient, data oferty, ważność, kwota całkowita i projekt.',
  tourDetailMetaInvoiceText: 'Klient, data faktury, termin płatności, kwota i projekt. Kwoty przeterminowane są wyróżnione.',
  tourDetailMetaCreditText: 'Klient, data, kwota i odniesienie do korygowanej faktury.',
  tourDetailPositionsTitle: 'Pozycje', tourDetailPositionsText: 'Wszystkie usługi i materiały z ilością, ceną jednostkową i sumą. Poniżej: netto, VAT i brutto.',
  tourDetailOfferStatusTitle: 'Status', tourDetailOfferStatusText: 'Zmień status: Szkic → Wysłana → Zaakceptowana / Odrzucona. Usunięcie tylko w "Szkicu". Po wysłaniu nie można cofnąć statusu.',
  tourDetailOfferActionsTitle: 'Akcje', tourDetailOfferActionsText: 'Wyślij e-mail, otwórz PDF, eksportuj GAEB. Gdy oferta jest "Zaakceptowana" pojawia się przycisk "→ Utwórz fakturę".',
  tourDetailInvoiceStatusTitle: 'Status', tourDetailInvoiceStatusText: 'Zmień status: Szkic → Wysłana → Zaakceptowana → Zapłacona / Anulowana. Usunięcie tylko w "Szkicu". "Zapłacona" przez menu.',
  tourDetailInvoiceActionsTitle: 'Akcje', tourDetailInvoiceActionsText: 'Wyślij e-mail, pobierz PDF i e-fakturę (ZUGFeRD), eksportuj GAEB. Po wysłaniu można wystawić korektę.',
  tourDetailCreditStatusTitle: 'Status', tourDetailCreditStatusText: 'Zmień status: Szkic → Wysłana → Zaakceptowana → Zapłacona. Usunięcie tylko w "Szkicu".',
  tourDetailCreditActionsTitle: 'Akcje', tourDetailCreditActionsText: 'Wyślij e-mail, pobierz PDF i e-fakturę. Korekta zawsze odnosi się do oryginalnej faktury.',
  tourDetailNotesTitle: 'Notatki i stopka', tourDetailNotesText: 'Notatki wewnętrzne, instrukcje płatności lub standardowe teksty widoczne na końcu dokumentu.',
  firstInvoice: 'Utworz pierwsza fakture.',
  firstCreditNote: 'Utworz pierwsza fakture korygujaca.',
  number: 'Numer',
  amount: 'Kwota',
  status: 'Status',
  details: 'Szczegoly',
  convertToInvoice: 'Konwertuj na fakture',
  createCreditNote: 'Utworz fakture korygujaca',
  createCreditNoteTitle: 'Utworz fakture korygujaca',
  createCreditNoteMessage: 'Utworz fakture korygujaca do faktury:',
  createCreditNoteError: 'Blad tworzenia faktury korigujacej',
  creditNoteCreated: 'Faktura korygujaca utworzona:',
  originalInvoice: 'Powiazana faktura',
  creditNoteInfoText: 'Tutaj mozesz zarzadzac fakturami korygujacymi.',
  creditNoteInfoItem1: 'Mozesz tworzyc faktury korygujace do istniejacych faktur lub tworzyc samodzielne faktury korygujace.',
  creditNoteInfoItem2: 'Faktury korygujace maja wlasna serie numerow (GS-...) i sa zarzadzane oddzielnie.',
  delete: 'Usun',
  confirmDelete: 'na pewno usunac?',
  deleteIrreversible: 'Tej operacji nie mozna cofnac.',
  offerDeleteHint: 'Oferta zostanie trwale usunieta.',
  invoiceDeleteHint: 'Faktura zostanie trwale usunieta.',
  deleteError: 'Blad usuwania',
  unknownError: 'Nieznany blad',
  loadError: 'Blad ladowania',
  saveError: 'Blad zapisu',
  deleteConfirm: 'Na pewno usunac?',
  lockedByOther: 'Aktualnie edytowane przez {name}',
  editLockedTooltip: 'Aktualnie edytowane przez {name}',
};
const documentsCs = {
  offerInfoText: 'Zde můžete spravovat své nabídky.',
  offerInfoItem1: 'Můžete vytvářet, upravovat a mazat nabídky.',
  offerInfoItem2: 'Můžete převádět nabídky na faktury.',
  offerInfoItem3: 'Můžete zobrazovat nabídky.',
  invoiceInfoText: 'Zde můžete spravovat své faktury.',
  invoiceInfoItem1: 'Můžete vytvářet, upravovat a mazat faktury.',
  invoiceInfoItem2: 'Můžete zobrazovat faktury.',
  edit: 'Upravit',
  sendByEmail: 'Poslat e-mailem',
  send: 'Odeslat',
  openPdf: 'Otevrit / stahnout PDF',
  downloadEInvoice: 'Stahnout e-fakturu ZUGFeRD 2.x (EN16931)',
  exportOffer: 'Export nabidky',
  exportAward: 'Export zakazky',
  exportMeasurement: 'Export vykazu',
  exportFinalInvoice: 'Export konecne faktury',
  customer: 'Zakaznik',
  vatId: 'DIC',
  date: 'Datum',
  due: 'Splatnost',
  validUntil: 'Platne do',
  paidOn: 'Zaplaceno dne',
  skonto: 'Skonto',
  total: 'Celkova castka',
  discount: 'Sleva',
  createdBy: 'Vytvoril',
  positions: 'Polozky',
  description: 'Popis',
  quantity: 'Mnozstvi',
  unit: 'Jednotka',
  unitPrice: 'Cena za jednotku',
  netSubtotal: 'Mezisoucet bez DPH',
  taxNotice: 'Danova poznamka',
  notes: 'Poznamky',
  footer: 'Paticka',
  recordPayment: 'Zaznamenat platbu',
  receivedAmount: 'Prijata castka',
  skontoWithin: 'pri platbe do',
  days: 'dnu',
  cancel: 'Zrusit',
  confirmPayment: 'Potvrdit platbu',
  changeStatus: 'Zmenit stav',
  setStatusTo: 'Nastavit stav na',
  change: 'Zmenit',
  statusChangedTo: 'Stav zmenen na',
  statusChangeNotPossible: 'Zmena stavu neni mozna',
  paymentRecorded: 'Platba zaznamenana',
  saveError: 'Chyba pri ukladani',
  accepted: 'prijato',
  notFound: 'Dokument nebyl nalezen',
  inclTax: 'vc.',
  vat: 'DPH',
  vatReverseCharge: 'DPH (reverse charge)',
  reverseChargeNote: 'Reverse charge - dan odvadi prijemce plneni.',
  convertToInvoiceTitle: 'Prevest na fakturu',
  convertToInvoiceMessage: 'Prevest nabidku na fakturu:',
  convertToInvoiceHint: 'Nabidka bude oznacena jako "Vyfakturovano".',
  createInvoice: 'Vytvorit fakturu',
  invoiceCreated: 'Faktura vytvorena:',
  convertError: 'Chyba pri prevodu',
  emailSent: 'E-mail byl uspesne odeslan',
  recipient: 'Prijemce',
  subject: 'Predmet',
  message: 'Zprava',
  messagePlaceholder: 'Vazeni, ...',
  openTestPreview: 'Otevrit testovaci nahled',
  sending: 'Odesilam...',
  sendError: 'Odeslani se nezdarilo',
  searchPlaceholder: 'Hledat podle cisla, zakaznika nebo projektu',
  allStatuses: 'Vsechny stavy',
  reset: 'Resetovat',
  results: 'vysledky',
  noOffers: 'Zadne nabidky',
  noInvoices: 'Zadne faktury',
  noCreditNotes: 'Zadne dobropisy',
  firstOffer: 'Vytvorte svou prvni nabidku.',
  startTour: 'Spustit průvodce',
  tourOfferFilterTitle: 'Filtr', tourOfferFilterText: 'Filtrujte nabídky podle čísla, zákazníka nebo stavu. Stavy: Koncept → Odesláno → Přijato / Odmítnuto / Vyfakturováno.',
  tourOfferTableTitle: 'Seznam nabídek', tourOfferTableText: 'Všechny nabídky s datem platnosti a stavem. Smazání je možné pouze ve stavu "Koncept".',
  tourOfferNewTitle: 'Vytvořit & převést nabídku', tourOfferNewText: 'Vytvořte novou nabídku. Přijatou nabídku lze jedním klikem převést na fakturu – všechny údaje se automaticky přenesou.',
  tourInvoiceTabsTitle: 'Faktury & dobropisy', tourInvoiceTabsText: 'Přepínejte mezi fakturami a dobropisy. Dobropisy opravují nebo ruší již odeslané faktury.',
  tourInvoiceFilterTitle: 'Filtr', tourInvoiceFilterText: 'Filtrujte podle čísla, zákazníka nebo stavu. Stavy: Koncept → Odesláno → Přijato → Zaplaceno / Stornováno.',
  tourInvoiceTableTitle: 'Seznam faktur', tourInvoiceTableText: 'Všechny faktury se splatností a stavem. Po splatnosti jsou červeně. Smazání jen ve stavu "Koncept".',
  tourInvoiceNewTitle: 'Nová faktura', tourInvoiceNewText: 'Vytvořte fakturu – přímo nebo z přijaté nabídky. Po přijetí platby nastavte stav na "Zaplaceno".',
  tourCreditNoteTabTitle: 'Dobropisy', tourCreditNoteTabText: 'Záložka zobrazuje všechny vystavené dobropisy. Dobropis opravuje nebo ruší již odeslanou fakturu.',
  tourCreditNoteFilterTitle: 'Filtr dobropisů', tourCreditNoteFilterText: 'Filtrujte dobropisy podle čísla, zákazníka nebo stavu. Stavy: Koncept → Odesláno → Přijato → Zaplaceno.',
  tourCreditNoteTableTitle: 'Seznam dobropisů', tourCreditNoteTableText: 'Všechny dobropisy s datem, částkou a stavem. Smazání pouze ve stavu "Koncept".',
  tourDetailMetaTitle: 'Záhlaví', tourDetailMetaOfferText: 'Zákazník, datum nabídky, platnost, celková částka a projekt.',
  tourDetailMetaInvoiceText: 'Zákazník, datum faktury, splatnost, celková částka a projekt. Po splatnosti zvýrazněno.',
  tourDetailMetaCreditText: 'Zákazník, datum, částka a odkaz na opravenou původní fakturu.',
  tourDetailPositionsTitle: 'Položky', tourDetailPositionsText: 'Všechny výkony a materiály s množstvím, jednotkovou cenou a celkem. Níže: netto, DPH a brutto.',
  tourDetailOfferStatusTitle: 'Stav', tourDetailOfferStatusText: 'Změna stavu: Koncept → Odesláno → Přijato / Odmítnuto. Smazání jen v "Konceptu". Po odeslání nelze vrátit zpět.',
  tourDetailOfferActionsTitle: 'Akce', tourDetailOfferActionsText: 'Odeslat e-mailem, otevřít PDF, exportovat GAEB. Po přijetí se zobrazí tlačítko "→ Vytvořit fakturu".',
  tourDetailInvoiceStatusTitle: 'Stav', tourDetailInvoiceStatusText: 'Změna stavu: Koncept → Odesláno → Přijato → Zaplaceno / Stornováno. Smazání jen v "Konceptu". "Zaplaceno" přes nabídku.',
  tourDetailInvoiceActionsTitle: 'Akce', tourDetailInvoiceActionsText: 'Odeslat e-mail, stáhnout PDF a e-fakturu (ZUGFeRD), exportovat GAEB. Po odeslání lze vystavit dobropis.',
  tourDetailCreditStatusTitle: 'Stav', tourDetailCreditStatusText: 'Změna stavu: Koncept → Odesláno → Přijato → Zaplaceno. Smazání jen v "Konceptu".',
  tourDetailCreditActionsTitle: 'Akce', tourDetailCreditActionsText: 'Odeslat e-mailem, stáhnout PDF a e-fakturu. Dobropis vždy odkazuje na původní fakturu.',
  tourDetailNotesTitle: 'Poznámky & zápatí', tourDetailNotesText: 'Interní poznámky, platební pokyny nebo standardní texty zobrazené na konci dokumentu.',
  firstInvoice: 'Vytvorte svou prvni fakturu.',
  firstCreditNote: 'Vytvorte svuj prvni dobropis.',
  number: 'Cislo',
  amount: 'Castka',
  status: 'Stav',
  details: 'Detaily',
  convertToInvoice: 'Prevest na fakturu',
  createCreditNote: 'Vytvorit dobropis',
  createCreditNoteTitle: 'Vytvorit dobropis',
  createCreditNoteMessage: 'Vytvorit dobropis k fakture:',
  createCreditNoteError: 'Chyba pri vytvareni dobropisu',
  creditNoteCreated: 'Dobropis vytvoren:',
  originalInvoice: 'Souvisejici faktura',
  creditNoteInfoText: 'Zde muzete spravovat sve dobropisy.',
  creditNoteInfoItem1: 'Muzete vytvaret dobropisy k existujicim fakturdam nebo vytvaret samostatne dobropisy.',
  creditNoteInfoItem2: 'Dobropisy maji vlastni radu cisel (GS-...) a jsou spravovany samostatne.',
  delete: 'Smazat',
  confirmDelete: 'opravdu smazat?',
  deleteIrreversible: 'Tuto akci nelze vratit.',
  offerDeleteHint: 'Nabidka bude trvale smazana.',
  invoiceDeleteHint: 'Faktura bude trvale smazana.',
  deleteError: 'Chyba pri mazani',
  unknownError: 'Neznama chyba',
  loadError: 'Chyba pri nacitani',
  saveError: 'Chyba pri ukladani',
  deleteConfirm: 'Opravdu smazat?',
  lockedByOther: 'Prave upravuje {name}',
  editLockedTooltip: 'Prave upravuje {name}',
};

const settingsDe = {
  subtitle: 'Firmendaten, Nummernkreise und Defaults',
  infoText: 'Hier kannst du die Standardeinstellungen für deinen Tenant festlegen, z.B. die Sprache der Benutzeroberfläche, Firmendaten, Nummernkreise und Standardwerte für neue Mitarbeiter.',
  infoItem1: 'Die Sprache der Benutzeroberfläche kann jederzeit geändert werden.',
  infoItem2: 'Firmendaten werden in Angeboten und Rechnungen angezeigt.',
  infoItem3: 'Für eine Nutzung von eRechnungen (ZUGFeRD/Factur-X) müssen die Bankdaten eingetragen werden.',
  infoItem4: 'Nummernkreise werden automatisch vergeben. Du kannst zwischen fortlaufender oder jahresbasierter Nummerierung wählen.',
  infoItem5: 'Standardwerte werden für neue Mitarbeiter, in Angeboten oder in Rechnungen vorgeschlagen, können aber individuell angepasstt werden. Die Mehrwertsteuer ist hiervon ausgeschlossen.',
  languageTitle: 'Sprache',
  languageHint: 'Wähle die Sprache der Benutzeroberfläche.',
  companyData: 'Firmendaten',
  companyName: 'Firmenname',
  companyNamePlaceholder: 'Muster GmbH',
  managingDirector: 'Geschaeftsführer',
  taxNumber: 'Steuernummer',
  accentColor: 'Akzentfarbe',
  pdfHeader: 'PDF-Briefkopf',
  pdfHeaderHint: 'Logo wird auf allen Angeboten, Rechnungen und Rapports angezeigt.',
  pdfLogo: 'Firmenlogo',
  pdfLogoHint: 'PNG oder JPG, max. 500 KB. Klicken oder Datei hierher ziehen.',
  pdfLogoPosition: 'Logo-Position',
  pdfLogoLeft: 'Links',
  pdfLogoCenter: 'Mitte',
  pdfLogoRight: 'Rechts',
  pdfPreview: 'Vorschau',
  pdfLogoRemove: 'Logo entfernen',
  pdfLogoTooLarge: 'Die Datei ist zu groß (max. 500 KB).',
  pdfLogoInvalid: 'Bitte eine PNG- oder JPG-Datei hochladen.',
  pdfEditHeader: 'Briefkopf gestalten',
  pdfColors: 'Akzentfarben',
  pdfColorOffer: 'Angebot',
  pdfColorInvoice: 'Rechnung',
  pdfColorRapport: 'Rapport', pdfColorAufmass: 'Aufmaß',
  bankAndEInvoice: 'Bankverbindung & eRechnung',
  bankAndEInvoiceHint: 'Wird im ZUGFeRD/Factur-X XML als Zahlungsinformation eingebettet.',
  bankName: 'Kreditinstitut',
  accountHolder: 'Kontoinhaber',
  numberRanges: 'Nummernkreise',
  numberRangesHint: 'Nummern werden automatisch vergeben. Wähle zwischen fortlaufender oder jahresbasierter Nummerierung.',
  range: 'Bereich',
  prefix: 'Präfix',
  yearlyReset: 'Jahresreset',
  yearFormat: 'Jahr-Format',
  separator: 'Trennzeichen',
  padding: 'Stellen',
  startNr: 'Start-Nr.',
  startNrHint: 'Beginnt bei dieser Nummer im ersten Jahr dieses Nummernkreises (z.B. bei einem Systemwechsel). Jedes weitere Jahr beginnt wieder bei 1.',
  preview: 'Vorschau',
  prefixPlaceholder: 'z.B. RE-',
  yearlyRestart: 'Jedes Jahr neu beginnen',
  sequentialNumbering: 'Fortlaufende Nummerierung',
  sequentialNumberingHint: 'Präfix + laufende Nummer + Suffix (z.B. RE-0001)',
  yearlyNumbering: 'Jahresbasierte Nummerierung',
  yearlyNumberingHint: 'Präfix + Jahr + Separator + laufende Nummer + Suffix (z.B. RE-2026-0001)',
  yearlyResetWarning: 'Bei Jahresreset beginnt die Nummerierung jedes Jahr wieder bei 1',
  defaults: 'Standard-Werte',
  defaultWeeklyHours: 'Standard-Wochenstunden',
  defaultVacationDays: 'Standard-Urlaubstage',
  forNewEmployees: 'Für neue Mitarbeiter',
  vatPercent: 'Mehrwertsteuer (%)',
  payrollDatev: 'Lohnverarbeitung & DATEV',
  stateForHolidays: 'Region (für Feiertage)',
  countryForHolidays: 'Land (für Feiertage)',
  collectiveAgreement: 'Tarifvertrag',
  brtvBauEnabled: 'BRTV-Bau aktivieren',
  defaultKmRate: 'Standard KM-Satz', defaultKmRatePlaceholder: 'z.B. 0,35',
  startTour: 'Führung starten',
  tourLanguageTitle: 'Sprache', tourLanguageText: 'Deine persönliche Spracheinstellung für die Benutzeroberfläche.',
  tourCompanyTitle: 'Firmendaten', tourCompanyText: 'Name, Adresse, Kontakt, Steuernummer, USt-IdNr., Gewerk und Akzentfarbe der Anwendung.',
  tourPdfTitle: 'PDF-Briefkopf', tourPdfText: 'Logo und Briefkopf für Angebote, Rechnungen und Rapporte individuell gestalten.',
  tourPdfModalTitle: 'Briefkopf gestalten', tourPdfModalText: 'Für jeden Dokumenttyp eigenes Logo und eigene Farben wählen. Eine Live-Vorschau zeigt das Ergebnis direkt.',
  tourBankTitle: 'Bank & E-Rechnung', tourBankText: 'IBAN, BIC und Bankdaten für ZUGFeRD/E-Rechnung – werden automatisch in Rechnungen eingebettet.',
  tourNumbersTitle: 'Nummernkreise', tourNumbersText: 'Präfix, Suffix, Startnummer und Padding für Projekte, Rechnungen, Angebote und mehr. Bei jährlichem Reset gilt die Startnummer nur im ersten Jahr (z.B. nach einem Systemwechsel) – danach beginnt die Zählung wieder bei 1.',
  tourDefaultsTitle: 'Standardwerte', tourDefaultsText: 'Wochenstunden, Urlaubstage, Standard-MwSt. und Währung als Vorgabe für neue Einträge.',
  tourPayrollTitle: 'Lohn & DATEV', tourPayrollText: 'Bundesland für Feiertage, BRTV-Bau-Modus und DATEV-Zugangsdaten für den Lohnexport.',
  tourIdsTitle: 'IDS Connect', tourIdsText: 'Lieferanten für IDS Connect hinterlegen – damit können Artikel direkt aus dem Lieferantenkatalog ins Materiallager übernommen werden.',
  tourIdsModalTitle: 'IDS-Lieferant anlegen', tourIdsModalText: 'Name, Katalog-URL und optionale Zugangsdaten. Nach dem Speichern erscheint der Lieferant im Materialmodul als IDS Connect-Option.',
  trade: 'Gewerk',
  tradeNone: 'Kein Gewerk / Allgemein',
  trades: {
    general: 'Allgemeiner Bau / Generalunternehmer',
    maler: 'Maler & Lackierer',
    zimmerer: 'Zimmerer',
    dachdecker: 'Dachdecker',
    elektriker: 'Elektriker / Elektrotechnik',
    shk: 'Sanitär, Heizung & Klima',
    fliesenleger: 'Fliesenleger',
    trockenbau: 'Trockenbau',
    estrich: 'Estrichleger',
    bodenleger: 'Bodenleger / Parkettleger',
    schreiner: 'Schreiner / Tischler',
    fenster: 'Fenster & Türen',
    landschaftsgaertner: 'Garten- & Landschaftsbau (GaLaBau)',
  },
  brtvBauHint: 'Automatisch 41h (April-November) und 39h (Dezember-Maerz) in der Lohnverarbeitung.',
  datevConsultant: 'DATEV Beraternummer',
  datevMandant: 'DATEV Mandantennummer',
  idsTitle: 'IDS Connect / OCI Punchout',
  idsHint: 'Lieferanten-Kataloge direkt aus dem ERP aufrufen und Artikel übernehmen.',
  supplier: 'Lieferant',
  noIdsSuppliers: 'Noch keine IDS-Lieferanten konfiguriert.',
  username: 'Benutzer',
  editSupplier: 'Lieferant bearbeiten',
  newIdsSupplier: 'Neuer IDS-Lieferant',
  idsNamePlaceholder: 'z.B. Würth Online',
  ociLaunchUrl: 'OCI Launch-URL',
  ociLaunchHint: 'Die vom Lieferanten bereitgestellte OCI-Startadresse',
  leaveUnchanged: '(unverändert lassen)',
  activeForCatalog: 'Aktiv (für Katalog-Aufruf verfügbar)',
  emailSenderTitle: 'E-Mail-Absender',
  emailSenderHint: 'Absender für Angebote und Rechnungen dieses Tenants.',
  emailFromAddress: 'Absender-E-Mail',
  emailFromName: 'Absender-Name',
  smtpHost: 'SMTP Host',
  smtpPort: 'SMTP Port',
  smtpUser: 'SMTP Benutzer',
  smtpPassword: 'SMTP Passwort',
  smtpPasswordSetHint: 'Passwort ist gesetzt (nur bei Änderung neu eingeben)',
  smtpSecure: 'TLS/SSL (secure)',
  smtpTest: 'SMTP testen',
  smtpTesting: 'Teste SMTP…',
  smtpTestSuccess: 'SMTP-Verbindung erfolgreich',
  smtpTestError: 'SMTP-Test fehlgeschlagen',
  imapHost: 'IMAP Host',
  imapPort: 'IMAP Port',
  imapUser: 'IMAP Benutzer',
  imapPassword: 'IMAP Passwort',
  imapPasswordSetHint: 'Passwort ist gesetzt (nur bei Änderung neu eingeben)',
  imapSentMailbox: 'Sent-Ordner',
  imapSecure: 'TLS/SSL (secure)',
  imapTest: 'IMAP testen',
  imapTesting: 'Teste IMAP…',
  imapTestSuccess: 'IMAP-Verbindung erfolgreich',
  imapTestError: 'IMAP-Test fehlgeschlagen',
  add: 'Hinzufügen',
  unsavedChanges: 'Ungespeicherte Änderungen',
  saved: 'Einstellungen gespeichert',
  nameUrlRequired: 'Name und URL sind erforderlich',
  supplierSaved: 'Lieferant gespeichert',
  supplierDeleted: 'Lieferant gelöscht',
  deleteSupplierConfirm: 'Lieferant wirklich löschen?'
};

const settingsEn = {
  subtitle: 'Company data, numbering ranges and defaults',
  infoText: 'Here you can set the default settings for your tenant, e.g. the language of the user interface, company data, numbering ranges and default values for new employees.',
  infoItem1: 'The language of the user interface can be changed at any time.',
  infoItem2: 'Company data is displayed in offers and invoices.',
  infoItem3: 'For using e-invoices (ZUGFeRD/Factur-X), bank details must be entered.',
  infoItem4: 'Numbering ranges are assigned automatically. You can choose between sequential or year-based numbering.',
  infoItem5: 'Default values are suggested for new employees, in offers or in invoices, but can be adjusted individually. VAT is excluded from this.',
  languageTitle: 'Language',
  languageHint: 'Choose the interface language.',
  companyData: 'Company data',
  companyName: 'Company name',
  companyNamePlaceholder: 'Sample Ltd.',
  managingDirector: 'Managing director',
  taxNumber: 'Tax number',
  accentColor: 'Accent color',
  pdfHeader: 'PDF letterhead',
  pdfHeaderHint: 'Logo is shown on all offers, invoices and reports.',
  pdfLogo: 'Company logo',
  pdfLogoHint: 'PNG or JPG, max. 500 KB. Click or drag file here.',
  pdfLogoPosition: 'Logo position',
  pdfLogoLeft: 'Left',
  pdfLogoCenter: 'Center',
  pdfLogoRight: 'Right',
  pdfPreview: 'Preview',
  pdfLogoRemove: 'Remove logo',
  pdfLogoTooLarge: 'File is too large (max. 500 KB).',
  pdfLogoInvalid: 'Please upload a PNG or JPG file.',
  pdfEditHeader: 'Edit letterhead',
  pdfColors: 'Accent colors', pdfColorOffer: 'Offer', pdfColorInvoice: 'Invoice', pdfColorRapport: 'Report', pdfColorAufmass: 'Measurement',
  bankAndEInvoice: 'Bank details & e-invoice',
  bankAndEInvoiceHint: 'Embedded as payment information in ZUGFeRD/Factur-X XML.',
  bankName: 'Bank name',
  accountHolder: 'Account holder',
  numberRanges: 'Number ranges',
  numberRangesHint: 'Numbers are assigned automatically. Choose sequential or year-based numbering.',
  range: 'Range',
  prefix: 'Prefix',
  yearlyReset: 'Yearly reset',
  yearFormat: 'Year format',
  separator: 'Separator',
  padding: 'Digits',
  startNr: 'Start no.',
  startNrHint: 'Numbering starts at this value in the first year of this range (e.g. when switching systems). Every following year still restarts at 1.',
  preview: 'Preview',
  prefixPlaceholder: 'e.g. INV-',
  yearlyRestart: 'Restart each year',
  sequentialNumbering: 'Sequential numbering',
  sequentialNumberingHint: 'Prefix + running number + suffix (e.g. INV-0001)',
  yearlyNumbering: 'Year-based numbering',
  yearlyNumberingHint: 'Prefix + year + separator + running number + suffix (e.g. INV-2026-0001)',
  yearlyResetWarning: 'With yearly reset, numbering starts again at 1 every year',
  defaults: 'Default values',
  defaultWeeklyHours: 'Default weekly hours',
  defaultVacationDays: 'Default vacation days',
  forNewEmployees: 'For new employees',
  vatPercent: 'VAT (%)',
  payrollDatev: 'Payroll & DATEV',
  stateForHolidays: 'Region (for holidays)',
  countryForHolidays: 'Country (for holidays)',
  collectiveAgreement: 'Collective agreement',
  brtvBauEnabled: 'Enable BRTV Construction',
  defaultKmRate: 'Default KM rate', defaultKmRatePlaceholder: 'e.g. 0.35',
  startTour: 'Start tour',
  tourLanguageTitle: 'Language', tourLanguageText: 'Your personal language setting for the user interface.',
  tourCompanyTitle: 'Company data', tourCompanyText: 'Name, address, contact, tax number, VAT ID, trade, and application accent colour.',
  tourPdfTitle: 'PDF header', tourPdfText: 'Customise logo and letterhead for offers, invoices and rapports individually.',
  tourPdfModalTitle: 'Design letterhead', tourPdfModalText: 'Choose a separate logo and colours for each document type. A live preview shows the result immediately.',
  tourBankTitle: 'Bank & e-invoice', tourBankText: 'IBAN, BIC and bank details for ZUGFeRD/e-invoice – embedded automatically in invoices.',
  tourNumbersTitle: 'Number ranges', tourNumbersText: 'Prefix, suffix, start number and padding for projects, invoices, offers and more. For ranges with yearly reset, the start number only applies in the first year (e.g. after switching systems) – every following year still restarts at 1.',
  tourDefaultsTitle: 'Default values', tourDefaultsText: 'Weekly hours, vacation days, default VAT rate and currency as defaults for new entries.',
  tourPayrollTitle: 'Payroll & DATEV', tourPayrollText: 'Federal state for public holidays, BRTV construction mode, and DATEV credentials for payroll export.',
  tourIdsTitle: 'IDS Connect', tourIdsText: 'Add suppliers for IDS Connect – so articles can be imported directly from the supplier catalogue into the material warehouse.',
  tourIdsModalTitle: 'Add IDS supplier', tourIdsModalText: 'Name, catalogue URL and optional credentials. After saving the supplier appears in the material module as an IDS Connect option.',
  trade: 'Trade',
  tradeNone: 'No trade / General',
  trades: {
    general: 'General Construction / Main Contractor',
    maler: 'Painter & Decorator',
    zimmerer: 'Carpenter / Timber Framer',
    dachdecker: 'Roofer',
    elektriker: 'Electrician',
    shk: 'Plumbing, Heating & HVAC',
    fliesenleger: 'Tiler',
    trockenbau: 'Drywall / Partition',
    estrich: 'Screed Layer',
    bodenleger: 'Floor Layer / Parquet',
    schreiner: 'Joiner / Cabinet Maker',
    fenster: 'Windows & Doors',
    landschaftsgaertner: 'Landscaping & Grounds (GaLaBau)',
  },
  brtvBauHint: 'Automatically applies 41h (Apr-Nov) and 39h (Dec-Mar) in payroll.',
  datevConsultant: 'DATEV consultant number',
  datevMandant: 'DATEV client number',
  idsTitle: 'IDS Connect / OCI Punchout',
  idsHint: 'Open supplier catalogs directly from ERP and transfer items.',
  supplier: 'Supplier',
  noIdsSuppliers: 'No IDS suppliers configured yet.',
  username: 'Username',
  editSupplier: 'Edit supplier',
  newIdsSupplier: 'New IDS supplier',
  idsNamePlaceholder: 'e.g. Wuerth Online',
  ociLaunchUrl: 'OCI launch URL',
  ociLaunchHint: 'OCI launch address provided by the supplier',
  leaveUnchanged: '(leave unchanged)',
  activeForCatalog: 'Active (available for catalog launch)',
  emailSenderTitle: 'Email sender',
  emailSenderHint: 'Sender used for this tenant\'s offers and invoices.',
  emailFromAddress: 'From email',
  emailFromName: 'From name',
  smtpHost: 'SMTP host',
  smtpPort: 'SMTP port',
  smtpUser: 'SMTP user',
  smtpPassword: 'SMTP password',
  smtpPasswordSetHint: 'Password is set (enter only to change)',
  smtpSecure: 'TLS/SSL (secure)',
  smtpTest: 'Test SMTP',
  smtpTesting: 'Testing SMTP…',
  smtpTestSuccess: 'SMTP connection successful',
  smtpTestError: 'SMTP test failed',
  imapHost: 'IMAP host',
  imapPort: 'IMAP port',
  imapUser: 'IMAP user',
  imapPassword: 'IMAP password',
  imapPasswordSetHint: 'Password is set (enter only to change)',
  imapSentMailbox: 'Sent mailbox',
  imapSecure: 'TLS/SSL (secure)',
  imapTest: 'Test IMAP',
  imapTesting: 'Testing IMAP…',
  imapTestSuccess: 'IMAP connection successful',
  imapTestError: 'IMAP test failed',
  add: 'Add',
  unsavedChanges: 'Unsaved changes',
  saved: 'Settings saved',
  nameUrlRequired: 'Name and URL are required',
  supplierSaved: 'Supplier saved',
  supplierDeleted: 'Supplier deleted',
  deleteSupplierConfirm: 'Delete supplier?'
};

const settingsFr = {
  subtitle: 'Donnees entreprise, plages de numerotation et valeurs par defaut',
  infoText: 'Ici, vous pouvez definir les parametres par defaut pour votre tenant, p.ex. la langue de l\'interface utilisateur, les donnees de l\'entreprise, les plages de numerotation et les valeurs par defaut pour les nouveaux employes.',
  infoItem1: 'La langue de l\'interface utilisateur peut etre modifiee a tout moment.',
  infoItem2: 'Les donnees de l\'entreprise sont affichees dans les offres et les factures.',
  infoItem3: 'Pour une utilisation des e-factures (ZUGFeRD/Factur-X), les donnees bancaires doivent etre saisies.',
  infoItem4: 'Les plages de numerotation sont attribuees automatiquement. Vous pouvez choisir entre une numerotation continue ou annuelle.',
  infoItem5: 'Les valeurs par defaut sont suggerees pour les nouveaux employes, dans les offres ou dans les factures, mais peuvent etre ajustees individuellement. La TVA est exclue de cela.',
  languageTitle: 'Langue',
  languageHint: "Choisissez la langue de l'interface.",
  companyData: 'Donnees entreprise',
  companyName: 'Nom de la societe',
  companyNamePlaceholder: 'Societe Exemple',
  managingDirector: 'Gerant',
  taxNumber: 'Numero fiscal',
  accentColor: "Couleur d'accent",
  pdfHeader: 'En-tête PDF',
  pdfHeaderHint: 'Le logo apparaît sur tous les devis, factures et rapports.',
  pdfLogo: 'Logo entreprise',
  pdfLogoHint: 'PNG ou JPG, max. 500 Ko. Cliquer ou déposer le fichier ici.',
  pdfLogoPosition: 'Position du logo',
  pdfLogoLeft: 'Gauche',
  pdfLogoCenter: 'Centre',
  pdfLogoRight: 'Droite',
  pdfPreview: 'Aperçu',
  pdfLogoRemove: 'Supprimer le logo',
  pdfLogoTooLarge: 'Fichier trop volumineux (max. 500 Ko).',
  pdfLogoInvalid: 'Veuillez télécharger un fichier PNG ou JPG.',
  pdfEditHeader: "Modifier l'en-tête",
  pdfColors: 'Couleurs accent', pdfColorOffer: 'Devis', pdfColorInvoice: 'Facture', pdfColorRapport: 'Rapport', pdfColorAufmass: 'Métré',
  bankAndEInvoice: 'Coordonnees bancaires & e-facture',
  bankAndEInvoiceHint: 'Integre dans le XML ZUGFeRD/Factur-X comme information de paiement.',
  bankName: 'Banque',
  accountHolder: 'Titulaire du compte',
  numberRanges: 'Plages de numerotation',
  numberRangesHint: 'Les numeros sont attribues automatiquement. Choisissez numerotation continue ou annuelle.',
  range: 'Domaine',
  prefix: 'Prefixe',
  yearlyReset: 'Reinitialisation annuelle',
  yearFormat: 'Format annee',
  separator: 'Separateur',
  padding: 'Chiffres',
  startNr: 'N° de depart',
  startNrHint: 'La numerotation commence a cette valeur la premiere annee de ce cycle (p.ex. lors d\'un changement de systeme). Les annees suivantes redemarrent toujours a 1.',
  preview: 'Apercu',
  prefixPlaceholder: 'p.ex. FAC-',
  yearlyRestart: 'Redemarrer chaque annee',
  sequentialNumbering: 'Numerotation continue',
  sequentialNumberingHint: 'Prefixe + numero courant + suffixe (p.ex. FAC-0001)',
  yearlyNumbering: 'Numerotation annuelle',
  yearlyNumberingHint: 'Prefixe + annee + separateur + numero courant + suffixe (p.ex. FAC-2026-0001)',
  yearlyResetWarning: 'Avec reinitialisation annuelle, la numerotation repart a 1 chaque annee',
  defaults: 'Valeurs par defaut',
  defaultWeeklyHours: 'Heures hebdomadaires par defaut',
  defaultVacationDays: 'Jours de conges par defaut',
  forNewEmployees: 'Pour les nouveaux employes',
  vatPercent: 'TVA (%)',
  payrollDatev: 'Paie & DATEV',
  stateForHolidays: 'Region (jours feries)',
  countryForHolidays: 'Pays (jours feries)',
  collectiveAgreement: 'Convention collective',
  brtvBauEnabled: 'Activer la convention BRTV BTP',
  defaultKmRate: 'Tarif km par défaut', defaultKmRatePlaceholder: 'ex. 0,35',
  startTour: 'Lancer la visite guidée',
  tourLanguageTitle: 'Langue', tourLanguageText: 'Votre paramètre de langue personnel pour l\'interface utilisateur.',
  tourCompanyTitle: 'Données entreprise', tourCompanyText: 'Nom, adresse, contact, numéro fiscal, TVA intracommunautaire, corps de métier et couleur d\'accentuation.',
  tourPdfTitle: 'En-tête PDF', tourPdfText: 'Personnaliser logo et en-tête pour offres, factures et rapports individuellement.',
  tourPdfModalTitle: 'Créer l\'en-tête', tourPdfModalText: 'Choisir un logo et des couleurs distincts par type de document. Un aperçu en direct affiche le résultat.',
  tourBankTitle: 'Banque & e-facture', tourBankText: 'IBAN, BIC et coordonnées bancaires pour ZUGFeRD/e-facture – intégrés automatiquement.',
  tourNumbersTitle: 'Plages de numéros', tourNumbersText: 'Préfixe, suffixe, numéro de départ et padding pour projets, factures, offres et plus. Pour les plages avec réinitialisation annuelle, le numéro de départ ne s\'applique que la première année (p.ex. après un changement de système) – les années suivantes repartent ensuite à 1.',
  tourDefaultsTitle: 'Valeurs par défaut', tourDefaultsText: 'Heures hebdomadaires, jours de congés, TVA par défaut et devise comme valeurs initiales.',
  tourPayrollTitle: 'Paie & DATEV', tourPayrollText: 'État fédéral pour les jours fériés, mode BRTV BTP et identifiants DATEV pour l\'export de paie.',
  tourIdsTitle: 'IDS Connect', tourIdsText: 'Ajoutez des fournisseurs IDS Connect – les articles peuvent ainsi être importés directement du catalogue fournisseur.',
  tourIdsModalTitle: 'Ajouter fournisseur IDS', tourIdsModalText: 'Nom, URL du catalogue et identifiants optionnels. Après enregistrement le fournisseur apparaît dans le module matériaux.',
  trade: 'Corps de métier',
  tradeNone: 'Aucun métier / Général',
  trades: {
    general: 'Construction générale / Entreprise générale',
    maler: 'Peintre',
    zimmerer: 'Charpentier',
    dachdecker: 'Couvreur',
    elektriker: 'Électricien',
    shk: 'Plomberie, chauffage & climatisation',
    fliesenleger: 'Carreleur',
    trockenbau: 'Cloisons sèches',
    estrich: 'Chape',
    bodenleger: 'Parqueteur / Poseur de revêtements',
    schreiner: 'Menuisier / Ébéniste',
    fenster: 'Fenêtres & portes',
    landschaftsgaertner: 'Paysagisme & aménagement extérieur',
  },
  brtvBauHint: 'Applique automatiquement 41h (avr-nov) et 39h (dec-mar) dans la paie.',
  datevConsultant: 'Numero conseiller DATEV',
  datevMandant: 'Numero client DATEV',
  idsTitle: 'IDS Connect / OCI Punchout',
  idsHint: 'Ouvrir les catalogues fournisseurs depuis ERP et reprendre les articles.',
  supplier: 'Fournisseur',
  noIdsSuppliers: 'Aucun fournisseur IDS configure.',
  username: "Nom d'utilisateur",
  editSupplier: 'Modifier fournisseur',
  newIdsSupplier: 'Nouveau fournisseur IDS',
  idsNamePlaceholder: 'p.ex. Wuerth Online',
  ociLaunchUrl: 'URL de lancement OCI',
  ociLaunchHint: 'Adresse OCI fournie par le fournisseur',
  leaveUnchanged: '(laisser inchange)',
  activeForCatalog: 'Actif (disponible pour ouverture catalogue)',
  emailSenderTitle: 'Expediteur e-mail',
  emailSenderHint: 'Expediteur utilise pour les offres et factures de ce tenant.',
  emailFromAddress: 'E-mail expediteur',
  emailFromName: 'Nom expediteur',
  smtpHost: 'Hote SMTP',
  smtpPort: 'Port SMTP',
  smtpUser: 'Utilisateur SMTP',
  smtpPassword: 'Mot de passe SMTP',
  smtpPasswordSetHint: 'Mot de passe defini (saisir uniquement pour modifier)',
  smtpSecure: 'TLS/SSL (secure)',
  smtpTest: 'Tester SMTP',
  smtpTesting: 'Test SMTP…',
  smtpTestSuccess: 'Connexion SMTP reussie',
  smtpTestError: 'Echec du test SMTP',
  imapHost: 'Hote IMAP',
  imapPort: 'Port IMAP',
  imapUser: 'Utilisateur IMAP',
  imapPassword: 'Mot de passe IMAP',
  imapPasswordSetHint: 'Mot de passe defini (saisir uniquement pour modifier)',
  imapSentMailbox: 'Dossier envoyes',
  imapSecure: 'TLS/SSL (secure)',
  imapTest: 'Tester IMAP',
  imapTesting: 'Test IMAP…',
  imapTestSuccess: 'Connexion IMAP reussie',
  imapTestError: 'Echec du test IMAP',
  add: 'Ajouter',
  unsavedChanges: 'Modifications non enregistrees',
  saved: 'Parametres enregistres',
  nameUrlRequired: 'Nom et URL sont obligatoires',
  supplierSaved: 'Fournisseur enregistre',
  supplierDeleted: 'Fournisseur supprime',
  deleteSupplierConfirm: 'Supprimer le fournisseur ?'
};

const settingsIt = {
  subtitle: 'Dati azienda, intervalli numerazione e valori predefiniti',
  infoText: 'Qui puoi impostare le impostazioni predefinite per il tuo tenant, ad es. la lingua dell\'interfaccia utente, i dati aziendali, gli intervalli di numerazione e i valori predefiniti per i nuovi dipendenti.',
  infoItem1: 'La lingua dell\'interfaccia utente può essere modificata in qualsiasi momento.',
  infoItem2: 'I dati aziendali vengono visualizzati nelle offerte e nelle fatture.',
  infoItem3: 'Per utilizzare le e-fatture (ZUGFeRD/Factur-X), è necessario inserire i dati bancari.',
  infoItem4: 'Gli intervalli di numerazione vengono assegnati automaticamente. Puoi scegliere tra numerazione progressiva o basata sull\'anno.',
  infoItem5: 'I valori predefiniti vengono suggeriti per i nuovi dipendenti, nelle offerte o nelle fatture, ma possono essere regolati individualmente. L\'IVA è esclusa da questo.',
  languageTitle: 'Lingua',
  languageHint: "Scegli la lingua dell'interfaccia.",
  companyData: 'Dati azienda',
  companyName: 'Nome azienda',
  companyNamePlaceholder: 'Azienda Esempio',
  managingDirector: 'Amministratore',
  taxNumber: 'Codice fiscale',
  accentColor: 'Colore accento',
  pdfHeader: 'Intestazione PDF',
  pdfHeaderHint: 'Il logo viene mostrato su tutti i preventivi, fatture e rapporti.',
  pdfLogo: 'Logo aziendale',
  pdfLogoHint: 'PNG o JPG, max. 500 KB. Clicca o trascina il file qui.',
  pdfLogoPosition: 'Posizione logo',
  pdfLogoLeft: 'Sinistra',
  pdfLogoCenter: 'Centro',
  pdfLogoRight: 'Destra',
  pdfPreview: 'Anteprima',
  pdfLogoRemove: 'Rimuovi logo',
  pdfLogoTooLarge: 'File troppo grande (max. 500 KB).',
  pdfLogoInvalid: 'Carica un file PNG o JPG.',
  pdfEditHeader: 'Modifica intestazione',
  pdfColors: 'Colori accento', pdfColorOffer: 'Preventivo', pdfColorInvoice: 'Fattura', pdfColorRapport: 'Rapporto', pdfColorAufmass: 'Computo',
  bankAndEInvoice: 'Dati bancari & fattura elettronica',
  bankAndEInvoiceHint: 'Inserito nel XML ZUGFeRD/Factur-X come informazione di pagamento.',
  bankName: 'Banca',
  accountHolder: 'Intestatario conto',
  numberRanges: 'Intervalli numerazione',
  numberRangesHint: 'I numeri sono assegnati automaticamente. Scegli numerazione progressiva o annuale.',
  range: 'Ambito',
  prefix: 'Prefisso',
  yearlyReset: 'Reset annuale',
  yearFormat: 'Formato anno',
  separator: 'Separatore',
  padding: 'Cifre',
  startNr: 'N. iniziale',
  startNrHint: 'La numerazione inizia da questo valore nel primo anno di questo intervallo (es. al passaggio da un altro sistema). Gli anni successivi ripartono comunque da 1.',
  preview: 'Anteprima',
  prefixPlaceholder: 'es. FAT-',
  yearlyRestart: 'Ricomincia ogni anno',
  sequentialNumbering: 'Numerazione progressiva',
  sequentialNumberingHint: 'Prefisso + numero progressivo + suffisso (es. FAT-0001)',
  yearlyNumbering: 'Numerazione annuale',
  yearlyNumberingHint: 'Prefisso + anno + separatore + numero progressivo + suffisso (es. FAT-2026-0001)',
  yearlyResetWarning: 'Con reset annuale la numerazione riparte da 1 ogni anno',
  defaults: 'Valori predefiniti',
  defaultWeeklyHours: 'Ore settimanali predefinite',
  defaultVacationDays: 'Giorni ferie predefiniti',
  forNewEmployees: 'Per nuovi dipendenti',
  vatPercent: 'IVA (%)',
  payrollDatev: 'Paghe & DATEV',
  stateForHolidays: 'Regione (festivita)',
  countryForHolidays: 'Paese (festivita)',
  collectiveAgreement: 'Contratto collettivo',
  brtvBauEnabled: 'Attiva BRTV Edilizia',
  defaultKmRate: 'Tariffa km predefinita', defaultKmRatePlaceholder: 'es. 0,35',
  startTour: 'Avvia la guida',
  tourLanguageTitle: 'Lingua', tourLanguageText: 'La tua impostazione personale della lingua per l\'interfaccia utente.',
  tourCompanyTitle: 'Dati aziendali', tourCompanyText: 'Nome, indirizzo, contatto, partita IVA, settore e colore di accento dell\'applicazione.',
  tourPdfTitle: 'Intestazione PDF', tourPdfText: 'Personalizzare logo e intestazione per offerte, fatture e rapporti individualmente.',
  tourPdfModalTitle: 'Progettare intestazione', tourPdfModalText: 'Scegliere logo e colori distinti per tipo di documento. Un\'anteprima in tempo reale mostra il risultato.',
  tourBankTitle: 'Banca & e-fattura', tourBankText: 'IBAN, BIC e coordinate bancarie per ZUGFeRD/e-fattura – incorporati automaticamente.',
  tourNumbersTitle: 'Intervalli numerici', tourNumbersText: 'Prefisso, suffisso, numero iniziale e padding per progetti, fatture, offerte e altro. Per gli intervalli con reset annuale, il numero iniziale si applica solo al primo anno (es. dopo un cambio di sistema) – gli anni successivi ripartono comunque da 1.',
  tourDefaultsTitle: 'Valori predefiniti', tourDefaultsText: 'Ore settimanali, giorni ferie, IVA predefinita e valuta come valori di partenza.',
  tourPayrollTitle: 'Retribuzioni & DATEV', tourPayrollText: 'Stato federale per le festività, modalità BRTV edilizia e credenziali DATEV per l\'export paghe.',
  tourIdsTitle: 'IDS Connect', tourIdsText: 'Aggiungi fornitori IDS Connect – gli articoli possono così essere importati direttamente dal catalogo fornitore.',
  tourIdsModalTitle: 'Aggiungi fornitore IDS', tourIdsModalText: 'Nome, URL catalogo e credenziali opzionali. Dopo il salvataggio il fornitore appare nel modulo materiali.',
  trade: 'Settore',
  tradeNone: 'Nessun settore / Generale',
  trades: {
    general: 'Edilizia generale / Appaltatore generale',
    maler: 'Pittore',
    zimmerer: 'Carpentiere',
    dachdecker: 'Lattoniere / Impermeabilizzatore',
    elektriker: 'Elettricista',
    shk: 'Idraulica, riscaldamento & climatizzazione',
    fliesenleger: 'Piastrellista',
    trockenbau: 'Cartongesso / Pareti divisorie',
    estrich: 'Massetto',
    bodenleger: 'Posatore pavimenti / Parquet',
    schreiner: 'Falegname',
    fenster: 'Finestre & porte',
    landschaftsgaertner: 'Giardinaggio & sistemazione esterna',
  },
  brtvBauHint: 'Applica automaticamente 41h (apr-nov) e 39h (dic-mar) nelle paghe.',
  datevConsultant: 'Numero consulente DATEV',
  datevMandant: 'Numero cliente DATEV',
  idsTitle: 'IDS Connect / OCI Punchout',
  idsHint: 'Apri cataloghi fornitori da ERP e importa articoli.',
  supplier: 'Fornitore',
  noIdsSuppliers: 'Nessun fornitore IDS configurato.',
  username: 'Username',
  editSupplier: 'Modifica fornitore',
  newIdsSupplier: 'Nuovo fornitore IDS',
  idsNamePlaceholder: 'es. Wuerth Online',
  ociLaunchUrl: 'URL avvio OCI',
  ociLaunchHint: 'Indirizzo OCI fornito dal fornitore',
  leaveUnchanged: '(lascia invariato)',
  activeForCatalog: 'Attivo (disponibile per avvio catalogo)',
  emailSenderTitle: 'Mittente e-mail',
  emailSenderHint: 'Mittente usato per offerte e fatture di questo tenant.',
  emailFromAddress: 'E-mail mittente',
  emailFromName: 'Nome mittente',
  smtpHost: 'Host SMTP',
  smtpPort: 'Porta SMTP',
  smtpUser: 'Utente SMTP',
  smtpPassword: 'Password SMTP',
  smtpPasswordSetHint: 'Password impostata (inserire solo per cambiare)',
  smtpSecure: 'TLS/SSL (secure)',
  smtpTest: 'Test SMTP',
  smtpTesting: 'Test SMTP…',
  smtpTestSuccess: 'Connessione SMTP riuscita',
  smtpTestError: 'Test SMTP fallito',
  imapHost: 'Host IMAP',
  imapPort: 'Porta IMAP',
  imapUser: 'Utente IMAP',
  imapPassword: 'Password IMAP',
  imapPasswordSetHint: 'Password impostata (inserire solo per cambiare)',
  imapSentMailbox: 'Cartella inviati',
  imapSecure: 'TLS/SSL (secure)',
  imapTest: 'Test IMAP',
  imapTesting: 'Test IMAP…',
  imapTestSuccess: 'Connessione IMAP riuscita',
  imapTestError: 'Test IMAP fallito',
  add: 'Aggiungi',
  unsavedChanges: 'Modifiche non salvate',
  saved: 'Impostazioni salvate',
  nameUrlRequired: 'Nome e URL sono obbligatori',
  supplierSaved: 'Fornitore salvato',
  supplierDeleted: 'Fornitore eliminato',
  deleteSupplierConfirm: 'Eliminare il fornitore?'
};

const settingsPl = {
  subtitle: 'Dane firmy, zakresy numeracji i wartosci domyslne',
  infoText: 'Tutaj mozesz ustawic domyslne ustawienia dla swojego tenanta, np. jezyk interfejsu, dane firmy, zakresy numeracji i wartosci domyslne dla nowych pracownikow.',
  infoItem1: 'Jezyk interfejsu moze byc zmieniony w dowolnym momencie.',
  infoItem2: 'Dane firmy sa wyswietlane w ofertach i fakturach.',
  infoItem3: 'Aby korzystac z e-faktur (ZUGFeRD/Factur-X), nalezy wprowadzic dane bankowe.',
  infoItem4: 'Zakresy numeracji sa przypisywane automatycznie. Mozesz wybrac miedzy numeracja ciagla a roczna.',
  infoItem5: 'Wartosci domyslne sa sugerowane dla nowych pracownikow, w ofertach lub w fakturach, ale moga byc dostosowane indywidualnie. VAT jest wykluczony z tego.',
  languageTitle: 'Jezyk',
  languageHint: 'Wybierz jezyk interfejsu.',
  companyData: 'Dane firmy',
  companyName: 'Nazwa firmy',
  companyNamePlaceholder: 'Firma Przyklad',
  managingDirector: 'Dyrektor zarzadzajacy',
  taxNumber: 'Numer podatkowy',
  accentColor: 'Kolor akcentu',
  pdfHeader: 'Nagłówek PDF',
  pdfHeaderHint: 'Logo jest wyświetlane na wszystkich ofertach, fakturach i raportach.',
  pdfLogo: 'Logo firmy',
  pdfLogoHint: 'PNG lub JPG, maks. 500 KB. Kliknij lub przeciągnij plik tutaj.',
  pdfLogoPosition: 'Pozycja logo',
  pdfLogoLeft: 'Lewo',
  pdfLogoCenter: 'Środek',
  pdfLogoRight: 'Prawo',
  pdfPreview: 'Podgląd',
  pdfLogoRemove: 'Usuń logo',
  pdfLogoTooLarge: 'Plik jest za duży (maks. 500 KB).',
  pdfLogoInvalid: 'Prześlij plik PNG lub JPG.',
  pdfEditHeader: 'Edytuj nagłówek',
  pdfColors: 'Kolory akcentu', pdfColorOffer: 'Oferta', pdfColorInvoice: 'Faktura', pdfColorRapport: 'Raport', pdfColorAufmass: 'Obmiar',
  bankAndEInvoice: 'Dane bankowe i e-faktura',
  bankAndEInvoiceHint: 'Osadzane w XML ZUGFeRD/Factur-X jako informacja platnosci.',
  bankName: 'Bank',
  accountHolder: 'Wlasciciel konta',
  numberRanges: 'Zakresy numeracji',
  numberRangesHint: 'Numery sa nadawane automatycznie. Wybierz numeracje ciagla albo roczna.',
  range: 'Zakres',
  prefix: 'Prefiks',
  yearlyReset: 'Reset roczny',
  yearFormat: 'Format roku',
  separator: 'Separator',
  padding: 'Cyfry',
  startNr: 'Nr startowy',
  startNrHint: 'Numeracja zaczyna sie od tej wartosci w pierwszym roku tego zakresu (np. przy zmianie systemu). Kolejne lata i tak zaczynaja od 1.',
  preview: 'Podglad',
  prefixPlaceholder: 'np. FAK-',
  yearlyRestart: 'Restart co rok',
  sequentialNumbering: 'Numeracja ciagla',
  sequentialNumberingHint: 'Prefiks + numer biezacy + sufiks (np. FAK-0001)',
  yearlyNumbering: 'Numeracja roczna',
  yearlyNumberingHint: 'Prefiks + rok + separator + numer biezacy + sufiks (np. FAK-2026-0001)',
  yearlyResetWarning: 'Przy resecie rocznym numeracja zaczyna sie co roku od 1',
  defaults: 'Wartosci domyslne',
  defaultWeeklyHours: 'Domyslne godziny tygodniowe',
  defaultVacationDays: 'Domyslne dni urlopu',
  forNewEmployees: 'Dla nowych pracownikow',
  vatPercent: 'VAT (%)',
  payrollDatev: 'Place i DATEV',
  stateForHolidays: 'Region (swieta)',
  countryForHolidays: 'Kraj (swieta)',
  collectiveAgreement: 'Uklad zbiorowy',
  brtvBauEnabled: 'Wlacz BRTV Budownictwo',
  defaultKmRate: 'Domyślna stawka km', defaultKmRatePlaceholder: 'np. 0,35',
  startTour: 'Uruchom przewodnik',
  tourLanguageTitle: 'Język', tourLanguageText: 'Twoje osobiste ustawienie języka interfejsu użytkownika.',
  tourCompanyTitle: 'Dane firmy', tourCompanyText: 'Nazwa, adres, kontakt, NIP, VAT-UE, branża i kolor akcentu aplikacji.',
  tourPdfTitle: 'Nagłówek PDF', tourPdfText: 'Indywidualne dostosowanie logo i nagłówka dla ofert, faktur i raportów.',
  tourPdfModalTitle: 'Projektuj nagłówek', tourPdfModalText: 'Wybierz oddzielne logo i kolory dla każdego typu dokumentu. Podgląd na żywo pokazuje wynik.',
  tourBankTitle: 'Bank & e-faktura', tourBankText: 'IBAN, BIC i dane bankowe dla ZUGFeRD/e-faktury – automatycznie osadzane w fakturach.',
  tourNumbersTitle: 'Zakresy numerów', tourNumbersText: 'Prefiks, sufiks, numer startowy i padding dla projektów, faktur, ofert i innych. Przy resecie rocznym numer startowy dotyczy tylko pierwszego roku (np. po zmianie systemu) – kolejne lata i tak zaczynają od 1.',
  tourDefaultsTitle: 'Wartości domyślne', tourDefaultsText: 'Godziny tygodniowe, dni urlopu, domyślna stawka VAT i waluta jako wartości bazowe.',
  tourPayrollTitle: 'Płace & DATEV', tourPayrollText: 'Land dla świąt, tryb BRTV budownictwo i dane dostępu DATEV do eksportu list płac.',
  tourIdsTitle: 'IDS Connect', tourIdsText: 'Dodaj dostawców IDS Connect – artykuły można bezpośrednio importować z katalogu dostawcy do magazynu.',
  tourIdsModalTitle: 'Dodaj dostawcę IDS', tourIdsModalText: 'Nazwa, URL katalogu i opcjonalne dane dostępu. Po zapisaniu dostawca pojawia się w module materiałów.',
  trade: 'Branza',
  tradeNone: 'Brak branzy / Ogolna',
  trades: {
    general: 'Budownictwo ogolne / Generalny wykonawca',
    maler: 'Malarz',
    zimmerer: 'Cieslarz',
    dachdecker: 'Dekarz',
    elektriker: 'Elektryk',
    shk: 'Hydraulika, ogrzewanie i klimatyzacja',
    fliesenleger: 'Glazurnik',
    trockenbau: 'Sucha zabudowa',
    estrich: 'Posadzki',
    bodenleger: 'Posadzkarz / Parkieciarz',
    schreiner: 'Stolarz',
    fenster: 'Okna i drzwi',
    landschaftsgaertner: 'Ogrodnictwo & zagospodarowanie terenu',
  },
  brtvBauHint: 'Automatycznie stosuje 41h (kwi-lis) i 39h (gru-mar) w placach.',
  datevConsultant: 'Numer konsultanta DATEV',
  datevMandant: 'Numer klienta DATEV',
  idsTitle: 'IDS Connect / OCI Punchout',
  idsHint: 'Otwieraj katalogi dostawcow z ERP i przenos artykuly.',
  supplier: 'Dostawca',
  noIdsSuppliers: 'Brak skonfigurowanych dostawcow IDS.',
  username: 'Uzytkownik',
  editSupplier: 'Edytuj dostawce',
  newIdsSupplier: 'Nowy dostawca IDS',
  idsNamePlaceholder: 'np. Wuerth Online',
  ociLaunchUrl: 'URL uruchomienia OCI',
  ociLaunchHint: 'Adres OCI podany przez dostawce',
  leaveUnchanged: '(pozostaw bez zmian)',
  activeForCatalog: 'Aktywny (dostepny dla katalogu)',
  emailSenderTitle: 'Nadawca e-mail',
  emailSenderHint: 'Nadawca uzywany dla ofert i faktur tego tenanta.',
  emailFromAddress: 'E-mail nadawcy',
  emailFromName: 'Nazwa nadawcy',
  smtpHost: 'Host SMTP',
  smtpPort: 'Port SMTP',
  smtpUser: 'Uzytkownik SMTP',
  smtpPassword: 'Haslo SMTP',
  smtpPasswordSetHint: 'Haslo ustawione (wpisz tylko aby zmienic)',
  smtpSecure: 'TLS/SSL (secure)',
  smtpTest: 'Testuj SMTP',
  smtpTesting: 'Test SMTP…',
  smtpTestSuccess: 'Polaczenie SMTP udane',
  smtpTestError: 'Test SMTP nieudany',
  imapHost: 'Host IMAP',
  imapPort: 'Port IMAP',
  imapUser: 'Uzytkownik IMAP',
  imapPassword: 'Haslo IMAP',
  imapPasswordSetHint: 'Haslo ustawione (wpisz tylko aby zmienic)',
  imapSentMailbox: 'Folder wyslanych',
  imapSecure: 'TLS/SSL (secure)',
  imapTest: 'Testuj IMAP',
  imapTesting: 'Test IMAP…',
  imapTestSuccess: 'Polaczenie IMAP udane',
  imapTestError: 'Test IMAP nieudany',
  add: 'Dodaj',
  unsavedChanges: 'Niezapisane zmiany',
  saved: 'Ustawienia zapisane',
  nameUrlRequired: 'Nazwa i URL sa wymagane',
  supplierSaved: 'Dostawca zapisany',
  supplierDeleted: 'Dostawca usuniety',
  deleteSupplierConfirm: 'Usunac dostawce?'
};

const settingsCs = {
  subtitle: 'Firemni udaje, ciselne rady a vychozi hodnoty',
  infoText: 'Zde muzete nastavit vychozi nastaveni pro vaseho tenanta, napriklad jazyk uzivatelskeho rozhrani, firemni udaje, ciselne rady a vychozi hodnoty pro nove zamestnance.',
  infoItem1: 'Jazyk uzivatelskeho rozhrani lze zmenit kdykoliv.',
  infoItem2: 'Firemni udaje jsou zobrazeny v nabidkach a fakturach.',
  infoItem3: 'Pro pouziti e-faktur (ZUGFeRD/Factur-X) je nutne zadat bankovni udaje.',
  infoItem4: 'Ciselne rady jsou pridelovany automaticky. Muzete zvolit mezi prubeznou nebo rocni numeraci.',
  infoItem5: 'Vychozi hodnoty jsou navrhovany pro nove zamestnance, v nabidkach nebo v fakturach, ale mohou byt upraveny jednotlivcne. DPH je z toho vyloucena.',
  languageTitle: 'Jazyk',
  languageHint: 'Vyberte jazyk rozhrani.',
  companyData: 'Firemni udaje',
  companyName: 'Nazev firmy',
  companyNamePlaceholder: 'Ukazkova firma',
  managingDirector: 'Jednatel',
  taxNumber: 'Danove cislo',
  accentColor: 'Barva akcentu',
  pdfHeader: 'Hlavicka PDF',
  pdfHeaderHint: 'Logo se zobrazuje na vsech nabidkach, fakturach a reportech.',
  pdfLogo: 'Logo firmy',
  pdfLogoHint: 'PNG nebo JPG, max. 500 KB. Kliknete nebo pretahnete soubor sem.',
  pdfLogoPosition: 'Pozice loga',
  pdfLogoLeft: 'Vlevo',
  pdfLogoCenter: 'Na stred',
  pdfLogoRight: 'Vpravo',
  pdfPreview: 'Nahled',
  pdfLogoRemove: 'Odebrat logo',
  pdfLogoTooLarge: 'Soubor je prilis velky (max. 500 KB).',
  pdfLogoInvalid: 'Nahrajte soubor PNG nebo JPG.',
  pdfEditHeader: 'Upravit hlavicku',
  pdfColors: 'Barvy akcentu', pdfColorOffer: 'Nabidka', pdfColorInvoice: 'Faktura', pdfColorRapport: 'Report', pdfColorAufmass: 'Vykaz',
  bankAndEInvoice: 'Bankovni udaje a e-faktura',
  bankAndEInvoiceHint: 'Vlozeno do XML ZUGFeRD/Factur-X jako platebni informace.',
  bankName: 'Banka',
  accountHolder: 'Majitel uctu',
  numberRanges: 'Ciselne rady',
  numberRangesHint: 'Cisla jsou pridelovana automaticky. Zvolte prubezne nebo rocni cislovani.',
  range: 'Oblast',
  prefix: 'Prefix',
  yearlyReset: 'Rocni reset',
  yearFormat: 'Format roku',
  separator: 'Oddelovac',
  padding: 'Pocet cislic',
  startNr: 'Pocatecni cislo',
  startNrHint: 'Cislovani zacina touto hodnotou v prvnim roce tohoto rozsahu (napr. pri prechodu z jineho systemu). Dalsi roky vzdy zacinaji znovu od 1.',
  preview: 'Nahled',
  prefixPlaceholder: 'napr. FAK-',
  yearlyRestart: 'Zacit kazdy rok znovu',
  sequentialNumbering: 'Prubezne cislovani',
  sequentialNumberingHint: 'Prefix + bezne cislo + sufix (napr. FAK-0001)',
  yearlyNumbering: 'Rocni cislovani',
  yearlyNumberingHint: 'Prefix + rok + oddelovac + bezne cislo + sufix (napr. FAK-2026-0001)',
  yearlyResetWarning: 'Pri rocnim resetu zacina cislovani kazdy rok znovu od 1',
  defaults: 'Vychozi hodnoty',
  defaultWeeklyHours: 'Vychozi tydenni hodiny',
  defaultVacationDays: 'Vychozi dny dovolene',
  forNewEmployees: 'Pro nove zamestnance',
  vatPercent: 'DPH (%)',
  payrollDatev: 'Mzdy a DATEV',
  stateForHolidays: 'Region (svatky)',
  countryForHolidays: 'Zeme (svatky)',
  collectiveAgreement: 'Kolektivni smlouva',
  brtvBauEnabled: 'Zapnout BRTV Stavebnictvi',
  defaultKmRate: 'Výchozí sazba km', defaultKmRatePlaceholder: 'např. 0,35',
  startTour: 'Spustit průvodce',
  tourLanguageTitle: 'Jazyk', tourLanguageText: 'Vaše osobní nastavení jazyka uživatelského rozhraní.',
  tourCompanyTitle: 'Firemní údaje', tourCompanyText: 'Název, adresa, kontakt, DIČ, IČ DPH, řemeslo a barva zvýraznění aplikace.',
  tourPdfTitle: 'Záhlaví PDF', tourPdfText: 'Individuální logo a záhlaví pro nabídky, faktury a výkazy.',
  tourPdfModalTitle: 'Navrhnout záhlaví', tourPdfModalText: 'Vyberte samostatné logo a barvy pro každý typ dokumentu. Živý náhled zobrazuje výsledek.',
  tourBankTitle: 'Banka & e-faktura', tourBankText: 'IBAN, BIC a bankovní údaje pro ZUGFeRD/e-fakturu – automaticky vloženy do faktur.',
  tourNumbersTitle: 'Číselné řady', tourNumbersText: 'Prefix, suffix, počáteční číslo a padding pro projekty, faktury, nabídky a další. U rozsahů s ročním resetem platí počáteční číslo jen pro první rok (např. po přechodu z jiného systému) – další roky začínají znovu od 1.',
  tourDefaultsTitle: 'Výchozí hodnoty', tourDefaultsText: 'Týdenní hodiny, dny dovolené, výchozí DPH a měna jako počáteční hodnoty.',
  tourPayrollTitle: 'Mzdy & DATEV', tourPayrollText: 'Spolková země pro svátky, režim BRTV stavebnictví a přihlašovací údaje DATEV pro export mezd.',
  tourIdsTitle: 'IDS Connect', tourIdsText: 'Přidejte dodavatele IDS Connect – artikly lze pak importovat přímo z katalogu dodavatele do skladu.',
  tourIdsModalTitle: 'Přidat dodavatele IDS', tourIdsModalText: 'Název, URL katalogu a volitelné přihlašovací údaje. Po uložení se dodavatel zobrazí v modulu materiálů.',
  trade: 'Remeslo',
  tradeNone: 'Zadne remeslo / Obecne',
  trades: {
    general: 'Obecne stavebnictvi / Generalny dodavatel',
    maler: 'Malar',
    zimmerer: 'Tesár',
    dachdecker: 'Pokryvac',
    elektriker: 'Elektrikar',
    shk: 'Instalace, topeni a klimatizace',
    fliesenleger: 'Obkladac',
    trockenbau: 'Suchá výstavba',
    estrich: 'Poterár',
    bodenleger: 'Podlahár / Parketár',
    schreiner: 'Truhlár',
    fenster: 'Okna a dvere',
    landschaftsgaertner: 'Zahradnictví & úpravy exteriéru',
  },
  brtvBauHint: 'Automaticky pouzije 41h (dub-list) a 39h (pro-bre) ve mzdach.',
  datevConsultant: 'DATEV cislo poradce',
  datevMandant: 'DATEV cislo klienta',
  idsTitle: 'IDS Connect / OCI Punchout',
  idsHint: 'Otevrete katalogy dodavatelu z ERP a prevezmete polozky.',
  supplier: 'Dodavatel',
  noIdsSuppliers: 'Zatim nejsou nakonfigurovani zadni IDS dodavatele.',
  username: 'Uzivatel',
  editSupplier: 'Upravit dodavatele',
  newIdsSupplier: 'Novy IDS dodavatel',
  idsNamePlaceholder: 'napr. Wuerth Online',
  ociLaunchUrl: 'OCI launch URL',
  ociLaunchHint: 'OCI adresa od dodavatele',
  leaveUnchanged: '(ponechat beze zmen)',
  activeForCatalog: 'Aktivni (dostupne pro katalog)',
  emailSenderTitle: 'Odesilatel e-mailu',
  emailSenderHint: 'Odesilatel pouzity pro nabidky a faktury tohoto tenanta.',
  emailFromAddress: 'E-mail odesilatele',
  emailFromName: 'Jmeno odesilatele',
  smtpHost: 'SMTP host',
  smtpPort: 'SMTP port',
  smtpUser: 'SMTP uzivatel',
  smtpPassword: 'SMTP heslo',
  smtpPasswordSetHint: 'Heslo je nastaveno (zadejte jen pri zmene)',
  smtpSecure: 'TLS/SSL (secure)',
  smtpTest: 'Test SMTP',
  smtpTesting: 'Testuji SMTP…',
  smtpTestSuccess: 'SMTP pripojeni uspesne',
  smtpTestError: 'SMTP test selhal',
  imapHost: 'IMAP host',
  imapPort: 'IMAP port',
  imapUser: 'IMAP uzivatel',
  imapPassword: 'IMAP heslo',
  imapPasswordSetHint: 'Heslo je nastaveno (zadejte jen pri zmene)',
  imapSentMailbox: 'Slozka odeslane',
  imapSecure: 'TLS/SSL (secure)',
  imapTest: 'Test IMAP',
  imapTesting: 'Testuji IMAP…',
  imapTestSuccess: 'IMAP pripojeni uspesne',
  imapTestError: 'IMAP test selhal',
  add: 'Pridat',
  unsavedChanges: 'Neulozene zmeny',
  saved: 'Nastaveni ulozeno',
  nameUrlRequired: 'Nazev a URL jsou povinne',
  supplierSaved: 'Dodavatel ulozen',
  supplierDeleted: 'Dodavatel smazan',
  deleteSupplierConfirm: 'Smazat dodavatele?'
};

const authDe = {
  forgotPasswordLink: 'Passwort vergessen?',
  forgotPassword: 'Passwort vergessen',
  forgotPasswordSent: 'Wenn ein Konto existiert, wurde ein Link zum Zurücksetzen versendet.',
  tenantSlug: 'Unternehmen (Slug)',
  sendResetLink: 'Reset-Link senden',
  backToLogin: 'Zurück zum Login',
  resetPassword: 'Passwort zurücksetzen',
  resetPasswordSuccess: 'Dein Passwort wurde erfolgreich gesetzt.',
  resetLinkInvalid: 'Der Link ist ungültig oder abgelaufen.',
  requestNewLink: 'Neuen Link anfordern',
  saveNewPassword: 'Neues Passwort speichern',
  emailRequired: 'E-Mail erforderlich',
  slugRequired: 'Tenant-Slug erforderlich',
  passwordRequired: 'Passwort erforderlich',
  passwordMinLength: 'Passwort min. 8 Zeichen',
  passwordMismatch: 'Passwoerter stimmen nicht überein',
  tenantSuspended: 'Dieser Zugang ist gesperrt. Bitte wende dich an den Support.',
  tenantInactive: 'Dieser Zugang ist nicht aktiv. Bitte prüfe, ob dein Abonnement noch gültig ist, oder wende dich an den Support.',
  subscriptionUnpaid: 'Deine Zahlung ist überfällig. Bitte aktualisiere deine Zahlungsdaten, um fortzufahren.'
};

const authEn = {
  forgotPasswordLink: 'Forgot password?',
  forgotPassword: 'Forgot password',
  forgotPasswordSent: 'If an account exists, a reset link has been sent.',
  tenantSlug: 'Company (slug)',
  sendResetLink: 'Send reset link',
  backToLogin: 'Back to login',
  resetPassword: 'Reset password',
  resetPasswordSuccess: 'Your password has been updated successfully.',
  resetLinkInvalid: 'The link is invalid or expired.',
  requestNewLink: 'Request new link',
  saveNewPassword: 'Save new password',
  emailRequired: 'Email is required',
  slugRequired: 'Tenant slug is required',
  passwordRequired: 'Password is required',
  passwordMinLength: 'Password min. 8 characters',
  passwordMismatch: 'Passwords do not match',
  tenantSuspended: 'This account has been suspended. Please contact support.',
  tenantInactive: 'This account is not active. Please check if your subscription is still valid, or contact support.',
  subscriptionUnpaid: 'Your payment is overdue. Please update your payment details to continue.'
};

const authFr = {
  forgotPasswordLink: 'Mot de passe oublie ?',
  forgotPassword: 'Mot de passe oublie',
  forgotPasswordSent: 'Si un compte existe, un lien de reinitialisation a ete envoye.',
  tenantSlug: 'Societe (slug)',
  sendResetLink: 'Envoyer le lien',
  backToLogin: 'Retour a la connexion',
  resetPassword: 'Reinitialiser le mot de passe',
  resetPasswordSuccess: 'Votre mot de passe a ete mis a jour.',
  resetLinkInvalid: 'Le lien est invalide ou expire.',
  requestNewLink: 'Demander un nouveau lien',
  saveNewPassword: 'Enregistrer le nouveau mot de passe',
  emailRequired: 'E-mail requis',
  slugRequired: 'Slug du tenant requis',
  passwordRequired: 'Mot de passe requis',
  passwordMinLength: 'Mot de passe min. 8 caracteres',
  passwordMismatch: 'Les mots de passe ne correspondent pas',
  tenantSuspended: 'Ce compte est suspendu. Veuillez contacter le support.',
  tenantInactive: 'Ce compte n\'est pas actif. Veuillez verifier si votre abonnement est toujours valide ou contacter le support.',
  subscriptionUnpaid: 'Votre paiement est en retard. Veuillez mettre a jour vos informations de paiement pour continuer.'
};

const authIt = {
  forgotPasswordLink: 'Password dimenticata?',
  forgotPassword: 'Password dimenticata',
  forgotPasswordSent: 'Se l\'account esiste, e stato inviato un link di reset.',
  tenantSlug: 'Azienda (slug)',
  sendResetLink: 'Invia link di reset',
  backToLogin: 'Torna al login',
  resetPassword: 'Reimposta password',
  resetPasswordSuccess: 'La password e stata aggiornata con successo.',
  resetLinkInvalid: 'Il link non e valido o e scaduto.',
  requestNewLink: 'Richiedi nuovo link',
  saveNewPassword: 'Salva nuova password',
  emailRequired: 'Email obbligatoria',
  slugRequired: 'Slug tenant obbligatorio',
  passwordRequired: 'Password obbligatoria',
  passwordMinLength: 'Password min. 8 caratteri',
  passwordMismatch: 'Le password non corrispondono',
  tenantSuspended: 'Questo account e sospeso. Contattare il supporto.',
  tenantInactive: 'Questo account non e attivo. Verifica se il tuo abbonamento e ancora valido o contatta il supporto.',
  subscriptionUnpaid: 'Il pagamento e in ritardo. Aggiorna i tuoi dati di pagamento per continuare.'
};

const authPl = {
  forgotPasswordLink: 'Zapomniales hasla?',
  forgotPassword: 'Reset hasla',
  forgotPasswordSent: 'Jesli konto istnieje, wyslano link do resetu hasla.',
  tenantSlug: 'Firma (slug)',
  sendResetLink: 'Wyslij link resetu',
  backToLogin: 'Wroc do logowania',
  resetPassword: 'Ustaw nowe haslo',
  resetPasswordSuccess: 'Haslo zostalo pomyslnie zmienione.',
  resetLinkInvalid: 'Link jest nieprawidlowy lub wygasl.',
  requestNewLink: 'Popros o nowy link',
  saveNewPassword: 'Zapisz nowe haslo',
  emailRequired: 'E-mail jest wymagany',
  slugRequired: 'Slug tenanta jest wymagany',
  passwordRequired: 'Haslo jest wymagane',
  passwordMinLength: 'Haslo min. 8 znakow',
  passwordMismatch: 'Hasla nie sa zgodne',
  tenantSuspended: 'To konto zostalo zawieszone. Skontaktuj sie z pomoca techniczna.',
  tenantInactive: 'To konto nie jest aktywne. Sprawdz, czy Twoja subskrypcja jest wazna, lub skontaktuj sie z pomoca techniczna.',
  subscriptionUnpaid: 'Platnosc jest przeterminowana. Zaktualizuj dane platnosci, aby kontynuowac.'
};

const authCs = {
  forgotPasswordLink: 'Zapomenute heslo?',
  forgotPassword: 'Zapomenute heslo',
  forgotPasswordSent: 'Pokud ucet existuje, byl odeslan odkaz pro reset hesla.',
  tenantSlug: 'Firma (slug)',
  sendResetLink: 'Odeslat reset odkaz',
  backToLogin: 'Zpet na prihlaseni',
  resetPassword: 'Reset hesla',
  resetPasswordSuccess: 'Heslo bylo uspesne zmeneno.',
  resetLinkInvalid: 'Odkaz je neplatny nebo expiroval.',
  requestNewLink: 'Pozadat o novy odkaz',
  saveNewPassword: 'Ulozit nove heslo',
  emailRequired: 'E-mail je povinny',
  slugRequired: 'Tenant slug je povinny',
  passwordRequired: 'Heslo je povinne',
  passwordMinLength: 'Heslo min. 8 znaku',
  passwordMismatch: 'Hesla se neshoduji',
  tenantSuspended: 'Tento ucet je pozastaven. Prosim kontaktujte podporu.',
  tenantInactive: 'Tento ucet neni aktivni. Zkontrolujte, zda je vase predplatne stale platne, nebo kontaktujte podporu.',
  subscriptionUnpaid: 'Platba je po splatnosti. Aktualizujte sve platebni udaje pro pokracovani.'
};

const employeeDe = {
  title: 'Mitarbeiterverwaltung',
  infoText: 'Hier kannst du Mitarbeiter anlegen, bearbeiten und verwalten.',
  infoItem1: 'Mitarbeiter können aktiviert/deaktiviert und Rollen zugewiesen werden.',
  infoItem2: 'Urlaubstage und Wochenstunden können individuell oder über Tarifvertrag (BRTV Bau) verwaltet werden.',
  infoItem3: 'Beim Löschen eines Mitarbeiters werden die Daten pseudonymisiert (DSGVO-konform).',
  infoItem4: 'Neue Mitarbeiter erhalten automatisch eine Einladungs-E-Mail mit Login-Daten, wenn diese beim Anlegen aktiviert wird.',
  infoItem5: 'Bulk-Aktionen sind über die Mehrfachauswahl möglich. Hierbei kannst du mehrere Mitarbeiter gleichzeitig aktivieren, deaktivieren, löschen oder die Rolle setzen.',
  employees: 'Mitarbeiter',
  newEmployee: 'Neuer Mitarbeiter',
  noEmployees: 'Keine Mitarbeiter',
  startTour: 'Führung starten',
  tourSearchTitle: 'Suche',
  tourSearchText: 'Mitarbeiter nach Name, E-Mail oder Rolle filtern.',
  tourTableTitle: 'Mitarbeiterliste',
  tourTableText: 'Alle Mitarbeiter mit Rolle, Urlaubstagen und Status. Checkbox aktiviert die Mehrfachauswahl.',
  tourBulkTitle: 'Mehrfachaktionen',
  tourBulkText: 'Mehrere Mitarbeiter gleichzeitig aktivieren, deaktivieren, Rolle ändern oder löschen.',
  tourNewTitle: 'Neuer Mitarbeiter',
  tourNewText: 'Legt einen neuen Mitarbeiter an – mit Name, E-Mail, Rolle und Urlaubstagen. Eine Einladungs-E-Mail wird automatisch verschickt.',
  tourModalTitle: 'Mitarbeiterformular',
  tourModalText: 'Name, E-Mail, Rolle, Qualifikation, Urlaubstage und Stundenlohn erfassen. Aktiv/Inaktiv-Status kann hier ebenfalls gesetzt werden.',
  selected: 'ausgewaehlt',
  activate: 'Aktivieren',
  deactivate: 'Deaktivieren',
  setRole: 'Rolle setzen',
  apply: 'Anwenden',
  clearSelection: 'Aufheben',
  vacationPerYear: 'Urlaub/Jahr',
  vacationDaysPerYear: 'Urlaubstage/Jahr',
  editEmployee: 'Mitarbeiter bearbeiten',
  firstName: 'Vorname',
  firstNamePlaceholder: 'Max',
  lastName: 'Nachname',
  lastNamePlaceholder: 'Mustermann',
  emailPlaceholder: "max{'@'}beispiel.de",
  password: 'Passwort',
  passwordPlaceholder: 'Leer lassen = automatisch generieren',
  passwordHint: 'Leer lassen um ein sicheres Startpasswort automatisch zu generieren.',
  sendInvite: 'Einladungs-E-Mail an Mitarbeiter senden',
  sendInviteHint: 'Sendet E-Mail mit Login-Daten und Startpasswort (SMTP muss konfiguriert sein).',
  billingRate: 'Verkaufsstundensatz',
  weeklyHours: 'Wochenstunden',
  collectiveAgreement: 'Tarifvertrag',
  brtvApply: 'BRTV-Bau für diesen Mitarbeiter anwenden',
  brtvApplyHint: 'Bei deaktivierter Option werden die individuellen Wochenstunden für Soll-Zeiten verwendet.',
  personnelNumber: 'Personalnummer',
  personnelPlaceholder: 'z.B. 00001',
  costCenterPlaceholder: 'z.B. 100',
  calendarColor: 'Kalenderfarbe',
  colorAuto: 'Wird automatisch zugewiesen',
  workingDaysDefault: 'Arbeitstage · Standard: 30',
  vacationEditWarning: 'Ändert auch das Kontingent im aktuellen Jahr',
  employeeCreated: 'Mitarbeiter erstellt',
  createdSuccess: 'wurde erfolgreich angelegt.',
  generatedPasswordHint: 'Das folgende Startpasswort wurde automatisch generiert. Bitte sicher notieren:',
  copy: 'Kopieren',
  inviteSent: 'Einladungs-E-Mail wurde gesendet',
  inviteFailed: 'E-Mail konnte nicht gesendet werden. SMTP prüfen.',
  bulkDeleteConfirm: '{count} Mitarbeiter unwiderruflich löschen (DSGVO-Pseudonymisierung)?',
  bulkActivated: 'Aktiviert',
  bulkDeactivated: 'Deaktiviert',
  bulkDeleted: 'Gelöscht',
  bulkRoleUpdated: 'Rolle aktualisiert',
  bulkError: 'Fehler bei Bulk-Aktion',
  requiredFields: 'Alle Pflichtfelder ausfüllen',
  saved: 'Mitarbeiter gespeichert',
  copyFailed: 'Kopieren fehlgeschlagen',
  deleteConfirm: '{name} löschen? (DSGVO-Pseudonymisierung)',
  deleted: 'Mitarbeiter gelöscht',
  deleteModalTitle: 'Mitarbeiter löschen',
  deleteModalText: 'wirklich löschen? (DSGVO-Pseudonymisierung)',
  deleteAndReduce: 'Löschen & Abo reduzieren',
  deleteAndReduceHint: 'Nutzer wird gelöscht und das Abonnement um 1 Seat reduziert (ab nächster Abrechnung).',
  deleteKeepSeat: 'Löschen & Platz freihalten',
  deleteKeepSeatHint: 'Nutzer wird gelöscht, der Platz bleibt für eine neue Person frei. Abo-Kosten bleiben gleich.',
  limitReachedTitle: 'Nutzer-Limit erreicht',
  limitReachedText: 'Sie haben die maximale Anzahl an Nutzern für Ihr aktuelles Abo erreicht. Möchten Sie Ihr Kontingent um einen weiteren Nutzer erweitern? Sie werden zu Stripe weitergeleitet, um die Änderung zu bestätigen.',
  upgradeSeats: 'Kontingent erweitern',
  upgradeDone: 'Abo erfolgreich aktualisiert',
  lockedByOther: 'Wird gerade bearbeitet von {name}'
};

const employeeEn = {
  title: 'Employee management',
  infoText: 'Here you can create, edit and manage employees.',
  infoItem1: 'Employees can be activated/deactivated and assigned roles.',
  infoItem2: 'Vacation days and weekly hours can be managed individually or via collective agreement (BRTV Construction).',
  infoItem3: 'When deleting an employee, the data is pseudonymized (GDPR compliant).',
  infoItem4: 'New employees automatically receive an invitation email with login details if activated upon creation.',
  infoItem5: 'Bulk actions are available via multi-select, allowing you to activate, deactivate, delete or set the role for multiple employees.',
  employees: 'employees',
  newEmployee: 'New employee',
  noEmployees: 'No employees',
  startTour: 'Start tour',
  tourSearchTitle: 'Search',
  tourSearchText: 'Filter employees by name, email or role.',
  tourTableTitle: 'Employee list',
  tourTableText: 'All employees with role, vacation days and status. Checkbox enables multi-selection.',
  tourBulkTitle: 'Bulk actions',
  tourBulkText: 'Activate, deactivate, change role or delete multiple employees at once.',
  tourNewTitle: 'New employee',
  tourNewText: 'Creates a new employee – with name, email, role and vacation days. An invitation email is sent automatically.',
  tourModalTitle: 'Employee form',
  tourModalText: 'Enter name, email, role, qualification, vacation days and hourly rate. Active/inactive status can also be set here.',
  selected: 'selected',
  activate: 'Activate',
  deactivate: 'Deactivate',
  setRole: 'Set role',
  apply: 'Apply',
  clearSelection: 'Clear',
  vacationPerYear: 'Vacation/year',
  vacationDaysPerYear: 'Vacation days/year',
  editEmployee: 'Edit employee',
  firstName: 'First name',
  firstNamePlaceholder: 'Max',
  lastName: 'Last name',
  lastNamePlaceholder: 'Doe',
  emailPlaceholder: "max{'@'}example.com",
  password: 'Password',
  passwordPlaceholder: 'Leave empty = auto-generate',
  passwordHint: 'Leave empty to generate a secure initial password automatically.',
  sendInvite: 'Send invitation email to employee',
  sendInviteHint: 'Sends email with login details and initial password (SMTP must be configured).',
  billingRate: 'Billing hourly rate',
  weeklyHours: 'Weekly hours',
  collectiveAgreement: 'Collective agreement',
  brtvApply: 'Apply BRTV Construction for this employee',
  brtvApplyHint: 'If disabled, individual weekly hours are used for target-time calculations.',
  personnelNumber: 'Personnel number',
  personnelPlaceholder: 'e.g. 00001',
  costCenterPlaceholder: 'e.g. 100',
  calendarColor: 'Calendar color',
  colorAuto: 'Assigned automatically',
  workingDaysDefault: 'Workdays · default: 30',
  vacationEditWarning: 'Also changes the quota in the current year',
  employeeCreated: 'Employee created',
  createdSuccess: 'was created successfully.',
  generatedPasswordHint: 'The following initial password was generated automatically. Please store it safely:',
  copy: 'Copy',
  inviteSent: 'Invitation email sent',
  inviteFailed: 'Email could not be sent. Check SMTP.',
  bulkDeleteConfirm: 'Permanently delete {count} employees (GDPR pseudonymization)?',
  bulkActivated: 'Activated',
  bulkDeactivated: 'Deactivated',
  bulkDeleted: 'Deleted',
  bulkRoleUpdated: 'Role updated',
  bulkError: 'Bulk action failed',
  requiredFields: 'Fill all required fields',
  saved: 'Employee saved',
  copyFailed: 'Copy failed',
  deleteConfirm: 'Delete {name}? (GDPR pseudonymization)',
  deleted: 'Employee deleted',
  deleteModalTitle: 'Delete employee',
  deleteModalText: 'really delete? (GDPR pseudonymization)',
  deleteAndReduce: 'Delete & reduce subscription',
  deleteAndReduceHint: 'Employee will be deleted and subscription reduced by 1 seat (effective next billing cycle).',
  deleteKeepSeat: 'Delete & keep seat',
  deleteKeepSeatHint: 'Employee will be deleted but the seat remains available for a new person. Subscription cost unchanged.',
  limitReachedTitle: 'User limit reached',
  limitReachedText: 'You have reached the maximum number of users for your current plan. Would you like to add one more user seat? You will be redirected to Stripe to confirm the change.',
  upgradeSeats: 'Expand seats',
  upgradeDone: 'Subscription updated successfully',
  lockedByOther: 'Currently being edited by {name}'
};

const employeeFr = {
  title: 'Gestion des employes',
  infoText: 'Ici, vous pouvez creer, modifier et gerer les employes.',
  infoItem1: 'Les employes peuvent etre actives/desactives et se voir attribuer des roles.',
  infoItem2: 'Les jours de conges et les heures hebdomadaires peuvent etre geres individuellement ou via une convention collective (BRTV Batiment).',
  infoItem3: 'Lors de la suppression d\'un employe, les donnees sont pseudonymisees (conforme au RGPD).',
  infoItem4: 'Les nouveaux employes reçoivent automatiquement un e-mail d\'invitation avec les details de connexion si ils sont actives lors de la creation.',
  infoItem5: 'Les actions grouppees sont disponibles via la selection multiple, vous permettant d\'activer, desactiver, supprimer ou definir le role de plusieurs employes en meme temps.',
  employees: 'employes',
  newEmployee: 'Nouvel employe',
  noEmployees: 'Aucun employe',
  startTour: 'Lancer la visite guidée',
  tourSearchTitle: 'Recherche',
  tourSearchText: 'Filtrer les employés par nom, e-mail ou rôle.',
  tourTableTitle: 'Liste des employés',
  tourTableText: 'Tous les employés avec rôle, jours de congés et statut. La case à cocher active la sélection multiple.',
  tourBulkTitle: 'Actions groupées',
  tourBulkText: 'Activer, désactiver, changer de rôle ou supprimer plusieurs employés en même temps.',
  tourNewTitle: 'Nouvel employé',
  tourNewText: 'Crée un nouvel employé – avec nom, e-mail, rôle et jours de congés. Un e-mail d\'invitation est envoyé automatiquement.',
  tourModalTitle: 'Formulaire employé',
  tourModalText: 'Saisissez nom, e-mail, rôle, qualification, jours de congés et taux horaire. Le statut actif/inactif peut aussi être défini ici.',
  selected: 'selectionnes',
  activate: 'Activer',
  deactivate: 'Desactiver',
  setRole: 'Definir role',
  apply: 'Appliquer',
  clearSelection: 'Annuler selection',
  vacationPerYear: 'Conges/an',
  vacationDaysPerYear: 'Jours de conges/an',
  editEmployee: "Modifier l'employe",
  firstName: 'Prenom',
  firstNamePlaceholder: 'Max',
  lastName: 'Nom',
  lastNamePlaceholder: 'Dupont',
  emailPlaceholder: "max{'@'}exemple.fr",
  password: 'Mot de passe',
  passwordPlaceholder: 'Laisser vide = generation auto',
  passwordHint: 'Laisser vide pour generer automatiquement un mot de passe initial securise.',
  sendInvite: "Envoyer un e-mail d'invitation",
  sendInviteHint: 'Envoie un e-mail avec identifiants et mot de passe initial (SMTP requis).',
  billingRate: 'Taux horaire de facturation',
  weeklyHours: 'Heures hebdomadaires',
  collectiveAgreement: 'Convention collective',
  brtvApply: 'Appliquer la convention BRTV BTP pour cet employe',
  brtvApplyHint: 'Si desactive, les heures hebdomadaires individuelles sont utilisees pour le calcul du temps cible.',
  personnelNumber: 'Numero du personnel',
  personnelPlaceholder: 'p.ex. 00001',
  costCenterPlaceholder: 'p.ex. 100',
  calendarColor: 'Couleur calendrier',
  colorAuto: 'Attribue automatiquement',
  workingDaysDefault: 'Jours ouvrables · defaut: 30',
  vacationEditWarning: "Modifie aussi le quota de l'annee en cours",
  employeeCreated: 'Employe cree',
  createdSuccess: 'a ete cree avec succes.',
  generatedPasswordHint: 'Le mot de passe initial suivant a ete genere automatiquement. Veuillez le conserver en securite :',
  copy: 'Copier',
  inviteSent: "E-mail d'invitation envoye",
  inviteFailed: "L'e-mail n'a pas pu etre envoye. Verifiez SMTP.",
  bulkDeleteConfirm: 'Supprimer definitivement {count} employes (pseudonymisation RGPD) ?',
  bulkActivated: 'Actives',
  bulkDeactivated: 'Desactives',
  bulkDeleted: 'Supprimes',
  bulkRoleUpdated: 'Role mis a jour',
  bulkError: 'Erreur action grouppee',
  requiredFields: 'Veuillez remplir tous les champs obligatoires',
  saved: 'Employe enregistre',
  copyFailed: 'Copie echouee',
  deleteConfirm: 'Supprimer {name} ? (pseudonymisation RGPD)',
  deleted: 'Employe supprime',
  deleteModalTitle: 'Supprimer un employe',
  deleteModalText: 'vraiment supprimer ? (pseudonymisation RGPD)',
  deleteAndReduce: 'Supprimer et reduire l\'abonnement',
  deleteAndReduceHint: 'L\'employe sera supprime et l\'abonnement reduit d\'1 siege (a compter du prochain cycle).',
  deleteKeepSeat: 'Supprimer et conserver le siege',
  deleteKeepSeatHint: 'L\'employe sera supprime mais le siege reste disponible pour une nouvelle personne.',
  limitReachedTitle: 'Limite d\'utilisateurs atteinte',
  limitReachedText: 'Vous avez atteint le nombre maximum d\'utilisateurs pour votre abonnement actuel. Souhaitez-vous ajouter un utilisateur supplementaire ? Vous serez redirige vers Stripe pour confirmer la modification.',
  upgradeSeats: 'Etendre les sièges',
  upgradeDone: 'Abonnement mis a jour avec succes',
  lockedByOther: 'Actuellement modifie par {name}'
};

const employeeIt = {
  title: 'Gestione dipendenti',
  infoText: 'Qui puoi creare, modificare e gestire i dipendenti.',
  infoItem1: 'I dipendenti possono essere attivati/disattivati e assegnati a ruoli.',
  infoItem2: 'I giorni di ferie e le ore settimanali possono essere gestiti individualmente o tramite accordo collettivo (BRTV Edilizia).',
  infoItem3: 'Quando si elimina un dipendente, i dati vengono resi pseudonimi (conforme al GDPR).',
  infoItem4: 'I nuovi dipendenti ricevono automaticamente un email di invito con i dettagli di accesso se sono attivi al momento della creazione.',
  infoItem5: 'Le azioni di gruppo sono disponibili tramite la selezione multipla, consentendo di attivare, disattivare, eliminare o definire il ruolo di più dipendenti contemporaneamente.',
  employees: 'dipendenti',
  newEmployee: 'Nuovo dipendente',
  noEmployees: 'Nessun dipendente',
  startTour: 'Avvia la guida',
  tourSearchTitle: 'Ricerca',
  tourSearchText: 'Filtra dipendenti per nome, e-mail o ruolo.',
  tourTableTitle: 'Lista dipendenti',
  tourTableText: 'Tutti i dipendenti con ruolo, giorni ferie e stato. La casella attiva la selezione multipla.',
  tourBulkTitle: 'Azioni multiple',
  tourBulkText: 'Attiva, disattiva, cambia ruolo o elimina più dipendenti contemporaneamente.',
  tourNewTitle: 'Nuovo dipendente',
  tourNewText: 'Crea un nuovo dipendente – con nome, e-mail, ruolo e giorni ferie. Un\'e-mail di invito viene inviata automaticamente.',
  tourModalTitle: 'Modulo dipendente',
  tourModalText: 'Inserisci nome, e-mail, ruolo, qualifica, giorni ferie e tariffa oraria. Lo stato attivo/inattivo può essere impostato qui.',
  selected: 'selezionati',
  activate: 'Attiva',
  deactivate: 'Disattiva',
  setRole: 'Imposta ruolo',
  apply: 'Applica',
  clearSelection: 'Annulla selezione',
  vacationPerYear: 'Ferie/anno',
  vacationDaysPerYear: 'Giorni ferie/anno',
  editEmployee: 'Modifica dipendente',
  firstName: 'Nome',
  firstNamePlaceholder: 'Max',
  lastName: 'Cognome',
  lastNamePlaceholder: 'Rossi',
  emailPlaceholder: "max{'@'}esempio.it",
  password: 'Password',
  passwordPlaceholder: 'Lascia vuoto = genera automaticamente',
  passwordHint: 'Lascia vuoto per generare automaticamente una password iniziale sicura.',
  sendInvite: 'Invia email di invito al dipendente',
  sendInviteHint: 'Invia email con dati di login e password iniziale (SMTP necessario).',
  billingRate: 'Tariffa oraria di vendita',
  weeklyHours: 'Ore settimanali',
  collectiveAgreement: 'Contratto collettivo',
  brtvApply: 'Applica BRTV Edilizia per questo dipendente',
  brtvApplyHint: 'Se disattivato, vengono usate le ore settimanali individuali per il calcolo delle ore obiettivo.',
  personnelNumber: 'Matricola',
  personnelPlaceholder: 'es. 00001',
  costCenterPlaceholder: 'es. 100',
  calendarColor: 'Colore calendario',
  colorAuto: 'Assegnato automaticamente',
  workingDaysDefault: 'Giorni lavorativi · predefinito: 30',
  vacationEditWarning: "Modifica anche il contingente dell'anno corrente",
  employeeCreated: 'Dipendente creato',
  createdSuccess: 'e stato creato con successo.',
  generatedPasswordHint: 'La seguente password iniziale e stata generata automaticamente. Conservala in modo sicuro:',
  copy: 'Copia',
  inviteSent: 'Email di invito inviata',
  inviteFailed: 'Email non inviata. Verifica SMTP.',
  bulkDeleteConfirm: 'Eliminare definitivamente {count} dipendenti (pseudonimizzazione GDPR)?',
  bulkActivated: 'Attivati',
  bulkDeactivated: 'Disattivati',
  bulkDeleted: 'Eliminati',
  bulkRoleUpdated: 'Ruolo aggiornato',
  bulkError: 'Errore azione multipla',
  requiredFields: 'Compila tutti i campi obbligatori',
  saved: 'Dipendente salvato',
  copyFailed: 'Copia non riuscita',
  deleteConfirm: 'Eliminare {name}? (pseudonimizzazione GDPR)',
  deleted: 'Dipendente eliminato',
  deleteModalTitle: 'Elimina dipendente',
  deleteModalText: 'eliminare davvero? (pseudonimizzazione GDPR)',
  deleteAndReduce: 'Elimina e riduci abbonamento',
  deleteAndReduceHint: 'Il dipendente verra eliminato e l\'abbonamento ridotto di 1 posto (dal prossimo ciclo).',
  deleteKeepSeat: 'Elimina e mantieni il posto',
  deleteKeepSeatHint: 'Il dipendente verra eliminato ma il posto rimane disponibile per una nuova persona.',
  limitReachedTitle: 'Limite utenti raggiunto',
  limitReachedText: 'Hai raggiunto il numero massimo di utenti per il tuo abbonamento attuale. Vuoi aggiungere un altro utente? Verrai reindirizzato a Stripe per confermare la modifica.',
  upgradeSeats: 'Espandi posti',
  upgradeDone: 'Abbonamento aggiornato con successo',
  lockedByOther: 'Attualmente in modifica da {name}'
};

const employeePl = {
  title: 'Zarzadzanie pracownikami',
  infoText: 'Tutaj mozesz tworzyc, edytowac i zarzadzac pracownikami.',
  infoItem1: 'Pracownicy moga byc aktywowani/dezaktywowani i przypisywani do ról.',
  infoItem2: 'Dni wolne i godziny tygodniowe moga byc zarzadzane indywidualnie lub poprzez umowe zbiorowa (BRTV Budownictwo).',
  infoItem3: 'Przy usuwaniu pracownika, dane sa pseudonimizowane (zgodnie z RODO).',
  infoItem4: 'Nowi pracownicy otrzymuja automatycznie e-mail z zaproszeniem z detalami logowania, jezeli sa aktywni przy tworzeniu.',
  infoItem5: 'Akcje grupowe sa dostepne przez wielokrotny wybor, pozwalajac na aktywowanie, dezaktywowanie, usuwanie lub ustawianie roli dla wielu pracownikow jednoczesnie.',
  employees: 'pracownikow',
  newEmployee: 'Nowy pracownik',
  noEmployees: 'Brak pracownikow',
  startTour: 'Uruchom przewodnik',
  tourSearchTitle: 'Wyszukiwanie',
  tourSearchText: 'Filtruj pracowników według nazwy, e-maila lub roli.',
  tourTableTitle: 'Lista pracowników',
  tourTableText: 'Wszyscy pracownicy z rolą, dniami urlopu i statusem. Checkbox włącza wielokrotny wybór.',
  tourBulkTitle: 'Akcje zbiorcze',
  tourBulkText: 'Aktywuj, dezaktywuj, zmień rolę lub usuń kilku pracowników jednocześnie.',
  tourNewTitle: 'Nowy pracownik',
  tourNewText: 'Tworzy nowego pracownika – z nazwą, e-mailem, rolą i dniami urlopu. E-mail z zaproszeniem jest wysyłany automatycznie.',
  tourModalTitle: 'Formularz pracownika',
  tourModalText: 'Wprowadź imię, e-mail, rolę, kwalifikacje, dni urlopu i stawkę godzinową. Status aktywny/nieaktywny można też tutaj ustawić.',
  selected: 'zaznaczono',
  activate: 'Aktywuj',
  deactivate: 'Dezaktywuj',
  setRole: 'Ustaw role',
  apply: 'Zastosuj',
  clearSelection: 'Wyczysc',
  vacationPerYear: 'Urlop/rok',
  vacationDaysPerYear: 'Dni urlopu/rok',
  editEmployee: 'Edytuj pracownika',
  firstName: 'Imie',
  firstNamePlaceholder: 'Max',
  lastName: 'Nazwisko',
  lastNamePlaceholder: 'Kowalski',
  emailPlaceholder: "max{'@'}przyklad.pl",
  password: 'Haslo',
  passwordPlaceholder: 'Puste = wygeneruj automatycznie',
  passwordHint: 'Pozostaw puste, aby automatycznie wygenerowac bezpieczne haslo startowe.',
  sendInvite: 'Wyslij e-mail zaproszenia do pracownika',
  sendInviteHint: 'Wysyla e-mail z danymi logowania i haslem startowym (wymagany SMTP).',
  billingRate: 'Stawka godzinowa sprzedazy',
  weeklyHours: 'Godziny tygodniowe',
  collectiveAgreement: 'Uklad zbiorowy',
  brtvApply: 'Stosuj BRTV Budownictwo dla tego pracownika',
  brtvApplyHint: 'Po wylaczeniu do wyliczenia czasu docelowego uzywane sa indywidualne godziny tygodniowe.',
  personnelNumber: 'Numer personalny',
  personnelPlaceholder: 'np. 00001',
  costCenterPlaceholder: 'np. 100',
  calendarColor: 'Kolor kalendarza',
  colorAuto: 'Przydzielany automatycznie',
  workingDaysDefault: 'Dni robocze · domyslnie: 30',
  vacationEditWarning: 'Zmienia rowniez limit w biezacym roku',
  employeeCreated: 'Pracownik utworzony',
  createdSuccess: 'zostal pomyslnie utworzony.',
  generatedPasswordHint: 'Ponizsze haslo startowe zostalo wygenerowane automatycznie. Zapisz je bezpiecznie:',
  copy: 'Kopiuj',
  inviteSent: 'E-mail zaproszenia zostal wyslany',
  inviteFailed: 'Nie mozna wyslac e-maila. Sprawdz SMTP.',
  bulkDeleteConfirm: 'Trwale usunac {count} pracownikow (pseudonimizacja RODO)?',
  bulkActivated: 'Aktywowano',
  bulkDeactivated: 'Dezaktywowano',
  bulkDeleted: 'Usunieto',
  bulkRoleUpdated: 'Role zaktualizowano',
  bulkError: 'Blad akcji zbiorczej',
  requiredFields: 'Wypelnij wszystkie wymagane pola',
  saved: 'Pracownik zapisany',
  copyFailed: 'Kopiowanie nie powiodlo sie',
  deleteConfirm: 'Usunac {name}? (pseudonimizacja RODO)',
  deleted: 'Pracownik usuniety',
  deleteModalTitle: 'Usun pracownika',
  deleteModalText: 'naprawde usunac? (pseudonimizacja RODO)',
  deleteAndReduce: 'Usun i obniz subskrypcje',
  deleteAndReduceHint: 'Pracownik zostanie usuniety a subskrypcja zmniejszona o 1 miejsce (od nastepnego okresu).',
  deleteKeepSeat: 'Usun i zachowaj miejsce',
  deleteKeepSeatHint: 'Pracownik zostanie usuniety ale miejsce pozostanie wolne dla nowej osoby.',
  limitReachedTitle: 'Osiagnieto limit uzytkownikow',
  limitReachedText: 'Osiagnales maksymalna liczbe uzytkownikow dla swojego obecnego planu. Czy chcesz dodac kolejnego uzytkownika? Zostaniesz przekierowany do Stripe w celu potwierdzenia zmiany.',
  upgradeSeats: 'Rozszerz miejsca',
  upgradeDone: 'Subskrypcja zaktualizowana pomyslnie',
  lockedByOther: 'Aktualnie edytowane przez {name}'
};

const employeeCs = {
  title: 'Sprava zamestnancu',
  infoText: 'Zde muzete vytvaret, upravovat a spravovat zamestnance.',
  infoItem1: 'Zamestnanci mohou byt aktivovani/deaktivovani a prirazeni k rolím.',
  infoItem2: 'Dny dovoleneho a hodiny v tydnu mohou byt spravovany individualne nebo pres kolektivni smlouvu (BRTV Stavebnictvi).',
  infoItem3: 'Pri smazani zamestnance jsou data pseudonymizovana (v souladu s GDPR).',
  infoItem4: 'Novi zamestnanci dostanou automaticky e-mail s pozvankou s detaily prihlaseni, pokud jsou aktivni pri vytvareni.',
  infoItem5: 'Skupinove akce jsou dostupne pres multiplikaci vyberu, coz vam umozi moznost aktivace, deaktivace, smazani nebo nastaveni role pro vice zamestnancu najednou.',
  employees: 'zamestnancu',
  newEmployee: 'Novy zamestnanec',
  noEmployees: 'Zadni zamestnanci',
  startTour: 'Spustit průvodce',
  tourSearchTitle: 'Vyhledávání',
  tourSearchText: 'Filtrujte zaměstnance podle jména, e-mailu nebo role.',
  tourTableTitle: 'Seznam zaměstnanců',
  tourTableText: 'Všichni zaměstnanci s rolí, dny dovolené a stavem. Zaškrtávací políčko zapíná vícenásobný výběr.',
  tourBulkTitle: 'Hromadné akce',
  tourBulkText: 'Aktivujte, deaktivujte, změňte roli nebo smažte více zaměstnanců najednou.',
  tourNewTitle: 'Nový zaměstnanec',
  tourNewText: 'Vytvoří nového zaměstnance – se jménem, e-mailem, rolí a dny dovolené. Pozvánkový e-mail je odeslán automaticky.',
  tourModalTitle: 'Formulář zaměstnance',
  tourModalText: 'Zadejte jméno, e-mail, roli, kvalifikaci, dny dovolené a hodinovou sazbu. Stav aktivní/neaktivní lze také nastavit zde.',
  selected: 'vybrano',
  activate: 'Aktivovat',
  deactivate: 'Deaktivovat',
  setRole: 'Nastavit roli',
  apply: 'Pouzit',
  clearSelection: 'Zrusit vyber',
  vacationPerYear: 'Dovolena/rok',
  vacationDaysPerYear: 'Dny dovolene/rok',
  editEmployee: 'Upravit zamestnance',
  firstName: 'Jmeno',
  firstNamePlaceholder: 'Max',
  lastName: 'Prijmeni',
  lastNamePlaceholder: 'Novak',
  emailPlaceholder: "max{'@'}priklad.cz",
  password: 'Heslo',
  passwordPlaceholder: 'Prazdne = automaticky vygenerovat',
  passwordHint: 'Nechte prazdne pro automaticke vytvoreni bezpecneho startovniho hesla.',
  sendInvite: 'Odeslat pozvankovy e-mail zamestnanci',
  sendInviteHint: 'Posle e-mail s prihlasenim a startovnim heslem (SMTP musi byt nastaveno).',
  billingRate: 'Prodejni hodinova sazba',
  weeklyHours: 'Tydenni hodiny',
  collectiveAgreement: 'Kolektivni smlouva',
  brtvApply: 'Pouzit BRTV Stavebnictvi pro tohoto zamestnance',
  brtvApplyHint: 'Pri vypnuti se pro vypocet planovaneho casu pouziji individualni tydenni hodiny.',
  personnelNumber: 'Personalni cislo',
  personnelPlaceholder: 'napr. 00001',
  costCenterPlaceholder: 'napr. 100',
  calendarColor: 'Barva kalendare',
  colorAuto: 'Prideleno automaticky',
  workingDaysDefault: 'Pracovni dny · vychozi: 30',
  vacationEditWarning: 'Zmeni i kontingent v aktualnim roce',
  employeeCreated: 'Zamestnanec vytvoren',
  createdSuccess: 'byl uspesne vytvoren.',
  generatedPasswordHint: 'Nasledujici startovni heslo bylo vygenerovano automaticky. Bezpecne si jej ulozte:',
  copy: 'Kopirovat',
  inviteSent: 'Pozvankovy e-mail byl odeslan',
  inviteFailed: 'E-mail se nepodarilo odeslat. Zkontrolujte SMTP.',
  bulkDeleteConfirm: 'Trvale smazat {count} zamestnancu (GDPR pseudonymizace)?',
  bulkActivated: 'Aktivovano',
  bulkDeactivated: 'Deaktivovano',
  bulkDeleted: 'Smazano',
  bulkRoleUpdated: 'Role aktualizovana',
  bulkError: 'Chyba hromadne akce',
  requiredFields: 'Vyplnte vsechna povinna pole',
  saved: 'Zamestnanec ulozen',
  copyFailed: 'Kopirovani se nezdarilo',
  deleteConfirm: 'Smazat {name}? (GDPR pseudonymizace)',
  deleted: 'Zamestnanec smazan',
  deleteModalTitle: 'Smazat zamestnance',
  deleteModalText: 'opravdu smazat? (pseudonymizace GDPR)',
  deleteAndReduce: 'Smazat a snizit predplatne',
  deleteAndReduceHint: 'Zamestnanec bude smazan a predplatne snizeno o 1 misto (od dalsiho obdobi).',
  deleteKeepSeat: 'Smazat a ponechat misto',
  deleteKeepSeatHint: 'Zamestnanec bude smazan ale misto zustane volne pro novou osobu.',
  limitReachedTitle: 'Dosazeny limit uzivatelu',
  limitReachedText: 'Dosahli jste maximalniho poctu uzivatelu pro vase aktualni predplatne. Chcete pridat dalsiho uzivatele? Budete presmerovani na Stripe pro potvrzeni zmeny.',
  upgradeSeats: 'Rozsirit mista',
  upgradeDone: 'Predplatne uspesne aktualizovano',
  lockedByOther: 'Prave upravuje {name}'
};

const permissionsDe = {
  title: 'Berechtigungen',
  infoText: 'Hier kannst du individuelle Berechtigungen pro Mitarbeiter anpassen, die von den Rollenberechtigungen abweichen.',
  infoItem1: 'Die Berechtigungen werden in Echtzeit angepasst und haben sofortige Wirkung.',
  infoItem2: 'Individuelle Berechtigungen überschreiben die Berechtigungen, die der Mitarbeiter durch seine Rolle erhält.',
  infoItem3: 'Individuell gewährte Berechtigungen werden zusätzlich zu den Rollenberechtigungen gewährt.',
  infoItem4: 'Individuell entzogene Berechtigungen entziehen die Berechtigung, auch wenn sie durch die Rolle gewährt wird.',
  subtitle: 'Individuelle Rechte pro Mitarbeiter anpassen',
  employee: 'Mitarbeiter',
  select: 'Auswaehlen',
  fromRole: 'Durch Rolle',
  grantedIndividually: 'Individuell gewaehrt',
  revokedIndividually: 'Individuell entzogen',
  revoked: 'entzogen',
  individual: 'individuell',
  role: 'Rolle',
  grant: 'Individuell gewaehren',
  revoke: 'Individuell entziehen',
  clearOverride: 'Override entfernen',
  selectEmployee: 'Mitarbeiter auswählen',
  selectEmployeeHint: 'Waehle einen Mitarbeiter um seine Berechtigungen anzupassen',
  startTour: 'Führung starten',
  tourSelectTitle: 'Mitarbeiter auswählen',
  tourSelectText: 'Wähle einen Mitarbeiter aus um dessen Berechtigungen einzusehen und individuell anzupassen.',
  tourLegendTitle: 'Legende',
  tourLegendText: 'Gelb = aus der Rolle vererbt, Grün = individuell erteilt, Rot = individuell entzogen.',
  tourGridTitle: 'Berechtigungsmatrix',
  tourGridText: 'Alle Berechtigungen geordnet nach Bereichen. ✓ erteilt eine Berechtigung individuell, ✕ entzieht sie – auch wenn die Rolle sie normalerweise hätte. ↺ setzt die individuelle Änderung zurück.',
  tourSaveTitle: 'Änderungen speichern',
  tourSaveText: 'Änderungen werden erst gespeichert wenn du auf "Speichern" klickst. Mit "Zurücksetzen" werden alle Änderungen dieser Sitzung verworfen.',
  unsavedChanges: 'Ungespeicherte Änderungen',
  save: 'Berechtigungen speichern',
  saved: 'Berechtigungen gespeichert',
  groups: {
    schedule: 'Baustellenplanung',
    reports: 'Berichte',
    documents: 'Dokumente',
    settings: 'Einstellungen',
    customers: 'Kunden',
    material: 'Material',
    media: 'Medien',
    employees: 'Mitarbeiter',
    projects: 'Projekte',
    vacation: 'Urlaub',
    timeRecording: 'Zeiterfassung',
    payroll: 'Lohnabrechnung'
  },
  perms: {
    admin_audit_read: 'Audit-Log anzeigen',
    admin_dashboard_read: 'Dashboard anzeigen',
    admin_impersonate: 'Nutzer impersonieren',
    admin_tenants_deactivate: 'Tenants deaktivieren',
    admin_tenants_read: 'Tenants lesen',
    admin_tenants_write: 'Tenants bearbeiten',
    admin_users_create: 'Nutzer anlegen',
    admin_users_delete: 'Nutzer löschen',
    admin_users_read: 'Nutzer lesen',
    admin_users_reset_password: 'Passwort zurücksetzen',
    admin_users_update: 'Nutzer bearbeiten',
    schedule_manage: 'Planung verwalten',
    schedule_view: 'Planung ansehen',
    reports_view: 'Berichte ansehen',
    payroll_view: 'Lohnabrechnung ansehen',
    documents_create: 'Dokumente erstellen',
    documents_delete: 'Dokumente löschen',
    documents_edit: 'Dokumente bearbeiten',
    documents_view: 'Dokumente ansehen',
    settings_manage: 'Einstellungen verwalten',
    customers_create: 'Kunden erstellen',
    customers_delete: 'Kunden löschen',
    customers_edit: 'Kunden bearbeiten',
    customers_view: 'Kunden ansehen',
    material_book: 'Lagerbewegungen buchen',
    material_manage: 'Artikel & Lieferanten',
    material_view: 'Lager ansehen',
    media_delete: 'Medien löschen',
    media_upload: 'Medien hochladen',
    media_view: 'Medien ansehen',
    employees_manage: 'Mitarbeiter verwalten',
    employees_view: 'Mitarbeiter ansehen',
    projects_create: 'Projekte erstellen',
    projects_delete: 'Projekte löschen',
    projects_edit: 'Projekte bearbeiten',
    projects_view: 'Projekte ansehen',
    vacation_approve: 'Urlaub genehmigen',
    vacation_manage: 'Urlaubskontingent',
    vacation_request: 'Urlaub beantragen',
    time_edit_all: 'Alle Zeiten bearbeiten',
    time_view_all: 'Alle Zeiten ansehen',
    time_view_own: 'Eigene Zeit ansehen'
  }
};

const permissionsEn = {
  title: 'Permissions',
  subtitle: 'Adjust individual rights per employee',
  employee: 'Employee',
  select: 'Select',
  fromRole: 'From role',
  grantedIndividually: 'Granted individually',
  revokedIndividually: 'Revoked individually',
  revoked: 'revoked',
  individual: 'individual',
  role: 'role',
  grant: 'Grant individually',
  revoke: 'Revoke individually',
  clearOverride: 'Remove override',
  selectEmployee: 'Select employee',
  selectEmployeeHint: 'Select an employee to adjust permissions',
  startTour: 'Start tour',
  tourSelectTitle: 'Select employee',
  tourSelectText: 'Choose an employee to view and individually adjust their permissions.',
  tourLegendTitle: 'Legend',
  tourLegendText: 'Yellow = inherited from role, Green = individually granted, Red = individually revoked.',
  tourGridTitle: 'Permission matrix',
  tourGridText: 'All permissions organised by area. ✓ grants a permission individually, ✕ revokes it – even if the role normally has it. ↺ resets the individual change.',
  tourSaveTitle: 'Save changes',
  tourSaveText: 'Changes are only saved when you click "Save". Use "Reset" to discard all changes from this session.',
  unsavedChanges: 'Unsaved changes',
  save: 'Save permissions',
  saved: 'Permissions saved',
  groups: {
    schedule: 'Site Planning',
    reports: 'Reports',
    documents: 'Documents',
    settings: 'Settings',
    customers: 'Customers',
    material: 'Material',
    media: 'Media',
    employees: 'Employees',
    projects: 'Projects',
    vacation: 'Vacation',
    timeRecording: 'Time Recording',
    payroll: 'Payroll'
  },
  perms: {
    admin_audit_read: 'View audit log',
    admin_dashboard_read: 'View dashboard',
    admin_impersonate: 'Impersonate user',
    admin_tenants_deactivate: 'Deactivate tenants',
    admin_tenants_read: 'View tenants',
    admin_tenants_write: 'Edit tenants',
    admin_users_create: 'Create user',
    admin_users_delete: 'Delete user',
    admin_users_read: 'View users',
    admin_users_reset_password: 'Reset password',
    admin_users_update: 'Edit user',
    schedule_manage: 'Manage planning',
    schedule_view: 'View planning',
    reports_view: 'View reports',
    payroll_view: 'View payroll',
    documents_create: 'Create documents',
    documents_delete: 'Delete documents',
    documents_edit: 'Edit documents',
    documents_view: 'View documents',
    settings_manage: 'Manage settings',
    customers_create: 'Create customers',
    customers_delete: 'Delete customers',
    customers_edit: 'Edit customers',
    customers_view: 'View customers',
    material_book: 'Book stock movements',
    material_manage: 'Articles & suppliers',
    material_view: 'View warehouse',
    media_delete: 'Delete media',
    media_upload: 'Upload media',
    media_view: 'View media',
    employees_manage: 'Manage employees',
    employees_view: 'View employees',
    projects_create: 'Create projects',
    projects_delete: 'Delete projects',
    projects_edit: 'Edit projects',
    projects_view: 'View projects',
    vacation_approve: 'Approve vacation',
    vacation_manage: 'Vacation allowance',
    vacation_request: 'Request vacation',
    time_edit_all: 'Edit all time entries',
    time_view_all: 'View all time entries',
    time_view_own: 'View own time entries'
  }
};

const permissionsFr = {
  title: 'Autorisations',
  subtitle: 'Ajuster les droits individuels par employe',
  employee: 'Employe',
  select: 'Selectionner',
  fromRole: 'Selon le role',
  grantedIndividually: 'Accorde individuellement',
  revokedIndividually: 'Retire individuellement',
  revoked: 'retire',
  individual: 'individuel',
  role: 'role',
  grant: 'Accorder individuellement',
  revoke: 'Retirer individuellement',
  clearOverride: 'Supprimer override',
  selectEmployee: 'Selectionner un employe',
  selectEmployeeHint: 'Choisissez un employe pour ajuster ses autorisations',
  startTour: 'Lancer la visite guidée',
  tourSelectTitle: 'Sélectionner un employé',
  tourSelectText: 'Choisissez un employé pour consulter et ajuster ses autorisations individuellement.',
  tourLegendTitle: 'Légende',
  tourLegendText: 'Jaune = hérité du rôle, Vert = accordé individuellement, Rouge = révoqué individuellement.',
  tourGridTitle: 'Matrice des autorisations',
  tourGridText: 'Toutes les autorisations par domaine. ✓ accorde individuellement, ✕ révoque – même si le rôle l\'a normalement. ↺ réinitialise la modification individuelle.',
  tourSaveTitle: 'Sauvegarder',
  tourSaveText: 'Les modifications ne sont enregistrées qu\'après avoir cliqué sur "Sauvegarder". "Réinitialiser" annule toutes les modifications de la session.',
  unsavedChanges: 'Modifications non enregistrees',
  save: 'Enregistrer autorisations',
  saved: 'Autorisations enregistrees',
  groups: {
    schedule: 'Planification chantier',
    reports: 'Rapports',
    documents: 'Documents',
    settings: 'Parametres',
    customers: 'Clients',
    material: 'Materiel',
    media: 'Medias',
    employees: 'Employes',
    projects: 'Projets',
    vacation: 'Conges',
    timeRecording: 'Saisie des temps',
    payroll: 'Paie'
  },
  perms: {
    admin_audit_read: "Afficher le journal d'audit",
    admin_dashboard_read: 'Afficher le tableau de bord',
    admin_impersonate: "Usurper l'identite d'un utilisateur",
    admin_tenants_deactivate: 'Desactiver les tenants',
    admin_tenants_read: 'Voir les tenants',
    admin_tenants_write: 'Modifier les tenants',
    admin_users_create: 'Creer un utilisateur',
    admin_users_delete: 'Supprimer un utilisateur',
    admin_users_read: 'Voir les utilisateurs',
    admin_users_reset_password: 'Reinitialiser le mot de passe',
    admin_users_update: 'Modifier un utilisateur',
    schedule_manage: 'Gerer la planification',
    schedule_view: 'Voir la planification',
    reports_view: 'Voir les rapports',
    payroll_view: 'Voir la paie',
    documents_create: 'Creer des documents',
    documents_delete: 'Supprimer des documents',
    documents_edit: 'Modifier des documents',
    documents_view: 'Voir les documents',
    settings_manage: 'Gerer les parametres',
    customers_create: 'Creer des clients',
    customers_delete: 'Supprimer des clients',
    customers_edit: 'Modifier des clients',
    customers_view: 'Voir les clients',
    material_book: 'Comptabiliser les mouvements de stock',
    material_manage: 'Articles et fournisseurs',
    material_view: 'Voir le stock',
    media_delete: 'Supprimer des medias',
    media_upload: 'Televerser des medias',
    media_view: 'Voir les medias',
    employees_manage: 'Gerer les employes',
    employees_view: 'Voir les employes',
    projects_create: 'Creer des projets',
    projects_delete: 'Supprimer des projets',
    projects_edit: 'Modifier des projets',
    projects_view: 'Voir les projets',
    vacation_approve: 'Approuver les conges',
    vacation_manage: 'Contingent de conges',
    vacation_request: 'Demander des conges',
    time_edit_all: 'Modifier toutes les saisies de temps',
    time_view_all: 'Voir toutes les saisies de temps',
    time_view_own: 'Voir ses propres saisies de temps'
  }
};

const permissionsIt = {
  title: 'Permessi',
  subtitle: 'Regola i diritti individuali per dipendente',
  employee: 'Dipendente',
  select: 'Seleziona',
  fromRole: 'Dal ruolo',
  grantedIndividually: 'Concesso individualmente',
  revokedIndividually: 'Revocato individualmente',
  revoked: 'revocato',
  individual: 'individuale',
  role: 'ruolo',
  grant: 'Concedi individualmente',
  revoke: 'Revoca individualmente',
  clearOverride: 'Rimuovi override',
  selectEmployee: 'Seleziona dipendente',
  selectEmployeeHint: 'Seleziona un dipendente per modificare i permessi',
  startTour: 'Avvia la guida',
  tourSelectTitle: 'Seleziona dipendente',
  tourSelectText: 'Scegli un dipendente per visualizzare e modificare individualmente i suoi permessi.',
  tourLegendTitle: 'Legenda',
  tourLegendText: 'Giallo = ereditato dal ruolo, Verde = concesso individualmente, Rosso = revocato individualmente.',
  tourGridTitle: 'Matrice permessi',
  tourGridText: 'Tutti i permessi per area. ✓ concede individualmente, ✕ revoca – anche se il ruolo lo prevede normalmente. ↺ annulla la modifica individuale.',
  tourSaveTitle: 'Salvare modifiche',
  tourSaveText: 'Le modifiche vengono salvate solo cliccando "Salva". "Reimposta" annulla tutte le modifiche della sessione.',
  unsavedChanges: 'Modifiche non salvate',
  save: 'Salva permessi',
  saved: 'Permessi salvati',
  groups: {
    schedule: 'Pianificazione cantiere',
    reports: 'Report',
    documents: 'Documenti',
    settings: 'Impostazioni',
    customers: 'Clienti',
    material: 'Materiale',
    media: 'Media',
    employees: 'Dipendenti',
    projects: 'Progetti',
    vacation: 'Ferie',
    timeRecording: 'Rilevazione ore',
    payroll: 'Buste paga'
  },
  perms: {
    admin_audit_read: 'Visualizza registro audit',
    admin_dashboard_read: 'Visualizza dashboard',
    admin_impersonate: 'Impersona utente',
    admin_tenants_deactivate: 'Disattiva tenant',
    admin_tenants_read: 'Visualizza tenant',
    admin_tenants_write: 'Modifica tenant',
    admin_users_create: 'Crea utente',
    admin_users_delete: 'Elimina utente',
    admin_users_read: 'Visualizza utenti',
    admin_users_reset_password: 'Reimposta password',
    admin_users_update: 'Modifica utente',
    schedule_manage: 'Gestisci pianificazione',
    schedule_view: 'Visualizza pianificazione',
    reports_view: 'Visualizza report',
    payroll_view: 'Visualizza paghe',
    documents_create: 'Crea documenti',
    documents_delete: 'Elimina documenti',
    documents_edit: 'Modifica documenti',
    documents_view: 'Visualizza documenti',
    settings_manage: 'Gestisci impostazioni',
    customers_create: 'Crea clienti',
    customers_delete: 'Elimina clienti',
    customers_edit: 'Modifica clienti',
    customers_view: 'Visualizza clienti',
    material_book: 'Registra movimenti magazzino',
    material_manage: 'Articoli e fornitori',
    material_view: 'Visualizza magazzino',
    media_delete: 'Elimina media',
    media_upload: 'Carica media',
    media_view: 'Visualizza media',
    employees_manage: 'Gestisci dipendenti',
    employees_view: 'Visualizza dipendenti',
    projects_create: 'Crea progetti',
    projects_delete: 'Elimina progetti',
    projects_edit: 'Modifica progetti',
    projects_view: 'Visualizza progetti',
    vacation_approve: 'Approva ferie',
    vacation_manage: 'Contingente ferie',
    vacation_request: 'Richiedi ferie',
    time_edit_all: 'Modifica tutte le ore',
    time_view_all: 'Visualizza tutte le ore',
    time_view_own: 'Visualizza le proprie ore'
  }
};

const permissionsPl = {
  title: 'Uprawnienia',
  subtitle: 'Dostosuj indywidualne prawa dla pracownika',
  employee: 'Pracownik',
  select: 'Wybierz',
  fromRole: 'Z roli',
  grantedIndividually: 'Nadane indywidualnie',
  revokedIndividually: 'Odebrane indywidualnie',
  revoked: 'odebrane',
  individual: 'indywidualne',
  role: 'rola',
  grant: 'Nadaj indywidualnie',
  revoke: 'Odbierz indywidualnie',
  clearOverride: 'Usun nadpisanie',
  selectEmployee: 'Wybierz pracownika',
  selectEmployeeHint: 'Wybierz pracownika, aby zmienic jego uprawnienia',
  startTour: 'Uruchom przewodnik',
  tourSelectTitle: 'Wybierz pracownika',
  tourSelectText: 'Wybierz pracownika aby wyświetlić i indywidualnie dostosować jego uprawnienia.',
  tourLegendTitle: 'Legenda',
  tourLegendText: 'Żółty = odziedziczony z roli, Zielony = przyznany indywidualnie, Czerwony = cofnięty indywidualnie.',
  tourGridTitle: 'Matryca uprawnień',
  tourGridText: 'Wszystkie uprawnienia według obszarów. ✓ przyznaje indywidualnie, ✕ cofa – nawet jeśli rola normalnie to ma. ↺ resetuje indywidualną zmianę.',
  tourSaveTitle: 'Zapisz zmiany',
  tourSaveText: 'Zmiany są zapisywane dopiero po kliknięciu "Zapisz". "Resetuj" odrzuca wszystkie zmiany z tej sesji.',
  unsavedChanges: 'Niezapisane zmiany',
  save: 'Zapisz uprawnienia',
  saved: 'Uprawnienia zapisane',
  groups: {
    schedule: 'Planowanie budowy',
    reports: 'Raporty',
    documents: 'Dokumenty',
    settings: 'Ustawienia',
    customers: 'Klienci',
    material: 'Material',
    media: 'Media',
    employees: 'Pracownicy',
    projects: 'Projekty',
    vacation: 'Urlop',
    timeRecording: 'Ewidencja czasu',
    payroll: 'Lista płac'
  },
  perms: {
    admin_audit_read: 'Wyswietl log audytu',
    admin_dashboard_read: 'Wyswietl dashboard',
    admin_impersonate: 'Podszywanie sie pod uzytkownika',
    admin_tenants_deactivate: 'Dezaktywuj tenantow',
    admin_tenants_read: 'Przegladaj tenantow',
    admin_tenants_write: 'Edytuj tenantow',
    admin_users_create: 'Utworz uzytkownika',
    admin_users_delete: 'Usun uzytkownika',
    admin_users_read: 'Przegladaj uzytkownikow',
    admin_users_reset_password: 'Resetuj haslo',
    admin_users_update: 'Edytuj uzytkownika',
    schedule_manage: 'Zarzadzaj planowaniem',
    schedule_view: 'Przegladaj planowanie',
    reports_view: 'Przegladaj raporty',
    payroll_view: 'Przegladaj place',
    documents_create: 'Utworz dokumenty',
    documents_delete: 'Usun dokumenty',
    documents_edit: 'Edytuj dokumenty',
    documents_view: 'Przegladaj dokumenty',
    settings_manage: 'Zarzadzaj ustawieniami',
    customers_create: 'Utworz klientow',
    customers_delete: 'Usun klientow',
    customers_edit: 'Edytuj klientow',
    customers_view: 'Przegladaj klientow',
    material_book: 'Ksieguj ruchy magazynowe',
    material_manage: 'Artykuly i dostawcy',
    material_view: 'Przegladaj magazyn',
    media_delete: 'Usun media',
    media_upload: 'Przesylaj media',
    media_view: 'Przegladaj media',
    employees_manage: 'Zarzadzaj pracownikami',
    employees_view: 'Przegladaj pracownikow',
    projects_create: 'Utworz projekty',
    projects_delete: 'Usun projekty',
    projects_edit: 'Edytuj projekty',
    projects_view: 'Przegladaj projekty',
    vacation_approve: 'Zatwierdz urlop',
    vacation_manage: 'Kontyngent urlopowy',
    vacation_request: 'Wnioskuj o urlop',
    time_edit_all: 'Edytuj wszystkie czasy',
    time_view_all: 'Przegladaj wszystkie czasy',
    time_view_own: 'Przegladaj wlasny czas'
  }
};

const permissionsCs = {
  title: 'Opravneni',
  subtitle: 'Upravit individualni prava pro zamestnance',
  employee: 'Zamestnanec',
  select: 'Vybrat',
  fromRole: 'Podle role',
  grantedIndividually: 'Individualne povoleno',
  revokedIndividually: 'Individualne odebrano',
  revoked: 'odebrano',
  individual: 'individualni',
  role: 'role',
  grant: 'Povolit individualne',
  revoke: 'Odebrat individualne',
  clearOverride: 'Odstranit override',
  selectEmployee: 'Vyberte zamestnance',
  selectEmployeeHint: 'Vyberte zamestnance pro upravu opravneni',
  startTour: 'Spustit průvodce',
  tourSelectTitle: 'Vybrat zaměstnance',
  tourSelectText: 'Vyberte zaměstnance pro zobrazení a individuální úpravu jeho oprávnění.',
  tourLegendTitle: 'Legenda',
  tourLegendText: 'Žlutá = zděděno z role, Zelená = uděleno individuálně, Červená = odebráno individuálně.',
  tourGridTitle: 'Matice oprávnění',
  tourGridText: 'Všechna oprávnění podle oblastí. ✓ uděluje individuálně, ✕ odebírá – i když to role normálně má. ↺ vrátí individuální změnu.',
  tourSaveTitle: 'Uložit změny',
  tourSaveText: 'Změny se uloží až po kliknutí na "Uložit". "Resetovat" zahodí všechny změny z této relace.',
  unsavedChanges: 'Neulozene zmeny',
  save: 'Ulozit opravneni',
  saved: 'Opravneni ulozena',
  groups: {
    schedule: 'Planovani stavby',
    reports: 'Zpravy',
    documents: 'Dokumenty',
    settings: 'Nastaveni',
    customers: 'Zakaznici',
    material: 'Material',
    media: 'Media',
    employees: 'Zamestnanci',
    projects: 'Projekty',
    vacation: 'Dovolena',
    timeRecording: 'Evidence casu',
    payroll: 'Mzdy'
  },
  perms: {
    admin_audit_read: 'Zobrazit audit log',
    admin_dashboard_read: 'Zobrazit dashboard',
    admin_impersonate: 'Vydavat se za uzivatele',
    admin_tenants_deactivate: 'Deaktivovat tenanty',
    admin_tenants_read: 'Cist tenanty',
    admin_tenants_write: 'Upravit tenanty',
    admin_users_create: 'Vytvorit uzivatele',
    admin_users_delete: 'Smazat uzivatele',
    admin_users_read: 'Cist uzivatele',
    admin_users_reset_password: 'Resetovat heslo',
    admin_users_update: 'Upravit uzivatele',
    schedule_manage: 'Spravovat planovani',
    schedule_view: 'Zobrazit planovani',
    reports_view: 'Zobrazit zpravy',
    payroll_view: 'Zobrazit mzdy',
    documents_create: 'Vytvorit dokumenty',
    documents_delete: 'Smazat dokumenty',
    documents_edit: 'Upravit dokumenty',
    documents_view: 'Zobrazit dokumenty',
    settings_manage: 'Spravovat nastaveni',
    customers_create: 'Vytvorit zakazniky',
    customers_delete: 'Smazat zakazniky',
    customers_edit: 'Upravit zakazniky',
    customers_view: 'Zobrazit zakazniky',
    material_book: 'Zauctovat pohyby skladu',
    material_manage: 'Polozky a dodavatele',
    material_view: 'Zobrazit sklad',
    media_delete: 'Smazat media',
    media_upload: 'Nahrat media',
    media_view: 'Zobrazit media',
    employees_manage: 'Spravovat zamestnance',
    employees_view: 'Zobrazit zamestnance',
    projects_create: 'Vytvorit projekty',
    projects_delete: 'Smazat projekty',
    projects_edit: 'Upravit projekty',
    projects_view: 'Zobrazit projekty',
    vacation_approve: 'Schvalit dovolenou',
    vacation_manage: 'Kontingent dovolene',
    vacation_request: 'Pozadat o dovolenou',
    time_edit_all: 'Upravit vsechny casy',
    time_view_all: 'Zobrazit vsechny casy',
    time_view_own: 'Zobrazit vlastni cas'
  }
};

const textBlocksDe = {
  title: 'Textbausteine',
  manage: 'Verwalten',
  loading: 'Lädt...',
  none: 'Keine Bausteine vorhanden',
  manageTitle: 'Textbausteine verwalten',
  titlePlaceholderShort: 'Titel',
  contentPlaceholderShort: 'Text...',
  newBlock: 'Neuer Baustein',
  titlePlaceholder: "Titel z.B. 'Zahlungsziel 14 Tage'",
  contentPlaceholder: 'Zahlbar innerhalb von 14 Tagen ohne Abzug...',
  create: 'Baustein erstellen',
  loadError: 'Fehler beim Laden der Bausteine',
  saved: 'Baustein gespeichert',
  created: 'Baustein erstellt',
  deleted: 'Baustein gelöscht',
  createError: 'Fehler beim Erstellen',
  deleteError: 'Fehler beim Löschen'
};

const textBlocksEn = {
  title: 'Text blocks',
  manage: 'Manage',
  loading: 'Loading...',
  none: 'No text blocks available',
  manageTitle: 'Manage text blocks',
  titlePlaceholderShort: 'Title',
  contentPlaceholderShort: 'Text...',
  newBlock: 'New text block',
  titlePlaceholder: "Title e.g. 'Payment term 14 days'",
  contentPlaceholder: 'Payable within 14 days without deduction...',
  create: 'Create text block',
  loadError: 'Error loading text blocks',
  saved: 'Text block saved',
  created: 'Text block created',
  deleted: 'Text block deleted',
  createError: 'Error while creating',
  deleteError: 'Error while deleting'
};

const textBlocksFr = {
  title: 'Blocs de texte',
  manage: 'Gerer',
  loading: 'Chargement...',
  none: 'Aucun bloc de texte disponible',
  manageTitle: 'Gerer les blocs de texte',
  titlePlaceholderShort: 'Titre',
  contentPlaceholderShort: 'Texte...',
  newBlock: 'Nouveau bloc de texte',
  titlePlaceholder: "Titre p. ex. 'Delai de paiement 14 jours'",
  contentPlaceholder: 'Payable sous 14 jours sans deduction...',
  create: 'Creer un bloc de texte',
  loadError: 'Erreur lors du chargement des blocs de texte',
  saved: 'Bloc de texte enregistre',
  created: 'Bloc de texte cree',
  deleted: 'Bloc de texte supprime',
  createError: 'Erreur lors de la creation',
  deleteError: 'Erreur lors de la suppression'
};
const textBlocksIt = {
  title: 'Blocchi di testo',
  manage: 'Gestisci',
  loading: 'Caricamento...',
  none: 'Nessun blocco di testo disponibile',
  manageTitle: 'Gestisci i blocchi di testo',
  titlePlaceholderShort: 'Titolo',
  contentPlaceholderShort: 'Testo...',
  newBlock: 'Nuovo blocco di testo',
  titlePlaceholder: "Titolo ad es. 'Termine di pagamento 14 giorni'",
  contentPlaceholder: 'Pagabile entro 14 giorni senza detrazione...',
  create: 'Crea blocco di testo',
  loadError: 'Errore durante il caricamento dei blocchi di testo',
  saved: 'Blocco di testo salvato',
  created: 'Blocco di testo creato',
  deleted: 'Blocco di testo eliminato',
  createError: 'Errore durante la creazione',
  deleteError: 'Errore durante l\'eliminazione'
};
const textBlocksPl = {
  title: 'Bloki tekstowe',
  manage: 'Zarzadzaj',
  loading: 'Ladowanie...',
  none: 'Brak dostepnych blokow tekstowych',
  manageTitle: 'Zarzadzaj blokami tekstowymi',
  titlePlaceholderShort: 'Tytul',
  contentPlaceholderShort: 'Tekst...',
  newBlock: 'Nowy blok tekstowy',
  titlePlaceholder: "Tytul np. 'Warunki platnosci 14 dni'",
  contentPlaceholder: 'Platne w ciagu 14 dni bez potraceń...',
  create: 'Utwòrz blok tekstowy',
  loadError: 'Blad w ladowaniu blokow tekstowych',
  saved: 'Blok tekstowy zapisany',
  created: 'Blok tekstowy utworzony',
  deleted: 'Blok tekstowy usuniety',
  createError: 'Blad podczas tworzenia',
  deleteError: 'Blad podczas usuwania'
};
const textBlocksCs = {
  title: 'Textove bloky',
  manage: 'Spravovat',
  loading: 'Nacitam...',
  none: 'Zadne textove bloky dostupne',
  manageTitle: 'Spravovat textove bloky',
  titlePlaceholderShort: 'Nazev',
  contentPlaceholderShort: 'Text...',
  newBlock: 'Novy textovy blok',
  titlePlaceholder: "Nazev napr. 'Platebni podminky 14 dni'",
  contentPlaceholder: 'Splatne v priebehu 14 dni bez slevy...',
  create: 'Vytvorit textovy blok',
  loadError: 'Chyba pri nacitani textovych bloku',
  saved: 'Textovy blok ulozeny',
  created: 'Textovy blok vytvoren',
  deleted: 'Textovy blok smazan',
  createError: 'Chyba pri vytvareni',
  deleteError: 'Chyba pri smezeni'
};

const inventoryDe = {
  title: 'Inventur',
  infoText: 'Hier kannst du den Bestand deines Lagers überprüfen und korrigieren.',
  infoItem1: 'Suche nach Artikelnummer, Bezeichnung oder Lagerort.',
  infoItem2: 'Zähle den tatsächlichen Bestand und trage diesen ein.',
  infoItem3: 'Nur positive oder negative Korrekturen werden gebucht.',
  infoItem4: 'Die Korrekturen werden automatisch gebucht.',
  toWarehouse: 'Zum Lager',
  startTour: 'Führung starten',
  tourHintTitle: 'Was ist eine Inventur?',
  tourHintText: 'Bei einer Inventur zählst du den tatsächlichen Bestand jedes Artikels und trägst ihn hier ein. Abweichungen zum Systembestand werden als Korrekturbuchungen gespeichert.',
  tourFilterTitle: 'Filter',
  tourFilterText: 'Suche nach Artikelnummer oder Bezeichnung, filtere nach Kategorie oder zeige nur Artikel mit eingetragenen Abweichungen.',
  tourTableTitle: 'Artikelliste',
  tourTableText: 'Trage den gezählten Bestand in das Feld "Gezählt" ein. Abweichungen zum Soll-Bestand werden farbig markiert. Mit der Notiz-Spalte kannst du Kommentare je Artikel hinterlegen.',
  tourActionsTitle: 'Inventur abschließen',
  tourActionsText: 'Mit "Artikel auswählen" kannst du die Inventur auf bestimmte Artikel einschränken. "Inventur abschließen" bucht alle Abweichungen als Korrekturen ins Lager – eine Zusammenfassung wird vorher zur Bestätigung angezeigt.',
  finishInventory: 'Inventur abschließen',
  hintPrefix: 'Nur',
  hintStrong: 'positive oder negative Korrekturen',
  hintSuffix: 'werden gebucht.',
  searchPlaceholder: 'Suche nach Artikelnummer, Bezeichnung oder Lagerort',
  allCategories: 'Alle Kategorien',
  onlyChanged: 'Nur gezählte Positionen',
  selected: 'Ausgewählt',
  selectItems: 'Positionen auswählen',
  items: 'Positionen',
  articleNo: 'Artikel-Nr.',
  description: 'Bezeichnung',
  category: 'Kategorie',
  stockLocation: 'Lagerort',
  expectedStock: 'Soll-Bestand',
  countedStock: 'Ist-Bestand',
  diff: 'Differenz',
  corrections: 'Korrekturen',
  globalNoteOptional: 'Globale Notiz',
  globalNotePlaceholder: 'Optionaler Hinweis für alle Korrekturen',
  defaultGlobalNote: 'Inventurkorrektur',
  finishNow: 'Jetzt abschließen',
  cancelFinish: 'Abbrechen',
  confirmPrefix: 'Es werden',
  confirmSuffix: 'Korrekturen gebucht. Fortfahren?',
  correctionsBooked: 'Korrekturen wurden gebucht',
  finishedTitle: 'Inventur abgeschlossen',
  finishError: 'Fehler beim Abschließen',
  back: 'Zurück',
  scan: 'Scannen',
  scanNotFound: 'Artikel nicht in dieser Liste gefunden'
};

const inventoryEn = {
  title: 'Inventory Count',
  infoText: 'Here you can check and correct the stock levels of your inventory.',
  infoItem1: 'Search by article number, description or storage location.',
  infoItem2: 'Count the actual stock and enter it.',
  infoItem3: 'Only positive or negative adjustments will be posted.',
  infoItem4: 'The adjustments will be automatically posted.',
  toWarehouse: 'To Warehouse',
  startTour: 'Start tour',
  tourHintTitle: 'What is a stocktake?',
  tourHintText: 'During a stocktake you count the actual quantity of each item and enter it here. Discrepancies against the system stock are saved as correction bookings.',
  tourFilterTitle: 'Filter',
  tourFilterText: 'Search by article number or description, filter by category, or show only items with entered discrepancies.',
  tourTableTitle: 'Article list',
  tourTableText: 'Enter the counted stock in the "Counted" field. Discrepancies from the target stock are highlighted in colour. Use the note column to add comments per item.',
  tourActionsTitle: 'Complete stocktake',
  tourActionsText: 'Use "Select items" to restrict the stocktake to specific articles. "Complete stocktake" books all discrepancies as corrections – a summary is shown for confirmation beforehand.',
  finishInventory: 'Complete Inventory',
  hintPrefix: 'Only',
  hintStrong: 'positive or negative adjustments',
  hintSuffix: 'will be posted.',
  searchPlaceholder: 'Search by article number, description or storage location',
  allCategories: 'All categories',
  onlyChanged: 'Only counted items',
  selected: 'Selected',
  selectItems: 'Select items',
  items: 'items',
  articleNo: 'Article no.',
  description: 'Description',
  category: 'Category',
  stockLocation: 'Storage location',
  expectedStock: 'Expected stock',
  countedStock: 'Counted stock',
  diff: 'Difference',
  corrections: 'Corrections',
  globalNoteOptional: 'Global note',
  globalNotePlaceholder: 'Optional note for all corrections',
  defaultGlobalNote: 'Inventory correction',
  finishNow: 'Complete now',
  cancelFinish: 'Cancel',
  confirmPrefix: 'This will post',
  confirmSuffix: 'corrections. Continue?',
  correctionsBooked: 'Corrections were posted',
  finishedTitle: 'Inventory completed',
  finishError: 'Error while completing inventory',
  back: 'Back',
  scan: 'Scan',
  scanNotFound: 'Item not found in this list'
};

const inventoryFr = {
  title: 'Inventaire',
  infoText: 'Ici, vous pouvez vérifier et corriger les niveaux de stock de votre inventaire.',
  infoItem1: 'Recherchez par numéro d\'article, description ou emplacement de stockage.',
  infoItem2: 'Comptez le stock réel et saisissez-le.',
  infoItem3: 'Seules les corrections positives ou négatives seront comptabilisées.',
  infoItem4: 'Les corrections seront automatiquement comptabilisées.',
  toWarehouse: 'Vers le stock',
  startTour: 'Lancer la visite guidée',
  tourHintTitle: 'Qu\'est-ce qu\'un inventaire ?',
  tourHintText: 'Lors d\'un inventaire vous comptez la quantité réelle de chaque article et la saisissez ici. Les écarts par rapport au stock système sont enregistrés comme corrections.',
  tourFilterTitle: 'Filtre',
  tourFilterText: 'Cherchez par numéro ou désignation, filtrez par catégorie ou affichez uniquement les articles avec des écarts saisis.',
  tourTableTitle: 'Liste des articles',
  tourTableText: 'Saisissez le stock compté dans le champ "Compté". Les écarts sont mis en évidence par couleur. La colonne note permet d\'ajouter des commentaires par article.',
  tourActionsTitle: 'Terminer l\'inventaire',
  tourActionsText: 'Utilisez "Sélectionner articles" pour limiter l\'inventaire à certains articles. "Terminer l\'inventaire" enregistre tous les écarts comme corrections – un récapitulatif s\'affiche pour confirmation.',
  finishInventory: 'Terminer l\'inventaire',
  hintPrefix: 'Seules les',
  hintStrong: 'corrections positives ou negatives',
  hintSuffix: 'seront comptabilisees.',
  searchPlaceholder: 'Rechercher par numero d\'article, designation ou emplacement',
  allCategories: 'Toutes les categories',
  onlyChanged: 'Seulement les positions comptees',
  selected: 'Selectionne',
  selectItems: 'Selectionner des positions',
  items: 'positions',
  articleNo: 'N d\'article',
  description: 'Designation',
  category: 'Categorie',
  stockLocation: 'Emplacement',
  expectedStock: 'Stock theorique',
  countedStock: 'Stock compte',
  diff: 'Difference',
  corrections: 'Corrections',
  globalNoteOptional: 'Note globale',
  globalNotePlaceholder: 'Note optionnelle pour toutes les corrections',
  defaultGlobalNote: 'Correction d\'inventaire',
  finishNow: 'Terminer maintenant',
  cancelFinish: 'Annuler',
  confirmPrefix: 'Cela va comptabiliser',
  confirmSuffix: 'corrections. Continuer ?',
  correctionsBooked: 'Les corrections ont ete comptabilisees',
  finishedTitle: 'Inventaire termine',
  finishError: 'Erreur lors de la finalisation',
  back: 'Retour',
  scan: 'Scanner',
  scanNotFound: 'Article introuvable dans cette liste'
};

const inventoryIt = {
  title: 'Inventario',
  infoText: 'Qui puoi controllare e correggere le giacenze del tuo magazzino.',
  infoItem1: 'Cerca per numero articolo, descrizione o ubicazione.',
  infoItem2: 'Conta la giacenza effettiva e inseriscila.',
  infoItem3: 'Solo le correzioni positive o negative verranno registrate.',
  infoItem4: 'Le correzioni verranno registrate automaticamente.',
  toWarehouse: 'Al magazzino',
  startTour: 'Avvia la guida',
  tourHintTitle: 'Cos\'è un inventario?',
  tourHintText: 'Durante un inventario conti la quantità reale di ogni articolo e la inserisci qui. Le discrepanze rispetto allo stock di sistema vengono salvate come correzioni.',
  tourFilterTitle: 'Filtro',
  tourFilterText: 'Cerca per numero articolo o descrizione, filtra per categoria o mostra solo articoli con discrepanze inserite.',
  tourTableTitle: 'Lista articoli',
  tourTableText: 'Inserisci lo stock contato nel campo "Contato". Le discrepanze vengono evidenziate a colori. La colonna note permette commenti per articolo.',
  tourActionsTitle: 'Completare l\'inventario',
  tourActionsText: 'Usa "Seleziona articoli" per limitare l\'inventario ad articoli specifici. "Completa inventario" registra tutte le discrepanze come correzioni – un riepilogo viene mostrato per conferma.',
  finishInventory: 'Completa inventario',
  hintPrefix: 'Solo',
  hintStrong: 'correzioni positive o negative',
  hintSuffix: 'verranno registrate.',
  searchPlaceholder: 'Cerca per numero articolo, descrizione o ubicazione',
  allCategories: 'Tutte le categorie',
  onlyChanged: 'Solo le posizioni conteggiate',
  selected: 'Selezionati',
  selectItems: 'Seleziona posizioni',
  items: 'posizioni',
  articleNo: 'N. articolo',
  description: 'Descrizione',
  category: 'Categoria',
  stockLocation: 'Ubicazione',
  expectedStock: 'Giacenza teorica',
  countedStock: 'Giacenza conteggiata',
  diff: 'Differenza',
  corrections: 'Correzioni',
  globalNoteOptional: 'Nota globale',
  globalNotePlaceholder: 'Nota opzionale per tutte le correzioni',
  defaultGlobalNote: 'Correzione inventario',
  finishNow: 'Completa ora',
  cancelFinish: 'Annulla',
  confirmPrefix: 'Verranno registrate',
  confirmSuffix: 'correzioni. Continuare?',
  correctionsBooked: 'Le correzioni sono state registrate',
  finishedTitle: 'Inventario completato',
  finishError: 'Errore durante il completamento',
  back: 'Indietro',
  scan: 'Scansiona',
  scanNotFound: 'Articolo non trovato in questo elenco'
};

const inventoryPl = {
  title: 'Inwentaryzacja',
  infoText: 'Tutaj możesz sprawdzić i poprawić poziomy zapasów w Twoim magazynie.',
  infoItem1: 'Wyszukaj po numerze artykułu, opisie lub lokalizacji magazynowej.',
  infoItem2: 'Zlicz rzeczywisty stan magazynowy i wprowadź go.',
  infoItem3: 'Tylko poprawki dodatnie lub ujemne zostaną zaksięgowane.',
  infoItem4: 'Poprawki zostaną automatycznie zaksięgowane.',
  toWarehouse: 'Do magazynu',
  startTour: 'Uruchom przewodnik',
  tourHintTitle: 'Co to jest inwentaryzacja?',
  tourHintText: 'Podczas inwentaryzacji liczysz rzeczywisty stan każdego artykułu i wprowadzasz go tutaj. Rozbieżności ze stanem w systemie są zapisywane jako korekty.',
  tourFilterTitle: 'Filtr',
  tourFilterText: 'Szukaj według numeru artykułu lub opisu, filtruj według kategorii lub pokaż tylko artykuły z wprowadzonymi rozbieżnościami.',
  tourTableTitle: 'Lista artykułów',
  tourTableText: 'Wprowadź zliczony stan w polu "Zliczono". Rozbieżności są oznaczone kolorami. Kolumna notatek umożliwia dodanie komentarzy do artykułu.',
  tourActionsTitle: 'Zakończ inwentaryzację',
  tourActionsText: 'Użyj "Wybierz artykuły" aby ograniczyć inwentaryzację do określonych artykułów. "Zakończ inwentaryzację" księguje wszystkie rozbieżności jako korekty – podsumowanie jest wyświetlane do potwierdzenia.',
  finishInventory: 'Zakoncz inwentaryzacje',
  hintPrefix: 'Tylko',
  hintStrong: 'korekty dodatnie lub ujemne',
  hintSuffix: 'zostana zaksiegowane.',
  searchPlaceholder: 'Szukaj po numerze artykulu, nazwie lub lokalizacji',
  allCategories: 'Wszystkie kategorie',
  onlyChanged: 'Tylko policzone pozycje',
  selected: 'Wybrane',
  selectItems: 'Wybierz pozycje',
  items: 'pozycje',
  articleNo: 'Nr artykulu',
  description: 'Nazwa',
  category: 'Kategoria',
  stockLocation: 'Lokalizacja magazynowa',
  expectedStock: 'Stan oczekiwany',
  countedStock: 'Stan policzony',
  diff: 'Roznica',
  corrections: 'Korekty',
  globalNoteOptional: 'Notatka globalna',
  globalNotePlaceholder: 'Opcjonalna notatka dla wszystkich korekt',
  defaultGlobalNote: 'Korekta inwentaryzacji',
  finishNow: 'Zakoncz teraz',
  cancelFinish: 'Anuluj',
  confirmPrefix: 'Zostanie zaksiegowanych',
  confirmSuffix: 'korekt. Kontynuowac?',
  correctionsBooked: 'Korekty zostaly zaksiegowane',
  finishedTitle: 'Inwentaryzacja zakonczona',
  finishError: 'Blad podczas konczenia inwentaryzacji',
  back: 'Wroc',
  scan: 'Skanuj',
  scanNotFound: 'Artykul nie znaleziony na tej liscie'
};

const inventoryCs = {
  title: 'Inventura',
  infoText: 'Zde můžete zkontrolovat a opravit úrovně zásob ve vašem skladu.',
  infoItem1: 'Hledejte podle čísla položky, názvu nebo umístění skladu.',
  infoItem2: 'Sečtěte skutečný stav skladu a zadejte ho.',
  infoItem3: 'Budou zaznamenány pouze kladné nebo záporné úpravy.',
  infoItem4: 'Úpravy budou automaticky zaznamenány.',
  toWarehouse: 'Do skladu',
  startTour: 'Spustit průvodce',
  tourHintTitle: 'Co je inventura?',
  tourHintText: 'Při inventuře spočítáte skutečný stav každé položky a zadáte jej zde. Odchylky od stavu v systému se uloží jako korekce.',
  tourFilterTitle: 'Filtr',
  tourFilterText: 'Hledejte podle čísla artiklu nebo popisu, filtrujte podle kategorie nebo zobrazte pouze položky se zadanými odchylkami.',
  tourTableTitle: 'Seznam artikelů',
  tourTableText: 'Zadejte spočítaný stav do pole "Spočítáno". Odchylky jsou barevně zvýrazněny. Sloupec poznámky umožňuje komentáře ke každé položce.',
  tourActionsTitle: 'Dokončit inventuru',
  tourActionsText: 'Použijte "Vybrat položky" pro omezení inventury na konkrétní artikly. "Dokončit inventuru" zaúčtuje všechny odchylky jako korekce – před tím se zobrazí přehled k potvrzení.',
  finishInventory: 'Dokončit inventuru',
  hintPrefix: 'Pouze',
  hintStrong: 'kladné nebo záporné korekce',
  hintSuffix: 'budou zaúčtovány.',
  searchPlaceholder: 'Hledat podle čísla položky, názvu nebo umístění skladu',
  allCategories: 'šechny kategorie',
  onlyChanged: 'Pouze sečtené položky',
  selected: 'Vybráno',
  selectItems: 'Vybrat položky',
  items: 'položky',
  articleNo: 'Cislo polozky',
  description: 'Nazev',
  category: 'Kategorie',
  stockLocation: 'Umisteni skladu',
  expectedStock: 'Ocekavany stav',
  countedStock: 'Secteny stav',
  diff: 'Rozdil',
  corrections: 'Korekce',
  globalNoteOptional: 'Globalni poznamka',
  globalNotePlaceholder: 'Volitelna poznamka pro vsechny korekce',
  defaultGlobalNote: 'Korekce inventury',
  finishNow: 'Dokoncit nyni',
  cancelFinish: 'Zrusit',
  confirmPrefix: 'Budou zauctovany',
  confirmSuffix: 'korekce. Pokracovat?',
  correctionsBooked: 'Korekce byly zauctovany',
  finishedTitle: 'Inventura dokoncena',
  finishError: 'Chyba pri dokonceni inventury',
  back: 'Zpet',
  scan: 'Skenovat',
  scanNotFound: 'Polozka na tomto seznamu nenalezena'
};

const docFormDe = {
  editOffer: 'Angebot bearbeiten',
  editInvoice: 'Rechnung bearbeiten',
  editCreditNote: 'Gutschrift bearbeiten',
  newOffer: 'Neues Angebot',
  newInvoice: 'Neue Rechnung',
  newCreditNote: 'Neue Gutschrift',
  createOffer: 'Angebot erstellen',
  createInvoice: 'Rechnung erstellen',
  createCreditNote: 'Gutschrift erstellen',
  creditNoteData: 'Gutschriftsdaten',
  offerEditInfoText: 'Hier kannst du dein Angebot bearbeiten. Du kannst Kunde oder Projekt ändern. Du kannst Positionen hinzufügen oder ändern und die restlichen Daten anpassen.',
  offerInfoItem1: 'Bei Angebots-Thema kannst du ein Thema eingeben, um ähnliche Angebote zu finden und Positionen zu übernehmen. Das funktioniert nur, wenn du bereits Angebote mit Themen hast.',
  offerInfoItem2: 'Das Dropdown bei Positionen, bei dem Auto-Erkennung steht, versucht die Datengrundlage festzulegen, um einen Import durch das Programm Dietrich´s zu ermöglichen. Es ist keine klassische Importfunktion, sondern versucht die Daten so zu erkennen, dass sie in das Angebot übernommen werden können.',
  offerInfoItem3: 'Du kannst Positionen hinzufügen, entfernen oder ändern. Alle Änderungen werden automatisch im Angebot übernommen.',
  offerInfoItem4: 'Das Angebotsdatum wird automatisch auf das aktuelle Datum gesetzt, kann aber geändert werden. Das Gültigkeitsdatum wird automatisch auf 30 Tage nach Angebotsdatum gesetzt, kann aber ebenfalls geändert werden.',
  offerInfoItem5: 'Die Steuer wird auch aus den Standard-Einstellungen übernommen. Wenn der Kunde eine Privatperson ist, wird dieser Steuersatz verwendet. Wenn es allerdings ein Unternehmen ist, wird keine Steuer auf dem Angebot angegeben (Reverse Charge).',
  offerInfoItem6: 'Man kann gesondert einen Rabatt, Skonto und Skonto-Frist angeben. Diese Angaben werden dann in einem Hinweis auf dem Angebot angedruckt.',
  offerCreateInfoText: 'Hier kannst du dein Angebot erstellen. Wähle Kunde und Projekt, füge Positionen hinzu und passe die Angebotsdaten an.',
  invoiceEditInfoText: 'Hier kannst du deine Rechnung bearbeiten. Wähle Kunde und Projekt, füge Positionen hinzu und passe die Angebots- und Rechnungsdaten an.',
  invoiceCreateInfoText: 'Hier kannst du deine Rechnung erstellen. Wähle Kunde und Projekt, füge Positionen hinzu und passe die Rechnungsdaten an.',
  invoiceInfoItem1: 'Wenn dem Projekt Arbeitsstunden und Materialien zugeordnet sind, werden diese automatisch angezeigt. Du kannst jede Position übernehmen, teilweise übernehmen oder stehen lassen.',
  invoiceInfoItem2: 'Es gibt die Rechnungstypen, Standard-, Abschlags-, Teil- und Schlussrechnung.',
  invoiceInfoItem3: 'Bei Abschlagsrechnungen kannst du den prozentualen Anteil oder Betrag der Rechnung angeben.',
  invoiceInfoItem4: 'Das Rechnungsdatum wird automatisch auf das aktuelle Datum gesetzt, kann aber geändert werden. Das Fälligkeitsdatum wird automatisch auf 30 Tage nach Rechnungsdatum gesetzt, kann aber ebenfalls geändert werden.',
  invoiceInfoItem5: 'Die Steuer wird auch aus den Standard-Einstellungen übernommen. Wenn der Kunde eine Privatperson ist, wird dieser Steuersatz verwendet. Wenn es allerdings ein Unternehmen ist, wird keine Steuer auf der Rechnung angegeben (Reverse Charge).',
  invoiceInfoItem6: 'Man kann gesondert einen Rabatt, Skonto und Skonto-Frist angeben. Diese Angaben werden dann in einem Hinweis auf der Rechnung angedruckt.',
  docFormInfoItem1: 'Du kannst ebenso eine GAEB-Datei importieren, um Positionen von Ausschreibungen zu übernehmen.',
  docFormInfoItem2: 'Der Button "Material auswählen" öffnet eine Materialauswahl, mit der du Materialpositionen hinzufügen kannst.',
  docFormInfoItem3: 'Der Button "+ Position" fügt eine neue Position hinzu.',
  docFormInfoItem4: 'Jede Position hat einen Kurztext, einen Langtext, eine Menge, eine Einheit, einen Einzelpreis und einen Gesamtpreis. Nur der Kurztext ist verpflichtend.',
  docFormInfoItem5: 'Mögliche Einheiten sind z.B. Std. für Stunden, m2 für Quadratmeter, m für Meter, Stk. für Stück, km für Kilometer, Monat oder Pauschal.',
  docFormInfoItem6: 'Der Gesamtpreis wird automatisch aus Menge mal Einzelpreis berechnet.',
  docFormInfoItem7: 'Im Bereich Notizen & Fußzeile kannst du eine interne Notiz eingeben, die unter dem Gesamtpreis des Angebotes angedruckt wird, und eine Fußzeile, die z.B. Zahlungsbedingungen oder die Bankverbindung enthalten kann.',
  docFormInfoItem8: 'Für beide kannst du Textbausteine erstellen, die du anschließend wiederverwenden kannst.',
  docFormInfoItem9: 'Die Währung wird automatisch von den Standard-Einstellungen übernommen, sie kann aber auch manuell geändert werden.',
  customerProject: 'Kunde & Projekt',
  selectCustomer: 'Kunde auswählen',
  offerTopic: 'Angebots-Thema',
  topicLabel: 'Thema',
  topicPlaceholder: 'z.B. 120 qm Fassade dämmen inkl. Gerüst',
  searchingSimilarOffers: 'Suche ähnliche Angebote...',
  similarOffersHint: 'Ähnliche Angebote zur Orientierung und Übernahme:',
  similar: 'ähnlich',
  offerNet: 'Angebot netto',
  actualEffortNet: 'Ist-Aufwand netto',
  deviation: 'Abweichung',
  totalCheck: 'Gesamtcheck',
  comparedPositionsSingular: 'Vergleichsposition',
  comparedPositionsPlural: 'Vergleichspositionen',
  actualTotal: 'Ist gesamt',
  medianExpected: 'Median erwartet',
  averageExpected: 'Durchschnitt erwartet',
  medianWord: 'Median',
  averageWord: 'Durchschnitt',
  expectedApproxMedian: 'Erwartet ca. {amount} nach Median',
  atWith: 'bei',
  comparisonsSingular: 'Vergleich',
  comparisonsPlural: 'Vergleichen',
  actualShort: 'Ist',
  noComparablePositions: 'Keine vergleichbaren Positionen gefunden',
  refreshComparison: 'Vergleich aktualisieren',
  manualRefreshHint: 'Änderst du Positionen oder Thema, bitte den Vergleich aktualisieren.',
  startTour: 'Führung starten',
  tourCustomerTitle: 'Kunde & Projekt', tourCustomerText: 'Wähle den Kunden und optional das Projekt aus. Adressdaten werden automatisch übernommen.',
  tourCustomerCreditText: 'Wähle den Kunden. Die Gutschrift bezieht sich auf eine bereits gestellte Rechnung.',
  tourTopicTitle: 'Thema & Vergleich', tourTopicText: 'Beschreibe das Leistungsthema. Das System vergleicht automatisch ähnliche frühere Angebote – nützlich für Preisschätzungen.',
  tourPositionsTitle: 'Positionen', tourPositionsOfferText: 'Positionen mit Beschreibung, Menge und Preis erfassen. Importoptionen: CSV, GAEB oder direkt aus dem Projektkatalog. Stunden- und Materialbuchungen können übernommen werden.',
  tourPositionsInvoiceText: 'Für dieses Projekt wurden Stunden, Material und Fahrzeuge geladen. Mit den Buttons „Stunden übernehmen", „Material übernehmen" und „Fahrzeuge übernehmen" kannst du offene Buchungen direkt als Rechnungspositionen übernehmen.',
  tourPositionsCreditText: 'Positionen der Gutschrift erfassen. Üblicherweise spiegeln sie einzelne Positionen der Originalrechnung wider.',
  tourNotesTitle: 'Notizen & Fußzeile', tourNotesText: 'Interne Notizen erscheinen nur intern. Die Fußzeile erscheint auf dem Dokument – z.B. Zahlungsbedingungen. Textbausteine erleichtern die Eingabe.',
  tourSummaryTitle: 'Zusammenfassung', tourSummaryOfferText: 'Angebotsdatum, Gültig-bis-Datum, Währung, MwSt. und optionaler Rabatt. Gesamtsummen werden live berechnet.',
  tourSummaryInvoiceText: 'Rechnungsdatum, Fälligkeitsdatum, Währung, MwSt., Skonto und Rechnungstyp. Gesamtsummen werden live berechnet.',
  tourSummaryCreditText: 'Datum, Währung und MwSt. der Gutschrift. Gesamtsummen werden live berechnet.',
  tourRemainingTitle: 'Offene Buchungen', tourRemainingText: 'Hier siehst du nicht abgerechnete Stunden, Material und Fahrzeuge dieses Projekts. Mit dem ↓-Button übernimmst du einzelne Einträge als Rechnungsposition – du kannst die Menge dabei anpassen.',
  tourSaveTitle: 'Speichern', tourSaveText: '"Als Entwurf speichern" speichert ohne Statusänderung. "Speichern" schließt den Vorgang ab. Der Entwurf wird automatisch lokal gesichert.',
  applyPositions: 'Positionen übernehmen',
  importCsv: 'CSV importieren',
  importGaeb: 'GAEB importieren',
  csvImportHint: 'CSV kann je nach Lieferant variieren. Nutze Auto oder stelle Trennzeichen/Spalten ein.',
  autoDetect: 'Auto-Erkennung',
  delimiter: 'Trennzeichen',
  hasHeader: 'Header vorhanden',
  skipRows: 'Zeilen überspringen',
  saveProfile: 'Profil speichern',
  importing: 'Importiere...',
  columnDescription: 'Spalte: Bezeichnung',
  columnDescriptionPlaceholder: 'z.B. Kurztext',
  columnQuantity: 'Spalte: Menge',
  columnQuantityPlaceholder: 'z.B. Menge',
  columnUnit: 'Spalte: Einheit',
  columnUnitPlaceholder: 'z.B. Einheit',
  columnUnitPrice: 'Spalte: Einzelpreis',
  columnUnitPricePlaceholder: 'z.B. Einzelpreis',
  columnTotalPrice: 'Spalte: Gesamtpreis',
  columnTotalPricePlaceholder: 'z.B. Gesamtpreis',
  selectProjectFirstTitle: 'Bitte zuerst ein Projekt wählen',
  selectProjectFirstHint: 'Material kann nur mit Projektbezug vorgeschlagen werden.',
  position: 'Position',
  addHeader: 'Zwischenüberschrift',
  sectionHeaderPlaceholder: 'Abschnittsüberschrift...',
  applyHours: 'Stunden übernehmen',
  applyMaterials: 'Materialpositionen übernehmen',
  applyAssets: 'Fahrzeuge & Maschinen',
  selectMaterial: 'Material auswählen',
  addMaterialAsPosition: 'Material als Position hinzufügen',
  unbilledHours: 'Nicht abgerechnete Stunden',
  unbilledMaterial: 'Nicht abgerechnetes Material',
  unbilledAssets: 'Fahrzeuge & Maschinen',
  available: 'Verfügbar',
  done: 'erledigt',
  allBilled: 'Alle Stunden und Materialien bereits abgerechnet',
  noProjectAssets: 'Keine Fahrzeug- oder Maschineneinsätze vorhanden',
  assetsImported: '{count} Einsatz/Einsätze übernommen',
  assetsLoadError: 'Fehler beim Laden der Einsätze',
  dailyRate: 'Tagessatz', days: 'Tage',
  positionText: 'Positionstext',
  shortTextPlaceholder: 'Kurztext...',
  longTextPlaceholder: 'Langtext (optional)...',
  notesFooter: 'Notizen & Fußzeile',
  internalNote: 'Interne Notiz',
  internalNotePlaceholder: 'Interne Bemerkungen (erscheinen im PDF)...',
  footerPlaceholder: 'Zahlungsbedingungen, Bankverbindung...',
  offerData: 'Angebotsdaten',
  invoiceData: 'Rechnungsdaten',
  offerDate: 'Angebotsdatum',
  invoiceDate: 'Rechnungsdatum',
  dueDate: 'Fälligkeitsdatum',
  currency: 'Waehrung',
  net: 'Netto',
  invoiceType: 'Rechnungstyp',
  standard: 'Standard',
  depositPercent: 'Abschlag (%)',
  orAmount: 'oder Betrag',
  tax: 'Steuer',
  reverseChargeActive: 'Reverse Charge aktiv',
  reverseChargeHintPrefix: 'Auf',
  reverseChargeHintSuffix: 'erscheint automatisch der Vermerk',
  skontoPercent: 'Skonto (%)',
  skontoDays: 'Skonto-Frist (Tage)',
  skontoInvoiceHint: 'Hinweis auf Rechnung',
  profileAuto: 'Auto-Erkennung',
  profileDietrichStd: 'Dietrichs Standard (Header)',
  profileDietrichPos: 'Dietrichs mit Pos + Gesamt',
  profileDietrichRaw: 'Dietrichs Roh-Export (ohne Header)',
  profileCustom: 'Benutzerdefiniert',
  importProfileSaved: 'Importprofil gespeichert',
  taxModeAutoAfterCustomer: 'Wird nach Auswahl des Kunden automatisch gesetzt',
  taxModeCompany: 'Firmenkunde erkannt - Steuer wird automatisch mit 0% angesetzt',
  taxModePrivate: 'Privatkunde erkannt - Standardsatz aus Einstellungen wird verwendet',
  noSuggestedPositions: 'Im vorgeschlagenen Angebot wurden keine Positionen gefunden',
  positionsImportedWithFactor: 'Positionen aus {number} übernommen (Mengenfaktor {factor}x)',
  positionsImported: 'Positionen aus {number} übernommen',
  suggestionApplyError: 'Vorschlag konnte nicht übernommen werden',
  noProjectHours: 'Keine nicht abgerechneten Stunden für dieses Projekt gefunden',
  hoursImported: '{count} Mitarbeiter als Stundenpositionen übernommen',
  hoursLoadError: 'Fehler beim Laden der Stunden',
  noProjectMaterials: 'Keine Materialien für dieses Projekt gefunden',
  materialsImported: '{count} Materialien übernommen',
  materialsLoadError: 'Fehler beim Laden der Materialien',
  noCatalogMaterials: 'Keine Materialien für die Auswahl gefunden',
  materialCatalogLoaded: '{count} Materialien zur Auswahl geladen',
  materialCatalogLoadError: 'Fehler beim Laden der Materialauswahl',
  invalidQuantity: 'Bitte eine gültige Menge eingeben',
  materialAddedAsPosition: 'Material als Position hinzugefügt',
  noGaebPositions: 'Keine Positionen im GAEB-Dokument gefunden',
  gaebImported: '{count} Positionen aus GAEB {phase} importiert',
  gaebImportFailed: 'GAEB-Import fehlgeschlagen',
  noCsvPositions: 'Keine Positionen im CSV gefunden',
  csvImported: '{count} Positionen aus CSV importiert',
  csvImportFailed: 'CSV-Import fehlgeschlagen',
  employee: 'Mitarbeiter',
  activity: 'Taetigkeit',
  workingHours: 'Arbeitsstunden',
  documentSaved: '{type} {number} gespeichert',
  documentCreated: '{type} {number} erstellt',
  sentInvoicesNotEditable: 'Versendete Rechnungen koennen nicht mehr bearbeitet werden.',
  documentLockedByOther: 'Diese {type} wird gerade von {name} bearbeitet. Du kannst sie nur ansehen.'
};

const docFormEn = {
  editOffer: 'Edit offer',
  editInvoice: 'Edit invoice',
  editCreditNote: 'Edit credit note',
  newOffer: 'New offer',
  newInvoice: 'New invoice',
  newCreditNote: 'New credit note',
  createOffer: 'Create offer',
  createInvoice: 'Create invoice',
  createCreditNote: 'Create credit note',
  creditNoteData: 'Credit note data',
  offerEditInfoText: 'Here you can edit your offer. You can change the customer or project, add or modify line items, and adjust the remaining data.',
  offerInfoItem1: 'In the offer topic field you can enter a topic to find similar offers and import their line items. This only works if you already have offers with topics.',
  offerInfoItem2: 'The dropdown in the line items section labelled "Auto detect" tries to identify the data format to enable an import from the Dietrich\'s software. It is not a classic import function but attempts to recognise the data so it can be transferred into the offer.',
  offerInfoItem3: 'You can add, remove or change line items. All changes are automatically applied to the offer.',
  offerInfoItem4: 'The offer date is automatically set to the current date but can be changed. The validity date is automatically set to 30 days after the offer date but can also be changed.',
  offerInfoItem5: 'The tax rate is taken from the default settings. If the customer is a private individual, this tax rate is used. If it is a company, no tax is shown on the offer (reverse charge).',
  offerInfoItem6: 'You can separately specify a discount, cash discount and cash discount period. These details are then printed as a note on the offer.',
  offerCreateInfoText: 'Here you can create your offer. Select customer and project, add line items and adjust the offer data.',
  invoiceEditInfoText: 'Here you can edit your invoice. Select customer and project, add line items and adjust the offer and invoice data.',
  invoiceCreateInfoText: 'Here you can create your invoice. Select customer and project, add line items and adjust the invoice data.',
  invoiceInfoItem1: 'If work hours and materials are assigned to the project, they are automatically displayed. You can apply each item in full, partially, or leave it.',
  invoiceInfoItem2: 'Invoice types available are standard, deposit, partial and final invoice.',
  invoiceInfoItem3: 'For deposit invoices you can specify the percentage share or amount of the invoice.',
  invoiceInfoItem4: 'The invoice date is automatically set to the current date but can be changed. The due date is automatically set to 30 days after the invoice date but can also be changed.',
  invoiceInfoItem5: 'The tax rate is taken from the default settings. If the customer is a private individual, this tax rate is used. If it is a company, no tax is shown on the invoice (reverse charge).',
  invoiceInfoItem6: 'You can separately specify a discount, cash discount and cash discount period. These details are then printed as a note on the invoice.',
  docFormInfoItem1: 'You can also import a GAEB file to transfer line items from tenders.',
  docFormInfoItem2: 'The "Select material" button opens a material selection where you can add material line items.',
  docFormInfoItem3: 'The "+ Position" button adds a new line item.',
  docFormInfoItem4: 'Each line item has a short text, a long text, a quantity, a unit, a unit price and a total price. Only the short text is mandatory.',
  docFormInfoItem5: 'Possible units are e.g. h for hours, m2 for square metres, m for metres, pcs for pieces, km for kilometres, month or lump sum.',
  docFormInfoItem6: 'The total price is automatically calculated from quantity times unit price.',
  docFormInfoItem7: 'In the Notes & Footer section you can enter an internal note printed below the total price of the offer, and a footer that can contain e.g. payment terms or bank details.',
  docFormInfoItem8: 'For both you can create text blocks that you can reuse.',
  docFormInfoItem9: 'The currency is automatically taken from the default settings but can also be changed manually.',
  customerProject: 'Customer & project',
  selectCustomer: 'Select customer',
  offerTopic: 'Offer topic',
  topicLabel: 'Topic',
  topicPlaceholder: 'e.g. Insulate 120 sqm facade incl. scaffold',
  searchingSimilarOffers: 'Searching similar offers...',
  similarOffersHint: 'Similar offers for orientation and quick apply:',
  similar: 'similar',
  offerNet: 'Offer net',
  actualEffortNet: 'Actual effort net',
  deviation: 'Deviation',
  totalCheck: 'Overall check',
  comparedPositionsSingular: 'compared item',
  comparedPositionsPlural: 'compared items',
  actualTotal: 'Actual total',
  medianExpected: 'Expected median',
  averageExpected: 'Expected average',
  medianWord: 'Median',
  averageWord: 'Average',
  expectedApproxMedian: 'Expected approx. {amount} by median',
  atWith: 'with',
  comparisonsSingular: 'comparison',
  comparisonsPlural: 'comparisons',
  actualShort: 'Actual',
  noComparablePositions: 'No comparable items found',
  refreshComparison: 'Refresh comparison',
  manualRefreshHint: 'If you change items or topic, refresh the comparison.',
  startTour: 'Start tour',
  tourCustomerTitle: 'Customer & project', tourCustomerText: 'Select the customer and optionally the project. Address details are transferred automatically.',
  tourCustomerCreditText: 'Select the customer. The credit note relates to an already issued invoice.',
  tourTopicTitle: 'Topic & comparison', tourTopicText: 'Describe the topic. The system automatically compares similar past offers – useful for price estimates.',
  tourPositionsTitle: 'Line items', tourPositionsOfferText: 'Enter items with description, quantity and price. Import options: CSV, GAEB or directly from the project catalogue. Hours and material bookings can be imported.',
  tourPositionsInvoiceText: 'Hours, materials and vehicles have been loaded for this project. Use the "Import hours", "Import materials" and "Import vehicles" buttons to add open bookings directly as invoice line items.',
  tourPositionsCreditText: 'Enter credit note items. Usually they mirror individual positions of the original invoice.',
  tourNotesTitle: 'Notes & footer', tourNotesText: 'Internal notes appear internally only. The footer text appears on the document – e.g. payment terms. Text blocks speed up entry.',
  tourSummaryTitle: 'Summary', tourSummaryOfferText: 'Offer date, valid-until, currency, VAT and optional discount. Totals are calculated live.',
  tourSummaryInvoiceText: 'Invoice date, due date, currency, VAT, discount and invoice type. Totals are calculated live.',
  tourSummaryCreditText: 'Date, currency and VAT of the credit note. Totals are calculated live.',
  tourRemainingTitle: 'Open bookings', tourRemainingText: 'Shows unbilled hours, materials and vehicles for this project. Use the ↓ button to add individual entries as invoice line items – you can adjust the quantity before adding.',
  tourSaveTitle: 'Save', tourSaveText: '"Save as draft" saves without changing status. "Save" completes the process. The draft is automatically saved locally.',
  applyPositions: 'Apply positions',
  importCsv: 'Import CSV',
  importGaeb: 'Import GAEB',
  csvImportHint: 'CSV can vary by supplier. Use auto detect or configure delimiter/columns.',
  autoDetect: 'Auto detect',
  delimiter: 'Delimiter',
  hasHeader: 'Has header',
  skipRows: 'Skip rows',
  saveProfile: 'Save profile',
  importing: 'Importing...',
  columnDescription: 'Column: Description',
  columnDescriptionPlaceholder: 'e.g. short text',
  columnQuantity: 'Column: Quantity',
  columnQuantityPlaceholder: 'e.g. quantity',
  columnUnit: 'Column: Unit',
  columnUnitPlaceholder: 'e.g. unit',
  columnUnitPrice: 'Column: Unit price',
  columnUnitPricePlaceholder: 'e.g. unit price',
  columnTotalPrice: 'Column: Total price',
  columnTotalPricePlaceholder: 'e.g. total price',
  selectProjectFirstTitle: 'Please select a project first',
  selectProjectFirstHint: 'Materials can only be suggested with a linked project.',
  position: 'Position',
  addHeader: 'Section header',
  sectionHeaderPlaceholder: 'Section heading...',
  applyHours: 'Apply work hours',
  applyMaterials: 'Apply material line items',
  applyAssets: 'Vehicles & Machines',
  selectMaterial: 'Select material',
  addMaterialAsPosition: 'Add material as line item',
  unbilledHours: 'Unbilled hours',
  unbilledMaterial: 'Unbilled material',
  unbilledAssets: 'Vehicles & Machines',
  available: 'Available',
  done: 'done',
  allBilled: 'All hours and materials are already billed',
  noProjectAssets: 'No vehicle or machine assignments found',
  assetsImported: '{count} assignment(s) imported',
  assetsLoadError: 'Error loading assignments',
  dailyRate: 'Daily rate', days: 'days',
  positionText: 'Line item text',
  shortTextPlaceholder: 'Short text...',
  longTextPlaceholder: 'Long text (optional)...',
  notesFooter: 'Notes & footer',
  internalNote: 'Internal note',
  internalNotePlaceholder: 'Internal remarks (shown in PDF)...',
  footerPlaceholder: 'Payment terms, bank details...',
  offerData: 'Offer data',
  invoiceData: 'Invoice data',
  offerDate: 'Offer date',
  invoiceDate: 'Invoice date',
  dueDate: 'Due date',
  currency: 'Currency',
  net: 'Net',
  invoiceType: 'Invoice type',
  standard: 'Standard',
  depositPercent: 'Deposit (%)',
  orAmount: 'or amount',
  tax: 'Tax',
  reverseChargeActive: 'Reverse charge active',
  reverseChargeHintPrefix: 'On',
  reverseChargeHintSuffix: 'the following note is added automatically',
  skontoPercent: 'Cash discount (%)',
  skontoDays: 'Cash discount period (days)',
  skontoInvoiceHint: 'Note on invoice',
  profileAuto: 'Auto detect',
  profileDietrichStd: 'Dietrich standard (header)',
  profileDietrichPos: 'Dietrich with pos + total',
  profileDietrichRaw: 'Dietrich raw export (without header)',
  profileCustom: 'Custom',
  importProfileSaved: 'Import profile saved',
  taxModeAutoAfterCustomer: 'Set automatically after selecting customer',
  taxModeCompany: 'Company customer detected - tax is automatically set to 0%',
  taxModePrivate: 'Private customer detected - default tax from settings is used',
  noSuggestedPositions: 'No line items were found in the suggested offer',
  positionsImportedWithFactor: 'Imported line items from {number} (quantity factor {factor}x)',
  positionsImported: 'Imported line items from {number}',
  suggestionApplyError: 'Could not apply suggestion',
  noProjectHours: 'No unbilled hours found for this project',
  hoursImported: 'Applied {count} employees as hour line items',
  hoursLoadError: 'Error loading work hours',
  noProjectMaterials: 'No materials found for this project',
  materialsImported: 'Imported {count} materials',
  materialsLoadError: 'Error loading materials',
  noCatalogMaterials: 'No materials available for selection',
  materialCatalogLoaded: 'Loaded {count} materials for selection',
  materialCatalogLoadError: 'Error loading material selection',
  invalidQuantity: 'Please enter a valid quantity',
  materialAddedAsPosition: 'Material added as line item',
  noGaebPositions: 'No line items found in GAEB document',
  gaebImported: 'Imported {count} line items from GAEB {phase}',
  gaebImportFailed: 'GAEB import failed',
  noCsvPositions: 'No line items found in CSV',
  csvImported: 'Imported {count} line items from CSV',
  csvImportFailed: 'CSV import failed',
  employee: 'Employee',
  activity: 'Activity',
  workingHours: 'Working hours',
  documentSaved: '{type} {number} saved',
  documentCreated: '{type} {number} created',
  sentInvoicesNotEditable: 'Sent invoices can no longer be edited.',
  documentLockedByOther: 'This {type} is currently being edited by {name}. You can only view it.'
};

const docFormFr = {
  editOffer: 'Modifier le devis',
  editInvoice: 'Modifier la facture',
  editCreditNote: 'Modifier l\'avoir',
  newOffer: 'Nouveau devis',
  newInvoice: 'Nouvelle facture',
  newCreditNote: 'Nouvel avoir',
  createOffer: 'Creer un devis',
  createInvoice: 'Creer une facture',
  createCreditNote: 'Creer un avoir',
  creditNoteData: 'Donnees de l\'avoir',
  offerEditInfoText: 'Ici vous pouvez modifier votre devis. Vous pouvez changer le client ou le projet, ajouter ou modifier des positions et ajuster les autres donnees.',
  offerInfoItem1: 'Dans le champ "Objet du devis" vous pouvez saisir un objet pour trouver des devis similaires et en reprendre les positions. Cela ne fonctionne que si vous avez deja des devis avec des objets.',
  offerInfoItem2: 'Le menu deroulant dans les positions avec la mention "Auto-detection" tente d\'identifier le format des donnees pour permettre un import depuis le logiciel Dietrich\'s. Ce n\'est pas une fonction d\'import classique mais tente de reconnaitre les donnees pour les integrer dans le devis.',
  offerInfoItem3: 'Vous pouvez ajouter, supprimer ou modifier des positions. Toutes les modifications sont automatiquement appliquees au devis.',
  offerInfoItem4: 'La date du devis est automatiquement definie a la date du jour mais peut etre modifiee. La date de validite est automatiquement definie a 30 jours apres la date du devis mais peut egalement etre modifiee.',
  offerInfoItem5: 'La taxe est reprise des parametres par defaut. Si le client est un particulier, ce taux est utilise. S\'il s\'agit d\'une entreprise, aucune taxe n\'est indiquee sur le devis (autoliquidation).',
  offerInfoItem6: 'Vous pouvez indiquer separement une remise, un escompte et un delai d\'escompte. Ces informations sont ensuite imprimees en note sur le devis.',
  offerCreateInfoText: 'Ici vous pouvez creer votre devis. Selectionnez le client et le projet, ajoutez des positions et ajustez les donnees du devis.',
  invoiceEditInfoText: 'Ici vous pouvez modifier votre facture. Selectionnez le client et le projet, ajoutez des positions et ajustez les donnees du devis et de la facture.',
  invoiceCreateInfoText: 'Ici vous pouvez creer votre facture. Selectionnez le client et le projet, ajoutez des positions et ajustez les donnees de la facture.',
  invoiceInfoItem1: 'Si des heures de travail et des materiaux sont attribues au projet, ils sont automatiquement affiches. Vous pouvez reprendre chaque position en totalite, partiellement ou la laisser.',
  invoiceInfoItem2: 'Les types de facture disponibles sont : standard, acompte, partielle et finale.',
  invoiceInfoItem3: 'Pour les factures d\'acompte, vous pouvez indiquer le pourcentage ou le montant de la facture.',
  invoiceInfoItem4: 'La date de facture est automatiquement definie a la date du jour mais peut etre modifiee. La date d\'echeance est automatiquement definie a 30 jours apres la date de facture mais peut egalement etre modifiee.',
  invoiceInfoItem5: 'La taxe est reprise des parametres par defaut. Si le client est un particulier, ce taux est utilise. S\'il s\'agit d\'une entreprise, aucune taxe n\'est indiquee sur la facture (autoliquidation).',
  invoiceInfoItem6: 'Vous pouvez indiquer separement une remise, un escompte et un delai d\'escompte. Ces informations sont ensuite imprimees en note sur la facture.',
  docFormInfoItem1: 'Vous pouvez egalement importer un fichier GAEB pour reprendre des positions d\'appels d\'offres.',
  docFormInfoItem2: 'Le bouton "Selectionner le materiel" ouvre une selection de materiaux avec laquelle vous pouvez ajouter des positions de materiel.',
  docFormInfoItem3: 'Le bouton "+ Position" ajoute une nouvelle position.',
  docFormInfoItem4: 'Chaque position dispose d\'un texte court, d\'un texte long, d\'une quantite, d\'une unite, d\'un prix unitaire et d\'un prix total. Seul le texte court est obligatoire.',
  docFormInfoItem5: 'Les unites possibles sont par ex. h pour heures, m2 pour metres carres, m pour metres, pcs pour pieces, km pour kilometres, mois ou forfait.',
  docFormInfoItem6: 'Le prix total est calcule automatiquement a partir de la quantite multipliee par le prix unitaire.',
  docFormInfoItem7: 'Dans la section Notes et pied de page vous pouvez saisir une note interne imprimee sous le prix total du devis et un pied de page pouvant contenir par ex. les conditions de paiement ou les coordonnees bancaires.',
  docFormInfoItem8: 'Pour les deux vous pouvez creer des blocs de texte que vous pouvez reutiliser.',
  docFormInfoItem9: 'La devise est automatiquement reprise des parametres par defaut mais peut egalement etre modifiee manuellement.',
  customerProject: 'Client et projet',
  selectCustomer: 'Selectionner un client',
  offerTopic: 'Objet du devis',
  topicLabel: 'Objet',
  topicPlaceholder: 'p. ex. isolation de facade 120 m² avec echafaudage',
  searchingSimilarOffers: 'Recherche de devis similaires...',
  similarOffersHint: 'Devis similaires pour orientation et reprise rapide :',
  similar: 'similaire',
  offerNet: 'Devis net',
  actualEffortNet: 'Cout reel net',
  deviation: 'Ecart',
  totalCheck: 'Controle global',
  comparedPositionsSingular: 'position comparee',
  comparedPositionsPlural: 'positions comparees',
  actualTotal: 'Total reel',
  medianExpected: 'Mediane attendue',
  averageExpected: 'Moyenne attendue',
  medianWord: 'Mediane',
  averageWord: 'Moyenne',
  expectedApproxMedian: 'Attendu env. {amount} selon la mediane',
  atWith: 'avec',
  comparisonsSingular: 'comparaison',
  comparisonsPlural: 'comparaisons',
  actualShort: 'Reel',
  noComparablePositions: 'Aucune position comparable trouvee',
  refreshComparison: 'Actualiser la comparaison',
  manualRefreshHint: 'Si vous modifiez les positions ou le sujet, actualisez la comparaison.',
  startTour: 'Lancer la visite guidée',
  tourCustomerTitle: 'Client & projet', tourCustomerText: 'Sélectionnez le client et éventuellement le projet. Les coordonnées sont reprises automatiquement.',
  tourCustomerCreditText: 'Sélectionnez le client. L\'avoir se rapporte à une facture déjà émise.',
  tourTopicTitle: 'Sujet & comparaison', tourTopicText: 'Décrivez le sujet. Le système compare automatiquement des devis similaires passés – utile pour les estimations.',
  tourPositionsTitle: 'Lignes', tourPositionsOfferText: 'Saisissez les lignes. Import : CSV, GAEB ou catalogue projet. Les heures et réservations matériaux peuvent être importées.',
  tourPositionsInvoiceText: 'Heures, matériaux et véhicules ont été chargés pour ce projet. Utilisez les boutons "Reprendre heures", "Reprendre matériaux" et "Reprendre véhicules" pour les ajouter directement comme lignes.',
  tourPositionsCreditText: 'Saisissez les lignes de l\'avoir. En général elles reflètent des positions de la facture d\'origine.',
  tourNotesTitle: 'Notes & pied de page', tourNotesText: 'Les notes internes sont visibles en interne seulement. Le pied de page apparaît sur le document. Les blocs de texte facilitent la saisie.',
  tourSummaryTitle: 'Récapitulatif', tourSummaryOfferText: 'Date du devis, validité, devise, TVA et remise optionnelle. Totaux calculés en temps réel.',
  tourSummaryInvoiceText: 'Date de facturation, échéance, devise, TVA, escompte et type de facture. Totaux calculés en temps réel.',
  tourSummaryCreditText: 'Date, devise et TVA de l\'avoir. Totaux calculés en temps réel.',
  tourRemainingTitle: 'Réservations ouvertes', tourRemainingText: 'Affiche les heures, matériaux et véhicules non facturés pour ce projet. Utilisez le bouton ↓ pour ajouter des entrées individuelles comme lignes de facture – vous pouvez ajuster la quantité avant d\'ajouter.',
  tourSaveTitle: 'Sauvegarder', tourSaveText: '"Brouillon" sauvegarde sans changer le statut. "Sauvegarder" finalise. Le brouillon est sauvegardé automatiquement en local.',
  applyPositions: 'Reprendre les positions',
  importCsv: 'Importer CSV',
  importGaeb: 'Importer GAEB',
  csvImportHint: 'Le CSV peut varier selon le fournisseur. Utilisez l\'auto-detection ou reglez le separateur et les colonnes.',
  autoDetect: 'Auto-detection',
  delimiter: 'Separateur',
  hasHeader: 'En-tete present',
  skipRows: 'Ignorer les lignes',
  saveProfile: 'Enregistrer le profil',
  importing: 'Import en cours...',
  columnDescription: 'Colonne : Description',
  columnDescriptionPlaceholder: 'p. ex. texte court',
  columnQuantity: 'Colonne : Quantite',
  columnQuantityPlaceholder: 'p. ex. quantite',
  columnUnit: 'Colonne : Unite',
  columnUnitPlaceholder: 'p. ex. unite',
  columnUnitPrice: 'Colonne : Prix unitaire',
  columnUnitPricePlaceholder: 'p. ex. prix unitaire',
  columnTotalPrice: 'Colonne : Prix total',
  columnTotalPricePlaceholder: 'p. ex. prix total',
  selectProjectFirstTitle: 'Veuillez d\'abord selectionner un projet',
  selectProjectFirstHint: 'Le materiel ne peut etre propose qu\'avec un projet lie.',
  position: 'Position',
  addHeader: 'Titre de section',
  sectionHeaderPlaceholder: 'Titre de section...',
  applyHours: 'Reprendre les heures de travail',
  applyMaterials: 'Reprendre les positions materiel',
  applyAssets: 'Vehicules & Machines',
  selectMaterial: 'Selectionner le materiel',
  addMaterialAsPosition: 'Ajouter le materiel comme position',
  unbilledHours: 'Heures non facturees',
  unbilledMaterial: 'Materiel non facture',
  unbilledAssets: 'Vehicules & Machines',
  available: 'Disponible',
  done: 'termine',
  allBilled: 'Toutes les heures et tous les materiaux sont deja factures',
  noProjectAssets: 'Aucun vehicule ou machine affecte',
  assetsImported: '{count} affectation(s) importee(s)',
  assetsLoadError: 'Erreur lors du chargement des affectations',
  dailyRate: 'Tarif journalier', days: 'jours',
  positionText: 'Texte de position',
  shortTextPlaceholder: 'Texte court...',
  longTextPlaceholder: 'Texte long (optionnel)...',
  notesFooter: 'Notes et pied de page',
  internalNote: 'Note interne',
  internalNotePlaceholder: 'Remarques internes (affichees dans le PDF)...',
  footerPlaceholder: 'Conditions de paiement, coordonnees bancaires...',
  offerData: 'Donnees du devis',
  invoiceData: 'Donnees de facture',
  offerDate: 'Date du devis',
  invoiceDate: 'Date de facture',
  dueDate: 'Date d\'echeance',
  currency: 'Devise',
  net: 'Net',
  invoiceType: 'Type de facture',
  standard: 'Standard',
  depositPercent: 'Acompte (%)',
  orAmount: 'ou montant',
  tax: 'Taxe',
  reverseChargeActive: 'Autoliquidation active',
  reverseChargeHintPrefix: 'Sur',
  reverseChargeHintSuffix: 'la mention suivante est ajoutee automatiquement',
  skontoPercent: 'Escompte (%)',
  skontoDays: 'Delai d\'escompte (jours)',
  skontoInvoiceHint: 'Mention sur la facture',
  profileAuto: 'Auto-detection',
  profileDietrichStd: 'Dietrich standard (en-tete)',
  profileDietrichPos: 'Dietrich avec positions + total',
  profileDietrichRaw: 'Export brut Dietrich (sans en-tete)',
  profileCustom: 'Personnalise',
  importProfileSaved: 'Profil d\'import enregistre',
  taxModeAutoAfterCustomer: 'Defini automatiquement apres la selection du client',
  taxModeCompany: 'Client entreprise detecte - la taxe est automatiquement fixee a 0 %',
  taxModePrivate: 'Client particulier detecte - le taux standard des parametres est utilise',
  noSuggestedPositions: 'Aucune position trouvee dans le devis propose',
  positionsImportedWithFactor: 'Positions importees depuis {number} (facteur de quantite {factor}x)',
  positionsImported: 'Positions importees depuis {number}',
  suggestionApplyError: 'Impossible d\'appliquer la suggestion',
  noProjectHours: 'Aucune heure non facturee trouvee pour ce projet',
  hoursImported: '{count} employes repris comme positions d\'heures',
  hoursLoadError: 'Erreur lors du chargement des heures',
  noProjectMaterials: 'Aucun materiel trouve pour ce projet',
  materialsImported: '{count} materiaux importes',
  materialsLoadError: 'Erreur lors du chargement des materiaux',
  noCatalogMaterials: 'Aucun materiel disponible pour la selection',
  materialCatalogLoaded: '{count} materiaux charges pour la selection',
  materialCatalogLoadError: 'Erreur lors du chargement du catalogue de materiaux',
  invalidQuantity: 'Veuillez saisir une quantite valide',
  materialAddedAsPosition: 'Materiel ajoute comme position',
  noGaebPositions: 'Aucune position trouvee dans le document GAEB',
  gaebImported: '{count} positions importees depuis GAEB {phase}',
  gaebImportFailed: 'Echec de l\'import GAEB',
  noCsvPositions: 'Aucune position trouvee dans le CSV',
  csvImported: '{count} positions importees depuis le CSV',
  csvImportFailed: 'Echec de l\'import CSV',
  employee: 'Employe',
  activity: 'Activite',
  workingHours: 'Heures de travail',
  documentSaved: '{type} {number} enregistre',
  documentCreated: '{type} {number} cree',
  sentInvoicesNotEditable: 'Les factures envoyees ne peuvent plus etre modifiees.',
  documentLockedByOther: 'Ce document ({type}) est actuellement modifie par {name}. Vous pouvez seulement le consulter.'
};
const docFormIt = {
  editOffer: 'Modifica offerta',
  editInvoice: 'Modifica fattura',
  editCreditNote: 'Modifica nota di credito',
  newOffer: 'Nuova offerta',
  newInvoice: 'Nuova fattura',
  newCreditNote: 'Nuova nota di credito',
  createOffer: 'Crea offerta',
  createInvoice: 'Crea fattura',
  createCreditNote: 'Crea nota di credito',
  creditNoteData: 'Dati nota di credito',
  offerEditInfoText: 'Qui puoi modificare la tua offerta. Puoi cambiare il cliente o il progetto, aggiungere o modificare posizioni e adattare i dati rimanenti.',
  offerInfoItem1: 'Nel campo "Oggetto offerta" puoi inserire un oggetto per trovare offerte simili e riprenderne le posizioni. Questo funziona solo se hai gia offerte con oggetti.',
  offerInfoItem2: 'Il menu a discesa nelle posizioni con la voce "Rilevamento automatico" cerca di identificare il formato dei dati per consentire un\'importazione dal software Dietrich\'s. Non e una funzione di importazione classica ma tenta di riconoscere i dati in modo da poterli inserire nell\'offerta.',
  offerInfoItem3: 'Puoi aggiungere, rimuovere o modificare posizioni. Tutte le modifiche vengono applicate automaticamente all\'offerta.',
  offerInfoItem4: 'La data dell\'offerta viene automaticamente impostata alla data odierna ma puo essere modificata. La data di validita viene automaticamente impostata a 30 giorni dopo la data dell\'offerta ma puo essere anch\'essa modificata.',
  offerInfoItem5: 'L\'imposta viene ripresa dalle impostazioni predefinite. Se il cliente e un privato, viene utilizzata questa aliquota. Se invece e un\'azienda, nessuna imposta viene indicata sull\'offerta (reverse charge).',
  offerInfoItem6: 'E possibile indicare separatamente uno sconto, uno sconto cassa e un termine per lo sconto cassa. Queste informazioni vengono poi stampate come nota sull\'offerta.',
  offerCreateInfoText: 'Qui puoi creare la tua offerta. Seleziona il cliente e il progetto, aggiungi posizioni e adatta i dati dell\'offerta.',
  invoiceEditInfoText: 'Qui puoi modificare la tua fattura. Seleziona il cliente e il progetto, aggiungi posizioni e adatta i dati dell\'offerta e della fattura.',
  invoiceCreateInfoText: 'Qui puoi creare la tua fattura. Seleziona il cliente e il progetto, aggiungi posizioni e adatta i dati della fattura.',
  invoiceInfoItem1: 'Se al progetto sono associate ore di lavoro e materiali, vengono visualizzati automaticamente. Puoi riprendere ogni posizione integralmente, parzialmente o lasciarla.',
  invoiceInfoItem2: 'I tipi di fattura disponibili sono: standard, acconto, parziale e finale.',
  invoiceInfoItem3: 'Per le fatture di acconto puoi specificare la percentuale o l\'importo della fattura.',
  invoiceInfoItem4: 'La data della fattura viene automaticamente impostata alla data odierna ma puo essere modificata. La data di scadenza viene automaticamente impostata a 30 giorni dopo la data della fattura ma puo essere anch\'essa modificata.',
  invoiceInfoItem5: 'L\'imposta viene ripresa dalle impostazioni predefinite. Se il cliente e un privato, viene utilizzata questa aliquota. Se invece e un\'azienda, nessuna imposta viene indicata sulla fattura (reverse charge).',
  invoiceInfoItem6: 'E possibile indicare separatamente uno sconto, uno sconto cassa e un termine per lo sconto cassa. Queste informazioni vengono poi stampate come nota sulla fattura.',
  docFormInfoItem1: 'Puoi anche importare un file GAEB per riprendere posizioni da bandi di gara.',
  docFormInfoItem2: 'Il pulsante "Seleziona materiale" apre una selezione di materiali con cui puoi aggiungere posizioni di materiale.',
  docFormInfoItem3: 'Il pulsante "+ Posizione" aggiunge una nuova posizione.',
  docFormInfoItem4: 'Ogni posizione ha un testo breve, un testo lungo, una quantita, un\'unita, un prezzo unitario e un prezzo totale. Solo il testo breve e obbligatorio.',
  docFormInfoItem5: 'Le unita possibili sono ad es. h per ore, m2 per metri quadrati, m per metri, pz per pezzi, km per chilometri, mese o forfait.',
  docFormInfoItem6: 'Il prezzo totale viene calcolato automaticamente da quantita per prezzo unitario.',
  docFormInfoItem7: 'Nella sezione Note e pie di pagina puoi inserire una nota interna stampata sotto il prezzo totale dell\'offerta e un pie di pagina che puo contenere ad es. condizioni di pagamento o coordinate bancarie.',
  docFormInfoItem8: 'Per entrambi puoi creare blocchi di testo riutilizzabili.',
  docFormInfoItem9: 'La valuta viene automaticamente ripresa dalle impostazioni predefinite ma puo anche essere modificata manualmente.',
  customerProject: 'Cliente e progetto',
  selectCustomer: 'Seleziona cliente',
  offerTopic: 'Oggetto offerta',
  topicLabel: 'Oggetto',
  topicPlaceholder: 'ad es. isolamento facciata 120 mq incl. ponteggio',
  searchingSimilarOffers: 'Ricerca offerte simili...',
  similarOffersHint: 'Offerte simili per orientamento e applicazione rapida:',
  similar: 'simile',
  offerNet: 'Offerta netta',
  actualEffortNet: 'Costo effettivo netto',
  deviation: 'Scostamento',
  totalCheck: 'Controllo totale',
  comparedPositionsSingular: 'posizione confrontata',
  comparedPositionsPlural: 'posizioni confrontate',
  actualTotal: 'Totale effettivo',
  medianExpected: 'Mediana prevista',
  averageExpected: 'Media prevista',
  medianWord: 'Mediana',
  averageWord: 'Media',
  expectedApproxMedian: 'Previsto circa {amount} in base alla mediana',
  atWith: 'con',
  comparisonsSingular: 'confronto',
  comparisonsPlural: 'confronti',
  actualShort: 'Eff.',
  noComparablePositions: 'Nessuna posizione comparabile trovata',
  refreshComparison: 'Aggiorna confronto',
  manualRefreshHint: 'Se modifichi posizioni o oggetto, aggiorna il confronto.',
  startTour: 'Avvia la guida',
  tourCustomerTitle: 'Cliente & progetto', tourCustomerText: 'Seleziona il cliente e opzionalmente il progetto. I dati vengono ripresi automaticamente.',
  tourCustomerCreditText: 'Seleziona il cliente. La nota di credito si riferisce a una fattura già emessa.',
  tourTopicTitle: 'Oggetto & confronto', tourTopicText: 'Descrivi l\'oggetto. Il sistema confronta automaticamente offerte simili precedenti.',
  tourPositionsTitle: 'Voci', tourPositionsOfferText: 'Inserisci voci con descrizione, quantità e prezzo. Import: CSV, GAEB o catalogo progetto. Ore e materiali prenotati possono essere importati.',
  tourPositionsInvoiceText: 'Ore, materiali e veicoli sono stati caricati per questo progetto. Usa i pulsanti "Importa ore", "Importa materiali" e "Importa veicoli" per aggiungere prenotazioni aperte come voci.',
  tourPositionsCreditText: 'Inserisci le voci della nota di credito. In genere rispecchiano posizioni della fattura originale.',
  tourNotesTitle: 'Note & piè di pagina', tourNotesText: 'Le note interne sono solo per uso interno. Il piè di pagina appare sul documento. I blocchi testo facilitano l\'inserimento.',
  tourSummaryTitle: 'Riepilogo', tourSummaryOfferText: 'Data offerta, validità, valuta, IVA e sconto opzionale. Totali calcolati in tempo reale.',
  tourSummaryInvoiceText: 'Data fattura, scadenza, valuta, IVA, sconto e tipo fattura. Totali calcolati in tempo reale.',
  tourSummaryCreditText: 'Data, valuta e IVA della nota di credito. Totali calcolati in tempo reale.',
  tourRemainingTitle: 'Prenotazioni aperte', tourRemainingText: 'Mostra ore, materiali e veicoli non ancora fatturati per questo progetto. Usa il pulsante ↓ per aggiungere singole voci come posizioni di fattura – puoi regolare la quantità prima di aggiungere.',
  tourSaveTitle: 'Salva', tourSaveText: '"Salva bozza" salva senza cambiare stato. "Salva" finalizza. La bozza viene salvata automaticamente in locale.',
  applyPositions: 'Applica posizioni',
  importCsv: 'Importa CSV',
  importGaeb: 'Importa GAEB',
  csvImportHint: 'Il CSV puo variare in base al fornitore. Usa il rilevamento automatico o imposta delimitatore e colonne.',
  autoDetect: 'Rilevamento automatico',
  delimiter: 'Separatore',
  hasHeader: 'Header presente',
  skipRows: 'Salta righe',
  saveProfile: 'Salva profilo',
  importing: 'Importazione in corso...',
  columnDescription: 'Colonna: Descrizione',
  columnDescriptionPlaceholder: 'ad es. testo breve',
  columnQuantity: 'Colonna: Quantita',
  columnQuantityPlaceholder: 'ad es. quantita',
  columnUnit: 'Colonna: Unita',
  columnUnitPlaceholder: 'ad es. unita',
  columnUnitPrice: 'Colonna: Prezzo unitario',
  columnUnitPricePlaceholder: 'ad es. prezzo unitario',
  columnTotalPrice: 'Colonna: Prezzo totale',
  columnTotalPricePlaceholder: 'ad es. prezzo totale',
  selectProjectFirstTitle: 'Seleziona prima un progetto',
  selectProjectFirstHint: 'I materiali possono essere proposti solo con un progetto collegato.',
  position: 'Posizione',
  addHeader: 'Intestazione di sezione',
  sectionHeaderPlaceholder: 'Titolo sezione...',
  applyHours: 'Applica ore di lavoro',
  applyMaterials: 'Applica posizioni materiale',
  applyAssets: 'Veicoli & Macchine',
  selectMaterial: 'Seleziona materiale',
  addMaterialAsPosition: 'Aggiungi materiale come posizione',
  unbilledHours: 'Ore non fatturate',
  unbilledMaterial: 'Materiale non fatturato',
  unbilledAssets: 'Veicoli & Macchine',
  available: 'Disponibile',
  done: 'fatto',
  allBilled: 'Tutte le ore e i materiali sono gia fatturati',
  noProjectAssets: 'Nessun veicolo o macchina assegnato',
  assetsImported: '{count} assegnazione/i importata/e',
  assetsLoadError: 'Errore nel caricamento delle assegnazioni',
  dailyRate: 'Tariffa giornaliera', days: 'giorni',
  positionText: 'Testo posizione',
  shortTextPlaceholder: 'Testo breve...',
  longTextPlaceholder: 'Testo lungo (opzionale)...',
  notesFooter: 'Note e piè di pagina',
  internalNote: 'Nota interna',
  internalNotePlaceholder: 'Note interne (visibili nel PDF)...',
  footerPlaceholder: 'Condizioni di pagamento, coordinate bancarie...',
  offerData: 'Dati offerta',
  invoiceData: 'Dati fattura',
  offerDate: 'Data offerta',
  invoiceDate: 'Data fattura',
  dueDate: 'Data di scadenza',
  currency: 'Valuta',
  net: 'Netto',
  invoiceType: 'Tipo fattura',
  standard: 'Standard',
  depositPercent: 'Acconto (%)',
  orAmount: 'oppure importo',
  tax: 'Imposta',
  reverseChargeActive: 'Reverse charge attivo',
  reverseChargeHintPrefix: 'Su',
  reverseChargeHintSuffix: 'viene aggiunta automaticamente la nota',
  skontoPercent: 'Sconto cassa (%)',
  skontoDays: 'Termine sconto cassa (giorni)',
  skontoInvoiceHint: 'Nota in fattura',
  profileAuto: 'Rilevamento automatico',
  profileDietrichStd: 'Dietrich standard (header)',
  profileDietrichPos: 'Dietrich con pos + totale',
  profileDietrichRaw: 'Dietrich export grezzo (senza header)',
  profileCustom: 'Personalizzato',
  importProfileSaved: 'Profilo di importazione salvato',
  taxModeAutoAfterCustomer: 'Impostato automaticamente dopo la selezione del cliente',
  taxModeCompany: 'Cliente aziendale rilevato - l\'imposta viene impostata automaticamente a 0%',
  taxModePrivate: 'Cliente privato rilevato - viene usata l\'aliquota standard dalle impostazioni',
  noSuggestedPositions: 'Nessuna posizione trovata nell\'offerta suggerita',
  positionsImportedWithFactor: 'Posizioni importate da {number} (fattore quantita {factor}x)',
  positionsImported: 'Posizioni importate da {number}',
  suggestionApplyError: 'Impossibile applicare il suggerimento',
  noProjectHours: 'Nessuna ora non fatturata trovata per questo progetto',
  hoursImported: '{count} dipendenti aggiunti come posizioni ore',
  hoursLoadError: 'Errore durante il caricamento delle ore',
  noProjectMaterials: 'Nessun materiale trovato per questo progetto',
  materialsImported: 'Importati {count} materiali',
  materialsLoadError: 'Errore durante il caricamento dei materiali',
  noCatalogMaterials: 'Nessun materiale disponibile per la selezione',
  materialCatalogLoaded: 'Caricati {count} materiali per la selezione',
  materialCatalogLoadError: 'Errore durante il caricamento del catalogo materiali',
  invalidQuantity: 'Inserire una quantita valida',
  materialAddedAsPosition: 'Materiale aggiunto come posizione',
  noGaebPositions: 'Nessuna posizione trovata nel documento GAEB',
  gaebImported: 'Importate {count} posizioni da GAEB {phase}',
  gaebImportFailed: 'Importazione GAEB non riuscita',
  noCsvPositions: 'Nessuna posizione trovata nel CSV',
  csvImported: 'Importate {count} posizioni da CSV',
  csvImportFailed: 'Importazione CSV non riuscita',
  employee: 'Dipendente',
  activity: 'Attivita',
  workingHours: 'Ore di lavoro',
  documentSaved: '{type} {number} salvato',
  documentCreated: '{type} {number} creato',
  sentInvoicesNotEditable: 'Le fatture inviate non possono piu essere modificate.',
  documentLockedByOther: 'Questo documento ({type}) e attualmente in modifica da {name}. Puoi solo visualizzarlo.'
};
const docFormPl = {
  editOffer: 'Edytuj oferte',
  editInvoice: 'Edytuj fakture',
  editCreditNote: 'Edytuj fakture korygujaca',
  newOffer: 'Nowa oferta',
  newInvoice: 'Nowa faktura',
  newCreditNote: 'Nowa faktura korygujaca',
  createOffer: 'Utworz oferte',
  createInvoice: 'Utworz fakture',
  createCreditNote: 'Utworz fakture korygujaca',
  creditNoteData: 'Dane faktury korigujacej',
  offerEditInfoText: 'Tutaj mozesz edytowac swoja oferte. Mozesz zmienic klienta lub projekt, dodawac lub modyfikowac pozycje i dostosowywac pozostale dane.',
  offerInfoItem1: 'W polu "Temat oferty" mozesz wpisac temat, aby znalezc podobne oferty i przejac ich pozycje. Dziala to tylko wtedy, gdy masz juz oferty z tematami.',
  offerInfoItem2: 'Lista rozwijana w pozycjach z etykieta "Autodetekcja" probuje zidentyfikowac format danych w celu umozliwienia importu z programu Dietrich\'s. Nie jest to klasyczna funkcja importu, lecz proba rozpoznania danych, aby mozna bylo je przejac do oferty.',
  offerInfoItem3: 'Mozesz dodawac, usuwac lub zmieniac pozycje. Wszystkie zmiany sa automatycznie stosowane w ofercie.',
  offerInfoItem4: 'Data oferty jest automatycznie ustawiana na biezaca date, ale moze byc zmieniona. Data waznosci jest automatycznie ustawiana na 30 dni po dacie oferty, ale rowniez moze byc zmieniona.',
  offerInfoItem5: 'Podatek jest pobierany z ustawien domyslnych. Jesli klient jest osoba fizyczna, stosowana jest ta stawka. Jesli to firma, na ofercie nie podaje sie podatku (odwrotne obciazenie).',
  offerInfoItem6: 'Mozna osobno podac rabat, skonto i termin skonta. Informacje te sa drukowane jako uwaga na ofercie.',
  offerCreateInfoText: 'Tutaj mozesz utworzyc swoja oferte. Wybierz klienta i projekt, dodaj pozycje i dostosuj dane oferty.',
  invoiceEditInfoText: 'Tutaj mozesz edytowac swoja fakture. Wybierz klienta i projekt, dodaj pozycje i dostosuj dane oferty i faktury.',
  invoiceCreateInfoText: 'Tutaj mozesz utworzyc swoja fakture. Wybierz klienta i projekt, dodaj pozycje i dostosuj dane faktury.',
  invoiceInfoItem1: 'Jesli do projektu przypisane sa godziny pracy i materialy, sa one wyswietlane automatycznie. Mozesz przejac kazda pozycje w calosci, czesciowo lub ja pominac.',
  invoiceInfoItem2: 'Dostepne typy faktur to: standardowa, zaliczkowa, czesciowa i koncowa.',
  invoiceInfoItem3: 'W przypadku faktur zaliczkowych mozesz podac procentowy udzial lub kwote faktury.',
  invoiceInfoItem4: 'Data faktury jest automatycznie ustawiana na biezaca date, ale moze byc zmieniona. Termin platnosci jest automatycznie ustawiony na 30 dni po dacie faktury, ale rowniez moze byc zmieniony.',
  invoiceInfoItem5: 'Podatek jest pobierany z ustawien domyslnych. Jesli klient jest osoba fizyczna, stosowana jest ta stawka. Jesli to firma, na fakturze nie podaje sie podatku (odwrotne obciazenie).',
  invoiceInfoItem6: 'Mozna osobno podac rabat, skonto i termin skonta. Informacje te sa drukowane jako uwaga na fakturze.',
  docFormInfoItem1: 'Mozna rowniez importowac plik GAEB, aby przejac pozycje z przetargow.',
  docFormInfoItem2: 'Przycisk "Wybierz material" otwiera wybor materialow, za pomoca ktorego mozna dodac pozycje materialowe.',
  docFormInfoItem3: 'Przycisk "+ Pozycja" dodaje nowa pozycje.',
  docFormInfoItem4: 'Kazda pozycja ma krotki tekst, dlugi tekst, ilosc, jednostke, cene jednostkowa i cene calkowita. Tylko krotki tekst jest obowiazkowy.',
  docFormInfoItem5: 'Mozliwe jednostki to np. h dla godzin, m2 dla metrow kwadratowych, m dla metrow, szt dla sztuk, km dla kilometrow, miesiac lub ryczalt.',
  docFormInfoItem6: 'Cena calkowita jest automatycznie obliczana jako ilosc razy cena jednostkowa.',
  docFormInfoItem7: 'W sekcji Notatki i stopka mozesz wpisac wewnetrzna notatke drukowana pod cena calkowita oferty oraz stopke zawierajaca np. warunki platnosci lub dane bankowe.',
  docFormInfoItem8: 'Dla obu mozesz tworzyc bloki tekstowe, ktore mozesz ponownie wykorzystac.',
  docFormInfoItem9: 'Waluta jest automatycznie pobierana z ustawien domyslnych, ale moze byc rowniez zmieniona recznie.',
  customerProject: 'Klient i projekt',
  selectCustomer: 'Wybierz klienta',
  offerTopic: 'Temat oferty',
  topicLabel: 'Temat',
  topicPlaceholder: 'np. 120 m² fasada ocieplana incl. rusztowanie',
  searchingSimilarOffers: 'Wyszukiwanie podobnych ofert...',
  similarOffersHint: 'Podobne oferty do porownania i szybkiego przejecia:',
  similar: 'podobne',
  offerNet: 'Oferta netto',
  actualEffortNet: 'Rzeczywisty koszt netto',
  deviation: 'Odchylenie',
  totalCheck: 'Kontrola sumy',
  comparedPositionsSingular: 'pozycja porownawcza',
  comparedPositionsPlural: 'pozycje porownawcze',
  actualTotal: 'suma rzeczywista',
  medianExpected: 'mediana oczekiwana',
  averageExpected: 'srednia oczekiwana',
  medianWord: 'Mediana',
  averageWord: 'Srednia',
  expectedApproxMedian: 'Oczekiwane ok. {amount} na podstawie mediany',
  atWith: 'z',
  comparisonsSingular: 'porownanie',
  comparisonsPlural: 'porownania',
  actualShort: 'rzeczywiste',
  noComparablePositions: 'Nie znaleziono porownanyc pozycji',
  refreshComparison: 'Odswiez porownanie',
  manualRefreshHint: 'Jesli zmienisz pozycje lub temat, odswiez porownanie.',
  startTour: 'Uruchom przewodnik',
  tourCustomerTitle: 'Klient i projekt', tourCustomerText: 'Wybierz klienta i opcjonalnie projekt. Dane adresowe są przejmowane automatycznie.',
  tourCustomerCreditText: 'Wybierz klienta. Korekta odnosi się do już wystawionej faktury.',
  tourTopicTitle: 'Temat i porównanie', tourTopicText: 'Opisz temat. System automatycznie porównuje podobne wcześniejsze oferty.',
  tourPositionsTitle: 'Pozycje', tourPositionsOfferText: 'Wprowadź pozycje z opisem, ilością i ceną. Import: CSV, GAEB lub katalog projektu. Godziny i materiały mogą być zaimportowane.',
  tourPositionsInvoiceText: 'Godziny, materiały i pojazdy zostały załadowane dla tego projektu. Użyj przycisków "Importuj godziny", "Importuj materiały" i "Importuj pojazdy" aby dodać otwarte rezerwacje jako pozycje.',
  tourPositionsCreditText: 'Wprowadź pozycje korekty. Zazwyczaj odzwierciedlają pozycje z oryginalnej faktury.',
  tourNotesTitle: 'Notatki i stopka', tourNotesText: 'Notatki wewnętrzne widoczne są tylko wewnętrznie. Stopka pojawia się na dokumencie. Bloki tekstowe ułatwiają wprowadzanie.',
  tourSummaryTitle: 'Podsumowanie', tourSummaryOfferText: 'Data oferty, ważność, waluta, VAT i opcjonalny rabat. Sumy obliczane na żywo.',
  tourSummaryInvoiceText: 'Data faktury, termin, waluta, VAT, rabat i typ faktury. Sumy obliczane na żywo.',
  tourSummaryCreditText: 'Data, waluta i VAT korekty. Sumy obliczane na żywo.',
  tourRemainingTitle: 'Otwarte rezerwacje', tourRemainingText: 'Pokazuje niezafakturowane godziny, materialy i pojazdy dla tego projektu. Przycisnij ↓ aby dodac poszczegolne wpisy jako pozycje faktury – mozesz dostosowac ilosc przed dodaniem.',
  tourSaveTitle: 'Zapisz', tourSaveText: '"Zapisz szkic" zapisuje bez zmiany statusu. "Zapisz" finalizuje. Szkic jest automatycznie zapisywany lokalnie.',
  applyPositions: 'Przejmij pozycje',
  importCsv: 'Importuj CSV',
  importGaeb: 'Importuj GAEB',
  csvImportHint: 'CSV moze sie roznic w zaleznosci od dostawcy. Uzyj autodeteccji lub skonfiguruj separator/kolumny.',
  autoDetect: 'Auto-wykrywanie',
  delimiter: 'Separator',
  hasHeader: 'Zawiera naglowek',
  skipRows: 'Pominac wiersze',
  saveProfile: 'Zapisz profil',
  importing: 'Importowanie...',
  columnDescription: 'Kolumna: Opis',
  columnDescriptionPlaceholder: 'np. krotki tekst',
  columnQuantity: 'Kolumna: Ilosc',
  columnQuantityPlaceholder: 'np. ilosc',
  columnUnit: 'Kolumna: Jednostka',
  columnUnitPlaceholder: 'np. jednostka',
  columnUnitPrice: 'Kolumna: Cena jednostkowa',
  columnUnitPricePlaceholder: 'np. cena jednostkowa',
  columnTotalPrice: 'Kolumna: Cena calkowita',
  columnTotalPricePlaceholder: 'np. cena calkowita',
  selectProjectFirstTitle: 'Najpierw wybierz projekt',
  selectProjectFirstHint: 'Material mozna sugerowac tylko z przypisaniem do projektu.',
  position: 'Pozycja',
  addHeader: 'Naglowek sekcji',
  sectionHeaderPlaceholder: 'Tytul sekcji...',
  applyHours: 'Przejmij godziny pracy',
  applyMaterials: 'Przejmij pozycje materialowe',
  applyAssets: 'Pojazdy i maszyny',
  selectMaterial: 'Wybierz material',
  addMaterialAsPosition: 'Dodaj material jako pozycje',
  unbilledHours: 'Nie zafakturowane godziny',
  unbilledMaterial: 'Nie zafakturowany material',
  unbilledAssets: 'Pojazdy i maszyny',
  available: 'Dostepne',
  done: 'wykonane',
  allBilled: 'Wszystkie godziny i materialy juz zafakturowane',
  noProjectAssets: 'Brak przypisanych pojazdow lub maszyn',
  assetsImported: 'Zaimportowano {count} przypisanie/n',
  assetsLoadError: 'Blad podczas ladowania przypisani',
  dailyRate: 'Stawka dzienna', days: 'dni',
  positionText: 'Tekst pozycji',
  shortTextPlaceholder: 'Krotki tekst...',
  longTextPlaceholder: 'Tekst dlugszy (opcjonalnie)...',
  notesFooter: 'Notatki i stopka',
  internalNote: 'Notatka wewnetrzna',
  internalNotePlaceholder: 'Notatki wewnetrzne (widoczne w PDF)...',
  footerPlaceholder: 'Warunki platnosci, dane bankowe...',
  offerData: 'Dane oferty',
  invoiceData: 'Dane faktury',
  offerDate: 'Data oferty',
  invoiceDate: 'Data faktury',
  dueDate: 'Termin platnosci',
  currency: 'Waluta',
  net: 'Netto',
  invoiceType: 'Typ faktury',
  standard: 'Standard',
  depositPercent: 'Zaliczka (%)',
  orAmount: 'lub kwota',
  tax: 'Podatek',
  reverseChargeActive: 'Reverse charge aktywny',
  reverseChargeHintPrefix: 'Na',
  reverseChargeHintSuffix: 'pojawia sie automatycznie notatka',
  skontoPercent: 'Skonto (%)',
  skontoDays: 'Termin skonta (dni)',
  skontoInvoiceHint: 'Notatka na fakturze',
  profileAuto: 'Autodeteccja',
  profileDietrichStd: 'Dietrich Standard (Header)',
  profileDietrichPos: 'Dietrich z poz + suma',
  profileDietrichRaw: 'Dietrich export surowy (bez headera)',
  profileCustom: 'Niestandardowy',
  importProfileSaved: 'Profil importu zapisany',
  taxModeAutoAfterCustomer: 'Ustawiane automatycznie po wyborze klienta',
  taxModeCompany: 'Klient biznesowy rozpoznany - podatek automatycznie ustawiony na 0%',
  taxModePrivate: 'Klient prywatny rozpoznany - domyslna stawka z ustawien jest uzywana',
  noSuggestedPositions: 'W proponowanej ofercie nie znaleziono pozycji',
  positionsImportedWithFactor: 'Pozycje zaimportowane z {number} (mnoznik ilosci {factor}x)',
  positionsImported: 'Pozycje zaimportowane z {number}',
  suggestionApplyError: 'Nie mozna zastosowac propozycji',
  noProjectHours: 'Nie znaleziono niezafakturowanych godzin dla tego projektu',
  hoursImported: 'Przejeto {count} pracownikow jako pozycje godzinowe',
  hoursLoadError: 'Blad podczas ladowania godzin',
  noProjectMaterials: 'Nie znaleziono materialow dla tego projektu',
  materialsImported: 'Zaimportowano {count} materialow',
  materialsLoadError: 'Blad podczas ladowania materialow',
  noCatalogMaterials: 'Brak materialow dostepnych do wyboru',
  materialCatalogLoaded: 'Zaladowano {count} materialow do wyboru',
  materialCatalogLoadError: 'Blad podczas ladowania katalogu materialow',
  invalidQuantity: 'Prosze podac poprawna ilosc',
  materialAddedAsPosition: 'Material dodany jako pozycja',
  noGaebPositions: 'Nie znaleziono pozycji w dokumencie GAEB',
  gaebImported: 'Zaimportowano {count} pozycji z GAEB {phase}',
  gaebImportFailed: 'Import GAEB nie powiodl sie',
  noCsvPositions: 'Nie znaleziono pozycji w CSV',
  csvImported: 'Zaimportowano {count} pozycji z CSV',
  csvImportFailed: 'Import CSV nie powiodl sie',
  employee: 'Pracownik',
  activity: 'Czynnosc',
  workingHours: 'Godziny pracy',
  documentSaved: '{type} {number} zapisano',
  documentCreated: '{type} {number} utworzono',
  sentInvoicesNotEditable: 'Wyslanych faktur nie mozna juz edytowac.',
  documentLockedByOther: 'Ten dokument ({type}) jest aktualnie edytowany przez {name}. Mozesz go tylko przegladac.'
};
const docFormCs = {
  editOffer: 'Upravit nabidku',
  editInvoice: 'Upravit fakturu',
  editCreditNote: 'Upravit dobropis',
  newOffer: 'Nova nabidka',
  newInvoice: 'Nova faktura',
  newCreditNote: 'Novy dobropis',
  createOffer: 'Vytvorit nabidku',
  createInvoice: 'Vytvorit fakturu',
  createCreditNote: 'Vytvorit dobropis',
  creditNoteData: 'Udaje dobropisu',
  offerEditInfoText: 'Zde muzete upravit svou nabidku. Muzete zmenit zakaznika nebo projekt, pridat nebo upravit polozky a prizpusobit zbyvajici data.',
  offerInfoItem1: 'V poli "Tema nabidky" muzete zadat tema, abyste nasli podobne nabidky a prevzali jejich polozky. Funguje to jen tehdy, pokud jiz mate nabidky s tematy.',
  offerInfoItem2: 'Rozbalovaci seznam v polozkach s oznacenim "Automaticke rozpoznavani" se pokusi identifikovat format dat, aby umoznil import ze softwaru Dietrich\'s. Neni to klasicka funkce importu, ale pokus o rozpoznani dat tak, aby je bylo mozne prevzit do nabidky.',
  offerInfoItem3: 'Muzete pridavat, odebirat nebo menit polozky. Vsechny zmeny jsou automaticky aplikovany v nabidce.',
  offerInfoItem4: 'Datum nabidky se automaticky nastavi na aktualni datum, ale lze jej zmenit. Datum platnosti se automaticky nastavi na 30 dni po datu nabidky, ale lze je take zmenit.',
  offerInfoItem5: 'Dan je prevzata z vychozich nastaveni. Pokud je zakaznik fyzickou osobou, pouzije se tato sazba. Pokud se jedna o firmu, na nabidce neni zadna dan uvedena (prenesena danova povinnost).',
  offerInfoItem6: 'Lze samostatne uvest slevu, skonto a lhutu skonta. Tyto udaje jsou pak vytisteny jako poznamka na nabidce.',
  offerCreateInfoText: 'Zde muzete vytvorit svou nabidku. Vyberte zakaznika a projekt, pridejte polozky a prizpusobte data nabidky.',
  invoiceEditInfoText: 'Zde muzete upravit svou fakturu. Vyberte zakaznika a projekt, pridejte polozky a prizpusobte data nabidky a faktury.',
  invoiceCreateInfoText: 'Zde muzete vytvorit svou fakturu. Vyberte zakaznika a projekt, pridejte polozky a prizpusobte data faktury.',
  invoiceInfoItem1: 'Pokud jsou k projektu prirazeny pracovni hodiny a materialy, zobrazuji se automaticky. Kazdou polozku muzete prevzit celou, castecne nebo ji nechat.',
  invoiceInfoItem2: 'Dostupne typy faktur jsou: standardni, zaloha, castecna a zaverecna.',
  invoiceInfoItem3: 'U zalochovych faktur muzete zadat procentualni podil nebo vysi faktury.',
  invoiceInfoItem4: 'Datum faktury se automaticky nastavi na aktualni datum, ale lze jej zmenit. Datum splatnosti se automaticky nastavi na 30 dni po datu faktury, ale lze je take zmenit.',
  invoiceInfoItem5: 'Dan je prevzata z vychozich nastaveni. Pokud je zakaznik fyzickou osobou, pouzije se tato sazba. Pokud se jedna o firmu, na fakture neni zadna dan uvedena (prenesena danova povinnost).',
  invoiceInfoItem6: 'Lze samostatne uvest slevu, skonto a lhutu skonta. Tyto udaje jsou pak vytisteny jako poznamka na fakture.',
  docFormInfoItem1: 'Lze take importovat soubor GAEB pro prevzeti polozek z vyberovych rizeni.',
  docFormInfoItem2: 'Tlacitko "Vybrat material" otevire vyber materialu, pomoci ktereho lze pridat materialove polozky.',
  docFormInfoItem3: 'Tlacitko "+ Polozka" prida novou polozku.',
  docFormInfoItem4: 'Kazda polozka ma kratky text, dlouhy text, mnozstvi, jednotku, jednotkovou cenu a celkovou cenu. Povinny je pouze kratky text.',
  docFormInfoItem5: 'Mozne jednotky jsou napr. hod. pro hodiny, m2 pro ctvercni metry, m pro metry, ks pro kusy, km pro kilometry, mesic nebo pausal.',
  docFormInfoItem6: 'Celkova cena se automaticky vypocita jako mnozstvi krat jednotkova cena.',
  docFormInfoItem7: 'V casti Poznamky a zapati muzete zadat interni poznamku vytistenenou pod celkovou cenou nabidky a zapati, ktere muze obsahovat napr. platebni podminky nebo bankovni udaje.',
  docFormInfoItem8: 'Pro oboji muzete vytvorit textove bloky, ktere pak muzete znovu pouzit.',
  docFormInfoItem9: 'Mena je automaticky prevzata z vychozich nastaveni, ale lze ji take zmenit rucne.',
  customerProject: 'Zakaznik a projekt',
  selectCustomer: 'Vyberte zakaznika',
  offerTopic: 'Tema nabidky',
  topicLabel: 'Tema',
  topicPlaceholder: 'napr. izolace 120 m² fasady vcetne leseneni',
  searchingSimilarOffers: 'Hledam podobne nabidky...',
  similarOffersHint: 'Podobne nabidky pro orientaci a rychle prevzeti:',
  similar: 'podobne',
  offerNet: 'Nabidka bez DPH',
  actualEffortNet: 'Skutecne naklady bez DPH',
  deviation: 'Odchylka',
  totalCheck: 'Celkova kontrola',
  comparedPositionsSingular: 'porovnavana polozka',
  comparedPositionsPlural: 'porovnavane polozky',
  actualTotal: 'skutecna suma',
  medianExpected: 'ocekavana mediana',
  averageExpected: 'ocekavany prumer',
  medianWord: 'Mediana',
  averageWord: 'Prumer',
  expectedApproxMedian: 'Ocekava se priblizne {amount} v zavislosti na mediane',
  atWith: 's',
  comparisonsSingular: 'porovnani',
  comparisonsPlural: 'porovnani',
  actualShort: 'skutecne',
  noComparablePositions: 'Nenalezeny zadne porovnavane polozky',
  refreshComparison: 'Obnovit porovnani',
  manualRefreshHint: 'Pokud zmenis polozky nebo tema, znovu nacti porovnani.',
  startTour: 'Spustit průvodce',
  tourCustomerTitle: 'Zákazník & projekt', tourCustomerText: 'Vyberte zákazníka a volitelně projekt. Adresní údaje jsou převzaty automaticky.',
  tourCustomerCreditText: 'Vyberte zákazníka. Dobropis se vztahuje k již vystavené faktuře.',
  tourTopicTitle: 'Téma & porovnání', tourTopicText: 'Popište téma. Systém automaticky porovnává podobné dřívější nabídky.',
  tourPositionsTitle: 'Položky', tourPositionsOfferText: 'Zadejte položky s popisem, množstvím a cenou. Import: CSV, GAEB nebo katalog projektu. Hodiny a materiály lze importovat.',
  tourPositionsInvoiceText: 'Hodiny, materiály a vozidla byly načteny pro tento projekt. Pomocí tlačítek "Importovat hodiny", "Importovat materiály" a "Importovat vozidla" přidejte otevřené rezervace jako položky.',
  tourPositionsCreditText: 'Zadejte položky dobropisu. Obvykle odráží položky původní faktury.',
  tourNotesTitle: 'Poznámky & zápatí', tourNotesText: 'Interní poznámky jsou viditelné pouze interně. Zápatí se zobrazí na dokumentu. Textové bloky usnadňují zadávání.',
  tourSummaryTitle: 'Přehled', tourSummaryOfferText: 'Datum nabídky, platnost, měna, DPH a volitelná sleva. Celkové částky se počítají živě.',
  tourSummaryInvoiceText: 'Datum faktury, splatnost, měna, DPH, skonto a typ faktury. Celkové částky se počítají živě.',
  tourSummaryCreditText: 'Datum, měna a DPH dobropisu. Celkové částky se počítají živě.',
  tourRemainingTitle: 'Otevrene rezervace', tourRemainingText: 'Zobrazuje neuvacturovane hodiny, materialy a vozidla pro tento projekt. Tlacitkem ↓ pridejte jednotlive zaznamy jako polozky faktury – mnozstvi muzete pred pridanim upravit.',
  tourSaveTitle: 'Uložit', tourSaveText: '"Uložit jako koncept" uloží bez změny stavu. "Uložit" finalizuje. Koncept je automaticky ukládán lokálně.',
  applyPositions: 'Prevzit polozky',
  importCsv: 'Import CSV',
  importGaeb: 'Import GAEB',
  csvImportHint: 'CSV se muze lisit podle dodavatele. Pouzij autodetekci nebo nastav oddelovac/sloupce.',
  autoDetect: 'Auto detekce',
  delimiter: 'Oddelovac',
  hasHeader: 'Obsahuje hlavicku',
  skipRows: 'Preskocit radky',
  saveProfile: 'Ulozit profil',
  importing: 'Importuji...',
  columnDescription: 'Sloupec: Popis',
  columnDescriptionPlaceholder: 'napr. kratky text',
  columnQuantity: 'Sloupec: Mnozstvi',
  columnQuantityPlaceholder: 'napr. mnozstvi',
  columnUnit: 'Sloupec: Jednotka',
  columnUnitPlaceholder: 'napr. jednotka',
  columnUnitPrice: 'Sloupec: Jednotkova cena',
  columnUnitPricePlaceholder: 'napr. jednotkova cena',
  columnTotalPrice: 'Sloupec: Celkova cena',
  columnTotalPricePlaceholder: 'napr. celkova cena',
  selectProjectFirstTitle: 'Nejdriv vyberte projekt',
  selectProjectFirstHint: 'Material lze navrhovat jen s vazbou na projekt.',
  position: 'Polozka',
  addHeader: 'Nadpis sekce',
  sectionHeaderPlaceholder: 'Nazev sekce...',
  applyHours: 'Prevzit pracovni hodiny',
  applyMaterials: 'Prevzit materialove polozky',
  applyAssets: 'Vozidla a stroje',
  selectMaterial: 'Vyberte material',
  addMaterialAsPosition: 'Pridat material jako polozku',
  unbilledHours: 'Nevyfakturovane hodiny',
  unbilledMaterial: 'Nevyfakturovany material',
  unbilledAssets: 'Vozidla a stroje',
  available: 'Dostupne',
  done: 'hotovo',
  allBilled: 'Vsechny hodiny a materialy jiz vyfakturovany',
  noProjectAssets: 'Zadna prirazena vozidla nebo stroje',
  assetsImported: '{count} prirazeni importovano',
  assetsLoadError: 'Chyba pri nacitani prirazeni',
  dailyRate: 'Denni sazba', days: 'dny',
  positionText: 'Text polozky',
  shortTextPlaceholder: 'Kratky text...',
  longTextPlaceholder: 'Dlouhy text (volitelne)...',
  notesFooter: 'Poznamky a paticka',
  internalNote: 'Interni poznamka',
  internalNotePlaceholder: 'Interni poznamky (zobrazene v PDF)...',
  footerPlaceholder: 'Platebni podminky, bankovni detaily...',
  offerData: 'Udaje nabidky',
  invoiceData: 'Udaje faktury',
  offerDate: 'Datum nabidky',
  invoiceDate: 'Datum faktury',
  dueDate: 'Datum splatnosti',
  currency: 'Mena',
  net: 'Bez DPH',
  invoiceType: 'Typ faktury',
  standard: 'Standard',
  depositPercent: 'Zalohova (%)',
  orAmount: 'nebo castka',
  tax: 'Dan',
  reverseChargeActive: 'Reverse charge aktivni',
  reverseChargeHintPrefix: 'Na',
  reverseChargeHintSuffix: 'se automaticky objev poznamka',
  skontoPercent: 'Skonto (%)',
  skontoDays: 'Skonto lhuta (dny)',
  skontoInvoiceHint: 'Poznamka na fakture',
  profileAuto: 'Autodetekce',
  profileDietrichStd: 'Dietrich Standard (Hlavicka)',
  profileDietrichPos: 'Dietrich s pol + souhrn',
  profileDietrichRaw: 'Dietrich surovy export (bez hlavicky)',
  profileCustom: 'Vlastni',
  importProfileSaved: 'Profil importu ulozeny',
  taxModeAutoAfterCustomer: 'Nastavi se automaticky po vyberu zakaznika',
  taxModeCompany: 'Obchodny zakaznik detekovan - dan je automaticky nastavena na 0%',
  taxModePrivate: 'Soukromy zakaznik detekovan - vychozi sazba z nastaveni se pouziva',
  noSuggestedPositions: 'V navrhovane nabidce nebyly nalezeny zadne polozky',
  positionsImportedWithFactor: 'Polozky importovany z {number} (faktor mnozstvi {factor}x)',
  positionsImported: 'Polozky importovany z {number}',
  suggestionApplyError: 'Nelze aplikovat navrh',
  noProjectHours: 'Pro tento projekt nebyly nalezeny zadne nevyfakturovane hodiny',
  hoursImported: 'Prevzato {count} zamestnancu jako hodinove polozky',
  hoursLoadError: 'Chyba pri nacitani hodin',
  noProjectMaterials: 'Pro tento projekt neni dostupny zadny material',
  materialsImported: 'Importovano {count} materialu',
  materialsLoadError: 'Chyba pri nacitani materialu',
  noCatalogMaterials: 'Pro vyber neni dostupny zadny material',
  materialCatalogLoaded: 'Nacteno {count} materialu k vyberu',
  materialCatalogLoadError: 'Chyba pri nacitani katalogu materialu',
  invalidQuantity: 'Prosim zadejte platne mnozstvi',
  materialAddedAsPosition: 'Material pridan jako polozka',
  noGaebPositions: 'V dokumentu GAEB byly nalezeny zadne polozky',
  gaebImported: 'Importovano {count} polozek z GAEB {phase}',
  gaebImportFailed: 'Import GAEB selhal',
  noCsvPositions: 'V CSV nebyly nalezeny zadne polozky',
  csvImported: 'Importovano {count} polozek z CSV',
  csvImportFailed: 'CSV import selhal',
  employee: 'Zamestnanec',
  activity: 'Cinnost',
  workingHours: 'Pracovni hodiny',
  documentSaved: '{type} {number} ulozeno',
  documentCreated: '{type} {number} vytvoreno',
  sentInvoicesNotEditable: 'Odeslane faktury uz nelze upravovat.',
  documentLockedByOther: 'Tento dokument ({type}) prave upravuje {name}. Muzete jej pouze prohlizet.'
};

const qrScannerDe = {
  title: 'QR-Code scannen',
  hint: 'Halte die Kamera auf das QR-Label des Artikels.',
  cameraError: 'Kamera konnte nicht gestartet werden. Bitte Kamera-Berechtigung erteilen.',
  unknownCode: 'Kein gültiges Material-Label erkannt.',
};

const qrScannerEn = {
  title: 'Scan QR code',
  hint: 'Point the camera at the item\'s QR label.',
  cameraError: 'Could not start the camera. Please grant camera permission.',
  unknownCode: 'No valid material label recognized.',
};

const qrScannerFr = {
  title: 'Scanner un QR code',
  hint: 'Pointez la camera vers l\'etiquette QR de l\'article.',
  cameraError: 'Impossible de demarrer la camera. Veuillez autoriser l\'acces a la camera.',
  unknownCode: 'Aucune etiquette de materiel valide reconnue.',
};

const qrScannerIt = {
  title: 'Scansiona QR code',
  hint: 'Punta la fotocamera sull\'etichetta QR dell\'articolo.',
  cameraError: 'Impossibile avviare la fotocamera. Concedi il permesso della fotocamera.',
  unknownCode: 'Nessuna etichetta materiale valida riconosciuta.',
};

const qrScannerPl = {
  title: 'Skanuj kod QR',
  hint: 'Skieruj kamere na etykiete QR artykulu.',
  cameraError: 'Nie udalo sie uruchomic kamery. Prosze przyznac uprawnienia do kamery.',
  unknownCode: 'Nie rozpoznano prawidlowej etykiety materialu.',
};

const qrScannerCs = {
  title: 'Skenovat QR kod',
  hint: 'Namirte kameru na QR stitek polozky.',
  cameraError: 'Kameru se nepodarilo spustit. Povolte prosim pristup ke kamere.',
  unknownCode: 'Nerozpoznan platny stitek materialu.',
};

export const messages = {
  de: {
    common: {
      close: 'Schließen',
      back: 'Zurück',
      save: 'Speichern',
      search: 'Suchen',
      cancel: 'Abbrechen',
      create: 'Erstellen',
      tour: { next: 'Weiter →', done: 'Fertig', skip: 'Überspringen' },
      delete: 'Löschen',
      info: 'Info',
      reset: 'Zurücksetzen',
      draftSave: 'Entwurf speichern',
      logout: 'Abmelden',
      language: 'Sprache',
      lightMode: 'Light Mode',
      darkMode: 'Dark Mode',
      unsavedChangesLeaveConfirm: 'Ungespeicherte Änderungen gehen verloren. Seite wirklich verlassen?',
      unsavedChangesDiscardConfirm: 'Ungespeicherte Änderungen verwerfen?',
      saved: 'Gespeichert',
      deleted: 'Gelöscht',
      refresh: 'Aktualisieren',
      loading: 'Wird geladen…',
      trialLimitExceeded: 'Trial-Limit erreicht: {current} von {limit} {entity} bereits angelegt. Bitte upgraden Sie auf den Pro-Plan.',
      trialEntities: {
        project: 'Projekten', customer: 'Kunden', employee: 'Mitarbeitern',
        work_timestamp: 'Zeiteinträgen', material: 'Materialien', material_movement: 'Materialbuchungen',
        supplier: 'Lieferanten', offer: 'Angeboten', invoice: 'Rechnungen',
        machine: 'Maschinen', vehicle: 'Fahrzeugen',
      },
    },
    support: {
      title: 'Problem melden',
      buttonTitle: 'Problem melden',
      category: 'Kategorie',
      categoryPlaceholder: '– bitte wählen –',
      categoryBug: 'Fehler / Bug',
      categoryFeature: 'Feature-Wunsch',
      categoryQuestion: 'Frage',
      categoryOther: 'Sonstiges',
      description: 'Beschreibung',
      descriptionPlaceholder: 'Was ist passiert? Was hast du erwartet?',
      send: 'Senden',
      sending: 'Wird gesendet…',
      errorSend: 'Fehler beim Senden. Bitte erneut versuchen.',
    },
    nav: {
      overview: 'Übersicht',
      assets: 'Assets',
      vehicles: 'Fahrzeuge',
      machines: 'Maschinen',
      crm: 'CRM',
      projects: 'Projekte',
      personal: 'Personal',
      material: 'Material',
      documents: 'Dokumente',
      admin: 'Verwaltung',
      dashboard: 'Dashboard',
      customers: 'Kunden',
      projectsList: 'Projekte',
      schedule: 'Baustellenplanung',
      timeRecording: 'Zeiterfassung',
      mediaStorage: 'Medienablage',
      calculator: 'Kalkulator',
      reports: 'Berichte',
      vacation: 'Urlaub',
      sickLeave: 'Krankmeldungen',
      payroll: 'Lohnabrechnung',
      warehouse: 'Lager',
      suppliers: 'Lieferanten',
      offers: 'Angebote',
      invoices: 'Rechnungen',
      creditNotes: 'Gutschriften',
      employees: 'Mitarbeiter',
      permissions: 'Berechtigungen',
      settings: 'Einstellungen',
      changelog: 'Changelog',
      chat: 'Projekt-Chat',
      aufmass: 'Aufmaß',
      restartTour: 'Navigations-Tour starten',
      tourUserTitle: 'Benutzerprofil', tourUserText: 'Klick auf deinen Namen öffnet das Profil – dort kannst du Sprache und Passwort ändern.',
      tourProfileTitle: 'Profil', tourProfileText: 'Name, E-Mail und Rolle anzeigen. Sprache der Benutzeroberfläche wählen und Passwort ändern.',
      tourThemeTitle: 'Hell-/Dunkel-Modus', tourThemeText: 'Wechsle zwischen hellem und dunklem Design.',
      tourLogoutTitle: 'Abmelden', tourLogoutText: 'Meldet dich sicher aus der Anwendung ab.',
      tourMobileUserTitle: 'Profil (Mobile)', tourMobileUserText: 'Auf Mobilgeräten erreichst du dein Profil über deine Initialen oben rechts – gleiche Funktionen wie im Desktop.',
    },
    chat: {
      title: 'Projekt-Chat',
      noRooms: 'Du bist noch keinem Projekt zugewiesen.',
      selectRoom: 'Projekt auswählen um den Chat zu öffnen.',
      noMessages: 'Noch keine Nachrichten.',
      typeMessage: 'Nachricht schreiben...',
      send: 'Senden',
      today: 'Heute',
      yesterday: 'Gestern',
      infoText: 'Der Projekt-Chat ermöglicht die direkte Kommunikation im Team für jedes Projekt.',
      infoItem1: 'Nachrichten in Echtzeit senden und empfangen',
      infoItem2: 'Jedes Projekt hat seinen eigenen Chat-Kanal',
      infoItem3: 'Ungelesene Nachrichten werden mit einem Badge angezeigt',
      infoItem4: 'Dem Projekt zugewiesene Mitarbeiter haben automatisch Zugang – beim Entfernen entfällt der Zugang',
      startTour: 'Führung starten',
      tourRoomsTitle: 'Projektchats',
      tourRoomsText: 'Hier siehst du alle Projekte, bei denen du Mitglied bist. Ungelesene Nachrichten werden mit einem roten Badge angezeigt.',
      tourMessagesTitle: 'Nachrichten',
      tourMessagesText: 'Alle Nachrichten des Projekts in chronologischer Reihenfolge. Klick auf ein Bild um es zu vergrößern.',
      tourInputTitle: 'Nachricht senden',
      tourInputText: 'Schreibe eine Nachricht oder füge ein Bild hinzu – per Dateiauswahl oder einfach Einfügen (Strg+V). Enter zum Senden.',
      attachImage: 'Bild anfügen',
      removeImage: 'Bild entfernen',
      image: 'Bild',
    },
    profile: {
      title: 'Mein Profil',
      name: 'Name',
      email: 'E-Mail',
      role: 'Rolle',
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort (min. 8 Zeichen)',
      confirmPassword: 'Passwort bestätigen',
      close: 'Schließen',
      updatePassword: 'Passwort ändern',
      enterCurrentPassword: 'Aktuelles Passwort eingeben',
      minPasswordLength: 'Min. 8 Zeichen',
      mismatch: 'Passwörter stimmen nicht überein',
      success: 'Passwort geändert',
      error: 'Fehler',
      showPassword: 'Passwort anzeigen',
      hidePassword: 'Passwort ausblenden'
    },
    changelog: changelogDe,
    auth: authDe,
    docForm: docFormDe,
    status: statusDe,
    documents: documentsDe,
    settings: settingsDe,
    dashboard: dashboardDe,
    customers: customersDe,
    project: projectDe,
    schedule: scheduleDe,
    time: timeDe,
    media: mediaDe,
    calc: calcDe,
    report: reportDe,
    vacation: vacationDe,
    sick: sickDe,
    payroll: payrollDe,
    projects: projectsDe,
    inventory: inventoryDe,
    qrScanner: qrScannerDe,
    textBlocks: textBlocksDe,
    employee: employeeDe,
    permissions: permissionsDe,
    materialPicker: materialPickerDe,
    materialView: materialViewDe,
    supplierView: supplierViewDe,
    importWizard: importWizardDe,
    vehicles: vehiclesDe,
    machines: machinesDe,
    aufmass: {
      title: 'Aufmaß', newAufmass: 'Neues Aufmaß', editAufmass: 'Aufmaß bearbeiten',
      noAufmass: 'Noch keine Aufmaße angelegt.', draft: 'Entwurf', approved: 'Freigegeben',
      approve: 'Freigeben', reopen: 'Freigabe zurückziehen', deleteConfirm: 'Aufmaß wirklich löschen?',
      titleLabel: 'Bezeichnung', titlePlaceholder: 'z.B. Dachsanierung Nordseite',
      dateLabel: 'Datum', projectLabel: 'Projekt', noProject: '– kein Projekt –', notesLabel: 'Notizen',
      position: 'Position', positions: 'Positionen', addPosition: '+ Position hinzufügen', positionTitle: 'Positionsbezeichnung',
      positionTitlePlaceholder: 'z.B. Dachdämmung', unit: 'Einheit',
      addRow: '+ Zeile', rowLabel: 'Beschreibung', rowLabelPlaceholder: 'z.B. Nordseite',
      count: 'Anz.', length: 'L (m)', width: 'B (m)', height: 'H (m)', result: 'Ergebnis', total: 'Gesamt',
      positionCount: '{n} Position(en)', saveError: 'Fehler beim Speichern.', titleRequired: 'Bezeichnung erforderlich.',
      lockedByOther: 'Dieses Aufmaß wird gerade von {name} bearbeitet. Du wirst zur Übersicht zurückgeleitet.',
      weightKg: 'Menge (kg)', backToList: 'Zur Übersicht', exportHint: 'In Angebot übernehmen',
      tourNewTitle: 'Neues Aufmaß anlegen', tourNewText: 'Klicke hier, um ein neues Aufmaß zu erstellen. Du kannst Bezeichnung, Projekt und Datum vergeben.',
      tourSearchTitle: 'Suchen & filtern', tourSearchText: 'Suche nach Bezeichnung, Projekt oder Ersteller. Filtere zusätzlich nach Status (Entwurf / Freigegeben).',
      tourListTitle: 'Aufmaß-Übersicht', tourListText: 'Alle Aufmaße auf einen Blick – mit Projektbezug, Datum, Status und Positionsanzahl. Klicke auf eine Karte, um sie zu öffnen.',
      tourModalTitle: 'Neues Aufmaß erstellen', tourModalText: 'Vergib eine Bezeichnung, wähle optional ein Projekt und setze das Datum. Mit „Erstellen" öffnet sich das Aufmaß direkt.',
      tourStatusTitle: 'Status & Metadaten', tourStatusText: 'Status (Entwurf oder Freigegeben), Projektbezug, Datum und Ersteller des Aufmaßes auf einen Blick.',
      tourActionsTitle: 'Aktionsleiste', tourActionsText: 'Speichere Änderungen, gib das Aufmaß frei, exportiere als PDF oder lösche es. Ein freigegebenes Aufmaß ist schreibgeschützt.',
      tourPositionTitle: 'Positionen', tourPositionText: 'Jede Position hat eine Bezeichnung und eine Einheit (m², lfm, m³, Stk.). Trage Anzahl, Länge und Breite ein – das Ergebnis wird automatisch berechnet.',
      tourAddPositionTitle: 'Position hinzufügen', tourAddPositionText: 'Füge beliebig viele Positionen hinzu, um verschiedene Messbereiche zu erfassen. Jede hat ihre eigene Tabelle und Gesamtsumme.',
      startTour: 'Führung starten',
      infoText: 'Die Aufmaß-Übersicht zeigt alle erfassten Aufmaße deines Betriebs.',
      infoItem1: 'Erstelle neue Aufmaße mit Bezeichnung, Projektbezug und Datum',
      infoItem2: 'Filtere nach Status (Entwurf / Freigegeben) oder suche nach Bezeichnung',
      infoItem3: 'Freigegebene Aufmaße dienen als Basis für Angebote und Rechnungen',
      infoDetailText: 'Im Aufmaß-Editor erfasst du Maße strukturiert in Positionen und Zeilen.',
      infoDetailItem1: 'Jede Position hat eine Einheit (m², lfm, m³, Stk.) – Zeilen werden automatisch berechnet',
      infoDetailItem2: 'Speichere Entwürfe jederzeit und gib das Aufmaß frei, wenn es fertig ist',
      infoDetailItem3: 'Freigegebene Aufmaße sind schreibgeschützt und können als PDF exportiert werden',
    },
    roles: {
      admin: 'Administrator',
      tenant_admin: 'Tenant-Admin',
      superadmin: 'Super-Admin',
      manager: 'Manager',
      employee: 'Mitarbeiter'
    }
  },
  en: {
    common: {
      close: 'Close',
      back: 'Back',
      save: 'Save',
      search: 'Search',
      cancel: 'Cancel',
      tour: { next: 'Next →', done: 'Done', skip: 'Skip' },
      create: 'Create',
      delete: 'Delete',
      info: 'Info',
      reset: 'Reset',
      draftSave: 'Save draft',
      logout: 'Log out',
      language: 'Language',
      lightMode: 'Light mode',
      darkMode: 'Dark mode',
      unsavedChangesLeaveConfirm: 'Unsaved changes will be lost. Leave this page anyway?',
      unsavedChangesDiscardConfirm: 'Discard unsaved changes?',
      saved: 'Saved',
      deleted: 'Deleted',
      refresh: 'Refresh',
      loading: 'Loading…',
      trialLimitExceeded: 'Trial limit reached: {current} of {limit} {entity} already created. Please upgrade to the Pro plan.',
      trialEntities: {
        project: 'projects', customer: 'customers', employee: 'employees',
        work_timestamp: 'time entries', material: 'materials', material_movement: 'material bookings',
        supplier: 'suppliers', offer: 'offers', invoice: 'invoices',
        machine: 'machines', vehicle: 'vehicles',
      },
    },
    support: {
      title: 'Report an issue',
      buttonTitle: 'Report an issue',
      category: 'Category',
      categoryPlaceholder: '– please select –',
      categoryBug: 'Bug / Error',
      categoryFeature: 'Feature request',
      categoryQuestion: 'Question',
      categoryOther: 'Other',
      description: 'Description',
      descriptionPlaceholder: 'What happened? What did you expect?',
      send: 'Send',
      sending: 'Sending…',
      errorSend: 'Failed to send. Please try again.',
    },
    nav: {
      overview: 'Overview',
      assets: 'Assets',
      vehicles: 'Vehicles',
      machines: 'Machines',
      crm: 'CRM',
      projects: 'Projects',
      personal: 'People',
      material: 'Materials',
      documents: 'Documents',
      admin: 'Administration',
      dashboard: 'Dashboard',
      customers: 'Customers',
      projectsList: 'Projects',
      schedule: 'Site planning',
      timeRecording: 'Time tracking',
      mediaStorage: 'Media storage',
      calculator: 'Calculator',
      reports: 'Reports',
      vacation: 'Vacation',
      sickLeave: 'Sick leave',
      payroll: 'Payroll',
      warehouse: 'Warehouse',
      suppliers: 'Suppliers',
      offers: 'Offers',
      invoices: 'Invoices',
      creditNotes: 'Credit Notes',
      employees: 'Employees',
      permissions: 'Permissions',
      settings: 'Settings',
      changelog: 'Changelog',
      chat: 'Project Chat',
      aufmass: 'Measurements',
      restartTour: 'Start navigation tour',
      tourUserTitle: 'User profile', tourUserText: 'Click on your name to open the profile – change language and password there.',
      tourProfileTitle: 'Profile', tourProfileText: 'View name, email and role. Choose the interface language and change your password.',
      tourThemeTitle: 'Light/dark mode', tourThemeText: 'Switch between light and dark design.',
      tourLogoutTitle: 'Log out', tourLogoutText: 'Securely logs you out of the application.',
      tourMobileUserTitle: 'Profile (mobile)', tourMobileUserText: 'On mobile devices access your profile via your initials in the top right – same functions as on desktop.',
    },
    chat: {
      title: 'Project Chat',
      noRooms: 'You are not assigned to any project yet.',
      selectRoom: 'Select a project to open the chat.',
      noMessages: 'No messages yet.',
      typeMessage: 'Write a message...',
      send: 'Send',
      today: 'Today',
      yesterday: 'Yesterday',
      infoText: 'The project chat enables direct team communication for each project.',
      infoItem1: 'Send and receive messages in real time',
      infoItem2: 'Each project has its own chat channel',
      infoItem3: 'Unread messages are indicated with a badge',
      infoItem4: 'Employees assigned to the project automatically get access – removing them revokes access',
      startTour: 'Start tour',
      tourRoomsTitle: 'Project chats',
      tourRoomsText: 'Here you see all projects you are a member of. Unread messages are shown with a red badge.',
      tourMessagesTitle: 'Messages',
      tourMessagesText: 'All project messages in chronological order. Click on an image to enlarge it.',
      tourInputTitle: 'Send message',
      tourInputText: 'Write a message or add an image – via file picker or paste (Ctrl+V). Press Enter to send.',
      attachImage: 'Attach image',
      removeImage: 'Remove image',
      image: 'Image',
    },
    profile: {
      title: 'My profile',
      name: 'Name',
      email: 'Email',
      role: 'Role',
      changePassword: 'Change password',
      currentPassword: 'Current password',
      newPassword: 'New password (min. 8 characters)',
      confirmPassword: 'Confirm password',
      close: 'Close',
      updatePassword: 'Change password',
      enterCurrentPassword: 'Enter current password',
      minPasswordLength: 'Min. 8 characters',
      mismatch: 'Passwords do not match',
      success: 'Password changed',
      error: 'Error',
      showPassword: 'Show password',
      hidePassword: 'Hide password'
    },
    auth: authEn,
    docForm: docFormEn,
    status: statusEn,
    documents: documentsEn,
    settings: settingsEn,
    dashboard: dashboardEn,
    customers: customersEn,
    project: projectEn,
    schedule: scheduleEn,
    time: timeEn,
    media: mediaEn,
    calc: calcEn,
    report: reportEn,
    vacation: vacationEn,
    sick: sickEn,
    payroll: payrollEn,
    projects: projectsEn,
    inventory: inventoryEn,
    qrScanner: qrScannerEn,
    textBlocks: textBlocksEn,
    employee: employeeEn,
    permissions: permissionsEn,
    materialPicker: materialPickerEn,
    materialView: materialViewEn,
    supplierView: supplierViewEn,
    importWizard: importWizardEn,
    vehicles: vehiclesEn,
    machines: machinesEn,
    aufmass: {
      title: 'Measurements', newAufmass: 'New measurement', editAufmass: 'Edit measurement',
      noAufmass: 'No measurements yet.', draft: 'Draft', approved: 'Approved',
      approve: 'Approve', reopen: 'Reopen', deleteConfirm: 'Really delete measurement?',
      titleLabel: 'Title', titlePlaceholder: 'e.g. Roof insulation north side',
      dateLabel: 'Date', projectLabel: 'Project', noProject: '– no project –', notesLabel: 'Notes',
      position: 'Position', positions: 'Positions', addPosition: '+ Add position', positionTitle: 'Position title',
      positionTitlePlaceholder: 'e.g. Roof insulation', unit: 'Unit',
      addRow: '+ Row', rowLabel: 'Description', rowLabelPlaceholder: 'e.g. North side',
      count: 'Qty', length: 'L (m)', width: 'W (m)', height: 'H (m)', result: 'Result', total: 'Total',
      positionCount: '{n} position(s)', saveError: 'Save error.', titleRequired: 'Title required.',
      lockedByOther: 'This measurement is currently being edited by {name}. You will be redirected to the list.',
      weightKg: 'Qty (kg)', backToList: 'Back to list', exportHint: 'Copy to offer',
      tourNewTitle: 'Create new measurement', tourNewText: 'Click here to create a new measurement. You can set a title, project and date.',
      tourSearchTitle: 'Search & filter', tourSearchText: 'Search by title, project or creator. Also filter by status (Draft / Approved).',
      tourListTitle: 'Measurement overview', tourListText: 'All measurements at a glance – with project, date, status and position count. Click a card to open it.',
      tourModalTitle: 'Create measurement', tourModalText: 'Enter a title, optionally select a project and set the date. "Create" opens the measurement for editing.',
      tourStatusTitle: 'Status & metadata', tourStatusText: 'Current status (Draft or Approved), project, date and creator at a glance.',
      tourActionsTitle: 'Action bar', tourActionsText: 'Save changes, approve the measurement, export as PDF or delete it. An approved measurement is read-only.',
      tourPositionTitle: 'Positions', tourPositionText: 'Each position has a title and a unit (m², lfm, m³, pcs). Enter count, length and width – the result is calculated automatically.',
      tourAddPositionTitle: 'Add position', tourAddPositionText: 'Add as many positions as needed to capture different measurement areas. Each has its own table and total.',
      startTour: 'Start tour',
      infoText: 'The measurement overview shows all recorded measurements for your company.',
      infoItem1: 'Create new measurements with a title, project reference and date',
      infoItem2: 'Filter by status (Draft / Approved) or search by title',
      infoItem3: 'Approved measurements serve as the basis for quotes and invoices',
      infoDetailText: 'In the measurement editor you capture dimensions structured into positions and rows.',
      infoDetailItem1: 'Each position has a unit (m², lfm, m³, pcs) – rows are calculated automatically',
      infoDetailItem2: 'Save drafts at any time and approve the measurement when it is complete',
      infoDetailItem3: 'Approved measurements are read-only and can be exported as PDF',
    },
    roles: {
      admin: 'Administrator',
      tenant_admin: 'Tenant admin',
      superadmin: 'Super admin',
      manager: 'Manager',
      employee: 'Employee'
    }
  },
  fr: {
    common: {
      close: 'Fermer',
      back: 'Retour',
      save: 'Enregistrer',
      search: 'Rechercher',
      tour: { next: 'Suivant →', done: 'Terminer', skip: 'Passer' },
      cancel: 'Annuler',
      create: 'Créer',
      delete: 'Supprimer',
      info: 'Info',
      reset: 'Réinitialiser',
      draftSave: 'Enregistrer le brouillon',
      logout: 'Se deconnecter',
      language: 'Langue',
      lightMode: 'Mode clair',
      darkMode: 'Mode sombre',
      unsavedChangesLeaveConfirm: 'Les modifications non enregistrees seront perdues. Quitter cette page ?',
      unsavedChangesDiscardConfirm: 'Ignorer les modifications non enregistrees ?',
      saved: 'Enregistré',
      deleted: 'Supprimé',
      refresh: 'Actualiser',
      loading: 'Chargement…',
      trialLimitExceeded: 'Limite d\'essai atteinte : {current} sur {limit} {entity} deja crees. Veuillez passer au plan Pro.',
      trialEntities: {
        project: 'projets', customer: 'clients', employee: 'employes',
        work_timestamp: 'entrees de temps', material: 'materiaux', material_movement: 'mouvements de materiel',
        supplier: 'fournisseurs', offer: 'offres', invoice: 'factures',
        machine: 'machines', vehicle: 'vehicules',
      },
    },
    support: {
      title: 'Signaler un problème',
      buttonTitle: 'Signaler un problème',
      category: 'Catégorie',
      categoryPlaceholder: '– veuillez choisir –',
      categoryBug: 'Bug / Erreur',
      categoryFeature: 'Demande de fonctionnalité',
      categoryQuestion: 'Question',
      categoryOther: 'Autre',
      description: 'Description',
      descriptionPlaceholder: 'Que s\'est-il passé ? Qu\'attendiez-vous ?',
      send: 'Envoyer',
      sending: 'Envoi en cours…',
      errorSend: 'Erreur lors de l\'envoi. Veuillez réessayer.',
    },
    nav: {
      overview: 'Vue d\'ensemble',
      assets: 'Actifs',
      vehicles: 'Véhicules',
      machines: 'Machines',
      crm: 'CRM',
      projects: 'Projets',
      personal: 'Personnel',
      material: 'Materiel',
      documents: 'Documents',
      admin: 'Administration',
      dashboard: 'Tableau de bord',
      customers: 'Clients',
      projectsList: 'Projets',
      schedule: 'Planification chantier',
      timeRecording: 'Saisie des temps',
      mediaStorage: 'Mediatheque',
      calculator: 'Calculateur',
      reports: 'Rapports',
      vacation: 'Conges',
      sickLeave: 'Arrets maladie',
      payroll: 'Paie',
      warehouse: 'Entrepot',
      suppliers: 'Fournisseurs',
      offers: 'Offres',
      invoices: 'Factures',
      creditNotes: 'Avoirs',
      employees: 'Employes',
      permissions: 'Autorisations',
      settings: 'Parametres',
      changelog: 'Journal des actions',
      chat: 'Chat projet',
      aufmass: 'Métré',
      restartTour: 'Lancer la visite de navigation',
      tourUserTitle: 'Profil utilisateur', tourUserText: 'Cliquez sur votre nom pour ouvrir le profil – changez la langue et le mot de passe.',
      tourProfileTitle: 'Profil', tourProfileText: 'Afficher nom, e-mail et rôle. Choisir la langue et changer le mot de passe.',
      tourThemeTitle: 'Mode clair/sombre', tourThemeText: 'Basculez entre design clair et sombre.',
      tourLogoutTitle: 'Déconnexion', tourLogoutText: 'Vous déconnecte en toute sécurité de l\'application.',
      tourMobileUserTitle: 'Profil (mobile)', tourMobileUserText: 'Sur mobile accédez au profil via vos initiales en haut à droite – mêmes fonctions que sur bureau.',
    },
    chat: {
      title: 'Chat projet',
      noRooms: "Vous n'etes affecte a aucun projet.",
      selectRoom: 'Selectionnez un projet pour ouvrir le chat.',
      noMessages: 'Aucun message pour l instant.',
      typeMessage: 'Ecrire un message...',
      send: 'Envoyer',
      today: "Aujourd hui",
      yesterday: 'Hier',
      infoText: 'Le chat projet permet une communication directe au sein de l equipe pour chaque projet.',
      infoItem1: 'Envoyer et recevoir des messages en temps reel',
      infoItem2: 'Chaque projet possede son propre canal de chat',
      infoItem3: 'Les messages non lus sont indiques par un badge',
      infoItem4: 'Les employes affectes au projet ont automatiquement acces – leur suppression retire cet acces',
      startTour: 'Lancer la visite guidée',
      tourRoomsTitle: 'Chats de projets',
      tourRoomsText: 'Ici vous voyez tous les projets dont vous êtes membre. Les messages non lus sont indiqués par un badge rouge.',
      tourMessagesTitle: 'Messages',
      tourMessagesText: 'Tous les messages du projet en ordre chronologique. Cliquez sur une image pour l\'agrandir.',
      tourInputTitle: 'Envoyer un message',
      tourInputText: 'Rédigez un message ou ajoutez une image – via le sélecteur ou coller (Ctrl+V). Appuyez sur Entrée pour envoyer.',
      attachImage: 'Joindre une image',
      removeImage: "Supprimer l image",
      image: 'Image',
    },
    profile: {
      title: 'Mon profil',
      name: 'Nom',
      email: 'E-mail',
      role: 'Role',
      changePassword: 'Changer le mot de passe',
      currentPassword: 'Mot de passe actuel',
      newPassword: 'Nouveau mot de passe (min. 8 caracteres)',
      confirmPassword: 'Confirmer le mot de passe',
      close: 'Fermer',
      updatePassword: 'Changer le mot de passe',
      enterCurrentPassword: 'Saisissez le mot de passe actuel',
      minPasswordLength: 'Min. 8 caracteres',
      mismatch: 'Les mots de passe ne correspondent pas',
      success: 'Mot de passe modifie',
      error: 'Erreur',
      showPassword: 'Afficher le mot de passe',
      hidePassword: 'Masquer le mot de passe'
    },
    auth: authFr,
    docForm: docFormFr,
    status: statusFr,
    documents: documentsFr,
    settings: settingsFr,
    dashboard: dashboardFr,
    customers: customersFr,
    project: projectFr,
    schedule: scheduleFr,
    time: timeFr,
    media: mediaFr,
    calc: calcFr,
    report: reportFr,
    vacation: vacationFr,
    sick: sickFr,
    payroll: payrollFr,
    projects: projectsFr,
    inventory: inventoryFr,
    qrScanner: qrScannerFr,
    textBlocks: textBlocksFr,
    employee: employeeFr,
    permissions: permissionsFr,
    materialPicker: materialPickerFr,
    materialView: materialViewFr,
    supplierView: supplierViewFr,
    importWizard: importWizardFr,
    vehicles: vehiclesFr,
    machines: machinesFr,
    aufmass: {
      title: 'Métré', newAufmass: 'Nouveau métré', editAufmass: 'Modifier le métré',
      noAufmass: 'Aucun métré.', draft: 'Brouillon', approved: 'Validé',
      approve: 'Valider', reopen: 'Réouvrir', deleteConfirm: 'Supprimer ce métré ?',
      titleLabel: 'Intitulé', titlePlaceholder: 'ex. Isolation toiture côté nord',
      dateLabel: 'Date', projectLabel: 'Projet', noProject: '– aucun projet –', notesLabel: 'Notes',
      position: 'Poste', positions: 'Postes', addPosition: '+ Ajouter un poste', positionTitle: 'Titre du poste',
      positionTitlePlaceholder: 'ex. Isolation toiture', unit: 'Unité',
      addRow: '+ Ligne', rowLabel: 'Description', rowLabelPlaceholder: 'ex. Côté nord',
      count: 'Qté', length: 'L (m)', width: 'l (m)', height: 'h (m)', result: 'Résultat', total: 'Total',
      positionCount: '{n} poste(s)', saveError: 'Erreur de sauvegarde.', titleRequired: 'Intitulé requis.',
      lockedByOther: 'Ce metre est actuellement modifie par {name}. Vous allez etre redirige vers la liste.',
      weightKg: 'Qté (kg)', backToList: 'Retour', exportHint: 'Copier dans l\'offre',
      tourNewTitle: 'Créer un métré', tourNewText: 'Cliquez ici pour créer un nouveau métré. Vous pouvez définir un intitulé, un projet et une date.',
      tourSearchTitle: 'Rechercher & filtrer', tourSearchText: 'Recherchez par intitulé, projet ou créateur. Filtrez aussi par statut (Brouillon / Validé).',
      tourListTitle: 'Vue d\'ensemble', tourListText: 'Tous les métrés d\'un coup d\'œil – avec projet, date, statut et nombre de postes. Cliquez sur une carte pour l\'ouvrir.',
      tourModalTitle: 'Créer un métré', tourModalText: 'Saisissez un intitulé, sélectionnez un projet et définissez la date. "Créer" ouvre le métré pour l\'édition.',
      tourStatusTitle: 'Statut & métadonnées', tourStatusText: 'Statut actuel (Brouillon ou Validé), projet, date et créateur en un coup d\'œil.',
      tourActionsTitle: 'Barre d\'actions', tourActionsText: 'Enregistrez, validez, exportez en PDF ou supprimez. Un métré validé est en lecture seule.',
      tourPositionTitle: 'Postes', tourPositionText: 'Chaque poste a un titre et une unité (m², lfm, m³, pcs). Saisissez quantité, longueur et largeur – le résultat est calculé automatiquement.',
      tourAddPositionTitle: 'Ajouter un poste', tourAddPositionText: 'Ajoutez autant de postes que nécessaire. Chacun a son propre tableau et son total.',
      startTour: 'Lancer la visite guidée',
      infoText: 'La vue d\'ensemble des métrés affiche tous les métrés enregistrés de votre entreprise.',
      infoItem1: 'Créez de nouveaux métrés avec un intitulé, un projet et une date',
      infoItem2: 'Filtrez par statut (Brouillon / Validé) ou recherchez par intitulé',
      infoItem3: 'Les métrés validés servent de base pour les devis et les factures',
      infoDetailText: 'Dans l\'éditeur de métré, vous saisissez les mesures structurées en postes et lignes.',
      infoDetailItem1: 'Chaque poste a une unité (m², lfm, m³, pcs) – les lignes sont calculées automatiquement',
      infoDetailItem2: 'Enregistrez les brouillons à tout moment et validez le métré quand il est prêt',
      infoDetailItem3: 'Les métrés validés sont en lecture seule et peuvent être exportés en PDF',
    },
    roles: {
      admin: 'Administrateur',
      tenant_admin: 'Admin locataire',
      superadmin: 'Super administrateur',
      manager: 'Manager',
      employee: 'Employe'
    }
  },
  it: {
    common: {
      close: 'Chiudi',
      back: 'Indietro',
      save: 'Salva',
      search: 'Cerca',
      cancel: 'Annulla',
      tour: { next: 'Avanti →', done: 'Fine', skip: 'Salta' },
      create: 'Crea',
      delete: 'Elimina',
      info: 'Info',
      reset: 'Reimposta',
      draftSave: 'Salva bozza',
      logout: 'Esci',
      language: 'Lingua',
      lightMode: 'Modalita chiara',
      darkMode: 'Modalita scura',
      unsavedChangesLeaveConfirm: 'Le modifiche non salvate andranno perse. Vuoi davvero lasciare questa pagina?',
      unsavedChangesDiscardConfirm: 'Scartare le modifiche non salvate?',
      saved: 'Salvato',
      deleted: 'Eliminato',
      refresh: 'Aggiorna',
      loading: 'Caricamento…',
      trialLimitExceeded: 'Limite trial raggiunto: {current} su {limit} {entity} gia creati. Eseguire l\'upgrade al piano Pro.',
      trialEntities: {
        project: 'progetti', customer: 'clienti', employee: 'dipendenti',
        work_timestamp: 'registrazioni orarie', material: 'materiali', material_movement: 'movimenti materiale',
        supplier: 'fornitori', offer: 'offerte', invoice: 'fatture',
        machine: 'macchine', vehicle: 'veicoli',
      },
    },
    support: {
      title: 'Segnala un problema',
      buttonTitle: 'Segnala un problema',
      category: 'Categoria',
      categoryPlaceholder: '– seleziona –',
      categoryBug: 'Bug / Errore',
      categoryFeature: 'Richiesta funzionalità',
      categoryQuestion: 'Domanda',
      categoryOther: 'Altro',
      description: 'Descrizione',
      descriptionPlaceholder: 'Cosa è successo? Cosa ti aspettavi?',
      send: 'Invia',
      sending: 'Invio in corso…',
      errorSend: 'Errore durante l\'invio. Riprova.',
    },
    nav: {
      overview: 'Panoramica',
      assets: 'Attivi',
      vehicles: 'Veicoli',
      machines: 'Macchine',
      crm: 'CRM',
      projects: 'Progetti',
      personal: 'Personale',
      material: 'Materiale',
      documents: 'Documenti',
      admin: 'Amministrazione',
      dashboard: 'Dashboard',
      customers: 'Clienti',
      projectsList: 'Progetti',
      schedule: 'Pianificazione cantiere',
      timeRecording: 'Rilevazione ore',
      mediaStorage: 'Archivio media',
      calculator: 'Calcolatore',
      reports: 'Report',
      vacation: 'Ferie',
      sickLeave: 'Malattia',
      payroll: 'Buste paga',
      warehouse: 'Magazzino',
      suppliers: 'Fornitori',
      offers: 'Offerte',
      invoices: 'Fatture',
      creditNotes: 'Note di credito',
      employees: 'Dipendenti',
      permissions: 'Permessi',
      settings: 'Impostazioni',
      changelog: 'Registro azioni',
      chat: 'Chat progetto',
      aufmass: 'Computo metrico',
      restartTour: 'Avvia tour navigazione',
      tourUserTitle: 'Profilo utente', tourUserText: 'Clicca sul tuo nome per aprire il profilo – cambia lingua e password.',
      tourProfileTitle: 'Profilo', tourProfileText: 'Visualizza nome, e-mail e ruolo. Scegli la lingua e cambia la password.',
      tourThemeTitle: 'Modalità chiara/scura', tourThemeText: 'Passa tra design chiaro e scuro.',
      tourLogoutTitle: 'Disconnetti', tourLogoutText: 'Ti disconnette in modo sicuro dall\'applicazione.',
      tourMobileUserTitle: 'Profilo (mobile)', tourMobileUserText: 'Su mobile accedi al profilo tramite le tue iniziali in alto a destra – stesse funzioni del desktop.',
    },
    chat: {
      title: 'Chat progetto',
      noRooms: 'Non sei ancora assegnato a nessun progetto.',
      selectRoom: 'Seleziona un progetto per aprire la chat.',
      noMessages: 'Nessun messaggio.',
      typeMessage: 'Scrivi un messaggio...',
      send: 'Invia',
      today: 'Oggi',
      yesterday: 'Ieri',
      infoText: 'La chat di progetto consente la comunicazione diretta nel team per ogni progetto.',
      infoItem1: 'Invia e ricevi messaggi in tempo reale',
      infoItem2: 'Ogni progetto ha il proprio canale chat',
      infoItem3: 'I messaggi non letti sono indicati con un badge',
      infoItem4: 'I dipendenti assegnati al progetto hanno automaticamente accesso – la rimozione revoca l accesso',
      startTour: 'Avvia la guida',
      tourRoomsTitle: 'Chat di progetto',
      tourRoomsText: 'Qui vedi tutti i progetti di cui sei membro. I messaggi non letti sono indicati con un badge rosso.',
      tourMessagesTitle: 'Messaggi',
      tourMessagesText: 'Tutti i messaggi del progetto in ordine cronologico. Clicca su un\'immagine per ingrandirla.',
      tourInputTitle: 'Invia messaggio',
      tourInputText: 'Scrivi un messaggio o aggiungi un\'immagine – tramite selettore file o incolla (Ctrl+V). Premi Invio per inviare.',
      attachImage: 'Allega immagine',
      removeImage: 'Rimuovi immagine',
      image: 'Immagine',
    },
    profile: {
      title: 'Il mio profilo',
      name: 'Nome',
      email: 'Email',
      role: 'Ruolo',
      changePassword: 'Cambia password',
      currentPassword: 'Password attuale',
      newPassword: 'Nuova password (min. 8 caratteri)',
      confirmPassword: 'Conferma password',
      close: 'Chiudi',
      updatePassword: 'Cambia password',
      enterCurrentPassword: 'Inserire la password attuale',
      minPasswordLength: 'Min. 8 caratteri',
      mismatch: 'Le password non corrispondono',
      success: 'Password aggiornata',
      error: 'Errore',
      showPassword: 'Mostra password',
      hidePassword: 'Nascondi password'
    },
    auth: authIt,
    docForm: docFormIt,
    status: statusIt,
    documents: documentsIt,
    settings: settingsIt,
    dashboard: dashboardIt,
    customers: customersIt,
    project: projectIt,
    schedule: scheduleIt,
    time: timeIt,
    media: mediaIt,
    calc: calcIt,
    report: reportIt,
    vacation: vacationIt,
    sick: sickIt,
    payroll: payrollIt,
    projects: projectsIt,
    inventory: inventoryIt,
    qrScanner: qrScannerIt,
    textBlocks: textBlocksIt,
    employee: employeeIt,
    permissions: permissionsIt,
    materialPicker: materialPickerIt,
    materialView: materialViewIt,
    supplierView: supplierViewIt,
    importWizard: importWizardIt,
    vehicles: vehiclesIt,
    machines: machinesIt,
    aufmass: {
      title: 'Computo', newAufmass: 'Nuovo computo', editAufmass: 'Modifica computo',
      noAufmass: 'Nessun computo.', draft: 'Bozza', approved: 'Approvato',
      approve: 'Approva', reopen: 'Riapri', deleteConfirm: 'Eliminare questo computo?',
      titleLabel: 'Titolo', titlePlaceholder: 'es. Isolamento tetto lato nord',
      dateLabel: 'Data', projectLabel: 'Progetto', noProject: '– nessun progetto –', notesLabel: 'Note',
      position: 'Posizione', positions: 'Posizioni', addPosition: '+ Aggiungi posizione', positionTitle: 'Titolo posizione',
      positionTitlePlaceholder: 'es. Isolamento tetto', unit: 'Unità',
      addRow: '+ Riga', rowLabel: 'Descrizione', rowLabelPlaceholder: 'es. Lato nord',
      count: 'N.', length: 'L (m)', width: 'L (m)', height: 'A (m)', result: 'Risultato', total: 'Totale',
      positionCount: '{n} posizione/i', saveError: 'Errore salvataggio.', titleRequired: 'Titolo obbligatorio.',
      lockedByOther: 'Questo computo metrico e attualmente in modifica da {name}. Verrai reindirizzato all elenco.',
      weightKg: 'Qtà (kg)', backToList: 'Torna alla lista', exportHint: 'Copia in offerta',
      tourNewTitle: 'Crea computo', tourNewText: 'Clicca qui per creare un nuovo computo. Puoi impostare titolo, progetto e data.',
      tourSearchTitle: 'Cerca & filtra', tourSearchText: 'Cerca per titolo, progetto o creatore. Filtra anche per stato (Bozza / Approvato).',
      tourListTitle: 'Panoramica', tourListText: 'Tutti i computi a colpo d\'occhio – con progetto, data, stato e numero di posizioni. Clicca su una scheda per aprirla.',
      tourModalTitle: 'Crea computo', tourModalText: 'Inserisci un titolo, seleziona opzionalmente un progetto e imposta la data. "Crea" apre il computo per la modifica.',
      tourStatusTitle: 'Stato & metadati', tourStatusText: 'Stato corrente (Bozza o Approvato), progetto, data e creatore in un\'unica visualizzazione.',
      tourActionsTitle: 'Barra azioni', tourActionsText: 'Salva, approva, esporta in PDF o elimina. Un computo approvato è di sola lettura.',
      tourPositionTitle: 'Posizioni', tourPositionText: 'Ogni posizione ha un titolo e un\'unità (m², lfm, m³, pz). Inserisci quantità, lunghezza e larghezza – il risultato è calcolato automaticamente.',
      tourAddPositionTitle: 'Aggiungi posizione', tourAddPositionText: 'Aggiungi tutte le posizioni necessarie per diverse aree di misura. Ognuna ha la sua tabella e il suo totale.',
      startTour: 'Avvia la guida',
      infoText: 'La panoramica dei computi mostra tutti i computi registrati della tua azienda.',
      infoItem1: 'Crea nuovi computi con titolo, progetto e data',
      infoItem2: 'Filtra per stato (Bozza / Approvato) o cerca per titolo',
      infoItem3: 'I computi approvati servono come base per preventivi e fatture',
      infoDetailText: 'Nell\'editor dei computi inserisci le misure strutturate in posizioni e righe.',
      infoDetailItem1: 'Ogni posizione ha un\'unità (m², lfm, m³, pz) – le righe vengono calcolate automaticamente',
      infoDetailItem2: 'Salva le bozze in qualsiasi momento e approva il computo quando è pronto',
      infoDetailItem3: 'I computi approvati sono di sola lettura e possono essere esportati come PDF',
    },
    roles: {
      admin: 'Amministratore',
      tenant_admin: 'Admin tenant',
      superadmin: 'Super admin',
      manager: 'Manager',
      employee: 'Dipendente'
    }
  },
  pl: {
    common: {
      close: 'Zamknij',
      back: 'Wstecz',
      save: 'Zapisz',
      search: 'Szukaj',
      cancel: 'Anuluj',
      create: 'Utworz',
      tour: { next: 'Dalej →', done: 'Gotowe', skip: 'Pomiń' },
      delete: 'Usun',
      info: 'Info',
      reset: 'Resetuj',
      draftSave: 'Zapisz wersje robocza',
      logout: 'Wyloguj',
      language: 'Jezyk',
      lightMode: 'Tryb jasny',
      darkMode: 'Tryb ciemny',
      unsavedChangesLeaveConfirm: 'Niezapisane zmiany zostana utracone. Czy na pewno opuscic strone?',
      unsavedChangesDiscardConfirm: 'Odrzucic niezapisane zmiany?',
      saved: 'Zapisano',
      deleted: 'Usunieto',
      refresh: 'Odswiez',
      loading: 'Ladowanie…',
      trialLimitExceeded: 'Osiagnieto limit trial: {current} z {limit} {entity} juz utworzono. Przejdz na plan Pro.',
      trialEntities: {
        project: 'projektow', customer: 'klientow', employee: 'pracownikow',
        work_timestamp: 'wpisow czasu', material: 'materialow', material_movement: 'ruchow materialowych',
        supplier: 'dostawcow', offer: 'ofert', invoice: 'faktur',
        machine: 'maszyn', vehicle: 'pojazdow',
      },
    },
    support: {
      title: 'Zgłoś problem',
      buttonTitle: 'Zgłoś problem',
      category: 'Kategoria',
      categoryPlaceholder: '– wybierz –',
      categoryBug: 'Błąd / Bug',
      categoryFeature: 'Propozycja funkcji',
      categoryQuestion: 'Pytanie',
      categoryOther: 'Inne',
      description: 'Opis',
      descriptionPlaceholder: 'Co się stało? Czego się spodziewałeś?',
      send: 'Wyślij',
      sending: 'Wysyłanie…',
      errorSend: 'Błąd podczas wysyłania. Spróbuj ponownie.',
    },
    nav: {
      overview: 'Przeglad',
      assets: 'Aktywa',
      vehicles: 'Pojazdy',
      machines: 'Maszyny',
      crm: 'CRM',
      projects: 'Projekty',
      personal: 'Personel',
      material: 'Materialy',
      documents: 'Dokumenty',
      admin: 'Administracja',
      dashboard: 'Panel',
      customers: 'Klienci',
      projectsList: 'Projekty',
      schedule: 'Planowanie budowy',
      timeRecording: 'Ewidencja czasu',
      mediaStorage: 'Archiwum mediow',
      calculator: 'Kalkulator',
      reports: 'Raporty',
      vacation: 'Urlop',
      sickLeave: 'Zwolnienia chorobowe',
      payroll: 'Lista plac',
      warehouse: 'Magazyn',
      suppliers: 'Dostawcy',
      offers: 'Oferty',
      invoices: 'Faktury',
      creditNotes: 'Faktury korygujace',
      employees: 'Pracownicy',
      permissions: 'Uprawnienia',
      settings: 'Ustawienia',
      changelog: 'Dziennik zmian',
      chat: 'Chat projektu',
      aufmass: 'Obmiar',
      restartTour: 'Uruchom tour nawigacji',
      tourUserTitle: 'Profil użytkownika', tourUserText: 'Kliknij swoje imię aby otworzyć profil – zmień język i hasło.',
      tourProfileTitle: 'Profil', tourProfileText: 'Wyświetl imię, e-mail i rolę. Wybierz język interfejsu i zmień hasło.',
      tourThemeTitle: 'Tryb jasny/ciemny', tourThemeText: 'Przełącz między jasnym a ciemnym projektem.',
      tourLogoutTitle: 'Wyloguj', tourLogoutText: 'Bezpiecznie wylogowuje Cię z aplikacji.',
      tourMobileUserTitle: 'Profil (mobile)', tourMobileUserText: 'Na urządzeniu mobilnym dostęp do profilu przez inicjały w prawym górnym rogu – te same funkcje co na komputerze.',
    },
    chat: {
      title: 'Chat projektu',
      noRooms: 'Nie jestes przypisany do zadnego projektu.',
      selectRoom: 'Wybierz projekt aby otworzyc czat.',
      noMessages: 'Brak wiadomosci.',
      typeMessage: 'Napisz wiadomosc...',
      send: 'Wyslij',
      today: 'Dzisiaj',
      yesterday: 'Wczoraj',
      infoText: 'Chat projektu umozliwia bezposrednia komunikacje w zespole dla kazdego projektu.',
      infoItem1: 'Wysylaj i odbieraj wiadomosci w czasie rzeczywistym',
      infoItem2: 'Kazdy projekt ma swoj wlasny kanal czatu',
      infoItem3: 'Nieprzeczytane wiadomosci sa oznaczone odznakami',
      infoItem4: 'Pracownicy przypisani do projektu automatycznie uzyskuja dostep – usuniecie odbiera dostep',
      startTour: 'Uruchom przewodnik',
      tourRoomsTitle: 'Czaty projektów',
      tourRoomsText: 'Tu widzisz wszystkie projekty, których jesteś członkiem. Nieprzeczytane wiadomości są oznaczone czerwoną odznaką.',
      tourMessagesTitle: 'Wiadomości',
      tourMessagesText: 'Wszystkie wiadomości projektu w kolejności chronologicznej. Kliknij na obraz aby go powiększyć.',
      tourInputTitle: 'Wyślij wiadomość',
      tourInputText: 'Napisz wiadomość lub dodaj obraz – przez selektor pliku lub wklej (Ctrl+V). Naciśnij Enter aby wysłać.',
      attachImage: 'Dolacz obraz',
      removeImage: 'Usun obraz',
      image: 'Obraz',
    },
    profile: {
      title: 'Moj profil',
      name: 'Imie i nazwisko',
      email: 'E-mail',
      role: 'Rola',
      changePassword: 'Zmien haslo',
      currentPassword: 'Aktualne haslo',
      newPassword: 'Nowe haslo (min. 8 znakow)',
      confirmPassword: 'Potwierdz haslo',
      close: 'Zamknij',
      updatePassword: 'Zmien haslo',
      enterCurrentPassword: 'Wpisz aktualne haslo',
      minPasswordLength: 'Min. 8 znakow',
      mismatch: 'Hasla nie sa zgodne',
      success: 'Haslo zmienione',
      error: 'Blad',
      showPassword: 'Pokaz haslo',
      hidePassword: 'Ukryj haslo'
    },
    auth: authPl,
    docForm: docFormPl,
    status: statusPl,
    documents: documentsPl,
    settings: settingsPl,
    dashboard: dashboardPl,
    customers: customersPl,
    project: projectPl,
    schedule: schedulePl,
    time: timePl,
    media: mediaPl,
    calc: calcPl,
    report: reportPl,
    vacation: vacationPl,
    sick: sickPl,
    payroll: payrollPl,
    projects: projectsPl,
    inventory: inventoryPl,
    qrScanner: qrScannerPl,
    textBlocks: textBlocksPl,
    employee: employeePl,
    permissions: permissionsPl,
    materialPicker: materialPickerPl,
    materialView: materialViewPl,
    supplierView: supplierViewPl,
    importWizard: importWizardPl,
    vehicles: vehiclesPl,
    machines: machinesPl,
    aufmass: {
      title: 'Obmiar', newAufmass: 'Nowy obmiar', editAufmass: 'Edytuj obmiar',
      noAufmass: 'Brak obmiarow.', draft: 'Szkic', approved: 'Zatwierdzony',
      approve: 'Zatwierdz', reopen: 'Wznow', deleteConfirm: 'Usunac ten obmiar?',
      titleLabel: 'Tytul', titlePlaceholder: 'np. Izolacja dachu',
      dateLabel: 'Data', projectLabel: 'Projekt', noProject: '– brak projektu –', notesLabel: 'Uwagi',
      position: 'Pozycja', positions: 'Pozycje', addPosition: '+ Dodaj pozycje', positionTitle: 'Tytul pozycji',
      positionTitlePlaceholder: 'np. Izolacja dachu', unit: 'Jednostka',
      addRow: '+ Wiersz', rowLabel: 'Opis', rowLabelPlaceholder: 'np. Strona polnocna',
      count: 'Il.', length: 'D (m)', width: 'S (m)', height: 'W (m)', result: 'Wynik', total: 'Suma',
      positionCount: '{n} pozycja/e', saveError: 'Blad zapisu.', titleRequired: 'Tytul wymagany.',
      lockedByOther: 'Ten obmiar jest aktualnie edytowany przez {name}. Zostaniesz przekierowany do listy.',
      weightKg: 'Ilość (kg)', backToList: 'Powrot', exportHint: 'Kopiuj do oferty',
      tourNewTitle: 'Nowy obmiar', tourNewText: 'Kliknij tutaj, aby utworzyc nowy obmiar. Mozesz ustawic tytul, projekt i date.',
      tourSearchTitle: 'Szukaj & filtruj', tourSearchText: 'Szukaj po tytule, projekcie lub autorze. Filtruj takze po statusie (Szkic / Zatwierdzony).',
      tourListTitle: 'Przeglad obmiarow', tourListText: 'Wszystkie obmiary w jednym miejscu – z projektem, data, statusem i liczba pozycji. Kliknij karte, aby ja otworzyc.',
      tourModalTitle: 'Utworz obmiar', tourModalText: 'Podaj tytul, opcjonalnie wybierz projekt i ustaw date. "Utworz" otwiera obmiar do edycji.',
      tourStatusTitle: 'Status & metadane', tourStatusText: 'Aktualny status (Szkic lub Zatwierdzony), projekt, data i autor jednym rzutem oka.',
      tourActionsTitle: 'Pasek akcji', tourActionsText: 'Zapisz, zatwierdz, eksportuj do PDF lub usun. Zatwierdzony obmiar jest tylko do odczytu.',
      tourPositionTitle: 'Pozycje', tourPositionText: 'Kazda pozycja ma tytul i jednostke (m², lfm, m³, szt.). Wpisz ilosc, dlugosc i szerokosc – wynik jest obliczany automatycznie.',
      tourAddPositionTitle: 'Dodaj pozycje', tourAddPositionText: 'Dodaj dowolna liczbe pozycji dla roznych obszarow pomiarowych. Kazda ma wlasna tabele i sume.',
      startTour: 'Uruchom przewodnik',
      infoText: 'Przeglad obmiarow pokazuje wszystkie zarejestrowane obmiary twojej firmy.',
      infoItem1: 'Tworzenie nowych obmiarow z tytulem, projektem i data',
      infoItem2: 'Filtrowanie wedlug statusu (Szkic / Zatwierdzony) lub wyszukiwanie po tytule',
      infoItem3: 'Zatwierdzone obmiary stanowia podstawe dla ofert i faktur',
      infoDetailText: 'W edytorze obmiarow zapisujesz wymiary podzielone na pozycje i wiersze.',
      infoDetailItem1: 'Kazda pozycja ma jednostke (m², lfm, m³, szt.) – wiersze sa obliczane automatycznie',
      infoDetailItem2: 'Zapisuj szkice w dowolnym momencie i zatwierdz obmiar gdy jest gotowy',
      infoDetailItem3: 'Zatwierdzone obmiary sa tylko do odczytu i moga byc eksportowane jako PDF',
    },
    roles: {
      admin: 'Administrator',
      tenant_admin: 'Administrator najemcy',
      superadmin: 'Super administrator',
      manager: 'Manager',
      employee: 'Pracownik'
    }
  },
  cs: {
    common: {
      close: 'Zavrit',
      back: 'Zpet',
      save: 'Ulozit',
      search: 'Hledat',
      tour: { next: 'Dalsi →', done: 'Hotovo', skip: 'Preskocit' },
      cancel: 'Zrusit',
      create: 'Vytvorit',
      delete: 'Smazat',
      info: 'Info',
      reset: 'Resetovat',
      draftSave: 'Ulozit koncept',
      logout: 'Odhlasit se',
      language: 'Jazyk',
      lightMode: 'Svetly rezim',
      darkMode: 'Tmavy rezim',
      unsavedChangesLeaveConfirm: 'Nevyulozene zmeny budou ztraceny. Opravdu opustit tuto stranku?',
      unsavedChangesDiscardConfirm: 'Zahodit neulozene zmeny?',
      saved: 'Ulozeno',
      deleted: 'Smazano',
      refresh: 'Obnovit',
      loading: 'Nacitani…',
      trialLimitExceeded: 'Limit trial dosažen: {current} z {limit} {entity} již vytvoreno. Provedte upgrade na plan Pro.',
      trialEntities: {
        project: 'projektu', customer: 'zakazniku', employee: 'zamestnancu',
        work_timestamp: 'casovych zaznamu', material: 'materialu', material_movement: 'pohybu materialu',
        supplier: 'dodavatelu', offer: 'nabidek', invoice: 'faktur',
        machine: 'stroju', vehicle: 'vozidel',
      },
    },
    support: {
      title: 'Nahlásit problém',
      buttonTitle: 'Nahlásit problém',
      category: 'Kategorie',
      categoryPlaceholder: '– vyberte –',
      categoryBug: 'Chyba / Bug',
      categoryFeature: 'Požadavek na funkci',
      categoryQuestion: 'Otázka',
      categoryOther: 'Ostatní',
      description: 'Popis',
      descriptionPlaceholder: 'Co se stalo? Co jste očekávali?',
      send: 'Odeslat',
      sending: 'Odesílání…',
      errorSend: 'Chyba při odesílání. Zkuste to prosím znovu.',
    },
    nav: {
      overview: 'Prehled',
      assets: 'Aktiva',
      vehicles: 'Vozidla',
      machines: 'Stroje',
      crm: 'CRM',
      projects: 'Projekty',
      personal: 'Personal',
      material: 'Material',
      documents: 'Dokumenty',
      admin: 'Administrace',
      dashboard: 'Nastenka',
      customers: 'Zakaznici',
      projectsList: 'Projekty',
      schedule: 'Planovani stavby',
      timeRecording: 'Evidence casu',
      mediaStorage: 'Archiv medii',
      calculator: 'Kalkulacka',
      reports: 'Reporty',
      vacation: 'Dovolena',
      sickLeave: 'Nemocenska',
      payroll: 'Mzdy',
      warehouse: 'Sklad',
      suppliers: 'Dodavatele',
      offers: 'Nabidky',
      invoices: 'Faktury',
      creditNotes: 'Dobropisy',
      employees: 'Zamestnanci',
      permissions: 'Opravneni',
      settings: 'Nastaveni',
      changelog: 'Záznam změn',
      chat: 'Chat projektu',
      aufmass: 'Výkaz výměr',
      restartTour: 'Spustit tour navigace',
      tourUserTitle: 'Profil uživatele', tourUserText: 'Klikněte na své jméno pro otevření profilu – změňte jazyk a heslo.',
      tourProfileTitle: 'Profil', tourProfileText: 'Zobrazit jméno, e-mail a roli. Vybrat jazyk rozhraní a změnit heslo.',
      tourThemeTitle: 'Světlý/tmavý režim', tourThemeText: 'Přepínání mezi světlým a tmavým designem.',
      tourLogoutTitle: 'Odhlásit se', tourLogoutText: 'Bezpečně vás odhlásí z aplikace.',
      tourMobileUserTitle: 'Profil (mobile)', tourMobileUserText: 'Na mobilním zařízení přistupujte k profilu přes vaše iniciály vpravo nahoře – stejné funkce jako na desktopu.',
    },
    chat: {
      title: 'Chat projektu',
      noRooms: 'Nejste prirazen k zadnemu projektu.',
      selectRoom: 'Vyberte projekt pro otevreni chatu.',
      noMessages: 'Zatim zadne zpravy.',
      typeMessage: 'Napiste zpravu...',
      send: 'Odeslat',
      today: 'Dnes',
      yesterday: 'Vcera',
      infoText: 'Chat projektu umoznuje primou komunikaci v tymu pro kazdy projekt.',
      infoItem1: 'Posilat a prijimat zpravy v realnem case',
      infoItem2: 'Kazdy projekt ma svuj vlastni kanal chatu',
      infoItem3: 'Neprecetene zpravy jsou oznaceny odznakem',
      infoItem4: 'Zamestnanci prirazenı k projektu maji automaticky pristup – odebranım se pristup odobere',
      startTour: 'Spustit průvodce',
      tourRoomsTitle: 'Projektové chaty',
      tourRoomsText: 'Zde vidíte všechny projekty, jejichž jste členem. Nepřečtené zprávy jsou označeny červeným odznakem.',
      tourMessagesTitle: 'Zprávy',
      tourMessagesText: 'Všechny zprávy projektu v chronologickém pořadí. Kliknutím na obrázek jej zvětšíte.',
      tourInputTitle: 'Odeslat zprávu',
      tourInputText: 'Napište zprávu nebo přidejte obrázek – přes výběr souboru nebo vložit (Ctrl+V). Stisknutím Enter odešlete.',
      attachImage: 'Prilozt obrazek',
      removeImage: 'Odebrat obrazek',
      image: 'Obrazek',
    },
    profile: {
      title: 'Muj profil',
      name: 'Jmeno',
      email: 'E-mail',
      role: 'Role',
      changePassword: 'Zmenit heslo',
      currentPassword: 'Aktualni heslo',
      newPassword: 'Nove heslo (min. 8 znaku)',
      confirmPassword: 'Potvrdit heslo',
      close: 'Zavrit',
      updatePassword: 'Zmenit heslo',
      enterCurrentPassword: 'Zadejte aktualni heslo',
      minPasswordLength: 'Min. 8 znaku',
      mismatch: 'Hesla se neshoduji',
      success: 'Heslo zmeneno',
      error: 'Chyba',
      showPassword: 'Zobrazit heslo',
      hidePassword: 'Skryt heslo'
    },
    auth: authCs,
    docForm: docFormCs,
    status: statusCs,
    documents: documentsCs,
    settings: settingsCs,
    dashboard: dashboardCs,
    customers: customersCs,
    project: projectCs,
    schedule: scheduleCs,
    time: timeCs,
    media: mediaCs,
    calc: calcCs,
    report: reportCs,
    vacation: vacationCs,
    sick: sickCs,
    payroll: payrollCs,
    projects: projectsCs,
    inventory: inventoryCs,
    qrScanner: qrScannerCs,
    textBlocks: textBlocksCs,
    employee: employeeCs,
    permissions: permissionsCs,
    materialPicker: materialPickerCs,
    materialView: materialViewCs,
    supplierView: supplierViewCs,
    importWizard: importWizardCs,
    vehicles: vehiclesCs,
    machines: machinesCs,
    aufmass: {
      title: 'Vykaz vymeru', newAufmass: 'Novy vykaz', editAufmass: 'Upravit vykaz',
      noAufmass: 'Zadne vykyze vymeru.', draft: 'Koncept', approved: 'Schvaleno',
      approve: 'Schvalit', reopen: 'Znovu otevrit', deleteConfirm: 'Opravdu smazat vykaz?',
      titleLabel: 'Nazev', titlePlaceholder: 'napr. Izolace strechy',
      dateLabel: 'Datum', projectLabel: 'Projekt', noProject: '– zadny projekt –', notesLabel: 'Poznamky',
      position: 'Polozka', positions: 'Polozky', addPosition: '+ Pridat polozku', positionTitle: 'Nazev polozky',
      positionTitlePlaceholder: 'napr. Izolace strechy', unit: 'Jednotka',
      addRow: '+ Radek', rowLabel: 'Popis', rowLabelPlaceholder: 'napr. Severni strana',
      count: 'Poc.', length: 'D (m)', width: 'S (m)', height: 'V (m)', result: 'Vysledek', total: 'Celkem',
      positionCount: '{n} polozka/ek', saveError: 'Chyba ulozeni.', titleRequired: 'Nazev je povinny.',
      lockedByOther: 'Tento obmer prave upravuje {name}. Budete presmerovani na seznam.',
      weightKg: 'Množ. (kg)', backToList: 'Zpet', exportHint: 'Zkopirovat do nabidky',
      tourNewTitle: 'Novy vykaz', tourNewText: 'Kliknutim zde vytvorite novy vykaz vymeru. Muzete zadat nazev, projekt a datum.',
      tourSearchTitle: 'Hledat & filtrovat', tourSearchText: 'Hledejte podle nazvu, projektu nebo autora. Filtrujte take podle stavu (Koncept / Schvaleno).',
      tourListTitle: 'Prehled vykyzu', tourListText: 'Vsechny vykyzy na jednom miste – s projektem, datem, stavem a poctem polozek. Kliknutim na kartu ji otevrete.',
      tourModalTitle: 'Vytvorit vykaz', tourModalText: 'Zadejte nazev, vyberte projekt a nastavte datum. "Vytvorit" otevre vykaz k uprave.',
      tourStatusTitle: 'Stav & metadata', tourStatusText: 'Aktualni stav (Koncept nebo Schvaleno), projekt, datum a autor na jednom miste.',
      tourActionsTitle: 'Panel akci', tourActionsText: 'Ulozit, schvalit, exportovat do PDF nebo smazat. Schvaleny vykaz je pouze ke cteni.',
      tourPositionTitle: 'Polozky', tourPositionText: 'Kazda polozka ma nazev a jednotku (m², lfm, m³, ks). Zadejte pocet, delku a sirku – vysledek se vypocita automaticky.',
      tourAddPositionTitle: 'Pridat polozku', tourAddPositionText: 'Pridejte libovolny pocet polozek pro ruzne oblasti mereni. Kazda ma vlastni tabulku a celkovy soucet.',
      startTour: 'Spustit průvodce',
      infoText: 'Prehled vykazu zobrazuje vsechny zaznamenane vykyzy vymeru vasi spolecnosti.',
      infoItem1: 'Vytvarejte nove vykyzy s nazvem, projektem a datem',
      infoItem2: 'Filtrujte podle stavu (Koncept / Schvaleno) nebo hledejte podle nazvu',
      infoItem3: 'Schvalene vykyzy slouzi jako podklad pro nabidky a faktury',
      infoDetailText: 'V editoru vykazu zachytavate miry strukturovane do polozek a radku.',
      infoDetailItem1: 'Kazda polozka ma jednotku (m², lfm, m³, ks) – radky se pocitaji automaticky',
      infoDetailItem2: 'Ukladejte koncepty kdykoli a schvalte vykaz az bude hotovy',
      infoDetailItem3: 'Schvalene vykyzy jsou pouze ke cteni a lze je exportovat jako PDF',
    },
    roles: {
      admin: 'Administrator',
      tenant_admin: 'Spravce tenantu',
      superadmin: 'Super administrator',
      manager: 'Manazer',
      employee: 'Zamestnanec'
    }
  }
};